import type {
  GraphQLResolveInfo,
  GraphQLScalarType,
  GraphQLScalarTypeConfig,
} from "graphql";
import type {
  AccommodationMapper,
  AccommodationAccessKeyMapper,
  AccommodationAvailabilityMapper,
  AccommodationAvailabilityBlockMapper,
  AccommodationEquipmentMapper,
  AccommodationFacilityMapper,
  AccommodationFeeMapper,
  AccommodationFeeItemMapper,
  AccommodationNoticeMapper,
  AccommodationOperationGroupMapper,
  AccommodationReservationMapper,
  AccommodationReservationAdditionalKeySetMapper,
  AccommodationReservationCheckOutItemMapper,
  AccommodationReservationDetailMapper,
  AccommodationReservationOptionsMapper,
  AdHocQuestionnaireResponseMapper,
  AdditionalGuestFeePolicyMapper,
  AdminRoleAssignmentMapper,
  ArchitectureTypeMapper,
  AreaMapper,
  AreaContentMapper,
  AreaGuideArticleMapper,
  AreaGuideSpotMapper,
  Auth0UserMapper,
  CancellationFeeTierMapper,
  CancellationPolicyContentMapper,
  CancellationPolicySectionMapper,
  CoOwnersApplicantInfoMapper,
  CoOwnersApplicantInfoDetailIndividualMapper,
  CoOwnersApplicantInfoDetailOrganizationMapper,
  CoOwnersApplicationMapper,
  CoOwnersApplicationEventsMapper,
  CoOwnersApplicationFileMapper,
  CoOwnersBakurakuInvoiceAnnualPaymentItemMapper,
  CoOwnersBakurakuInvoiceRecipientMapper,
  CoOwnersBakurakuInvoiceRegistrationFeeItemMapper,
  CoOwnersBakurakuInvoiceRemainingPaymentItemMapper,
  CoOwnersPlanOfferingMapper,
  CoOwnersUnitSaleMapper,
  CoOwnersWebinarScheduleMapper,
  CoWorkingSpaceKeyMapper,
  ConsumedSuppliesFeeItemMapper,
  ConsumedSupplyFeeItemWaiverMapper,
  ContentArchitectMapper,
  ContentArchitecturalFeatureMapper,
  ContentArchitecturalFeatureUsageRuleMapper,
  ContentArchitectureTypeMapper,
  ContentArchitectureTypeBasicAmenityMapper,
  ContentArchitectureTypeVariantFacilityAmenityMapper,
  ContentRoomTypeMapper,
  DraftAccommodationReservationMapper,
  FacilityMapper,
  FacilityBaseFeePolicyMapper,
  FacilityCancelFeePolicyMapper,
  FacilityControllerMapper,
  FacilityCustomFieldValueMapper,
  FacilityFeeItemMapper,
  FacilityReservationMapper,
  FacilityReservationCleaningReportMapper,
  FacilityReservationDataSyncMapper,
  FacilityResourceMapper,
  FacilityResourceBlockMapper,
  FacilitySlotMapper,
  FacilitySlotAvailabilityMapper,
  HighSeasonPeriodMapper,
  IdentityVerificationMapper,
  InspectionReportMapper,
  InspectionSupplyItemMapper,
  InspectionViolationHandlingMapper,
  InspectionViolationItemMapper,
  InternalAreaMapper,
  InternalContentRoomTypeMapper,
  InternalNativeAppHomeContentMapper,
  InternalOneShotScriptMapper,
  InternalOtaRoomUnitMapper,
  InternalRoomTypeMapper,
  InternalRoomTypeFeatureMapper,
  InternalScriptAffectedCountMapper,
  InternalScriptExecutionMapper,
  InternalScriptExecutionActorMapper,
  InternalScriptExecutionLogLineMapper,
  InternalSiteMapper,
  InternalSiteAddressMapper,
  InternalStaffContractMapper,
  InternalStaffCreditTransactionMapper,
  LocalTaxBracketMapper,
  LocalTaxPolicyMapper,
  MemberPerksNowhereDrinkTicketMapper,
  MusicConnectEquipmentAttributeMapper,
  NativeAppHomeContentMapper,
  NewsMapper,
  OrganizationMapper,
  OrganizationMembersStayMapper,
  OrganizationMembershipMapper,
  OrganizationYearlyContractMapper,
  OwnerPlanMapper,
  PlugDeviceMapper,
  RawNewsMapper,
  RawSiteFaqMapper,
  ReservationPriceStatementMapper,
  ReservationStatementItemMapper,
  RoomTypeMapper,
  RoomTypeAvailabilitiesMapper,
  RoomTypeAvailabilityMapper,
  RoomTypeFeatureMapper,
  S2oMapper,
  S2oPointMapper,
  SanuEdgeDeviceMapper,
  SanuIncAccommodationReservationProviderMapper,
  SaunaEquipmentAttributeMapper,
  SeasonalFeeSettingMapper,
  SiteMapper,
  SiteAccessRouteGroupMapper,
  SiteAccessRoutePointMapper,
  SiteActivityProgramMapper,
  SiteAvailabilityNightMapper,
  SiteContentMapper,
  StaffContractMapper,
  StaffGroupMapper,
  StayReviewMapper,
  StayReviewQuestionnaireMapper,
  StayReviewResponseMapper,
  StayReviewResponseWithReservationMapper,
  StayReviewV2Mapper,
  StayReviewV2ConcernMapper,
  StayTicketMapper,
  StayTicketMasterMapper,
  StayTicketMasterTemplateMapper,
  StayTicketReservationInfoMapper,
  StayTicketTemplateMapper,
  StayTicketUnitMapper,
  StripeCustomerMapper,
  SupplyItemMapper,
  SupplyItemInstallationMapper,
  SupplyItemMasterMapper,
  TermsMapper,
  TermsRevisionMapper,
  TrialContractMapper,
  UploadedFileMapper,
  UserMapper,
  UserAppInstallationMapper,
  UserIdentityMapper,
  UserMonthlyStatementMapper,
  UserOwnershipMapper,
  UserSubscriptionMapper,
  WifiConnectionMapper,
  WifiEquipmentAttributeMapper,
} from "./../schema.mappers";
import type { Context } from "../Context";
import { Temporal } from "@js-temporal/polyfill";
import type { Prisma } from "../../domain/__generated__/prisma/client";
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type EnumResolverSignature<T, AllowedValues = any> = {
  [key in keyof T]?: AllowedValues;
};
export type RequireFields<T, K extends keyof T> = Omit<T, K> & {
  [P in K]-?: NonNullable<T[P]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: Temporal.Instant; output: Temporal.Instant | Date };
  /**
   * Prisma.Decimal に対応する。
   * JSON number としてシリアライズされる。
   */
  Decimal: { input: Prisma.Decimal; output: Prisma.Decimal };
  /**
   * Temporal.PlainDate に対応する。
   * "2024-01-01" のようにシリアライズされる。
   */
  PlainDate: { input: Temporal.PlainDate; output: Temporal.PlainDate };
  /**
   * Temporal.PlainDateTime に対応する。
   * "2024-01-01T00:00:00" のようにシリアライズされる。
   */
  PlainDateTime: {
    input: Temporal.PlainDateTime;
    output: Temporal.PlainDateTime;
  };
  /**
   * Temporal.PlainYearMonth に対応する。
   * "2024-01" のようにシリアライズされる。
   */
  PlainYearMonth: {
    input: Temporal.PlainYearMonth;
    output: Temporal.PlainYearMonth;
  };
  /**
   * Temporal.ZonedDateTime に対応する。
   * "2024-01-01T00:00:00+09:00[Asia/Tokyo]" のようにシリアライズされる。
   */
  ZonedDateTime: {
    input: Temporal.ZonedDateTime;
    output: Temporal.ZonedDateTime;
  };
};

export type AcceptAccommodationReservationError = {
  __typename?: "AcceptAccommodationReservationError";
  case: AcceptAccommodationReservationErrorCase;
};

export const AcceptAccommodationReservationErrorCase = {
  /** ログインユーザーとは異なるユーザーに紐づいている */
  NotAuthorized: "NotAuthorized",
  /** Stay Gift from Owners のオーナーが自身の予約を取ろうとした */
  OwnerOfStayGiftFromOwnersError: "OwnerOfStayGiftFromOwnersError",
  /** 該当する仮予約が存在しない */
  UserAcceptCodeNotFound: "UserAcceptCodeNotFound",
} as const;

export type AcceptAccommodationReservationErrorCase =
  (typeof AcceptAccommodationReservationErrorCase)[keyof typeof AcceptAccommodationReservationErrorCase];
export type AcceptAccommodationReservationPayload =
  | AcceptAccommodationReservationError
  | AccommodationReservation;

export const AccessKeyType = {
  /** 清掃スタッフ用PINコード。部屋ごとに異なる */
  SiteCleaningStaff: "SiteCleaningStaff",
  /** 管理者用PINコード。拠点単位で共通 */
  SiteManager: "SiteManager",
} as const;

export type AccessKeyType = (typeof AccessKeyType)[keyof typeof AccessKeyType];
/** アクセスルートグループに表示する交通手段アイコン */
export const AccessRouteTransportIcon = {
  Bicycle: "Bicycle",
  Bus: "Bus",
  Car: "Car",
  Ferry: "Ferry",
  Other: "Other",
  Plane: "Plane",
  Train: "Train",
  Walk: "Walk",
} as const;

export type AccessRouteTransportIcon =
  (typeof AccessRouteTransportIcon)[keyof typeof AccessRouteTransportIcon];
/** トップ画面からいつでもアクセスできる予約カレンダーの種類 */
export const AccessibleReservationCalendarType = {
  BusinessPlan: "BusinessPlan",
  CoOwnersPlan: "CoOwnersPlan",
  FullOwnerPlan: "FullOwnerPlan",
  StaffPlan: "StaffPlan",
  StandardPlan: "StandardPlan",
  TrialPlan: "TrialPlan",
} as const;

export type AccessibleReservationCalendarType =
  (typeof AccessibleReservationCalendarType)[keyof typeof AccessibleReservationCalendarType];
/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type Accommodation = {
  __typename?: "Accommodation";
  /** 解錠できるアクセスキーのみ返す。未発行・ウィンドウ無し（滞在中など）・期間切れは null。JTAS には SiteCleaningStaff のみ */
  accessKey?: Maybe<AccommodationAccessKey>;
  /**
   * 部屋クラス。provider ごとの改定ルール適用前の宿泊日は null。
   * provider 引数と nullable は移行期のためのもので、forBiz の移行が完了する 2028/5 宿泊以降は不要になるので、
   * その時点で provider を外して non-null に変更する。
   * `class` は多くの言語で予約語のため、冗長だが型名に揃えて accommodationClass にしている
   */
  accommodationClass?: Maybe<AccommodationClass>;
  /** 建築タイプ */
  architectureType: ArchitectureType;
  /**
   * 空室かどうか（日付・期間指定）
   * プランによって、見れる範囲が制限されている。
   */
  availabilities: Array<AccommodationAvailability>;
  /**
   * provider の所有クラスから見た、部屋クラスの上下関係。
   * 所有クラスを持たない provider（オーナー系・Stay Gift from Owners 以外）と改定ルール適用前の宿泊日は null
   */
  classRelation?: Maybe<AccommodationClassRelation>;
  /**
   * 拠点内における名前
   * 例：1012, Crea
   */
  code: Scalars["String"]["output"];
  /** 施設のコンテンツ */
  content: AccommodationContent;
  /**
   * 施設に紐づく機器一覧。
   * 滞在中（チェックイン後〜チェックアウトまで）の予約を持つユーザーにのみ返す。
   * admin は滞在の有無に関わらず取得できる。それ以外には空リストを返す。
   */
  equipments: Array<AccommodationEquipment>;
  /** 設備一覧（管理用、IDを含む） */
  facilities: Array<AccommodationFacility>;
  /** 設備の一覧 */
  facilityTypes: Array<AccommodationFacilityType>;
  id: Scalars["ID"]["output"];
  /** 自己所有物件かどうか。Stay Gift from Owners は発行元オーナーの所有で判定する */
  isOwned: Scalars["Boolean"]["output"];
  /**
   * 名前(computed)
   * 拠点名を合わせた、グローバルな呼び名（例：一宮1st 1101、Amatsumi 安曇野）
   */
  name: Scalars["String"]["output"];
  /** 施設に関するお知らせ（旧予約カード案内） */
  notices: Array<AccommodationNotice>;
  /**
   * 運用タイプ。予約リードタイムと同じ基準（改定日時点の運用設定）で解決する。
   * 公開前の拠点で運用グループが未設定の部屋は null
   */
  operationType?: Maybe<AccommodationOperationType>;
  /** 紐づいた RemoteLOCK のデバイス ID（未設定の場合は null）。登録時に RemoteLOCK と突き合わせて検証済み */
  remoteLockDeviceId?: Maybe<Scalars["String"]["output"]>;
  /** ルームタイプ。`otaRoomUnit` の紐付けが無い accommodation では null。 */
  roomType?: Maybe<RoomType>;
  /** 施設に紐づくエッジデバイス一覧 */
  sanuEdgeDevices: Array<SanuEdgeDevice>;
  /** 施設がある拠点 */
  site: Site;
  /**
   * 並び順
   * 通常並び順を意識する必要はないが、管理ページで編集するために必要。
   */
  sort: Scalars["Int"]["output"];
};

/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type AccommodationaccessKeyArgs = {
  keyType: AccessKeyType;
};

/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type AccommodationaccommodationClassArgs = {
  night: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
};

/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type AccommodationavailabilitiesArgs = {
  firstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  occupancyLimitTarget?: InputMaybe<OccupancyLimitTargetType>;
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type AccommodationclassRelationArgs = {
  night: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
};

/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type AccommodationfacilityTypesArgs = {
  date?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * 宿泊施設
 * 予約対象となる最小単位。
 */
export type AccommodationisOwnedArgs = {
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

/** スタッフ用アクセスキー（PINコード）の当月の状態。解錠できるときだけ返るため各フィールドは必ず揃う */
export type AccommodationAccessKey = {
  __typename?: "AccommodationAccessKey";
  /** 有効期間の終了時刻。範囲の意味は startsAt と同じ */
  endsAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** デバイスまで PIN が届いたとみなせるか。RemoteLOCK へは問い合わせず最後の書き込みから 1 時間経過で判定する */
  isSynced: Scalars["Boolean"]["output"];
  /** 当月の有効なPINコード */
  pin: Scalars["String"]["output"];
  /** 有効期間の開始時刻。清掃キーは今日の入室ウィンドウ、管理者キーは当月いっぱい */
  startsAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
};

/** 宿泊施設の空室情報 */
export type AccommodationAvailability = {
  __typename?: "AccommodationAvailability";
  /** ブロック情報 */
  block?: Maybe<AccommodationAvailabilityBlock>;
  date: Scalars["PlainDate"]["output"];
  /**
   * 必ず発生する一泊あたり料金
   * 2023/11時点だと、基本料金＋繁忙日料金＋施設追加料金＋設備利用料金（マストのもの）
   */
  guaranteedPrice?: Maybe<Scalars["Int"]["output"]>;
  /**
   * 予約可能な日付の範囲で空室かどうか
   * Note: 予約可能な施設かどうかは反映されていない
   */
  isAvailable: Scalars["Boolean"]["output"];
};

/** 宿泊施設の利用ブロック（管理用） */
export type AccommodationAvailabilityBlock = {
  __typename?: "AccommodationAvailabilityBlock";
  /** ブロックする宿泊施設（指定しない場合は拠点全体） */
  accommodation?: Maybe<Accommodation>;
  /** ブロックの開始日 */
  beginNight: Scalars["PlainDate"]["output"];
  /**
   * 一括作成でまとめて作成された予約ブロックを紐付けるID。
   * internalBulkCreateAccommodationAvailabilityBlocksで作成された場合のみ設定される。
   */
  bulkCreateId?: Maybe<Scalars["ID"]["output"]>;
  /** カテゴリー */
  category: AccommodationAvailabilityBlockCategory;
  /** カテゴリ情報 */
  categoryInfo: AccommodationAvailabilityBlockCategoryInfo;
  /** 作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** 作成者 */
  createdByUser?: Maybe<User>;
  /** ブロックの終了日 */
  endNight: Scalars["PlainDate"]["output"];
  id: Scalars["ID"]["output"];
  /**
   * 一時的なブロックであることを示すフラグ
   * 予約当日には予約ブロックとして利用されないことを想定する
   */
  isTentative: Scalars["Boolean"]["output"];
  /** 名前。外部パートナーには伏字で返す */
  name: Scalars["String"]["output"];
  /** メモ。外部パートナーには伏字で返す */
  note: Scalars["String"]["output"];
  /** ブロックする拠点 */
  site: Site;
  /** 社内スタッフグループ */
  staffGroup?: Maybe<StaffGroup>;
  /** 更新日時 */
  updatedAt: Scalars["ZonedDateTime"]["output"];
  /** 更新者 */
  updatedByUser?: Maybe<User>;
};

export const AccommodationAvailabilityBlockCategory = {
  /** @deprecated MaintenanceInspection / MaintenanceConstruction を使用してください */
  AccommodationMaintenance: "AccommodationMaintenance",
  /** @deprecated 点検・工事関連のカテゴリを使用してください */
  AccommodationSpecChange: "AccommodationSpecChange",
  /** @deprecated OpsBeforeOpening を使用してください */
  BeforeFirstUse: "BeforeFirstUse",
  /** 清掃調整 */
  CleaningAdjustment: "CleaningAdjustment",
  /** その他清掃 */
  CleaningOther: "CleaningOther",
  /** 特別清掃 */
  CleaningSpecial: "CleaningSpecial",
  /** CSp対応 */
  CustomerSupport: "CustomerSupport",
  /** @deprecated MaintenanceLandscape を使用してください */
  LandscapeMaintenance: "LandscapeMaintenance",
  /** @deprecated OpsLastMinuteCancellation を使用してください */
  LastMinuteCancellation: "LastMinuteCancellation",
  /** 工事 */
  MaintenanceConstruction: "MaintenanceConstruction",
  /** 点検 */
  MaintenanceInspection: "MaintenanceInspection",
  /** 植栽 */
  MaintenanceLandscape: "MaintenanceLandscape",
  /** その他点検・工事 */
  MaintenanceOther: "MaintenanceOther",
  /** OTA枠確保(プログラムから作成) */
  OnlineTravelAgent: "OnlineTravelAgent",
  /** 開業前 */
  OpsBeforeOpening: "OpsBeforeOpening",
  /** 直前減泊 */
  OpsLastMinuteCancellation: "OpsLastMinuteCancellation",
  /** その他オペレーション調整 */
  OpsOther: "OpsOther",
  /** SANU外部起因トラブル */
  OpsTemporaryClose: "OpsTemporaryClose",
  /** トラブル解決待ち */
  OpsTroubleWaiting: "OpsTroubleWaiting",
  /** 撮影・取材 */
  OtherShooting: "OtherShooting",
  /** @deprecated ReservationForStaff / ReservationForStakeholder などを使用してください */
  PromotionalUse: "PromotionalUse",
  /** 法人合宿 */
  ReservationForBusiness: "ReservationForBusiness",
  /** アーリーチェックイン用(プログラムから作成) */
  ReservationForEarlyCheckIn: "ReservationForEarlyCheckIn",
  /** イベント利用 */
  ReservationForEvent: "ReservationForEvent",
  /** 社員宿泊 */
  ReservationForStaff: "ReservationForStaff",
  /** 招待宿泊 */
  ReservationForStakeholder: "ReservationForStakeholder",
  /** その他宿泊用 */
  ReservationOther: "ReservationOther",
  /** @deprecated CleaningSpecial を使用してください */
  SpecialCleaning: "SpecialCleaning",
  /** @deprecated OpsTroubleWaiting などを使用してください */
  Trouble: "Trouble",
} as const;

export type AccommodationAvailabilityBlockCategory =
  (typeof AccommodationAvailabilityBlockCategory)[keyof typeof AccommodationAvailabilityBlockCategory];
/** 予約ブロックカテゴリの詳細情報 */
export type AccommodationAvailabilityBlockCategoryInfo = {
  __typename?: "AccommodationAvailabilityBlockCategoryInfo";
  /** カテゴリグループ */
  categoryGroup: Scalars["String"]["output"];
  /** カテゴリキー */
  key: AccommodationAvailabilityBlockCategory;
  /** 表示ラベル */
  label: Scalars["String"]["output"];
  /** 説明 */
  note: Scalars["String"]["output"];
};

/**
 * ブロック解放スケジュール
 *
 * チェックイン N 日前のバッチ実行時に、現在のブロック室数が
 * blockRoomCountUpperLimit を超えていれば上限値まで自動解除する。
 * 0 を指定するとその日数で全解除する。
 */
export type AccommodationAvailabilityBlockReleaseSchedule = {
  __typename?: "AccommodationAvailabilityBlockReleaseSchedule";
  /** 維持するブロック室数の上限（0 = 全解除） */
  blockRoomCountUpperLimit: Scalars["Int"]["output"];
  /** チェックインN日前 */
  daysBeforeCheckin: Scalars["Int"]["output"];
  /** ID */
  id: Scalars["ID"]["output"];
  /** 拠点ID */
  siteId: Scalars["ID"]["output"];
};

/** クラス。アルファベットが後ろほど上位（E < F < G）。 */
export const AccommodationClass = {
  E: "E",
  F: "F",
  G: "G",
} as const;

export type AccommodationClass =
  (typeof AccommodationClass)[keyof typeof AccommodationClass];
/** 所有クラスから見た部屋クラスの上下関係 */
export const AccommodationClassRelation = {
  Higher: "Higher",
  Lower: "Lower",
  Same: "Same",
} as const;

export type AccommodationClassRelation =
  (typeof AccommodationClassRelation)[keyof typeof AccommodationClassRelation];
/** 施設コンテンツ */
export type AccommodationContent = {
  __typename?: "AccommodationContent";
  /** 設備マニュアルの外部リンク */
  manualUrl?: Maybe<Scalars["String"]["output"]>;
};

/** 宿泊施設の機器 */
export type AccommodationEquipment = {
  __typename?: "AccommodationEquipment";
  /** この機器が設置されている宿泊施設 */
  accommodation: Accommodation;
  /** 機器種別ごとの固有情報。将来的に状態・制御方法もこの中で機器ごとに扱う。 */
  attribute?: Maybe<AccommodationEquipmentAttribute>;
  /** 一覧用の短い説明文 */
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 機器名（例: Wi-Fi, Music Connect） */
  name: Scalars["String"]["output"];
  /** 一覧での表示順。小さいほど先頭 */
  sort: Scalars["Int"]["output"];
  /** 公開ステータス */
  status: AccommodationEquipmentStatusType;
  /** 機器種別 */
  type: AccommodationEquipmentType;
};

/** 機器種別ごとの固有情報 */
export type AccommodationEquipmentAttribute =
  | MusicConnectEquipmentAttribute
  | SaunaEquipmentAttribute
  | WifiEquipmentAttribute;

/**
 * 機器の公開ステータス。
 * Draft < Preview < PublishedForSanuStaff < Published の順に公開範囲が広がる。
 */
export const AccommodationEquipmentStatusType = {
  /** 準備中。誰にも公開されない */
  Draft: "Draft",
  /** admin にのみ公開 */
  Preview: "Preview",
  /** 全ユーザーに公開 */
  Published: "Published",
  /** @sa-nu.com のユーザーまたは admin に公開 */
  PublishedForSanuStaff: "PublishedForSanuStaff",
} as const;

export type AccommodationEquipmentStatusType =
  (typeof AccommodationEquipmentStatusType)[keyof typeof AccommodationEquipmentStatusType];
/** 機器種別 */
export const AccommodationEquipmentType = {
  MusicConnect: "MusicConnect",
  Sauna: "Sauna",
  Wifi: "Wifi",
} as const;

export type AccommodationEquipmentType =
  (typeof AccommodationEquipmentType)[keyof typeof AccommodationEquipmentType];
/** 宿泊施設の種類 */
export type AccommodationFacility = {
  __typename?: "AccommodationFacility";
  id: Scalars["ID"]["output"];
  slug: Scalars["String"]["output"];
  type: AccommodationFacilityType;
};

/** 宿泊施設設備フィルタータイプ */
export const AccommodationFacilityFilterType = {
  Exclude: "Exclude",
  Include: "Include",
} as const;

export type AccommodationFacilityFilterType =
  (typeof AccommodationFacilityFilterType)[keyof typeof AccommodationFacilityFilterType];
/** 宿泊施設に付属する設備 */
export const AccommodationFacilityType = {
  DogFriendly: "DogFriendly",
  DogRun: "DogRun",
  EVCharger: "EVCharger",
  Onsen: "Onsen",
  Sauna: "Sauna",
  Workation: "Workation",
} as const;

export type AccommodationFacilityType =
  (typeof AccommodationFacilityType)[keyof typeof AccommodationFacilityType];
/**
 * 宿泊料金
 * 宿泊料金とは、有料備品の利用を除く、チェックアウト日までに請求される料金のこと。
 * 例えば、ベース料金、土祝料金、リノベ料金、サウナ料金、清掃料金、Dog料金、EV料金、NoShow料金、キャンセル料金など。
 * チェックアウト日より後に請求される料金として、月末に決済される8泊目以降追加料金がある。
 */
export type AccommodationFee = {
  __typename?: "AccommodationFee";
  /** 請求方法 - AutoChargeの場合は自動請求、Manualの場合は別途請求 */
  billingMethod: BillingMethod;
  /** 別途請求の詳細 - billingMethodがManualの場合のみ存在します。 */
  billingMethodManualDetail?: Maybe<Scalars["String"]["output"]>;
  /** 有料備品の免除一覧 */
  consumedSupplyFeeItemWaivers: Array<ConsumedSupplyFeeItemWaiver>;
  /** 料金の項目 */
  items: Array<AccommodationFeeItem>;
  /** 請求・支払いの状態（管理者向け）。下書き/プレビューの予約では null。 */
  status?: Maybe<AccommodationFeeStatus>;
  /** Stripe請求書ID */
  stripeInvoiceId?: Maybe<Scalars["String"]["output"]>;
  /** 料金の合計 */
  totalAmount: Scalars["Int"]["output"];
};

/** 宿泊予約に対して適用されるオプション料金の請求有無の設定 */
export type AccommodationFeeApplicability = {
  __typename?: "AccommodationFeeApplicability";
  waiveArchitectureTypeAdditionalFee: Scalars["Boolean"]["output"];
  waiveDogFee: Scalars["Boolean"]["output"];
  waiveDogRunFee: Scalars["Boolean"]["output"];
  waiveEvChargerFee: Scalars["Boolean"]["output"];
  waiveOnsenFee: Scalars["Boolean"]["output"];
  waiveSaunaFee: Scalars["Boolean"]["output"];
};

/** 宿泊料金の割引情報（チケットマスタの料金ルール由来）。 */
export type AccommodationFeeDiscount = {
  __typename?: "AccommodationFeeDiscount";
  /** 料金修正値 */
  feeModifier: Scalars["Int"]["output"];
  /** 料金修正タイプ */
  feeModifierType: FeeModifierType;
  /**
   * 対象の泊数。ruleType により意味が異なる:
   * NightFeeModifier は対象の泊（N 泊目）、ConsecutiveNightDiscount は適用閾値（この泊数以上で適用）。
   */
  night: Scalars["Int"]["output"];
  /** 宿泊料金ルールタイプ */
  ruleType: AccommodationFeeRuleType;
};

export type AccommodationFeeInput = {
  /** 請求方法 - AutoChargeの場合は自動請求、Manualの場合は別途請求 */
  billingMethod?: InputMaybe<BillingMethod>;
  /** 別途請求の詳細 - billingMethodがManualの場合のみ使用されます。 */
  billingMethodManualDetail?: InputMaybe<Scalars["String"]["input"]>;
  items: Array<AccommodationFeeItemInput>;
};

export type AccommodationFeeItem = {
  __typename?: "AccommodationFeeItem";
  /** 料金の金額 */
  amount: Scalars["Int"]["output"];
  /** 作成日時 */
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** 料金種別を区別するためのキー */
  key: Scalars["ID"]["output"];
  /** 項目名 */
  label: Scalars["String"]["output"];
  /** 日付（料金の種類が PER_NIGHT の場合のみ） */
  night?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 利用した宿泊チケット */
  stayTicket?: Maybe<StayTicket>;
  /** 消費税率 */
  taxRate: Scalars["Float"]["output"];
  /** 料金の種類 */
  type: AccommodationFeeItemPerType;
};

/** 管理画面から設定される宿泊料金の項目。消費税は10%固定。 */
export type AccommodationFeeItemInput = {
  amount: Scalars["Int"]["input"];
  key: Scalars["String"]["input"];
  night?: InputMaybe<Scalars["PlainDate"]["input"]>;
  type: AccommodationFeeItemPerType;
};

export const AccommodationFeeItemPerType = {
  /** 1泊あたりの料金 */
  PerNight: "PerNight",
  /** 1滞在あたりの料金 */
  PerStay: "PerStay",
} as const;

export type AccommodationFeeItemPerType =
  (typeof AccommodationFeeItemPerType)[keyof typeof AccommodationFeeItemPerType];
/** 宿泊料金設定ルール */
export type AccommodationFeeRule = {
  __typename?: "AccommodationFeeRule";
  /** 料金修正値 */
  feeModifier: Scalars["Int"]["output"];
  /** 料金修正タイプ */
  feeModifierType: FeeModifierType;
  id: Scalars["ID"]["output"];
  /** 対象の夜（1から始まる） */
  night: Scalars["Int"]["output"];
  /** ルールタイプ */
  ruleType: AccommodationFeeRuleType;
};

/** 宿泊料金設定ルールの入力 */
export type AccommodationFeeRuleInput = {
  /** 料金修正値 */
  feeModifier: Scalars["Int"]["input"];
  /** 料金修正タイプ */
  feeModifierType: FeeModifierType;
  /** 対象の夜（1から始まる） */
  night: Scalars["Int"]["input"];
  /** ルールタイプ */
  ruleType: AccommodationFeeRuleType;
};

/** 料金ルールタイプ */
export const AccommodationFeeRuleType = {
  /** 連泊割引 */
  ConsecutiveNightDiscount: "ConsecutiveNightDiscount",
  FreeNight: "FreeNight",
  /** 特定の泊に対する料金修正 */
  NightFeeModifier: "NightFeeModifier",
} as const;

export type AccommodationFeeRuleType =
  (typeof AccommodationFeeRuleType)[keyof typeof AccommodationFeeRuleType];
/** 宿泊料金の請求・支払いライフサイクル。 */
export const AccommodationFeeStatus = {
  /** 未確定（宿泊料金の確定待ち） */
  Draft: "Draft",
  /** 請求書発行済み・支払い待ち */
  InvoiceOpen: "InvoiceOpen",
  /** 支払い完了 */
  InvoicePaid: "InvoicePaid",
  /** 支払い失敗 */
  InvoicePaymentFailed: "InvoicePaymentFailed",
  /** 支払いにユーザーの追加操作が必要 */
  InvoiceRequiresAction: "InvoiceRequiresAction",
  /** 確定済み・請求書発行待ち */
  Open: "Open",
  /** 別途請求（Stripe 自動請求の対象外） */
  Unknown: "Unknown",
} as const;

export type AccommodationFeeStatus =
  (typeof AccommodationFeeStatus)[keyof typeof AccommodationFeeStatus];
/** 施設に関するお知らせ */
export type AccommodationNotice = {
  __typename?: "AccommodationNotice";
  /** このお知らせを出している宿泊施設 */
  accommodations: Array<Accommodation>;
  /** infoの内容（50文字まで） */
  brief: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  /** 作成者（管理用） */
  createdUser: User;
  /** infoの内容（300文字まで） */
  detail?: Maybe<Scalars["String"]["output"]>;
  /**
   * お知らせの対象期間の終了日。
   * この期間と重なる予約に対してお知らせが提供される（予約期間との重複で判定される）。
   * 閲覧画面での「表示終了日」ではない点に注意。
   */
  endDate: Scalars["PlainDate"]["output"];
  /** infoに関する外部webサイトなどの参照urlが入る */
  externalUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 更新者（管理用） */
  lastUpdatedUser: User;
  /** 対象者にメールで通知するか（管理用） */
  sendEmailToExpectedUsers: Scalars["Boolean"]["output"];
  /**
   * お知らせの対象期間の開始日。
   * この期間と重なる予約に対してお知らせが提供される（予約期間との重複で判定される）。
   * 閲覧画面での「表示開始日」ではない点に注意。
   */
  startDate: Scalars["PlainDate"]["output"];
  /** 公開ステータス（管理用） */
  status: AccommodationNoticeStatus;
  updatedAt: Scalars["DateTime"]["output"];
};

/** 宿泊施設お知らせのステータス（管理用） */
export const AccommodationNoticeStatus = {
  /** 公開中 */
  Active: "Active",
  /** 下書き */
  Draft: "Draft",
  /** 非公開 */
  Unpublished: "Unpublished",
} as const;

export type AccommodationNoticeStatus =
  (typeof AccommodationNoticeStatus)[keyof typeof AccommodationNoticeStatus];
/** 運用グループ。拠点 × 建築タイプの単位で運用タイプ・クラス・追加料金を割り当てる */
export type AccommodationOperationGroup = {
  __typename?: "AccommodationOperationGroup";
  architectureType: ArchitectureType;
  id: Scalars["ID"]["output"];
  /** 設定値の一覧（effectiveFrom の昇順）。現状は 1 件だけ */
  settings: Array<AccommodationOperationGroupSetting>;
};

/** 運用グループの設定値 */
export type AccommodationOperationGroupSetting = {
  __typename?: "AccommodationOperationGroupSetting";
  /** 法人プランで泊まるときの 1 泊あたりの追加料金 */
  additionalFeeForBusinessPlan: Scalars["Int"]["output"];
  /** E クラスのオーナーが泊まるときの 1 泊あたりの追加料金 */
  additionalFeeForClassEOwner: Scalars["Int"]["output"];
  /** F クラスのオーナーが泊まるときの 1 泊あたりの追加料金 */
  additionalFeeForClassFOwner: Scalars["Int"]["output"];
  class: AccommodationClass;
  /** 適用開始日、この宿泊日から適用 */
  effectiveFrom: Scalars["PlainDate"]["output"];
  id: Scalars["ID"]["output"];
  operationType: AccommodationOperationType;
};

/** 運用タイプ */
export const AccommodationOperationType = {
  CoOwners: "CoOwners",
  FullOwner: "FullOwner",
  Open: "Open",
} as const;

export type AccommodationOperationType =
  (typeof AccommodationOperationType)[keyof typeof AccommodationOperationType];
/**
 * 宿泊予約
 * システムにより在庫が確保されている。
 */
export type AccommodationReservation = {
  __typename?: "AccommodationReservation";
  /** 部屋を解錠するための暗証番号 */
  accessCode?: Maybe<Scalars["String"]["output"]>;
  /** 滞在先の施設 */
  accommodation: Accommodation;
  /** 施設に関するお知らせ（旧予約カード案内） */
  accommodationNotices: Array<AccommodationNotice>;
  /** 利用可能な追加の鍵の情報 */
  additionalKeySet: AccommodationReservationAdditionalKeySet;
  /** キャンセルできるかどうか */
  canCancel: Scalars["Boolean"]["output"];
  /** 現時点でチェックインできるかどうか */
  canCheckIn: Scalars["Boolean"]["output"];
  /** 現時点でチェックアウトできるかどうか */
  canCheckOut: Scalars["Boolean"]["output"];
  /**
   * One more Cabin を予約できるかどうか
   * （すでに One more Cabin を予約済みの場合も false となる）
   */
  canReserveOneMoreCabin: Scalars["Boolean"]["output"];
  /** キャンセル日時（キャンセルされていない場合は null） */
  canceledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * この予約に適用されるキャンセルポリシー（表示用）。
   * 精算ロジックと同一のドメイン関数から生成される。
   */
  cancellationPolicyContent?: Maybe<CancellationPolicyContent>;
  /** チェックイン用QRコード */
  checkInQrCode?: Maybe<CheckInQrCode>;
  /** チェックイン時刻 */
  checkedInAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** チェックイン場所 */
  checkedInGeoLocation?: Maybe<GeoLocation>;
  /** チェックアウト時刻 */
  checkedOutAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 有料備品の利用料金 */
  consumedSuppliesFee: ConsumedSuppliesFee;
  /** 予約の作成時刻 */
  createdAt: Scalars["DateTime"]["output"];
  /**
   * この予約を作成したユーザー
   * 通常のサブスクの場合は user と同じだが、招待や管理者による予約などの場合に異なる
   */
  createdUser?: Maybe<User>;
  /** 現在時刻でのアーリーチェックイン料金（アーリーチェックイン対象の場合のみ） */
  currentEarlyCheckInFee?: Maybe<Scalars["Int"]["output"]>;
  /** フォームに入力した詳細情報 */
  detail: AccommodationReservationDetail;
  /** アーリーチェックイン対象かどうか */
  earlyCheckInEligible: Scalars["Boolean"]["output"];
  /** アーリーチェックインの料金テーブル（アーリーチェックイン対象の場合のみ） */
  earlyCheckInPriceTable?: Maybe<Array<EarlyCheckInPriceSlot>>;
  /**
   * ECI 表示状態。
   * - HIDDEN: ECI 案内も表示しない
   * - VISIBLE: ECI 案内ラベルのみ表示（実行不可、現在 ECI 料金時間帯外）
   * - AVAILABLE: 案内 + チェックイン実行可能（現在 ECI 料金時間帯内）
   */
  earlyCheckInStatus: EarlyCheckInStatus;
  /** 付帯サービス一覧 */
  facilities: Array<Facility>;
  /** 付帯サービスの利用料金 */
  facilityFee: FacilityFee;
  /** 付帯サービス予約一覧 */
  facilityReservations: Array<FacilityReservation>;
  /** 宿泊施設の利用料金 */
  fee: AccommodationFee;
  /** 料金計算に際して利用されたオプション料金の請求有無の設定 */
  feeApplicability: AccommodationFeeApplicability;
  /** 滞在初日 */
  firstDate: Scalars["PlainDate"]["output"];
  /**
   * いつから
   * カレンダー上で選択する、最初の日。この日の午後から滞在が可能。
   */
  firstNight: Scalars["PlainDate"]["output"];
  /**
   * チェックイン・清掃で照合するための宿泊者名。会員予約は User.name、OTA 予約は otaDetail の姓名。
   * User オブジェクトそのものは UsersRead が要る。
   */
  guestName?: Maybe<Scalars["String"]["output"]>;
  /** キャンセルされたかどうか */
  hasCanceled: Scalars["Boolean"]["output"];
  /** 施設にサウナデバイスが紐づいているかどうか */
  hasSanuDevices: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** 招待URL（まだユーザーに紐づいていない仮予約の場合に存在） */
  invitationUrl?: Maybe<Scalars["String"]["output"]>;
  /** 付帯サービス種別の追加予約が可能かどうか */
  isFacilityReservable: Scalars["Boolean"]["output"];
  /** 部屋タイプ予約として作成された予約か */
  isRoomTypeReservation: Scalars["Boolean"]["output"];
  /** サウナコントロールにアクセスできるかどうか */
  isSaunaControlAccessible: Scalars["Boolean"]["output"];
  /** 仮予約かどうか */
  isTentative: Scalars["Boolean"]["output"];
  /** 滞在最終日（予約した日の翌日） */
  lastDate: Scalars["PlainDate"]["output"];
  /**
   * いつまで
   * カレンダー上で選択する、最後の日。この日の翌日の朝まで滞在は可能。
   */
  lastNight: Scalars["PlainDate"]["output"];
  /**
   * この予約の宿泊に適用される地方税ポリシー。
   * 宿泊税は拠点、入湯税は棟に紐づくが、有効期間の判定に滞在日が要るため予約側で解決する。
   */
  localTaxPolicies: Array<LocalTaxPolicy>;
  /** 予約内容の変更ができる範囲 */
  mutationScope: AccommodationReservationMutationScope;
  /** 泊数(computed) */
  nights: Scalars["Int"]["output"];
  /** One more Cabin の予約情報 */
  oneMoreCabinAccommodationReservation?: Maybe<AccommodationReservation>;
  /** OTA予約の詳細情報 */
  otaDetail?: Maybe<AccommodationReservationOtaDetail>;
  /** 予約が作成された根拠 */
  provider: AccommodationReservationProvider;
  /** 予約の開始時刻(computed) */
  reservedFrom: Scalars["ZonedDateTime"]["output"];
  /** 予約の終了時刻(computed) */
  reservedTo: Scalars["ZonedDateTime"]["output"];
  /** 旧滞在レビュー回答 */
  review?: Maybe<StayReview>;
  /**
   * 表示用の標準チェックイン時刻。
   * ECI対象でも入室基準時刻（reservedFrom）ではなくこの値を表示に用いる。表示専用。
   */
  standardCheckInTime: Scalars["ZonedDateTime"]["output"];
  /** 新滞在レビュー回答 */
  stayReviewResponse?: Maybe<StayReviewResponse>;
  /** 滞在レビュー 2.0。null は未着手 */
  stayReviewV2?: Maybe<StayReviewV2>;
  /** 滞在ステータス */
  stayStatus: AccommodationReservationStayStatus;
  /** チケット予約の情報 */
  stayTicketUnit?: Maybe<StayTicketUnit>;
  /** 仮予約確定の期限 */
  tentativeDeadline?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** この予約を所有しているユーザー */
  user?: Maybe<User>;
  /** 仮予約コード */
  userAcceptCode?: Maybe<Scalars["String"]["output"]>;
  /** 同伴者 */
  userCompanions: Array<UserCompanion>;
};

/**
 * 宿泊予約
 * システムにより在庫が確保されている。
 */
export type AccommodationReservationfacilityReservationsArgs = {
  facilityType?: InputMaybe<FacilityType>;
  status?: InputMaybe<FacilityReservationStatusType>;
};

/**
 * 宿泊予約
 * システムにより在庫が確保されている。
 */
export type AccommodationReservationisFacilityReservableArgs = {
  facilityType: FacilityType;
  isForce?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** 宿泊予約に紐づく追加の鍵の情報 */
export type AccommodationReservationAdditionalKeySet = {
  __typename?: "AccommodationReservationAdditionalKeySet";
  /** コワーキングスペースの鍵 */
  coWorkingSpaceKey?: Maybe<CoWorkingSpaceKey>;
};

export type AccommodationReservationChange = {
  __typename?: "AccommodationReservationChange";
  from: Scalars["String"]["output"];
  to: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type AccommodationReservationCheckOutAvailabilitiesInput = {
  accommodationId: Scalars["ID"]["input"];
  firstNight: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
  reservationIdForChange?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AccommodationReservationCheckOutAvailabilitiesPayload = {
  __typename?: "AccommodationReservationCheckOutAvailabilitiesPayload";
  items: Array<AccommodationReservationCheckOutItem>;
};

export type AccommodationReservationCheckOutItem = {
  __typename?: "AccommodationReservationCheckOutItem";
  /** 1泊増やすことによる追加料金 */
  additionalNightsFee: Scalars["Int"]["output"];
  /** そのチェックアウト日が選択可能かどうか */
  available: Scalars["Boolean"]["output"];
  /** ブロック情報 */
  block?: Maybe<AccommodationAvailabilityBlock>;
  /** チェックアウト日 */
  date: Scalars["PlainDate"]["output"];
  /**
   * このチェックアウト日（= この滞在日数）で実際に適用される割引（applied）。
   * StayTicket かつ負の修正値の場合のみ。ラダー全段（master）は
   * AccommodationReservationCheckOutAvailabilitiesPayload.discounts を参照。
   */
  discounts: Array<AccommodationFeeDiscount>;
};

/** 滞在予約でフォームに入力する詳細情報 */
export type AccommodationReservationDetail = {
  __typename?: "AccommodationReservationDetail";
  /**
   * 部屋変更を許可する
   * One more CabinやEV充電器利用時は強制的にfalse
   */
  allowRoomChange: Scalars["Boolean"]["output"];
  /**
   * 愛犬を同伴する
   * 設備にDogfriendlyがある場合のみ true にできる
   */
  bringDog: Scalars["Boolean"]["output"];
  /**
   * アーリーチェックインで支払った料金（税込）
   * 管理者のみ閲覧可能
   */
  earlyCheckInFee?: Maybe<Scalars["Int"]["output"]>;
  /**
   * アーリーチェックインで選択した時間帯スロット
   * 管理者のみ閲覧可能
   */
  earlyCheckInSlot?: Maybe<EarlyCheckInPriceSlot>;
  /** 内部管理用スタンプ（絵文字） */
  internalStamp?: Maybe<Scalars["String"]["output"]>;
  /** 行先地 */
  nextLocation: Scalars["String"]["output"];
  /** 大人人数 */
  numberOfAdults: Scalars["Int"]["output"];
  /** 愛犬を同伴する場合の頭数 */
  numberOfDogs: Scalars["Int"]["output"];
  /** 5歳以下の子供人数 */
  numberOfInfants: Scalars["Int"]["output"];
  /** 12歳未満の子供人数 */
  numberOfKids: Scalars["Int"]["output"];
  /** 合計の子供人数 */
  numberOfTotalChildren: Scalars["Int"]["output"];
  /** 前泊地 */
  previousLocation: Scalars["String"]["output"];
  /**
   * EV充電器を利用する
   * 設備にEVChargerがある場合のみ true にできる
   */
  useEvCharger: Scalars["Boolean"]["output"];
};

export type AccommodationReservationDetailInput = {
  /** 部屋変更を許可する */
  allowRoomChange?: InputMaybe<Scalars["Boolean"]["input"]>;
  bringDog: Scalars["Boolean"]["input"];
  internalStamp?: InputMaybe<Scalars["String"]["input"]>;
  nextLocation: Scalars["String"]["input"];
  numberOfAdults: Scalars["Int"]["input"];
  numberOfDogs: Scalars["Int"]["input"];
  numberOfInfants: Scalars["Int"]["input"];
  numberOfKids: Scalars["Int"]["input"];
  previousLocation: Scalars["String"]["input"];
  useEvCharger: Scalars["Boolean"]["input"];
};

export const AccommodationReservationMutationScope = {
  /** 何も変更できない */
  Freezed: "Freezed",
  /** 宿泊施設・いつから・いつまで滞在するかの変更ができる */
  NoLimit: "NoLimit",
  /** いつまで滞在するかのみ変更ができる */
  OnlyExit: "OnlyExit",
} as const;

export type AccommodationReservationMutationScope =
  (typeof AccommodationReservationMutationScope)[keyof typeof AccommodationReservationMutationScope];
/** 滞在予約でフォームに入力する詳細情報のうち、料金計算に関わる情報 */
export type AccommodationReservationOptions = {
  __typename?: "AccommodationReservationOptions";
  bringDog: Scalars["Boolean"]["output"];
  numberOfDogs: Scalars["Int"]["output"];
  useEvCharger: Scalars["Boolean"]["output"];
};

export type AccommodationReservationOtaDetail = {
  __typename?: "AccommodationReservationOtaDetail";
  address?: Maybe<Scalars["String"]["output"]>;
  apiMessage?: Maybe<Scalars["String"]["output"]>;
  apiReference?: Maybe<Scalars["String"]["output"]>;
  apiSource?: Maybe<Scalars["String"]["output"]>;
  arrivalTime?: Maybe<Scalars["String"]["output"]>;
  bookingTime?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  cancelTime?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  channel?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  comments?: Maybe<Scalars["String"]["output"]>;
  commission?: Maybe<Scalars["Int"]["output"]>;
  company?: Maybe<Scalars["String"]["output"]>;
  countryCode?: Maybe<Scalars["String"]["output"]>;
  deposit?: Maybe<Scalars["Int"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  languageCode?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  modifiedTime?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  postCode?: Maybe<Scalars["String"]["output"]>;
  price?: Maybe<Scalars["Int"]["output"]>;
  pricePerRoom?: Maybe<Scalars["Int"]["output"]>;
  rateDescription?: Maybe<Scalars["String"]["output"]>;
  reference?: Maybe<Scalars["String"]["output"]>;
  referer?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  tax?: Maybe<Scalars["Int"]["output"]>;
};

export type AccommodationReservationProvider =
  | BusinessPlanAccommodationReservationProvider
  | CoOwnersPlanAccommodationReservationProvider
  | FullOwnerPlanAccommodationReservationProvider
  | OneMoreCabinAccommodationReservationProvider
  | OnlineTravelAgentAccommodationReservationProvider
  | SanuIncAccommodationReservationProvider
  | StaffPlanAccommodationReservationProvider
  | StandardPlanAccommodationReservationProvider
  | StayDirectAccommodationReservationProvider
  | StayTicketAccommodationReservationProvider
  | TrialPlanAccommodationReservationProvider;

export type AccommodationReservationProviderInput = {
  providerOneMoreCabinParentAccommodationReservationId?: InputMaybe<
    Scalars["ID"]["input"]
  >;
  providerOrganizationId?: InputMaybe<Scalars["ID"]["input"]>;
  providerOtaIsIkyuDiamondMember?: InputMaybe<Scalars["Boolean"]["input"]>;
  providerOtaLeadAccommodationReservationId?: InputMaybe<
    Scalars["ID"]["input"]
  >;
  providerSanuIncStaffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
  providerSanuIncUsage?: InputMaybe<AccommodationReservationProviderSanuIncUsage>;
  providerStaffContractId?: InputMaybe<Scalars["ID"]["input"]>;
  providerStayTicketUnitId?: InputMaybe<Scalars["ID"]["input"]>;
  providerTrialContractId?: InputMaybe<Scalars["ID"]["input"]>;
  providerType: AccommodationReservationProviderType;
  providerUserOwnershipId?: InputMaybe<Scalars["ID"]["input"]>;
  providerUserSubscriptionId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * 記録用の宿泊用途
 * これで予約ルールを変更することはせず、もしそれが必要になる場合は Provider として切り出すことを検討する。
 * 管理画面での汎用カスタマイズに対するプリセット定義はして良い。
 */
export const AccommodationReservationProviderSanuIncUsage = {
  /** 開業前宿泊 */
  BeforeOpeningStay: "BeforeOpeningStay",
  /** 法人向け宿泊 */
  BusinessStay: "BusinessStay",
  /** 清掃ありブロック（廃止済み） */
  CleaningBlock: "CleaningBlock",
  /** 清掃あり社内利用（廃止済み） */
  CleaningInternalUse: "CleaningInternalUse",
  /** 社員業務宿泊（廃止済み） */
  EmployeeOperationalStay: "EmployeeOperationalStay",
  /** 請求書払い宿泊（廃止済み） */
  InvoicePaymentStay: "InvoicePaymentStay",
  /** One More Cabin（手動）（廃止済み） */
  OneMoreCabinManual: "OneMoreCabinManual",
  /** OTA宿泊 */
  OnlineTravelAgent: "OnlineTravelAgent",
  /** その他有料宿泊 */
  OtherStay: "OtherStay",
  /** プロモーション宿泊（廃止済み） */
  PromotionStay: "PromotionStay",
  /** プロモ枠利用宿泊 */
  PromotionalStay: "PromotionalStay",
  /** Retreat plan（廃止済み） */
  RetreatPlan: "RetreatPlan",
  /** 社員福利厚生（SANU STAY）（廃止済み） */
  SanuStay: "SanuStay",
  /** ステークホルダー宿泊（廃止済み） */
  StakeholderStay: "StakeholderStay",
  /** トラブル・補填宿泊 */
  TroubleCoverStay: "TroubleCoverStay",
  /** トラブル対応宿泊（廃止済み） */
  TroubleStay: "TroubleStay",
} as const;

export type AccommodationReservationProviderSanuIncUsage =
  (typeof AccommodationReservationProviderSanuIncUsage)[keyof typeof AccommodationReservationProviderSanuIncUsage];
/**
 * 宿泊予約を作成する根拠となる、商品・プラン・権利などのプロパイダー
 * 言い換えると、それによって宿泊予約が受ける各種ビジネスルールが異なるようなもの
 */
export const AccommodationReservationProviderType = {
  BusinessPlan: "BusinessPlan",
  CoOwnersPlan: "CoOwnersPlan",
  FullOwnerPlan: "FullOwnerPlan",
  OneMoreCabin: "OneMoreCabin",
  OnlineTravelAgent: "OnlineTravelAgent",
  SanuInc: "SanuInc",
  StaffPlan: "StaffPlan",
  StandardPlan: "StandardPlan",
  StayDirect: "StayDirect",
  StayTicket: "StayTicket",
  TrialPlan: "TrialPlan",
} as const;

export type AccommodationReservationProviderType =
  (typeof AccommodationReservationProviderType)[keyof typeof AccommodationReservationProviderType];
export const AccommodationReservationStayStatus = {
  /** 滞在しなかった */
  NoStay: "NoStay",
  /** キャンセル済み */
  StayCanceled: "StayCanceled",
  /** 滞在後 */
  Stayed: "Stayed",
  /** 滞在中 */
  Staying: "Staying",
  /** 仮押さえ */
  Tentative: "Tentative",
  /** 滞在前 */
  WillStay: "WillStay",
} as const;

export type AccommodationReservationStayStatus =
  (typeof AccommodationReservationStayStatus)[keyof typeof AccommodationReservationStayStatus];
/**
 * 宿泊施設の絞り込み条件
 * accommodationIdsまたはsiteIdsのどちらか一方のみを指定可能
 */
export type AccommodationScope =
  | { accommodationIds: Array<Scalars["ID"]["input"]>; siteIds?: never }
  | { accommodationIds?: never; siteIds: Array<Scalars["ID"]["input"]> };

/** アカウント連携のアイデンティティ情報 */
export type AccountLinkIdentity = {
  __typename?: "AccountLinkIdentity";
  /** Auth0コネクション名 */
  connection: Scalars["String"]["output"];
  /** 認証プロバイダー（例: google-oauth2, apple, auth0） */
  provider: Scalars["String"]["output"];
  /** Auth0ユーザーID */
  userId: Scalars["String"]["output"];
};

/** アカウント連携のプラットフォーム */
export const AccountLinkPlatform = {
  /** ネイティブアプリ */
  Native: "Native",
  /** Webブラウザ */
  Web: "Web",
} as const;

export type AccountLinkPlatform =
  (typeof AccountLinkPlatform)[keyof typeof AccountLinkPlatform];
export type AcquireStayTicketsError = {
  __typename?: "AcquireStayTicketsError";
  case: AcquireStayTicketsErrorCase;
};

export const AcquireStayTicketsErrorCase = {
  InvalidRequest: "InvalidRequest",
  NotAuthorized: "NotAuthorized",
  PaymentFailed: "PaymentFailed",
} as const;

export type AcquireStayTicketsErrorCase =
  (typeof AcquireStayTicketsErrorCase)[keyof typeof AcquireStayTicketsErrorCase];
export type AcquireStayTicketsInput = {
  items: Array<StayTicketAcquisitionItem>;
  mode: StayTicketAcquisitionMode;
};

export type AcquireStayTicketsPayload =
  | AcquireStayTicketsError
  | AcquireStayTicketsResult;

export type AcquireStayTicketsResult = {
  __typename?: "AcquireStayTicketsResult";
  tickets: Array<StayTicket>;
};

export type ActivateMemberPerksDrinkTicketError = {
  __typename?: "ActivateMemberPerksDrinkTicketError";
  case: ActivateMemberPerksDrinkTicketErrorCase;
};

export const ActivateMemberPerksDrinkTicketErrorCase = {
  HasAlreadyActivated: "HasAlreadyActivated",
  IsNotEligible: "IsNotEligible",
} as const;

export type ActivateMemberPerksDrinkTicketErrorCase =
  (typeof ActivateMemberPerksDrinkTicketErrorCase)[keyof typeof ActivateMemberPerksDrinkTicketErrorCase];
export type ActivateMemberPerksDrinkTicketPayload =
  | ActivateMemberPerksDrinkTicketError
  | Success;

/** アンケートの1問分の回答 */
export type AdHocQuestionnaireAnswerInput = {
  /** 質問ID（例: "q1", "q2", "q3"） */
  questionId: Scalars["String"]["input"];
  /** 回答値（回答タイプに応じていずれか1つを指定） */
  value: AdHocQuestionnaireAnswerValueInput;
};

/** 回答値の型。質問タイプに応じていずれか1つのフィールドのみ指定する。 */
export type AdHocQuestionnaireAnswerValueInput =
  /** 自由記述の回答値 */
  | {
      freeText: Scalars["String"]["input"];
      multipleSelect?: never;
      singleSelect?: never;
    } /** 複数選択の回答値 */
  | {
      freeText?: never;
      multipleSelect: AdHocQuestionnaireMultipleSelectInput;
      singleSelect?: never;
    } /** 単一選択の回答値 */
  | {
      freeText?: never;
      multipleSelect?: never;
      singleSelect: Scalars["String"]["input"];
    };

/** 複数選択の回答 */
export type AdHocQuestionnaireMultipleSelectInput = {
  /** 「その他」の自由記述テキスト（「その他」が選択された場合のみ） */
  otherText?: InputMaybe<Scalars["String"]["input"]>;
  /** 選択された選択肢のリスト */
  selected: Array<Scalars["String"]["input"]>;
};

export type AdHocQuestionnaireResponse = {
  __typename?: "AdHocQuestionnaireResponse";
  id: Scalars["ID"]["output"];
  questionnaireTemplateId: Scalars["ID"]["output"];
};

/** 3人目以降の追加ゲスト料金ポリシー */
export type AdditionalGuestFeePolicy = {
  __typename?: "AdditionalGuestFeePolicy";
  /** 大人の人数別単価。インデックス i = 基準を超えて (i+1) 人目。空配列=追加料金なし。 */
  adultPrices: Array<Scalars["Int"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** 内部管理用の名称 */
  internalName: Scalars["String"]["output"];
  /** 子供（6〜12歳）の人数別単価。仕様は大人と同じ。 */
  kidsPrices: Array<Scalars["Int"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export const AdditionalNoticeType = {
  Refund: "Refund",
  Transfer: "Transfer",
} as const;

export type AdditionalNoticeType =
  (typeof AdditionalNoticeType)[keyof typeof AdditionalNoticeType];
export type Address = AddressInJapan | AddressInternational;

export type AddressInJapan = {
  __typename?: "AddressInJapan";
  /**
   * 住所1。郵便番号から都道府県〜町域が自動入力される（例: 東京都千代田区千代田）。
   * line2 との区切りは入力者次第で保証されないため、連結して 1 つの住所として扱う
   */
  line1: Scalars["String"]["output"];
  /** 住所2。番地・建物名・部屋番号（例: 1-1 〇〇ビル101） */
  line2: Scalars["String"]["output"];
  /** 郵便番号 */
  postalCode: Scalars["String"]["output"];
};

export type AddressInJapanInput = {
  line1: Scalars["String"]["input"];
  line2: Scalars["String"]["input"];
  postalCode: Scalars["String"]["input"];
};

export type AddressInternational = {
  __typename?: "AddressInternational";
  /** 市区町村（City） */
  city: Scalars["String"]["output"];
  /** 国名（Country） */
  country: CountryEnum;
  /** 建物名、通り名・番地（Building Name, Street Address） */
  line1: Scalars["String"]["output"];
  /** アパート・部屋番号（Apartment/Unit/Suite Number） */
  line2?: Maybe<Scalars["String"]["output"]>;
  /** 郵便番号（ZIP/Postal Code） */
  postalCode: Scalars["String"]["output"];
  /** 州・県（State/Province） */
  stateProvince: Scalars["String"]["output"];
};

export type AddressInternationalInput = {
  city: Scalars["String"]["input"];
  country: CountryEnum;
  line1: Scalars["String"]["input"];
  line2?: InputMaybe<Scalars["String"]["input"]>;
  postalCode: Scalars["String"]["input"];
  stateProvince: Scalars["String"]["input"];
};

export const AdminRole = {
  /**
   * 管理者。業務データの閲覧・更新と、スクリプト・開発用の口を使える。unrestricted なので、
   * @access の無い internal root も旧 admin フラグと同じく通る。
   */
  Admin: "Admin",
  /** テスト専用・付与不可。既存テストが閲覧専用のロールとして使うので定義だけ残しており、削除予定。 */
  OpsSupport: "OpsSupport",
  /**
   * 清掃・管理パートナー企業の拠点責任者（外部）。常に拠点スコープで、PartnerSiteStaff と同じ閲覧・清掃の
   * 操作に加え、自分の拠点に限って PartnerSiteStaff を付与・剥奪できる。他の拠点や他のロールは付与できない。
   * scope 付きなので T2 以上は見えない。SuperAdmin が付与する。
   */
  PartnerSiteManager: "PartnerSiteManager",
  /**
   * テスト専用・付与不可。既存テストが拠点スコープの閲覧ロールとして使うので定義だけ残しており、削除予定。
   * 外部パートナーに渡すのは PartnerSiteManager / PartnerSiteStaff。
   */
  PartnerSiteOperator: "PartnerSiteOperator",
  /**
   * 清掃・管理パートナー企業のスタッフ（外部）。常に拠点スコープで、担当拠点の予約・宿泊運営カレンダー（部屋と
   * 利用ブロック。ブロックの名前とメモは伏せる）と付帯サービスの清掃タスクだけ扱う。scope 付きなので T2 以上は見えない。
   * SuperAdmin と、同じ拠点の PartnerSiteManager が付与する。
   */
  PartnerSiteStaff: "PartnerSiteStaff",
  /**
   * ロール管理者。Admin ロールの付与・剥奪と、ロール割り当ての一覧、その画面で使うユーザー検索だけ
   * できる。他の管理画面は使えない。
   */
  RoleAdmin: "RoleAdmin",
  /** すべての操作ができ、SuperAdmin・Admin・RoleAdmin・PartnerSiteManager・PartnerSiteStaff を付与・剥奪できる。Tech チームに付ける。 */
  SuperAdmin: "SuperAdmin",
} as const;

export type AdminRole = (typeof AdminRole)[keyof typeof AdminRole];
/**
 * 管理ロールの割り当て。失効は revokedAt で記録し、再付与は新しい行になる（監査のため行は消さない）。
 * 拠点スコープの主体には自分の拠点の行だけ見せ、全拠点のロールの行（site が null）は見せない。
 */
export type AdminRoleAssignment = {
  __typename?: "AdminRoleAssignment";
  /** 割り当て先の氏名とメール。拠点スコープの PartnerSiteManager がロール画面で読むための射影 */
  assignee: InternalAdminRoleAssignee;
  expiresAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  grantedAt: Scalars["ZonedDateTime"]["output"];
  /**
   * 付与した管理者。adminRoleAssignments は本人にも読めるので、付与者の素性が
   * 被付与者に漏れないよう UsersRead で塞ぐ。移行で機械的に付与した行は null。
   */
  grantedByUser?: Maybe<User>;
  id: Scalars["ID"]["output"];
  revokedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  revokedByUser?: Maybe<User>;
  role: AdminRole;
  /** 拠点スコープ。scope: Site のロールでは必ず入り、それ以外では null。 */
  site?: Maybe<Site>;
  /** 割り当て先。拠点スコープの主体は User を辿れないので、ロール画面は assignee を読む */
  user: User;
};

export type AgreeToTermsError = {
  __typename?: "AgreeToTermsError";
  case: AgreeToTermsErrorCase;
};

export const AgreeToTermsErrorCase = {
  /** 規約の改定が存在しない、または同意を求めていない改定（User.requiredTermsAgreements に含まれない） */
  NotFound: "NotFound",
} as const;

export type AgreeToTermsErrorCase =
  (typeof AgreeToTermsErrorCase)[keyof typeof AgreeToTermsErrorCase];
export type AgreeToTermsPayload = AgreeToTermsError | Success;

export type AgreeToWeekdayTermsError = {
  __typename?: "AgreeToWeekdayTermsError";
  case: AgreeToWeekdayTermsErrorCase;
};

export const AgreeToWeekdayTermsErrorCase = {
  /** 既に同意済み */
  AlreadyAgreed: "AlreadyAgreed",
  /** サブスクリプションが存在しない */
  NotSubscribed: "NotSubscribed",
} as const;

export type AgreeToWeekdayTermsErrorCase =
  (typeof AgreeToWeekdayTermsErrorCase)[keyof typeof AgreeToWeekdayTermsErrorCase];
export type AgreeToWeekdayTermsPayload = AgreeToWeekdayTermsError | Success;

export type ApplyToTrialSubscriptionError = {
  __typename?: "ApplyToTrialSubscriptionError";
  case: ApplyToTrialSubscriptionErrorCase;
};

export const ApplyToTrialSubscriptionErrorCase = {
  DuplicationError: "DuplicationError",
  InvalidEnrollmentMonth: "InvalidEnrollmentMonth",
  InvalidOperation: "InvalidOperation",
  PaymentError: "PaymentError",
} as const;

export type ApplyToTrialSubscriptionErrorCase =
  (typeof ApplyToTrialSubscriptionErrorCase)[keyof typeof ApplyToTrialSubscriptionErrorCase];
export type ApplyToTrialSubscriptionPayload =
  | ApplyToTrialSubscriptionError
  | StripeRequireNextAction
  | Success;

export type ApplyToWeekdaySubscriptionError = {
  __typename?: "ApplyToWeekdaySubscriptionError";
  case: ApplyToWeekdaySubscriptionErrorCase;
};

export const ApplyToWeekdaySubscriptionErrorCase = {
  DuplicationError: "DuplicationError",
  InvalidOperation: "InvalidOperation",
  InvalidPromotionCode: "InvalidPromotionCode",
  InvalidStartDate: "InvalidStartDate",
  PaymentError: "PaymentError",
} as const;

export type ApplyToWeekdaySubscriptionErrorCase =
  (typeof ApplyToWeekdaySubscriptionErrorCase)[keyof typeof ApplyToWeekdaySubscriptionErrorCase];
export type ApplyToWeekdaySubscriptionPayload =
  | ApplyToWeekdaySubscriptionError
  | StripeRequireNextAction
  | Success;

/** 建築タイプ */
export type ArchitectureType = {
  __typename?: "ArchitectureType";
  /** この建築タイプの宿泊施設一覧（管理者向け） */
  accommodations: Array<Accommodation>;
  /** この建築タイプの宿泊施設数 */
  accommodationsCount: Scalars["Int"]["output"];
  /**
   * 1泊あたりの施設追加料金
   * デフォルトは0で、主にリノベーションに対して設定される。
   */
  additionalFee: Scalars["Int"]["output"];
  /** 収容人数 */
  capacity: Scalars["Int"]["output"];
  /** 建築のコンテンツ */
  content: ContentArchitectureType;
  id: Scalars["ID"]["output"];
  /** CMS 編集用のコンテンツ。content_architecture_types 行が無い場合は null（公開側の content は throw する） */
  internalContent?: Maybe<ContentArchitectureType>;
  /**
   * 呼称
   * モデル名＋サイズ
   * e.g. BEE, MOSS Medium, ARC Small, HIARI, ...
   */
  name: Scalars["String"]["output"];
  /** 公開済みかどうか */
  published: Scalars["Boolean"]["output"];
  /** 建築ラインナップ自体のカテゴリー */
  series: ArchitectureTypeSeries;
  /** シリーズ名（DBカラム名、例：SANU CABIN） */
  seriesName: Scalars["String"]["output"];
  /**
   * モデル名
   * e.g. BEE, MOSS, ARC, HIARI, ....
   */
  seriesShortName: Scalars["String"]["output"];
  /** 建築サイズ。サイズが定義されている建築の場合のみ */
  size?: Maybe<ArchitectureTypeSize>;
  slug: Scalars["String"]["output"];
};

/** 建築シリーズ */
export const ArchitectureTypeSeries = {
  /** SANUオリジナルの設計。プロダクトとして多数展開される。 */
  Original: "Original",
  /** 主に既存の建物のリノベーション。単棟になる。 */
  Selection: "Selection",
} as const;

export type ArchitectureTypeSeries =
  (typeof ArchitectureTypeSeries)[keyof typeof ArchitectureTypeSeries];
/** 建築サイズ */
export const ArchitectureTypeSize = {
  Large: "Large",
  Medium: "Medium",
  Small: "Small",
} as const;

export type ArchitectureTypeSize =
  (typeof ArchitectureTypeSize)[keyof typeof ArchitectureTypeSize];
/** トップページ表示のArchive article (ニュースレター) */
export type ArchiveArticle = {
  __typename?: "ArchiveArticle";
  /** 新しいかどうか */
  isNew: Scalars["Boolean"]["output"];
  /** 日付 */
  publishedAt: Scalars["ZonedDateTime"]["output"];
  /** タイトル */
  title: Scalars["String"]["output"];
  /** 遷移先URL */
  url: Scalars["String"]["output"];
};

/**
 * エリア
 * 散財する拠点を一定の地域でまとめたもの
 */
export type Area = {
  __typename?: "Area";
  /** エリアのコンテンツ */
  content: AreaContent;
  id: Scalars["ID"]["output"];
  /**
   * エリアの名前
   * 例：一宮、安曇野
   */
  name: Scalars["String"]["output"];
  /**
   * エリアに含まれる published 済みの拠点の一覧。予約開始前の拠点も含む。
   * 非公開を含む全件は internal の InternalArea.sites を使う。
   */
  sites: Array<Site>;
  /**
   * エリアに含まれる、予約ができる拠点の一覧。
   * provider なしの場合は一般予約可能 (reservable) な拠点のみを返す。
   * 公開ページの拠点一覧には sites を使う。
   */
  sitesForReservation: Array<Site>;
  slug: Scalars["String"]["output"];
  /** 並び順 */
  sort: Scalars["Int"]["output"];
};

/**
 * エリア
 * 散財する拠点を一定の地域でまとめたもの
 */
export type AreasitesForReservationArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

/** エリアコンテンツ */
export type AreaContent = {
  __typename?: "AreaContent";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  /** 東京からのアクセス説明 */
  accessFromTokyoDescription?: Maybe<Scalars["String"]["output"]>;
  allCapsName?: Maybe<Scalars["String"]["output"]>;
  /** キャッチコピー */
  catchCopy?: Maybe<Scalars["String"]["output"]>;
  /** エリア紹介文（長文） */
  description?: Maybe<Scalars["String"]["output"]>;
  /** エリアガイド記事（MAGAZINE への動線）。掲載対象エリアにこのエリアを含む記事を sort 順で返す */
  guideArticles: Array<AreaGuideArticle>;
  /** おすすめスポットをまとめたGoogle MapsリストのURL */
  guideSpotMapListUrl?: Maybe<Scalars["String"]["output"]>;
  /** おすすめスポットページ下部Tipsの本文（💡） */
  guideSpotTips?: Maybe<Scalars["String"]["output"]>;
  /** おすすめスポットページ下部Tipsの見出し（例: スーパーやショップは拠点に向かう前に立ち寄るのがおすすめ。） */
  guideSpotTipsTitle?: Maybe<Scalars["String"]["output"]>;
  /** おすすめスポット */
  guideSpots: Array<AreaGuideSpot>;
  /** ヒーロー画像 */
  heroImages: Array<UploadedFile>;
  reservationFormCoverImageUrl?: Maybe<Scalars["String"]["output"]>;
  /** 道路状況ライブカメラURL */
  roadConditionLiveCameraUrl?: Maybe<Scalars["String"]["output"]>;
  /** 短い住所表示（例: "静岡県"） */
  shortAddress?: Maybe<Scalars["String"]["output"]>;
  /** 最終更新日時（編集履歴の表示用） */
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/**
 * エリアページから MAGAZINE のエリアガイド記事へ誘導するリンク。
 * 記事本文は MAGAZINE 側にあり、ここには動線に必要なメタ情報だけを持つ。
 * guideArticles は並び順で返すので、公開側に sort は出さない (admin 用は internal schema)。
 */
export type AreaGuideArticle = {
  __typename?: "AreaGuideArticle";
  /** 掲載対象エリア（admin の一覧・編集フォーム用） */
  areas: Array<InternalArea>;
  id: Scalars["ID"]["output"];
  /** MAGAZINE 上の公開日。表示専用で、掲載可否には効かない */
  publishedDate: Scalars["PlainDate"]["output"];
  /** 並び順（全記事で 1 本。エリアごとには持たない） */
  sort: Scalars["Int"]["output"];
  /** サムネイル画像。未設定なら null */
  thumbnail?: Maybe<UploadedFile>;
  title: Scalars["String"]["output"];
  /** MAGAZINE 記事の URL */
  url: Scalars["String"]["output"];
};

/** エリアのおすすめスポット */
export type AreaGuideSpot = {
  __typename?: "AreaGuideSpot";
  businessHours?: Maybe<Scalars["String"]["output"]>;
  /** カテゴリ（複数可。Bubble の option_area_guide_category が String[] のため） */
  categories: Array<AreaGuideSpotCategory>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  images: Array<UploadedFile>;
  mapUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** 掲載終了日（当日を含む）。null は無期限。この日を過ぎると公開ページから外れる */
  publishEndDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 掲載開始日（当日を含む）。null は開始日の指定なし */
  publishStartDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /**
   * 今日時点で公開ページに出ているか（掲載期間の中にいるか）。
   * 公開ページの絞り込みと同じ判定なので、admin の表示はこれを使う
   */
  publishedNow: Scalars["Boolean"]["output"];
  sort: Scalars["Int"]["output"];
  /** タグ（ベーカリー・スーパー 等のフリーテキスト） */
  tags: Array<Scalars["String"]["output"]>;
  websiteUrl?: Maybe<Scalars["String"]["output"]>;
};

/**
 * おすすめスポットのカテゴリ。
 * カテゴリを増やす場合はエンジニアが Prisma の enum を更新する必要がある。
 */
export const AreaGuideSpotCategory = {
  /** 飲食店 */
  CafeRestaurant: "CafeRestaurant",
  /** イベント */
  Events: "Events",
  /** 食料品店 */
  FoodStore: "FoodStore",
  /** 自然 */
  NatureSpot: "NatureSpot",
  /** その他 */
  Others: "Others",
  /** ショップ */
  Shop: "Shop",
} as const;

export type AreaGuideSpotCategory =
  (typeof AreaGuideSpotCategory)[keyof typeof AreaGuideSpotCategory];
export type Auth0User = {
  __typename?: "Auth0User";
  /** Auth0 の User ID */
  id: Scalars["String"]["output"];
  /** リンク済みアイデンティティのAuth0 ID一覧（ローカルDB） */
  linkedIdentities: Array<Scalars["String"]["output"]>;
};

/** 基本料金モード */
export const BaseAccommodationFeeMode = {
  Daily: "Daily",
  Policy: "Policy",
} as const;

export type BaseAccommodationFeeMode =
  (typeof BaseAccommodationFeeMode)[keyof typeof BaseAccommodationFeeMode];
/** 基本となる1泊ごとの宿泊料金のポリシー */
export type BaseAccommodationFeePolicy = {
  __typename?: "BaseAccommodationFeePolicy";
  /**
   * 1泊目、2泊目と決まる料金
   * このリストよりも長い泊数になる場合は、定義されている最後の1泊の料金が適用される。
   */
  dailyFeePolicy?: Maybe<Array<Scalars["Int"]["output"]>>;
  id: Scalars["ID"]["output"];
  /** 内部向けの名前 */
  internalName: Scalars["String"]["output"];
};

export type Beds24Booking = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  apiMessage?: InputMaybe<Scalars["String"]["input"]>;
  apiReference?: InputMaybe<Scalars["String"]["input"]>;
  apiSource?: InputMaybe<Scalars["String"]["input"]>;
  arrival: Scalars["PlainDate"]["input"];
  arrivalTime?: InputMaybe<Scalars["String"]["input"]>;
  bookingGroup?: InputMaybe<Beds24BookingGroup>;
  bookingTime?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  cancelTime?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  channel?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  comments?: InputMaybe<Scalars["String"]["input"]>;
  commission?: InputMaybe<Scalars["Int"]["input"]>;
  company?: InputMaybe<Scalars["String"]["input"]>;
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  departure: Scalars["PlainDate"]["input"];
  deposit?: InputMaybe<Scalars["Int"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  languageCode?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  masterId?: InputMaybe<Scalars["Int"]["input"]>;
  modifiedTime?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  numAdult: Scalars["Int"]["input"];
  numChild: Scalars["Int"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
  postCode?: InputMaybe<Scalars["String"]["input"]>;
  price?: InputMaybe<Scalars["Int"]["input"]>;
  pricePerRoom?: InputMaybe<Scalars["Int"]["input"]>;
  rateDescription?: InputMaybe<Scalars["String"]["input"]>;
  reference?: InputMaybe<Scalars["String"]["input"]>;
  referer?: InputMaybe<Scalars["String"]["input"]>;
  roomId: Scalars["Int"]["input"];
  state?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["String"]["input"];
  tax?: InputMaybe<Scalars["Int"]["input"]>;
  unitId: Scalars["Int"]["input"];
};

export type Beds24BookingDetail = {
  __typename?: "Beds24BookingDetail";
  fee: Beds24BookingFee;
  isGroupBooking: Scalars["Boolean"]["output"];
  masterBookingId?: Maybe<Scalars["Int"]["output"]>;
};

export type Beds24BookingEvent = {
  booking: Beds24Booking;
  infoItems: Array<Beds24InfoItem>;
  invoiceItems: Array<Beds24InvoiceItem>;
  messages: Array<Beds24Message>;
};

export type Beds24BookingFee = {
  __typename?: "Beds24BookingFee";
  perRoomAmount: Scalars["Int"]["output"];
  totalAmount?: Maybe<Scalars["Int"]["output"]>;
  totalUnpaidAmount?: Maybe<Scalars["Int"]["output"]>;
};

export type Beds24BookingGroup = {
  ids: Array<Scalars["Int"]["input"]>;
  master: Scalars["Int"]["input"];
};

export type Beds24BookingMessageError = {
  __typename?: "Beds24BookingMessageError";
  case: Beds24BookingMessageErrorCase;
};

export const Beds24BookingMessageErrorCase = {
  GeneralError: "GeneralError",
  InvalidEmail: "InvalidEmail",
} as const;

export type Beds24BookingMessageErrorCase =
  (typeof Beds24BookingMessageErrorCase)[keyof typeof Beds24BookingMessageErrorCase];
export const Beds24BookingMessageKind = {
  ReservationReminderBefore2Day: "ReservationReminderBefore2Day",
  ReservationReminderToday: "ReservationReminderToday",
  TentativeReservationCreated: "TentativeReservationCreated",
} as const;

export type Beds24BookingMessageKind =
  (typeof Beds24BookingMessageKind)[keyof typeof Beds24BookingMessageKind];
export type Beds24BookingMessageResult = Beds24BookingMessageError | Success;

export type Beds24BookingMessageResultPayload = {
  __typename?: "Beds24BookingMessageResultPayload";
  result: Beds24BookingMessageResult;
};

export type Beds24InfoItem = {
  code: Scalars["String"]["input"];
  id: Scalars["Int"]["input"];
  text: Scalars["String"]["input"];
};

export type Beds24InvoiceItem = {
  id: Scalars["Int"]["input"];
  lineTotal: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
};

export type Beds24Message = {
  id: Scalars["Int"]["input"];
  message: Scalars["String"]["input"];
};

export type Beds24SyncFollowingReservationsResultPayload =
  | CancelAccommodationReservationError
  | ChangeAccommodationReservationError;

export type Beds24WebhookError = {
  __typename?: "Beds24WebhookError";
  case: Beds24WebhookErrorCase;
};

export const Beds24WebhookErrorCase = {
  BookingStatusNotSupported: "BookingStatusNotSupported",
  GeneralError: "GeneralError",
  ReservationNotFound: "ReservationNotFound",
  UnsupportedProvider: "UnsupportedProvider",
} as const;

export type Beds24WebhookErrorCase =
  (typeof Beds24WebhookErrorCase)[keyof typeof Beds24WebhookErrorCase];
export type Beds24WebhookResult = Beds24WebhookError | Beds24WebhookSuccess;

export type Beds24WebhookResultPayload = {
  __typename?: "Beds24WebhookResultPayload";
  bookingDetail?: Maybe<Beds24BookingDetail>;
  changes?: Maybe<Array<AccommodationReservationChange>>;
  message?: Maybe<Scalars["String"]["output"]>;
  reservation?: Maybe<AccommodationReservation>;
  result: Beds24WebhookResult;
};

export type Beds24WebhookSuccess = {
  __typename?: "Beds24WebhookSuccess";
  case: Beds24WebhookSuccessCase;
};

export const Beds24WebhookSuccessCase = {
  BookingNotAssigned: "BookingNotAssigned",
  ProcessingSkipped: "ProcessingSkipped",
  ReservationCanceled: "ReservationCanceled",
  ReservationChanged: "ReservationChanged",
  ReservationCreated: "ReservationCreated",
  ReservationDetailUpdated: "ReservationDetailUpdated",
} as const;

export type Beds24WebhookSuccessCase =
  (typeof Beds24WebhookSuccessCase)[keyof typeof Beds24WebhookSuccessCase];
export const BillingMethod = {
  /** 自動請求 - Stripe経由で自動的に請求されます */
  AutoCharge: "AutoCharge",
  /** 別途請求 - 別途請求処理が必要です */
  Manual: "Manual",
} as const;

export type BillingMethod = (typeof BillingMethod)[keyof typeof BillingMethod];
export type BulkCreateOrganizationYearlyContractInvoicesInput = {
  /** 年間払いか、月払いか */
  frequency: OrganizationYearlyContractInvoiceFrequency;
  /**
   * 下書きとして作成するか、すぐにオープンな契約書として作成するか
   * デフォルト: true
   */
  isDraft?: Scalars["Boolean"]["input"];
  /** 請求金額（税込） */
  itemAmount: Scalars["Int"]["input"];
  /** 決済方法。銀行振込か、クレジットカード払いか */
  paymentMethodType: OrganizationYearlyContractInvoicePaymentMethodType;
  /**
   * 請求書を自動でオープンにする場合の日付（下書きの場合のみ）
   * 年払いの場合: この日付に公開
   * 月払いの場合: 各月のこの日付に公開（例: 2025-01-15を指定すると、2025年1月15日、2月15日、...、12月15日に公開）
   */
  scheduledOpenDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export type BundleStayTicketsPayload = {
  __typename?: "BundleStayTicketsPayload";
  /**
   * 同一のビジネスルールを持つ宿泊チケットのまとまり。
   * バリデーションエラーにならない宿泊チケットが少なくとも一つ以上ある場合、このフィールドが返る。
   */
  stayTicketUnit?: Maybe<StayTicketUnit>;
  /** 引数で与えられた宿泊チケットコードと同じ順序・数で返る。 */
  stayTicketsValidationResult: Array<StayTicketValidationResult>;
};

/** 企業が契約できるビジネスプラン */
export type BusinessPlan = {
  __typename?: "BusinessPlan";
  /** メンバーが支払う1泊あたりの金額 */
  feePerNights: Scalars["Int"]["output"];
  /** 1口あたりの価格（税込） */
  feePerNum: Scalars["Int"]["output"];
  /** ビジネスプランのID（現在は名前と同じ） */
  id: Scalars["ID"]["output"];
  /** 繁忙日料金を無料にするかどうか */
  isPeakDayFeeFree: Scalars["Boolean"]["output"];
  /** ビジネスプランの名前 */
  name: Scalars["String"]["output"];
};

export type BusinessPlanAccommodationReservationProvider = {
  __typename?: "BusinessPlanAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  organizationId: Scalars["ID"]["output"];
};

export type CancelAccommodationReservationError = {
  __typename?: "CancelAccommodationReservationError";
  case: CancelAccommodationReservationErrorCase;
};

export const CancelAccommodationReservationErrorCase = {
  CancelPaymentFailed: "CancelPaymentFailed",
  CancelRuleError: "CancelRuleError",
  CancelTemporarilyUnavailable: "CancelTemporarilyUnavailable",
  HasActiveFacilityReservation: "HasActiveFacilityReservation",
  NotAuthorized: "NotAuthorized",
} as const;

export type CancelAccommodationReservationErrorCase =
  (typeof CancelAccommodationReservationErrorCase)[keyof typeof CancelAccommodationReservationErrorCase];
export type CancelAccommodationReservationPayload =
  | AccommodationReservation
  | CancelAccommodationReservationError;

export type CancelCoOwnersApplicationError = {
  __typename?: "CancelCoOwnersApplicationError";
  case: CancelCoOwnersApplicationErrorCase;
};

export const CancelCoOwnersApplicationErrorCase = {
  AlreadyCancelled: "AlreadyCancelled",
  CannotCancelAfterHandover: "CannotCancelAfterHandover",
  NotFound: "NotFound",
  PermissionDenied: "PermissionDenied",
  StripeRefundError: "StripeRefundError",
} as const;

export type CancelCoOwnersApplicationErrorCase =
  (typeof CancelCoOwnersApplicationErrorCase)[keyof typeof CancelCoOwnersApplicationErrorCase];
export type CancelCoOwnersApplicationPayload =
  | CancelCoOwnersApplicationError
  | Success;

export type CancelFacilityReservationError = {
  __typename?: "CancelFacilityReservationError";
  case: CancelFacilityReservationErrorCase;
};

export const CancelFacilityReservationErrorCase = {
  AlreadyCanceled: "AlreadyCanceled",
  NotAuthorized: "NotAuthorized",
  NotCancelable: "NotCancelable",
  PastReserveDeadline: "PastReserveDeadline",
  ReservationNotFound: "ReservationNotFound",
} as const;

export type CancelFacilityReservationErrorCase =
  (typeof CancelFacilityReservationErrorCase)[keyof typeof CancelFacilityReservationErrorCase];
export type CancelFacilityReservationPayload =
  | CancelFacilityReservationError
  | Success;

/**
 * 宿泊料金を元にしたキャンセル料金のポリシー
 * 例えば、前日であれば100%、3日前であれば70%などのように決まる。
 */
export type CancelFeeFixedPolicy = {
  __typename?: "CancelFeeFixedPolicy";
  before1DaysFee: Scalars["Int"]["output"];
  before3DaysFee: Scalars["Int"]["output"];
  before7DaysFee: Scalars["Int"]["output"];
  /** true の場合、即時100%のキャンセル料が発生する（実質的にキャンセル不可のポリシー）。 */
  immediate: Scalars["Boolean"]["output"];
};

export type CancelFeeFixedPolicyInput = {
  before1DaysFee: Scalars["Int"]["input"];
  before3DaysFee: Scalars["Int"]["input"];
  before7DaysFee: Scalars["Int"]["input"];
};

/**
 * 宿泊予約に適用されるキャンセル料金のポリシー
 * @deprecated Use AccommodationReservation.cancellationPolicy instead
 */
export type CancelFeePolicy = CancelFeeFixedPolicy | CancelFeeRatePolicy;

/** 固定額になっているキャンセル料金のポリシー */
export type CancelFeeRatePolicy = {
  __typename?: "CancelFeeRatePolicy";
  before1DaysRate: Scalars["Float"]["output"];
  before3DaysRate: Scalars["Float"]["output"];
  before7DaysRate: Scalars["Float"]["output"];
  /** true の場合、即時100%のキャンセル料が発生する（実質的にキャンセル不可のポリシー）。 */
  immediate: Scalars["Boolean"]["output"];
};

export type CancelFeeRatePolicyInput = {
  before1DaysRate: Scalars["Float"]["input"];
  before3DaysRate: Scalars["Float"]["input"];
  before7DaysRate: Scalars["Float"]["input"];
};

export type CancelStandardSubscriptionApplicationError = {
  __typename?: "CancelStandardSubscriptionApplicationError";
  case: CancelStandardSubscriptionApplicationErrorCase;
  stripeRequestId?: Maybe<Scalars["String"]["output"]>;
};

export const CancelStandardSubscriptionApplicationErrorCase = {
  InvalidOperation: "InvalidOperation",
  NoSubscriptionScheduleError: "NoSubscriptionScheduleError",
  ReservationExists: "ReservationExists",
  StripeError: "StripeError",
  UnknownError: "UnknownError",
} as const;

export type CancelStandardSubscriptionApplicationErrorCase =
  (typeof CancelStandardSubscriptionApplicationErrorCase)[keyof typeof CancelStandardSubscriptionApplicationErrorCase];
export type CancelStandardSubscriptionApplicationPayload =
  | CancelStandardSubscriptionApplicationError
  | Success;

export type CancelStandardSubscriptionPauseError = {
  __typename?: "CancelStandardSubscriptionPauseError";
  case: CancelStandardSubscriptionPauseErrorCase;
};

export const CancelStandardSubscriptionPauseErrorCase = {
  InvalidOperation: "InvalidOperation",
  NoSubscriptionError: "NoSubscriptionError",
  NoSubscriptionScheduleError: "NoSubscriptionScheduleError",
  StripeError: "StripeError",
  SubscriptionScheduleInvalidTrigger: "SubscriptionScheduleInvalidTrigger",
} as const;

export type CancelStandardSubscriptionPauseErrorCase =
  (typeof CancelStandardSubscriptionPauseErrorCase)[keyof typeof CancelStandardSubscriptionPauseErrorCase];
export type CancelStandardSubscriptionPausePayload =
  | CancelStandardSubscriptionPauseError
  | Success;

export type CancelStandardSubscriptionResumeError = {
  __typename?: "CancelStandardSubscriptionResumeError";
  case: CancelStandardSubscriptionResumeErrorCase;
};

export const CancelStandardSubscriptionResumeErrorCase = {
  GeneralError: "GeneralError",
  InvalidOperation: "InvalidOperation",
} as const;

export type CancelStandardSubscriptionResumeErrorCase =
  (typeof CancelStandardSubscriptionResumeErrorCase)[keyof typeof CancelStandardSubscriptionResumeErrorCase];
export type CancelStandardSubscriptionResumePayload =
  | CancelStandardSubscriptionResumeError
  | Success;

export type CancelStandardSubscriptionTerminationError = {
  __typename?: "CancelStandardSubscriptionTerminationError";
  case: CancelStandardSubscriptionTerminationErrorCase;
};

export const CancelStandardSubscriptionTerminationErrorCase = {
  InvalidOperation: "InvalidOperation",
  NoSubscriptionError: "NoSubscriptionError",
  NotTerminating: "NotTerminating",
  StripeError: "StripeError",
} as const;

export type CancelStandardSubscriptionTerminationErrorCase =
  (typeof CancelStandardSubscriptionTerminationErrorCase)[keyof typeof CancelStandardSubscriptionTerminationErrorCase];
export type CancelStandardSubscriptionTerminationPayload =
  | CancelStandardSubscriptionTerminationError
  | Success;

export type CancelStayGiftsError = {
  __typename?: "CancelStayGiftsError";
  case: CancelStayGiftsErrorCase;
};

export const CancelStayGiftsErrorCase = {
  /** チケットがキャンセル可能な状態ではない（既にキャンセル済みなど） */
  InvalidState: "InvalidState",
  /** 認証エラー（他人のチケットを指定した場合） */
  NotAuthorized: "NotAuthorized",
  /** 指定されたチケットが存在しない */
  NotFound: "NotFound",
} as const;

export type CancelStayGiftsErrorCase =
  (typeof CancelStayGiftsErrorCase)[keyof typeof CancelStayGiftsErrorCase];
/** Stay Giftチケットキャンセルの結果 */
export type CancelStayGiftsPayload =
  | CancelStayGiftsError
  | CancelStayGiftsResult;

export type CancelStayGiftsResult = {
  __typename?: "CancelStayGiftsResult";
  /** キャンセルされたチケット */
  cancelledTickets: Array<StayTicket>;
};

export type CancelTrialSubscriptionError = {
  __typename?: "CancelTrialSubscriptionError";
  case: CancelTrialSubscriptionErrorCase;
};

export const CancelTrialSubscriptionErrorCase = {
  ContractNotFound: "ContractNotFound",
  InvalidOperation: "InvalidOperation",
  ReservationExists: "ReservationExists",
  StripeError: "StripeError",
} as const;

export type CancelTrialSubscriptionErrorCase =
  (typeof CancelTrialSubscriptionErrorCase)[keyof typeof CancelTrialSubscriptionErrorCase];
export type CancelTrialSubscriptionPayload =
  | CancelTrialSubscriptionError
  | Success;

/** キャンセル料金の1段階。表示用ラベルと料金説明のペア。 */
export type CancellationFeeTier = {
  __typename?: "CancellationFeeTier";
  /** 料金の説明文（例: "11,000円（税込）" or "宿泊料金の100%"） */
  feeDescription: Scalars["String"]["output"];
  /** 表示用ラベル（例: "宿泊日3日前の15時以降"） */
  label: Scalars["String"]["output"];
};

/**
 * 予約に適用されるキャンセルポリシー全体。
 * 新旧ルール跨ぎの場合は sections が2件になる。
 */
export type CancellationPolicyContent = {
  __typename?: "CancellationPolicyContent";
  sections: Array<CancellationPolicySection>;
};

/**
 * キャンセルポリシーの1セクション。
 * 新旧ルール跨ぎの場合、日付範囲ごとに conditionLabel で区別する。
 */
export type CancellationPolicySection = {
  __typename?: "CancellationPolicySection";
  changeDeadlineDescription: Scalars["String"]["output"];
  /** 条件ラベル（例: "4/24以前の宿泊日"）。単一ルールの場合 null */
  conditionLabel?: Maybe<Scalars["String"]["output"]>;
  noShowDescription: Scalars["String"]["output"];
  tiers: Array<CancellationFeeTier>;
};

export type ChangeAccommodationAvailabilityBlockInput = {
  beginNight: Scalars["PlainDate"]["input"];
  category: AccommodationAvailabilityBlockCategory;
  endNight: Scalars["PlainDate"]["input"];
  /**
   * 既存の予約と重複していてもブロックを変更する。
   * 既存の他ブロックとの重複は指定に関わらず不可。
   */
  ignoreReservations?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTentative: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  staffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ChangeAccommodationReservationError = {
  __typename?: "ChangeAccommodationReservationError";
  case: ChangeAccommodationReservationErrorCase;
  internalCode?: Maybe<Scalars["String"]["output"]>;
};

export const ChangeAccommodationReservationErrorCase = {
  /** 予約変更手数料の支払いに失敗した */
  ChangePaymentFailed: "ChangePaymentFailed",
  /** サブスクにおいて同一予約サイクル内ですでに予約を取っている */
  CycleDuplicationError: "CycleDuplicationError",
  /** 変更先の日程または拠点に対応していない付帯サービス予約があるため変更できない */
  HasConflictingFacilityReservation: "HasConflictingFacilityReservation",
  /** 現在予約可能な期間に収まっていない */
  InvalidReservationPeriodError: "InvalidReservationPeriodError",
  /** 月間泊数の上限を超えている */
  MaxNightsPerMonthExceededError: "MaxNightsPerMonthExceededError",
  /** 年間泊数の上限を超えている */
  MaxNightsPerYearExceededError: "MaxNightsPerYearExceededError",
  /** 同時予約数の上限を超えている */
  MaxReservationsExceededError: "MaxReservationsExceededError",
  /** 同月内予約数の上限を超えている */
  MonthlyReservationLimitExceededError: "MonthlyReservationLimitExceededError",
  /**
   * 予約変更が可能な範囲を超えている
   * 直前であるかどうかなどリードタイムによって制限がかかる
   */
  MutationScopeError: "MutationScopeError",
  /** サブスクにおいて1週間以内ですでに予約を取っている */
  Next7DaysDuplicationError: "Next7DaysDuplicationError",
  /** オーナーの泊数が不足している */
  OwnerStayCreditInsufficientError: "OwnerStayCreditInsufficientError",
  /** オーナー拠点の繁忙日はオーナー会員のみが予約可能である */
  PeakDayOwnerOnlyError: "PeakDayOwnerOnlyError",
  /** High日制限を超えている */
  PeakDaysLimitExceededError: "PeakDaysLimitExceededError",
  /** 同一の日程ですでに別の予約を取っている */
  ReservationOverlapError: "ReservationOverlapError",
  /**
   * 部屋が空室ではないため利用不可能
   * （内部的には稼働制御によるものであることもある）
   */
  ResourceUnavailable: "ResourceUnavailable",
  /** 拠点ハイシーズン制限を超えている（FullOwnerのみ） */
  SiteHighSeasonLimitExceededError: "SiteHighSeasonLimitExceededError",
  /** 宿泊チケットが使用済みまたは無効である */
  StayTicketError: "StayTicketError",
  /** サブスクリプションが支払い失敗により停止されている */
  SubscriptionSuspended: "SubscriptionSuspended",
  /** 未同意の規約の改定がある */
  TermsNotAgreedError: "TermsNotAgreedError",
  /** Trialプランが支払い失敗により停止されている */
  TrialContractSuspended: "TrialContractSuspended",
  /** Trialプランの泊数が不足している */
  TrialStayCreditInsufficientError: "TrialStayCreditInsufficientError",
  /** 予期せぬエラー */
  UnexpectedError: "UnexpectedError",
  /** 未払いの宿泊料金がある */
  UnpaidAccommodationFeeError: "UnpaidAccommodationFeeError",
} as const;

export type ChangeAccommodationReservationErrorCase =
  (typeof ChangeAccommodationReservationErrorCase)[keyof typeof ChangeAccommodationReservationErrorCase];
export type ChangeAccommodationReservationPayload =
  | AccommodationReservation
  | ChangeAccommodationReservationError;

export type CheckInAccommodationReservationError = {
  __typename?: "CheckInAccommodationReservationError";
  case: CheckInAccommodationReservationErrorCase;
};

export const CheckInAccommodationReservationErrorCase = {
  /** 既にチェックイン済み */
  AlreadyCheckedIn: "AlreadyCheckedIn",
  /** チェックイン認証が完了していない（QR認証） */
  AuthenticationRequired: "AuthenticationRequired",
  /** チェックイン規則に違反している */
  CheckInRuleError: "CheckInRuleError",
  /** 暗証番号が発行されていない */
  NoAccessCode: "NoAccessCode",
} as const;

export type CheckInAccommodationReservationErrorCase =
  (typeof CheckInAccommodationReservationErrorCase)[keyof typeof CheckInAccommodationReservationErrorCase];
export type CheckInAccommodationReservationInput = {
  checkedInGeoLocation?: InputMaybe<GeoLocationInput>;
  numberOfDogs: Scalars["Int"]["input"];
};

export type CheckInAccommodationReservationPayload =
  | AccommodationReservation
  | CheckInAccommodationReservationError;

/** チェックイン認証方式 */
export const CheckInAuthenticationType = {
  /** 認証不要 */
  NotRequired: "NotRequired",
  /** QRコード認証 */
  QrCode: "QrCode",
} as const;

export type CheckInAuthenticationType =
  (typeof CheckInAuthenticationType)[keyof typeof CheckInAuthenticationType];
/** チェックイン用QRコード */
export type CheckInQrCode = {
  __typename?: "CheckInQrCode";
  /** QRコード */
  code: Scalars["String"]["output"];
  /** コードの有効期限 */
  expiresAt: Scalars["ZonedDateTime"]["output"];
  /** 認証ステータス */
  status: CheckInQrCodeStatus;
  /** 認証完了日時 */
  verifiedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
};

/** チェックイン用QRコードの認証ステータス */
export const CheckInQrCodeStatus = {
  /** 認証失敗 */
  Failed: "Failed",
  /** 認証待ち */
  Pending: "Pending",
  /** 認証成功 */
  Verified: "Verified",
} as const;

export type CheckInQrCodeStatus =
  (typeof CheckInQrCodeStatus)[keyof typeof CheckInQrCodeStatus];
export type CheckOutAccommodationReservationError = {
  __typename?: "CheckOutAccommodationReservationError";
  case: CheckOutAccommodationReservationErrorCase;
};

export const CheckOutAccommodationReservationErrorCase = {
  /** 既にチェックアウト済み */
  AlreadyCheckedOut: "AlreadyCheckedOut",
  CheckOutRuleError: "CheckOutRuleError",
  NotAuthorized: "NotAuthorized",
  /** 指定した設問が存在しない */
  QuestionnaireNotFound: "QuestionnaireNotFound",
  /** 入力値が不正（必須フィールドが未指定） */
  ValidationError: "ValidationError",
} as const;

export type CheckOutAccommodationReservationErrorCase =
  (typeof CheckOutAccommodationReservationErrorCase)[keyof typeof CheckOutAccommodationReservationErrorCase];
export type CheckOutAccommodationReservationPayload =
  | AccommodationReservation
  | CheckOutAccommodationReservationError;

/** Co-Owners の繁忙日数上限を算出するための割合、繁忙日数上限はfloor(unitNightsPerYear × 割合)で計算される */
export const CoOwnerPeakDaysRatio = {
  /** 1/2、ルール改定（2026/6/23販売開始・2027/4/1宿泊分から適用）後のプラン用 */
  OneHalf: "OneHalf",
  /** 2/3、ルール改定前のプラン用 */
  TwoThirds: "TwoThirds",
} as const;

export type CoOwnerPeakDaysRatio =
  (typeof CoOwnerPeakDaysRatio)[keyof typeof CoOwnerPeakDaysRatio];
export type CoOwnersApplicantInfo = {
  __typename?: "CoOwnersApplicantInfo";
  /** 申込者の詳細情報 */
  detail: CoOwnersApplicantInfoDetail;
  /** 本人確認書類 */
  identificationDocument1?: Maybe<UploadedFile>;
  identificationDocument2?: Maybe<UploadedFile>;
  /** 本人確認書類 */
  identificationDocumentType: IdentificationDocumentType;
  /** 外国PEPsへの該当有無 */
  isPep: Scalars["Boolean"]["output"];
  /** 利用用途 */
  purchasePurpose?: Maybe<OwnerPurchasePurposeType>;
  /** 利用用途Otherの場合の自由記述 */
  purchasePurposeFree?: Maybe<Scalars["String"]["output"]>;
};

export type CoOwnersApplicantInfoDetail =
  | CoOwnersApplicantInfoDetailIndividual
  | CoOwnersApplicantInfoDetailOrganization;

export type CoOwnersApplicantInfoDetailIndividual = {
  __typename?: "CoOwnersApplicantInfoDetailIndividual";
  /** 勤務先名 */
  employerName?: Maybe<Scalars["String"]["output"]>;
  /** 世帯年収 */
  householdIncome?: Maybe<IncomeBracketType>;
  /** 利用意向 */
  intendedUsage?: Maybe<OwnerIntendedUsageType>;
  /** 金融資産 */
  personalFinancialAssets?: Maybe<FinancialAssetsBracketType>;
  /** ローン申込の有無 */
  useLoan: Scalars["Boolean"]["output"];
};

export type CoOwnersApplicantInfoDetailOrganization = {
  __typename?: "CoOwnersApplicantInfoDetailOrganization";
  /** 実質的支配者の住所 */
  beneficialOwnerAddress?: Maybe<AddressInJapan>;
  /** 実質的支配者の生年月日 */
  beneficialOwnerBirthDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 実質的支配者の名前 */
  beneficialOwnerName?: Maybe<Scalars["String"]["output"]>;
  /** その他の実質的支配者 */
  beneficialOwnerOthers?: Maybe<Scalars["String"]["output"]>;
  /** 実質的支配者と法人の関係性 */
  beneficialOwnerRelationship?: Maybe<OwnerOrganizationBeneficialOwnerRelationshipType>;
  /** 実質的支配者と法人の関係性はOtherの場合の自由記述 */
  beneficialOwnerRelationshipFree?: Maybe<Scalars["String"]["output"]>;
  /** 事業内容 */
  businessActivity?: Maybe<OwnerOrganizationBusinessActivityType>;
  /** 事業内容はOtherの場合の自由記述 */
  businessActivityFree?: Maybe<Scalars["String"]["output"]>;
  /** 会社の住所 */
  organizationAddress?: Maybe<AddressInJapan>;
  /** 会社名 */
  organizationName: Scalars["String"]["output"];
  /** 法人とオーナーの関係性 */
  organizationRelationship?: Maybe<OwnerOrganizationRelationshipType>;
  /** 登記簿謄本 */
  registryCertificateDocuments: Array<UploadedFile>;
  /** 会社代表者名 */
  representativeName: Scalars["String"]["output"];
};

/** CoOwners申し込み */
export type CoOwnersApplication = {
  __typename?: "CoOwnersApplication";
  /** 追加購入割引額 */
  additionalPurchaseDiscountAmount: Scalars["Int"]["output"];
  /** 追加購入割引備考 */
  additionalPurchaseDiscountNote: Scalars["String"]["output"];
  /** 登録料の事前請求が必要かどうか */
  advancePaymentRequired: Scalars["Boolean"]["output"];
  /** 申込者に非表示のものを含む全ファイル */
  allFiles: Array<CoOwnersApplicationFile>;
  /** 申し込み者 */
  applicant: User;
  /** 申込者の情報 */
  applicantInfo: CoOwnersApplicantInfo;
  /** 申込金の支払い方法 */
  applicationFeePaymentMethod?: Maybe<PaymentMethodType>;
  /** 管理者用メモ */
  comment?: Maybe<Scalars["String"]["output"]>;
  /** 引渡し希望日 */
  desiredHandoverDate?: Maybe<Scalars["PlainYearMonth"]["output"]>;
  /** 重要事項説明会参加者 */
  disclosureAssitant?: Maybe<DisclosureAssistantType>;
  /** 社員紹介割引額 */
  employeeReferralDiscountAmount: Scalars["Int"]["output"];
  /** 各イベントの日時 */
  events: CoOwnersApplicationEvents;
  /** 申込者が閲覧できるファイル。管理者が非表示にしたものと削除済みのものは含まない */
  files: Array<CoOwnersApplicationFile>;
  /** 友人紹介割引額 */
  friendReferralDiscountAmount: Scalars["Int"]["output"];
  /** 必須入力項目が入力済みかどうか */
  hasCoOwnersApplicationRequiredFieldsFilled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** 本人確認情報 */
  identityVerifications: Array<IdentityVerification>;
  /** 招待コード */
  invitationCode?: Maybe<Scalars["String"]["output"]>;
  /** その他割引額 */
  otherDiscountAmount: Scalars["Int"]["output"];
  /** その他割引備考 */
  otherDiscountNote: Scalars["String"]["output"];
  /** 管理者用ファイル */
  otherFiles: Array<UploadedFile>;
  /** CoOwnersのプラン */
  ownerPlan: OwnerPlan;
  /** 登録料の支払い方法 */
  registrationFeePaymentMethod?: Maybe<PaymentMethodType>;
  /** 残金の支払い方法 */
  remainingAmountPaymentMethod?: Maybe<PaymentMethodType>;
  /** 別日程調整を希望したかどうか */
  requestedOtherWebinarSchedule: Scalars["Boolean"]["output"];
  /** Co-Owners充当特典（旧S2Oポイント）の割引金額 */
  s2oPoint?: Maybe<S2oPoint>;
  /**
   * 選択した重要事項説明会
   * NOTE: admin によって変更されたりすることも考えると、`selected` は誤解を招くかもしれない
   */
  selectedWebinarSchedule?: Maybe<CoOwnersWebinarSchedule>;
  /** ステータス */
  status: CoOwnersApplicationStatus;
  /** 口単位の売却履歴。売却予定のものは soldAt が null で、申込が売却予定の間だけ 1 件ある */
  unitSales: Array<CoOwnersUnitSale>;
  /** 口数 */
  units: Scalars["Int"]["output"];
  /** 重要事項説明会の候補日 */
  webinarSchedules: Array<CoOwnersWebinarSchedule>;
};

/** CoOwners申し込み */
export type CoOwnersApplicationallFilesArgs = {
  includeDeleted?: Scalars["Boolean"]["input"];
};

export type CoOwnersApplicationDetailInput =
  /** 個人名義の詳細情報 */
  | {
      individual: CoOwnersApplicationIndividualInput;
      organization?: never;
    } /** 法人名義の詳細情報 */
  | { individual?: never; organization: CoOwnersApplicationOrganizationInput };

export type CoOwnersApplicationDetails =
  /** 個人名義の詳細情報 */
  | {
      individual: CoOwnersApplicationIndividualInput;
      organization?: never;
    } /** 法人名義の詳細情報 */
  | { individual?: never; organization: CoOwnersApplicationOrganizationInput };

export type CoOwnersApplicationEvents = {
  __typename?: "CoOwnersApplicationEvents";
  /** 前受金受領日 */
  advancePaymentReceivedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** キャンセル日 */
  cancelledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 完了日 */
  completedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 契約サイン日 */
  contractSignedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 受け渡し完了日 */
  handoverCompletedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 重説招待日 */
  invitedToDisclosureAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 重要事項説明会参加日 */
  participatedInDisclosureAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 入金受領日 */
  paymentReceivedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** レビュー日 */
  reviewedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 仮申込日 */
  submittedAt: Scalars["ZonedDateTime"]["output"];
};

/**
 * オーナー申込ごとに申込者と管理者がやり取りするファイル。
 * 一覧取得では URL を発行せず、ダウンロード時に createCoOwnersApplicationFileDownloadUrl で都度発行する
 */
export type CoOwnersApplicationFile = {
  __typename?: "CoOwnersApplicationFile";
  contentType: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  deletedBy?: Maybe<User>;
  /** アップロード時のファイル名 */
  fileName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** バイト数 */
  size: Scalars["Int"]["output"];
  uploadedBy: User;
  visibleToApplicant: Scalars["Boolean"]["output"];
};

export type CoOwnersApplicationIndividualInput = {
  /** 勤務先名 */
  employerName?: InputMaybe<Scalars["String"]["input"]>;
  /** 世帯年収 */
  householdIncome?: InputMaybe<IncomeBracketType>;
  /** 利用意向 */
  intendedUsage?: InputMaybe<OwnerIntendedUsageType>;
  /** 金融資産 */
  personalFinancialAssets?: InputMaybe<FinancialAssetsBracketType>;
  /** ローン申込の有無 */
  useLoan: Scalars["Boolean"]["input"];
};

export type CoOwnersApplicationInfoInput = {
  /** 追加購入割引額 */
  additionalPurchaseDiscountAmount?: InputMaybe<Scalars["Int"]["input"]>;
  /** 追加購入割引備考 */
  additionalPurchaseDiscountNote?: InputMaybe<Scalars["String"]["input"]>;
  /** 登録料の事前請求が必要かどうか */
  advancePaymentRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 申込金の支払い方法 */
  applicationFeePaymentMethod?: InputMaybe<PaymentMethodType>;
  /** メモ（null 以外の時上書きされる） */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** 引渡し希望日 */
  desiredHandoverDate?: InputMaybe<Scalars["PlainYearMonth"]["input"]>;
  /** 重要事項説明会参加者 */
  disclosureAssitant?: InputMaybe<DisclosureAssistantType>;
  /** 社員紹介割引額 */
  employeeReferralDiscountAmount?: InputMaybe<Scalars["Int"]["input"]>;
  /** 友人紹介割引額 */
  friendReferralDiscountAmount?: InputMaybe<Scalars["Int"]["input"]>;
  /** 本人確認書類 */
  identificationDocument1?: InputMaybe<UploadedFileInput>;
  /** 本人確認書類 */
  identificationDocument2?: InputMaybe<UploadedFileInput>;
  /** 本人確認書類 */
  identificationDocumentType?: InputMaybe<IdentificationDocumentType>;
  /** その他割引額 */
  otherDiscountAmount?: InputMaybe<Scalars["Int"]["input"]>;
  /** その他割引備考 */
  otherDiscountNote?: InputMaybe<Scalars["String"]["input"]>;
  /** 登録料の支払い方法 */
  registrationFeePaymentMethod?: InputMaybe<PaymentMethodType>;
  /** 残金の支払い方法 */
  remainingAmountPaymentMethod?: InputMaybe<PaymentMethodType>;
  /**
   * 重要事項説明会日（変更用）
   * null を指定した場合はブランクにリセットされる
   */
  webinarScheduleId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CoOwnersApplicationInput = {
  /** 詳細の情報 */
  details: CoOwnersApplicationDetails;
  /**
   * 本人確認書類
   * @deprecated 本人確認は申込後の eKYC（TRUSTDOCK）で実施するためアップロード不要
   */
  identificationDocument1?: InputMaybe<UploadedFileInput>;
  /** @deprecated 本人確認は申込後の eKYC（TRUSTDOCK）で実施するためアップロード不要 */
  identificationDocument2?: InputMaybe<UploadedFileInput>;
  /**
   * 本人確認書類
   * @deprecated 本人確認は申込後の eKYC（TRUSTDOCK）で実施するため書類の事前申告は不要
   */
  identificationDocumentType?: InputMaybe<IdentificationDocumentType>;
  /** 希望する本人確認方法。未指定の場合は本人確認を開始しない */
  identityVerificationMethod?: InputMaybe<IdentityVerificationMethod>;
  /** 紹介コード */
  invitationCode?: InputMaybe<Scalars["String"]["input"]>;
  /** CoOwnersプランのID */
  ownerPlanId: Scalars["ID"]["input"];
  /** 口数 */
  units: Scalars["Int"]["input"];
  /** Weekday/Trial で蓄積した充当特典を利用するかどうか */
  useS2oPoints: Scalars["Boolean"]["input"];
  /** Stay 宿泊で蓄積した充当特典を利用するかどうか。初回申込でのみ有効。 */
  useStayCredit?: Scalars["Boolean"]["input"];
};

export type CoOwnersApplicationOrganizationInput = {
  /** 実質的支配者の住所 */
  beneficialOwnerAddress?: InputMaybe<AddressInJapanInput>;
  /** 実質的支配者の生年月日 */
  beneficialOwnerBirthDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 実質的支配者の名前 */
  beneficialOwnerName?: InputMaybe<Scalars["String"]["input"]>;
  /** その他の実質的支配者 */
  beneficialOwnerOthers?: InputMaybe<Scalars["String"]["input"]>;
  /** 実質的支配者と法人の関係性 */
  beneficialOwnerRelationship?: InputMaybe<OwnerOrganizationBeneficialOwnerRelationshipType>;
  /** 実質的支配者と法人の関係性はOtherの場合の自由記述 */
  beneficialOwnerRelationshipFree?: InputMaybe<Scalars["String"]["input"]>;
  /** 事業内容 */
  businessActivity?: InputMaybe<OwnerOrganizationBusinessActivityType>;
  /** 事業内容はOtherの場合の自由記述 */
  businessActivityFree?: InputMaybe<Scalars["String"]["input"]>;
  /** 会社の住所 */
  organizationAddress?: InputMaybe<AddressInJapanInput>;
  /** 会社名 */
  organizationName: Scalars["String"]["input"];
  /** 法人とオーナーの関係性 */
  organizationRelationship?: InputMaybe<OwnerOrganizationRelationshipType>;
  /** 登記簿謄本 */
  registryCertificateDocuments?: InputMaybe<Array<UploadedFileInput>>;
  /** 会社代表者名 */
  representativeName: Scalars["String"]["input"];
};

export type CoOwnersApplicationOwnerInfoInput = {
  /** 引渡し希望日 */
  desiredHandoverDate?: InputMaybe<Scalars["PlainYearMonth"]["input"]>;
  /** 詳細の情報 */
  detail: CoOwnersApplicationDetailInput;
  /** 外国PEPsへの該当有無 */
  isPep: Scalars["Boolean"]["input"];
  /** 利用用途 */
  purchasePurpose: OwnerPurchasePurposeType;
  /** 利用用途Otherの場合の自由記述 */
  purchasePurposeFree?: InputMaybe<Scalars["String"]["input"]>;
};

export const CoOwnersApplicationStatus = {
  /** 登録料支払い済み */
  AdvancePaymentReceived: "AdvancePaymentReceived",
  /**
   * 仮申込承認済み
   * 旧フローで使用。互換性維持のため残しておく。
   */
  Approved: "Approved",
  /**
   * 申込時の支払い待ち
   * 3D セキュアで失敗時などの状態
   */
  AwaitingApplicationPayment: "AwaitingApplicationPayment",
  /** キャンセル */
  Cancelled: "Cancelled",
  /** 申込完了 */
  Completed: "Completed",
  /** 契約サイン済み */
  ContractSigned: "ContractSigned",
  /** 引渡し完了 */
  HandoverCompleted: "HandoverCompleted",
  /**
   * 仮申込レビュー待ち
   * 旧フローで使用。互換性維持のため残しておく。
   */
  InReview: "InReview",
  /**
   * 重要事項説明会招待済み
   * 重説の日程が確定している
   */
  InvitedToDisclosure: "InvitedToDisclosure",
  /** 重要事項説明会参加済み */
  ParticipatedInDisclosure: "ParticipatedInDisclosure",
  /** 残金入金完了 */
  PaymentReceived: "PaymentReceived",
  /**
   * 売却予定
   * 買い替え（HIKE への下取り）契約済みで、引渡しまで既存物件のオーナーであり続ける状態。今年度の宿泊権利は残るが、次年度以降は付与されない。
   */
  PlannedForSale: "PlannedForSale",
  /**
   * 仮申込却下
   * 旧フローで使用。互換性維持のため残しておく。
   */
  Rejected: "Rejected",
  /**
   * 無効化（売却済）
   * 売却予定の年度末精算が完了し、既存物件の権利を完全に剥奪した状態。観測上の振る舞いは Void と同じ（プラン非表示・終端）。
   */
  Sold: "Sold",
  /**
   * 無効化
   * 引渡完了後に Admin が無効化したケース。観測上の振る舞いは Cancelled と同じ（プラン非表示・終端・S2O 充当不可）だが、遷移元は HandoverCompleted のみで、遷移時アクションが異なる（権利剥奪・予約や StayGift があれば不可）。
   */
  Void: "Void",
} as const;

export type CoOwnersApplicationStatus =
  (typeof CoOwnersApplicationStatus)[keyof typeof CoOwnersApplicationStatus];
export type CoOwnersApplicationStatusInput = {
  /** 初年度の泊数オーバーライド（登録料受領済/入金完了 に変更する場合に指定。省略時は自動計算） */
  currentYearStayCredits?: InputMaybe<Scalars["Int"]["input"]>;
  /** 次年度の泊数オーバーライド（登録料受領済/入金完了 に変更する場合に指定。省略時は自動計算） */
  nextYearStayCredits?: InputMaybe<Scalars["Int"]["input"]>;
  /** 変更後のステータス */
  status: CoOwnersApplicationStatus;
};

export type CoOwnersBakurakuInvoiceAnnualPaymentItem = {
  __typename?: "CoOwnersBakurakuInvoiceAnnualPaymentItem";
  /** 品目金額 */
  amount: Scalars["Int"]["output"];
  /** 申込者（送付先コードのユーザー）。CSV には含めず画面の確認用 */
  applicant: User;
  /** 日付 */
  date: Scalars["String"]["output"];
  /** 書類番号 */
  documentNumber: Scalars["String"]["output"];
  /** 品目名 */
  name: Scalars["String"]["output"];
  /** 備考 */
  note: Scalars["String"]["output"];
  /** 支払期日 */
  paymentDueDate: Scalars["String"]["output"];
  /** 送付先コード */
  recipientCode: Scalars["String"]["output"];
  /** 品目税率 */
  taxRate: Scalars["String"]["output"];
  /** 品目単位 */
  unit: Scalars["String"]["output"];
};

/** バクラク連携用の送付先マスタデータ */
export type CoOwnersBakurakuInvoiceRecipient = {
  __typename?: "CoOwnersBakurakuInvoiceRecipient";
  /** コード */
  code: Scalars["String"]["output"];
  /** 部署名 */
  departmentName: Scalars["String"]["output"];
  /** メールアドレス */
  email: Scalars["String"]["output"];
  /** メール送付 */
  emailDelivery: Scalars["String"]["output"];
  /** 送付先名 */
  recipientName: Scalars["String"]["output"];
};

/** バクラク連携用の登録料請求書明細 */
export type CoOwnersBakurakuInvoiceRegistrationFeeItem = {
  __typename?: "CoOwnersBakurakuInvoiceRegistrationFeeItem";
  /** 品目金額 */
  amount: Scalars["Int"]["output"];
  /** 申込者（送付先コードのユーザー）。CSV には含めず画面の確認用 */
  applicant: User;
  /** 日付 */
  date: Scalars["String"]["output"];
  /** 書類番号 */
  documentNumber: Scalars["String"]["output"];
  /** 品目名 */
  name: Scalars["String"]["output"];
  /** 備考 */
  note: Scalars["String"]["output"];
  /** 支払期日 */
  paymentDueDate: Scalars["String"]["output"];
  /** 送付先コード */
  recipientCode: Scalars["String"]["output"];
  /** 品目税率 */
  taxRate: Scalars["String"]["output"];
  /** 品目単位 */
  unit: Scalars["String"]["output"];
};

/** バクラク連携用の残代金請求書明細 */
export type CoOwnersBakurakuInvoiceRemainingPaymentItem = {
  __typename?: "CoOwnersBakurakuInvoiceRemainingPaymentItem";
  /** 品目金額 */
  amount: Scalars["Int"]["output"];
  /** 申込者（送付先コードのユーザー）。CSV には含めず画面の確認用 */
  applicant: User;
  /** 日付 */
  date: Scalars["String"]["output"];
  /** 書類番号 */
  documentNumber: Scalars["String"]["output"];
  /** 品目名 */
  name: Scalars["String"]["output"];
  /** 備考 */
  note: Scalars["String"]["output"];
  /** 支払期日 */
  paymentDueDate: Scalars["String"]["output"];
  /** 送付先コード */
  recipientCode: Scalars["String"]["output"];
  /** 品目税率 */
  taxRate: Scalars["String"]["output"];
  /** 品目単位 */
  unit: Scalars["String"]["output"];
};

export type CoOwnersPlanAccommodationReservationProvider = {
  __typename?: "CoOwnersPlanAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  userOwnershipId: Scalars["ID"]["output"];
};

/** CoOwnersプランの提供内容 */
export type CoOwnersPlanOffering = {
  __typename?: "CoOwnersPlanOffering";
  /** 招待コード */
  earlyAccessCode?: Maybe<Scalars["String"]["output"]>;
  /** 見積書 */
  estimate?: Maybe<UploadedFile>;
  id: Scalars["ID"]["output"];
  /** 非表示設定 */
  isHidden: Scalars["Boolean"]["output"];
  /** このプランの提供は売れ切れているかどうか */
  isSoldOut: Scalars["Boolean"]["output"];
  /** 口数 */
  units: Scalars["Int"]["output"];
};

/** Co-Owners 申込の口単位の売却（買い替えによる下取り） */
export type CoOwnersUnitSale = {
  __typename?: "CoOwnersUnitSale";
  id: Scalars["ID"]["output"];
  /** 売却月。売却月が属する年度までは宿泊権利が残る */
  saleYearMonth: Scalars["PlainYearMonth"]["output"];
  /** 売却を完了した日時。売却予定の間は null */
  soldAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** 売却する口数 */
  units: Scalars["Int"]["output"];
};

/** 重説参加スケジュール */
export type CoOwnersWebinarSchedule = {
  __typename?: "CoOwnersWebinarSchedule";
  /** 申し込み */
  coOwnersApplications?: Maybe<Array<CoOwnersApplication>>;
  id: Scalars["ID"]["output"];
  /** 説明会の申し込みを受け付けているかどうか */
  isActive: Scalars["Boolean"]["output"];
  /** プランの拠点 */
  site: Site;
  /** 重説開始日時 */
  startsAt: Scalars["ZonedDateTime"]["output"];
  /** Zoom MTG等のURL */
  url: Scalars["String"]["output"];
};

/** 付帯サービスコワーキングスペース向けドアロックのコントローラ属性情報 */
export type CoWorkingSpaceDoorLock = {
  __typename?: "CoWorkingSpaceDoorLock";
  keyUrl?: Maybe<Scalars["String"]["output"]>;
};

/**
 * 追加の鍵の情報
 * コワーキングスペースなどに利用
 */
export type CoWorkingSpaceKey = {
  __typename?: "CoWorkingSpaceKey";
  /** 鍵の有効開始時刻 */
  availableFrom: Scalars["ZonedDateTime"]["output"];
  /** 鍵の有効終了時刻 */
  availableTo: Scalars["ZonedDateTime"]["output"];
  /** 説明 URL */
  instructionUrl: Scalars["String"]["output"];
  /** 鍵の URL */
  keyUrl?: Maybe<Scalars["String"]["output"]>;
  /** 施設名 */
  name: Scalars["String"]["output"];
};

/** アイデンティティ追加完了エラー */
export type CompleteAddIdentityError = {
  __typename?: "CompleteAddIdentityError";
  case: CompleteAddIdentityErrorCase;
};

/** アイデンティティ追加完了エラーケース */
export const CompleteAddIdentityErrorCase = {
  /** このソーシャルアカウントは既に別のアカウントに連携されている */
  AlreadyLinkedToAnotherAccount: "AlreadyLinkedToAnotherAccount",
  /** intent tokenが無効または期限切れ */
  InvalidIntentToken: "InvalidIntentToken",
  /** Auth0とのトークン交換に失敗 */
  TokenExchangeFailed: "TokenExchangeFailed",
} as const;

export type CompleteAddIdentityErrorCase =
  (typeof CompleteAddIdentityErrorCase)[keyof typeof CompleteAddIdentityErrorCase];
/** アイデンティティ追加完了の入力 */
export type CompleteAddIdentityInput = {
  /** Auth0から返されたauthorization code */
  code: Scalars["String"]["input"];
  /** ラウンドトリップ用のstate (intent token) */
  state: Scalars["String"]["input"];
};

/** アイデンティティ追加完了の結果 */
export type CompleteAddIdentityPayload =
  | CompleteAddIdentityError
  | CompleteAddIdentitySuccess;

/** アイデンティティ追加完了成功 */
export type CompleteAddIdentitySuccess = {
  __typename?: "CompleteAddIdentitySuccess";
  /** 成功後のリダイレクトURL */
  redirectUrl: Scalars["String"]["output"];
};

export type ConfirmTentativeAccommodationReservationError = {
  __typename?: "ConfirmTentativeAccommodationReservationError";
  case: ConfirmTentativeAccommodationReservationErrorCase;
};

export const ConfirmTentativeAccommodationReservationErrorCase = {
  GeneralError: "GeneralError",
  InvalidStatus: "InvalidStatus",
  NotAuthorized: "NotAuthorized",
  TentativeDeadlineExceeded: "TentativeDeadlineExceeded",
} as const;

export type ConfirmTentativeAccommodationReservationErrorCase =
  (typeof ConfirmTentativeAccommodationReservationErrorCase)[keyof typeof ConfirmTentativeAccommodationReservationErrorCase];
export type ConfirmTentativeAccommodationReservationInput = {
  nextLocation: Scalars["String"]["input"];
  numberOfAdults: Scalars["Int"]["input"];
  numberOfDogs: Scalars["Int"]["input"];
  numberOfInfants: Scalars["Int"]["input"];
  numberOfKids: Scalars["Int"]["input"];
  previousLocation: Scalars["String"]["input"];
};

export type ConfirmTentativeAccommodationReservationPayload =
  | AccommodationReservation
  | ConfirmTentativeAccommodationReservationError;

/** 有料備品の利用料金 */
export type ConsumedSuppliesFee = {
  __typename?: "ConsumedSuppliesFee";
  /** 料金の項目 */
  items: Array<ConsumedSuppliesFeeItem>;
  /** 料金の合計 */
  totalAmount: Scalars["Int"]["output"];
};

/** 有料備品の利用料金の項目 */
export type ConsumedSuppliesFeeItem = {
  __typename?: "ConsumedSuppliesFeeItem";
  /** 税込金額(合計) */
  amount: Scalars["Int"]["output"];
  /** 項目名 */
  label: Scalars["String"]["output"];
  /** 数量 */
  quantity: Scalars["Int"]["output"];
  /**
   * 清掃報告（JTAS）で申告された実消費数量。免除適用前の数量。
   * Bubble 経由の項目や、対応する清掃報告が存在しない場合は null。
   */
  reportedQuantity?: Maybe<Scalars["Int"]["output"]>;
  /** 消費税率 */
  taxRate: Scalars["Float"]["output"];
  /** 税込金額（単価） */
  unitAmount: Scalars["Int"]["output"];
};

/** 有料備品利用による請求項目 */
export type ConsumedSuppliesFeeItemInput = {
  externalSupplyProductMasterId: Scalars["ID"]["input"];
  label: Scalars["String"]["input"];
  quantity: Scalars["Int"]["input"];
  taxRateType: ConsumptionTaxRateType;
  unitAmount: Scalars["Int"]["input"];
};

/** 有料備品の免除 */
export type ConsumedSupplyFeeItemWaiver = {
  __typename?: "ConsumedSupplyFeeItemWaiver";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** 免除する数量 */
  quantity: Scalars["Int"]["output"];
  /** 対象の備品種別（type=BySupplyItemMasterCategory の場合のみ） */
  supplyItemMasterCategory?: Maybe<SupplyItemMasterCategory>;
  /** 免除タイプ */
  type: ConsumedSupplyFeeItemWaiverType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ConsumedSupplyFeeItemWaiverInput = {
  quantity: Scalars["Int"]["input"];
  /** type=BySupplyItemMasterCategory の場合は必須 */
  supplyItemMasterCategory?: InputMaybe<SupplyItemMasterCategory>;
  type: ConsumedSupplyFeeItemWaiverType;
};

/** 有料備品の免除のタイプ */
export const ConsumedSupplyFeeItemWaiverType = {
  /** 指定した種別の備品の中で最も単価が高いものを免除 */
  BySupplyItemMasterCategory: "BySupplyItemMasterCategory",
  /** 全備品の中で最も単価が高いものを免除 */
  HighestUnitPrice: "HighestUnitPrice",
} as const;

export type ConsumedSupplyFeeItemWaiverType =
  (typeof ConsumedSupplyFeeItemWaiverType)[keyof typeof ConsumedSupplyFeeItemWaiverType];
/** 消費税の種類 */
export const ConsumptionTaxRateType = {
  /** 軽減税率 */
  Reduced: "Reduced",
  /** 標準税率 */
  Standard: "Standard",
} as const;

export type ConsumptionTaxRateType =
  (typeof ConsumptionTaxRateType)[keyof typeof ConsumptionTaxRateType];
/** 建築家 */
export type ContentArchitect = {
  __typename?: "ContentArchitect";
  /** この建築家が紐づいている建築タイプ（名前順） */
  architectureTypes: Array<ArchitectureType>;
  /** プロフィール */
  bio: Scalars["String"]["output"];
  /** 会社名 */
  company: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** 写真 */
  imageUrl: UploadedFile;
  /** 名前（日本語） */
  name: Scalars["String"]["output"];
  /** 名前（英語） */
  nameEn: Scalars["String"]["output"];
};

/** 設備コンテンツ。公開ページ /architectures/features/[slug] と建築トップの設備カードの中身 */
export type ContentArchitecturalFeature = {
  __typename?: "ContentArchitecturalFeature";
  /** このコンテンツが説明している設備。公開ページの「この設備がある拠点」一覧を駆動する */
  accommodationFacilities: Array<AccommodationFacility>;
  /** 設備の提供状況についての注記。未設定なら null */
  availabilityNote?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["String"]["output"];
  /** 公開ページに出す特徴 */
  facilityAmenities: Array<ContentArchitectureTypeVariantFacilityAmenity>;
  id: Scalars["ID"]["output"];
  /** 公開ページのカルーセル画像 */
  imageUrls: Array<UploadedFile>;
  name: Scalars["String"]["output"];
  /** 利用ルールの末尾に出る注記 */
  ruleNoteMarkup: Scalars["String"]["output"];
  /** 利用ルールの見出し（「愛犬同伴時のお願い」など） */
  ruleTitle: Scalars["String"]["output"];
  /** 利用ルールの本文。sort 昇順 */
  rules: Array<ContentArchitecturalFeatureUsageRule>;
  /** 公開ページの URL に入る識別子。変えると既存 URL が 404 になる */
  slug: Scalars["String"]["output"];
  /** 建築トップの設備カードの並び順 */
  sort: Scalars["Int"]["output"];
  /** 建築トップの設備カードに出る画像。未設定なら null */
  thumbnailImageUrl?: Maybe<UploadedFile>;
  usageConditionsDescription: Scalars["String"]["output"];
  usageFeesDescriptionMarkup: Scalars["String"]["output"];
};

/** 設備コンテンツの利用ルール 1 件 */
export type ContentArchitecturalFeatureUsageRule = {
  __typename?: "ContentArchitecturalFeatureUsageRule";
  bodyMarkup: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** ルールに添える画像。未設定なら null */
  imageUrl?: Maybe<UploadedFile>;
  sort: Scalars["Int"]["output"];
};

/** 建築ページのナビゲーション */
export type ContentArchitecturePageNavigation = {
  __typename?: "ContentArchitecturePageNavigation";
  feature: Array<ContentArchitecturePageNavigationItem>;
  originalSeries: Array<ContentArchitecturePageNavigationItem>;
  selectionSeries: Array<ContentArchitecturePageNavigationItem>;
};

/** 建築ページのナビゲーション項目 */
export type ContentArchitecturePageNavigationItem = {
  __typename?: "ContentArchitecturePageNavigationItem";
  /** エリア: Selectionシリーズのみ */
  area?: Maybe<Scalars["String"]["output"]>;
  /** 名前 */
  name: Scalars["String"]["output"];
  /** 遷移先 */
  path: Scalars["String"]["output"];
  /** slug (subItemsがある場合は省略) */
  slug?: Maybe<Scalars["String"]["output"]>;
  /** サブ項目 */
  subItems?: Maybe<Array<ContentArchitecturePageNavigationSubItem>>;
  /** 画像 */
  thumbnail: UploadedFile;
};

/** 建築ページのナビゲーションサブ項目（Medium, Large） */
export type ContentArchitecturePageNavigationSubItem = {
  __typename?: "ContentArchitecturePageNavigationSubItem";
  /** name */
  name: Scalars["String"]["output"];
  /** 遷移先 */
  path: Scalars["String"]["output"];
  /** slug */
  slug: Scalars["String"]["output"];
};

/** 建築タイプのコンテンツ */
export type ContentArchitectureType = {
  __typename?: "ContentArchitectureType";
  /** 設備の操作マニュアル（リンク） */
  amenitiesInstructionsUrl?: Maybe<Scalars["String"]["output"]>;
  /** 建築家 */
  architect: ContentArchitect;
  /** 建築家のコメント */
  architectComment: Scalars["String"]["output"];
  /** 建築タイプ */
  architectureType: ArchitectureType;
  /** エリア (Selection Seriesのみ) */
  area?: Maybe<Scalars["String"]["output"]>;
  /** 基本の設備 */
  basicAmenities: Array<ContentArchitectureTypeBasicAmenity>;
  /** 最大収容人数（フリーテキスト） */
  capacityDescription: Scalars["String"]["output"];
  /** 予約完了メールに表示される画像 URL の設定値。未設定なら null（公開側の emailCoverImageUrl はデフォルト画像にフォールバックする） */
  customEmailCoverImageUrl?: Maybe<Scalars["String"]["output"]>;
  /** 概要テキスト */
  description: Scalars["String"]["output"];
  /** 予約完了メールに表示される建築タイプの画像 URL */
  emailCoverImageUrl: Scalars["String"]["output"];
  /** 備品リスト（リンク） */
  equipmentsListUrl?: Maybe<Scalars["String"]["output"]>;
  /** 体験リスト */
  experiences: Array<ContentArchitectureTypeExperience>;
  /** 間取り図（Selection Seriesのみ） */
  floorPlanImageUrl?: Maybe<UploadedFile>;
  /** ID */
  id: Scalars["ID"]["output"];
  /** カルーセル画像 */
  imageUrls: Array<UploadedFile>;
  /** オプション */
  options: Array<ContentArchitectureTypeVariant>;
  /** 対象拠点 */
  sites: Array<ContentArchitectureTypeSite>;
  /** 広さ（フリーテキスト） */
  sizeDescription: Scalars["String"]["output"];
  /** 広さ（㎡） */
  sizeSqm: Scalars["Float"]["output"];
  /** 建築ページ一覧での並び順 */
  sort: Scalars["Int"]["output"];
  /** 建築（一覧）ページで表示される画像。未設定なら null */
  thumbnailImageUrl?: Maybe<UploadedFile>;
  updatedAt: Scalars["ZonedDateTime"]["output"];
  /** 建築バリエーション */
  variations: Array<ContentArchitectureTypeVariant>;
};

/** 基本の設備 */
export type ContentArchitectureTypeBasicAmenity = {
  __typename?: "ContentArchitectureTypeBasicAmenity";
  /** この設備が紐づいている建築タイプ（名前順） */
  architectureTypes: Array<ArchitectureType>;
  /** 設備のアイコン。未設定の設備が実在するので null になりうる */
  iconUrl?: Maybe<UploadedFile>;
  id: Scalars["ID"]["output"];
  /** 設備の名前 */
  name: Scalars["String"]["output"];
  sort: Scalars["Int"]["output"];
};

/** 体験 */
export type ContentArchitectureTypeExperience = {
  __typename?: "ContentArchitectureTypeExperience";
  /** 体験の説明（Markup） */
  descriptionMarkup: Scalars["String"]["output"];
  /** 体験の画像 */
  imageUrl: UploadedFile;
  /** 体験の名前 */
  name: Scalars["String"]["output"];
};

/** 建築タイプのFeature */
export type ContentArchitectureTypeFeature = {
  __typename?: "ContentArchitectureTypeFeature";
  /** 対象拠点の上部に表示される注意事項（eg.「建築タイプごとに異なる仕様のサウナが設置されていますので、各建築タイプのページでご確認ください。」） */
  availabilityNote?: Maybe<Scalars["String"]["output"]>;
  /** 説明 */
  description: Scalars["String"]["output"];
  /** 設備の詳細 */
  facilityDetails: ContentFacilityDetails;
  /** カルーセル画像 */
  imageUrls: Array<UploadedFile>;
  /** 名前 */
  name: Scalars["String"]["output"];
  /** 対象拠点(部屋) */
  sitesByArchitectureType: Array<ContentArchitectureTypeFeatureSite>;
  /** 利用ルール */
  usageRule?: Maybe<ContentArchitectureTypeFeatureUsageRule>;
};

/** 建築タイプのFeatureの建築タイプごとの対象拠点 */
export type ContentArchitectureTypeFeatureSite = {
  __typename?: "ContentArchitectureTypeFeatureSite";
  /** 建築タイプ名 */
  architectureTypeName: Scalars["String"]["output"];
  /** 対象拠点 */
  sites: Array<ContentArchitectureTypeVariantSite>;
};

export type ContentArchitectureTypeFeatureUsageRule = {
  __typename?: "ContentArchitectureTypeFeatureUsageRule";
  /** 注意事項(Markup) */
  noteMarkup?: Maybe<Scalars["String"]["output"]>;
  /** ルール内容 */
  ruleItems: Array<ContentArchitectureTypeFeatureUsageRuleItem>;
  /** ルール見出し */
  title: Scalars["String"]["output"];
};

export type ContentArchitectureTypeFeatureUsageRuleItem = {
  __typename?: "ContentArchitectureTypeFeatureUsageRuleItem";
  /** ルール内容 */
  bodyMarkup: Scalars["String"]["output"];
  /** 画像 */
  imageUrl?: Maybe<UploadedFile>;
};

/** 建築タイプの対象拠点 */
export type ContentArchitectureTypeSite = {
  __typename?: "ContentArchitectureTypeSite";
  /** オープン予定 */
  isOpeningSoon: Scalars["Boolean"]["output"];
  /** 拠点の名前 */
  name: Scalars["String"]["output"];
};

/** 建築タイプのバリエーション・オプション */
export type ContentArchitectureTypeVariant = {
  __typename?: "ContentArchitectureTypeVariant";
  /** このバリエーション / オプションを構成する設備 */
  accommodationFacilities: Array<AccommodationFacility>;
  /** ひとこと説明（WithSaunaの「サウナ付きのキャビン」にあたる） */
  brief: Scalars["String"]["output"];
  /** 説明 */
  description: Scalars["String"]["output"];
  /** 設備の詳細 */
  facilityDetails: ContentFacilityDetails;
  id: Scalars["ID"]["output"];
  /** カルーセル画像 */
  imageUrls: Array<UploadedFile>;
  /** バリエーションとオプションはテーブルが分かれているだけで同形なので、区別は kind で持つ */
  kind: ContentArchitectureTypeVariantKind;
  /** 名前 */
  name: Scalars["String"]["output"];
  /** 対象拠点(部屋) */
  sites: Array<ContentArchitectureTypeVariantSite>;
  slug: Scalars["String"]["output"];
};

/** 建築タイプのバリエーション・オプションに付帯する設備（「WithSauna」に付帯する「バレルサウナ」「水風呂・ととのい椅子」・「サウナ用備品」など） */
export type ContentArchitectureTypeVariantFacilityAmenity = {
  __typename?: "ContentArchitectureTypeVariantFacilityAmenity";
  /** このアメニティが属する設備（「バレルサウナ」なら Sauna） */
  accommodationFacility: AccommodationFacility;
  /** 説明（Markup） */
  descriptionMarkup: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** 名前 */
  name: Scalars["String"]["output"];
  /** このアメニティを参照している件数。参照が 1 件でもあると削除できない */
  referenceCounts: ContentFacilityAmenityReferenceCounts;
};

/** 建築タイプのバリエーション（Variation）とオプション（Option）は別テーブルだが、公開型は同じ ContentArchitectureTypeVariant なので kind で区別する */
export const ContentArchitectureTypeVariantKind = {
  Option: "Option",
  Variation: "Variation",
} as const;

export type ContentArchitectureTypeVariantKind =
  (typeof ContentArchitectureTypeVariantKind)[keyof typeof ContentArchitectureTypeVariantKind];
/** 建築タイプのバリエーション・オプションの対象拠点 */
export type ContentArchitectureTypeVariantSite = {
  __typename?: "ContentArchitectureTypeVariantSite";
  /** 部屋リスト */
  accommodations: Array<Accommodation>;
  /** 拠点名 */
  name: Scalars["String"]["output"];
};

/** 設備アメニティの参照元の件数 */
export type ContentFacilityAmenityReferenceCounts = {
  __typename?: "ContentFacilityAmenityReferenceCounts";
  features: Scalars["Int"]["output"];
  options: Scalars["Int"]["output"];
  variations: Scalars["Int"]["output"];
};

/** バリエーション・オプションや、Featureなどの詳細情報 */
export type ContentFacilityDetails = {
  __typename?: "ContentFacilityDetails";
  /** 付帯する設備 */
  facilityAmenities: Array<ContentArchitectureTypeVariantFacilityAmenity>;
  /** ご利用条件・備考テキスト */
  usageConditionsDescription: Scalars["String"]["output"];
  /** ご利用料金テキスト（Markup） */
  usageFeesDescriptionMarkup: Scalars["String"]["output"];
};

/** ルームタイプの表示コンテンツ */
export type ContentRoomType = {
  __typename?: "ContentRoomType";
  /** 紹介文 (空文字 / 未設定の場合は null。呼び出し側でトルツメする想定) */
  description?: Maybe<Scalars["String"]["output"]>;
  /**
   * ヒーロー画像。`count` 指定時は先頭から `count` 件のみ返す
   * （一覧サムネは count: 1、詳細はギャラリー全件、のように payload を絞れる）。
   */
  heroImages: Array<UploadedFile>;
  /** ID */
  id: Scalars["ID"]["output"];
};

/** ルームタイプの表示コンテンツ */
export type ContentRoomTypeheroImagesArgs = {
  count?: InputMaybe<Scalars["Int"]["input"]>;
};

/** 契約継続タイプ */
export const ContractContinuationType = {
  /** 解約（次期契約を作成しない） */
  Cancel: "Cancel",
  /** 継続（契約終了5ヶ月前までに次期契約を自動作成） */
  Continue: "Continue",
} as const;

export type ContractContinuationType =
  (typeof ContractContinuationType)[keyof typeof ContractContinuationType];
/** 契約ステータス */
export const ContractStatus = {
  /** 契約中（現在有効） */
  Active: "Active",
  /** 契約満了（期間終了済み） */
  Expired: "Expired",
  /** 契約無効済（論理削除済み） */
  Invalidated: "Invalidated",
  /** 契約予定（3ヶ月以内に開始予定） */
  Scheduled: "Scheduled",
} as const;

export type ContractStatus =
  (typeof ContractStatus)[keyof typeof ContractStatus];
export const CountryEnum = {
  ABW: "ABW",
  AFG: "AFG",
  AGO: "AGO",
  AIA: "AIA",
  ALB: "ALB",
  AND: "AND",
  ANT: "ANT",
  ARE: "ARE",
  ARG: "ARG",
  ARM: "ARM",
  ASM: "ASM",
  ATA: "ATA",
  ATG: "ATG",
  AUS: "AUS",
  AUT: "AUT",
  AZE: "AZE",
  BDI: "BDI",
  BEL: "BEL",
  BEN: "BEN",
  BFA: "BFA",
  BGD: "BGD",
  BGR: "BGR",
  BHR: "BHR",
  BHS: "BHS",
  BIH: "BIH",
  BLR: "BLR",
  BLZ: "BLZ",
  BMU: "BMU",
  BOL: "BOL",
  BRA: "BRA",
  BRB: "BRB",
  BRN: "BRN",
  BTN: "BTN",
  BWA: "BWA",
  CAF: "CAF",
  CAN: "CAN",
  CCK: "CCK",
  CHE: "CHE",
  CHI: "CHI",
  CHL: "CHL",
  CHN: "CHN",
  CIV: "CIV",
  CMR: "CMR",
  COD: "COD",
  COG: "COG",
  COK: "COK",
  COL: "COL",
  COM: "COM",
  CPV: "CPV",
  CRI: "CRI",
  CUB: "CUB",
  CXR: "CXR",
  CYM: "CYM",
  CYP: "CYP",
  CZE: "CZE",
  DEU: "DEU",
  DJI: "DJI",
  DMA: "DMA",
  DNK: "DNK",
  DOM: "DOM",
  DZA: "DZA",
  ECU: "ECU",
  EGY: "EGY",
  ERI: "ERI",
  ESH: "ESH",
  ESP: "ESP",
  EST: "EST",
  ETH: "ETH",
  FIN: "FIN",
  FJI: "FJI",
  FLK: "FLK",
  FRA: "FRA",
  FRO: "FRO",
  FSM: "FSM",
  GAB: "GAB",
  GBR: "GBR",
  GEO: "GEO",
  GHA: "GHA",
  GIB: "GIB",
  GIN: "GIN",
  GLP: "GLP",
  GMB: "GMB",
  GNB: "GNB",
  GNQ: "GNQ",
  GRC: "GRC",
  GRD: "GRD",
  GRL: "GRL",
  GTM: "GTM",
  GUF: "GUF",
  GUM: "GUM",
  GUY: "GUY",
  HKG: "HKG",
  HND: "HND",
  HRV: "HRV",
  HTI: "HTI",
  HUN: "HUN",
  IDN: "IDN",
  IMN: "IMN",
  IND: "IND",
  IOT: "IOT",
  IRL: "IRL",
  IRN: "IRN",
  IRQ: "IRQ",
  ISL: "ISL",
  ISR: "ISR",
  ITA: "ITA",
  JAM: "JAM",
  JON: "JON",
  JOR: "JOR",
  JPN: "JPN",
  KAS: "KAS",
  KAZ: "KAZ",
  KEN: "KEN",
  KGZ: "KGZ",
  KHM: "KHM",
  KIR: "KIR",
  KNA: "KNA",
  KOR: "KOR",
  KSV: "KSV",
  KWT: "KWT",
  LAO: "LAO",
  LBN: "LBN",
  LBR: "LBR",
  LBY: "LBY",
  LCA: "LCA",
  LIE: "LIE",
  LKA: "LKA",
  LSO: "LSO",
  LTU: "LTU",
  LUX: "LUX",
  LVA: "LVA",
  MAC: "MAC",
  MAR: "MAR",
  MCO: "MCO",
  MDA: "MDA",
  MDG: "MDG",
  MDV: "MDV",
  MEX: "MEX",
  MHL: "MHL",
  MID: "MID",
  MKD: "MKD",
  MLI: "MLI",
  MLT: "MLT",
  MMR: "MMR",
  MNE: "MNE",
  MNG: "MNG",
  MNP: "MNP",
  MOZ: "MOZ",
  MRT: "MRT",
  MSR: "MSR",
  MTQ: "MTQ",
  MUS: "MUS",
  MWI: "MWI",
  MYS: "MYS",
  MYT: "MYT",
  NAM: "NAM",
  NCL: "NCL",
  NER: "NER",
  NFK: "NFK",
  NGA: "NGA",
  NIC: "NIC",
  NIU: "NIU",
  NLD: "NLD",
  NOR: "NOR",
  NPL: "NPL",
  NRU: "NRU",
  NZL: "NZL",
  OMN: "OMN",
  PAK: "PAK",
  PAN: "PAN",
  PCN: "PCN",
  PER: "PER",
  PHL: "PHL",
  PLW: "PLW",
  PNG: "PNG",
  POL: "POL",
  PRI: "PRI",
  PRK: "PRK",
  PRT: "PRT",
  PRY: "PRY",
  PSE: "PSE",
  PYF: "PYF",
  QAT: "QAT",
  REU: "REU",
  ROU: "ROU",
  RUS: "RUS",
  RWA: "RWA",
  SAU: "SAU",
  SDN: "SDN",
  SEN: "SEN",
  SGP: "SGP",
  SHN: "SHN",
  SJM: "SJM",
  SLB: "SLB",
  SLE: "SLE",
  SLV: "SLV",
  SMR: "SMR",
  SOM: "SOM",
  SPM: "SPM",
  SRB: "SRB",
  SSD: "SSD",
  STP: "STP",
  SUR: "SUR",
  SVK: "SVK",
  SVN: "SVN",
  SWE: "SWE",
  SWZ: "SWZ",
  SYC: "SYC",
  SYR: "SYR",
  TCA: "TCA",
  TCD: "TCD",
  TGO: "TGO",
  THA: "THA",
  TJK: "TJK",
  TKL: "TKL",
  TKM: "TKM",
  TLS: "TLS",
  TON: "TON",
  TTO: "TTO",
  TUN: "TUN",
  TUR: "TUR",
  TUV: "TUV",
  TWN: "TWN",
  TZA: "TZA",
  UGA: "UGA",
  UKR: "UKR",
  URY: "URY",
  USA: "USA",
  UZB: "UZB",
  VAT: "VAT",
  VCT: "VCT",
  VEN: "VEN",
  VGB: "VGB",
  VIR: "VIR",
  VNM: "VNM",
  VUT: "VUT",
  WAK: "WAK",
  WLF: "WLF",
  WSM: "WSM",
  YEM: "YEM",
  ZAF: "ZAF",
  ZMB: "ZMB",
  ZWE: "ZWE",
  ZZZ: "ZZZ",
} as const;

export type CountryEnum = (typeof CountryEnum)[keyof typeof CountryEnum];
export type CreateAccommodationAvailabilityBlockInput = {
  accommodationId?: InputMaybe<Scalars["ID"]["input"]>;
  beginNight: Scalars["PlainDate"]["input"];
  category: AccommodationAvailabilityBlockCategory;
  endNight: Scalars["PlainDate"]["input"];
  /**
   * 既存の予約と重複していてもブロックを作成する。
   * 既存の他ブロックとの重複は指定に関わらず不可。
   */
  ignoreReservations?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTentative: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  siteId: Scalars["ID"]["input"];
  staffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateAccommodationReservationError = {
  __typename?: "CreateAccommodationReservationError";
  case: CreateAccommodationReservationErrorCase;
  internalCode?: Maybe<Scalars["String"]["output"]>;
};

export const CreateAccommodationReservationErrorCase = {
  /** サブスクにおいて同一予約サイクル内ですでに予約を取っている */
  CycleDuplicationError: "CycleDuplicationError",
  /** 現在予約可能な期間に収まっていない */
  InvalidReservationPeriodError: "InvalidReservationPeriodError",
  /** 月間泊数の上限を超えている */
  MaxNightsPerMonthExceededError: "MaxNightsPerMonthExceededError",
  /** 年間泊数の上限を超えている */
  MaxNightsPerYearExceededError: "MaxNightsPerYearExceededError",
  /** 同時予約数の上限を超えている */
  MaxReservationsExceededError: "MaxReservationsExceededError",
  /** Weekdayプランの月7泊制限を超過している */
  MonthlyNightLimitExceededError: "MonthlyNightLimitExceededError",
  /** 同月内予約数の上限を超えている */
  MonthlyReservationLimitExceededError: "MonthlyReservationLimitExceededError",
  /** サブスクにおいて1週間以内ですでに予約を取っている */
  Next7DaysDuplicationError: "Next7DaysDuplicationError",
  /** Stay Gift from Owners のオーナーが自身の予約を取ろうとした */
  OwnerOfStayGiftFromOwnersError: "OwnerOfStayGiftFromOwnersError",
  /** オーナーの泊数が不足している */
  OwnerStayCreditInsufficientError: "OwnerStayCreditInsufficientError",
  /** オーナー拠点の繁忙日はオーナー会員のみが予約可能である */
  PeakDayOwnerOnlyError: "PeakDayOwnerOnlyError",
  /** High日制限を超えている */
  PeakDaysLimitExceededError: "PeakDaysLimitExceededError",
  /** 同一の日程ですでに別の予約を取っている */
  ReservationOverlapError: "ReservationOverlapError",
  /**
   * 部屋が空室ではないため利用不可能
   * （内部的には稼働制御によるものであることもある）
   */
  ResourceUnavailable: "ResourceUnavailable",
  /** SanuIncプロバイダーでstaffGroupIdが指定されていない */
  SanuIncStaffGroupIdRequiredError: "SanuIncStaffGroupIdRequiredError",
  /** 拠点ハイシーズン制限を超えている（FullOwnerのみ） */
  SiteHighSeasonLimitExceededError: "SiteHighSeasonLimitExceededError",
  /** 宿泊チケットが使用済みまたは無効である */
  StayTicketError: "StayTicketError",
  /** サブスクリプションが支払い失敗により停止されている */
  SubscriptionSuspended: "SubscriptionSuspended",
  /** 未同意の規約の改定がある */
  TermsNotAgreedError: "TermsNotAgreedError",
  /** Trialプランが支払い失敗により停止されている */
  TrialContractSuspended: "TrialContractSuspended",
  /** Trialプランの泊数が不足している */
  TrialStayCreditInsufficientError: "TrialStayCreditInsufficientError",
  /** 予期せぬエラー */
  UnexpectedError: "UnexpectedError",
  /** 未払いの宿泊料金がある */
  UnpaidAccommodationFeeError: "UnpaidAccommodationFeeError",
  /** Weekdayプランの新規約に同意していない */
  WeekdayTermsNotAgreedError: "WeekdayTermsNotAgreedError",
} as const;

export type CreateAccommodationReservationErrorCase =
  (typeof CreateAccommodationReservationErrorCase)[keyof typeof CreateAccommodationReservationErrorCase];
export type CreateAccommodationReservationInput = {
  accommodationId: Scalars["ID"]["input"];
  detail: AccommodationReservationDetailInput;
  firstNight: Scalars["PlainDate"]["input"];
  /** 部屋タイプ予約として作成するか。省略時は false（通常予約）として扱う */
  isRoomTypeReservation?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastNight: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
};

export type CreateAccommodationReservationPayload =
  | AccommodationReservation
  | CreateAccommodationReservationError;

export type CreateCoOwnersApplicationFileDownloadUrlError = {
  __typename?: "CreateCoOwnersApplicationFileDownloadUrlError";
  case: CreateCoOwnersApplicationFileDownloadUrlErrorCase;
};

export const CreateCoOwnersApplicationFileDownloadUrlErrorCase = {
  NotFound: "NotFound",
} as const;

export type CreateCoOwnersApplicationFileDownloadUrlErrorCase =
  (typeof CreateCoOwnersApplicationFileDownloadUrlErrorCase)[keyof typeof CreateCoOwnersApplicationFileDownloadUrlErrorCase];
export type CreateCoOwnersApplicationFileDownloadUrlPayload =
  | CreateCoOwnersApplicationFileDownloadUrlError
  | CreateCoOwnersApplicationFileDownloadUrlSuccess;

export type CreateCoOwnersApplicationFileDownloadUrlSuccess = {
  __typename?: "CreateCoOwnersApplicationFileDownloadUrlSuccess";
  url: Scalars["String"]["output"];
};

export type CreateCoOwnersApplicationFileUploadPolicyInput = {
  coOwnersApplicationId: Scalars["ID"]["input"];
  /** アップロードするファイルの Content-Type。PDF または画像のみ */
  contentType: Scalars["String"]["input"];
};

export type CreateFacilityReservationError = {
  __typename?: "CreateFacilityReservationError";
  case: CreateFacilityReservationErrorCase;
};

export const CreateFacilityReservationErrorCase = {
  AccommodationReservationPeriodMismatch:
    "AccommodationReservationPeriodMismatch",
  FeePolicyNotFound: "FeePolicyNotFound",
  InvalidFacilityFieldData: "InvalidFacilityFieldData",
  InvalidSlotSelection: "InvalidSlotSelection",
  InvalidStartDate: "InvalidStartDate",
  NoAccommodationReservation: "NoAccommodationReservation",
  PastReserveDeadline: "PastReserveDeadline",
  ProviderNotEligible: "ProviderNotEligible",
  ResourceUnavailable: "ResourceUnavailable",
  ServiceNotAvailable: "ServiceNotAvailable",
  TemporarilyUnavailable: "TemporarilyUnavailable",
} as const;

export type CreateFacilityReservationErrorCase =
  (typeof CreateFacilityReservationErrorCase)[keyof typeof CreateFacilityReservationErrorCase];
/** 付帯サービス予約作成入力 */
export type CreateFacilityReservationInput = {
  accommodationReservationId: Scalars["ID"]["input"];
  customFieldValues?: InputMaybe<Array<FacilityCustomFieldValueInput>>;
  endDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  resourceId: Scalars["ID"]["input"];
  slotId?: InputMaybe<Scalars["ID"]["input"]>;
  startDate: Scalars["PlainDate"]["input"];
};

export type CreateFacilityReservationPayload =
  | CreateFacilityReservationError
  | CreateFacilityReservationSuccess;

export type CreateFacilityReservationSuccess = {
  __typename?: "CreateFacilityReservationSuccess";
  reservation: FacilityReservation;
};

export type CreateFileUploadPolicyError = {
  __typename?: "CreateFileUploadPolicyError";
  case: CreateFileUploadPolicyErrorCase;
};

export const CreateFileUploadPolicyErrorCase = {
  GeneralError: "GeneralError",
  /** 紐づけ先のリソースが存在しないか、アクセスできない */
  NotFound: "NotFound",
  ResourceIdRequired: "ResourceIdRequired",
} as const;

export type CreateFileUploadPolicyErrorCase =
  (typeof CreateFileUploadPolicyErrorCase)[keyof typeof CreateFileUploadPolicyErrorCase];
export type CreateFileUploadPolicySuccess = {
  __typename?: "CreateFileUploadPolicySuccess";
  policy: S3UploadPolicy;
};

export type CreateFullOwnerContractUploadPolicyInput = {
  type: SanuFileType;
};

/** 基本宿泊料金ポリシーの作成・更新時の入力 */
export type CreateOrUpdateBaseAccommodationFeePolicyInput = {
  dailyFeePolicy: Array<Scalars["Int"]["input"]>;
  feeModifier?: InputMaybe<Scalars["Int"]["input"]>;
  feeModifierType?: InputMaybe<FeeModifierType>;
  /**
   * 料金設定ルール。
   * 省略 (null) した場合は既存のルールを変更しない。
   * 空配列を渡した場合は既存のルールを全削除する。
   * 配列を渡した場合は既存のルールを全置換する。
   */
  feeRules?: InputMaybe<Array<AccommodationFeeRuleInput>>;
  internalName: Scalars["String"]["input"];
  /** 宿泊費の一部または全部が第三者（タイアップ先等）の負担であるか */
  isThirdPartyCovered?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** dailyFeePolicy に含まれない第三者負担額（泊毎） */
  thirdPartyCoveredDailyFeePolicy?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type CreateOrUpdateBusinessPlanInput = {
  feePerNights: Scalars["Int"]["input"];
  feePerNum: Scalars["Int"]["input"];
  isPeakDayFeeFree: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
};

export type CreateOrUpdateCancelFeePolicyInput = {
  /** 固定料金の場合の設定値（0以上の整数） */
  cancelFeeFixedPolicy?: InputMaybe<CancelFeeFixedPolicyInput>;
  /** 料率ベースの場合の設定値（0.0 ~ 1.0） */
  cancelFeeRatePolicy?: InputMaybe<CancelFeeRatePolicyInput>;
  /** true の場合、即時100%のキャンセル料が発生する（実質的にキャンセル不可のポリシー）。 */
  immediate?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 内部管理用の名前 */
  internalDescription: Scalars["String"]["input"];
  /** 内部管理用の名前 */
  internalName: Scalars["String"]["input"];
};

/** 法人の作成・更新時の入力 */
export type CreateOrUpdateOrganizationInput = {
  announcementContent: Scalars["String"]["input"];
  assignedUserEmail?: InputMaybe<Scalars["String"]["input"]>;
  billingEmail?: InputMaybe<Scalars["String"]["input"]>;
  defaultFrequency?: InputMaybe<OrganizationYearlyContractInvoiceFrequency>;
  defaultPaymentMethod?: InputMaybe<OrganizationYearlyContractInvoicePaymentMethodType>;
  /** サービス上で表示する名称。省略すると現在の値を保ち、null か空文字で未設定に戻す */
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  emailDomainsForMember: Array<Scalars["String"]["input"]>;
  invitationCode: Scalars["String"]["input"];
  maxNightsPerMember?: InputMaybe<Scalars["Int"]["input"]>;
  maxNightsPerMonth?: InputMaybe<Scalars["Int"]["input"]>;
  maxNightsPerStay?: InputMaybe<Scalars["Int"]["input"]>;
  memberCustomFieldEnabled: Scalars["Boolean"]["input"];
  memberCustomFieldName?: InputMaybe<Scalars["String"]["input"]>;
  memberCustomFieldPlaceholder?: InputMaybe<Scalars["String"]["input"]>;
  memberCustomFieldRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  paymentMethodCardEnabled: Scalars["Boolean"]["input"];
  suspended: Scalars["Boolean"]["input"];
};

export type CreateOrUpdateOrganizationYearlyContractInput = {
  amountRecord: Scalars["Float"]["input"];
  businessPlanId: Scalars["String"]["input"];
  continuationType?: InputMaybe<ContractContinuationType>;
  endMonth: Scalars["PlainYearMonth"]["input"];
  maxNightsPerMonth?: InputMaybe<Scalars["Int"]["input"]>;
  nightsPerMonth: Scalars["Int"]["input"];
  nightsPerYear: Scalars["Int"]["input"];
  startMonth: Scalars["PlainYearMonth"]["input"];
};

export type CreateOrUpdateOrganizationYearlyContractInvoiceInput = {
  /**
   * 年間払いか、月払いか
   * 新規作成時は必須
   */
  frequency?: InputMaybe<OrganizationYearlyContractInvoiceFrequency>;
  /**
   * 下書きとして作成するか、すぐにオープンな請求書として作成するか
   * オープンな請求書として作成すると、ユーザー側のダッシュボードにも表示される
   * 新規作成時は必須、更新時は無視される
   */
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * 請求金額（税込）
   * 新規作成時は必須
   */
  itemAmount?: InputMaybe<Scalars["Int"]["input"]>;
  /**
   * 決済方法。銀行振込か、クレジットカード払いか
   * 新規作成時は必須
   */
  paymentMethodType?: InputMaybe<OrganizationYearlyContractInvoicePaymentMethodType>;
  /**
   * 請求書を自動でオープンにする場合の日付。
   * 下書き状態の請求書についてのみ、設定可能。
   * nullを指定すると公開予定日をクリアする。
   */
  scheduledOpenDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 月払いの場合、いつの月分の請求書か */
  yearMonth?: InputMaybe<Scalars["PlainYearMonth"]["input"]>;
};

export type CreateOrUpdateStaffGroupInput = {
  archivedAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  smarthrId: Scalars["String"]["input"];
};

export type CreateOrUpdateUserAppInstallationError = {
  __typename?: "CreateOrUpdateUserAppInstallationError";
  case: CreateOrUpdateUserAppInstallationErrorCase;
};

export const CreateOrUpdateUserAppInstallationErrorCase = {
  GeneralError: "GeneralError",
} as const;

export type CreateOrUpdateUserAppInstallationErrorCase =
  (typeof CreateOrUpdateUserAppInstallationErrorCase)[keyof typeof CreateOrUpdateUserAppInstallationErrorCase];
export type CreateOrUpdateUserAppInstallationInput = {
  /** FCMトークン */
  fcmToken: Scalars["String"]["input"];
  /** インストールID */
  installationId: Scalars["ID"]["input"];
  /** プッシュ通知のプラットフォーム */
  platform: PushNotificationPlatform;
  /**
   * 登録時のアプリバージョン
   * デバッグ用の参考情報なのでオプショナル
   */
  registeredAppVersion?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * 端末モデル
   * デバッグ用の参考情報なのでオプショナル
   */
  registeredDeviceModel?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * 登録時のOSバージョン
   * デバッグ用の参考情報なのでオプショナル
   */
  registeredOsVersion?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateOrUpdateUserAppInstallationPayload =
  | CreateOrUpdateUserAppInstallationError
  | Success;

export type CreateSanuOwnerPlanFileUploadPolicyInput = {
  type: SanuFileType;
};

export type CreateSanuOwnerPlanUserFileUploadPolicyInput = {
  ownerPlanId: Scalars["ID"]["input"];
  type: SanuOwnerPlanUserFileType;
  units: Scalars["Int"]["input"];
};

export type CreateStripeCardSetupIntentOfOrganizationPayload = {
  __typename?: "CreateStripeCardSetupIntentOfOrganizationPayload";
  clientSecret: Scalars["String"]["output"];
};

export type CreateStripeCardSetupIntentOfViewerPayload = {
  __typename?: "CreateStripeCardSetupIntentOfViewerPayload";
  clientSecret: Scalars["String"]["output"];
};

export type CreateUserFileUploadPolicyInput = {
  type: UserFileType;
};

export type CreateWebviewSessionError = {
  __typename?: "CreateWebviewSessionError";
  case: CreateWebviewSessionErrorCase;
};

export const CreateWebviewSessionErrorCase = {
  /** 認証が必要 */
  Unauthorized: "Unauthorized",
} as const;

export type CreateWebviewSessionErrorCase =
  (typeof CreateWebviewSessionErrorCase)[keyof typeof CreateWebviewSessionErrorCase];
export type CreateWebviewSessionInput = {
  /** WebView内でセッション確立後にリダイレクトするパス（例: "/member"） */
  redirectTo: Scalars["String"]["input"];
};

export type CreateWebviewSessionPayload =
  | CreateWebviewSessionError
  | CreateWebviewSessionSuccess;

/** WebViewセッションURL生成成功 */
export type CreateWebviewSessionSuccess = {
  __typename?: "CreateWebviewSessionSuccess";
  /** WebViewで開くべきURL（短期トークン付き） */
  url: Scalars["String"]["output"];
};

export const CronJobName = {
  ApplyGuestAccessKeys: "ApplyGuestAccessKeys",
  AutoTransitionCoOwnersHandover: "AutoTransitionCoOwnersHandover",
  CalculateAndOpenAccommodationFees: "CalculateAndOpenAccommodationFees",
  CancelExceededTentativeAccommodationReservations:
    "CancelExceededTentativeAccommodationReservations",
  CheckGuestAccessKeys: "CheckGuestAccessKeys",
  CheckOutExceededAccommodationReservations:
    "CheckOutExceededAccommodationReservations",
  CloseSupplyReports: "CloseSupplyReports",
  CreateCleaningTasks: "CreateCleaningTasks",
  CreateNextOrganizationYearlyContracts:
    "CreateNextOrganizationYearlyContracts",
  DetermineEarlyCheckInEligibility: "DetermineEarlyCheckInEligibility",
  FetchCoOwnersIdentityVerificationEvidence:
    "FetchCoOwnersIdentityVerificationEvidence",
  FetchModifiedBeds24Bookings: "FetchModifiedBeds24Bookings",
  GrantStaffStayCredits: "GrantStaffStayCredits",
  IssueInvoicesOfAccommodationFees: "IssueInvoicesOfAccommodationFees",
  JobsAt0300Jst: "JobsAt0300Jst",
  JobsAt1500Jst: "JobsAt1500Jst",
  OpenDraftInvoices: "OpenDraftInvoices",
  ReleaseExpiredAccessKeys: "ReleaseExpiredAccessKeys",
  RotateDailyStaffAccessKeys: "RotateDailyStaffAccessKeys",
  RotateMonthlyStaffAccessKeys: "RotateMonthlyStaffAccessKeys",
  ScheduledReleaseReservationBlocks: "ScheduledReleaseReservationBlocks",
  SendCheckInAndCheckOutTodayReminders: "SendCheckInAndCheckOutTodayReminders",
  SendCheckOutGuideMails: "SendCheckOutGuideMails",
  SendCleaningTasksDailyReminder: "SendCleaningTasksDailyReminder",
  SendCoOwnersIdentityVerificationReminderMails:
    "SendCoOwnersIdentityVerificationReminderMails",
  SendCoOwnersWebinarReminderMails: "SendCoOwnersWebinarReminderMails",
  SendFacilityReservationUsageEndReminders:
    "SendFacilityReservationUsageEndReminders",
  SendIchinomiyaNoticeMails: "SendIchinomiyaNoticeMails",
  SmartPlugStatusUpdate: "SmartPlugStatusUpdate",
  SyncBeds24FuturePrices: "SyncBeds24FuturePrices",
  SyncBubbleSupplyItemMasters: "SyncBubbleSupplyItemMasters",
  SyncCoOwnersIdentityVerifications: "SyncCoOwnersIdentityVerifications",
} as const;

export type CronJobName = (typeof CronJobName)[keyof typeof CronJobName];
/** 日次料金のターゲット */
export const DailyRateTarget = {
  /** OTA向け（Beds24同期用） */
  OnlineTravelAgent: "OnlineTravelAgent",
  /** 自社向け（内部価格計算用） */
  SanuInc: "SanuInc",
} as const;

export type DailyRateTarget =
  (typeof DailyRateTarget)[keyof typeof DailyRateTarget];
export type DeleteUserAppInstallationError = {
  __typename?: "DeleteUserAppInstallationError";
  case: DeleteUserAppInstallationErrorCase;
};

export const DeleteUserAppInstallationErrorCase = {
  GeneralError: "GeneralError",
  NotFound: "NotFound",
} as const;

export type DeleteUserAppInstallationErrorCase =
  (typeof DeleteUserAppInstallationErrorCase)[keyof typeof DeleteUserAppInstallationErrorCase];
export type DeleteUserAppInstallationPayload =
  | DeleteUserAppInstallationError
  | Success;

export type DeleteViewerError = {
  __typename?: "DeleteViewerError";
  case: DeleteViewerErrorCase;
};

export const DeleteViewerErrorCase = {
  Auth0UserNotDeleted: "Auth0UserNotDeleted",
  PendingAccommodationReservations: "PendingAccommodationReservations",
  PendingCoOwnersApplications: "PendingCoOwnersApplications",
  StripePaymentMethodNotDeleted: "StripePaymentMethodNotDeleted",
  UserDataNotDeleted: "UserDataNotDeleted",
  UserOrganizationAdmin: "UserOrganizationAdmin",
  UserOwnershipActive: "UserOwnershipActive",
  UserSubscriptionActive: "UserSubscriptionActive",
} as const;

export type DeleteViewerErrorCase =
  (typeof DeleteViewerErrorCase)[keyof typeof DeleteViewerErrorCase];
export type DeleteViewerPayload = DeleteViewerError | Success;

export const DisclosureAssistantType = {
  /** 担当 */
  PersonInCharge: "PersonInCharge",
  /** 代表 */
  Representative: "Representative",
} as const;

export type DisclosureAssistantType =
  (typeof DisclosureAssistantType)[keyof typeof DisclosureAssistantType];
export type DogfriendlyAccommodationFacility = {
  __typename?: "DogfriendlyAccommodationFacility";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * ドラフト予約
 * 予約確定前の料金見積もりを含む予約
 * データベース上には保存されない
 */
export type DraftAccommodationReservation = {
  __typename?: "DraftAccommodationReservation";
  accommodation: Accommodation;
  /** 滞在期間に重なる施設のお知らせ（AccommodationReservation.accommodationNotices と同じ重なり判定）。 */
  accommodationNotices: Array<AccommodationNotice>;
  /** 8泊目以降の追加料金（見込み） */
  additionalNights: Scalars["Int"]["output"];
  /** 部屋変更可否の選択をできるかどうか */
  canSelectAllowRoomChange: Scalars["Boolean"]["output"];
  /** この予約ドラフトに適用されるキャンセルポリシー（表示用）。 */
  cancellationPolicyContent?: Maybe<CancellationPolicyContent>;
  fee: AccommodationFee;
  /** 料金計算に際して利用されたオプション料金の請求有無の設定 */
  feeApplicability: AccommodationFeeApplicability;
  firstDate: Scalars["PlainDate"]["output"];
  firstNight: Scalars["PlainDate"]["output"];
  lastDate: Scalars["PlainDate"]["output"];
  lastNight: Scalars["PlainDate"]["output"];
  /** この滞在に適用される地方税ポリシー。空でなければ予約前の同意取得が必要。 */
  localTaxPolicies: Array<LocalTaxPolicy>;
  nights: Scalars["Int"]["output"];
  options: AccommodationReservationOptions;
  reservedFrom: Scalars["ZonedDateTime"]["output"];
  reservedTo: Scalars["ZonedDateTime"]["output"];
  /** 表示用の標準チェックイン時刻。 */
  standardCheckInTime: Scalars["ZonedDateTime"]["output"];
  stayTicketUnit?: Maybe<StayTicketUnit>;
};

export type DraftAccommodationReservationByStayTicketMasterInput = {
  accommodationId: Scalars["ID"]["input"];
  firstNight: Scalars["PlainDate"]["input"];
  /** 人数情報。StayTicket master に AdditionalGuestFeePolicy が紐付いている場合のみ追加料金計算で参照される */
  guestCounts: GuestCountsInput;
  lastNight: Scalars["PlainDate"]["input"];
  options: DraftAccommodationReservationOptionsInput;
  /** 予約可能資産・期間・料金計算条件の解決元となる StayTicketMaster の参照。 */
  stayTicketMasterReference: StayTicketMasterReferenceInput;
};

/**
 * provider を経由せず StayTicketMaster から直接見積もった、非会員向けの宿泊料金プレビュー結果。
 * 発行済み StayTicketUnit の実在を前提にしたフィールド（キャンセルポリシー等）は持たない。
 */
export type DraftAccommodationReservationByStayTicketMasterResult = {
  __typename?: "DraftAccommodationReservationByStayTicketMasterResult";
  fee: AccommodationFee;
};

export type DraftAccommodationReservationInput = {
  accommodationId: Scalars["ID"]["input"];
  firstNight: Scalars["PlainDate"]["input"];
  /** 人数情報。StayTicket master に AdditionalGuestFeePolicy が紐付いている場合のみ追加料金計算で参照される */
  guestCounts: GuestCountsInput;
  /**
   * 変更予約の元 ID。指定すると SanuInc/OTA は元 fee 保持、
   * StandardPlan/StayTicket + internalPreserveDynamicPricing=true では DP 保持。
   */
  internalOriginalReservationId?: InputMaybe<Scalars["ID"]["input"]>;
  /**
   * true の場合、変更前 fee にあった動的料金 item の amount を維持する。
   * internalOriginalReservationId と組み合わせて使う。
   * 対象: StandardPlan の calculated_dynamic_pricing_fee、StayTicket の calculated_base_fee。
   * 拠点変更時は無効化。
   */
  internalPreserveDynamicPricing?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastNight: Scalars["PlainDate"]["input"];
  options: DraftAccommodationReservationOptionsInput;
  /**
   * 予約変更フォームで元予約の ID。指定時は 2 つの効果がある:
   * 1. additionalNights 計算から当該予約の泊数を除外する (重複カウント防止)。
   * 2. 同じ accommodation への変更の場合、元予約の動的料金 amount を見積もりに引き継ぐ
   *    (`changeAccommodationReservation` の挙動と一致させる)。
   * 他ユーザーの ID を指定した場合は無視される (所有権チェックあり)。
   */
  originalReservationIdToExcludeForAdditionalNights?: InputMaybe<
    Scalars["ID"]["input"]
  >;
  provider: AccommodationReservationProviderInput;
};

export type DraftAccommodationReservationOptionsInput = {
  bringDog: Scalars["Boolean"]["input"];
  numberOfDogs: Scalars["Int"]["input"];
  useEvCharger: Scalars["Boolean"]["input"];
};

export type EVChargerAccommodationFacility = {
  __typename?: "EVChargerAccommodationFacility";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** アーリーチェックインの料金テーブルのスロット */
export type EarlyCheckInPriceSlot = {
  __typename?: "EarlyCheckInPriceSlot";
  /** 終了時刻（時） */
  endHour: Scalars["Int"]["output"];
  /** このスロットのID */
  id: Scalars["ID"]["output"];
  /** 表示用ラベル */
  label: Scalars["String"]["output"];
  /** 料金（税込） */
  price: Scalars["Int"]["output"];
  /** 開始時刻（時） */
  startHour: Scalars["Int"]["output"];
};

/** ECI 表示状態 */
export const EarlyCheckInStatus = {
  /** 案内ラベル + チェックイン実行可能（現在 ECI 料金時間帯内） */
  Available: "Available",
  /** ECI 案内も表示しない（対象外 / チェックイン後 / standardCheckInTime 以降 等） */
  Hidden: "Hidden",
  /** ECI 案内ラベル表示のみ（チェックイン実行は不可、現在 ECI 料金時間帯外） */
  Visible: "Visible",
} as const;

export type EarlyCheckInStatus =
  (typeof EarlyCheckInStatus)[keyof typeof EarlyCheckInStatus];
export type EstimateStandardSubscriptionApplicationError = {
  __typename?: "EstimateStandardSubscriptionApplicationError";
  case: EstimateStandardSubscriptionApplicationErrorCase;
};

export const EstimateStandardSubscriptionApplicationErrorCase = {
  /** 割引コードに対応する商品をすでに購入したことがあるため使えない */
  HasPriorTransaction: "HasPriorTransaction",
  /**
   * 割引コードが無効
   * 割引コードが存在しない、存在するが有効期限切れなど
   */
  InvalidPromotionCode: "InvalidPromotionCode",
} as const;

export type EstimateStandardSubscriptionApplicationErrorCase =
  (typeof EstimateStandardSubscriptionApplicationErrorCase)[keyof typeof EstimateStandardSubscriptionApplicationErrorCase];
export type EstimateStandardSubscriptionApplicationFeePayload =
  | EstimateStandardSubscriptionApplicationError
  | EstimateStandardSubscriptionApplicationSuccess;

export type EstimateStandardSubscriptionApplicationSuccess = {
  __typename?: "EstimateStandardSubscriptionApplicationSuccess";
  /** 割引適用後の金額 */
  amount: Scalars["Int"]["output"];
};

export type EstimatedCancelFeeOfAccommodationReservationError = {
  __typename?: "EstimatedCancelFeeOfAccommodationReservationError";
  case: EstimatedCancelFeeOfAccommodationReservationErrorCase;
};

export const EstimatedCancelFeeOfAccommodationReservationErrorCase = {
  GeneralError: "GeneralError",
} as const;

export type EstimatedCancelFeeOfAccommodationReservationErrorCase =
  (typeof EstimatedCancelFeeOfAccommodationReservationErrorCase)[keyof typeof EstimatedCancelFeeOfAccommodationReservationErrorCase];
export type EstimatedCancelFeeOfAccommodationReservationPayload =
  | EstimatedCancelFeeOfAccommodationReservationError
  | EstimatedChargeOfAccommodationReservation;

export type EstimatedChangeFeeOfAccommodationReservationError = {
  __typename?: "EstimatedChangeFeeOfAccommodationReservationError";
  case: EstimatedChangeFeeOfAccommodationReservationErrorCase;
};

export const EstimatedChangeFeeOfAccommodationReservationErrorCase = {
  GeneralError: "GeneralError",
} as const;

export type EstimatedChangeFeeOfAccommodationReservationErrorCase =
  (typeof EstimatedChangeFeeOfAccommodationReservationErrorCase)[keyof typeof EstimatedChangeFeeOfAccommodationReservationErrorCase];
export type EstimatedChangeFeeOfAccommodationReservationInput = {
  accommodationId: Scalars["ID"]["input"];
  firstNight: Scalars["PlainDate"]["input"];
  /** 人数情報。StayTicket master に AdditionalGuestFeePolicy が紐付いている場合のみ追加料金計算で参照される */
  guestCounts: GuestCountsInput;
  lastNight: Scalars["PlainDate"]["input"];
  options: DraftAccommodationReservationOptionsInput;
};

export type EstimatedChangeFeeOfAccommodationReservationPayload =
  | EstimatedChangeFeeOfAccommodationReservationError
  | EstimatedChargeOfAccommodationReservation;

export type EstimatedChargeOfAccommodationReservation = {
  __typename?: "EstimatedChargeOfAccommodationReservation";
  items: Array<EstimatedChargeOfAccommodationReservationItem>;
  totalAmountOfFee: Scalars["Int"]["output"];
};

export type EstimatedChargeOfAccommodationReservationItem = {
  __typename?: "EstimatedChargeOfAccommodationReservationItem";
  amountOfFee?: Maybe<Scalars["Int"]["output"]>;
  chargeType: EstimatedChargeOfAccommodationReservationItemType;
  label: Scalars["String"]["output"];
  night: Scalars["PlainDate"]["output"];
};

export const EstimatedChargeOfAccommodationReservationItemType = {
  Fee: "Fee",
  OwnerStayCredit: "OwnerStayCredit",
  StaffStayCredit: "StaffStayCredit",
  TrialStayCredit: "TrialStayCredit",
} as const;

export type EstimatedChargeOfAccommodationReservationItemType =
  (typeof EstimatedChargeOfAccommodationReservationItemType)[keyof typeof EstimatedChargeOfAccommodationReservationItemType];
/** 付帯サービスEV充電器向けロックのコントローラ属性情報 */
export type EvChargerLock = {
  __typename?: "EvChargerLock";
  controllerId?: Maybe<Scalars["String"]["output"]>;
  expireAt: Scalars["ZonedDateTime"]["output"];
  token?: Maybe<Scalars["String"]["output"]>;
};

/** Stay Gift from Ownersのエクスポート結果 */
export type ExportStayGiftsPayload = {
  __typename?: "ExportStayGiftsPayload";
  tickets: Array<StayGiftExportItem>;
};

/** 付帯サービス */
export type Facility = {
  __typename?: "Facility";
  /** 料金ポリシー一覧 */
  baseFeePolicies: Array<FacilityBaseFeePolicy>;
  /** キャンセル締切の何日前（0=当日, 1=前日） */
  cancelDeadlineDaysBefore: Scalars["Int"]["output"];
  /** キャンセル締切時刻 */
  cancelDeadlineHour: Scalars["Int"]["output"];
  /** キャンセル料ポリシー一覧 */
  cancelFeePolicies: Array<FacilityCancelFeePolicy>;
  /** キャンセル料ルールURL（nullの場合はリンク非表示） */
  cancelRuleUrl?: Maybe<Scalars["String"]["output"]>;
  /** 設備詳細（Markdown） */
  contentDetail?: Maybe<Scalars["String"]["output"]>;
  /** 予約時の案内（Markdown） */
  contentGuide?: Maybe<Scalars["String"]["output"]>;
  /** コンテンツ用画像一覧（Markdown内で参照する画像） */
  contentImages: Array<UploadedFile>;
  /** 注意事項（Markdown） */
  contentNotice?: Maybe<Scalars["String"]["output"]>;
  /** 利用について（Markdown） */
  contentUsage?: Maybe<Scalars["String"]["output"]>;
  /** 作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** カスタムフィールド定義（到着時刻などの動的フォーム項目） */
  customFields?: Maybe<Array<FacilityCustomFieldItem>>;
  /** 説明文 */
  description: Scalars["String"]["output"];
  /** 詳細リンクURL（nullの場合はリンク非表示） */
  detailUrl?: Maybe<Scalars["String"]["output"]>;
  /** 適用される割引一覧（予約フォーム表示用） */
  discountFeePolicies: Array<FacilityDiscountFeePolicy>;
  id: Scalars["ID"]["output"];
  /** 画像 */
  image: UploadedFile;
  /** 清掃レポート機能が有効か（将来別システム移行予定） */
  isCleaningReportEnabled: Scalars["Boolean"]["output"];
  /** データ連携管理機能が有効か */
  isDataSyncEnabled: Scalars["Boolean"]["output"];
  /** いずれかのスロットが予約可能か（バッジ表示用） */
  isReservable: Scalars["Boolean"]["output"];
  /** 予約機能が有効か（false は予約不要・無料で自由に利用できる） */
  isReserveEnabled: Scalars["Boolean"]["output"];
  /** この宿泊予約で予約済みか（AccommodationReservation.facilities 経由の場合のみ有効） */
  isReserved: Scalars["Boolean"]["output"];
  /** 予約締切時刻内か（カード有効化用。枠の有無に関わらず、締め切り前のスロットが存在するか） */
  isUsable: Scalars["Boolean"]["output"];
  /** 拠点/部屋タイプの公開ページと予約カレンダーへの掲載が有効か（滞在中の予約画面のカードには影響しない） */
  isVisibleEnabled: Scalars["Boolean"]["output"];
  /** 短縮表示名（ボタン/カード用） */
  label: Scalars["String"]["output"];
  /** 正式名称 */
  name: Scalars["String"]["output"];
  /** 予約締切の何日前（0=当日, 1=前日, 7=1週間前） */
  reserveDeadlineDaysBefore: Scalars["Int"]["output"];
  /** 予約締切時刻 */
  reserveDeadlineHour: Scalars["Int"]["output"];
  /** リソース一覧 */
  resources: Array<FacilityResource>;
  /** 利用可能な全サイト一覧 */
  sites: Array<Site>;
  /** スロット定義一覧（unitType=Slot の場合のみ） */
  slots: Array<FacilitySlot>;
  /** 公開ステータス（既存予約の表示・キャンセルには影響しない） */
  status: FacilityStatusType;
  /** 規約リンクのラベル（例: "レンタカー利用規約"） */
  termsLabel?: Maybe<Scalars["String"]["output"]>;
  /** 利用規約URL（nullの場合は規約チェックボックス非表示） */
  termsUrl?: Maybe<Scalars["String"]["output"]>;
  /** 付帯サービス種別 */
  type: FacilityType;
  /** 単位種別 */
  unitType: FacilityUnitType;
};

/** 付帯サービス料金ポリシー */
export type FacilityBaseFeePolicy = {
  __typename?: "FacilityBaseFeePolicy";
  id: Scalars["ID"]["output"];
  /** 対象リソース */
  resource?: Maybe<FacilityResource>;
  /** 対象単位数。unit:1がデフォルト単価 */
  unit: Scalars["Int"]["output"];
  /** 1単位あたりの料金 */
  unitFeeAmount: Scalars["Decimal"]["output"];
};

/** 付帯サービスキャンセルポリシー */
export type FacilityCancelFeePolicy = {
  __typename?: "FacilityCancelFeePolicy";
  /** 適用開始日（開始日の何日前） */
  deadlineDaysBefore: Scalars["Int"]["output"];
  /** 適用開始時刻 */
  deadlineHour: Scalars["Int"]["output"];
  /** キャンセル料タイプ */
  feeModifierType: FeeModifierType;
  /** キャンセル料値（Percentage: 料率%, Value: 固定額） */
  feeValue: Scalars["Decimal"]["output"];
  id: Scalars["ID"]["output"];
  /** 対象リソース */
  resource?: Maybe<FacilityResource>;
};

/** 付帯サービスコントローラー */
export type FacilityController = {
  __typename?: "FacilityController";
  attribute?: Maybe<FacilityControllerAttribute>;
  controllerAttribute?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  type: FacilityResourceControllerType;
};

/** 付帯サービス予約のコントローラ属性情報 */
export type FacilityControllerAttribute =
  | CoWorkingSpaceDoorLock
  | EvChargerLock
  | OnsenAndSaunaDoorLock
  | RentalCycleKeyBox
  | WashingMachineTracker;

/** 付帯サービスカスタムフィールド定義 */
export type FacilityCustomFieldItem = {
  __typename?: "FacilityCustomFieldItem";
  caption?: Maybe<Scalars["String"]["output"]>;
  key: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  options?: Maybe<Array<Scalars["String"]["output"]>>;
  placeholder?: Maybe<Scalars["String"]["output"]>;
  required: Scalars["Boolean"]["output"];
  type: FacilityFieldType;
};

/** 付帯サービスカスタムフィールド定義の入力 */
export type FacilityCustomFieldItemInput = {
  /** 補足テキスト（フォームのヘルプテキスト） */
  caption?: InputMaybe<Scalars["String"]["input"]>;
  /** フィールドキー（一意） */
  key: Scalars["String"]["input"];
  /** フィールドラベル（表示名） */
  label: Scalars["String"]["input"];
  /** 選択肢（type=SingleSelectの場合のみ） */
  options?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** プレースホルダー */
  placeholder?: InputMaybe<Scalars["String"]["input"]>;
  /** 必須フラグ */
  required: Scalars["Boolean"]["input"];
  /** フィールドタイプ */
  type: FacilityFieldType;
};

/** 付帯サービスカスタムフィールド値 */
export type FacilityCustomFieldValue = {
  __typename?: "FacilityCustomFieldValue";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/** 付帯サービスカスタムフィールド値入力 */
export type FacilityCustomFieldValueInput = {
  key: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

/** 付帯サービス予約に適用される割引情報（予約確定前の表示用） */
export type FacilityDiscountFeePolicy = {
  __typename?: "FacilityDiscountFeePolicy";
  /** 割引タイプ（Value: 固定金額, Percentage: 割引率） */
  discountModifierType: FeeModifierType;
  /** 割引値（Percentageの場合は割引率%, Valueの場合は固定割引額・円） */
  discountValue: Scalars["Int"]["output"];
  /** 割引ラベル（例: "奄美大島1sお試し無料宿泊チケット"） */
  label: Scalars["String"]["output"];
};

/** 付帯サービスの利用料金 */
export type FacilityFee = {
  __typename?: "FacilityFee";
  /** 料金の項目 */
  items: Array<FacilityFeeItem>;
  /** 料金の合計 */
  totalAmount: Scalars["Int"]["output"];
};

/** 付帯サービスの利用料金の項目 */
export type FacilityFeeItem = {
  __typename?: "FacilityFeeItem";
  /** 税込金額 */
  amount: Scalars["Int"]["output"];
  /** 項目名 */
  label: Scalars["String"]["output"];
  /** 消費税率 */
  taxRate: Scalars["Float"]["output"];
};

/** 付帯サービスフィールドタイプ */
export const FacilityFieldType = {
  SingleSelect: "SingleSelect",
  Text: "Text",
} as const;

export type FacilityFieldType =
  (typeof FacilityFieldType)[keyof typeof FacilityFieldType];
/** 請求明細ラベルのパーツ */
export type FacilityInvoiceLabelPart = {
  __typename?: "FacilityInvoiceLabelPart";
  /** 予約期間の表記。type が ReservePeriod の時のみ値を持つ */
  format?: Maybe<FacilityInvoiceLabelPeriodFormat>;
  type: FacilityInvoiceLabelPartType;
  /** 固定文言。type が Text の時のみ値を持つ */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** 請求明細ラベルのパーツ入力 */
export type FacilityInvoiceLabelPartInput = {
  /** 予約期間の表記。type が ReservePeriod の時は必須 */
  format?: InputMaybe<FacilityInvoiceLabelPeriodFormat>;
  type: FacilityInvoiceLabelPartType;
  /** 固定文言。type が Text の時は必須 */
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/** 請求明細ラベルのパーツ種別 */
export const FacilityInvoiceLabelPartType = {
  /** 予約期間 */
  ReservePeriod: "ReservePeriod",
  /** 固定文言 */
  Text: "Text",
} as const;

export type FacilityInvoiceLabelPartType =
  (typeof FacilityInvoiceLabelPartType)[keyof typeof FacilityInvoiceLabelPartType];
/** 予約期間パーツの表記 */
export const FacilityInvoiceLabelPeriodFormat = {
  /** 日付のみ（例: 2026/9/6〜9/9） */
  Date: "Date",
  /** 日付と時刻（例: 2026/9/6 10:00〜9/9 10:00） */
  DateTime: "DateTime",
} as const;

export type FacilityInvoiceLabelPeriodFormat =
  (typeof FacilityInvoiceLabelPeriodFormat)[keyof typeof FacilityInvoiceLabelPeriodFormat];
/** 付帯サービス予約 */
export type FacilityReservation = {
  __typename?: "FacilityReservation";
  /** 関連する宿泊予約 */
  accommodationReservation: AccommodationReservation;
  /** キャンセル日時 */
  canceledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 請求額（totalFeeAmount - discountAmount） */
  chargedFeeAmount: Scalars["Decimal"]["output"];
  /** 清掃レポート（設備で isCleaningReportEnabled=true の場合のみ値が入る） */
  cleaningReport?: Maybe<FacilityReservationCleaningReport>;
  /** コントローラ一覧 */
  controllers: Array<FacilityController>;
  /** 予約作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** カスタムフィールド値（Facility.customFieldsで定義されたフィールドへの入力値） */
  customFieldValues: Array<FacilityCustomFieldValue>;
  /** データ連携情報（設備で isDataSyncEnabled=true の場合のみ値が入る） */
  dataSync?: Maybe<FacilityReservationDataSync>;
  /** 割引額 */
  discountAmount: Scalars["Decimal"]["output"];
  /** 割引理由 */
  discountReason?: Maybe<Scalars["String"]["output"]>;
  /** 終了日時 */
  endAt: Scalars["PlainDateTime"]["output"];
  /** 現時点でのキャンセル料（ステータスがReserved以外の場合は0） */
  estimatedCancelFee: Scalars["Int"]["output"];
  /**
   * 清掃で照合するための宿泊者名（AccommodationReservation.guestName と同じ）。付帯サービスは複数拠点に
   * 属しうるので、拠点スコープの主体が他拠点の宿泊予約を経由せずに読めるようにする。
   */
  guestName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** キャンセル可能か（ステータスがReservedかつ予約締切内） */
  isCancelable: Scalars["Boolean"]["output"];
  /** リソース */
  resource: FacilityResource;
  /** リソース表示名（「サイト名 リソース名」形式） */
  resourceLabel: Scalars["String"]["output"];
  /** 開始日時 */
  startAt: Scalars["PlainDateTime"]["output"];
  /** 予約ステータス */
  status: FacilityReservationStatusType;
  /** 利用規約同意日時 */
  termsAgreedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 定価（unitFeeAmount × units） */
  totalFeeAmount: Scalars["Decimal"]["output"];
  /** 1単位あたりの料金（スナップショット） */
  unitFeeAmount: Scalars["Decimal"]["output"];
  /** 予約時点の単位種別 */
  unitType: FacilityUnitType;
  /** 単位数（泊数/時間数/スロット数） */
  units: Scalars["Int"]["output"];
  /** 予約したユーザー */
  user: User;
};

/** 付帯サービス清掃レポートレコード（付帯サービス予約に紐づく清掃状態を管理。将来別システム移行予定） */
export type FacilityReservationCleaningReport = {
  __typename?: "FacilityReservationCleaningReport";
  status: FacilityReservationCleaningStatus;
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** 付帯サービス清掃レポートステータス */
export const FacilityReservationCleaningStatus = {
  Completed: "Completed",
  Pending: "Pending",
} as const;

export type FacilityReservationCleaningStatus =
  (typeof FacilityReservationCleaningStatus)[keyof typeof FacilityReservationCleaningStatus];
/** 付帯サービスデータ連携レコード（付帯サービス予約に紐づくデータ連携状態を管理） */
export type FacilityReservationDataSync = {
  __typename?: "FacilityReservationDataSync";
  status: FacilityReservationDataSyncStatus;
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** 付帯サービスデータ連携ステータス */
export const FacilityReservationDataSyncStatus = {
  Pending: "Pending",
  Synced: "Synced",
} as const;

export type FacilityReservationDataSyncStatus =
  (typeof FacilityReservationDataSyncStatus)[keyof typeof FacilityReservationDataSyncStatus];
/** 付帯サービス予約ステータス */
export const FacilityReservationStatusType = {
  Canceled: "Canceled",
  Reserved: "Reserved",
} as const;

export type FacilityReservationStatusType =
  (typeof FacilityReservationStatusType)[keyof typeof FacilityReservationStatusType];
/** 付帯サービスリソース */
export type FacilityResource = {
  __typename?: "FacilityResource";
  /** このリソースの料金ポリシー一覧 */
  baseFeePolicies: Array<FacilityBaseFeePolicy>;
  /** コントローラ一覧 */
  controllers: Array<FacilityController>;
  /** 請求明細ラベルのパーツ。null なら明細名は「施設名（リソース名）」になる */
  customInvoiceLabel?: Maybe<Array<FacilityInvoiceLabelPart>>;
  /** 付帯サービス */
  facility: Facility;
  id: Scalars["ID"]["output"];
  /** 識別子（ナンバー、施設番号等） */
  identifier: Scalars["String"]["output"];
  /** このリソースで予約可能な開始スロットが1つ以上あるか */
  isReservable: Scalars["Boolean"]["output"];
  /** リソース名 */
  name: Scalars["String"]["output"];
  /** リソースのコントローラ一覧 */
  resourceControllers: Array<InternalFacilityController>;
  /** このリソースのスロット一覧 */
  slotAvailabilities: Array<FacilitySlotAvailability>;
};

/** 付帯サービスリソース */
export type FacilityResourcecontrollersArgs = {
  accommodationReservationId: Scalars["ID"]["input"];
};

/** 付帯サービスリソース */
export type FacilityResourceisReservableArgs = {
  isForce?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** 付帯サービスリソース */
export type FacilityResourceslotAvailabilitiesArgs = {
  isForce?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** 付帯サービスリソースブロック */
export type FacilityResourceBlock = {
  __typename?: "FacilityResourceBlock";
  /** ブロック終了日時 */
  endAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** 理由（Admin時のみ） */
  reason?: Maybe<Scalars["String"]["output"]>;
  /** リソース */
  resource: FacilityResource;
  /** ブロック種別 */
  resourceBlockType: FacilityResourceBlockType;
  /** ブロック開始日時 */
  startAt: Scalars["DateTime"]["output"];
};

/** 付帯サービスリソースブロック種別 */
export const FacilityResourceBlockType = {
  Admin: "Admin",
  User: "User",
} as const;

export type FacilityResourceBlockType =
  (typeof FacilityResourceBlockType)[keyof typeof FacilityResourceBlockType];
/** 付帯サービスコントローラー種別 */
export const FacilityResourceControllerType = {
  CoWorkingSpaceDoorLock: "CoWorkingSpaceDoorLock",
  EvChargerLock: "EvChargerLock",
  OnsenAndSaunaDoorLock: "OnsenAndSaunaDoorLock",
  RentalCycleKeyBox: "RentalCycleKeyBox",
  WashingMachineTracker: "WashingMachineTracker",
} as const;

export type FacilityResourceControllerType =
  (typeof FacilityResourceControllerType)[keyof typeof FacilityResourceControllerType];
/** 付帯サービススロット */
export type FacilitySlot = {
  __typename?: "FacilitySlot";
  /** 終了時刻（時） */
  endHour: Scalars["Int"]["output"];
  /** 終了時刻（分） */
  endMinute: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  /** このスロットが適用されるリソース */
  resource?: Maybe<FacilityResource>;
  /** 開始時刻（時） */
  startHour: Scalars["Int"]["output"];
  /** 開始時刻（分） */
  startMinute: Scalars["Int"]["output"];
};

/** 付帯サービススロット予約可否（予約不可のものも含む、レンジ内全件） */
export type FacilitySlotAvailability = {
  __typename?: "FacilitySlotAvailability";
  /** 所属日（全 unitType 共通。Night / Reservation は貸出候補日、Slot は枠の属する日） */
  date: Scalars["PlainDate"]["output"];
  /** 予約可能かどうか */
  isReservable: Scalars["Boolean"]["output"];
  /** 表示用ラベル（例: "01/15(水)"、"10:00"） */
  label: Scalars["String"]["output"];
  /** スロットID（unitType=Slot のみ。Night / Reservation は null） */
  slotId?: Maybe<Scalars["ID"]["output"]>;
  /** 予約不可の理由（isReservable: false の場合のみ） */
  unavailableReason?: Maybe<FacilitySlotUnavailableReason>;
};

/** 付帯サービススロットが予約不可の理由 */
export const FacilitySlotUnavailableReason = {
  AlreadyReserved: "AlreadyReserved",
  Blocked: "Blocked",
  DeadlinePassed: "DeadlinePassed",
  OutsideOperatingHours: "OutsideOperatingHours",
  Past: "Past",
} as const;

export type FacilitySlotUnavailableReason =
  (typeof FacilitySlotUnavailableReason)[keyof typeof FacilitySlotUnavailableReason];
/** 付帯サービス公開ステータス */
export const FacilityStatusType = {
  Draft: "Draft",
  Preview: "Preview",
  Published: "Published",
} as const;

export type FacilityStatusType =
  (typeof FacilityStatusType)[keyof typeof FacilityStatusType];
/** 付帯サービス種別 */
export const FacilityType = {
  Barbecue: "Barbecue",
  CoWorkingSpace: "CoWorkingSpace",
  EvCharger: "EvCharger",
  OnsenAndSauna: "OnsenAndSauna",
  RentalCar: "RentalCar",
  RentalCycle: "RentalCycle",
  WashingMachine: "WashingMachine",
} as const;

export type FacilityType = (typeof FacilityType)[keyof typeof FacilityType];
/** 付帯サービス予約単位種別 */
export const FacilityUnitType = {
  Night: "Night",
  Reservation: "Reservation",
  Slot: "Slot",
} as const;

export type FacilityUnitType =
  (typeof FacilityUnitType)[keyof typeof FacilityUnitType];
/** 料金修正タイプ */
export const FeeModifierType = {
  /** パーセンテージ */
  Percentage: "Percentage",
  /** 固定金額 */
  Value: "Value",
} as const;

export type FeeModifierType =
  (typeof FeeModifierType)[keyof typeof FeeModifierType];
export const FieldTierPermission = {
  AccommodationsKeysRead: "AccommodationsKeysRead",
  /** 利用ブロックの名前とメモ。社員名・取引先名・社内のメモが入りうるので、外部パートナーには伏せる（期間と分類は見える）。 */
  AvailabilityBlocksCommercialRead: "AvailabilityBlocksCommercialRead",
  CoOwnersRestrictedRead: "CoOwnersRestrictedRead",
  ReservationsKeysRead: "ReservationsKeysRead",
  StayTicketsPiiRead: "StayTicketsPiiRead",
  UsersCommercialRead: "UsersCommercialRead",
  UsersPiiRead: "UsersPiiRead",
  UsersRestrictedRead: "UsersRestrictedRead",
} as const;

export type FieldTierPermission =
  (typeof FieldTierPermission)[keyof typeof FieldTierPermission];
export const FileCopyTarget = {
  architectureType: "architectureType",
  area: "area",
  banner: "banner",
  ownerApplication: "ownerApplication",
  ownerPlan: "ownerPlan",
  userPicture: "userPicture",
} as const;

export type FileCopyTarget =
  (typeof FileCopyTarget)[keyof typeof FileCopyTarget];
export type FileUploadPolicyPayload =
  | CreateFileUploadPolicyError
  | CreateFileUploadPolicySuccess;

/** アカウント連携完了エラー */
export type FinalizeAccountLinkError = {
  __typename?: "FinalizeAccountLinkError";
  case: FinalizeAccountLinkErrorCase;
};

/** アカウント連携完了エラーケース */
export const FinalizeAccountLinkErrorCase = {
  /** 再認証したユーザーが期待するIDと一致しない */
  IdentityMismatch: "IdentityMismatch",
  /** intent tokenが無効または期限切れ */
  InvalidIntentToken: "InvalidIntentToken",
  /** Auth0とのトークン交換に失敗 */
  TokenExchangeFailed: "TokenExchangeFailed",
} as const;

export type FinalizeAccountLinkErrorCase =
  (typeof FinalizeAccountLinkErrorCase)[keyof typeof FinalizeAccountLinkErrorCase];
/** アカウント連携の完了に必要な入力 */
export type FinalizeAccountLinkInput = {
  /** Auth0から返されたauthorization code */
  code: Scalars["String"]["input"];
  /** ラウンドトリップ用のstate (intent token) */
  state: Scalars["String"]["input"];
};

/** アカウント連携完了結果 */
export type FinalizeAccountLinkPayload =
  | FinalizeAccountLinkError
  | FinalizeAccountLinkSuccess;

/** アカウント連携完了成功 */
export type FinalizeAccountLinkSuccess = {
  __typename?: "FinalizeAccountLinkSuccess";
  /** Auth0の /continue エンドポイントへのリダイレクトURL（link_token付き） */
  continueUrl: Scalars["String"]["output"];
};

export const FinancialAssetsBracketType = {
  Above300Mil: "Above300Mil",
  Below5Mil: "Below5Mil",
  DoNotKnowWillNotSay: "DoNotKnowWillNotSay",
  From5MilTo10Mil: "From5MilTo10Mil",
  From10MilTo30Mil: "From10MilTo30Mil",
  From30MilTo50Mil: "From30MilTo50Mil",
  From50MilTo100Mil: "From50MilTo100Mil",
  From100MilTo300Mil: "From100MilTo300Mil",
} as const;

export type FinancialAssetsBracketType =
  (typeof FinancialAssetsBracketType)[keyof typeof FinancialAssetsBracketType];
export type FullOwnerPlanAccommodationReservationProvider = {
  __typename?: "FullOwnerPlanAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  userOwnershipId: Scalars["ID"]["output"];
};

export const GenderType = {
  Female: "Female",
  Male: "Male",
  NoAnswer: "NoAnswer",
} as const;

export type GenderType = (typeof GenderType)[keyof typeof GenderType];
export type GenerateCheckInQrCodeError = {
  __typename?: "GenerateCheckInQrCodeError";
  case: GenerateCheckInQrCodeErrorCase;
};

export const GenerateCheckInQrCodeErrorCase = {
  /** このサイトはQR認証を必要としない */
  QrCodeNotRequired: "QrCodeNotRequired",
  /** 予約が見つからない */
  ReservationNotFound: "ReservationNotFound",
  /** 予約の所有者でない */
  Unauthorized: "Unauthorized",
} as const;

export type GenerateCheckInQrCodeErrorCase =
  (typeof GenerateCheckInQrCodeErrorCase)[keyof typeof GenerateCheckInQrCodeErrorCase];
export type GenerateCheckInQrCodeInput = {
  /** 対象の予約ID */
  accommodationReservationId: Scalars["ID"]["input"];
};

export type GenerateCheckInQrCodePayload =
  | GenerateCheckInQrCodeError
  | GenerateCheckInQrCodeSuccess;

export type GenerateCheckInQrCodeSuccess = {
  __typename?: "GenerateCheckInQrCodeSuccess";
  /** 生成されたQRコード */
  checkInQrCode: CheckInQrCode;
};

/** 位置情報 */
export type GeoLocation = {
  __typename?: "GeoLocation";
  latitude: Scalars["Float"]["output"];
  longitude: Scalars["Float"]["output"];
};

export type GeoLocationInput = {
  latitude: Scalars["Float"]["input"];
  longitude: Scalars["Float"]["input"];
};

/** お客様向けキー適用のトリガー種別。 */
export const GuestAccessKeyTrigger = {
  CancelReserve: "CancelReserve",
  ChangeReserve: "ChangeReserve",
  CreateReserve: "CreateReserve",
} as const;

export type GuestAccessKeyTrigger =
  (typeof GuestAccessKeyTrigger)[keyof typeof GuestAccessKeyTrigger];
/** 予約時に料金計算へ流す人数情報 */
export type GuestCountsInput = {
  /** 大人の人数 */
  numberOfAdults: Scalars["Int"]["input"];
  /** 乳幼児（0〜5歳）の人数 */
  numberOfInfants: Scalars["Int"]["input"];
  /** 子供（6〜12歳）の人数 */
  numberOfKids: Scalars["Int"]["input"];
};

/** ハイシーズン期間 */
export type HighSeasonPeriod = {
  __typename?: "HighSeasonPeriod";
  /** 終了日 */
  endDay: Scalars["Int"]["output"];
  /** 終了月 */
  endMonth: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  /** 有効かどうか */
  isActive: Scalars["Boolean"]["output"];
  /** 表示用ラベル（"年末年始 2026" など） */
  label: Scalars["String"]["output"];
  /** 開始日 */
  startDay: Scalars["Int"]["output"];
  /** 開始月 */
  startMonth: Scalars["Int"]["output"];
  /** ハイシーズン種別 */
  type: HighSeasonType;
  /** 適用年（nullの場合は毎年適用） */
  year?: Maybe<Scalars["Int"]["output"]>;
};

/** ハイシーズン種別 */
export const HighSeasonType = {
  /** ゴールデンウィーク */
  GoldenWeek: "GoldenWeek",
  /** 年末年始 */
  NewYear: "NewYear",
  /** お盆 */
  Obon: "Obon",
  /** シルバーウィーク */
  SilverWeek: "SilverWeek",
} as const;

export type HighSeasonType =
  (typeof HighSeasonType)[keyof typeof HighSeasonType];
export type HubSpotSyncContactError = {
  __typename?: "HubSpotSyncContactError";
  case: HubSpotSyncContactErrorCase;
};

export const HubSpotSyncContactErrorCase = {
  UserNotFound: "UserNotFound",
} as const;

export type HubSpotSyncContactErrorCase =
  (typeof HubSpotSyncContactErrorCase)[keyof typeof HubSpotSyncContactErrorCase];
export type HubSpotSyncContactResult = HubSpotSyncContactError | Success;

export type HubSpotSyncDealError = {
  __typename?: "HubSpotSyncDealError";
  case: HubSpotSyncDealErrorCase;
};

export const HubSpotSyncDealErrorCase = {
  ApplicationNotFound: "ApplicationNotFound",
  DealNotFound: "DealNotFound",
} as const;

export type HubSpotSyncDealErrorCase =
  (typeof HubSpotSyncDealErrorCase)[keyof typeof HubSpotSyncDealErrorCase];
export type HubSpotSyncDealResult = HubSpotSyncDealError | Success;

export const IdentificationDocumentType = {
  BasicResidentRegisterCard: "BasicResidentRegisterCard",
  DriverLicense: "DriverLicense",
  MyNumberCard: "MyNumberCard",
  Passport: "Passport",
  ResidenceCard: "ResidenceCard",
  Undetermined: "Undetermined",
} as const;

export type IdentificationDocumentType =
  (typeof IdentificationDocumentType)[keyof typeof IdentificationDocumentType];
/** アイデンティティプロバイダー */
export const IdentityProvider = {
  /** Apple ID */
  Apple: "Apple",
  /** メールアドレス＋パスワード */
  EmailPassword: "EmailPassword",
  /** Googleアカウント */
  Google: "Google",
} as const;

export type IdentityProvider =
  (typeof IdentityProvider)[keyof typeof IdentityProvider];
/**
 * 本人確認情報
 * Co-Owners は申込、Full-Owner はオーナープランのどちらか一方に紐づく
 */
export type IdentityVerification = {
  __typename?: "IdentityVerification";
  id: Scalars["ID"]["output"];
  method: IdentityVerificationMethod;
  note: Scalars["String"]["output"];
  /** Full-Owner 契約の本人確認の場合、対象のオーナープラン */
  ownerPlan?: Maybe<OwnerPlan>;
  result?: Maybe<IdentityVerificationResult>;
  status: IdentityVerificationStatus;
  /** 書類提出専用 WEB ページ URL */
  submissionPageUrl?: Maybe<Scalars["String"]["output"]>;
  /** 書類提出専用 WEB ページ URL の有効期限 */
  submissionPageUrlExpiresAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** TRUSTDOCK オペレーション画面の詳細ページ URL */
  trustdockOperationPageUrl?: Maybe<Scalars["String"]["output"]>;
  /** TRUSTDOCK 側で発行される身元確認 ID */
  trustdockVerificationId?: Maybe<Scalars["String"]["output"]>;
};

/** 本人確認の方法 */
export const IdentityVerificationMethod = {
  /** IC チップ読み取り + セルフィー、犯収法ヘ方式 */
  IcChipAndSelfie: "IcChipAndSelfie",
  /** 対面での写真付き本人確認書類の提示、犯収法イ方式 */
  InPersonPhotoId: "InPersonPhotoId",
  /** 本人限定受取郵便、犯収法ヲ方式 */
  RestrictedDeliveryMail: "RestrictedDeliveryMail",
} as const;

export type IdentityVerificationMethod =
  (typeof IdentityVerificationMethod)[keyof typeof IdentityVerificationMethod];
/** 本人確認の結果 */
export const IdentityVerificationResult = {
  Approved: "Approved",
  Denied: "Denied",
} as const;

export type IdentityVerificationResult =
  (typeof IdentityVerificationResult)[keyof typeof IdentityVerificationResult];
/** 本人確認の進行状況 */
export const IdentityVerificationStatus = {
  Accepted: "Accepted",
  DocumentSubmitted: "DocumentSubmitted",
  InProgress: "InProgress",
  NotStarted: "NotStarted",
  PlansSelected: "PlansSelected",
  Verified: "Verified",
} as const;

export type IdentityVerificationStatus =
  (typeof IdentityVerificationStatus)[keyof typeof IdentityVerificationStatus];
export const IncomeBracketType = {
  Above30Mil: "Above30Mil",
  Below5Mil: "Below5Mil",
  DoNotKnowWillNotSay: "DoNotKnowWillNotSay",
  From5MilTo8Mil: "From5MilTo8Mil",
  From8MilTo10Mil: "From8MilTo10Mil",
  From10MilTo15Mil: "From10MilTo15Mil",
  From15MilTo20Mil: "From15MilTo20Mil",
  From20MilTo30Mil: "From20MilTo30Mil",
} as const;

export type IncomeBracketType =
  (typeof IncomeBracketType)[keyof typeof IncomeBracketType];
/** アカウント連携開始エラー */
export type InitiateAccountLinkError = {
  __typename?: "InitiateAccountLinkError";
  case: InitiateAccountLinkErrorCase;
};

/** アカウント連携開始エラーケース */
export const InitiateAccountLinkErrorCase = {
  /** セッショントークンが無効または期限切れ */
  InvalidSessionToken: "InvalidSessionToken",
} as const;

export type InitiateAccountLinkErrorCase =
  (typeof InitiateAccountLinkErrorCase)[keyof typeof InitiateAccountLinkErrorCase];
/** アカウント連携の開始に必要な入力 */
export type InitiateAccountLinkInput = {
  /** プラットフォーム */
  platform: AccountLinkPlatform;
  /** Auth0から受け取ったセッショントークン */
  sessionToken: Scalars["String"]["input"];
  /** Auth0のOIDC state パラメータ */
  state: Scalars["String"]["input"];
};

/** アカウント連携開始結果 */
export type InitiateAccountLinkPayload =
  | InitiateAccountLinkError
  | InitiateAccountLinkSuccess;

/** アカウント連携開始成功 */
export type InitiateAccountLinkSuccess = {
  __typename?: "InitiateAccountLinkSuccess";
  /** ユーザーをリダイレクトすべきAuth0のOAuth認可URL */
  redirectUrl: Scalars["String"]["output"];
};

/** アイデンティティ追加開始エラー */
export type InitiateAddIdentityError = {
  __typename?: "InitiateAddIdentityError";
  case: InitiateAddIdentityErrorCase;
};

/** アイデンティティ追加開始エラーケース */
export const InitiateAddIdentityErrorCase = {
  /** 既に同じプロバイダーが連携済み */
  AlreadyLinked: "AlreadyLinked",
  /** 認証されていない */
  Unauthorized: "Unauthorized",
} as const;

export type InitiateAddIdentityErrorCase =
  (typeof InitiateAddIdentityErrorCase)[keyof typeof InitiateAddIdentityErrorCase];
/** アイデンティティ追加開始の入力 */
export type InitiateAddIdentityInput = {
  /** プラットフォーム */
  platform: AccountLinkPlatform;
  /** 追加するプロバイダー */
  provider: IdentityProvider;
};

/** アイデンティティ追加開始結果 */
export type InitiateAddIdentityPayload =
  | InitiateAddIdentityError
  | InitiateAddIdentitySuccess;

/** アイデンティティ追加開始成功 */
export type InitiateAddIdentitySuccess = {
  __typename?: "InitiateAddIdentitySuccess";
  /** ユーザーをリダイレクトすべきAuth0の再認証URL */
  redirectUrl: Scalars["String"]["output"];
};

/** 清掃ボードの 1 行（部屋 × 確認日） */
export type Inspection = {
  __typename?: "Inspection";
  /** 宿泊施設 */
  accommodation: Accommodation;
  /** 確認日 */
  inspectionDate: Scalars["PlainDate"]["output"];
  /** 当日の予約 */
  reservation?: Maybe<AccommodationReservation>;
  /** 清掃ステータス。報告が無ければ NotStarted */
  status: InspectionStatusType;
};

/** 確認報告。1 予約 1 件で、有料備品の報告とハウスルール違反の報告が同じ行に載る */
export type InspectionReport = {
  __typename?: "InspectionReport";
  /** 有料備品報告の締め。締め済みは請求が確定している */
  closedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** JTAS 側の報告ID */
  externalViolationReportId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 報告の対象になった滞在。確認日は lastNight の翌日 */
  reservation: AccommodationReservation;
  /** 有料備品報告の写真 */
  supplyItemMedia: Array<UploadedFile>;
  /** 報告された有料備品 */
  supplyItems: Array<InspectionSupplyItem>;
  updatedAt: Scalars["ZonedDateTime"]["output"];
  /** 違反の発生事象の詳細 */
  violationDescription?: Maybe<Scalars["String"]["output"]>;
  /** ハウスルール違反への社内対応。まだ着手していない報告には行が無いので null になる */
  violationHandling?: Maybe<InspectionViolationHandling>;
  /** ハウスルール違反の項目。JTAS 側マスタのスナップショットで、報告のたびに全置換される */
  violationItems: Array<InspectionViolationItem>;
  /** 違反の証跡 */
  violationMedia: Array<UploadedFile>;
};

/** 確認報告の種別 */
export const InspectionReportType = {
  Supply: "Supply",
  Violation: "Violation",
} as const;

export type InspectionReportType =
  (typeof InspectionReportType)[keyof typeof InspectionReportType];
export const InspectionStatusType = {
  Inspected: "Inspected",
  InspectionRequired: "InspectionRequired",
  NotStarted: "NotStarted",
  Started: "Started",
} as const;

export type InspectionStatusType =
  (typeof InspectionStatusType)[keyof typeof InspectionStatusType];
export type InspectionSupplyItem = {
  __typename?: "InspectionSupplyItem";
  id: Scalars["ID"]["output"];
  /** 備品マスタの表示名（スタッフ用） */
  name: Scalars["String"]["output"];
  quantity: Scalars["Int"]["output"];
};

/** ハウスルール違反への社内対応の記録 */
export type InspectionViolationHandling = {
  __typename?: "InspectionViolationHandling";
  id: Scalars["ID"]["output"];
  severity: InspectionViolationSeverity;
  severityAssessedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  severityAssessedByUser?: Maybe<User>;
  status: InspectionViolationHandlingStatus;
  updatedAt: Scalars["ZonedDateTime"]["output"];
  warningActionAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  warningActionByUser?: Maybe<User>;
  warningActionNote?: Maybe<Scalars["String"]["output"]>;
};

/** ハウスルール違反への対応状況 */
export const InspectionViolationHandlingStatus = {
  Assessed: "Assessed",
  Handled: "Handled",
  Pending: "Pending",
} as const;

export type InspectionViolationHandlingStatus =
  (typeof InspectionViolationHandlingStatus)[keyof typeof InspectionViolationHandlingStatus];
export type InspectionViolationItem = {
  __typename?: "InspectionViolationItem";
  id: Scalars["ID"]["output"];
  /** JTAS 側マスタの識別子 */
  typeId: Scalars["Int"]["output"];
  typeName: Scalars["String"]["output"];
};

/** 違反レベル */
export const InspectionViolationSeverity = {
  High: "High",
  Low: "Low",
  Medium: "Medium",
  NotAssessed: "NotAssessed",
} as const;

export type InspectionViolationSeverity =
  (typeof InspectionViolationSeverity)[keyof typeof InspectionViolationSeverity];
export type InternalAccommodationEquipmentError = {
  __typename?: "InternalAccommodationEquipmentError";
  case: InternalAccommodationEquipmentErrorCase;
};

export const InternalAccommodationEquipmentErrorCase = {
  /** 指定した宿泊施設が見つからない */
  AccommodationNotFound: "AccommodationNotFound",
  /** attribute が機器種別と一致しない */
  AttributeTypeMismatch: "AttributeTypeMismatch",
  /** 同じ宿泊施設に同じ種別の機器が既に存在する */
  DuplicateEquipmentType: "DuplicateEquipmentType",
  /** 指定した機器が見つからない */
  EquipmentNotFound: "EquipmentNotFound",
  /** 指定した deviceId が sanu_edge_devices に登録されていない */
  SanuEdgeDeviceNotFound: "SanuEdgeDeviceNotFound",
} as const;

export type InternalAccommodationEquipmentErrorCase =
  (typeof InternalAccommodationEquipmentErrorCase)[keyof typeof InternalAccommodationEquipmentErrorCase];
export type InternalAddLocalTaxPolicyError = {
  __typename?: "InternalAddLocalTaxPolicyError";
  case: InternalAddLocalTaxPolicyErrorCase;
};

export const InternalAddLocalTaxPolicyErrorCase = {
  /** 適用先の拠点、またはいずれかの部屋に適用済みのポリシーと有効期間が重なる */
  OverlappingEffectivePeriod: "OverlappingEffectivePeriod",
} as const;

export type InternalAddLocalTaxPolicyErrorCase =
  (typeof InternalAddLocalTaxPolicyErrorCase)[keyof typeof InternalAddLocalTaxPolicyErrorCase];
export type InternalAddLocalTaxPolicyPayload =
  | InternalAddLocalTaxPolicyError
  | LocalTaxPolicy;

/** 地方税ポリシーの適用先。いずれか 1 つだけを指定する */
export type InternalAddLocalTaxPolicyTargetInput =
  /** 入湯税として適用する部屋 */
  | {
      accommodationIds: Array<Scalars["ID"]["input"]>;
      siteId?: never;
    } /** 宿泊税として適用する拠点 */
  | { accommodationIds?: never; siteId: Scalars["ID"]["input"] };

export type InternalAdjustOwnerStayCreditError = {
  __typename?: "InternalAdjustOwnerStayCreditError";
  case: InternalAdjustOwnerStayCreditErrorCase;
};

export const InternalAdjustOwnerStayCreditErrorCase = {
  InsufficientBalance: "InsufficientBalance",
  InvalidAmount: "InvalidAmount",
  OwnershipNotFound: "OwnershipNotFound",
} as const;

export type InternalAdjustOwnerStayCreditErrorCase =
  (typeof InternalAdjustOwnerStayCreditErrorCase)[keyof typeof InternalAdjustOwnerStayCreditErrorCase];
export type InternalAdjustOwnerStayCreditPayload =
  | InternalAdjustOwnerStayCreditError
  | Success;

export type InternalAdjustStaffCreditsError = {
  __typename?: "InternalAdjustStaffCreditsError";
  case: InternalAdjustStaffCreditsErrorCase;
};

export const InternalAdjustStaffCreditsErrorCase = {
  /** 契約が見つからない */
  ContractNotFound: "ContractNotFound",
  /** 残高不足（減算が残高を超える） */
  InsufficientBalance: "InsufficientBalance",
  /** 入力値が無効（泊数・ピーク日がともに0） */
  InvalidInput: "InvalidInput",
  /** 権限がない */
  NotAuthorized: "NotAuthorized",
} as const;

export type InternalAdjustStaffCreditsErrorCase =
  (typeof InternalAdjustStaffCreditsErrorCase)[keyof typeof InternalAdjustStaffCreditsErrorCase];
export type InternalAdjustStaffCreditsResult =
  | InternalAdjustStaffCreditsError
  | InternalAdjustStaffCreditsSuccess;

export type InternalAdjustStaffCreditsSuccess = {
  __typename?: "InternalAdjustStaffCreditsSuccess";
  contract: StaffContract;
};

/**
 * ロール割り当ての対象ユーザーの氏名とメール。User と違い他の情報へ辿る field を持たないので、
 * 拠点スコープの主体にも返せる
 */
export type InternalAdminRoleAssignee = {
  __typename?: "InternalAdminRoleAssignee";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type InternalAppendS2oPointsToCoOwnersApplicationError = {
  __typename?: "InternalAppendS2oPointsToCoOwnersApplicationError";
  case: InternalAppendS2oPointsToCoOwnersApplicationErrorCase;
};

export const InternalAppendS2oPointsToCoOwnersApplicationErrorCase = {
  /** CoOwnersApplicationが無効（キャンセル済みなど） */
  CoOwnersApplicationInvalid: "CoOwnersApplicationInvalid",
  /** CoOwnersApplicationが見つからない */
  CoOwnersApplicationNotFound: "CoOwnersApplicationNotFound",
  /** 有効な Co-Owners充当特典（旧S2Oポイント）残高が不足している */
  InsufficientS2oPointBalance: "InsufficientS2oPointBalance",
  /** 金額が不正（0以下） */
  InvalidAmount: "InvalidAmount",
} as const;

export type InternalAppendS2oPointsToCoOwnersApplicationErrorCase =
  (typeof InternalAppendS2oPointsToCoOwnersApplicationErrorCase)[keyof typeof InternalAppendS2oPointsToCoOwnersApplicationErrorCase];
export type InternalAppendS2oPointsToCoOwnersApplicationPayload =
  | InternalAppendS2oPointsToCoOwnersApplicationError
  | Success;

export type InternalApplyGuestAccessKeyError = {
  __typename?: "InternalApplyGuestAccessKeyError";
  message: Scalars["String"]["output"];
};

export type InternalApplyGuestAccessKeyPayload =
  | InternalApplyGuestAccessKeyError
  | Success;

export type InternalApplyStaffAccessKeyError = {
  __typename?: "InternalApplyStaffAccessKeyError";
  message: Scalars["String"]["output"];
};

export type InternalApplyStaffAccessKeyPayload =
  | InternalApplyStaffAccessKeyError
  | Success;

/** 建築コンテンツ系 mutation の共通エラー */
export type InternalArchitectureContentError = {
  __typename?: "InternalArchitectureContentError";
  case: InternalArchitectureContentErrorCase;
  /** 管理画面にそのまま表示できる説明 */
  message: Scalars["String"]["output"];
};

export const InternalArchitectureContentErrorCase = {
  /** 新規作成時は建築家が必須（公開スキーマの architect が non-null のため） */
  ArchitectRequired: "ArchitectRequired",
  ArchitectureTypeNotFound: "ArchitectureTypeNotFound",
  /** 建築タイプにコンテンツ行が無い */
  ContentNotFound: "ContentNotFound",
  /** 他から参照中で削除できない（message に参照元を含む） */
  InUse: "InUse",
  /** S3 の rawUrl 形式でない */
  InvalidImage: "InvalidImage",
  /** http(s) の絶対 URL でない */
  InvalidUrl: "InvalidUrl",
  /** 名前が空（slug を決められない） */
  NameRequired: "NameRequired",
  /** id で指定した関連レコードが存在しない（message に id を含む） */
  ResourceNotFound: "ResourceNotFound",
  /** 新規作成時は並び順が必須 */
  SortRequired: "SortRequired",
} as const;

export type InternalArchitectureContentErrorCase =
  (typeof InternalArchitectureContentErrorCase)[keyof typeof InternalArchitectureContentErrorCase];
/**
 * 建築コンテンツ画像の用途。S3 のキーは
 * ArchitectureType なら `architecture-contents/<建築 slug>/`、それ以外は `architecture-contents/shared/<用途>/` 配下になる
 */
export const InternalArchitectureContentImageKind = {
  /** 建築家の顔写真（shared/architects） */
  Architect: "Architect",
  /** 建築タイプに紐づく画像（サムネイル・カルーセル・間取り図）。architectureTypeId が必須 */
  ArchitectureType: "ArchitectureType",
  /** 基本の設備のアイコン（shared/basic-amenity-icons） */
  BasicAmenityIcon: "BasicAmenityIcon",
  /** 特徴ページの画像（shared/features） */
  Feature: "Feature",
  /** 特徴ページの利用ルール画像（shared/feature-usage-rules） */
  FeatureUsageRule: "FeatureUsageRule",
  /** バリエーション・オプションの画像（shared/variants） */
  Variant: "Variant",
} as const;

export type InternalArchitectureContentImageKind =
  (typeof InternalArchitectureContentImageKind)[keyof typeof InternalArchitectureContentImageKind];
/**
 * 管理画面用のエリア型。public `Area` には載せたくない field（多言語名など）を含む。
 * public schema からは `localizedName` が露出しないようにここに集約する。
 */
export type InternalArea = {
  __typename?: "InternalArea";
  /** エリアコンテンツ */
  content: AreaContent;
  /** おすすめスポット（未掲載・掲載期間外も含む全件）。公開ページ用は `content.guideSpots`。 */
  guideSpots: Array<AreaGuideSpot>;
  id: Scalars["ID"]["output"];
  /** 多言語化されたエリア名。admin の編集 UI で各 locale の値を取得するために使用する。 */
  localizedName: InternalLocalizedString;
  /** エリア名（canonical）。admin 表示用なので caller.locale による localize はしない。 */
  name: Scalars["String"]["output"];
  /** エリアに含まれる拠点の一覧（admin 用 InternalSite） */
  sites: Array<InternalSite>;
  slug: Scalars["String"]["output"];
  /** 並び順 */
  sort: Scalars["Int"]["output"];
};

export type InternalAssignAccessCodeToAccommodationReservationError = {
  __typename?: "InternalAssignAccessCodeToAccommodationReservationError";
  internalCode: Scalars["String"]["output"];
};

export type InternalAssignAccessCodeToAccommodationReservationPayload =
  | AccommodationReservation
  | InternalAssignAccessCodeToAccommodationReservationError;

export type InternalAssignAdminRoleError = {
  __typename?: "InternalAssignAdminRoleError";
  code: InternalAssignAdminRoleErrorCode;
  message: Scalars["String"]["output"];
};

export const InternalAssignAdminRoleErrorCode = {
  AlreadyAssigned: "AlreadyAssigned",
  ExpiresAtNotInFuture: "ExpiresAtNotInFuture",
  /** 付与先が userId と email のどちらか一方だけで指定されていない（両方無いか、両方ある） */
  InvalidAssignee: "InvalidAssignee",
  /** 呼び出し元が付与できないロール（internalGrantableAdminRoles に無いもの） */
  RoleNotGrantable: "RoleNotGrantable",
  ScopeNotAllowed: "ScopeNotAllowed",
  ScopeRequired: "ScopeRequired",
  /** 自分自身への付与 */
  SelfAssignment: "SelfAssignment",
  SiteNotFound: "SiteNotFound",
  /** 呼び出し元の付与権が及ばない拠点（PartnerSiteManager が自分の拠点以外に付けようとした） */
  SiteNotGrantable: "SiteNotGrantable",
  UserNotFound: "UserNotFound",
} as const;

export type InternalAssignAdminRoleErrorCode =
  (typeof InternalAssignAdminRoleErrorCode)[keyof typeof InternalAssignAdminRoleErrorCode];
export type InternalAssignAdminRoleInput = {
  /**
   * 付与先のメールアドレス。ユーザー検索（UsersRead）を持たない PartnerSiteManager 向けで、userId とどちらか一方だけを指定する（空文字や空白だけなら指定なしとみなす）。
   * 前後の空白を除き大文字小文字を区別しない完全一致で退会していないユーザーに解決し、該当が無ければ UserNotFound
   */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** 未来の時刻。省略時は無期限。 */
  expiresAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  role: AdminRole;
  /** scope: Site のロールでは必須。将来の軸 (facilityTypeSlug 等) はここに optional で足す。 */
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 付与先の User.id。email とどちらか一方だけを指定する（両方無いか両方あると InvalidAssignee。空文字や空白だけの email は指定なしとみなす） */
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type InternalAssignAdminRolePayload =
  | AdminRoleAssignment
  | InternalAssignAdminRoleError;

/** Auth0ユーザーのアイデンティティ */
export type InternalAuth0Identity = {
  __typename?: "InternalAuth0Identity";
  /** コネクション名 */
  connection: Scalars["String"]["output"];
  /** ソーシャルプロバイダーかどうか */
  isSocial: Scalars["Boolean"]["output"];
  /** profileDataのメールアドレス（リンク済みアイデンティティの場合） */
  profileEmail?: Maybe<Scalars["String"]["output"]>;
  /** profileDataのメール確認済みフラグ */
  profileEmailVerified?: Maybe<Scalars["Boolean"]["output"]>;
  /** プロバイダー（auth0, google-oauth2, apple） */
  provider: Scalars["String"]["output"];
  /** プロバイダー側ユーザーID */
  userId: Scalars["String"]["output"];
};

/** Auth0 Management APIから取得したユーザー */
export type InternalAuth0User = {
  __typename?: "InternalAuth0User";
  /** メールアドレス */
  email?: Maybe<Scalars["String"]["output"]>;
  /** メール確認済みかどうか */
  emailVerified: Scalars["Boolean"]["output"];
  /** アイデンティティ一覧 */
  identities: Array<InternalAuth0Identity>;
  /** Auth0ユーザーID（例: auth0|xxx, google-oauth2|xxx） */
  userId: Scalars["String"]["output"];
};

/** スタッフプラン登録可能なターム */
export type InternalAvailableStaffSemester = {
  __typename?: "InternalAvailableStaffSemester";
  label: Scalars["String"]["output"];
  semester: StaffSemester;
  year: Scalars["Int"]["output"];
};

/** internalBeds24SyncFuturePrices の実行結果。 */
export type InternalBeds24SyncFuturePricesResult = {
  __typename?: "InternalBeds24SyncFuturePricesResult";
  dryRun: Scalars["Boolean"]["output"];
  processedNightCount: Scalars["Int"]["output"];
  skippedRoomTypes: Array<InternalBeds24SyncFuturePricesSkip>;
  targets: Array<InternalBeds24SyncFuturePricesTarget>;
};

export type InternalBeds24SyncFuturePricesSkip = {
  __typename?: "InternalBeds24SyncFuturePricesSkip";
  reason: Scalars["String"]["output"];
  roomType: RoomType;
};

export type InternalBeds24SyncFuturePricesTarget = {
  __typename?: "InternalBeds24SyncFuturePricesTarget";
  blackoutRangeCount: Scalars["Int"]["output"];
  priceRangeCount: Scalars["Int"]["output"];
  roomType: RoomType;
};

/** 予約ブロック一括作成の失敗情報 */
export type InternalBulkCreateAccommodationAvailabilityBlockFailure = {
  __typename?: "InternalBulkCreateAccommodationAvailabilityBlockFailure";
  /** 失敗した入力内容 */
  input: InternalBulkCreateAccommodationAvailabilityBlockFailureInput;
  /** エラー理由 */
  reason: Scalars["String"]["output"];
};

/** CreateAccommodationAvailabilityBlockInputと同じ構造（output type版） */
export type InternalBulkCreateAccommodationAvailabilityBlockFailureInput = {
  __typename?: "InternalBulkCreateAccommodationAvailabilityBlockFailureInput";
  /** 部屋ID（nullの場合は全部屋対象） */
  accommodationId?: Maybe<Scalars["ID"]["output"]>;
  /** 開始日 */
  beginNight: Scalars["PlainDate"]["output"];
  /** 種別 */
  category: AccommodationAvailabilityBlockCategory;
  /** 終了日 */
  endNight: Scalars["PlainDate"]["output"];
  /** 一時的なブロックフラグ */
  isTentative: Scalars["Boolean"]["output"];
  /** ブロック名 */
  name: Scalars["String"]["output"];
  /** メモ欄 */
  note?: Maybe<Scalars["String"]["output"]>;
  /** 拠点ID */
  siteId: Scalars["ID"]["output"];
  /** グループID */
  staffGroupId?: Maybe<Scalars["ID"]["output"]>;
};

/** 予約ブロック一括作成の結果 */
export type InternalBulkCreateAccommodationAvailabilityBlocksPayload = {
  __typename?: "InternalBulkCreateAccommodationAvailabilityBlocksPayload";
  /** 作成に失敗した入力とエラー理由 */
  failed: Array<InternalBulkCreateAccommodationAvailabilityBlockFailure>;
  /** 作成に成功した予約ブロック */
  success: Array<AccommodationAvailabilityBlock>;
};

export type InternalBulkCreateOrganizationYearlyContractInvoicesError = {
  __typename?: "InternalBulkCreateOrganizationYearlyContractInvoicesError";
  case: InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase;
  /** 作成に失敗するまでに作成できていた件数 */
  createdCount: Scalars["Int"]["output"];
  /**
   * 作成後に取り消せず Stripe に残った請求書のID。
   * 運用者が手作業で消す必要があるため、maskedErrorsで潰れない payload で返す。
   */
  orphanedInvoiceIds: Array<Scalars["String"]["output"]>;
};

export const InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase = {
  /** カード自動決済の請求書を作ろうとしたが、カードが登録されていない */
  CardIsNotRegistered: "CardIsNotRegistered",
  /** 無効化済みの契約に対して請求書を作成しようとした */
  ContractIsInvalidated: "ContractIsInvalidated",
  /** 作成の途中でStripeへの作成に失敗した */
  CreationFailed: "CreationFailed",
  /** Stripe顧客にメールアドレスが登録されていない */
  CustomerEmailRequired: "CustomerEmailRequired",
  /** 銀行振込の支払期限が過去日になる（Stripeが受け付けない） */
  DueDateIsInPast: "DueDateIsInPast",
  /** 公開予定日が指定できる範囲（契約開始月の前月1日〜契約開始月末）の外 */
  ScheduledOpenDateOutOfRange: "ScheduledOpenDateOutOfRange",
} as const;

export type InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase =
  (typeof InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase)[keyof typeof InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase];
export type InternalBulkCreateOrganizationYearlyContractInvoicesPayload =
  | InternalBulkCreateOrganizationYearlyContractInvoicesError
  | InternalBulkCreateOrganizationYearlyContractInvoicesSuccess;

export type InternalBulkCreateOrganizationYearlyContractInvoicesSuccess = {
  __typename?: "InternalBulkCreateOrganizationYearlyContractInvoicesSuccess";
  /** 作成された請求書のStripe Invoice IDs */
  invoiceIds: Array<Scalars["String"]["output"]>;
};

/** 予約ブロック一括解除の失敗情報 */
export type InternalBulkDeleteAccommodationAvailabilityBlockFailure = {
  __typename?: "InternalBulkDeleteAccommodationAvailabilityBlockFailure";
  /** 失敗した予約ブロックのID */
  id: Scalars["ID"]["output"];
  /** エラー理由 */
  reason: Scalars["String"]["output"];
};

/** 予約ブロック一括解除の結果 */
export type InternalBulkDeleteAccommodationAvailabilityBlocksPayload = {
  __typename?: "InternalBulkDeleteAccommodationAvailabilityBlocksPayload";
  /** 解除に失敗した予約ブロックのIDとエラー理由 */
  failed: Array<InternalBulkDeleteAccommodationAvailabilityBlockFailure>;
  /**
   * 解除に成功した予約ブロックのID。解除済みオブジェクトを返すとクライアントのキャッシュに
   * 復活してしまうため、表示に必要な情報は呼び出し側が一覧の行から ID 引きで補う。
   */
  successIds: Array<Scalars["ID"]["output"]>;
};

export type InternalBulkUpdateSeasonalFeeSettingsError = {
  __typename?: "InternalBulkUpdateSeasonalFeeSettingsError";
  /** エラーメッセージ */
  message: Scalars["String"]["output"];
  /** エラーが発生した夜の日付 */
  night: Scalars["String"]["output"];
};

export type InternalBulkUpdateSeasonalFeeSettingsInput = {
  /** 追加料金。nullの場合は該当する夜の記録を削除 */
  additionalFee?: InputMaybe<Scalars["Int"]["input"]>;
  /** 日付 */
  night: Scalars["PlainDate"]["input"];
};

export type InternalBulkUpdateSeasonalFeeSettingsPayload = {
  __typename?: "InternalBulkUpdateSeasonalFeeSettingsPayload";
  /** 作成された設定の数 */
  created: Scalars["Int"]["output"];
  /** 削除された設定の数 */
  deleted: Scalars["Int"]["output"];
  /** 処理に失敗したレコードのエラー情報 */
  errors: Array<InternalBulkUpdateSeasonalFeeSettingsError>;
  /** 更新された設定の数 */
  updated: Scalars["Int"]["output"];
};

export type InternalBulkUpdateStayTicketMasterInput = {
  /** 追加ゲスト料金ポリシーID（undefinedの場合は更新しない、nullの場合は紐付けを解除） */
  additionalGuestFeePolicyId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 更新対象のチケットマスタID */
  id: Scalars["ID"]["input"];
  /** 管理部署ID（nullの場合は更新しない） */
  staffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
  /** チケット区分（nullの場合は更新しない） */
  ticketCategory?: InputMaybe<TicketCategory>;
};

export type InternalBulkUpdateStayTicketMastersError = {
  __typename?: "InternalBulkUpdateStayTicketMastersError";
  /** エラーが発生したチケットマスタID */
  id: Scalars["String"]["output"];
  /** エラーメッセージ */
  message: Scalars["String"]["output"];
};

export type InternalBulkUpdateStayTicketMastersPayload = {
  __typename?: "InternalBulkUpdateStayTicketMastersPayload";
  /** 処理に失敗したレコードのエラー情報 */
  errors: Array<InternalBulkUpdateStayTicketMastersError>;
  /** スキップしたレコード数 */
  skipped: Scalars["Int"]["output"];
  /** 更新成功したレコード数 */
  updated: Scalars["Int"]["output"];
};

export type InternalCancelCoOwnersApplicationError = {
  __typename?: "InternalCancelCoOwnersApplicationError";
  case: InternalCancelCoOwnersApplicationErrorCase;
};

export const InternalCancelCoOwnersApplicationErrorCase = {
  /** 既にキャンセル済み */
  AlreadyCancelled: "AlreadyCancelled",
  /** 引渡完了後はキャンセル不可 */
  CannotCancelAfterHandover: "CannotCancelAfterHandover",
  /** データが存在しない */
  NotFound: "NotFound",
  /** 権限が不足している */
  PermissionDenied: "PermissionDenied",
  /** Stripe返金エラー */
  StripeRefundError: "StripeRefundError",
} as const;

export type InternalCancelCoOwnersApplicationErrorCase =
  (typeof InternalCancelCoOwnersApplicationErrorCase)[keyof typeof InternalCancelCoOwnersApplicationErrorCase];
export type InternalCancelCoOwnersApplicationPayload =
  | CoOwnersApplication
  | InternalCancelCoOwnersApplicationError;

export type InternalCommonError = {
  __typename?: "InternalCommonError";
  message: Scalars["String"]["output"];
};

/** ルームタイプの表示コンテンツ（CMS 編集用） */
export type InternalContentRoomType = {
  __typename?: "InternalContentRoomType";
  /** 紹介文 */
  description?: Maybe<Scalars["String"]["output"]>;
  heroImages: Array<UploadedFile>;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** ブロック解放スケジュールの作成入力 */
export type InternalCreateAccommodationAvailabilityBlockReleaseScheduleInput = {
  /** 維持するブロック室数の上限（0 = 全解除） */
  blockRoomCountUpperLimit: Scalars["Int"]["input"];
  /** チェックインN日前 */
  daysBeforeCheckin: Scalars["Int"]["input"];
  /** 拠点ID */
  siteId: Scalars["ID"]["input"];
};

export type InternalCreateAccommodationEquipmentInput = {
  accommodationId: Scalars["ID"]["input"];
  /**
   * 機器種別ごとの固有情報を表す JSON 文字列（GraphQL に input union が無いため、Facility の
   * InternalCreateOrUpdateFacilityControllerInput.attribute に倣う）。
   * 形は type によって決まり、domain/models/AccommodationEquipment.ts の zod スキーマが検証する。
   * - Wifi: { primary: { ssid, password }, secondary: { ssid, password } | null }
   * - MusicConnect: { instruction }
   * - Sauna: { deviceId }
   */
  attribute: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  sort: Scalars["Int"]["input"];
  status: AccommodationEquipmentStatusType;
  type: AccommodationEquipmentType;
};

export type InternalCreateAccommodationEquipmentPayload =
  | AccommodationEquipment
  | InternalAccommodationEquipmentError;

export type InternalCreateAccommodationOperationGroupError = {
  __typename?: "InternalCreateAccommodationOperationGroupError";
  case: InternalCreateAccommodationOperationGroupErrorCase;
};

export const InternalCreateAccommodationOperationGroupErrorCase = {
  /** 拠点 × 建築タイプの運用グループがすでにある */
  AlreadyExists: "AlreadyExists",
  /** 建築タイプが見つからない */
  ArchitectureTypeNotFound: "ArchitectureTypeNotFound",
  /** 追加料金が不正（負の値、またはクラスで使われない欄が 0 以外） */
  InvalidAdditionalFee: "InvalidAdditionalFee",
  /** 拠点が見つからない */
  SiteNotFound: "SiteNotFound",
} as const;

export type InternalCreateAccommodationOperationGroupErrorCase =
  (typeof InternalCreateAccommodationOperationGroupErrorCase)[keyof typeof InternalCreateAccommodationOperationGroupErrorCase];
export type InternalCreateAccommodationOperationGroupInput = {
  additionalFeeForBusinessPlan: Scalars["Int"]["input"];
  additionalFeeForClassEOwner: Scalars["Int"]["input"];
  additionalFeeForClassFOwner: Scalars["Int"]["input"];
  architectureTypeId: Scalars["ID"]["input"];
  class: AccommodationClass;
  operationType: AccommodationOperationType;
  siteId: Scalars["ID"]["input"];
};

export type InternalCreateAccommodationOperationGroupPayload =
  | AccommodationOperationGroup
  | InternalCreateAccommodationOperationGroupError;

export type InternalCreateAccommodationReservationInput = {
  accommodationId: Scalars["ID"]["input"];
  detail: AccommodationReservationDetailInput;
  fee?: InputMaybe<AccommodationFeeInput>;
  firstNight: Scalars["PlainDate"]["input"];
  /**
   * SanuIncの場合、TentativeDeadlineを設定するかどうか
   * true: SanuIncUsageによって期限を設定
   * false: 9999-12-31T23:59:59Zを設定
   */
  hasDeadline?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * 仮予約として取るかどうか
   * 既存ユーザーではない場合、必ず仮予約として取る必要がある。
   */
  isTentative: Scalars["Boolean"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
  /** 予約を作成する対象ユーザー（既存ユーザーの場合） */
  userId?: InputMaybe<Scalars["ID"]["input"]>;
  waiveConsumedSuppliesFee: Scalars["Boolean"]["input"];
};

export type InternalCreateArchitectureContentImageUploadPolicyInput = {
  /** kind が ArchitectureType のとき必須（無ければ ResourceIdRequired）。それ以外は無視する */
  architectureTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  kind: InternalArchitectureContentImageKind;
};

/** エリア画像アップロードポリシーの入力 */
export type InternalCreateAreaImageUploadPolicyInput = {
  /** エリアID */
  areaId: Scalars["ID"]["input"];
};

/** エリア作成の入力 */
export type InternalCreateAreaInput = {
  /** 多言語化されたエリア名。全 locale (Ja / En / ZhCn) 必須。 */
  localizedName: InternalLocalizedStringInput;
  /** エリア名（例：一宮、安曇野）。旧フィールドで analytics 等で参照されている。 */
  name: Scalars["String"]["input"];
  /** スラッグ（URLに使用、英小文字・数字・ハイフンのみ） */
  slug: Scalars["String"]["input"];
  /** 並び順 */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InternalCreateCoOwnersIdentityVerificationError = {
  __typename?: "InternalCreateCoOwnersIdentityVerificationError";
  case: InternalCreateCoOwnersIdentityVerificationErrorCase;
};

export const InternalCreateCoOwnersIdentityVerificationErrorCase = {
  /**
   * 同じ method の本人確認が既に存在するため作成できない
   * （IcChipAndSelfie は進行中、RestrictedDeliveryMail はステータスを問わず1件まで）
   */
  ActiveVerificationExists: "ActiveVerificationExists",
  /** 作成できない method が指定された */
  UnsupportedMethod: "UnsupportedMethod",
} as const;

export type InternalCreateCoOwnersIdentityVerificationErrorCase =
  (typeof InternalCreateCoOwnersIdentityVerificationErrorCase)[keyof typeof InternalCreateCoOwnersIdentityVerificationErrorCase];
export type InternalCreateCoOwnersIdentityVerificationInput = {
  method: IdentityVerificationMethod;
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalCreateCoOwnersIdentityVerificationPayload =
  | IdentityVerification
  | InternalCreateCoOwnersIdentityVerificationError;

export type InternalCreateConsumedSuppliesFeeItemsError = {
  __typename?: "InternalCreateConsumedSuppliesFeeItemsError";
  case: InternalCreateConsumedSuppliesFeeItemsErrorCase;
};

export const InternalCreateConsumedSuppliesFeeItemsErrorCase = {
  AccommodationFeeIsNotOpen: "AccommodationFeeIsNotOpen",
  ExternalCleaningTaskIdNotMatch: "ExternalCleaningTaskIdNotMatch",
} as const;

export type InternalCreateConsumedSuppliesFeeItemsErrorCase =
  (typeof InternalCreateConsumedSuppliesFeeItemsErrorCase)[keyof typeof InternalCreateConsumedSuppliesFeeItemsErrorCase];
export type InternalCreateConsumedSuppliesFeeItemsInput = {
  accommodationReservationId: Scalars["ID"]["input"];
  externalCleaningTaskId: Scalars["ID"]["input"];
  items: Array<ConsumedSuppliesFeeItemInput>;
};

export type InternalCreateConsumedSuppliesFeeItemsPayload =
  | InternalCreateConsumedSuppliesFeeItemsError
  | Success;

/** 設備画像アップロードポリシーの入力 */
export type InternalCreateFacilityImageUploadPolicyInput = {
  /** 設備ID */
  facilityId: Scalars["ID"]["input"];
};

/** 付帯サービス新規作成入力 */
export type InternalCreateFacilityInput = {
  /** 料金ポリシー一覧 */
  baseFeePolicies: Array<InternalCreateOrUpdateFacilityBaseFeePolicyInput>;
  /** 返却後の準備日数（例: 充電1日 → 1）。デフォルト0 */
  bufferDays?: InputMaybe<Scalars["Int"]["input"]>;
  /** キャンセル締切の何日前（0=当日, 1=前日） */
  cancelDeadlineDaysBefore?: InputMaybe<Scalars["Int"]["input"]>;
  /** キャンセル締切時刻 */
  cancelDeadlineHour?: InputMaybe<Scalars["Int"]["input"]>;
  /** キャンセル料ポリシー一覧 */
  cancelFeePolicies: Array<InternalCreateOrUpdateFacilityCancelFeePolicyInput>;
  /** キャンセル料ルールURL */
  cancelRuleUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 設備詳細（Markdown） */
  contentDetail?: InputMaybe<Scalars["String"]["input"]>;
  /** 予約時の案内（Markdown） */
  contentGuide?: InputMaybe<Scalars["String"]["input"]>;
  /** 注意事項（Markdown） */
  contentNotice?: InputMaybe<Scalars["String"]["input"]>;
  /** 利用について（Markdown） */
  contentUsage?: InputMaybe<Scalars["String"]["input"]>;
  /** カスタムフィールド設定 */
  customFields?: InputMaybe<Array<FacilityCustomFieldItemInput>>;
  /** 施設説明文 */
  description: Scalars["String"]["input"];
  /** 詳細リンクURL（nullの場合はリンク非表示） */
  detailUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 付帯サービス種別 */
  facilityType: FacilityType;
  /** 単位種別 */
  facilityUnitType: FacilityUnitType;
  /** 施設画像 */
  image: UploadedFileInput;
  /** 清掃レポート機能を有効化（将来別システム移行予定） */
  isCleaningReportEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** データ連携管理機能を有効化 */
  isDataSyncEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 予約機能を有効にするか（false の場合は予約不要・無料で baseFeePolicies/cancelFeePolicies も不要） */
  isReserveEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 公開ページと予約カレンダーへの掲載を有効にするか */
  isVisibleEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 短縮表示名（ボタン/カード用） */
  label: Scalars["String"]["input"];
  /** 正式名称 */
  name: Scalars["String"]["input"];
  /** 予約締切の何日前（0=当日, 1=前日, 7=1週間前） */
  reserveDeadlineDaysBefore?: InputMaybe<Scalars["Int"]["input"]>;
  /** 予約締切時刻 */
  reserveDeadlineHour?: InputMaybe<Scalars["Int"]["input"]>;
  /** リソース一覧（最低1件必須） */
  resources: Array<InternalCreateOrUpdateFacilityResourceInput>;
  /** 拠点ID一覧 */
  siteIds: Array<Scalars["ID"]["input"]>;
  /** スロット定義一覧（facilityUnitType=Slot の場合のみ） */
  slots?: InputMaybe<Array<InternalCreateOrUpdateFacilitySlotInput>>;
  /** 公開ステータス */
  status: FacilityStatusType;
  /** 規約リンクのラベル */
  termsLabel?: InputMaybe<Scalars["String"]["input"]>;
  /** 利用規約URL */
  termsUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalCreateFacilityReservationError = {
  __typename?: "InternalCreateFacilityReservationError";
  case: InternalCreateFacilityReservationErrorCase;
};

export const InternalCreateFacilityReservationErrorCase = {
  AccommodationReservationPeriodMismatch:
    "AccommodationReservationPeriodMismatch",
  FeePolicyNotFound: "FeePolicyNotFound",
  InvalidDiscount: "InvalidDiscount",
  InvalidFacilityFieldData: "InvalidFacilityFieldData",
  InvalidSlotSelection: "InvalidSlotSelection",
  InvalidStartDate: "InvalidStartDate",
  NoAccommodationReservation: "NoAccommodationReservation",
  PastReserveDeadline: "PastReserveDeadline",
  ProviderNotEligible: "ProviderNotEligible",
  ResourceUnavailable: "ResourceUnavailable",
  ServiceNotAvailable: "ServiceNotAvailable",
  TemporarilyUnavailable: "TemporarilyUnavailable",
} as const;

export type InternalCreateFacilityReservationErrorCase =
  (typeof InternalCreateFacilityReservationErrorCase)[keyof typeof InternalCreateFacilityReservationErrorCase];
/** 管理者による付帯サービス予約作成入力 */
export type InternalCreateFacilityReservationInput = {
  /** 宿泊予約ID */
  accommodationReservationId: Scalars["ID"]["input"];
  /** カスタムフィールドの入力値 */
  customFieldValues?: InputMaybe<Array<FacilityCustomFieldValueInput>>;
  /** 管理者による割引。指定時は自動適用の割引（LEP対象者割引・Co-Owners特典など）を置き換える */
  discount?: InputMaybe<InternalFacilityReservationDiscountInput>;
  /** 返却/終了日（Night / Reservation の場合のみ） */
  endDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 強制予約(admin のみ利用可能) */
  isForce?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** リソースID */
  resourceId: Scalars["ID"]["input"];
  /** 選択したスロットID（unitType=Slot の場合のみ） */
  slotId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 利用開始日（Slot は利用日、Night / Reservation は貸出日） */
  startDate: Scalars["PlainDate"]["input"];
};

export type InternalCreateFacilityReservationPayload =
  | InternalCreateFacilityReservationError
  | Success;

export type InternalCreateFullOwnerIdentityVerificationError = {
  __typename?: "InternalCreateFullOwnerIdentityVerificationError";
  case: InternalCreateFullOwnerIdentityVerificationErrorCase;
};

export const InternalCreateFullOwnerIdentityVerificationErrorCase = {
  /**
   * 同じ method の本人確認が既に存在するため作成できない
   * （IcChipAndSelfie は進行中、RestrictedDeliveryMail はステータスを問わず1件まで）
   */
  ActiveVerificationExists: "ActiveVerificationExists",
  /** 作成できない method が指定された */
  UnsupportedMethod: "UnsupportedMethod",
} as const;

export type InternalCreateFullOwnerIdentityVerificationErrorCase =
  (typeof InternalCreateFullOwnerIdentityVerificationErrorCase)[keyof typeof InternalCreateFullOwnerIdentityVerificationErrorCase];
export type InternalCreateFullOwnerIdentityVerificationInput = {
  method: IdentityVerificationMethod;
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalCreateFullOwnerIdentityVerificationPayload =
  | IdentityVerification
  | InternalCreateFullOwnerIdentityVerificationError;

export type InternalCreateLocalTaxPolicyError = {
  __typename?: "InternalCreateLocalTaxPolicyError";
  case: InternalCreateLocalTaxPolicyErrorCase;
  message: Scalars["String"]["output"];
};

export const InternalCreateLocalTaxPolicyErrorCase = {
  /** 段階的定額の金額区分が正しくない（2 件以上で、0 円から隙間なく続き、最後は上限なし） */
  InvalidBrackets: "InvalidBrackets",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** 同じ自治体・税種別のポリシーと有効期間が重なる */
  OverlappingEffectivePeriod: "OverlappingEffectivePeriod",
} as const;

export type InternalCreateLocalTaxPolicyErrorCase =
  (typeof InternalCreateLocalTaxPolicyErrorCase)[keyof typeof InternalCreateLocalTaxPolicyErrorCase];
export type InternalCreateLocalTaxPolicyInput = {
  effectiveFrom: Scalars["PlainDate"]["input"];
  /** null は無期限 */
  effectiveTo?: InputMaybe<Scalars["PlainDate"]["input"]>;
  localGovernmentName: Scalars["String"]["input"];
  /** 税額の定め。指定したものが算出タイプ（一律定額・段階的定額・一律比率）になる */
  taxRule: InternalLocalTaxRuleInput;
  taxType: LocalTaxType;
  waiveKids: Scalars["Boolean"]["input"];
};

export type InternalCreateLocalTaxPolicyPayload =
  | InternalCreateLocalTaxPolicyError
  | LocalTaxPolicy;

/** 宿泊施設コンテンツ作成・更新の入力 */
export type InternalCreateOrUpdateAccommodationContentInput = {
  /** 設備マニュアルURL */
  manualUrl?: InputMaybe<Scalars["String"]["input"]>;
};

/** 部屋（Accommodation）の作成・更新時のエラー */
export type InternalCreateOrUpdateAccommodationError = {
  __typename?: "InternalCreateOrUpdateAccommodationError";
  message: Scalars["String"]["output"];
};

/** 部屋（Accommodation）の作成・更新時の入力 */
export type InternalCreateOrUpdateAccommodationInput = {
  /** 部屋の建築タイプのID */
  architectureTypeId: Scalars["ID"]["input"];
  /** 部屋のコード */
  code: Scalars["String"]["input"];
  /** 設備の ID */
  facilityIds: Array<Scalars["ID"]["input"]>;
  /** RemoteLOCK のデバイスID（null で紐づけ解除）。存在しない ID は保存時に拒否される */
  remoteLockDeviceId?: InputMaybe<Scalars["String"]["input"]>;
  /** 部屋が属する拠点のID */
  siteId: Scalars["ID"]["input"];
  /** 並び順 */
  sort: Scalars["Int"]["input"];
};

/** 宿泊施設お知らせの作成・更新時のエラー */
export type InternalCreateOrUpdateAccommodationNoticeError = {
  __typename?: "InternalCreateOrUpdateAccommodationNoticeError";
  case: InternalCreateOrUpdateAccommodationNoticeErrorCase;
  message: Scalars["String"]["output"];
};

/** エラーの種類 */
export const InternalCreateOrUpdateAccommodationNoticeErrorCase = {
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateAccommodationNoticeErrorCase =
  (typeof InternalCreateOrUpdateAccommodationNoticeErrorCase)[keyof typeof InternalCreateOrUpdateAccommodationNoticeErrorCase];
/** 宿泊施設のお知らせの作成・更新時の入力 */
export type InternalCreateOrUpdateAccommodationNoticeInput = {
  /** 対象宿泊施設のID一覧 */
  accommodationConnectionIds: Array<Scalars["ID"]["input"]>;
  /** タイトル */
  brief: Scalars["String"]["input"];
  /** 詳細 */
  detail: Scalars["String"]["input"];
  /** 表示終了日 */
  endDate: Scalars["PlainDate"]["input"];
  /** 外部URL */
  externalUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 対象者にメールで通知するか */
  sendEmailToExpectedUsers: Scalars["Boolean"]["input"];
  /** 表示開始日 */
  startDate: Scalars["PlainDate"]["input"];
  /** ステータス */
  status: AccommodationNoticeStatus;
};

/** 宿泊施設お知らせの作成・更新の結果 */
export type InternalCreateOrUpdateAccommodationNoticePayload =
  | AccommodationNotice
  | InternalCreateOrUpdateAccommodationNoticeError;

/** 部屋（Accommodation）の作成・更新の結果 */
export type InternalCreateOrUpdateAccommodationPayload =
  | Accommodation
  | InternalCreateOrUpdateAccommodationError;

/** 追加ゲスト料金ポリシーの作成・更新時のエラー */
export type InternalCreateOrUpdateAdditionalGuestFeePolicyError = {
  __typename?: "InternalCreateOrUpdateAdditionalGuestFeePolicyError";
  case: InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase;
  message: Scalars["String"]["output"];
};

/** エラーの種類 */
export const InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase = {
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** リソースが見つからない */
  ResourceNotFound: "ResourceNotFound",
} as const;

export type InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase =
  (typeof InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase)[keyof typeof InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase];
/** 追加ゲスト料金ポリシーの作成・更新の入力 */
export type InternalCreateOrUpdateAdditionalGuestFeePolicyInput = {
  adultPrices: Array<Scalars["Int"]["input"]>;
  internalName: Scalars["String"]["input"];
  kidsPrices: Array<Scalars["Int"]["input"]>;
};

/** 追加ゲスト料金ポリシーの作成・更新の結果 */
export type InternalCreateOrUpdateAdditionalGuestFeePolicyPayload =
  | AdditionalGuestFeePolicy
  | InternalCreateOrUpdateAdditionalGuestFeePolicyError;

/** 建築タイプ作成・更新の入力 */
export type InternalCreateOrUpdateArchitectureTypeInput = {
  /** 1泊あたりの施設追加料金 */
  additionalFee?: InputMaybe<Scalars["Int"]["input"]>;
  /** 定員 */
  capacity?: InputMaybe<Scalars["Int"]["input"]>;
  /** 公開状態 */
  published?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** シリーズ */
  series?: InputMaybe<ArchitectureTypeSeries>;
  /** シリーズ名（例：SANU CABIN） */
  seriesName?: InputMaybe<Scalars["String"]["input"]>;
  /** 短縮名（例：BEE, MOSS） */
  seriesShortName?: InputMaybe<Scalars["String"]["input"]>;
  /** サイズ */
  size?: InputMaybe<ArchitectureTypeSize>;
  /** スラッグ（URLに使用、英小文字・数字・ハイフンのみ。作成時のみ必須） */
  slug?: InputMaybe<Scalars["String"]["input"]>;
};

/** エリアガイド記事作成・更新の入力 */
export type InternalCreateOrUpdateAreaGuideArticleInput = {
  /** 掲載対象エリアの ID（1 件以上。既存の紐付けは全置換） */
  areaIds: Array<Scalars["ID"]["input"]>;
  /** MAGAZINE 上の公開日 */
  publishedDate: Scalars["PlainDate"]["input"];
  /** 並び順。省略時は新規なら末尾、更新なら変更しない */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  /** サムネイル画像。null で外す。省略時は変更しない */
  thumbnail?: InputMaybe<UploadedFileInput>;
  title: Scalars["String"]["input"];
  /** MAGAZINE 記事の URL（http(s) の絶対 URL） */
  url: Scalars["String"]["input"];
};

/** エリアおすすめスポット作成・更新の入力 */
export type InternalCreateOrUpdateAreaGuideSpotInput = {
  /** エリアID（新規作成時に必要） */
  areaId?: InputMaybe<Scalars["ID"]["input"]>;
  businessHours?: InputMaybe<Scalars["String"]["input"]>;
  /** カテゴリ（複数可） */
  categories?: InputMaybe<Array<AreaGuideSpotCategory>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** 画像（順序保持）。undefined のときは更新しない */
  images?: InputMaybe<Array<UploadedFileInput>>;
  mapUrl?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  /**
   * 掲載終了日（当日を含む）。null で無期限に戻す。省略時は変更しない。
   * 掲載を止めたいときは過去日を入れる
   */
  publishEndDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 掲載開始日（当日を含む）。null で指定なしに戻す。省略時は変更しない */
  publishStartDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  /** タグ（ベーカリー・スーパー 等のフリーテキスト） */
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  websiteUrl?: InputMaybe<Scalars["String"]["input"]>;
};

/** 基本宿泊料金ポリシーの作成・更新時のエラー */
export type InternalCreateOrUpdateBaseAccommodationFeePolicyError = {
  __typename?: "InternalCreateOrUpdateBaseAccommodationFeePolicyError";
  case: InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase;
  message: Scalars["String"]["output"];
};

/** エラーの種類 */
export const InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase = {
  /** データベースエラー */
  DatabaseError: "DatabaseError",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** リソースが見つからない */
  ResourceNotFound: "ResourceNotFound",
} as const;

export type InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase =
  (typeof InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase)[keyof typeof InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase];
/** 基本宿泊料金ポリシーの作成・更新の結果 */
export type InternalCreateOrUpdateBaseAccommodationFeePolicyPayload =
  | InternalCreateOrUpdateBaseAccommodationFeePolicyError
  | RawBaseAccommodationFeePolicy;

export type InternalCreateOrUpdateBusinessPlanError = {
  __typename?: "InternalCreateOrUpdateBusinessPlanError";
  case: InternalCreateOrUpdateBusinessPlanErrorCase;
  message: Scalars["String"]["output"];
};

/** 法人プランの作成・更新時のエラーの種類 */
export const InternalCreateOrUpdateBusinessPlanErrorCase = {
  /** プラン名が他の法人プランと重複している */
  DuplicatedName: "DuplicatedName",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateBusinessPlanErrorCase =
  (typeof InternalCreateOrUpdateBusinessPlanErrorCase)[keyof typeof InternalCreateOrUpdateBusinessPlanErrorCase];
export type InternalCreateOrUpdateBusinessPlanPayload =
  | BusinessPlan
  | InternalCreateOrUpdateBusinessPlanError;

export type InternalCreateOrUpdateCancelFeePolicyError = {
  __typename?: "InternalCreateOrUpdateCancelFeePolicyError";
  case: InternalCreateOrUpdateCancelFeePolicyErrorCase;
  message: Scalars["String"]["output"];
};

export const InternalCreateOrUpdateCancelFeePolicyErrorCase = {
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** リソースが見つからない */
  ResourceNotFound: "ResourceNotFound",
} as const;

export type InternalCreateOrUpdateCancelFeePolicyErrorCase =
  (typeof InternalCreateOrUpdateCancelFeePolicyErrorCase)[keyof typeof InternalCreateOrUpdateCancelFeePolicyErrorCase];
export type InternalCreateOrUpdateCancelFeePolicyPayload =
  | InternalCreateOrUpdateCancelFeePolicyError
  | RawCancelFeePolicy;

export type InternalCreateOrUpdateCoOwnersPlanOfferingError = {
  __typename?: "InternalCreateOrUpdateCoOwnersPlanOfferingError";
  case: InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase;
};

export const InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase = {
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase =
  (typeof InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase)[keyof typeof InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase];
/** CoOwnersPlanOffering の作成・更新時の入力 */
export type InternalCreateOrUpdateCoOwnersPlanOfferingInput = {
  /** 早期アクセスコード */
  earlyAccessCode?: InputMaybe<Scalars["String"]["input"]>;
  /** 見積もり書 */
  estimate?: InputMaybe<UploadedFileInput>;
  /** 非表示かどうか */
  isHidden: Scalars["Boolean"]["input"];
  /** 売り切れかどうか */
  isSoldOut: Scalars["Boolean"]["input"];
  /** オーナープランID */
  ownerPlanId: Scalars["ID"]["input"];
  /** 口数 */
  units: Scalars["Int"]["input"];
};

export type InternalCreateOrUpdateCoOwnersPlanOfferingPayload =
  | CoOwnersPlanOffering
  | InternalCreateOrUpdateCoOwnersPlanOfferingError;

/** Co-Owners 重要事項説明会スケジュールの作成・更新時のエラー */
export type InternalCreateOrUpdateCoOwnersWebinarScheduleError = {
  __typename?: "InternalCreateOrUpdateCoOwnersWebinarScheduleError";
  case: InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase;
};

/** エラーの種類 */
export const InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase = {
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase =
  (typeof InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase)[keyof typeof InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase];
/** Co-Owners 重要事項説明会スケジュールの作成・更新時の入力 */
export type InternalCreateOrUpdateCoOwnersWebinarScheduleInput = {
  /** 説明会の申し込みを受け付けるかどうか */
  isActive: Scalars["Boolean"]["input"];
  /** プランの拠点ID */
  siteId: Scalars["ID"]["input"];
  /** 重説開始日時 */
  startsAt: Scalars["ZonedDateTime"]["input"];
  /** Zoom MTG等のURL */
  url: Scalars["String"]["input"];
};

/** Co-Owners 重要事項説明会スケジュールの作成・更新の結果 */
export type InternalCreateOrUpdateCoOwnersWebinarSchedulePayload =
  | CoOwnersWebinarSchedule
  | InternalCreateOrUpdateCoOwnersWebinarScheduleError;

/** 建築家の作成・更新の入力 */
export type InternalCreateOrUpdateContentArchitectInput = {
  /** プロフィール */
  bio: Scalars["String"]["input"];
  /** 会社名 */
  company: Scalars["String"]["input"];
  /** 写真 */
  image: UploadedFileInput;
  /** 名前（日本語） */
  name: Scalars["String"]["input"];
  /** 名前（英語） */
  nameEn: Scalars["String"]["input"];
};

export type InternalCreateOrUpdateContentArchitectPayload =
  | ContentArchitect
  | InternalArchitectureContentError;

/**
 * 設備コンテンツの作成・更新の入力。
 * 省略したフィールドは変更しない（カード単位で保存するため）
 */
export type InternalCreateOrUpdateContentArchitecturalFeatureInput = {
  /** このコンテンツが説明している設備（全量置き換え）。編集中の設備は外せない */
  accommodationFacilityIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 設備の提供状況についての注記。空文字で未設定にする */
  availabilityNote?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** 公開ページに出すアメニティ（全量置き換え） */
  facilityAmenityIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 公開ページのカルーセル画像（全量置き換え） */
  images?: InputMaybe<Array<UploadedFileInput>>;
  /** 名前。作成時は必須 */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** 利用ルールの末尾に出る注記 */
  ruleNoteMarkup?: InputMaybe<Scalars["String"]["input"]>;
  /** 利用ルールの見出し */
  ruleTitle?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * 公開ページの URL に入る識別子。作成時のみ使い、更新では無視する
   * （変えると公開済み URL が 404 になるため）
   */
  slug?: InputMaybe<Scalars["String"]["input"]>;
  /** 建築トップの設備カードに出る画像。null を明示すると未設定に戻す */
  thumbnailImage?: InputMaybe<UploadedFileInput>;
  usageConditionsDescription?: InputMaybe<Scalars["String"]["input"]>;
  usageFeesDescriptionMarkup?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalCreateOrUpdateContentArchitecturalFeaturePayload =
  | ContentArchitecturalFeature
  | InternalArchitectureContentError;

/** 設備コンテンツの利用ルールの作成・更新の入力 */
export type InternalCreateOrUpdateContentArchitecturalFeatureUsageRuleInput = {
  bodyMarkup: Scalars["String"]["input"];
  /** ルールに添える画像。null で未設定にする */
  image?: InputMaybe<UploadedFileInput>;
  /** 並び順。省略すると末尾に置く */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload =
  | ContentArchitecturalFeatureUsageRule
  | InternalArchitectureContentError;

export type InternalCreateOrUpdateContentArchitectureTypeBasicAmenityInput = {
  /** アイコン。未設定の設備が実在するので null を許容する */
  icon?: InputMaybe<UploadedFileInput>;
  /** 設備の名前 */
  name: Scalars["String"]["input"];
  /** 公開ページの表示順。省略すると末尾に置く */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * 建築タイプコンテンツ作成・更新の入力。
 * 全 field 省略可能で、省略した field は更新しない。新規作成時は sort と architectId が必須
 */
export type InternalCreateOrUpdateContentArchitectureTypeInput = {
  /** 設備の操作マニュアル（リンク）。空文字で未設定 */
  amenitiesInstructionsUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 建築家のコメント */
  architectComment?: InputMaybe<Scalars["String"]["input"]>;
  /** 建築家 ID */
  architectId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 基本の設備 ID（全量置き換え） */
  basicAmenityIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 最大収容人数（フリーテキスト） */
  capacityDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** 概要テキスト */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** 予約完了メールに表示される画像 URL。null で未設定（デフォルト画像にフォールバック） */
  emailCoverImageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 備品リスト（リンク）。空文字で未設定 */
  equipmentsListUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 間取り図（Selection Series のみ）。null を明示すると削除 */
  floorPlanImage?: InputMaybe<UploadedFileInput>;
  /** カルーセル画像（全量置き換え） */
  images?: InputMaybe<Array<UploadedFileInput>>;
  /** 広さ（フリーテキスト） */
  sizeDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** 広さ（㎡） */
  sizeSqm?: InputMaybe<Scalars["Float"]["input"]>;
  /** 建築ページ一覧での並び順 */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  /** 建築（一覧）ページで表示される画像。null を明示すると未設定に戻す */
  thumbnailImage?: InputMaybe<UploadedFileInput>;
};

export type InternalCreateOrUpdateContentArchitectureTypePayload =
  | ContentArchitectureType
  | InternalArchitectureContentError;

/**
 * バリエーション / オプションの作成・更新の入力。
 * 公開型が全て non-null なので省略は許さず、更新時も全 field を送る
 */
export type InternalCreateOrUpdateContentArchitectureTypeVariantInput = {
  /** このバリエーション / オプションを構成する設備 ID（全量置き換え） */
  accommodationFacilityIds: Array<Scalars["ID"]["input"]>;
  /** ひとこと説明（「サウナ付きのキャビン」など） */
  brief: Scalars["String"]["input"];
  /** 説明 */
  description: Scalars["String"]["input"];
  /** 付帯する設備アメニティ ID（全量置き換え） */
  facilityAmenityIds: Array<Scalars["ID"]["input"]>;
  /** カルーセル画像（全量置き換え） */
  images: Array<UploadedFileInput>;
  /** 名前（「With Sauna」など）。slug はここから自動生成する */
  name: Scalars["String"]["input"];
  /** 利用条件の説明 */
  usageConditionsDescription: Scalars["String"]["input"];
  /** 利用料金の説明（Markup） */
  usageFeesDescriptionMarkup: Scalars["String"]["input"];
};

export type InternalCreateOrUpdateContentArchitectureTypeVariantPayload =
  | ContentArchitectureTypeVariant
  | InternalArchitectureContentError;

export type InternalCreateOrUpdateContentBasicAmenityPayload =
  | ContentArchitectureTypeBasicAmenity
  | InternalArchitectureContentError;

/** 設備アメニティの作成・更新の入力 */
export type InternalCreateOrUpdateContentFacilityAmenityInput = {
  /** 属する設備（「バレルサウナ」なら Sauna） */
  accommodationFacilityId: Scalars["ID"]["input"];
  /** 説明（Markup） */
  descriptionMarkup: Scalars["String"]["input"];
  /** 名前（「バレルサウナ」など） */
  name: Scalars["String"]["input"];
};

export type InternalCreateOrUpdateContentFacilityAmenityPayload =
  | ContentArchitectureTypeVariantFacilityAmenity
  | InternalArchitectureContentError;

/** 付帯サービス料金ポリシー入力 */
export type InternalCreateOrUpdateFacilityBaseFeePolicyInput = {
  /**
   * リソース識別子（resource.identifierと紐づけ）
   * nullの場合はfacility全体のデフォルト料金
   */
  resourceIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  /** 何単位目までの累計料金か（1-indexed）。unit:1がデフォルト単価 */
  unit: Scalars["Int"]["input"];
  /** 累計料金（unit:1の場合は1単位あたりの料金） */
  unitFeeAmount: Scalars["Decimal"]["input"];
};

/** 付帯サービスキャンセル料ポリシー入力 */
export type InternalCreateOrUpdateFacilityCancelFeePolicyInput = {
  /** 適用開始日（開始日の何日前） */
  deadlineDaysBefore: Scalars["Int"]["input"];
  /** 適用開始時刻 */
  deadlineHour: Scalars["Int"]["input"];
  /** キャンセル料タイプ（Value: 固定金額, Percentage: キャンセル料率） */
  feeModifierType: FeeModifierType;
  /** キャンセル料値（Percentageの場合はキャンセル料率0-100, Valueの場合は固定キャンセル料・円） */
  feeValue: Scalars["Decimal"]["input"];
  /**
   * リソース識別子（resource.identifierと紐づけ）
   * nullの場合はfacility全体のデフォルトキャンセル料ポリシー
   */
  resourceIdentifier?: InputMaybe<Scalars["String"]["input"]>;
};

/** 付帯サービスコントローラー入力 */
export type InternalCreateOrUpdateFacilityControllerInput = {
  attribute?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  type: FacilityResourceControllerType;
};

export type InternalCreateOrUpdateFacilityError = {
  __typename?: "InternalCreateOrUpdateFacilityError";
  case: InternalCreateOrUpdateFacilityErrorCase;
};

export const InternalCreateOrUpdateFacilityErrorCase = {
  CustomInvoiceLabelRequiresReserveEnabled:
    "CustomInvoiceLabelRequiresReserveEnabled",
  FacilityNotFound: "FacilityNotFound",
  InvalidControllerAttribute: "InvalidControllerAttribute",
  InvalidCustomInvoiceLabel: "InvalidCustomInvoiceLabel",
  SiteNotFound: "SiteNotFound",
} as const;

export type InternalCreateOrUpdateFacilityErrorCase =
  (typeof InternalCreateOrUpdateFacilityErrorCase)[keyof typeof InternalCreateOrUpdateFacilityErrorCase];
export type InternalCreateOrUpdateFacilityPayload =
  | InternalCreateOrUpdateFacilityError
  | Success;

export type InternalCreateOrUpdateFacilityResourceBlockError = {
  __typename?: "InternalCreateOrUpdateFacilityResourceBlockError";
  case: InternalCreateOrUpdateFacilityResourceBlockErrorCase;
};

export const InternalCreateOrUpdateFacilityResourceBlockErrorCase = {
  BlockNotFound: "BlockNotFound",
  ResourceNotFound: "ResourceNotFound",
} as const;

export type InternalCreateOrUpdateFacilityResourceBlockErrorCase =
  (typeof InternalCreateOrUpdateFacilityResourceBlockErrorCase)[keyof typeof InternalCreateOrUpdateFacilityResourceBlockErrorCase];
/** 付帯サービスリソースブロック作成・更新入力 */
export type InternalCreateOrUpdateFacilityResourceBlockInput = {
  /** 終了日時 */
  endAt: Scalars["PlainDateTime"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /** 理由 */
  reason?: InputMaybe<Scalars["String"]["input"]>;
  /** リソースID */
  resourceId: Scalars["ID"]["input"];
  /** 開始日時 */
  startAt: Scalars["PlainDateTime"]["input"];
};

export type InternalCreateOrUpdateFacilityResourceBlockPayload =
  | InternalCreateOrUpdateFacilityResourceBlockError
  | Success;

/** 付帯サービスリソース入力 */
export type InternalCreateOrUpdateFacilityResourceInput = {
  /** コントローラー設定 */
  controllers?: InputMaybe<
    Array<InternalCreateOrUpdateFacilityControllerInput>
  >;
  /** 請求明細ラベルのパーツ（並び順どおりに半角スペースで連結する）。予約受付が有効な施設でのみ設定できる。更新時は未指定なら変更せず、null で解除する */
  customInvoiceLabel?: InputMaybe<Array<FacilityInvoiceLabelPartInput>>;
  /** 識別子（車両番号、設備番号など） */
  identifier: Scalars["String"]["input"];
  /** リソース名 */
  name: Scalars["String"]["input"];
};

/** 付帯サービススロット入力 */
export type InternalCreateOrUpdateFacilitySlotInput = {
  /** 終了時刻（時） */
  endHour: Scalars["Int"]["input"];
  /** 終了時刻（分） */
  endMinute?: InputMaybe<Scalars["Int"]["input"]>;
  /** リソース識別子（resource.identifierと紐づけ） */
  resourceIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  /** 開始時刻（時） */
  startHour: Scalars["Int"]["input"];
  /** 開始時刻（分） */
  startMinute?: InputMaybe<Scalars["Int"]["input"]>;
};

/** ネイティブアプリのホームコンテンツ作成・更新時のエラー */
export type InternalCreateOrUpdateNativeAppHomeContentError = {
  __typename?: "InternalCreateOrUpdateNativeAppHomeContentError";
  case: InternalCreateOrUpdateNativeAppHomeContentErrorCase;
  message: Scalars["String"]["output"];
};

/** エラーの種類 */
export const InternalCreateOrUpdateNativeAppHomeContentErrorCase = {
  /** データベースエラー */
  DatabaseError: "DatabaseError",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** リソースが見つからない */
  NotFound: "NotFound",
  /** 並行更新により楽観ロックが競合した（再読み込みして再試行） */
  OptimisticLockConflict: "OptimisticLockConflict",
} as const;

export type InternalCreateOrUpdateNativeAppHomeContentErrorCase =
  (typeof InternalCreateOrUpdateNativeAppHomeContentErrorCase)[keyof typeof InternalCreateOrUpdateNativeAppHomeContentErrorCase];
/**
 * ネイティブアプリのホームコンテンツ作成・更新の結果。
 * 成功時は保存後のエンティティを返す（Apollo cache の自動更新のため）
 */
export type InternalCreateOrUpdateNativeAppHomeContentPayload =
  | InternalCreateOrUpdateNativeAppHomeContentError
  | InternalNativeAppHomeContent;

/** お知らせの作成・更新時のエラー */
export type InternalCreateOrUpdateNewsError = {
  __typename?: "InternalCreateOrUpdateNewsError";
  case: InternalCreateOrUpdateNewsErrorCase;
};

export const InternalCreateOrUpdateNewsErrorCase = {
  /** HTML の場合は content が必須 */
  ContentIsRequiredForHTML: "ContentIsRequiredForHTML",
  /** InternalPage は使用しない */
  InternalPageIsNoLongerUsed: "InternalPageIsNoLongerUsed",
  /** ExternalLink の場合は URL が必須 */
  UrlIsRequiredForExternalLink: "UrlIsRequiredForExternalLink",
} as const;

export type InternalCreateOrUpdateNewsErrorCase =
  (typeof InternalCreateOrUpdateNewsErrorCase)[keyof typeof InternalCreateOrUpdateNewsErrorCase];
/** お知らせの作成・更新時の入力 */
export type InternalCreateOrUpdateNewsInput = {
  /** コンテンツ（contentType が HTML の場合にはコンテンツ、ExternalLink の場合は URL を入力。） */
  content: Scalars["String"]["input"];
  /** コンテンツの種類 */
  contentType: NewsContentType;
  /** カテゴリ */
  displayCategory: NewsDisplayCategory;
  /** 公開日時 */
  publishedAt: Scalars["ZonedDateTime"]["input"];
  /** ステータス */
  status: NewsStatus;
  /** どのプランに対して表示するか */
  targetPlans: Array<TargetPlanType>;
  /** タイトル */
  title: Scalars["String"]["input"];
};

/** お知らせの作成・更新の結果 */
export type InternalCreateOrUpdateNewsPayload =
  | InternalCreateOrUpdateNewsError
  | News;

export type InternalCreateOrUpdateOrganizationError = {
  __typename?: "InternalCreateOrUpdateOrganizationError";
  case: InternalCreateOrUpdateOrganizationErrorCase;
  message: Scalars["String"]["output"];
};

/** 法人の作成・更新時のエラーの種類 */
export const InternalCreateOrUpdateOrganizationErrorCase = {
  /** 指定した SANU 担当者のユーザーが存在しない */
  AssignedUserNotFound: "AssignedUserNotFound",
  /** 組織コードが他の法人と重複している */
  DuplicatedInvitationCode: "DuplicatedInvitationCode",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateOrganizationErrorCase =
  (typeof InternalCreateOrUpdateOrganizationErrorCase)[keyof typeof InternalCreateOrUpdateOrganizationErrorCase];
export type InternalCreateOrUpdateOrganizationPayload =
  | InternalCreateOrUpdateOrganizationError
  | Organization;

export type InternalCreateOrUpdateOrganizationYearlyContractError = {
  __typename?: "InternalCreateOrUpdateOrganizationYearlyContractError";
  message: Scalars["String"]["output"];
};

export type InternalCreateOrUpdateOrganizationYearlyContractInvoiceError = {
  __typename?: "InternalCreateOrUpdateOrganizationYearlyContractInvoiceError";
  case: InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase;
};

export const InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase =
  {
    /** カード自動決済の請求書を作ろうとしたが、カードが登録されていない */
    CardIsNotRegistered: "CardIsNotRegistered",
    /** 新規作成時にcontractIdが指定されていない */
    ContractIdRequired: "ContractIdRequired",
    /** 無効化済みの契約に対して請求書を作成しようとした */
    ContractIsInvalidated: "ContractIsInvalidated",
    /** Stripe顧客にメールアドレスが登録されていない（銀行振込の場合に必要） */
    CustomerEmailRequired: "CustomerEmailRequired",
    /** 銀行振込の支払期限（対象年月の2ヶ月後の月末）が既に過ぎている */
    DueDateIsInPast: "DueDateIsInPast",
    /** draft状態でない請求書は更新できない */
    InvoiceIsNotDraft: "InvoiceIsNotDraft",
    /** 必須フィールドが不足 */
    MissingRequiredFields: "MissingRequiredFields",
    /** 公開予定日が指定できる範囲（対象月の前月1日〜対象月末）の外 */
    ScheduledOpenDateOutOfRange: "ScheduledOpenDateOutOfRange",
    /** 月払いの対象年月が契約期間外 */
    YearMonthOutOfContractPeriod: "YearMonthOutOfContractPeriod",
  } as const;

export type InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase =
  (typeof InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase)[keyof typeof InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase];
export type InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload =
  | InternalCreateOrUpdateOrganizationYearlyContractInvoiceError
  | Success;

export type InternalCreateOrUpdateOrganizationYearlyContractPayload =
  | InternalCreateOrUpdateOrganizationYearlyContractError
  | OrganizationYearlyContract;

/** OwnerPlan の作成・更新時のエラー */
export type InternalCreateOrUpdateOwnerPlanError = {
  __typename?: "InternalCreateOrUpdateOwnerPlanError";
  case: InternalCreateOrUpdateOwnerPlanErrorCase;
};

/** エラーの種類 */
export const InternalCreateOrUpdateOwnerPlanErrorCase = {
  /** 部屋が見つからない */
  AccommodationNotFound: "AccommodationNotFound",
  /** FullOwner の場合部屋が必要 */
  AccommodationRequiredForFullOwner: "AccommodationRequiredForFullOwner",
  /** 建築タイプが見つからない */
  ArchitectureTypeNotFound: "ArchitectureTypeNotFound",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** 所有対象（拠点・建築タイプ）に対応する運用グループの設定が登録されていない */
  OperationGroupSettingNotFound: "OperationGroupSettingNotFound",
  /** オーナープランが見つからない */
  OwnerPlanNotFound: "OwnerPlanNotFound",
  /** Co-Owners の場合拠点と建築タイプが必要 */
  SiteAndArchitectureTypeRequiedForCoOwners:
    "SiteAndArchitectureTypeRequiedForCoOwners",
  /** 拠点が見つからない */
  SiteNotFound: "SiteNotFound",
} as const;

export type InternalCreateOrUpdateOwnerPlanErrorCase =
  (typeof InternalCreateOrUpdateOwnerPlanErrorCase)[keyof typeof InternalCreateOrUpdateOwnerPlanErrorCase];
/** OwnerPlan の作成・更新時の入力 */
export type InternalCreateOrUpdateOwnerPlanInput = {
  /** 宿泊施設の設備ID */
  accommodationFacilityIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 部屋ID (FullOwnerの部屋所有の場合) */
  accommodationId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 建築タイプID(Co-OwnersとFullOwnerの部屋所有の場合、FullOwnerの拠点所有=拠点投資家の場合は null) */
  architectureTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  /** バルコニー面積 */
  balconySizeSqm: Scalars["Float"]["input"];
  /** 基本料金 */
  baseAccommodationFeePerNight: Scalars["Int"]["input"];
  /**
   * ドッグ棟フィルター (CoOwnersの場合)
   * accommodationFacilityIdsにDogFriendlyが含まれる場合は自動でIncludeになる
   */
  dogFriendlyFilter?: InputMaybe<AccommodationFacilityFilterType>;
  /** 権利形態 */
  formOfRights: Scalars["String"]["input"];
  /** 客室面積 */
  guestRoomSizeSqm: Scalars["Float"]["input"];
  /** 引き渡し開始予定年月 */
  handoverStartDate?: InputMaybe<Scalars["PlainYearMonth"]["input"]>;
  /** 借地対象面積 */
  leasedLandSizeSqm: Scalars["Float"]["input"];
  /** 繁忙日の制限有無 (CoOwners のみ) */
  limitPeakDays: Scalars["Boolean"]["input"];
  /** 管理名 */
  managedName?: InputMaybe<Scalars["String"]["input"]>;
  /** 他拠点利用基本料金 */
  nonOwnedBaseAccommodationFeePerNight: Scalars["Int"]["input"];
  /**
   * 繁忙日数上限の算出割合。CoOwners かつ limitPeakDays=true のとき必須、それ以外は null。
   * mutation は floor(unitNightsPerYear × この割合) を 1 口あたりの上限として保存する。
   */
  peakDaysRatio?: InputMaybe<CoOwnerPeakDaysRatio>;
  /** 1口あたりの登録料（本来は`unit`prefixがついているべき） */
  registrationFee: Scalars["Int"]["input"];
  /** 拠点ID */
  siteId: Scalars["ID"]["input"];
  /** 敷地面積 */
  siteSizeSqm: Scalars["Float"]["input"];
  /** 口数 */
  totalUnits: Scalars["Int"]["input"];
  /** プランタイプ (CoOwners または FullOwner) */
  type: OwnerPlanType;
  /** 1口に相当する火災保険料、1口あたりのに変更する */
  unitAnnualFireInsuranceFee: Scalars["Int"]["input"];
  /** 1口に相当する借地料 */
  unitAnnualLandRentFee: Scalars["Int"]["input"];
  /** 1口に相当する年間管理費 */
  unitAnnualMaintenanceFee: Scalars["Int"]["input"];
  /** 1口に相当する温泉基本料金・更新料 */
  unitAnnualOnsenFee: Scalars["Int"]["input"];
  /** 1口に相当する建物固定資産税 */
  unitAnnualPropertyTax: Scalars["Int"]["input"];
  /** 1口に相当する修繕積立金 */
  unitAnnualRepairReserve: Scalars["Int"]["input"];
  /** 1口に相当する申込金 */
  unitApplicationFee: Scalars["Int"]["input"];
  /** 1口に相当する建物費 */
  unitBuildingFee?: InputMaybe<Scalars["Int"]["input"]>;
  /** 1口に相当する年間の泊数 */
  unitNightsPerYear: Scalars["Int"]["input"];
  /** 1口に相当する購入金額 */
  unitPurchaseAmount: Scalars["Int"]["input"];
};

/** OwnerPlan の作成・更新の結果 */
export type InternalCreateOrUpdateOwnerPlanPayload =
  | InternalCreateOrUpdateOwnerPlanError
  | OwnerPlan;

/** 拠点アクセスルートグループ作成・更新の入力 */
export type InternalCreateOrUpdateSiteAccessRouteGroupInput = {
  /**
   * 地点リスト（始点→経由→終点の順）。
   * Mutation 毎に全置換する。
   */
  points: Array<InternalSiteAccessRoutePointInput>;
  /** 拠点ID（新規作成時に必要） */
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 並び順 */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  /** グループ見出し（例: "公共交通機関でお越しの方"） */
  title: Scalars["String"]["input"];
  /** グループ見出し脇のアイコン */
  transportIcon: AccessRouteTransportIcon;
};

export type InternalCreateOrUpdateSiteActivityProgramError = {
  __typename?: "InternalCreateOrUpdateSiteActivityProgramError";
  case: InternalCreateOrUpdateSiteActivityProgramErrorCase;
  message: Scalars["String"]["output"];
};

export const InternalCreateOrUpdateSiteActivityProgramErrorCase = {
  ActivityProgramNotFound: "ActivityProgramNotFound",
  InvalidExternalUrl: "InvalidExternalUrl",
  InvalidPublicationPeriod: "InvalidPublicationPeriod",
  SiteNotFound: "SiteNotFound",
  TitleRequired: "TitleRequired",
} as const;

export type InternalCreateOrUpdateSiteActivityProgramErrorCase =
  (typeof InternalCreateOrUpdateSiteActivityProgramErrorCase)[keyof typeof InternalCreateOrUpdateSiteActivityProgramErrorCase];
export type InternalCreateOrUpdateSiteActivityProgramPayload =
  | InternalCreateOrUpdateSiteActivityProgramError
  | SiteActivityProgram;

export type InternalCreateOrUpdateSiteFaqError = {
  __typename?: "InternalCreateOrUpdateSiteFaqError";
  case: InternalCreateOrUpdateSiteFaqErrorCase;
};

export const InternalCreateOrUpdateSiteFaqErrorCase = {
  /** 回答が空 */
  AnswerIsEmpty: "AnswerIsEmpty",
  /** 質問が空 */
  QuestionIsEmpty: "QuestionIsEmpty",
} as const;

export type InternalCreateOrUpdateSiteFaqErrorCase =
  (typeof InternalCreateOrUpdateSiteFaqErrorCase)[keyof typeof InternalCreateOrUpdateSiteFaqErrorCase];
/** 拠点FAQの作成・更新時の入力 */
export type InternalCreateOrUpdateSiteFaqInput = {
  /** 回答 (HTML) */
  answer: Scalars["String"]["input"];
  /** 案内画像URL（チェックイン当日メール・拠点ページ・nativeappチェックインシートに表示） */
  guidanceImageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 質問 */
  question: Scalars["String"]["input"];
  /** 拠点ID */
  siteId: Scalars["ID"]["input"];
  /** 並び順 */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InternalCreateOrUpdateSiteFaqPayload =
  | InternalCreateOrUpdateSiteFaqError
  | RawSiteFaq;

/** 拠点画像の更新時の入力 */
export type InternalCreateOrUpdateSiteImagesInput = {
  /** 画像のURLリスト（並び順を保持） */
  images: Array<UploadedFileInput>;
};

/** 社内スタッフグループ作成・更新時のエラー */
export type InternalCreateOrUpdateStaffGroupError = {
  __typename?: "InternalCreateOrUpdateStaffGroupError";
  case: InternalCreateOrUpdateStaffGroupErrorCase;
  message: Scalars["String"]["output"];
};

/** 社内スタッフグループ作成・更新時のエラーの種類 */
export const InternalCreateOrUpdateStaffGroupErrorCase = {
  /** SmartHR ID が他のグループと重複している */
  DuplicatedSmarthrId: "DuplicatedSmarthrId",
  /** 更新対象のグループが存在しない */
  NotFound: "NotFound",
} as const;

export type InternalCreateOrUpdateStaffGroupErrorCase =
  (typeof InternalCreateOrUpdateStaffGroupErrorCase)[keyof typeof InternalCreateOrUpdateStaffGroupErrorCase];
/** 社内スタッフグループ作成・更新の結果 */
export type InternalCreateOrUpdateStaffGroupPayload =
  | InternalCreateOrUpdateStaffGroupError
  | StaffGroup;

/** 宿泊チケットマスターの作成・更新時のエラー */
export type InternalCreateOrUpdateStayTicketMasterError = {
  __typename?: "InternalCreateOrUpdateStayTicketMasterError";
  case: InternalCreateOrUpdateStayTicketMasterErrorCase;
  message: Scalars["String"]["output"];
};

export const InternalCreateOrUpdateStayTicketMasterErrorCase = {
  /** 不正な入力 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateStayTicketMasterErrorCase =
  (typeof InternalCreateOrUpdateStayTicketMasterErrorCase)[keyof typeof InternalCreateOrUpdateStayTicketMasterErrorCase];
/** 宿泊チケットマスターの作成・更新時の入力 */
export type InternalCreateOrUpdateStayTicketMasterInput = {
  /** 3人目以降の追加ゲスト料金ポリシーID（任意） */
  additionalGuestFeePolicyId?: InputMaybe<Scalars["ID"]["input"]>;
  additionalNoticeTypes: Array<AdditionalNoticeType>;
  availableAccommodationFacilityIds: Array<Scalars["ID"]["input"]>;
  availableArchitectureTypeIds: Array<Scalars["ID"]["input"]>;
  availableSiteIds: Array<Scalars["ID"]["input"]>;
  baseAccommodationFeeMode: BaseAccommodationFeeMode;
  baseAccommodationFeePolicyId: Scalars["ID"]["input"];
  cancelFeePolicyId: Scalars["ID"]["input"];
  includeSeasonalFee: Scalars["Boolean"]["input"];
  internalDescription: Scalars["String"]["input"];
  /** アーカイブ済みかどうか */
  isArchived?: InputMaybe<Scalars["Boolean"]["input"]>;
  isBulkUsage: Scalars["Boolean"]["input"];
  lookupKey?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  notice: Scalars["String"]["input"];
  occupancyLimitTarget: OccupancyLimitTarget;
  /** 管理部署ID（SmartHR組織図の末端グループ） */
  staffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 使用したテンプレートID（任意） */
  templateId?: InputMaybe<Scalars["ID"]["input"]>;
  /** チケット区分 */
  ticketCategory?: InputMaybe<TicketCategory>;
  waiveArchitectureTypeAdditionalFee: Scalars["Boolean"]["input"];
  waiveCleaningFee: Scalars["Boolean"]["input"];
  waiveConsumedSuppliesFee: Scalars["Boolean"]["input"];
  waiveDogFee: Scalars["Boolean"]["input"];
  waiveDogRunFee: Scalars["Boolean"]["input"];
  waiveEvChargerFee: Scalars["Boolean"]["input"];
  waiveOnsenFee: Scalars["Boolean"]["input"];
  waivePeakDayFee: Scalars["Boolean"]["input"];
  waiveSaunaFee: Scalars["Boolean"]["input"];
  waiveSiteAdditionalFee: Scalars["Boolean"]["input"];
};

/** 宿泊チケットマスターの作成・更新の結果 */
export type InternalCreateOrUpdateStayTicketMasterPayload =
  | InternalCreateOrUpdateStayTicketMasterError
  | StayTicketMaster;

/** チケットマスター雛形の作成・更新時のエラー */
export type InternalCreateOrUpdateStayTicketMasterTemplateError = {
  __typename?: "InternalCreateOrUpdateStayTicketMasterTemplateError";
  case: InternalCreateOrUpdateStayTicketMasterTemplateErrorCase;
  message: Scalars["String"]["output"];
};

export const InternalCreateOrUpdateStayTicketMasterTemplateErrorCase = {
  /** 不正な入力 */
  InvalidInput: "InvalidInput",
} as const;

export type InternalCreateOrUpdateStayTicketMasterTemplateErrorCase =
  (typeof InternalCreateOrUpdateStayTicketMasterTemplateErrorCase)[keyof typeof InternalCreateOrUpdateStayTicketMasterTemplateErrorCase];
/** チケットマスター雛形の作成・更新の入力 */
export type InternalCreateOrUpdateStayTicketMasterTemplateInput = {
  /** 3人目以降の追加ゲスト料金ポリシーID（任意） */
  additionalGuestFeePolicyId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 利用可能な施設タイプID */
  availableAccommodationFacilityIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 利用可能な建築タイプID */
  availableArchitectureTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 利用可能な拠点ID */
  availableSiteIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** 基本料金モード */
  baseAccommodationFeeMode?: InputMaybe<BaseAccommodationFeeMode>;
  /** 基本宿泊料金ポリシーID */
  baseAccommodationFeePolicyId?: InputMaybe<Scalars["ID"]["input"]>;
  /** キャンセル料金ポリシーID */
  cancelFeePolicyId?: InputMaybe<Scalars["ID"]["input"]>;
  /** シーズン料金の追加有無 */
  includeSeasonalFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 管理用説明 */
  internalDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** 一括利用かどうか */
  isBulkUsage?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 表示名 */
  name: Scalars["String"]["input"];
  /** 稼働制御の対象 */
  occupancyLimitTarget?: InputMaybe<OccupancyLimitTarget>;
  /** 一意識別子 */
  slug: Scalars["String"]["input"];
  /** 施設追加料金の請求をしないかどうか */
  waiveArchitectureTypeAdditionalFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 清掃料金の請求をしないかどうか */
  waiveCleaningFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 備品料金の請求をしないかどうか */
  waiveConsumedSuppliesFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** dog料金の請求をしないかどうか */
  waiveDogFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** ドッグラン料金の請求をしないかどうか */
  waiveDogRunFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** EV Charger 料金の請求をしないかどうか */
  waiveEvChargerFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 温泉料金の請求をしないかどうか */
  waiveOnsenFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 繁忙日料金の請求をしないかどうか */
  waivePeakDayFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** サウナ料金の請求をしないかどうか */
  waiveSaunaFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 拠点別ハイシーズン料金の請求をしないかどうか */
  waiveSiteAdditionalFee?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** チケットマスター雛形の作成・更新の結果 */
export type InternalCreateOrUpdateStayTicketMasterTemplatePayload =
  | InternalCreateOrUpdateStayTicketMasterTemplateError
  | StayTicketMasterTemplate;

/** StayTicketTemplateの作成・更新時のエラー */
export type InternalCreateOrUpdateStayTicketTemplateError = {
  __typename?: "InternalCreateOrUpdateStayTicketTemplateError";
  message: Scalars["String"]["output"];
};

/** StayTicketTemplate の作成・更新時の入力 */
export type InternalCreateOrUpdateStayTicketTemplateInput = {
  /** rawExpiresAtを現在から何日後に設定するか */
  daysUntilExpiration?: InputMaybe<Scalars["Int"]["input"]>;
  /** rawStayEndNightを現在から何日後に設定するか */
  daysUntilLastStay?: InputMaybe<Scalars["Int"]["input"]>;
  /** チケット発行機能の有効／無効を設定する */
  isActive: Scalars["Boolean"]["input"];
  /** stayTicketMasterが同じでも異なる設定を入れる可能性があるので、lookupKeyで設定管理を行う */
  lookupKey: Scalars["String"]["input"];
  /** 予約期限を固定で設定する場合に使用 */
  rawExpiresAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  /** 宿泊可能終了日を固定で設定する場合に使用 */
  rawStayEndNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 宿泊可能開始日を固定で設定する場合に使用 */
  rawStayStartNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 宿泊チケットマスターのID */
  stayTicketMasterId: Scalars["ID"]["input"];
};

export type InternalCreateOrUpdateSupplyItemInstallationInput = {
  accommodationId?: InputMaybe<Scalars["ID"]["input"]>;
  architectureTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  defaultQuantity: Scalars["Int"]["input"];
  /** 既存の設置情報ID（省略時は新規作成） */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  siteId: Scalars["ID"]["input"];
};

export type InternalCreateOrUpdateSupplyItemInstallationsError = {
  __typename?: "InternalCreateOrUpdateSupplyItemInstallationsError";
  case: InternalCreateOrUpdateSupplyItemInstallationsErrorCase;
};

export const InternalCreateOrUpdateSupplyItemInstallationsErrorCase = {
  DuplicateInstallation: "DuplicateInstallation",
  InstallationNotFound: "InstallationNotFound",
  InvalidInstallationReference: "InvalidInstallationReference",
  SiteNotFound: "SiteNotFound",
  SupplyItemMasterNotFound: "SupplyItemMasterNotFound",
  TemporarilyUnavailable: "TemporarilyUnavailable",
} as const;

export type InternalCreateOrUpdateSupplyItemInstallationsErrorCase =
  (typeof InternalCreateOrUpdateSupplyItemInstallationsErrorCase)[keyof typeof InternalCreateOrUpdateSupplyItemInstallationsErrorCase];
export type InternalCreateOrUpdateSupplyItemInstallationsPayload =
  | InternalCreateOrUpdateSupplyItemInstallationsError
  | Success;

export type InternalCreateOrUpdateSupplyItemMasterError = {
  __typename?: "InternalCreateOrUpdateSupplyItemMasterError";
  case: InternalCreateOrUpdateSupplyItemMasterErrorCase;
};

export const InternalCreateOrUpdateSupplyItemMasterErrorCase = {
  RequiredFieldMissing: "RequiredFieldMissing",
  SupplyItemMasterNotFound: "SupplyItemMasterNotFound",
} as const;

export type InternalCreateOrUpdateSupplyItemMasterErrorCase =
  (typeof InternalCreateOrUpdateSupplyItemMasterErrorCase)[keyof typeof InternalCreateOrUpdateSupplyItemMasterErrorCase];
/**
 * 新規作成時は unit / isEnabled 以外が必須（isEnabled の既定は true）。
 * 更新時は指定したフィールドだけを更新し、省略したフィールドは現在値を保つ。
 */
export type InternalCreateOrUpdateSupplyItemMasterInput = {
  category?: InputMaybe<SupplyItemMasterCategory>;
  /** マスタID（省略時は新規作成） */
  id?: InputMaybe<Scalars["ID"]["input"]>;
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  namePrivate?: InputMaybe<Scalars["String"]["input"]>;
  namePublic?: InputMaybe<Scalars["String"]["input"]>;
  price?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  taxRateType?: InputMaybe<ConsumptionTaxRateType>;
  unit?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalCreateOrUpdateSupplyItemMasterPayload =
  | InternalCreateOrUpdateSupplyItemMasterError
  | SupplyItemMaster;

export type InternalCreateOtaRoomUnitInput = {
  /** 宿泊施設ID */
  accommodationId: Scalars["ID"]["input"];
  /** ユニット番号 */
  unit: Scalars["Int"]["input"];
};

export type InternalCreateRoomTypeImageUploadPolicyInput = {
  /** 部屋タイプID */
  roomTypeId: Scalars["ID"]["input"];
};

export type InternalCreateRoomTypeInput = {
  /** ルームタイプ名（例：SANU CABIN BEE｜シンプル客室） */
  name: Scalars["String"]["input"];
};

export type InternalCreateSiteActivityProgramInput = {
  /** 外部の詳細・予約ページ URL（https のみ） */
  externalUrl: Scalars["String"]["input"];
  image: UploadedFileInput;
  localizedDescription?: InputMaybe<InternalLocalizedStringInput>;
  localizedTitle: InternalLocalizedStringInput;
  /** 掲載終了日時。省略すると無期限 */
  publishEndAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  /** 掲載開始日時。省略すると登録した時点から掲載する */
  publishStartAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  /** 掲載する拠点 ID 一覧（1 件以上） */
  siteIds: Array<Scalars["ID"]["input"]>;
};

/** 拠点作成時のエラー */
export type InternalCreateSiteError = {
  __typename?: "InternalCreateSiteError";
  case: InternalCreateSiteErrorCase;
  message: Scalars["String"]["output"];
};

/** 拠点作成時のエラー種別 */
export const InternalCreateSiteErrorCase = {
  /** 指定した RemoteLOCK Location ID が RemoteLOCK に存在しない */
  RemoteLockLocationNotFound: "RemoteLockLocationNotFound",
  /** ページを公開していない状態で予約を受け付けようとした */
  SiteNotPublished: "SiteNotPublished",
} as const;

export type InternalCreateSiteErrorCase =
  (typeof InternalCreateSiteErrorCase)[keyof typeof InternalCreateSiteErrorCase];
/** 拠点FAQ画像アップロードポリシーの入力 */
export type InternalCreateSiteFaqImageUploadPolicyInput = {
  /** 拠点ID */
  siteId: Scalars["ID"]["input"];
};

/** 拠点ハイシーズン期間の作成入力 */
export type InternalCreateSiteHighSeasonPeriodInput = {
  /** 2027 年度以降の拠点追加料金 */
  additionalFeeAmount: Scalars["Int"]["input"];
  /** 終了日（1-31） */
  endDay: Scalars["Int"]["input"];
  /** 終了月（1-12） */
  endMonth: Scalars["Int"]["input"];
  /** ラベル */
  label: Scalars["String"]["input"];
  /** 拠点ID */
  siteId: Scalars["ID"]["input"];
  /** 開始日（1-31） */
  startDay: Scalars["Int"]["input"];
  /** 開始月（1-12） */
  startMonth: Scalars["Int"]["input"];
};

/** 拠点画像アップロードポリシーの入力 */
export type InternalCreateSiteImageUploadPolicyInput = {
  /** 拠点ID */
  siteId: Scalars["ID"]["input"];
};

/** 拠点作成の入力 */
export type InternalCreateSiteInput = {
  /** チェックイン認証タイプ */
  checkInAuthenticationType?: InputMaybe<CheckInAuthenticationType>;
  /** カスタム予約リード月数（未設定の場合はデフォルトの3ヶ月） */
  customReservationLeadMonths?: InputMaybe<Scalars["Int"]["input"]>;
  /** 早期チェックイン可能かどうか */
  earlyCheckInEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 多言語化された拠点名。全 locale 必須。 */
  localizedName: InternalLocalizedStringInput;
  /** 拠点名（例：一宮 1st）。旧フィールドで analytics 等で参照されている。 */
  name: Scalars["String"]["input"];
  /** 開業日 */
  openingDate: Scalars["PlainDate"]["input"];
  /** 拠点番号（例：1st, 2nd） */
  ordinalName?: InputMaybe<Scalars["String"]["input"]>;
  /** 一般開放日（一般会員が予約できる最初の宿泊日）。null なら開業日と同じ。 */
  publicOpeningDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 拠点・エリアページの公開フラグ。true でページを公開する（可視性の権威フラグ。予約を受け付けるには公開済みである必要がある）。 */
  published?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** RemoteLOCK の Location ID。拠点管理者キーの AccessPerson に紐づける。存在しない ID は保存時に拒否される */
  remoteLockLocationId?: InputMaybe<Scalars["String"]["input"]>;
  /** 予約可能かどうか */
  reservable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** オーナー先行予約可能かどうか */
  reservableForOwnerEarlyAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** スラッグ（URLに使用、英小文字・数字・ハイフンのみ） */
  slug: Scalars["String"]["input"];
  /** SwitchBot の拠点 API キー。スマートプラグの稼働状況取得に使う */
  switchbotLocationApiKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** 拠点作成の結果 */
export type InternalCreateSitePayload = InternalCreateSiteError | InternalSite;

/** StayTicketTemplateの作成・更新の結果 */
export type InternalCreateStayTicketTemplatePayload =
  | InternalCreateOrUpdateStayTicketTemplateError
  | StayTicketTemplate;

export type InternalCreateTermsRevisionError = {
  __typename?: "InternalCreateTermsRevisionError";
  case: InternalCreateTermsRevisionErrorCase;
};

export const InternalCreateTermsRevisionErrorCase = {
  /** 同じ改定日・対象の改定が既にある */
  AlreadyExists: "AlreadyExists",
  /** 入力値が不正（過去の改定日、対象を指定できない規約、個別規約を持つ OwnerPlan など） */
  InvalidInput: "InvalidInput",
  /** 規約または OwnerPlan が見つからない */
  ResourceNotFound: "ResourceNotFound",
} as const;

export type InternalCreateTermsRevisionErrorCase =
  (typeof InternalCreateTermsRevisionErrorCase)[keyof typeof InternalCreateTermsRevisionErrorCase];
export type InternalCreateTermsRevisionInput = {
  /** 社内向けの改定内容の要約 */
  internalSummary: Scalars["String"]["input"];
  revisedDate: Scalars["PlainDate"]["input"];
  /** null は規約の適用者全員。FullOwnerPlan の共通規約でのみ指定できる */
  targetOwnerPlanId?: InputMaybe<Scalars["ID"]["input"]>;
  termsId: Scalars["ID"]["input"];
};

export type InternalCreateTermsRevisionPayload =
  | InternalCreateTermsRevisionError
  | Terms;

export type InternalDeleteAccommodationEquipmentPayload =
  | InternalAccommodationEquipmentError
  | InternalDeleteAccommodationEquipmentSuccess;

export type InternalDeleteAccommodationEquipmentSuccess = {
  __typename?: "InternalDeleteAccommodationEquipmentSuccess";
  id: Scalars["ID"]["output"];
};

export type InternalDeleteArchitectureContentPayload =
  | InternalArchitectureContentError
  | Success;

export type InternalDeleteFacilityResourceBlockError = {
  __typename?: "InternalDeleteFacilityResourceBlockError";
  case: InternalDeleteFacilityResourceBlockErrorCase;
};

export const InternalDeleteFacilityResourceBlockErrorCase = {
  BlockNotFound: "BlockNotFound",
  CannotDeleteUserBlock: "CannotDeleteUserBlock",
} as const;

export type InternalDeleteFacilityResourceBlockErrorCase =
  (typeof InternalDeleteFacilityResourceBlockErrorCase)[keyof typeof InternalDeleteFacilityResourceBlockErrorCase];
export type InternalDeleteFacilityResourceBlockPayload =
  | InternalDeleteFacilityResourceBlockError
  | Success;

export type InternalDeleteLocalTaxPolicyError = {
  __typename?: "InternalDeleteLocalTaxPolicyError";
  case: InternalDeleteLocalTaxPolicyErrorCase;
};

export const InternalDeleteLocalTaxPolicyErrorCase = {
  /** 拠点・部屋に適用されている */
  LinkedToSiteOrAccommodation: "LinkedToSiteOrAccommodation",
} as const;

export type InternalDeleteLocalTaxPolicyErrorCase =
  (typeof InternalDeleteLocalTaxPolicyErrorCase)[keyof typeof InternalDeleteLocalTaxPolicyErrorCase];
export type InternalDeleteLocalTaxPolicyPayload =
  | InternalDeleteLocalTaxPolicyError
  | Success;

export type InternalDeleteSupplyItemInstallationError = {
  __typename?: "InternalDeleteSupplyItemInstallationError";
  case: InternalDeleteSupplyItemInstallationErrorCase;
};

export const InternalDeleteSupplyItemInstallationErrorCase = {
  InstallationNotFound: "InstallationNotFound",
} as const;

export type InternalDeleteSupplyItemInstallationErrorCase =
  (typeof InternalDeleteSupplyItemInstallationErrorCase)[keyof typeof InternalDeleteSupplyItemInstallationErrorCase];
export type InternalDeleteSupplyItemInstallationPayload =
  | InternalDeleteSupplyItemInstallationError
  | Success;

export type InternalDeleteSupplyItemMasterError = {
  __typename?: "InternalDeleteSupplyItemMasterError";
  case: InternalDeleteSupplyItemMasterErrorCase;
};

export const InternalDeleteSupplyItemMasterErrorCase = {
  HasActiveInstallations: "HasActiveInstallations",
  SupplyItemMasterNotFound: "SupplyItemMasterNotFound",
} as const;

export type InternalDeleteSupplyItemMasterErrorCase =
  (typeof InternalDeleteSupplyItemMasterErrorCase)[keyof typeof InternalDeleteSupplyItemMasterErrorCase];
export type InternalDeleteSupplyItemMasterPayload =
  | InternalDeleteSupplyItemMasterError
  | Success;

/** リソースのコントローラ */
export type InternalFacilityController = {
  __typename?: "InternalFacilityController";
  attribute?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  type: FacilityResourceControllerType;
};

/** 管理者が付帯サービス予約に適用する割引 */
export type InternalFacilityReservationDiscountInput = {
  /** 割引タイプ（Value: 固定金額, Percentage: 割引率） */
  discountModifierType: FeeModifierType;
  /** 割引値（Percentageの場合は割引率%（1〜100）, Valueの場合は割引額・円。いずれも 1 以上） */
  discountValue: Scalars["Int"]["input"];
  /** 割引理由。FacilityReservation.discountReason に保存され、管理画面でのみ表示する */
  label: Scalars["String"]["input"];
};

export type InternalFutureCleaningAmount = {
  __typename?: "InternalFutureCleaningAmount";
  /** その日に清掃が必要な部屋のリスト（デバッグ用） */
  accommodations: Array<Accommodation>;
  /** その日の全体の必要清掃数（=部屋数） */
  amount: Scalars["Int"]["output"];
  /** 部屋の設備組み合わせごとに分類した必要清掃数 */
  amountByFacilities: Array<InternalFutureCleaningAmountByFacility>;
  /** 清掃に入る日付 */
  date: Scalars["PlainDate"]["output"];
};

export type InternalFutureCleaningAmountByFacility = {
  __typename?: "InternalFutureCleaningAmountByFacility";
  /** 必要清掃数 */
  amount: Scalars["Int"]["output"];
  /** 設備組み合わせの名前 */
  facilityCombinationName: Scalars["String"]["output"];
};

export type InternalFutureCleaningAmounts = {
  __typename?: "InternalFutureCleaningAmounts";
  list: Array<InternalFutureCleaningAmount>;
};

export type InternalFutureCleaningAmountsError = {
  __typename?: "InternalFutureCleaningAmountsError";
  message: Scalars["String"]["output"];
};

export type InternalFutureCleaningAmountsPayload =
  | InternalFutureCleaningAmounts
  | InternalFutureCleaningAmountsError;

export type InternalGenerateUserMonthlyStatementError = {
  __typename?: "InternalGenerateUserMonthlyStatementError";
  case: InternalGenerateUserMonthlyStatementErrorCase;
  message?: Maybe<Scalars["String"]["output"]>;
};

export const InternalGenerateUserMonthlyStatementErrorCase = {
  /** ユーザーが見つからない */
  UserNotFound: "UserNotFound",
} as const;

export type InternalGenerateUserMonthlyStatementErrorCase =
  (typeof InternalGenerateUserMonthlyStatementErrorCase)[keyof typeof InternalGenerateUserMonthlyStatementErrorCase];
export type InternalGenerateUserMonthlyStatementPayload =
  | InternalGenerateUserMonthlyStatementError
  | UserMonthlyStatement;

/** 画面から付与できる管理ロール */
export type InternalGrantableAdminRole = {
  __typename?: "InternalGrantableAdminRole";
  role: AdminRole;
  /** 割り当てに要るスコープの軸。Site なら拠点の指定が必須、null なら指定できない */
  scope?: Maybe<ScopeDimension>;
};

export type InternalInvalidateOrganizationYearlyContractError = {
  __typename?: "InternalInvalidateOrganizationYearlyContractError";
  case: InternalInvalidateOrganizationYearlyContractErrorCase;
};

export const InternalInvalidateOrganizationYearlyContractErrorCase = {
  /** 対象契約期間内に予約が存在する */
  ReservationsExistInContractPeriod: "ReservationsExistInContractPeriod",
} as const;

export type InternalInvalidateOrganizationYearlyContractErrorCase =
  (typeof InternalInvalidateOrganizationYearlyContractErrorCase)[keyof typeof InternalInvalidateOrganizationYearlyContractErrorCase];
export type InternalInvalidateOrganizationYearlyContractInvoiceError = {
  __typename?: "InternalInvalidateOrganizationYearlyContractInvoiceError";
  case: InternalInvalidateOrganizationYearlyContractInvoiceErrorCase;
};

export const InternalInvalidateOrganizationYearlyContractInvoiceErrorCase = {
  /** 既に無効化されている */
  InvoiceIsAlreadyInvalidated: "InvoiceIsAlreadyInvalidated",
  /** 支払い済みのinvoiceは無効化できない */
  InvoiceIsPaid: "InvoiceIsPaid",
  /** 回収不能状態のinvoiceは無効化できない */
  InvoiceIsUncollectible: "InvoiceIsUncollectible",
} as const;

export type InternalInvalidateOrganizationYearlyContractInvoiceErrorCase =
  (typeof InternalInvalidateOrganizationYearlyContractInvoiceErrorCase)[keyof typeof InternalInvalidateOrganizationYearlyContractInvoiceErrorCase];
export type InternalInvalidateOrganizationYearlyContractInvoicePayload =
  | InternalInvalidateOrganizationYearlyContractInvoiceError
  | Success;

export type InternalInvalidateOrganizationYearlyContractPayload =
  | InternalInvalidateOrganizationYearlyContractError
  | Success;

export type InternalInvalidateS2oPointsError = {
  __typename?: "InternalInvalidateS2oPointsError";
  case: InternalInvalidateS2oPointsErrorCase;
};

export const InternalInvalidateS2oPointsErrorCase = {
  /** ユーザーが見つからない */
  UserNotFound: "UserNotFound",
} as const;

export type InternalInvalidateS2oPointsErrorCase =
  (typeof InternalInvalidateS2oPointsErrorCase)[keyof typeof InternalInvalidateS2oPointsErrorCase];
export type InternalInvalidateS2oPointsInput = {
  /** メモ */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** ユーザーID */
  userId: Scalars["ID"]["input"];
};

export type InternalInvalidateS2oPointsPayload =
  | InternalInvalidateS2oPointsError
  | Success;

/** Stay Ticket無効化の結果 */
export type InternalInvalidateStayTicketsByCodeResult = {
  __typename?: "InternalInvalidateStayTicketsByCodeResult";
  /** 無効化されたチケット（Open → Voidに変更） */
  invalidatedTickets: Array<StayTicket>;
  /** 見つからなかったcode */
  notFoundCodes: Array<Scalars["String"]["output"]>;
  /** スキップされたチケット（Open以外のステータスだったチケット） */
  skippedTickets: Array<StayTicket>;
};

export type InternalIssueS2oPointsError = {
  __typename?: "InternalIssueS2oPointsError";
  case: InternalIssueS2oPointsErrorCase;
};

export const InternalIssueS2oPointsErrorCase = {
  /** 残高不足 */
  InsufficientBalance: "InsufficientBalance",
  /** 無効な金額（0など） */
  InvalidAmount: "InvalidAmount",
  /** 無効な日付（未来または3年以上前） */
  InvalidDate: "InvalidDate",
  /** 無効なトランザクションタイプ */
  InvalidTransactionType: "InvalidTransactionType",
  /** トライアル契約が見つからない */
  TrialContractNotFound: "TrialContractNotFound",
  /** ユーザーが見つからない */
  UserNotFound: "UserNotFound",
} as const;

export type InternalIssueS2oPointsErrorCase =
  (typeof InternalIssueS2oPointsErrorCase)[keyof typeof InternalIssueS2oPointsErrorCase];
export type InternalIssueS2oPointsInput = {
  /** 付与するポイント数 */
  amount: Scalars["Int"]["input"];
  /** 付与日（省略時は今日） */
  date?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** メモ */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** トランザクションタイプ */
  transactionType: S2oPointAdminTransactionType;
  /** ユーザーID */
  userId: Scalars["ID"]["input"];
};

export type InternalIssueS2oPointsPayload =
  | InternalIssueS2oPointsError
  | Success;

export type InternalJtasCreateOrUpdateInspectionStatusesError = {
  __typename?: "InternalJtasCreateOrUpdateInspectionStatusesError";
  case: InternalJtasCreateOrUpdateInspectionStatusesErrorCase;
};

export const InternalJtasCreateOrUpdateInspectionStatusesErrorCase = {
  ReservationNotFound: "ReservationNotFound",
} as const;

export type InternalJtasCreateOrUpdateInspectionStatusesErrorCase =
  (typeof InternalJtasCreateOrUpdateInspectionStatusesErrorCase)[keyof typeof InternalJtasCreateOrUpdateInspectionStatusesErrorCase];
export type InternalJtasCreateOrUpdateInspectionStatusesInput = {
  items: Array<InternalJtasInspectionStatusInput>;
};

export type InternalJtasCreateOrUpdateInspectionStatusesPayload =
  | InternalJtasCreateOrUpdateInspectionStatusesError
  | Success;

export type InternalJtasCreateOrUpdateSupplyReportError = {
  __typename?: "InternalJtasCreateOrUpdateSupplyReportError";
  case: InternalJtasCreateOrUpdateSupplyReportErrorCase;
};

export const InternalJtasCreateOrUpdateSupplyReportErrorCase = {
  MediaFetchFailed: "MediaFetchFailed",
  ReservationCanceled: "ReservationCanceled",
  ReservationNotFound: "ReservationNotFound",
  SupplyItemMasterNotFound: "SupplyItemMasterNotFound",
  SupplyReportClosed: "SupplyReportClosed",
} as const;

export type InternalJtasCreateOrUpdateSupplyReportErrorCase =
  (typeof InternalJtasCreateOrUpdateSupplyReportErrorCase)[keyof typeof InternalJtasCreateOrUpdateSupplyReportErrorCase];
export type InternalJtasCreateOrUpdateSupplyReportInput = {
  accommodationId: Scalars["ID"]["input"];
  imageUrls?: InputMaybe<Array<Scalars["String"]["input"]>>;
  inspectionDate: Scalars["PlainDate"]["input"];
  supplyItems: Array<InternalJtasSupplyItemInput>;
};

export type InternalJtasCreateOrUpdateSupplyReportPayload =
  | InternalJtasCreateOrUpdateSupplyReportError
  | Success;

export type InternalJtasCreateOrUpdateViolationReportError = {
  __typename?: "InternalJtasCreateOrUpdateViolationReportError";
  case: InternalJtasCreateOrUpdateViolationReportErrorCase;
};

export const InternalJtasCreateOrUpdateViolationReportErrorCase = {
  MediaFetchFailed: "MediaFetchFailed",
  ReservationNotFound: "ReservationNotFound",
  ViolationReportClosed: "ViolationReportClosed",
} as const;

export type InternalJtasCreateOrUpdateViolationReportErrorCase =
  (typeof InternalJtasCreateOrUpdateViolationReportErrorCase)[keyof typeof InternalJtasCreateOrUpdateViolationReportErrorCase];
export type InternalJtasCreateOrUpdateViolationReportInput = {
  accommodationId: Scalars["ID"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  externalReportId: Scalars["String"]["input"];
  imageUrls?: InputMaybe<Array<Scalars["String"]["input"]>>;
  inspectionDate: Scalars["PlainDate"]["input"];
  violationItems: Array<InternalJtasViolationItemInput>;
};

export type InternalJtasCreateOrUpdateViolationReportPayload =
  | InternalJtasCreateOrUpdateViolationReportError
  | Success;

export type InternalJtasDeleteViolationReportError = {
  __typename?: "InternalJtasDeleteViolationReportError";
  case: InternalJtasDeleteViolationReportErrorCase;
};

export const InternalJtasDeleteViolationReportErrorCase = {
  ViolationReportClosed: "ViolationReportClosed",
  ViolationReportNotFound: "ViolationReportNotFound",
} as const;

export type InternalJtasDeleteViolationReportErrorCase =
  (typeof InternalJtasDeleteViolationReportErrorCase)[keyof typeof InternalJtasDeleteViolationReportErrorCase];
export type InternalJtasDeleteViolationReportInput = {
  externalReportId: Scalars["String"]["input"];
};

export type InternalJtasDeleteViolationReportPayload =
  | InternalJtasDeleteViolationReportError
  | Success;

export type InternalJtasInspectionStatusInput = {
  accommodationId: Scalars["ID"]["input"];
  inspectionDate: Scalars["PlainDate"]["input"];
  status: InspectionStatusType;
};

export type InternalJtasSupplyItemInput = {
  quantity: Scalars["Int"]["input"];
  supplyItemMasterId: Scalars["ID"]["input"];
};

export type InternalJtasViolationItemInput = {
  typeId: Scalars["Int"]["input"];
  typeName: Scalars["String"]["input"];
};

export type InternalLeaveOrganizationError = {
  __typename?: "InternalLeaveOrganizationError";
  case: InternalLeaveOrganizationErrorCase;
};

export const InternalLeaveOrganizationErrorCase = {
  /** 法人プランの予約が残っている */
  HasActiveReservation: "HasActiveReservation",
} as const;

export type InternalLeaveOrganizationErrorCase =
  (typeof InternalLeaveOrganizationErrorCase)[keyof typeof InternalLeaveOrganizationErrorCase];
export type InternalLeaveOrganizationPayload =
  | InternalLeaveOrganizationError
  | Success;

export type InternalLocalTaxFixedAmountInput = {
  /** 1 人 1 泊あたりの税額 */
  taxAmount: Scalars["Decimal"]["input"];
};

export type InternalLocalTaxFixedRateInput = {
  /** 1 人 1 泊あたりの最大税額。null は上限なし */
  maxTaxAmount?: InputMaybe<Scalars["Decimal"]["input"]>;
  /** 1 人 1 泊あたりの宿泊費（税抜）に掛ける税率（3% は 0.03） */
  taxRate: Scalars["Decimal"]["input"];
};

/** 地方税の税額の定め。いずれか 1 つだけを指定する */
export type InternalLocalTaxRuleInput =
  /** 一律定額 */
  | {
      fixedAmount: InternalLocalTaxFixedAmountInput;
      fixedRate?: never;
      steppedAmount?: never;
    } /** 一律比率 */
  | {
      fixedAmount?: never;
      fixedRate: InternalLocalTaxFixedRateInput;
      steppedAmount?: never;
    } /** 段階的定額 */
  | {
      fixedAmount?: never;
      fixedRate?: never;
      steppedAmount: InternalLocalTaxSteppedAmountInput;
    };

export type InternalLocalTaxSteppedAmountInput = {
  /** 2 件以上。0 円から隙間なく続き、最後の区分は上限なし */
  brackets: Array<InternalLocalTaxSteppedBracketInput>;
};

export type InternalLocalTaxSteppedBracketInput = {
  /** 同上の上限（含まない）。null は上限なし */
  maxAmount?: InputMaybe<Scalars["Decimal"]["input"]>;
  /** 1 人 1 泊あたりの宿泊費（税抜）の下限（含む） */
  minAmount: Scalars["Decimal"]["input"];
  /** 1 人 1 泊あたりの税額 */
  taxAmount: Scalars["Decimal"]["input"];
};

/**
 * 多言語化されたコンテンツを保持する type。各 locale field は optional (null = 未入力)。
 * admin の編集 UI が「locale ごとに値があるか」を扱える形にした。
 * GraphQL field 名はハイフン不可なので zhCn は camelCase。
 */
export type InternalLocalizedString = {
  __typename?: "InternalLocalizedString";
  en?: Maybe<Scalars["String"]["output"]>;
  ja?: Maybe<Scalars["String"]["output"]>;
  zhCn?: Maybe<Scalars["String"]["output"]>;
  zhTw?: Maybe<Scalars["String"]["output"]>;
};

/**
 * 多言語化されたコンテンツの入力。各 locale field は optional (未入力時は null)。
 * GraphQL field 名はハイフン不可なので zhCn は camelCase。
 */
export type InternalLocalizedStringInput = {
  en?: InputMaybe<Scalars["String"]["input"]>;
  ja?: InputMaybe<Scalars["String"]["input"]>;
  zhCn?: InputMaybe<Scalars["String"]["input"]>;
  zhTw?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalMarkCoOwnersApplicationPlannedForSaleError = {
  __typename?: "InternalMarkCoOwnersApplicationPlannedForSaleError";
  case: InternalMarkCoOwnersApplicationPlannedForSaleErrorCase;
};

export const InternalMarkCoOwnersApplicationPlannedForSaleErrorCase = {
  /** 売却口数が 1 未満、またはオーナーシップが現在持つ口数を超えている */
  InvalidSaleUnits: "InvalidSaleUnits",
  /** ステータスが引渡完了でないため売却予定にできない */
  InvalidStatusTransition: "InvalidStatusTransition",
  /** 次年度以降の宿泊権利が残る口数分を超えて消費されているため減らせない */
  NextYearStayCreditsInUse: "NextYearStayCreditsInUse",
  /** データが存在しない */
  NotFound: "NotFound",
  /** 申込に紐づく UserOwnership が存在しない（データ不整合） */
  OwnershipNotFound: "OwnershipNotFound",
  /** 権限が不足している */
  PermissionDenied: "PermissionDenied",
  /** 売却月が引渡月より前 */
  SaleMonthBeforeHandover: "SaleMonthBeforeHandover",
  /** 売却月が売却済の前回の売却月より前 */
  SaleMonthBeforePreviousSale: "SaleMonthBeforePreviousSale",
  /** 売却月を後ろにずらすと減らした宿泊権利を元に戻す必要があるため変更不可 */
  SaleMonthRequiresCreditRestore: "SaleMonthRequiresCreditRestore",
  /** 他の更新と競合したため一時的に実行できない（リトライ可能） */
  TemporarilyUnavailable: "TemporarilyUnavailable",
} as const;

export type InternalMarkCoOwnersApplicationPlannedForSaleErrorCase =
  (typeof InternalMarkCoOwnersApplicationPlannedForSaleErrorCase)[keyof typeof InternalMarkCoOwnersApplicationPlannedForSaleErrorCase];
export type InternalMarkCoOwnersApplicationPlannedForSalePayload =
  | CoOwnersApplication
  | InternalMarkCoOwnersApplicationPlannedForSaleError;

export type InternalMarkCoOwnersApplicationSoldError = {
  __typename?: "InternalMarkCoOwnersApplicationSoldError";
  case: InternalMarkCoOwnersApplicationSoldErrorCase;
};

export const InternalMarkCoOwnersApplicationSoldErrorCase = {
  /** 紐づくアクティブな予約があるため売却済にできない */
  HasActiveReservations: "HasActiveReservations",
  /** 未滞在の StayGift（Open / Reserved）が残っているため売却済にできない */
  HasActiveStayGifts: "HasActiveStayGifts",
  /** ステータスが売却予定でないため売却済にできない */
  InvalidStatusTransition: "InvalidStatusTransition",
  /** データが存在しない */
  NotFound: "NotFound",
  /** 申込に紐づく UserOwnership が存在しない（データ不整合） */
  OwnershipNotFound: "OwnershipNotFound",
  /** 権限が不足している */
  PermissionDenied: "PermissionDenied",
} as const;

export type InternalMarkCoOwnersApplicationSoldErrorCase =
  (typeof InternalMarkCoOwnersApplicationSoldErrorCase)[keyof typeof InternalMarkCoOwnersApplicationSoldErrorCase];
export type InternalMarkCoOwnersApplicationSoldPayload =
  | CoOwnersApplication
  | InternalMarkCoOwnersApplicationSoldError;

/** 管理者用 NativeAppHomeContent エンティティ */
export type InternalNativeAppHomeContent = {
  __typename?: "InternalNativeAppHomeContent";
  /** 作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** 説明 */
  description?: Maybe<InternalLocalizedString>;
  /** ID */
  id: Scalars["ID"]["output"];
  /** 画像 URL */
  imageUrl: UploadedFile;
  /** ラベル */
  label?: Maybe<InternalLocalizedString>;
  /** ラベルタイプ */
  labelType: NativeAppHomeContentLabelType;
  /** リンク */
  link: InternalLocalizedString;
  /** リンクアクション */
  linkAction: NativeAppHomeContentLinkAction;
  /** リンクラベル */
  linkLabel?: Maybe<InternalLocalizedString>;
  /** 並び順 */
  sort: Scalars["Int"]["output"];
  /** 公開状態 */
  status: NativeAppHomeContentStatus;
  /** タイトル */
  title?: Maybe<InternalLocalizedString>;
  /** 更新日時 */
  updatedAt: Scalars["ZonedDateTime"]["output"];
  /** 更新者 */
  updatedUser: User;
};

/** NativeAppHomeContent 管理者用入力 */
export type InternalNativeAppHomeContentInput = {
  /** 説明 */
  description?: InputMaybe<InternalLocalizedStringInput>;
  /** 画像 URL */
  imageUrl: UploadedFileInput;
  /** ラベル */
  label?: InputMaybe<InternalLocalizedStringInput>;
  /** ラベルタイプ */
  labelType?: InputMaybe<NativeAppHomeContentLabelType>;
  /** リンク */
  link: InternalLocalizedStringInput;
  /** リンクアクション */
  linkAction?: InputMaybe<NativeAppHomeContentLinkAction>;
  /** リンクラベル */
  linkLabel?: InputMaybe<InternalLocalizedStringInput>;
  /** 並び順 */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  /** 公開状態 */
  status?: InputMaybe<NativeAppHomeContentStatus>;
  /** タイトル */
  title?: InputMaybe<InternalLocalizedStringInput>;
};

/** レジストリに登録された one-shot スクリプトのメタ情報とソース */
export type InternalOneShotScript = {
  __typename?: "InternalOneShotScript";
  description: Scalars["String"]["output"];
  /** 最後に実行 (dry-run 含む) が開始された日時。実行履歴が無ければ null */
  lastExecutedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** ベース admin 権限に追加で要求する権限ラベル (表示用) */
  requiredPermission?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["ID"]["output"];
  /** read-only のソーステキスト (ビルド時生成マップ由来) */
  source: Scalars["String"]["output"];
  /** ビルド時に Shiki でハイライト済みのソース HTML (light/dark dual theme) */
  sourceHtml: Scalars["String"]["output"];
  supportsDryRun: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

/** OTAルームユニット */
export type InternalOtaRoomUnit = {
  __typename?: "InternalOtaRoomUnit";
  accommodation: Accommodation;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  unit: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type InternalPartialUpdateOrganizationError = {
  __typename?: "InternalPartialUpdateOrganizationError";
  message: Scalars["String"]["output"];
};

export type InternalPartialUpdateOrganizationPayload =
  | InternalPartialUpdateOrganizationError
  | Organization;

export type InternalRegisterCoOwnersApplicationFileInput = {
  coOwnersApplicationId: Scalars["ID"]["input"];
  fileName: Scalars["String"]["input"];
  rawUrl: Scalars["String"]["input"];
  visibleToApplicant: Scalars["Boolean"]["input"];
};

export type InternalReleaseAccessKeyError = {
  __typename?: "InternalReleaseAccessKeyError";
  message: Scalars["String"]["output"];
};

export type InternalReleaseAccessKeyPayload =
  | InternalReleaseAccessKeyError
  | Success;

export type InternalRemoveLocalTaxPolicyError = {
  __typename?: "InternalRemoveLocalTaxPolicyError";
  case: InternalRemoveLocalTaxPolicyErrorCase;
};

export const InternalRemoveLocalTaxPolicyErrorCase = {
  /** 解除する拠点・部屋の予約の税額計算に使われている */
  UsedForTaxCalculation: "UsedForTaxCalculation",
} as const;

export type InternalRemoveLocalTaxPolicyErrorCase =
  (typeof InternalRemoveLocalTaxPolicyErrorCase)[keyof typeof InternalRemoveLocalTaxPolicyErrorCase];
export type InternalRemoveLocalTaxPolicyPayload =
  | InternalRemoveLocalTaxPolicyError
  | LocalTaxPolicy;

/** 地方税ポリシーの適用を解除する対象。いずれか 1 つだけを指定する */
export type InternalRemoveLocalTaxPolicyTargetInput =
  /** 入湯税の適用を解除する部屋 */
  | {
      accommodationId: Scalars["ID"]["input"];
      siteId?: never;
    } /** 宿泊税の適用を解除する拠点 */
  | { accommodationId?: never; siteId: Scalars["ID"]["input"] };

/** 宿泊施設並び順更新の入力 */
export type InternalReorderAccommodationInput = {
  /** 宿泊施設ID */
  id: Scalars["ID"]["input"];
  /** 新しい並び順 */
  sort: Scalars["Int"]["input"];
};

/** 建築コンテンツ系の並び順更新の入力 */
export type InternalReorderArchitectureContentInput = {
  id: Scalars["ID"]["input"];
  /** 新しい並び順 */
  sort: Scalars["Int"]["input"];
};

/** エリア並び順更新の入力 */
export type InternalReorderAreaInput = {
  /** エリアID */
  id: Scalars["ID"]["input"];
  /** 新しい並び順 */
  sort: Scalars["Int"]["input"];
};

/** 並び順更新の汎用入力 */
export type InternalReorderInput = {
  id: Scalars["ID"]["input"];
  sort: Scalars["Int"]["input"];
};

/** 拠点FAQ並び順更新の入力 */
export type InternalReorderSiteFaqInput = {
  /** FAQ ID */
  id: Scalars["ID"]["input"];
  /** 新しい並び順 */
  sort: Scalars["Int"]["input"];
};

/** 拠点並び順更新の入力 */
export type InternalReorderSiteInput = {
  /** 拠点ID */
  id: Scalars["ID"]["input"];
  /** 新しい並び順 */
  sort: Scalars["Int"]["input"];
};

export type InternalRevokeAdminRoleError = {
  __typename?: "InternalRevokeAdminRoleError";
  code: InternalRevokeAdminRoleErrorCode;
  message: Scalars["String"]["output"];
};

export const InternalRevokeAdminRoleErrorCode = {
  AlreadyRevoked: "AlreadyRevoked",
  NotFound: "NotFound",
  /** 呼び出し元が外せないロールの割り当て。外せるのは自分が付与できるロールだけ */
  RoleNotRevocable: "RoleNotRevocable",
  /** 自分自身の割り当て */
  SelfRevocation: "SelfRevocation",
} as const;

export type InternalRevokeAdminRoleErrorCode =
  (typeof InternalRevokeAdminRoleErrorCode)[keyof typeof InternalRevokeAdminRoleErrorCode];
export type InternalRevokeAdminRolePayload =
  | AdminRoleAssignment
  | InternalRevokeAdminRoleError;

/** ルームタイプ（OTA Room Type と自社 Room Type を統合した統一モデル） */
export type InternalRoomType = {
  __typename?: "InternalRoomType";
  /** 関連する建築タイプ（既存データには未設定で null） */
  architectureType?: Maybe<ArchitectureType>;
  beds24RoomId: Scalars["Int"]["output"];
  /** 表示コンテンツ（CMS 編集用） */
  content?: Maybe<InternalContentRoomType>;
  createdAt: Scalars["DateTime"]["output"];
  /** 自社サービス向け多言語表示名。未設定なら name にフォールバック */
  displayNames?: Maybe<InternalLocalizedString>;
  /** 特徴（多対多） */
  features: Array<InternalRoomTypeFeature>;
  id: Scalars["ID"]["output"];
  /** OTA / Beds24 側の名前 */
  name: Scalars["String"]["output"];
  /** 多言語備考 */
  notes?: Maybe<InternalLocalizedString>;
  otaRoomUnits: Array<InternalOtaRoomUnit>;
  /** URL 用 slug（site 内でユニーク） */
  slug?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** ルームタイプの「特徴」マスター */
export type InternalRoomTypeFeature = {
  __typename?: "InternalRoomTypeFeature";
  /**
   * 対応する Accommodation 設備タイプ。
   * null = RoomType.features だけで完結する特徴（fuji-view 等）、
   * non-null = Accommodation 粒度でも評価が必要な設備（サウナ・温泉 等）。
   */
  accommodationFacilityType?: Maybe<AccommodationFacilityType>;
  category: RoomTypeFeatureCategory;
  iconSlug?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 多言語表示名 */
  name: InternalLocalizedString;
  slug: Scalars["String"]["output"];
  /** 表示・組み立て時の並び順（昇順、全体共通） */
  sort: Scalars["Int"]["output"];
};

export type InternalRunOneShotScriptError = {
  __typename?: "InternalRunOneShotScriptError";
  case: InternalRunOneShotScriptErrorCase;
  message: Scalars["String"]["output"];
};

export const InternalRunOneShotScriptErrorCase = {
  /** 同一スクリプトが既に実行中 */
  AlreadyRunning: "AlreadyRunning",
  /** confirmation が slug と一致しない */
  ConfirmationMismatch: "ConfirmationMismatch",
  /** 本番実行なのに confirmation が無い */
  ConfirmationRequired: "ConfirmationRequired",
  /** dry-run 非対応スクリプトに dryRun=true が指定された */
  DryRunNotSupported: "DryRunNotSupported",
  /** 指定 id のスクリプトがレジストリに無い */
  ScriptNotFound: "ScriptNotFound",
} as const;

export type InternalRunOneShotScriptErrorCase =
  (typeof InternalRunOneShotScriptErrorCase)[keyof typeof InternalRunOneShotScriptErrorCase];
export type InternalRunOneShotScriptInput = {
  /** 本番実行 (dryRun=false) のときに必須の確認トークン (= slug) */
  confirmation?: InputMaybe<Scalars["String"]["input"]>;
  /** true で副作用なしの dry-run。デフォルトは UI 側で ON */
  dryRun: Scalars["Boolean"]["input"];
  slug: Scalars["ID"]["input"];
};

export type InternalRunOneShotScriptResult =
  | InternalRunOneShotScriptError
  | InternalScriptExecution;

export type InternalScriptAffectedCount = {
  __typename?: "InternalScriptAffectedCount";
  key: Scalars["String"]["output"];
  value: Scalars["Int"]["output"];
};

export type InternalScriptExecution = {
  __typename?: "InternalScriptExecution";
  affected: Array<InternalScriptAffectedCount>;
  dryRun: Scalars["Boolean"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  finishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** finishedAt が null かつ十分古い場合に true (プロセスクラッシュ等で宙吊り) */
  interrupted: Scalars["Boolean"]["output"];
  logs: Array<InternalScriptExecutionLogLine>;
  slug: Scalars["ID"]["output"];
  startedAt: Scalars["DateTime"]["output"];
  status: ScriptExecutionStatus;
  summary?: Maybe<Scalars["String"]["output"]>;
  triggeredBy: InternalScriptExecutionActor;
};

export type InternalScriptExecutionActor = {
  __typename?: "InternalScriptExecutionActor";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type InternalScriptExecutionLogLine = {
  __typename?: "InternalScriptExecutionLogLine";
  level: ScriptLogLevel;
  message: Scalars["String"]["output"];
  ts: Scalars["DateTime"]["output"];
};

/** ユーザー指定プッシュ通知のエラー */
export type InternalSendPushNotificationsError = {
  __typename?: "InternalSendPushNotificationsError";
  case: InternalSendPushNotificationsErrorCase;
  message: Scalars["String"]["output"];
};

/** ユーザー指定プッシュ通知のエラー種別 */
export const InternalSendPushNotificationsErrorCase = {
  /** 宛先が空、または title と body の両方が未指定 */
  InvalidInput: "InvalidInput",
  /** 指定した Email に一致するユーザーがいない */
  NoAppInstallations: "NoAppInstallations",
} as const;

export type InternalSendPushNotificationsErrorCase =
  (typeof InternalSendPushNotificationsErrorCase)[keyof typeof InternalSendPushNotificationsErrorCase];
/** ユーザー指定プッシュ通知の入力 */
export type InternalSendPushNotificationsInput = {
  /** 本文。title と body の少なくとも一方は必須 */
  body?: InputMaybe<Scalars["String"]["input"]>;
  /** 送信先ユーザーの Email アドレス */
  emails: Array<Scalars["String"]["input"]>;
  /** 通知に添付する画像 URL */
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 通知タップ時に開くリンク URL */
  linkUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** タイトル。title と body の少なくとも一方は必須 */
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/** ユーザー指定プッシュ通知の結果 */
export type InternalSendPushNotificationsPayload =
  | InternalSendPushNotificationsError
  | InternalSendPushNotificationsResult;

/**
 * ユーザー指定プッシュ通知の送信結果。
 * どのアドレスに届かなかったかを管理画面で確かめられるよう、件数ではなく Email をそのまま返す
 */
export type InternalSendPushNotificationsResult = {
  __typename?: "InternalSendPushNotificationsResult";
  /** 端末に送信できた Email */
  deliveredEmails: Array<Scalars["String"]["output"]>;
  /** 送信を試みたが届かなかった Email */
  failedEmails: Array<Scalars["String"]["output"]>;
  /** ユーザーはいるが通知先の端末が登録されていない Email */
  noDeviceEmails: Array<Scalars["String"]["output"]>;
  /** 一致するユーザーがいなかった Email。大文字小文字まで一致する必要がある */
  notFoundEmails: Array<Scalars["String"]["output"]>;
};

/** 管理画面用の拠点型。public `Site` には載せたくない field（Beds24 連携・多言語名など）を含む。 */
export type InternalSite = {
  __typename?: "InternalSite";
  /** 拠点内の宿泊施設一覧 */
  accommodations: Array<Accommodation>;
  /** 拠点があるエリア */
  area: InternalArea;
  /** Beds24プロパティID（未連携の場合は null） */
  beds24PropertyId?: Maybe<Scalars["Int"]["output"]>;
  /** チェックイン認証タイプ */
  checkInAuthenticationType: CheckInAuthenticationType;
  /** 拠点コンテンツ */
  content: SiteContent;
  /** カスタム予約リード月数（未設定の場合は null） */
  customReservationLeadMonths?: Maybe<Scalars["Int"]["output"]>;
  /** 早期チェックイン可能か */
  earlyCheckInEnabled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** 多言語化された拠点名。admin の編集 UI で各 locale の値を取得するために使用する。 */
  localizedName: InternalLocalizedString;
  /** 拠点名（canonical）。admin 表示用なので caller.locale による localize はしない。 */
  name: Scalars["String"]["output"];
  /** 開業日 */
  openingDate: Scalars["PlainDate"]["output"];
  /** 拠点番号（例: 1st, 2nd） */
  ordinalName?: Maybe<Scalars["String"]["output"]>;
  /** 一般開放日（一般会員が予約できる最初の宿泊日）。null なら開業日と同じ。 */
  publicOpeningDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 拠点・エリアページの公開フラグ。true でページを公開する（可視性の権威フラグ。予約を受け付けるには公開済みである必要がある）。 */
  published: Scalars["Boolean"]["output"];
  /**
   * RemoteLock の Location ID（未設定の場合は null）。拠点管理者キーの AccessPerson に
   * 拠点内の全デバイスへのアクセスを一括付与するのに使う。
   */
  remoteLockLocationId?: Maybe<Scalars["String"]["output"]>;
  /** 予約可能か */
  reservable: Scalars["Boolean"]["output"];
  /** オーナー先行予約可能か */
  reservableForOwnerEarlyAccess: Scalars["Boolean"]["output"];
  /** ルームタイプ特徴マスター一覧（sort 昇順、全 site 共通） */
  roomTypeFeatures: Array<InternalRoomTypeFeature>;
  /** ルームタイプ一覧 */
  roomTypes: Array<InternalRoomType>;
  slug: Scalars["String"]["output"];
  /**
   * この拠点における、ある備品の設置情報。同じ対象に複数行が残っているデータがあるため、
   * 対象ごとに作成日時が最も新しい1件へ畳んで返す
   */
  supplyItemInstallations: Array<SupplyItemInstallation>;
  /** SwitchBot の拠点 API キー（未設定の場合は null）。スマートプラグの稼働状況取得に使う。 */
  switchbotLocationApiKey?: Maybe<Scalars["String"]["output"]>;
};

/** 管理画面用の拠点型。public `Site` には載せたくない field（Beds24 連携・多言語名など）を含む。 */
export type InternalSitesupplyItemInstallationsArgs = {
  masterId: Scalars["ID"]["input"];
};

/** アクセスルート上の地点（始点/経由/終点）入力 */
export type InternalSiteAccessRoutePointInput = {
  legToNextDescription?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

/** 拠点住所の多言語編集用の値 */
export type InternalSiteAddress = {
  __typename?: "InternalSiteAddress";
  /** 町名・番地以降（{ja,en}） */
  addressLine?: Maybe<InternalLocalizedString>;
  /** 市区町村（{ja,en}） */
  city?: Maybe<InternalLocalizedString>;
  /** 都道府県（{ja,en}） */
  prefecture?: Maybe<InternalLocalizedString>;
};

/**
 * スタッフプラン契約（管理画面用）
 * ユーザー情報を含む
 */
export type InternalStaffContract = {
  __typename?: "InternalStaffContract";
  /** 登録者 */
  createdUser: User;
  /** 今期の付与泊数 */
  currentSemesterGrantedStayCredits: Scalars["Int"]["output"];
  /** 今期の残り泊数 */
  currentSemesterStayCredits: Scalars["Int"]["output"];
  enrolledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 予約可能かどうか */
  isReservable: Scalars["Boolean"]["output"];
  /** 残りのピーク日数（今期） */
  remainingPeakDays: Scalars["Int"]["output"];
  /** Semester別の宿泊数情報 */
  semesterCredits: Array<StaffSemesterCredit>;
  staffType: StaffType;
  status: StaffContractStatus;
  statusDetail: StaffContractStatusDetail;
  terminatedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 更新者 */
  updatedUser: User;
  user: User;
};

/** スタッフプラン宿泊クレジット履歴（管理画面用） */
export type InternalStaffCreditTransaction = {
  __typename?: "InternalStaffCreditTransaction";
  /** 紐づく予約（予約消費の場合） */
  accommodationReservation?: Maybe<AccommodationReservation>;
  /** 泊数（正=付与、負=消費） */
  amount: Scalars["Int"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  /** 実行者（nullの場合はシステム自動実行） */
  createdByUser?: Maybe<User>;
  id: Scalars["ID"]["output"];
  /** ピーク日数（正=付与、負=消費） */
  peakDaysAmount: Scalars["Int"]["output"];
  semester: StaffSemester;
  status: StaffStayCreditTransactionStatus;
  type: StaffStayCreditTransactionType;
  year: Scalars["Int"]["output"];
};

export type InternalStartStaffPlanError = {
  __typename?: "InternalStartStaffPlanError";
  case: InternalStartStaffPlanErrorCase;
};

export const InternalStartStaffPlanErrorCase = {
  /** 既に有効な契約が存在する */
  AlreadyActive: "AlreadyActive",
  /** 泊数が無効（1-4泊の範囲外） */
  InvalidNights: "InvalidNights",
  /** タームが無効（現在または次のタームのみ選択可能） */
  InvalidSemester: "InvalidSemester",
  /** 権限がない */
  NotAuthorized: "NotAuthorized",
} as const;

export type InternalStartStaffPlanErrorCase =
  (typeof InternalStartStaffPlanErrorCase)[keyof typeof InternalStartStaffPlanErrorCase];
/** for Staffプラン開始の結果 */
export type InternalStartStaffPlanResult =
  | InternalStartStaffPlanError
  | InternalStartStaffPlanSuccess;

export type InternalStartStaffPlanSuccess = {
  __typename?: "InternalStartStaffPlanSuccess";
  contract: StaffContract;
};

/** 宿泊チケット一覧のソート対象フィールド */
export const InternalStayTicketsOrderBy = {
  /** チケットコード */
  Code: "Code",
  /** 作成日 */
  CreatedAt: "CreatedAt",
  /** 有効期限 */
  ExpiresAt: "ExpiresAt",
  /** 宿泊終了日 */
  StayEndNight: "StayEndNight",
  /** 宿泊開始日 */
  StayStartNight: "StayStartNight",
} as const;

export type InternalStayTicketsOrderBy =
  (typeof InternalStayTicketsOrderBy)[keyof typeof InternalStayTicketsOrderBy];
/** 宿泊チケット一覧のページネーション結果 */
export type InternalStayTicketsResult = {
  __typename?: "InternalStayTicketsResult";
  /** チケット一覧 */
  items: Array<StayTicket>;
  /** 総件数 */
  totalCount: Scalars["Int"]["output"];
};

export type InternalStopStaffPlanError = {
  __typename?: "InternalStopStaffPlanError";
  case: InternalStopStaffPlanErrorCase;
  message?: Maybe<Scalars["String"]["output"]>;
};

export const InternalStopStaffPlanErrorCase = {
  /** 次のターム以降の予約が存在する */
  FutureReservationsExist: "FutureReservationsExist",
  /** 有効な契約が存在しない */
  NotActive: "NotActive",
  /** 権限がない */
  NotAuthorized: "NotAuthorized",
} as const;

export type InternalStopStaffPlanErrorCase =
  (typeof InternalStopStaffPlanErrorCase)[keyof typeof InternalStopStaffPlanErrorCase];
/** for Staffプラン停止の結果 */
export type InternalStopStaffPlanResult =
  | InternalStopStaffPlanError
  | InternalStopStaffPlanSuccess;

export type InternalStopStaffPlanSuccess = {
  __typename?: "InternalStopStaffPlanSuccess";
  contract: StaffContract;
};

/** 管理者によるアイデンティティ解除の結果 */
export type InternalUnlinkIdentityPayload = {
  __typename?: "InternalUnlinkIdentityPayload";
  /** 解除が成功したかどうか */
  success: Scalars["Boolean"]["output"];
};

/** ブロック解放スケジュールの更新入力 */
export type InternalUpdateAccommodationAvailabilityBlockReleaseScheduleInput = {
  /** 維持するブロック室数の上限（0 = 全解除） */
  blockRoomCountUpperLimit: Scalars["Int"]["input"];
  /** チェックインN日前 */
  daysBeforeCheckin: Scalars["Int"]["input"];
};

/** 未指定のフィールドは変更しない。description は null 指定でクリアできる。 */
export type InternalUpdateAccommodationEquipmentInput = {
  /** 形は InternalCreateAccommodationEquipmentInput.attribute と同じ。既存行の type に対して検証する（type 自体は変更できない）。 */
  attribute?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<AccommodationEquipmentStatusType>;
};

export type InternalUpdateAccommodationEquipmentPayload =
  | AccommodationEquipment
  | InternalAccommodationEquipmentError;

export type InternalUpdateAccommodationOperationGroupSettingError = {
  __typename?: "InternalUpdateAccommodationOperationGroupSettingError";
  case: InternalUpdateAccommodationOperationGroupSettingErrorCase;
};

export const InternalUpdateAccommodationOperationGroupSettingErrorCase = {
  /** 追加料金が不正（負の値、またはクラスで使われない欄が 0 以外） */
  InvalidAdditionalFee: "InvalidAdditionalFee",
  /** 設定値が見つからない */
  NotFound: "NotFound",
  /** 拠点が予約受付中（一般またはオーナー先行）のため更新できない */
  SiteReservable: "SiteReservable",
  /**
   * 紐づくオーナープランの所有権があるため更新できない。
   * 開業前でもオーナーは所有権由来の宿泊券で他拠点を予約でき、
   * その料金は所有クラスで決まるため、クラス・追加料金は所有権の付与前に確定させる必要がある
   */
  UserOwnershipExists: "UserOwnershipExists",
} as const;

export type InternalUpdateAccommodationOperationGroupSettingErrorCase =
  (typeof InternalUpdateAccommodationOperationGroupSettingErrorCase)[keyof typeof InternalUpdateAccommodationOperationGroupSettingErrorCase];
export type InternalUpdateAccommodationOperationGroupSettingInput = {
  additionalFeeForBusinessPlan: Scalars["Int"]["input"];
  additionalFeeForClassEOwner: Scalars["Int"]["input"];
  additionalFeeForClassFOwner: Scalars["Int"]["input"];
  class: AccommodationClass;
  operationType: AccommodationOperationType;
};

export type InternalUpdateAccommodationOperationGroupSettingPayload =
  | AccommodationOperationGroupSetting
  | InternalUpdateAccommodationOperationGroupSettingError;

export type InternalUpdateAccommodationReservationInput = {
  accommodationId: Scalars["ID"]["input"];
  detail: AccommodationReservationDetailInput;
  fee?: InputMaybe<AccommodationFeeInput>;
  firstNight: Scalars["PlainDate"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
  /**
   * true の場合、変更前 fee にあった動的料金 item の amount を維持する。
   * 対象: StandardPlan の calculated_dynamic_pricing_fee、
   *      StayTicket の calculated_base_fee。
   * 拠点変更、または対応する (night, key) が元 fee にない場合は通常再計算に fallback。
   */
  preserveDynamicPricing?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** エリアコンテンツ更新の入力 */
export type InternalUpdateAreaContentInput = {
  /** 東京からのアクセス説明 */
  accessFromTokyoDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** 英語表記の大文字名（例：ICHINOMIYA、AZUMINO） */
  allCapsName?: InputMaybe<Scalars["String"]["input"]>;
  /** キャッチコピー */
  catchCopy?: InputMaybe<Scalars["String"]["input"]>;
  /** エリア紹介文 */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** おすすめスポットをまとめたGoogle MapsリストのURL */
  guideSpotMapListUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** おすすめスポットページ下部Tipsの本文 */
  guideSpotTips?: InputMaybe<Scalars["String"]["input"]>;
  /** おすすめスポットページ下部Tipsの見出し */
  guideSpotTipsTitle?: InputMaybe<Scalars["String"]["input"]>;
  /** ヒーロー画像（既存を全置換する。undefined のときは更新しない） */
  heroImages?: InputMaybe<Array<UploadedFileInput>>;
  /** 予約フォームのカバー画像URL */
  reservationFormCoverImageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 道路状況ライブカメラURL */
  roadConditionLiveCameraUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 短い住所表示（例: "静岡県"） */
  shortAddress?: InputMaybe<Scalars["String"]["input"]>;
};

/** エリア更新時のエラー */
export type InternalUpdateAreaError = {
  __typename?: "InternalUpdateAreaError";
  case: InternalUpdateAreaErrorCase;
  message: Scalars["String"]["output"];
};

/** エリア更新時のエラー種別 */
export const InternalUpdateAreaErrorCase = {
  /** 並行更新により楽観ロックが競合した（再読み込みして再試行） */
  OptimisticLockConflict: "OptimisticLockConflict",
} as const;

export type InternalUpdateAreaErrorCase =
  (typeof InternalUpdateAreaErrorCase)[keyof typeof InternalUpdateAreaErrorCase];
/** エリア更新の入力 */
export type InternalUpdateAreaInput = {
  /** 多言語化されたエリア名。全 locale 必須。 */
  localizedName?: InputMaybe<InternalLocalizedStringInput>;
  /** エリア名 */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** スラッグ */
  slug?: InputMaybe<Scalars["String"]["input"]>;
  /** 並び順 */
  sort?: InputMaybe<Scalars["Int"]["input"]>;
};

/** エリア更新の結果 */
export type InternalUpdateAreaPayload = InternalArea | InternalUpdateAreaError;

export type InternalUpdateCoOwnersApplicationDetailError = {
  __typename?: "InternalUpdateCoOwnersApplicationDetailError";
  case: InternalUpdateCoOwnersApplicationDetailErrorCase;
};

export const InternalUpdateCoOwnersApplicationDetailErrorCase = {
  /** 詳細情報の種類が一致しない */
  DetailTypeMismatch: "DetailTypeMismatch",
  /** データが存在しない */
  NotFound: "NotFound",
} as const;

export type InternalUpdateCoOwnersApplicationDetailErrorCase =
  (typeof InternalUpdateCoOwnersApplicationDetailErrorCase)[keyof typeof InternalUpdateCoOwnersApplicationDetailErrorCase];
export type InternalUpdateCoOwnersApplicationDetailPayload =
  | CoOwnersApplication
  | InternalUpdateCoOwnersApplicationDetailError;

export type InternalUpdateCoOwnersApplicationFileError = {
  __typename?: "InternalUpdateCoOwnersApplicationFileError";
  case: InternalUpdateCoOwnersApplicationFileErrorCase;
};

export const InternalUpdateCoOwnersApplicationFileErrorCase = {
  /** 存在しないか削除済み */
  NotFound: "NotFound",
} as const;

export type InternalUpdateCoOwnersApplicationFileErrorCase =
  (typeof InternalUpdateCoOwnersApplicationFileErrorCase)[keyof typeof InternalUpdateCoOwnersApplicationFileErrorCase];
export type InternalUpdateCoOwnersApplicationFilePayload =
  | CoOwnersApplicationFile
  | InternalUpdateCoOwnersApplicationFileError;

export type InternalUpdateCoOwnersApplicationInfoError = {
  __typename?: "InternalUpdateCoOwnersApplicationInfoError";
  case: InternalUpdateCoOwnersApplicationInfoErrorCase;
};

export const InternalUpdateCoOwnersApplicationInfoErrorCase = {
  /** 本人確認書類1が不正 */
  IdDocument1Invalid: "IdDocument1Invalid",
  /** 本人確認書類2が不正 */
  IdDocument2Invalid: "IdDocument2Invalid",
  /** 入力値が不正 */
  InvalidInput: "InvalidInput",
  /** データが存在しない */
  NotFound: "NotFound",
} as const;

export type InternalUpdateCoOwnersApplicationInfoErrorCase =
  (typeof InternalUpdateCoOwnersApplicationInfoErrorCase)[keyof typeof InternalUpdateCoOwnersApplicationInfoErrorCase];
export type InternalUpdateCoOwnersApplicationInfoPayload =
  | CoOwnersApplication
  | InternalUpdateCoOwnersApplicationInfoError;

export type InternalUpdateCoOwnersApplicationStatusError = {
  __typename?: "InternalUpdateCoOwnersApplicationStatusError";
  case: InternalUpdateCoOwnersApplicationStatusErrorCase;
};

export const InternalUpdateCoOwnersApplicationStatusErrorCase = {
  /** 本人確認が未完了（契約サイン済み への変更時に承認済みの本人確認が必要） */
  IdentityVerificationNotApproved: "IdentityVerificationNotApproved",
  /** 無効なステータス遷移 */
  InvalidStatusTransition: "InvalidStatusTransition",
  /** 引渡希望日が未設定（登録料受領済/入金完了 への変更時に必要） */
  MissingDesiredHandoverDate: "MissingDesiredHandoverDate",
  /** データが存在しない */
  NotFound: "NotFound",
} as const;

export type InternalUpdateCoOwnersApplicationStatusErrorCase =
  (typeof InternalUpdateCoOwnersApplicationStatusErrorCase)[keyof typeof InternalUpdateCoOwnersApplicationStatusErrorCase];
export type InternalUpdateCoOwnersApplicationStatusPayload =
  | CoOwnersApplication
  | InternalUpdateCoOwnersApplicationStatusError;

/** 設備コンテンツ用画像の更新時の入力 */
export type InternalUpdateFacilityContentImagesInput = {
  /** 画像のURLリスト（並び順を保持） */
  images: Array<UploadedFileInput>;
};

/** 設備コンテンツ用画像の更新結果 */
export type InternalUpdateFacilityContentImagesPayload =
  | InternalCommonError
  | Success;

/** 付帯サービス更新入力 */
export type InternalUpdateFacilityInput = {
  /** 料金ポリシー一覧（指定した場合は全削除→再作成） */
  baseFeePolicies?: InputMaybe<
    Array<InternalCreateOrUpdateFacilityBaseFeePolicyInput>
  >;
  /** 返却後の準備日数 */
  bufferDays?: InputMaybe<Scalars["Int"]["input"]>;
  /** キャンセル締切の何日前（0=当日, 1=前日） */
  cancelDeadlineDaysBefore?: InputMaybe<Scalars["Int"]["input"]>;
  /** キャンセル締切時刻 */
  cancelDeadlineHour?: InputMaybe<Scalars["Int"]["input"]>;
  /** キャンセル料ポリシー一覧（指定した場合は全削除→再作成） */
  cancelFeePolicies?: InputMaybe<
    Array<InternalCreateOrUpdateFacilityCancelFeePolicyInput>
  >;
  /** キャンセル料ルールURL */
  cancelRuleUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 設備詳細（Markdown） */
  contentDetail?: InputMaybe<Scalars["String"]["input"]>;
  /** 予約時の案内（Markdown） */
  contentGuide?: InputMaybe<Scalars["String"]["input"]>;
  /** 注意事項（Markdown） */
  contentNotice?: InputMaybe<Scalars["String"]["input"]>;
  /** 利用について（Markdown） */
  contentUsage?: InputMaybe<Scalars["String"]["input"]>;
  /** カスタムフィールド設定 */
  customFields?: InputMaybe<Array<FacilityCustomFieldItemInput>>;
  /** 施設説明文 */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** 詳細リンクURL（nullの場合はリンク非表示） */
  detailUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 更新対象の設備ID */
  facilityId: Scalars["ID"]["input"];
  /** 施設画像 */
  image?: InputMaybe<UploadedFileInput>;
  /** 清掃レポート機能を有効化 */
  isCleaningReportEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** データ連携管理機能を有効化 */
  isDataSyncEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 予約機能を有効にするか */
  isReserveEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 公開ページと予約カレンダーへの掲載を有効にするか */
  isVisibleEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 短縮表示名（ボタン/カード用） */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** 正式名称 */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** 予約締切の何日前（0=当日, 1=前日, 7=1週間前） */
  reserveDeadlineDaysBefore?: InputMaybe<Scalars["Int"]["input"]>;
  /** 予約締切時刻 */
  reserveDeadlineHour?: InputMaybe<Scalars["Int"]["input"]>;
  /** リソース一覧（指定した場合は既存をsoft delete→新規作成） */
  resources?: InputMaybe<Array<InternalCreateOrUpdateFacilityResourceInput>>;
  /** 拠点ID一覧（指定した場合は全削除→再作成） */
  siteIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** スロット定義一覧（指定した場合は全削除→再作成） */
  slots?: InputMaybe<Array<InternalCreateOrUpdateFacilitySlotInput>>;
  /** 公開ステータス */
  status?: InputMaybe<FacilityStatusType>;
  /** 規約リンクのラベル */
  termsLabel?: InputMaybe<Scalars["String"]["input"]>;
  /** 利用規約URL */
  termsUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalUpdateFacilityReservationCleaningError = {
  __typename?: "InternalUpdateFacilityReservationCleaningError";
  case: InternalUpdateFacilityReservationCleaningErrorCase;
};

export const InternalUpdateFacilityReservationCleaningErrorCase = {
  /** 予約が見つからない */
  ReservationNotFound: "ReservationNotFound",
} as const;

export type InternalUpdateFacilityReservationCleaningErrorCase =
  (typeof InternalUpdateFacilityReservationCleaningErrorCase)[keyof typeof InternalUpdateFacilityReservationCleaningErrorCase];
/** 付帯サービス予約の清掃ステータス更新結果 */
export type InternalUpdateFacilityReservationCleaningPayload =
  | InternalUpdateFacilityReservationCleaningError
  | Success;

export type InternalUpdateFacilityReservationDataSyncError = {
  __typename?: "InternalUpdateFacilityReservationDataSyncError";
  case: InternalUpdateFacilityReservationDataSyncErrorCase;
};

export const InternalUpdateFacilityReservationDataSyncErrorCase = {
  /** 予約が見つからない */
  ReservationNotFound: "ReservationNotFound",
} as const;

export type InternalUpdateFacilityReservationDataSyncErrorCase =
  (typeof InternalUpdateFacilityReservationDataSyncErrorCase)[keyof typeof InternalUpdateFacilityReservationDataSyncErrorCase];
/** 付帯サービス予約のデータ連携ステータス更新結果 */
export type InternalUpdateFacilityReservationDataSyncPayload =
  | InternalUpdateFacilityReservationDataSyncError
  | Success;

export type InternalUpdateIdentityVerificationError = {
  __typename?: "InternalUpdateIdentityVerificationError";
  case: InternalUpdateIdentityVerificationErrorCase;
};

export const InternalUpdateIdentityVerificationErrorCase = {
  /** ステータスが遷移不可 */
  InvalidStatusTransition: "InvalidStatusTransition",
  NotFound: "NotFound",
  /** Verified への更新時に result が指定されていない */
  ResultRequiredWhenVerified: "ResultRequiredWhenVerified",
} as const;

export type InternalUpdateIdentityVerificationErrorCase =
  (typeof InternalUpdateIdentityVerificationErrorCase)[keyof typeof InternalUpdateIdentityVerificationErrorCase];
export type InternalUpdateIdentityVerificationInput = {
  note?: InputMaybe<Scalars["String"]["input"]>;
  result?: InputMaybe<IdentityVerificationResult>;
  status?: InputMaybe<IdentityVerificationStatus>;
};

export type InternalUpdateIdentityVerificationPayload =
  | InternalUpdateIdentityVerificationError
  | Success;

export type InternalUpdateIndividualTermsDocumentError = {
  __typename?: "InternalUpdateIndividualTermsDocumentError";
  case: InternalUpdateIndividualTermsDocumentErrorCase;
};

export const InternalUpdateIndividualTermsDocumentErrorCase = {
  /** 入力値が不正（共通規約を指定した場合など） */
  InvalidInput: "InvalidInput",
  /** 規約が見つからない */
  ResourceNotFound: "ResourceNotFound",
} as const;

export type InternalUpdateIndividualTermsDocumentErrorCase =
  (typeof InternalUpdateIndividualTermsDocumentErrorCase)[keyof typeof InternalUpdateIndividualTermsDocumentErrorCase];
export type InternalUpdateIndividualTermsDocumentInput = {
  document: UploadedFileInput;
};

export type InternalUpdateIndividualTermsDocumentPayload =
  | InternalUpdateIndividualTermsDocumentError
  | Terms;

export type InternalUpdateInspectionViolationHandlingError = {
  __typename?: "InternalUpdateInspectionViolationHandlingError";
  case: InternalUpdateInspectionViolationHandlingErrorCase;
};

export const InternalUpdateInspectionViolationHandlingErrorCase = {
  InspectionReportNotFound: "InspectionReportNotFound",
  NothingToUpdate: "NothingToUpdate",
  SeverityNotAssessed: "SeverityNotAssessed",
  ViolationNotReported: "ViolationNotReported",
} as const;

export type InternalUpdateInspectionViolationHandlingErrorCase =
  (typeof InternalUpdateInspectionViolationHandlingErrorCase)[keyof typeof InternalUpdateInspectionViolationHandlingErrorCase];
export type InternalUpdateInspectionViolationHandlingInput = {
  inspectionReportId: Scalars["ID"]["input"];
  severity?: InputMaybe<InspectionViolationSeverity>;
  warningActionNote?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalUpdateInspectionViolationHandlingPayload =
  | InternalUpdateInspectionViolationHandlingError
  | Success;

export type InternalUpdateLocalTaxPolicyError = {
  __typename?: "InternalUpdateLocalTaxPolicyError";
  case: InternalUpdateLocalTaxPolicyErrorCase;
};

export const InternalUpdateLocalTaxPolicyErrorCase = {
  /** 有効終了日が有効開始日より前 */
  EffectiveToBeforeEffectiveFrom: "EffectiveToBeforeEffectiveFrom",
  /** 同じ自治体・税種別のポリシー、または同じ拠点・部屋に適用済みのポリシーと有効期間が重なる */
  OverlappingEffectivePeriod: "OverlappingEffectivePeriod",
  /** 有効終了日より後の泊の税額計算に使われている */
  UsedAfterEffectiveTo: "UsedAfterEffectiveTo",
} as const;

export type InternalUpdateLocalTaxPolicyErrorCase =
  (typeof InternalUpdateLocalTaxPolicyErrorCase)[keyof typeof InternalUpdateLocalTaxPolicyErrorCase];
export type InternalUpdateLocalTaxPolicyInput = {
  /** 有効終了日（この日を含む） */
  effectiveTo: Scalars["PlainDate"]["input"];
};

export type InternalUpdateLocalTaxPolicyPayload =
  | InternalUpdateLocalTaxPolicyError
  | LocalTaxPolicy;

export type InternalUpdateRoomTypeContentInput = {
  /** 紹介文 */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** ヒーロー画像一覧（全量置き換え）。省略時は更新しない。 */
  heroImages?: InputMaybe<Array<UploadedFileInput>>;
};

export type InternalUpdateRoomTypeInput = {
  /** 建築タイプ ID */
  architectureTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  /** 自社サービス向け多言語表示名 */
  displayNames?: InputMaybe<InternalLocalizedStringInput>;
  /** 紐付ける特徴 ID リスト（全量置き換え） */
  featureIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** OTA / Beds24 側の名前（変更すると Beds24 にも反映される） */
  name: Scalars["String"]["input"];
  /** 多言語備考 */
  notes?: InputMaybe<InternalLocalizedStringInput>;
  /** URL 用 slug（site 内でユニーク） */
  slug?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalUpdateSiteActivityProgramInput = {
  externalUrl?: InputMaybe<Scalars["String"]["input"]>;
  image?: InputMaybe<UploadedFileInput>;
  localizedDescription?: InputMaybe<InternalLocalizedStringInput>;
  localizedTitle?: InputMaybe<InternalLocalizedStringInput>;
  /** 掲載終了日時。null で未設定（無期限）に戻す。フィールドを省略すると変更しない */
  publishEndAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  /** 掲載開始日時。null で未設定（即時掲載）に戻す。フィールドを省略すると変更しない */
  publishStartAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  /** 掲載する拠点 ID 一覧（指定した場合は全置換） */
  siteIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** 拠点コンテンツ更新の入力 */
export type InternalUpdateSiteContentInput = {
  /** 住所: 町名・番地以降（建物名・部屋番号を含む。多言語） */
  addressLine?: InputMaybe<InternalLocalizedStringInput>;
  /** 住所: 市区町村（多言語） */
  city?: InputMaybe<InternalLocalizedStringInput>;
  /** 拠点紹介文 */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Google Maps レビュー URL */
  googleMapsReviewUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Google Maps URL */
  googleMapsUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** ヒーロー画像（既存を全置換する。undefined のときは更新しない） */
  heroImages?: InputMaybe<Array<UploadedFileInput>>;
  /** 路面凍結情報URL */
  iceRoadInfoUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 緯度 */
  latitude?: InputMaybe<Scalars["Float"]["input"]>;
  /** 経度 */
  longitude?: InputMaybe<Scalars["Float"]["input"]>;
  /** 拠点マップ画像URL */
  mapImageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 駐車場の台数表記（例: 各部屋1台） */
  parkingCapacity?: InputMaybe<Scalars["String"]["input"]>;
  /** 駐車場の注釈 */
  parkingInfo?: InputMaybe<Scalars["String"]["input"]>;
  /** 住所: 郵便番号（言語非依存） */
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** 住所: 都道府県（多言語） */
  prefecture?: InputMaybe<InternalLocalizedStringInput>;
};

/** 拠点更新時のエラー */
export type InternalUpdateSiteError = {
  __typename?: "InternalUpdateSiteError";
  case: InternalUpdateSiteErrorCase;
  message: Scalars["String"]["output"];
};

/** 拠点更新時のエラー種別 */
export const InternalUpdateSiteErrorCase = {
  /** 運用グループの設定が無い部屋があるため、公開できない */
  OperationGroupSettingMissing: "OperationGroupSettingMissing",
  /** 並行更新により楽観ロックが競合した（再読み込みして再試行） */
  OptimisticLockConflict: "OptimisticLockConflict",
  /** 指定した RemoteLOCK Location ID が RemoteLOCK に存在しない */
  RemoteLockLocationNotFound: "RemoteLockLocationNotFound",
  /** ページを公開していない状態で予約を受け付けようとした */
  SiteNotPublished: "SiteNotPublished",
} as const;

export type InternalUpdateSiteErrorCase =
  (typeof InternalUpdateSiteErrorCase)[keyof typeof InternalUpdateSiteErrorCase];
/** 拠点ハイシーズン期間の更新入力 */
export type InternalUpdateSiteHighSeasonPeriodInput = {
  /** 2027 年度以降の拠点追加料金 */
  additionalFeeAmount: Scalars["Int"]["input"];
  /** 終了日（1-31） */
  endDay: Scalars["Int"]["input"];
  /** 終了月（1-12） */
  endMonth: Scalars["Int"]["input"];
  /** ラベル */
  label: Scalars["String"]["input"];
  /** 開始日（1-31） */
  startDay: Scalars["Int"]["input"];
  /** 開始月（1-12） */
  startMonth: Scalars["Int"]["input"];
};

/** 拠点画像の更新結果 */
export type InternalUpdateSiteImagesPayload = InternalCommonError | Success;

/** 拠点更新の入力 */
export type InternalUpdateSiteInput = {
  /** チェックイン認証タイプ */
  checkInAuthenticationType?: InputMaybe<CheckInAuthenticationType>;
  /** カスタム予約リード月数（未設定の場合はデフォルトの3ヶ月） */
  customReservationLeadMonths?: InputMaybe<Scalars["Int"]["input"]>;
  /** 早期チェックイン可能かどうか */
  earlyCheckInEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 多言語化された拠点名。全 locale 必須。 */
  localizedName?: InputMaybe<InternalLocalizedStringInput>;
  /** 拠点名 */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** 開業日 */
  openingDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 拠点番号（例：1st, 2nd） */
  ordinalName?: InputMaybe<Scalars["String"]["input"]>;
  /** 一般開放日（一般会員が予約できる最初の宿泊日）。null なら開業日と同じ。 */
  publicOpeningDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 拠点・エリアページの公開フラグ。true でページを公開する（可視性の権威フラグ。予約を受け付けるには公開済みである必要がある）。 */
  published?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** RemoteLock の Location ID（null で紐づけ解除）。存在しない ID は保存時に拒否される */
  remoteLockLocationId?: InputMaybe<Scalars["String"]["input"]>;
  /** 予約可能かどうか */
  reservable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** オーナー先行予約可能かどうか */
  reservableForOwnerEarlyAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** SwitchBot の拠点 API キー（null で解除）。省略時は変更しない */
  switchbotLocationApiKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** 拠点パラメータ更新時のエラー */
export type InternalUpdateSiteParametersError = {
  __typename?: "InternalUpdateSiteParametersError";
  message: Scalars["String"]["output"];
};

/** 拠点パラメータ更新の入力 */
export type InternalUpdateSiteParametersInput = {
  /** 拠点の Google Maps レビュー URL */
  googleMapsReviewUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** 開業日 */
  openingDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 一般開放日（一般会員が予約できる最初の宿泊日）。null なら開業日と同じ。 */
  publicOpeningDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 拠点・エリアページの公開フラグ。true でページを公開する（可視性の権威フラグ。予約を受け付けるには公開済みである必要がある）。 */
  published?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 予約可能かのフラグ */
  reservable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** オーナー向けの予約可能かのフラグ */
  reservableForOwnerEarlyAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** 拠点パラメータ更新の結果 */
export type InternalUpdateSiteParametersPayload =
  | InternalSite
  | InternalUpdateSiteParametersError;

/** 拠点更新の結果 */
export type InternalUpdateSitePayload = InternalSite | InternalUpdateSiteError;

/** StayTicket更新の入力 */
export type InternalUpdateStayTicketInput = {
  /** 送付先メールアドレス（nullの場合は変更しない、空文字の場合はクリア） */
  destinationEmail?: InputMaybe<Scalars["String"]["input"]>;
  /** 有効期限（nullの場合は変更しない） */
  expiresAt?: InputMaybe<Scalars["ZonedDateTime"]["input"]>;
  /** ステータス（nullの場合は変更しない） */
  status?: InputMaybe<StayTicketStatusType>;
  /** 宿泊可能終了日（nullの場合は変更しない） */
  stayEndNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  /** 宿泊可能開始日（nullの場合は変更しない） */
  stayStartNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

/** 無効なステータス変更（Expiredは直接設定不可） */
export type InternalUpdateStayTicketInvalidStatusError = {
  __typename?: "InternalUpdateStayTicketInvalidStatusError";
  message: Scalars["String"]["output"];
};

/** 指定されたチケットIDが見つからない */
export type InternalUpdateStayTicketNotFoundError = {
  __typename?: "InternalUpdateStayTicketNotFoundError";
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
};

/** StayTicket更新の結果 */
export type InternalUpdateStayTicketPayload =
  | InternalUpdateStayTicketInvalidStatusError
  | InternalUpdateStayTicketNotFoundError
  | StayTicket;

export type InternalUpdateUserInput = {
  addressInJapan?: InputMaybe<AddressInJapanInput>;
  addressInternational?: InputMaybe<AddressInternationalInput>;
  addressIsInJapan: Scalars["Boolean"]["input"];
  birthDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  carOwnershipStatus?: InputMaybe<UserProfileCarOwnershipStatus>;
  gender?: InputMaybe<GenderType>;
  householdComposition?: InputMaybe<UserProfileHouseholdComposition>;
  name: Scalars["String"]["input"];
  nameKana?: InputMaybe<Scalars["String"]["input"]>;
  nationality?: InputMaybe<CountryEnum>;
  numberOfDogs?: InputMaybe<Scalars["Int"]["input"]>;
  passportNumber?: InputMaybe<Scalars["String"]["input"]>;
  passportPhoto?: InputMaybe<UploadedFileInput>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  professionFree?: InputMaybe<Scalars["String"]["input"]>;
  professionType?: InputMaybe<UserProfileProfessionType>;
};

export type InternalUpsertBaseAccommodationFeeDailyRateError = {
  __typename?: "InternalUpsertBaseAccommodationFeeDailyRateError";
  /** エラーが発生したBeds24ルームID */
  beds24RoomId?: Maybe<Scalars["Int"]["output"]>;
  /** エラーが発生した日付 */
  date?: Maybe<Scalars["String"]["output"]>;
  /** エラーが発生したレコードのインデックス */
  index: Scalars["Int"]["output"];
  /** エラーメッセージ */
  message: Scalars["String"]["output"];
};

export type InternalUpsertBaseAccommodationFeeDailyRateInput = {
  /** 金額 */
  amount: Scalars["Int"]["input"];
  /** Beds24のルームID */
  beds24RoomId: Scalars["Int"]["input"];
  /** 日付 */
  date: Scalars["PlainDate"]["input"];
};

export type InternalUpsertBaseAccommodationFeeDailyRatesPayload = {
  __typename?: "InternalUpsertBaseAccommodationFeeDailyRatesPayload";
  /** 作成されたレコードの数 */
  created: Scalars["Int"]["output"];
  /** 処理に失敗したレコードのエラー情報 */
  errors: Array<InternalUpsertBaseAccommodationFeeDailyRateError>;
  /** スキップされたレコードの数 */
  skipped: Scalars["Int"]["output"];
  /** 更新されたレコードの数 */
  updated: Scalars["Int"]["output"];
};

export type InternalUpsertConsumedSupplyFeeItemWaiversError = {
  __typename?: "InternalUpsertConsumedSupplyFeeItemWaiversError";
  message: Scalars["String"]["output"];
};

export type InternalUpsertConsumedSupplyFeeItemWaiversInput = {
  accommodationReservationId: Scalars["ID"]["input"];
  /** 免除ルール一覧 */
  waivers: Array<ConsumedSupplyFeeItemWaiverInput>;
};

export type InternalUpsertConsumedSupplyFeeItemWaiversPayload =
  | InternalUpsertConsumedSupplyFeeItemWaiversError
  | Success;

/** ユーザー検索結果 */
export type InternalUserSearchResult = {
  __typename?: "InternalUserSearchResult";
  /** 次のページがあるか */
  hasNextPage: Scalars["Boolean"]["output"];
  /** 検索結果の総件数 */
  totalCount: Scalars["Int"]["output"];
  /** ユーザー一覧 */
  users: Array<User>;
};

/** ユーザー統計情報 */
export type InternalUserStats = {
  __typename?: "InternalUserStats";
  /** アクティブメンバー数（サブスクリプションステータスがUsable） */
  activeMembers: Scalars["Int"]["output"];
  /** ゲスト数（サブスクリプションステータスがNeutralでNeutralDefault） */
  guests: Scalars["Int"]["output"];
  /** 月次解約率（パーセント） */
  monthlyChurnRate: Scalars["Float"]["output"];
  /** 今月の新規登録数 */
  newSignupsThisMonth: Scalars["Int"]["output"];
  /** 総ユーザー数（削除されていないユーザー） */
  totalUsers: Scalars["Int"]["output"];
  /** 今後の予約があるユーザー数 */
  usersWithUpcomingReservations: Scalars["Int"]["output"];
};

export type InternalVoidCoOwnersApplicationError = {
  __typename?: "InternalVoidCoOwnersApplicationError";
  case: InternalVoidCoOwnersApplicationErrorCase;
};

export const InternalVoidCoOwnersApplicationErrorCase = {
  /** 紐づくアクティブな予約があるため無効化不可 */
  HasActiveReservations: "HasActiveReservations",
  /** 未滞在の StayGift（Open / Reserved）が残っているため無効化不可 */
  HasActiveStayGifts: "HasActiveStayGifts",
  /** ステータスが引渡完了でないため無効化不可 */
  InvalidStatusTransition: "InvalidStatusTransition",
  /** データが存在しない */
  NotFound: "NotFound",
  /** 申込に紐づく UserOwnership が存在しない（データ不整合） */
  OwnershipNotFound: "OwnershipNotFound",
  /** 権限が不足している */
  PermissionDenied: "PermissionDenied",
} as const;

export type InternalVoidCoOwnersApplicationErrorCase =
  (typeof InternalVoidCoOwnersApplicationErrorCase)[keyof typeof InternalVoidCoOwnersApplicationErrorCase];
export type InternalVoidCoOwnersApplicationPayload =
  | CoOwnersApplication
  | InternalVoidCoOwnersApplicationError;

export type InviteBusinessMembersError = {
  __typename?: "InviteBusinessMembersError";
  case: InviteBusinessMembersErrorCase;
};

export const InviteBusinessMembersErrorCase = {
  /** 送信対象のメールアドレスが 0 件 */
  EmptyEmails: "EmptyEmails",
  /** 送信対象のメールアドレスが 100 件を超えている */
  ExceedsMaxRecipients: "ExceedsMaxRecipients",
  /** 入力にメール形式として不正なアドレスが含まれている */
  InvalidEmailFormat: "InvalidEmailFormat",
  /** viewer が対象組織の Admin ではない */
  NotOrganizationAdmin: "NotOrganizationAdmin",
} as const;

export type InviteBusinessMembersErrorCase =
  (typeof InviteBusinessMembersErrorCase)[keyof typeof InviteBusinessMembersErrorCase];
export type InviteBusinessMembersInput = {
  /** 招待するメールアドレス。最大 100 件。 */
  emails: Array<Scalars["String"]["input"]>;
};

export type InviteBusinessMembersPayload =
  | InviteBusinessMembersError
  | InviteBusinessMembersSuccess;

export type InviteBusinessMembersSuccess = {
  __typename?: "InviteBusinessMembersSuccess";
  /** 実際に招待メール送信を試みた件数（既存所属メンバー除外後の残数）。 */
  sentCount: Scalars["Int"]["output"];
};

export type IssueSanuEdgeDeviceAccessTokenError = {
  __typename?: "IssueSanuEdgeDeviceAccessTokenError";
  case: IssueSanuEdgeDeviceAccessTokenErrorCase;
};

export const IssueSanuEdgeDeviceAccessTokenErrorCase = {
  /** デバイスにアクセスできない（時間外など） */
  DeviceNotAccessible: "DeviceNotAccessible",
  /** 施設に該当デバイスがない */
  NoDevice: "NoDevice",
  /** 予約が見つからない */
  ReservationNotFound: "ReservationNotFound",
  /** 予約の所有者でない */
  Unauthorized: "Unauthorized",
} as const;

export type IssueSanuEdgeDeviceAccessTokenErrorCase =
  (typeof IssueSanuEdgeDeviceAccessTokenErrorCase)[keyof typeof IssueSanuEdgeDeviceAccessTokenErrorCase];
export type IssueSanuEdgeDeviceAccessTokenInput = {
  /** 対象の予約ID */
  accommodationReservationId: Scalars["ID"]["input"];
  /** 対象のデバイス種別 */
  deviceType: SanuEdgeDeviceType;
};

export type IssueSanuEdgeDeviceAccessTokenPayload =
  | IssueSanuEdgeDeviceAccessTokenError
  | IssueSanuEdgeDeviceAccessTokenSuccess;

export type IssueSanuEdgeDeviceAccessTokenSuccess = {
  __typename?: "IssueSanuEdgeDeviceAccessTokenSuccess";
  /** トークンが発行されたデバイス */
  device: SanuEdgeDevice;
  /** MQTTセッション用JWTトークン */
  token: Scalars["String"]["output"];
};

export type IssueStayTicketsError = {
  __typename?: "IssueStayTicketsError";
  case: IssueStayTicketsErrorCase;
};

export const IssueStayTicketsErrorCase = {
  InvalidRequest: "InvalidRequest",
} as const;

export type IssueStayTicketsErrorCase =
  (typeof IssueStayTicketsErrorCase)[keyof typeof IssueStayTicketsErrorCase];
export type IssueStayTicketsInput = {
  lineId?: InputMaybe<Scalars["String"]["input"]>;
  templateKey: Scalars["String"]["input"];
};

export type IssueStayTicketsPayload =
  | IssueStayTicketsError
  | IssueStayTicketsResult;

export type IssueStayTicketsResult = {
  __typename?: "IssueStayTicketsResult";
  tickets: Array<StayTicket>;
};

export type JoinOrganizationError = {
  __typename?: "JoinOrganizationError";
  case: JoinOrganizationErrorCase;
};

export const JoinOrganizationErrorCase = {
  /** すでに法人組織に所属している */
  AlreadyBelongsToOrganization: "AlreadyBelongsToOrganization",
} as const;

export type JoinOrganizationErrorCase =
  (typeof JoinOrganizationErrorCase)[keyof typeof JoinOrganizationErrorCase];
export type JoinOrganizationPayload = JoinOrganizationError | Success;

export type LeaveOrganizationByViewerError = {
  __typename?: "LeaveOrganizationByViewerError";
  case: LeaveOrganizationErrorCase;
};

export type LeaveOrganizationByViewerPayload =
  | LeaveOrganizationByViewerError
  | Success;

export type LeaveOrganizationError = {
  __typename?: "LeaveOrganizationError";
  case: LeaveOrganizationErrorCase;
};

export const LeaveOrganizationErrorCase = {
  /** 未来の予約を保持している */
  HasActiveReservation: "HasActiveReservation",
  /** 組織に所属していない */
  NotBelongsToOrganization: "NotBelongsToOrganization",
} as const;

export type LeaveOrganizationErrorCase =
  (typeof LeaveOrganizationErrorCase)[keyof typeof LeaveOrganizationErrorCase];
/** Bubble からデータを取り込むためのマイグレーションツールの実行結果 */
export type LoadDataOutput = {
  __typename?: "LoadDataOutput";
  results: Array<LoadDataOutputResult>;
};

/** マイグレーションツールのタスクごとの実行結果 */
export type LoadDataOutputResult = {
  __typename?: "LoadDataOutputResult";
  destinationTable: Scalars["String"]["output"];
  errorRecords: Scalars["Int"]["output"];
  errors: Array<LoadDataOutputResultError>;
  ignoredRecords: Scalars["Int"]["output"];
  insertedRecords: Scalars["Int"]["output"];
  sourceRecords: Scalars["Int"]["output"];
  sourceTable: Scalars["String"]["output"];
};

export type LoadDataOutputResultError = {
  __typename?: "LoadDataOutputResultError";
  data?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
  position: Scalars["String"]["output"];
};

export const LoadDataTarget = {
  all: "all",
  announcement: "announcement",
  asset: "asset",
  business: "business",
  owner: "owner",
  reservation: "reservation",
  ticket: "ticket",
  user: "user",
} as const;

export type LoadDataTarget =
  (typeof LoadDataTarget)[keyof typeof LoadDataTarget];
/** 地方税の金額区分。1 人 1 泊あたりの課税対象宿泊費（税抜）が [minAmount, maxAmount) に入るときに適用される */
export type LocalTaxBracket = {
  __typename?: "LocalTaxBracket";
  id: Scalars["ID"]["output"];
  /** 1 人 1 泊あたり課税対象宿泊費の上限（この値を含まない）。null は上限なし */
  maxAmount?: Maybe<Scalars["Decimal"]["output"]>;
  /** 1 人 1 泊あたりの税額の上限。FixedRate で使う */
  maxTaxAmount?: Maybe<Scalars["Decimal"]["output"]>;
  /** 1 人 1 泊あたり課税対象宿泊費の下限（この値を含む） */
  minAmount: Scalars["Decimal"]["output"];
  /** 1 人 1 泊あたりの税額。FixedAmount / SteppedAmount で使う */
  taxAmount?: Maybe<Scalars["Decimal"]["output"]>;
  /** 税率（3% は 0.03）。FixedRate で使う */
  taxRate?: Maybe<Scalars["Decimal"]["output"]>;
};

/**
 * 自治体ごとの地方税（宿泊税・入湯税）の課税設定。
 * 税額は滞在実績に基づきチェックアウト時に確定するため、予約時点では確定できず金額は公開しない。
 */
export type LocalTaxPolicy = {
  __typename?: "LocalTaxPolicy";
  /** このポリシーを入湯税として適用している部屋 */
  accommodations: Array<Accommodation>;
  /** 金額区分。minAmount の昇順 */
  brackets: Array<LocalTaxBracket>;
  /** 有効開始日（この日を含む） */
  effectiveFrom: Scalars["PlainDate"]["output"];
  /** 有効終了日（この日を含む）。null は無期限 */
  effectiveTo?: Maybe<Scalars["PlainDate"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 自治体名（例: 白馬村） */
  localGovernmentName: Scalars["String"]["output"];
  /** このポリシーを宿泊税として適用している拠点 */
  sites: Array<InternalSite>;
  taxType: LocalTaxType;
  /** 算出タイプ */
  type: LocalTaxPolicyType;
  /** 子供を課税対象から除外するか */
  waiveKids: Scalars["Boolean"]["output"];
};

/** 地方税ポリシーの算出タイプ */
export const LocalTaxPolicyType = {
  /** 一律定額 */
  FixedAmount: "FixedAmount",
  /** 一律比率 */
  FixedRate: "FixedRate",
  /** 段階的定額 */
  SteppedAmount: "SteppedAmount",
} as const;

export type LocalTaxPolicyType =
  (typeof LocalTaxPolicyType)[keyof typeof LocalTaxPolicyType];
/** 地方税の種別 */
export const LocalTaxType = {
  /** 宿泊税 */
  AccommodationTax: "AccommodationTax",
  /** 入湯税 */
  BathingTax: "BathingTax",
} as const;

export type LocalTaxType = (typeof LocalTaxType)[keyof typeof LocalTaxType];
/** メンバー特典として提供されるNOWHEREのドリンクチケット */
export type MemberPerksNowhereDrinkTicket = {
  __typename?: "MemberPerksNowhereDrinkTicket";
  /** ドリンクチケットの利用状況 */
  used: Scalars["Boolean"]["output"];
  /** ドリンクチケットの利用時間 */
  usedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** ドリンクチケットの対象メンバー */
  user: User;
};

/** Music Connect 機器の固有情報 */
export type MusicConnectEquipmentAttribute = {
  __typename?: "MusicConnectEquipmentAttribute";
  /** 使い方の説明（マークダウン形式） */
  instruction: Scalars["String"]["output"];
};

export type Mutation = {
  __typename?: "Mutation";
  /** 宿泊予約を受け取る */
  acceptAccommodationReservation: AcceptAccommodationReservationPayload;
  /** 宿泊チケットを購入する */
  acquireStayTickets: AcquireStayTicketsPayload;
  /** メンバー特典が利用可能な場合に利用する */
  activateMemberPerksDrinkTicket: ActivateMemberPerksDrinkTicketPayload;
  /**
   * 規約の改定に同意する
   * 同意済みの改定を指定した場合も Success を返す
   */
  agreeToTerms: AgreeToTermsPayload;
  /**
   * Weekdayプラン規約改定に同意する
   * @deprecated 規約の同意は Terms / TermsRevision に統合した。同意は agreeToTerms で記録する
   */
  agreeToWeekdayTerms: AgreeToWeekdayTermsPayload;
  /** Trialプランのサブスクリプションに申し込む */
  applyToTrialSubscription: ApplyToTrialSubscriptionPayload;
  /** ウィークデープランのサブスクリプションに申し込む */
  applyToWeekdaySubscription: ApplyToWeekdaySubscriptionPayload;
  /** 宿泊予約に同伴者を割り当てる */
  assignUserCompanions: Array<UserCompanion>;
  /**
   * 宿泊チケットをバリデーションした上でまとめたIDとして取得する
   * 先頭の宿泊チケットから順番にバリデーションが行われる。
   */
  bundleStayTickets: BundleStayTicketsPayload;
  /** 宿泊予約をキャンセルする */
  cancelAccommodationReservation: CancelAccommodationReservationPayload;
  /** CoOwners の申し込みをキャンセルする */
  cancelCoOwnersApplication: CancelCoOwnersApplicationPayload;
  /** 付帯サービス予約をキャンセルする */
  cancelFacilityReservation: CancelFacilityReservationPayload;
  /** スタンダードプランのサブスクリプションの申し込みをキャンセルする */
  cancelStandardSubscriptionApplication: CancelStandardSubscriptionApplicationPayload;
  /** スタンダードプランのサブスクリプションの休会申し込みをキャンセルする */
  cancelStandardSubscriptionPause: CancelStandardSubscriptionPausePayload;
  /** スタンダードプランのサブスクリプションの休会復帰を取り止めて解約する */
  cancelStandardSubscriptionResume: CancelStandardSubscriptionResumePayload;
  /** スタンダードプランのサブスクリプションの解約申し込みをキャンセルする */
  cancelStandardSubscriptionTermination: CancelStandardSubscriptionTerminationPayload;
  /** Co-Owners/Ownersが自分が発行したStay Giftチケットをキャンセルする */
  cancelStayGifts: CancelStayGiftsPayload;
  /** Trialプランのサブスクリプションをキャンセルする */
  cancelTrialSubscription: CancelTrialSubscriptionPayload;
  /** 宿泊施設のブロックを変更する */
  changeAccommodationAvailabilityBlock: Scalars["Boolean"]["output"];
  /** 宿泊予約を変更する */
  changeAccommodationReservation: ChangeAccommodationReservationPayload;
  /** チェックインを行う */
  checkInAccommodationReservation: CheckInAccommodationReservationPayload;
  /**
   * チェックアウトを行う（最終チェックのみ。滞在レビューは任意で別途送信する）
   * id は宿泊予約のID
   */
  checkOutAccommodationReservation: CheckOutAccommodationReservationPayload;
  /**
   * チェックアウトと同時に新滞在レビューを保存する
   * id は宿泊予約のID
   * @deprecated 旧 nativeapp の後方互換のため残す。新規実装は checkOutAccommodationReservation を使う
   */
  checkOutAccommodationReservationWithStayReviewResponse: CheckOutAccommodationReservationPayload;
  /** アイデンティティ追加の新プロバイダーコールバックを処理する（Step 3） */
  completeAddIdentity: CompleteAddIdentityPayload;
  /** 仮押さえの宿泊予約を確定する */
  confirmTentativeAccommodationReservation: ConfirmTentativeAccommodationReservationPayload;
  /** Bubbleでアップロードしたファイルを移行する */
  copyFilesToS3: Scalars["Boolean"]["output"];
  /** 宿泊施設の利用ブロックをする */
  createAccommodationAvailabilityBlock: Scalars["Boolean"]["output"];
  /**
   * 宿泊予約を作成する
   * WebUIの予約画面で作られた一時予約を元に作成
   */
  createAccommodationReservation: CreateAccommodationReservationPayload;
  /** 申込のファイルをダウンロードするための URL を発行する。発行はダウンロード履歴として記録される */
  createCoOwnersApplicationFileDownloadUrl: CreateCoOwnersApplicationFileDownloadUrlPayload;
  /**
   * 申込にファイルをアップロードするためのポリシーを生成する。
   * アップロード後に registerCoOwnersApplicationFile で申込に紐づける
   */
  createCoOwnersApplicationFileUploadPolicy: FileUploadPolicyPayload;
  /** 付帯サービス予約を作成する */
  createFacilityReservation: CreateFacilityReservationPayload;
  /** FullOwnerの利用規約をアップロードするためのポリシーを生成する */
  createFullOwnerContractUploadPolicy: FileUploadPolicyPayload;
  /** プッシュ通知のためのデバイス情報を登録・更新する */
  createOrUpdateUserAppInstallation: CreateOrUpdateUserAppInstallationPayload;
  /**
   * OwnerPlanに対するパブリックなファイルをアップロードするためのポリシーを生成する
   * // NOTE: 設計としてファイルアップロードを一般化したい
   */
  createSanuOwnerPlanFileUploadPolicy: FileUploadPolicyPayload;
  /**
   * OwnerPlanに対するユーザに紐づくファイルをアップロードするためのポリシーを生成する
   * // NOTE: 設計としてファイルアップロードを一般化したい
   */
  createSanuOwnerPlanUserFileUploadPolicy: FileUploadPolicyPayload;
  /** 指定された組織に紐づく形で Stripe のカードタイプの SetupIntent を作成し、クライアントシークレットを返す */
  createStripeCardSetupIntentOfOrganization: CreateStripeCardSetupIntentOfOrganizationPayload;
  /** 現在のユーザーに紐づく形で Stripe のカードタイプの SetupIntent を作成し、クライアントシークレットを返す */
  createStripeCardSetupIntentOfViewer: CreateStripeCardSetupIntentOfViewerPayload;
  /** 同伴者を追加する */
  createUserCompanion: UserCompanion;
  /** ユーザに紐づくファイルをアップロードするためのポリシーを生成する */
  createUserFileUploadPolicy: FileUploadPolicyPayload;
  /**
   * WebView用のセッションURLを生成する。
   * ネイティブアプリがAuth0アクセストークンで認証後、
   * WebView内で使用する短期セッションを確立するためのURLを返す。
   */
  createWebviewSession: CreateWebviewSessionPayload;
  /** 宿泊施設のブロックを解除する */
  deleteAccommodationAvailabilityBlock?: Maybe<Scalars["Boolean"]["output"]>;
  /** プッシュ通知のためのデバイス情報を削除する */
  deleteUserAppInstallation: DeleteUserAppInstallationPayload;
  /** 同伴者を削除する */
  deleteUserCompanion: Success;
  /** ユーザー削除（退会） */
  deleteViewer: DeleteViewerPayload;
  /** アカウント連携を完了する（OAuth codeをトークンに交換し、Auth0 /continueへのURLを返す） */
  finalizeAccountLink: FinalizeAccountLinkPayload;
  /** チェックイン用QRコードを生成する */
  generateCheckInQrCode: GenerateCheckInQrCodePayload;
  /** スタンダードプランのサブスクリプションを今すぐ開始する */
  immediatelyApplyToStandardSubscriptionForDevelop: Scalars["Boolean"]["output"];
  /** スタンダードプランのサブスクリプションを今すぐ終了する */
  immediatelyCancelStandardSubscriptionForDevelop: Scalars["Boolean"]["output"];
  /** アカウント連携を開始する（OAuth認証のリダイレクトURLを生成） */
  initiateAccountLink: InitiateAccountLinkPayload;
  /** 設定画面からアイデンティティ（ソーシャルログイン）を追加開始する */
  initiateAddIdentity: InitiateAddIdentityPayload;
  /** 地方税ポリシーを拠点または部屋に適用する。 */
  internalAddLocalTaxPolicy: InternalAddLocalTaxPolicyPayload;
  /**
   * 管理者向け：オーナーの宿泊権利を調整する
   * amount が正の値の場合は付与、負の値の場合は消化として記録される
   */
  internalAdjustOwnerStayCredit: InternalAdjustOwnerStayCreditPayload;
  /**
   * スタッフプランの宿泊クレジットを手動調整する
   * 正の値で付与、負の値で減算
   */
  internalAdjustStaffCredits: InternalAdjustStaffCreditsResult;
  /**
   * 指定した金額の Co-Owners充当特典（旧S2Oポイント）を CoOwnersApplication に適用する。
   * 利用上限（cap）や申込日までのポイント制限は適用しない。
   * 保持ポイント以上の金額は指定できない。
   */
  internalAppendS2oPointsToCoOwnersApplication: InternalAppendS2oPointsToCoOwnersApplicationPayload;
  /**
   * 予約のお客様向けキー（RemoteLock Booking）を現在の予約状態に同期する（worker経由で呼び出される）。
   * bookingId はキャンセル時のみ渡す（予約行の反映列はキャンセル時に null 済みで、実行時に読み直せない）。
   */
  internalApplyGuestAccessKey: InternalApplyGuestAccessKeyPayload;
  /**
   * 施設のアクセスキーを適用する（worker経由で呼び出される）。
   * 発行スコープだけを受け取り、拠点とロックデバイスは accommodationId から実行時に引き直す。
   * siteId は拠点スコープ（SiteManager）のときのみ渡す。
   */
  internalApplyStaffAccessKey: InternalApplyStaffAccessKeyPayload;
  /** 宿泊予約に対して RemoteLOCK の予約を発行して、暗証番号を割り当てる */
  internalAssignAccessCodeToAccommodationReservation: InternalAssignAccessCodeToAccommodationReservationPayload;
  /**
   * 管理ロールを付与する。付与先は input.userId か input.email で指定し、email はサーバーでユーザーに解決する
   * （該当が無ければ UserNotFound）。拠点スコープの付与権（PartnerSiteManager）では input.siteId が自分の拠点に限られる
   */
  internalAssignAdminRole: InternalAssignAdminRolePayload;
  internalBeds24CreateOrUpdateBlackBooking: Scalars["Boolean"]["output"];
  internalBeds24CreateOrUpdateBlackBookings: Scalars["Boolean"]["output"];
  internalBeds24CreateOrUpdateBooking: Scalars["Boolean"]["output"];
  internalBeds24DeleteBlackBookings: Scalars["Boolean"]["output"];
  /**
   * beds24 invite code を refresh token に交換する
   * （IP 環境・ローカル開発環境の Admin 限定）。
   * 返り値の refreshToken を環境変数 BEDS24_REFRESH_TOKEN に設定して使う
   */
  internalBeds24ExchangeInviteCode: Scalars["String"]["output"];
  internalBeds24ProcessWebhookEvent: Beds24WebhookResultPayload;
  internalBeds24SendBookingMessage: Beds24BookingMessageResultPayload;
  internalBeds24SendGuestMessageAutoReply: Scalars["Boolean"]["output"];
  internalBeds24SyncFollowingReservations: Array<Beds24SyncFollowingReservationsResultPayload>;
  /**
   * 今日以降の Beds24 OTA calendar を DB rate + 運用ルール (CoOwners × 繁忙日 → blackout) から
   * 再生成し全量再送する。 運用タイプ変更後の即時反映 / cutover 前の検算などに使う。
   */
  internalBeds24SyncFuturePrices: InternalBeds24SyncFuturePricesResult;
  /** 予約ブロックを一括で作成する */
  internalBulkCreateAccommodationAvailabilityBlocks: InternalBulkCreateAccommodationAvailabilityBlocksPayload;
  /** 法人向けの年間契約の請求書を一括作成する（年払いの場合は1件、月払いの場合は12件の請求書を作成） */
  internalBulkCreateOrganizationYearlyContractInvoices: InternalBulkCreateOrganizationYearlyContractInvoicesPayload;
  /** 予約ブロックを一括で解除する */
  internalBulkDeleteAccommodationAvailabilityBlocks: InternalBulkDeleteAccommodationAvailabilityBlocksPayload;
  /** シーズン料金設定を一括で作成/更新/削除する */
  internalBulkUpdateSeasonalFeeSettings: InternalBulkUpdateSeasonalFeeSettingsPayload;
  /** チケットマスタを一括更新する */
  internalBulkUpdateStayTicketMasters: InternalBulkUpdateStayTicketMastersPayload;
  /** Admin画面から、宿泊予約をキャンセル */
  internalCancelAccommodationReservation: CancelAccommodationReservationPayload;
  /** Co-Owners 申し込みをキャンセルする */
  internalCancelCoOwnersApplication: InternalCancelCoOwnersApplicationPayload;
  /** 付帯サービス予約をキャンセルする */
  internalCancelFacilityReservation: CancelFacilityReservationPayload;
  /** IP 環境 beds24 セットアップを強制終了する（クリーンアップなし） */
  internalCancelIpBeds24Setup: Scalars["Boolean"]["output"];
  /** Admin画面から、宿泊予約を変更する */
  internalChangeAccommodationReservation: ChangeAccommodationReservationPayload;
  /** 管理者が任意の予約に対してチェックインを行う */
  internalCheckInAccommodationReservation: CheckInAccommodationReservationPayload;
  /** 既存のBeds24プロパティIDを拠点に紐付ける */
  internalConnectBeds24Property: InternalSite;
  /** ブロック解放スケジュールを作成する（管理者向け） */
  internalCreateAccommodationAvailabilityBlockReleaseSchedule: AccommodationAvailabilityBlockReleaseSchedule;
  /** 機器を登録する */
  internalCreateAccommodationEquipment: InternalCreateAccommodationEquipmentPayload;
  /**
   * 運用グループを設定値 1 件つきで作成する。
   * 設定値の effectiveFrom は 2027-04-01 固定で作成される。
   * 予約可能期間の計算は 2027-04-01 時点の運用タイプだけを参照しているため、
   * 別の日付にすると運用タイプを解決できず、設定値のない泊の料金計算が失敗する
   */
  internalCreateAccommodationOperationGroup: InternalCreateAccommodationOperationGroupPayload;
  /**
   * Admin画面から、宿泊予約を作成する
   * WebUIの予約画面で作られた一時予約を元に作成
   */
  internalCreateAccommodationReservation: CreateAccommodationReservationPayload;
  /** 建築コンテンツ画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateArchitectureContentImageUploadPolicy: FileUploadPolicyPayload;
  /** エリアを作成する */
  internalCreateArea: InternalArea;
  /** エリアガイド記事のサムネイル画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateAreaGuideArticleImageUploadPolicy: FileUploadPolicyPayload;
  /** エリア画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateAreaImageUploadPolicy: FileUploadPolicyPayload;
  /** 申込のファイル（非表示のものを含む）をダウンロードするための URL を発行する */
  internalCreateCoOwnersApplicationFileDownloadUrl: CreateCoOwnersApplicationFileDownloadUrlPayload;
  /** 管理者が申込者の領域にファイルをアップロードするためのポリシーを生成する */
  internalCreateCoOwnersApplicationFileUploadPolicy: FileUploadPolicyPayload;
  /** Co-Owners 申込の本人確認レコードを手動で作成する */
  internalCreateCoOwnersIdentityVerification: InternalCreateCoOwnersIdentityVerificationPayload;
  /**
   * 有料備品の利用実績を踏まえて、宿泊料金決済の中に請求項目を入れ込む
   * 清掃・備品管理を行う Bubble のシステムから呼ばれる
   */
  internalCreateConsumedSuppliesFeeItems: InternalCreateConsumedSuppliesFeeItemsPayload;
  /** 付帯サービスを新規作成する */
  internalCreateFacility: InternalCreateOrUpdateFacilityPayload;
  /** 設備画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateFacilityImageUploadPolicy: FileUploadPolicyPayload;
  /** 付帯サービス予約を作成する */
  internalCreateFacilityReservation: InternalCreateFacilityReservationPayload;
  /**
   * Full-Owner 契約の本人確認レコードを作成する
   * userId は本人確認を行うユーザーで、法人契約では取引担当者を指定する
   */
  internalCreateFullOwnerIdentityVerification: InternalCreateFullOwnerIdentityVerificationPayload;
  /** 地方税ポリシーを金額区分とあわせて登録する。 */
  internalCreateLocalTaxPolicy: InternalCreateLocalTaxPolicyPayload;
  /** アプリホーム画面コンテンツの画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateNativeAppHomeContentImageUploadPolicy: FileUploadPolicyPayload;
  /** 管理者向けに、部屋（Accommodation）を追加・更新する */
  internalCreateOrUpdateAccommodation: InternalCreateOrUpdateAccommodationPayload;
  /** 宿泊施設コンテンツを作成・更新する */
  internalCreateOrUpdateAccommodationContent: Accommodation;
  /** 宿泊施設お知らせを追加・更新する（管理者向け） */
  internalCreateOrUpdateAccommodationNotice: InternalCreateOrUpdateAccommodationNoticePayload;
  /** 追加ゲスト料金ポリシーの新規追加・編集 */
  internalCreateOrUpdateAdditionalGuestFeePolicy: InternalCreateOrUpdateAdditionalGuestFeePolicyPayload;
  /** 建築タイプを作成・更新する。IDが空であれば新規作成となる */
  internalCreateOrUpdateArchitectureType: ArchitectureType;
  /** エリアガイド記事を作成・更新する。掲載対象エリアは areaIds で全置換する */
  internalCreateOrUpdateAreaGuideArticle: AreaGuideArticle;
  /** エリアおすすめスポットを作成・更新する */
  internalCreateOrUpdateAreaGuideSpot: AreaGuideSpot;
  /** 基本宿泊料金ポリシーの新規追加・編集 */
  internalCreateOrUpdateBaseAccommodationFeePolicy: InternalCreateOrUpdateBaseAccommodationFeePolicyPayload;
  /**
   * Beds24プロパティを拠点に作成・連携する。既にbeds24PropertyIdが設定されている
   * 拠点の場合は、新規作成ではなく既存プロパティの情報を最新の値で同期する
   */
  internalCreateOrUpdateBeds24Property: InternalSite;
  /** 法人プランを作成・更新する */
  internalCreateOrUpdateBusinessPlan: InternalCreateOrUpdateBusinessPlanPayload;
  /** キャンセル料金ポリシーの新規追加・編集 */
  internalCreateOrUpdateCancelFeePolicy: InternalCreateOrUpdateCancelFeePolicyPayload;
  /** CoOwnersPlanOffering を追加・更新する */
  internalCreateOrUpdateCoOwnersPlanOffering: InternalCreateOrUpdateCoOwnersPlanOfferingPayload;
  /** Co-Owners 重要事項説明会スケジュールを作成・更新する */
  internalCreateOrUpdateCoOwnersWebinarSchedule: InternalCreateOrUpdateCoOwnersWebinarSchedulePayload;
  /** 建築家マスタを作成・更新する。id を省略すると新規作成 */
  internalCreateOrUpdateContentArchitect: InternalCreateOrUpdateContentArchitectPayload;
  /** 設備コンテンツを作成・更新する。設備 1 件につき 1 件で、未作成なら作成する */
  internalCreateOrUpdateContentArchitecturalFeature: InternalCreateOrUpdateContentArchitecturalFeaturePayload;
  /** 設備コンテンツの利用ルールを作成・更新する。id を省略すると新規作成 */
  internalCreateOrUpdateContentArchitecturalFeatureUsageRule: InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload;
  /**
   * 建築タイプコンテンツを作成・更新する。
   * コンテンツ行が無い建築タイプでは新規作成となり、その場合 architectId が必須
   */
  internalCreateOrUpdateContentArchitectureType: InternalCreateOrUpdateContentArchitectureTypePayload;
  /** 基本の設備マスタを作成・更新する。id を省略すると新規作成 */
  internalCreateOrUpdateContentArchitectureTypeBasicAmenity: InternalCreateOrUpdateContentBasicAmenityPayload;
  /**
   * 建築タイプのバリエーション / オプションを作成・更新する。id を省略すると新規作成。
   * kind はテーブルを決めるので、作成後は変更できない
   */
  internalCreateOrUpdateContentArchitectureTypeVariant: InternalCreateOrUpdateContentArchitectureTypeVariantPayload;
  /** 設備アメニティを作成・更新する。id を省略すると新規作成 */
  internalCreateOrUpdateContentFacilityAmenity: InternalCreateOrUpdateContentFacilityAmenityPayload;
  /**
   * 付帯サービスソースのブロックを作成・更新する
   * idを指定すると既存ブロックを更新、省略すると新規作成
   */
  internalCreateOrUpdateFacilityResourceBlock: InternalCreateOrUpdateFacilityResourceBlockPayload;
  /** ネイティブアプリのホームコンテンツを作成または更新 */
  internalCreateOrUpdateNativeAppHomeContent: InternalCreateOrUpdateNativeAppHomeContentPayload;
  /** お知らせを追加・更新する（管理者向け） */
  internalCreateOrUpdateNews: InternalCreateOrUpdateNewsPayload;
  /** 法人を作成・更新する */
  internalCreateOrUpdateOrganization: InternalCreateOrUpdateOrganizationPayload;
  /** 法人の年間契約を作成・更新する */
  internalCreateOrUpdateOrganizationYearlyContract: InternalCreateOrUpdateOrganizationYearlyContractPayload;
  /** 法人向けの年間契約の請求書を作成・更新する */
  internalCreateOrUpdateOrganizationYearlyContractInvoice: InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload;
  /** OwnerPlan を作成または更新する */
  internalCreateOrUpdateOwnerPlan: InternalCreateOrUpdateOwnerPlanPayload;
  /**
   * 拠点アクセスルートグループを作成・更新する。
   * points は与えられた配列で全置換する（IDの引き継ぎは行わない）。
   */
  internalCreateOrUpdateSiteAccessRouteGroup: SiteAccessRouteGroup;
  /** 拠点FAQを追加・更新する（管理者向け） */
  internalCreateOrUpdateSiteFaq: InternalCreateOrUpdateSiteFaqPayload;
  /** 社内スタッフグループを作成または更新する */
  internalCreateOrUpdateStaffGroup: InternalCreateOrUpdateStaffGroupPayload;
  /** チケットマスターの新規追加・編集 */
  internalCreateOrUpdateStayTicketMaster: InternalCreateOrUpdateStayTicketMasterPayload;
  /** チケットマスター雛形の新規追加・編集 */
  internalCreateOrUpdateStayTicketMasterTemplate: InternalCreateOrUpdateStayTicketMasterTemplatePayload;
  internalCreateOrUpdateStayTicketTemplate: InternalCreateStayTicketTemplatePayload;
  /** 備品の設置情報を作成・更新する */
  internalCreateOrUpdateSupplyItemInstallations: InternalCreateOrUpdateSupplyItemInstallationsPayload;
  /** 備品マスタを作成または更新する */
  internalCreateOrUpdateSupplyItemMaster: InternalCreateOrUpdateSupplyItemMasterPayload;
  /** OTAルームユニットを作成する（宿泊施設をルームタイプに割り当てる） */
  internalCreateOtaRoomUnit: InternalOtaRoomUnit;
  /** OTAルームタイプを作成し、Beds24にルームを自動作成する */
  internalCreateRoomType: InternalRoomType;
  /** 部屋タイプ画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateRoomTypeImageUploadPolicy: FileUploadPolicyPayload;
  /** 拠点を作成する */
  internalCreateSite: InternalCreateSitePayload;
  /** Nature Club のアクティビティプログラムを作成する */
  internalCreateSiteActivityProgram: InternalCreateOrUpdateSiteActivityProgramPayload;
  /** アクティビティプログラム画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateSiteActivityProgramImageUploadPolicy: FileUploadPolicyPayload;
  /** 拠点FAQ画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateSiteFaqImageUploadPolicy: FileUploadPolicyPayload;
  /** 拠点ハイシーズン期間を作成する（管理者向け） */
  internalCreateSiteHighSeasonPeriod: SiteHighSeasonPeriod;
  /** 拠点画像アップロード用のポリシーを生成する（公開バケット） */
  internalCreateSiteImageUploadPolicy: FileUploadPolicyPayload;
  /** 規約の改定を作成する */
  internalCreateTermsRevision: InternalCreateTermsRevisionPayload;
  /** StayTicketMasterからチケットを発行する */
  internalCreateTicketsFromMaster: Array<StayTicket>;
  /**
   * あるユーザーにオーナーとしての権利を付与する
   * 初年度の泊数は同時に付与する
   */
  internalCreateUserOwnership: UserOwnership;
  /** 宿泊施設を削除する */
  internalDeleteAccommodation: Scalars["Boolean"]["output"];
  /** ブロック解放スケジュールを削除する（管理者向け） */
  internalDeleteAccommodationAvailabilityBlockReleaseSchedule: Scalars["Boolean"]["output"];
  /** 機器を削除する */
  internalDeleteAccommodationEquipment: InternalDeleteAccommodationEquipmentPayload;
  /** エリアガイド記事を削除する */
  internalDeleteAreaGuideArticle: Scalars["Boolean"]["output"];
  /** エリアおすすめスポットを削除する */
  internalDeleteAreaGuideSpot: Scalars["Boolean"]["output"];
  /** 管理者がAuth0ユーザーを削除する（primary identity） */
  internalDeleteAuth0User: InternalUnlinkIdentityPayload;
  /** 申込のファイルを削除する。S3 のオブジェクトは削除し、履歴として行は残す */
  internalDeleteCoOwnersApplicationFile: InternalUpdateCoOwnersApplicationFilePayload;
  /** 建築家マスタを削除する。建築タイプから参照中は削除しない */
  internalDeleteContentArchitect: InternalDeleteArchitectureContentPayload;
  /** 設備コンテンツを削除する。利用ルールも同じトランザクションで削除する */
  internalDeleteContentArchitecturalFeature: InternalDeleteArchitectureContentPayload;
  /** 設備コンテンツの利用ルールを削除する */
  internalDeleteContentArchitecturalFeatureUsageRule: InternalDeleteArchitectureContentPayload;
  /** 基本の設備マスタを削除する。建築タイプから参照中は削除しない */
  internalDeleteContentArchitectureTypeBasicAmenity: InternalDeleteArchitectureContentPayload;
  /** 建築タイプのバリエーション / オプションを削除する */
  internalDeleteContentArchitectureTypeVariant: InternalDeleteArchitectureContentPayload;
  /** 設備アメニティを削除する。バリエーション / オプション / 設備コンテンツから参照中は削除しない */
  internalDeleteContentFacilityAmenity: InternalDeleteArchitectureContentPayload;
  /** 付帯サービスリソースのブロックを削除する */
  internalDeleteFacilityResourceBlock: InternalDeleteFacilityResourceBlockPayload;
  /** 地方税ポリシーを金額区分ごと削除する。拠点・部屋に適用中のものは削除しない。税額計算に使われたものは計算記録が金額区分を参照しているため DB 制約で削除できない */
  internalDeleteLocalTaxPolicy: InternalDeleteLocalTaxPolicyPayload;
  /** OTAルームユニットを削除する（割り当て解除） */
  internalDeleteOtaRoomUnit: Scalars["Boolean"]["output"];
  /** OTAルームタイプを削除する（紐づくユニットも全て削除） */
  internalDeleteRoomType: Scalars["Boolean"]["output"];
  /** 拠点アクセスルートグループを削除する */
  internalDeleteSiteAccessRouteGroup: Scalars["Boolean"]["output"];
  /** Nature Club のアクティビティプログラムを削除する（論理削除） */
  internalDeleteSiteActivityProgram: Success;
  /** 拠点FAQを削除する（管理者向け） */
  internalDeleteSiteFaq: Scalars["Boolean"]["output"];
  /** 拠点ハイシーズン期間を削除する（管理者向け） */
  internalDeleteSiteHighSeasonPeriod: Scalars["Boolean"]["output"];
  /** 備品の設置情報を削除する。同じ対象に複数行が残っているデータがあるため、その対象の行をまとめて消す */
  internalDeleteSupplyItemInstallation: InternalDeleteSupplyItemInstallationPayload;
  /** 備品マスタを論理削除する */
  internalDeleteSupplyItemMaster: InternalDeleteSupplyItemMasterPayload;
  internalEnqueueBeds24DeleteBlackBookings: Scalars["Boolean"]["output"];
  /** RetoolのWorkflowを実行する */
  internalExecuteRetoolWorkflow: Scalars["Boolean"]["output"];
  /** 法人向けの年間契約の請求書を下書き状態からオープンに移行する */
  internalFinalizeOrganizationYearlyContractInvoice: Scalars["Boolean"]["output"];
  /**
   * オーナーに対して特定年度の泊数を付与する
   * もし年度の途中の場合は、月割りで付与する
   * すでに付与している場合は null を返す
   */
  internalGrantNightsToOwnerFirstYear?: Maybe<Scalars["Int"]["output"]>;
  /**
   * テスト用！
   * ユーザーに過去の months 分の Co-Owners充当特典（旧S2Oポイント）の amount を付与する
   */
  internalGrantTestS2oPoints: Scalars["Boolean"]["output"];
  /** ユーザー情報をHubSpotコンタクトに同期する */
  internalHubSpotSyncContact: HubSpotSyncContactResult;
  /** CoOwnersApplicationをHubSpot Dealに同期する */
  internalHubSpotSyncDeal: HubSpotSyncDealResult;
  /** 法人向けの年間契約を無効化する */
  internalInvalidateOrganizationYearlyContract: InternalInvalidateOrganizationYearlyContractPayload;
  /** 法人向けの年間契約の請求書を無効化する */
  internalInvalidateOrganizationYearlyContractInvoice: InternalInvalidateOrganizationYearlyContractInvoicePayload;
  /** 管理者がユーザーの Co-Owners充当特典（旧S2Oポイント） を全て失効する */
  internalInvalidateS2oPoints: InternalInvalidateS2oPointsPayload;
  /**
   * Codeの配列でStay Ticketを無効化する（Void状態に変更）
   * Openステータスのチケットのみ無効化され、それ以外はスキップされる
   */
  internalInvalidateStayTicketsByCode: InternalInvalidateStayTicketsByCodeResult;
  /**
   * IP 環境 beds24 セットアップの 1 step を実行する（worker 専用）。
   * state は SetupState の JSON 文字列
   */
  internalIpBeds24SetupStep: Scalars["Boolean"]["output"];
  /** 管理者がユーザーに Co-Owners充当特典（旧S2Oポイント）を付与する */
  internalIssueS2oPoints: InternalIssueS2oPointsPayload;
  /** ユーザーを法人に所属させる */
  internalJoinOrganization: Scalars["Boolean"]["output"];
  /** JTAS からの清掃ステータスの報告を反映する */
  internalJtasCreateOrUpdateInspectionStatuses: InternalJtasCreateOrUpdateInspectionStatusesPayload;
  /** JTAS からの備品消費報告を反映する */
  internalJtasCreateOrUpdateSupplyReport: InternalJtasCreateOrUpdateSupplyReportPayload;
  /** JTAS からの違反報告を反映する */
  internalJtasCreateOrUpdateViolationReport: InternalJtasCreateOrUpdateViolationReportPayload;
  /** JTAS からの違反報告の取り下げを反映する */
  internalJtasDeleteViolationReport: InternalJtasDeleteViolationReportPayload;
  /** ユーザーを法人から削除する */
  internalLeaveOrganization: InternalLeaveOrganizationPayload;
  /**
   * Co-Owners 申し込み（引渡完了済み）の一部または全部の口を売却予定にする。
   * 買い替え契約済みで引渡し前のオーナーが対象。売却月の年度までは全口の宿泊権利を残し、
   * その先の年度は残る口数分だけにする（全口売却なら剥奪する）。
   * すでに売却予定の場合は売却口数・売却月を更新する。
   */
  internalMarkCoOwnersApplicationPlannedForSale: InternalMarkCoOwnersApplicationPlannedForSalePayload;
  /**
   * Co-Owners 申し込み（売却予定）の売却を完了する。年度末精算完了後に実行する。
   * 全口の売却なら売却済にし、残っている宿泊権利を剥奪してプランを非表示にする。
   * 紐づくアクティブな予約や未滞在の StayGift が存在する場合は変更不可。
   * 一部の口の売却ならオーナーシップの口数を減らして引渡完了に戻す。
   */
  internalMarkCoOwnersApplicationSold: InternalMarkCoOwnersApplicationSoldPayload;
  /** 法人を更新する */
  internalPartialUpdateOrganization: InternalPartialUpdateOrganizationPayload;
  /** Admin画面から、ユーザーのシステム設定を更新する */
  internalPartialUpdateUserSystemSettings: User;
  /** 管理者がアップロードしたファイルを申込に紐づける */
  internalRegisterCoOwnersApplicationFile: RegisterCoOwnersApplicationFilePayload;
  /** アクセスキー（RemoteLock Booking / AccessPerson）を解放する（worker経由で呼び出される） */
  internalReleaseAccessKey: InternalReleaseAccessKeyPayload;
  /**
   * キャンセルされている予約に紐付いているAccommodationAvailabilityをリリースる
   * 処理された予約の数を返す
   */
  internalReleaseAvailabilitesFromCanceledReservations: Scalars["Int"]["output"];
  /** 仮予約に紐付いているチケットをReservedからOpenに戻す */
  internalReleaseStayTicketsFromTentativeReservation: Scalars["Boolean"]["output"];
  /** 拠点または部屋への地方税ポリシーの適用を解除する。その拠点・部屋の税額計算に使われたものは解除しない */
  internalRemoveLocalTaxPolicy: InternalRemoveLocalTaxPolicyPayload;
  /** Stripe サブスクリプション独自の支払い方法を削除する */
  internalRemoveStripeSubscriptionPaymentMethod: Scalars["String"]["output"];
  /** 宿泊施設の並び順を一括更新する */
  internalReorderAccommodations: Array<Accommodation>;
  /** エリアガイド記事の並び順を一括更新する */
  internalReorderAreaGuideArticles: Array<AreaGuideArticle>;
  /** エリアおすすめスポットの並び順を一括更新する */
  internalReorderAreaGuideSpots: Array<AreaGuideSpot>;
  /** エリアの並び順を一括更新する */
  internalReorderAreas: Array<Area>;
  /** 設備コンテンツの利用ルールの並び順を更新する。更新後の全件を sort 昇順で返す */
  internalReorderContentArchitecturalFeatureUsageRules: Array<ContentArchitecturalFeatureUsageRule>;
  /** 基本の設備マスタの並び順を更新する（公開ページの表示順）。更新後の全件を sort 昇順で返す */
  internalReorderContentArchitectureTypeBasicAmenities: Array<ContentArchitectureTypeBasicAmenity>;
  /** 建築ページ一覧の並び順（content.sort）を一括更新する */
  internalReorderContentArchitectureTypes: Array<ContentArchitectureType>;
  /** 拠点アクセスルートグループの並び順を一括更新する */
  internalReorderSiteAccessRouteGroups: Array<SiteAccessRouteGroup>;
  /** 拠点FAQの並び順を一括更新する（管理者向け） */
  internalReorderSiteFaqs: Array<RawSiteFaq>;
  /** 拠点の並び順を一括更新する */
  internalReorderSites: Array<Site>;
  /** 仮予約のユーザーをリセットする（userIdをNULLに設定） */
  internalResetTentativeReservationUser: Scalars["Boolean"]["output"];
  /** 管理ロールの割り当てを失効させる。拠点スコープの付与権では自分の拠点の割り当てに限られる */
  internalRevokeAdminRole: InternalRevokeAdminRolePayload;
  /**
   * one-shot スクリプトを実行する。dryRun=false の本番実行には confirmation
   * (= slug) が必須。実行ごとに ScriptExecution 行を必ず永続化する。
   */
  internalRunOneShotScript: InternalRunOneShotScriptResult;
  /** 指定したユーザーのスタンダードプランのサブスクリプションの解約をスケジュールする */
  internalScheduleStandardSubscriptionTermination: ScheduleStandardSubscriptionTerminationPayload;
  internalScheduledReleaseReservationBlocks: Array<Scalars["String"]["output"]>;
  /** Co-Owners 申込の本人確認（eKYC）の依頼メールを送信する */
  internalSendCoOwnersIdentityVerificationRequest: Success;
  /** ユーザーを指定してプッシュ通知を送信する */
  internalSendPushNotifications: InternalSendPushNotificationsPayload;
  /**
   * 指定した番号へテスト SMS を送り、SNS の MessageId を返す（Admin 限定）。
   * OIDC → AssumeRoleWithWebIdentity → sns:Publish の疎通を本番で確かめるためのもの。
   * 本文には必ず [TEST] が付く。message を省略すると既定の文面を送る
   */
  internalSendTestSms?: Maybe<Scalars["String"]["output"]>;
  /**
   * IP 環境 beds24 セットアップを開始する（IP 環境・ローカル開発環境の Admin 限定）。
   * 進捗を初期化し、最初の step を worker chain に enqueue する。
   * fromDate / toDate（YYYY-MM-DD）は予約・ブロックの同期対象範囲
   * （省略時は 3 日前〜無期限）
   */
  internalStartIpBeds24Setup: Scalars["Boolean"]["output"];
  /**
   * for Staffプランを開始する
   * Retoolからの初回登録時に使用
   */
  internalStartStaffPlan: InternalStartStaffPlanResult;
  /** for Staffプランを停止する */
  internalStopStaffPlan: InternalStopStaffPlanResult;
  /** 拠点の全ルームタイプをBeds24に同期する */
  internalSyncAllBeds24Rooms: InternalSite;
  /** Beds24のルーム数（qty）を同期する */
  internalSyncBeds24RoomQty: InternalRoomType;
  /** 管理者がAuth0ユーザーからリンク済みアイデンティティを解除する */
  internalUnlinkAuth0Identity: InternalUnlinkIdentityPayload;
  /** 管理者がユーザーのリンク済みアイデンティティを解除する */
  internalUnlinkIdentity: InternalUnlinkIdentityPayload;
  /** ブロック解放スケジュールを更新する（管理者向け） */
  internalUpdateAccommodationAvailabilityBlockReleaseSchedule: AccommodationAvailabilityBlockReleaseSchedule;
  /** 機器を更新する */
  internalUpdateAccommodationEquipment: InternalUpdateAccommodationEquipmentPayload;
  /**
   * 運用グループの設定値を更新する。
   * 拠点の予約受付前で、紐づくオーナープランの所有権がないときだけ更新できる
   */
  internalUpdateAccommodationOperationGroupSetting: InternalUpdateAccommodationOperationGroupSettingPayload;
  /** エリアの基本情報を更新する */
  internalUpdateArea: InternalUpdateAreaPayload;
  /** エリアのコンテンツを更新する */
  internalUpdateAreaContent: InternalArea;
  /** Co-Owners 申し込み詳細情報を更新する */
  internalUpdateCoOwnersApplicationDetail: InternalUpdateCoOwnersApplicationDetailPayload;
  /** 申込のファイルを申込者に表示するかどうかを切り替える */
  internalUpdateCoOwnersApplicationFileVisibility: InternalUpdateCoOwnersApplicationFilePayload;
  /** Co-Owners の申し込み情報を更新する */
  internalUpdateCoOwnersApplicationInfo: InternalUpdateCoOwnersApplicationInfoPayload;
  /** Co-Owners 申し込みステータスを更新する */
  internalUpdateCoOwnersApplicationStatus: InternalUpdateCoOwnersApplicationStatusPayload;
  /** 付帯サービスを更新する */
  internalUpdateFacility: InternalCreateOrUpdateFacilityPayload;
  /** 設備コンテンツ用画像一覧を更新する */
  internalUpdateFacilityContentImages: InternalUpdateFacilityContentImagesPayload;
  /** 付帯サービス予約を更新する */
  internalUpdateFacilityReservation: UpdateFacilityReservationPayload;
  /** 付帯サービスの清掃ステータスを更新する */
  internalUpdateFacilityReservationCleaning: InternalUpdateFacilityReservationCleaningPayload;
  /** 付帯サービス予約のデータ連携ステータスを更新する */
  internalUpdateFacilityReservationDataSync: InternalUpdateFacilityReservationDataSyncPayload;
  /** 本人確認のステータス・結果を手動更新する */
  internalUpdateIdentityVerification: InternalUpdateIdentityVerificationPayload;
  /** 個別規約のファイルを差し替え、差し替え日を改定日とする改定も同時に作成する */
  internalUpdateIndividualTermsDocument: InternalUpdateIndividualTermsDocumentPayload;
  /**
   * ハウスルール違反への対応を記録する。違反レベルの判定と注意喚起の実施は
   * 別々の画面操作だが、渡された項目だけを更新するのでどちらからも呼べる
   */
  internalUpdateInspectionViolationHandling: InternalUpdateInspectionViolationHandlingPayload;
  /** 地方税ポリシーを更新する。 */
  internalUpdateLocalTaxPolicy: InternalUpdateLocalTaxPolicyPayload;
  /** ルームタイプを更新する */
  internalUpdateRoomType: InternalRoomType;
  /** ルームタイプのコンテンツ（紹介文・ヒーロー画像）を更新する */
  internalUpdateRoomTypeContent: InternalContentRoomType;
  /** 拠点の基本情報を更新する */
  internalUpdateSite: InternalUpdateSitePayload;
  /** Nature Club のアクティビティプログラムを更新する */
  internalUpdateSiteActivityProgram: InternalCreateOrUpdateSiteActivityProgramPayload;
  /** 拠点コンテンツを更新する */
  internalUpdateSiteContent: InternalSite;
  /** 拠点ハイシーズン期間を更新する（管理者向け） */
  internalUpdateSiteHighSeasonPeriod: SiteHighSeasonPeriod;
  /** 拠点画像を登録 */
  internalUpdateSiteImages: InternalUpdateSiteImagesPayload;
  /** 管理者向けの拠点パラメータを更新する */
  internalUpdateSiteParameters: InternalUpdateSiteParametersPayload;
  /** 発行済みStayTicketの有効期限・宿泊期間・ステータスを更新する */
  internalUpdateStayTicket: InternalUpdateStayTicketPayload;
  /** Admin画面から、ユーザー情報を一括で更新する */
  internalUpdateUser: User;
  /** 基本日別宿泊料金を一括で作成/更新する */
  internalUpsertBaseAccommodationFeeDailyRates: InternalUpsertBaseAccommodationFeeDailyRatesPayload;
  /** 有料備品の免除を作成/更新する（指定した内容で洗い替え） */
  internalUpsertConsumedSupplyFeeItemWaivers: InternalUpsertConsumedSupplyFeeItemWaiversPayload;
  /**
   * Co-Owners 申し込み（引渡完了済み）を無効化する。
   * ステータスのみ Void へ変更し、申込レコード自体は残す。
   * 紐づくアクティブな予約や未滞在の StayGift が存在する場合は変更不可。残っている宿泊権利は剥奪される。
   */
  internalVoidCoOwnersApplication: InternalVoidCoOwnersApplicationPayload;
  /** ユーザー情報をZendeskに同期する */
  internalZendeskSyncUser: ZendeskSyncUserResult;
  /**
   * 法人組織の管理者が、複数のメールアドレスへ招待メールを一括送信する。
   * 対象は viewer が Admin として所属する組織。
   * 既存の所属メンバーはバックエンド側で送信対象から除外される。
   */
  inviteBusinessMembers: InviteBusinessMembersPayload;
  /** エッジデバイスアクセス用のMQTTセッショントークンを発行する */
  issueSanuEdgeDeviceAccessToken: IssueSanuEdgeDeviceAccessTokenPayload;
  /** 宿泊チケットを発行する */
  issueStayTickets: IssueStayTicketsPayload;
  /** ユーザーを法人に所属させる */
  joinOrganization: JoinOrganizationPayload;
  /** 法人組織からメンバーを外す */
  leaveOrganization: leaveOrganizationPayload;
  /** ログイン中のユーザーが自分自身で法人組織から抜ける */
  leaveOrganizationByViewer: LeaveOrganizationByViewerPayload;
  /** Bubble からデータをロードする */
  loadData: LoadDataOutput;
  /** 法人組織の情報を更新する */
  partialUpdateOrganization: PartialUpdateOrganizationPayload;
  /** 法人組織のメンバーの情報を更新する */
  partialUpdateOrganizationMembership: PartialUpdateOrganizationMembershipPayload;
  /** 自身のユーザーシステム設定を一括で更新する */
  partialUpdateViewerSystemSettings: User;
  /**
   * 滞在レビューの回答を投稿する
   * id は宿泊予約のID
   */
  postStayReviewResponse: PostStayReviewResponsePayload;
  /** Vercel によってトリガーされる定期実行処理 */
  processCronJob: ProcessCronJobResponse;
  /** Stripe のイベント処理 */
  processStripeEvent: ProcessStripeEventResponse;
  /** TRUSTDOCK の Webhook イベント処理 */
  processTrustdockEvent: ProcessTrustdockEventResponse;
  /** アップロード済みのファイルを申込に紐づける */
  registerCoOwnersApplicationFile: RegisterCoOwnersApplicationFilePayload;
  /** 設定画面からアイデンティティ（ソーシャルログイン）を削除する */
  removeIdentity: RemoveIdentityPayload;
  /** スタンダードプランのサブスクリプションの休会を解除する */
  resumeStandardSubscriptionImmediately: ResumeStandardSubscriptionImmediatelyPayload;
  /** 滞在レビュー 2.0 を下書き保存する。途中離脱に備えて入力のたびに呼ぶ */
  saveStayReviewV2Draft: SaveStayReviewV2DraftPayload;
  /** スタンダードプランのサブスクリプションの休会を申し込む */
  scheduleStandardSubscriptionPause: ScheduleStandardSubscriptionPausePayload;
  /** スタンダードプランのサブスクリプションの解約を申し込む */
  scheduleStandardSubscriptionTermination: ScheduleStandardSubscriptionTerminationPayload;
  /**
   * 重要事項説明会を選択する
   * coOwnersWebinarScheduleId に null を指定したときは別日程を希望していることとする。
   */
  selectWebinarSchedule: SelectWebinarSchedulePayload;
  /** 確認されていないメールアドレスに確認メールを送信する */
  sendEmailToVerifyEmail: SendEmailToVerifyNewEmailPayload;
  /** メールアドレス変更のために、新しいメールアドレスに確認メールを送信する */
  sendEmailToVerifyNewEmail: SendEmailToVerifyNewEmailPayload;
  /** パスワードリセットメールを送る */
  sendPasswordResetEmail: SendPasswordResetEmailPayload;
  /** アンケートの回答を送信する */
  submitAdHocQuestionnaireResponse: SubmitAdHocQuestionnaireResponsePayload;
  /** Co-Owners の申し込みを行う（新フロー） */
  submitCoOwnersApplication: SubmitCoOwnersApplicationPayload;
  /** 滞在レビュー 2.0 を送信する。4 軸の評価がすべて必要 */
  submitStayReviewV2: SubmitStayReviewV2Payload;
  /**
   * 宿泊予約のオプションを更新する。
   * guestCounts を指定すると追加人数料金（StayTicket master に AdditionalGuestFeePolicy がセットされた場合）も再計算する。
   */
  updateAccommodationReservationOptions: UpdateAccommodationReservationOptionsPayload;
  /** Co-Owners申し込み詳細情報を更新する */
  updateCoOwnersApplicationOwnerInfo: UpdateCoOwnersApplicationOwnerInfoPayload;
  /** 付帯サービス予約を更新する */
  updateFacilityReservation: UpdateFacilityReservationPayload;
  /** 同伴者を編集する */
  updateUserCompanion: UserCompanion;
  /** 自身のユーザー情報を一括で更新する */
  updateViewer: User;
  /** マーケメール配信の同意を更新する */
  updateViewerMarketingEmailConsent: User;
  /**
   * ユーザーの名前を設定する
   * すでに名前が設定されている場合は更新せずに空を返す。
   */
  updateViewerName?: Maybe<User>;
  /** アイデンティティ追加の再認証コールバックを処理する（Step 2） */
  verifyAddIdentityReauth: VerifyAddIdentityReauthPayload;
  /** チェックイン用QRコードを検証する */
  verifyCheckInQrCode: VerifyCheckInQrCodePayload;
  /** 確認コードを入力して、メールアドレス変更を確定する */
  verifyNewEmail: VerifyNewEmailPayload;
  /** Bubble にデータを書き戻す */
  writeBack: Scalars["String"]["output"];
};

export type MutationacceptAccommodationReservationArgs = {
  userAcceptCode: Scalars["String"]["input"];
};

export type MutationacquireStayTicketsArgs = {
  input: AcquireStayTicketsInput;
};

export type MutationagreeToTermsArgs = {
  termsRevisionId: Scalars["ID"]["input"];
};

export type MutationapplyToTrialSubscriptionArgs = {
  enrollmentMonth: Scalars["PlainYearMonth"]["input"];
};

export type MutationapplyToWeekdaySubscriptionArgs = {
  promotionCode?: InputMaybe<Scalars["String"]["input"]>;
  startFrom: Scalars["PlainDate"]["input"];
};

export type MutationassignUserCompanionsArgs = {
  accommodationReservationId: Scalars["ID"]["input"];
  userCompanionIds: Array<Scalars["ID"]["input"]>;
};

export type MutationbundleStayTicketsArgs = {
  codes: Array<Scalars["String"]["input"]>;
};

export type MutationcancelAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationcancelCoOwnersApplicationArgs = {
  coOwnersApplicationId: Scalars["ID"]["input"];
};

export type MutationcancelFacilityReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationcancelStandardSubscriptionResumeArgs = {
  questionnaire: UserSubscriptionTerminationQuestionnaireInput;
};

export type MutationcancelStayGiftsArgs = {
  ticketIds: Array<Scalars["ID"]["input"]>;
};

export type MutationchangeAccommodationAvailabilityBlockArgs = {
  id: Scalars["ID"]["input"];
  input: ChangeAccommodationAvailabilityBlockInput;
};

export type MutationchangeAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateAccommodationReservationInput;
};

export type MutationcheckInAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
  input: CheckInAccommodationReservationInput;
};

export type MutationcheckOutAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationcheckOutAccommodationReservationWithStayReviewResponseArgs =
  {
    id: Scalars["ID"]["input"];
    input: PostStayReviewResponseInput;
  };

export type MutationcompleteAddIdentityArgs = {
  input: CompleteAddIdentityInput;
};

export type MutationconfirmTentativeAccommodationReservationArgs = {
  detailInput: ConfirmTentativeAccommodationReservationInput;
  id: Scalars["ID"]["input"];
};

export type MutationcopyFilesToS3Args = {
  target: FileCopyTarget;
};

export type MutationcreateAccommodationAvailabilityBlockArgs = {
  input: CreateAccommodationAvailabilityBlockInput;
};

export type MutationcreateAccommodationReservationArgs = {
  input: CreateAccommodationReservationInput;
};

export type MutationcreateCoOwnersApplicationFileDownloadUrlArgs = {
  coOwnersApplicationFileId: Scalars["ID"]["input"];
};

export type MutationcreateCoOwnersApplicationFileUploadPolicyArgs = {
  input: CreateCoOwnersApplicationFileUploadPolicyInput;
};

export type MutationcreateFacilityReservationArgs = {
  input: CreateFacilityReservationInput;
};

export type MutationcreateFullOwnerContractUploadPolicyArgs = {
  input: CreateFullOwnerContractUploadPolicyInput;
};

export type MutationcreateOrUpdateUserAppInstallationArgs = {
  input: CreateOrUpdateUserAppInstallationInput;
};

export type MutationcreateSanuOwnerPlanFileUploadPolicyArgs = {
  input: CreateSanuOwnerPlanFileUploadPolicyInput;
};

export type MutationcreateSanuOwnerPlanUserFileUploadPolicyArgs = {
  input: CreateSanuOwnerPlanUserFileUploadPolicyInput;
};

export type MutationcreateStripeCardSetupIntentOfOrganizationArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type MutationcreateUserCompanionArgs = {
  input: UserCompanionInput;
};

export type MutationcreateUserFileUploadPolicyArgs = {
  input: CreateUserFileUploadPolicyInput;
};

export type MutationcreateWebviewSessionArgs = {
  input: CreateWebviewSessionInput;
};

export type MutationdeleteAccommodationAvailabilityBlockArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationdeleteUserAppInstallationArgs = {
  installationId: Scalars["ID"]["input"];
};

export type MutationdeleteUserCompanionArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationfinalizeAccountLinkArgs = {
  input: FinalizeAccountLinkInput;
};

export type MutationgenerateCheckInQrCodeArgs = {
  input: GenerateCheckInQrCodeInput;
};

export type MutationinitiateAccountLinkArgs = {
  input: InitiateAccountLinkInput;
};

export type MutationinitiateAddIdentityArgs = {
  input: InitiateAddIdentityInput;
};

export type MutationinternalAddLocalTaxPolicyArgs = {
  policyId: Scalars["ID"]["input"];
  target: InternalAddLocalTaxPolicyTargetInput;
};

export type MutationinternalAdjustOwnerStayCreditArgs = {
  amount: Scalars["Int"]["input"];
  ownershipId: Scalars["ID"]["input"];
  year: Scalars["Int"]["input"];
};

export type MutationinternalAdjustStaffCreditsArgs = {
  contractId: Scalars["ID"]["input"];
  nights: Scalars["Int"]["input"];
  peakDays: Scalars["Int"]["input"];
  semester: StaffSemester;
  year: Scalars["Int"]["input"];
};

export type MutationinternalAppendS2oPointsToCoOwnersApplicationArgs = {
  amount: Scalars["Int"]["input"];
  coOwnersApplicationId: Scalars["ID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationinternalApplyGuestAccessKeyArgs = {
  bookingId?: InputMaybe<Scalars["String"]["input"]>;
  reservationId: Scalars["String"]["input"];
  triggerType: GuestAccessKeyTrigger;
};

export type MutationinternalApplyStaffAccessKeyArgs = {
  accommodationId?: InputMaybe<Scalars["String"]["input"]>;
  keyType: AccessKeyType;
  siteId?: InputMaybe<Scalars["String"]["input"]>;
  triggerType: StaffAccessKeyTrigger;
};

export type MutationinternalAssignAccessCodeToAccommodationReservationArgs = {
  checkStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
  reservationId: Scalars["ID"]["input"];
};

export type MutationinternalAssignAdminRoleArgs = {
  input: InternalAssignAdminRoleInput;
};

export type MutationinternalBeds24CreateOrUpdateBlackBookingArgs = {
  blockId: Scalars["String"]["input"];
};

export type MutationinternalBeds24CreateOrUpdateBlackBookingsArgs = {
  blockIds: Array<Scalars["ID"]["input"]>;
};

export type MutationinternalBeds24CreateOrUpdateBookingArgs = {
  reservationId: Scalars["String"]["input"];
};

export type MutationinternalBeds24ExchangeInviteCodeArgs = {
  inviteCode: Scalars["String"]["input"];
};

export type MutationinternalBeds24ProcessWebhookEventArgs = {
  event: Beds24BookingEvent;
};

export type MutationinternalBeds24SendBookingMessageArgs = {
  kind: Beds24BookingMessageKind;
  reservationId: Scalars["String"]["input"];
};

export type MutationinternalBeds24SendGuestMessageAutoReplyArgs = {
  bookingId: Scalars["Int"]["input"];
};

export type MutationinternalBeds24SyncFollowingReservationsArgs = {
  leadingReservationId: Scalars["String"]["input"];
};

export type MutationinternalBeds24SyncFuturePricesArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationinternalBulkCreateAccommodationAvailabilityBlocksArgs = {
  input: Array<CreateAccommodationAvailabilityBlockInput>;
  skipBeds24CreditCheck?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationinternalBulkCreateOrganizationYearlyContractInvoicesArgs = {
  contractId: Scalars["ID"]["input"];
  input: BulkCreateOrganizationYearlyContractInvoicesInput;
};

export type MutationinternalBulkDeleteAccommodationAvailabilityBlocksArgs = {
  ids: Array<Scalars["ID"]["input"]>;
  skipBeds24CreditCheck?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationinternalBulkUpdateSeasonalFeeSettingsArgs = {
  input: Array<InternalBulkUpdateSeasonalFeeSettingsInput>;
};

export type MutationinternalBulkUpdateStayTicketMastersArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  input: Array<InternalBulkUpdateStayTicketMasterInput>;
};

export type MutationinternalCancelAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalCancelCoOwnersApplicationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalCancelFacilityReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalChangeAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateAccommodationReservationInput;
};

export type MutationinternalCheckInAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
  input: CheckInAccommodationReservationInput;
};

export type MutationinternalConnectBeds24PropertyArgs = {
  propertyId: Scalars["Int"]["input"];
  siteId: Scalars["ID"]["input"];
};

export type MutationinternalCreateAccommodationAvailabilityBlockReleaseScheduleArgs =
  {
    input: InternalCreateAccommodationAvailabilityBlockReleaseScheduleInput;
  };

export type MutationinternalCreateAccommodationEquipmentArgs = {
  input: InternalCreateAccommodationEquipmentInput;
};

export type MutationinternalCreateAccommodationOperationGroupArgs = {
  input: InternalCreateAccommodationOperationGroupInput;
};

export type MutationinternalCreateAccommodationReservationArgs = {
  input: InternalCreateAccommodationReservationInput;
};

export type MutationinternalCreateArchitectureContentImageUploadPolicyArgs = {
  input: InternalCreateArchitectureContentImageUploadPolicyInput;
};

export type MutationinternalCreateAreaArgs = {
  input: InternalCreateAreaInput;
};

export type MutationinternalCreateAreaImageUploadPolicyArgs = {
  input: InternalCreateAreaImageUploadPolicyInput;
};

export type MutationinternalCreateCoOwnersApplicationFileDownloadUrlArgs = {
  coOwnersApplicationFileId: Scalars["ID"]["input"];
};

export type MutationinternalCreateCoOwnersApplicationFileUploadPolicyArgs = {
  input: CreateCoOwnersApplicationFileUploadPolicyInput;
};

export type MutationinternalCreateCoOwnersIdentityVerificationArgs = {
  coOwnersApplicationId: Scalars["ID"]["input"];
  input: InternalCreateCoOwnersIdentityVerificationInput;
};

export type MutationinternalCreateConsumedSuppliesFeeItemsArgs = {
  input: InternalCreateConsumedSuppliesFeeItemsInput;
};

export type MutationinternalCreateFacilityArgs = {
  input: InternalCreateFacilityInput;
};

export type MutationinternalCreateFacilityImageUploadPolicyArgs = {
  input: InternalCreateFacilityImageUploadPolicyInput;
};

export type MutationinternalCreateFacilityReservationArgs = {
  input: InternalCreateFacilityReservationInput;
};

export type MutationinternalCreateFullOwnerIdentityVerificationArgs = {
  input: InternalCreateFullOwnerIdentityVerificationInput;
  ownerPlanId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationinternalCreateLocalTaxPolicyArgs = {
  input: InternalCreateLocalTaxPolicyInput;
};

export type MutationinternalCreateOrUpdateAccommodationArgs = {
  accommodationId?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAccommodationInput;
};

export type MutationinternalCreateOrUpdateAccommodationContentArgs = {
  accommodationId: Scalars["ID"]["input"];
  input: InternalCreateOrUpdateAccommodationContentInput;
};

export type MutationinternalCreateOrUpdateAccommodationNoticeArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAccommodationNoticeInput;
};

export type MutationinternalCreateOrUpdateAdditionalGuestFeePolicyArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAdditionalGuestFeePolicyInput;
};

export type MutationinternalCreateOrUpdateArchitectureTypeArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateArchitectureTypeInput;
};

export type MutationinternalCreateOrUpdateAreaGuideArticleArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAreaGuideArticleInput;
};

export type MutationinternalCreateOrUpdateAreaGuideSpotArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateAreaGuideSpotInput;
};

export type MutationinternalCreateOrUpdateBaseAccommodationFeePolicyArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateBaseAccommodationFeePolicyInput;
};

export type MutationinternalCreateOrUpdateBeds24PropertyArgs = {
  siteId: Scalars["ID"]["input"];
};

export type MutationinternalCreateOrUpdateBusinessPlanArgs = {
  businessPlanId?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateBusinessPlanInput;
};

export type MutationinternalCreateOrUpdateCancelFeePolicyArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateCancelFeePolicyInput;
};

export type MutationinternalCreateOrUpdateCoOwnersPlanOfferingArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateCoOwnersPlanOfferingInput;
};

export type MutationinternalCreateOrUpdateCoOwnersWebinarScheduleArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateCoOwnersWebinarScheduleInput;
};

export type MutationinternalCreateOrUpdateContentArchitectArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateContentArchitectInput;
};

export type MutationinternalCreateOrUpdateContentArchitecturalFeatureArgs = {
  accommodationFacilityId: Scalars["ID"]["input"];
  input: InternalCreateOrUpdateContentArchitecturalFeatureInput;
};

export type MutationinternalCreateOrUpdateContentArchitecturalFeatureUsageRuleArgs =
  {
    featureId: Scalars["ID"]["input"];
    id?: InputMaybe<Scalars["ID"]["input"]>;
    input: InternalCreateOrUpdateContentArchitecturalFeatureUsageRuleInput;
  };

export type MutationinternalCreateOrUpdateContentArchitectureTypeArgs = {
  architectureTypeId: Scalars["ID"]["input"];
  input: InternalCreateOrUpdateContentArchitectureTypeInput;
};

export type MutationinternalCreateOrUpdateContentArchitectureTypeBasicAmenityArgs =
  {
    id?: InputMaybe<Scalars["ID"]["input"]>;
    input: InternalCreateOrUpdateContentArchitectureTypeBasicAmenityInput;
  };

export type MutationinternalCreateOrUpdateContentArchitectureTypeVariantArgs = {
  architectureTypeId: Scalars["ID"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateContentArchitectureTypeVariantInput;
  kind: ContentArchitectureTypeVariantKind;
};

export type MutationinternalCreateOrUpdateContentFacilityAmenityArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateContentFacilityAmenityInput;
};

export type MutationinternalCreateOrUpdateFacilityResourceBlockArgs = {
  input: InternalCreateOrUpdateFacilityResourceBlockInput;
};

export type MutationinternalCreateOrUpdateNativeAppHomeContentArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalNativeAppHomeContentInput;
};

export type MutationinternalCreateOrUpdateNewsArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateNewsInput;
};

export type MutationinternalCreateOrUpdateOrganizationArgs = {
  input: CreateOrUpdateOrganizationInput;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationinternalCreateOrUpdateOrganizationYearlyContractArgs = {
  contractId?: InputMaybe<Scalars["ID"]["input"]>;
  input: CreateOrUpdateOrganizationYearlyContractInput;
  organizationId: Scalars["ID"]["input"];
};

export type MutationinternalCreateOrUpdateOrganizationYearlyContractInvoiceArgs =
  {
    contractId?: InputMaybe<Scalars["ID"]["input"]>;
    input: CreateOrUpdateOrganizationYearlyContractInvoiceInput;
    invoiceId?: InputMaybe<Scalars["ID"]["input"]>;
  };

export type MutationinternalCreateOrUpdateOwnerPlanArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateOwnerPlanInput;
};

export type MutationinternalCreateOrUpdateSiteAccessRouteGroupArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateSiteAccessRouteGroupInput;
};

export type MutationinternalCreateOrUpdateSiteFaqArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateSiteFaqInput;
};

export type MutationinternalCreateOrUpdateStaffGroupArgs = {
  input: CreateOrUpdateStaffGroupInput;
  staffGroupId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationinternalCreateOrUpdateStayTicketMasterArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateStayTicketMasterInput;
};

export type MutationinternalCreateOrUpdateStayTicketMasterTemplateArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateStayTicketMasterTemplateInput;
};

export type MutationinternalCreateOrUpdateStayTicketTemplateArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: InternalCreateOrUpdateStayTicketTemplateInput;
};

export type MutationinternalCreateOrUpdateSupplyItemInstallationsArgs = {
  installations: Array<InternalCreateOrUpdateSupplyItemInstallationInput>;
  masterId: Scalars["ID"]["input"];
};

export type MutationinternalCreateOrUpdateSupplyItemMasterArgs = {
  input: InternalCreateOrUpdateSupplyItemMasterInput;
};

export type MutationinternalCreateOtaRoomUnitArgs = {
  input: InternalCreateOtaRoomUnitInput;
  roomTypeId: Scalars["ID"]["input"];
};

export type MutationinternalCreateRoomTypeArgs = {
  input: InternalCreateRoomTypeInput;
  siteId: Scalars["ID"]["input"];
};

export type MutationinternalCreateRoomTypeImageUploadPolicyArgs = {
  input: InternalCreateRoomTypeImageUploadPolicyInput;
};

export type MutationinternalCreateSiteArgs = {
  areaId: Scalars["ID"]["input"];
  input: InternalCreateSiteInput;
};

export type MutationinternalCreateSiteActivityProgramArgs = {
  input: InternalCreateSiteActivityProgramInput;
};

export type MutationinternalCreateSiteFaqImageUploadPolicyArgs = {
  input: InternalCreateSiteFaqImageUploadPolicyInput;
};

export type MutationinternalCreateSiteHighSeasonPeriodArgs = {
  input: InternalCreateSiteHighSeasonPeriodInput;
};

export type MutationinternalCreateSiteImageUploadPolicyArgs = {
  input: InternalCreateSiteImageUploadPolicyInput;
};

export type MutationinternalCreateTermsRevisionArgs = {
  input: InternalCreateTermsRevisionInput;
};

export type MutationinternalCreateTicketsFromMasterArgs = {
  count: Scalars["Int"]["input"];
  destinationEmail?: InputMaybe<Scalars["String"]["input"]>;
  expiresAt: Scalars["ZonedDateTime"]["input"];
  programYear?: InputMaybe<Scalars["Int"]["input"]>;
  stayEndNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  stayStartNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  stayTicketMasterId?: InputMaybe<Scalars["ID"]["input"]>;
  userOwnershipId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationinternalCreateUserOwnershipArgs = {
  coOwnersApplicationId?: InputMaybe<Scalars["ID"]["input"]>;
  endDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  ownerPlanId: Scalars["ID"]["input"];
  startDate: Scalars["PlainDate"]["input"];
  units: Scalars["Int"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationinternalDeleteAccommodationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteAccommodationAvailabilityBlockReleaseScheduleArgs =
  {
    id: Scalars["ID"]["input"];
  };

export type MutationinternalDeleteAccommodationEquipmentArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteAreaGuideArticleArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteAreaGuideSpotArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteAuth0UserArgs = {
  auth0UserId: Scalars["String"]["input"];
};

export type MutationinternalDeleteCoOwnersApplicationFileArgs = {
  coOwnersApplicationFileId: Scalars["ID"]["input"];
};

export type MutationinternalDeleteContentArchitectArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteContentArchitecturalFeatureArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteContentArchitecturalFeatureUsageRuleArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteContentArchitectureTypeBasicAmenityArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteContentArchitectureTypeVariantArgs = {
  id: Scalars["ID"]["input"];
  kind: ContentArchitectureTypeVariantKind;
};

export type MutationinternalDeleteContentFacilityAmenityArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteFacilityResourceBlockArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteLocalTaxPolicyArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteOtaRoomUnitArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteRoomTypeArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteSiteAccessRouteGroupArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteSiteActivityProgramArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteSiteFaqArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteSiteHighSeasonPeriodArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteSupplyItemInstallationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalDeleteSupplyItemMasterArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalExecuteRetoolWorkflowArgs = {
  event: Scalars["String"]["input"];
  payload: Scalars["String"]["input"];
};

export type MutationinternalFinalizeOrganizationYearlyContractInvoiceArgs = {
  invoiceId: Scalars["ID"]["input"];
};

export type MutationinternalGrantNightsToOwnerFirstYearArgs = {
  ownershipId: Scalars["ID"]["input"];
  year: Scalars["Int"]["input"];
};

export type MutationinternalGrantTestS2oPointsArgs = {
  amount: Scalars["Int"]["input"];
  months: Scalars["Int"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationinternalHubSpotSyncContactArgs = {
  userId: Scalars["String"]["input"];
};

export type MutationinternalHubSpotSyncDealArgs = {
  coOwnersApplicationId: Scalars["String"]["input"];
};

export type MutationinternalInvalidateOrganizationYearlyContractArgs = {
  contractId: Scalars["ID"]["input"];
};

export type MutationinternalInvalidateOrganizationYearlyContractInvoiceArgs = {
  invoiceId: Scalars["ID"]["input"];
};

export type MutationinternalInvalidateS2oPointsArgs = {
  input: InternalInvalidateS2oPointsInput;
};

export type MutationinternalInvalidateStayTicketsByCodeArgs = {
  codes: Array<Scalars["String"]["input"]>;
};

export type MutationinternalIpBeds24SetupStepArgs = {
  state: Scalars["String"]["input"];
};

export type MutationinternalIssueS2oPointsArgs = {
  input: InternalIssueS2oPointsInput;
};

export type MutationinternalJoinOrganizationArgs = {
  allowConcurrentUse?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationId: Scalars["String"]["input"];
  role: OrganizationRole;
  userEmail: Scalars["String"]["input"];
};

export type MutationinternalJtasCreateOrUpdateInspectionStatusesArgs = {
  input: InternalJtasCreateOrUpdateInspectionStatusesInput;
};

export type MutationinternalJtasCreateOrUpdateSupplyReportArgs = {
  input: InternalJtasCreateOrUpdateSupplyReportInput;
};

export type MutationinternalJtasCreateOrUpdateViolationReportArgs = {
  input: InternalJtasCreateOrUpdateViolationReportInput;
};

export type MutationinternalJtasDeleteViolationReportArgs = {
  input: InternalJtasDeleteViolationReportInput;
};

export type MutationinternalLeaveOrganizationArgs = {
  organizationId: Scalars["String"]["input"];
  userEmail: Scalars["String"]["input"];
};

export type MutationinternalMarkCoOwnersApplicationPlannedForSaleArgs = {
  id: Scalars["ID"]["input"];
  saleYearMonth: Scalars["PlainYearMonth"]["input"];
  units: Scalars["Int"]["input"];
};

export type MutationinternalMarkCoOwnersApplicationSoldArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalPartialUpdateOrganizationArgs = {
  input: PartialUpdateOrganizationInput;
  organizationId: Scalars["ID"]["input"];
};

export type MutationinternalPartialUpdateUserSystemSettingsArgs = {
  input: UserSystemSettingsInput;
  userId: Scalars["String"]["input"];
};

export type MutationinternalRegisterCoOwnersApplicationFileArgs = {
  input: InternalRegisterCoOwnersApplicationFileInput;
};

export type MutationinternalReleaseAccessKeyArgs = {
  accessPersonId: Scalars["String"]["input"];
  bookingId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationinternalReleaseStayTicketsFromTentativeReservationArgs = {
  unitId: Scalars["ID"]["input"];
};

export type MutationinternalRemoveLocalTaxPolicyArgs = {
  policyId: Scalars["ID"]["input"];
  target: InternalRemoveLocalTaxPolicyTargetInput;
};

export type MutationinternalRemoveStripeSubscriptionPaymentMethodArgs = {
  subscriptionId: Scalars["String"]["input"];
};

export type MutationinternalReorderAccommodationsArgs = {
  input: Array<InternalReorderAccommodationInput>;
};

export type MutationinternalReorderAreaGuideArticlesArgs = {
  input: Array<InternalReorderInput>;
};

export type MutationinternalReorderAreaGuideSpotsArgs = {
  input: Array<InternalReorderInput>;
};

export type MutationinternalReorderAreasArgs = {
  input: Array<InternalReorderAreaInput>;
};

export type MutationinternalReorderContentArchitecturalFeatureUsageRulesArgs = {
  input: Array<InternalReorderArchitectureContentInput>;
};

export type MutationinternalReorderContentArchitectureTypeBasicAmenitiesArgs = {
  input: Array<InternalReorderArchitectureContentInput>;
};

export type MutationinternalReorderContentArchitectureTypesArgs = {
  input: Array<InternalReorderArchitectureContentInput>;
};

export type MutationinternalReorderSiteAccessRouteGroupsArgs = {
  input: Array<InternalReorderInput>;
};

export type MutationinternalReorderSiteFaqsArgs = {
  input: Array<InternalReorderSiteFaqInput>;
};

export type MutationinternalReorderSitesArgs = {
  input: Array<InternalReorderSiteInput>;
};

export type MutationinternalResetTentativeReservationUserArgs = {
  reservationId: Scalars["ID"]["input"];
};

export type MutationinternalRevokeAdminRoleArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalRunOneShotScriptArgs = {
  input: InternalRunOneShotScriptInput;
};

export type MutationinternalScheduleStandardSubscriptionTerminationArgs = {
  afterIterations: Scalars["Int"]["input"];
  targetUserId: Scalars["String"]["input"];
};

export type MutationinternalScheduledReleaseReservationBlocksArgs = {
  targetDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationinternalSendCoOwnersIdentityVerificationRequestArgs = {
  coOwnersApplicationId: Scalars["String"]["input"];
};

export type MutationinternalSendPushNotificationsArgs = {
  input: InternalSendPushNotificationsInput;
};

export type MutationinternalSendTestSmsArgs = {
  message?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber: Scalars["String"]["input"];
};

export type MutationinternalStartIpBeds24SetupArgs = {
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  phases?: InputMaybe<Array<Scalars["String"]["input"]>>;
  toDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationinternalStartStaffPlanArgs = {
  initialNights: Scalars["Int"]["input"];
  staffType: StaffType;
  startSemester: StaffSemester;
  startYear: Scalars["Int"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationinternalStopStaffPlanArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationinternalSyncAllBeds24RoomsArgs = {
  siteId: Scalars["ID"]["input"];
};

export type MutationinternalSyncBeds24RoomQtyArgs = {
  roomTypeId: Scalars["ID"]["input"];
};

export type MutationinternalUnlinkAuth0IdentityArgs = {
  primaryAuth0UserId: Scalars["String"]["input"];
  provider: Scalars["String"]["input"];
  providerUserId: Scalars["String"]["input"];
};

export type MutationinternalUnlinkIdentityArgs = {
  provider: IdentityProvider;
  userId: Scalars["String"]["input"];
};

export type MutationinternalUpdateAccommodationAvailabilityBlockReleaseScheduleArgs =
  {
    id: Scalars["ID"]["input"];
    input: InternalUpdateAccommodationAvailabilityBlockReleaseScheduleInput;
  };

export type MutationinternalUpdateAccommodationEquipmentArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateAccommodationEquipmentInput;
};

export type MutationinternalUpdateAccommodationOperationGroupSettingArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateAccommodationOperationGroupSettingInput;
};

export type MutationinternalUpdateAreaArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateAreaInput;
};

export type MutationinternalUpdateAreaContentArgs = {
  areaId: Scalars["ID"]["input"];
  input: InternalUpdateAreaContentInput;
};

export type MutationinternalUpdateCoOwnersApplicationDetailArgs = {
  id: Scalars["ID"]["input"];
  input: CoOwnersApplicationDetailInput;
};

export type MutationinternalUpdateCoOwnersApplicationFileVisibilityArgs = {
  coOwnersApplicationFileId: Scalars["ID"]["input"];
  visibleToApplicant: Scalars["Boolean"]["input"];
};

export type MutationinternalUpdateCoOwnersApplicationInfoArgs = {
  id: Scalars["ID"]["input"];
  input: CoOwnersApplicationInfoInput;
};

export type MutationinternalUpdateCoOwnersApplicationStatusArgs = {
  id: Scalars["ID"]["input"];
  input: CoOwnersApplicationStatusInput;
};

export type MutationinternalUpdateFacilityArgs = {
  input: InternalUpdateFacilityInput;
};

export type MutationinternalUpdateFacilityContentImagesArgs = {
  facilityId: Scalars["ID"]["input"];
  input: InternalUpdateFacilityContentImagesInput;
};

export type MutationinternalUpdateFacilityReservationArgs = {
  input: UpdateFacilityReservationInput;
};

export type MutationinternalUpdateFacilityReservationCleaningArgs = {
  reservationId: Scalars["ID"]["input"];
  status: FacilityReservationCleaningStatus;
};

export type MutationinternalUpdateFacilityReservationDataSyncArgs = {
  reservationId: Scalars["ID"]["input"];
  status: FacilityReservationDataSyncStatus;
};

export type MutationinternalUpdateIdentityVerificationArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateIdentityVerificationInput;
};

export type MutationinternalUpdateIndividualTermsDocumentArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateIndividualTermsDocumentInput;
};

export type MutationinternalUpdateInspectionViolationHandlingArgs = {
  input: InternalUpdateInspectionViolationHandlingInput;
};

export type MutationinternalUpdateLocalTaxPolicyArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateLocalTaxPolicyInput;
};

export type MutationinternalUpdateRoomTypeArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateRoomTypeInput;
};

export type MutationinternalUpdateRoomTypeContentArgs = {
  input: InternalUpdateRoomTypeContentInput;
  roomTypeId: Scalars["ID"]["input"];
};

export type MutationinternalUpdateSiteArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateSiteInput;
};

export type MutationinternalUpdateSiteActivityProgramArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateSiteActivityProgramInput;
};

export type MutationinternalUpdateSiteContentArgs = {
  input: InternalUpdateSiteContentInput;
  siteId: Scalars["ID"]["input"];
};

export type MutationinternalUpdateSiteHighSeasonPeriodArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateSiteHighSeasonPeriodInput;
};

export type MutationinternalUpdateSiteImagesArgs = {
  input: InternalCreateOrUpdateSiteImagesInput;
  siteId: Scalars["ID"]["input"];
};

export type MutationinternalUpdateSiteParametersArgs = {
  input: InternalUpdateSiteParametersInput;
  siteId: Scalars["ID"]["input"];
};

export type MutationinternalUpdateStayTicketArgs = {
  id: Scalars["ID"]["input"];
  input: InternalUpdateStayTicketInput;
};

export type MutationinternalUpdateUserArgs = {
  id: Scalars["String"]["input"];
  input: InternalUpdateUserInput;
};

export type MutationinternalUpsertBaseAccommodationFeeDailyRatesArgs = {
  input: Array<InternalUpsertBaseAccommodationFeeDailyRateInput>;
  target: DailyRateTarget;
};

export type MutationinternalUpsertConsumedSupplyFeeItemWaiversArgs = {
  input: InternalUpsertConsumedSupplyFeeItemWaiversInput;
};

export type MutationinternalVoidCoOwnersApplicationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationinternalZendeskSyncUserArgs = {
  updateEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  userId: Scalars["String"]["input"];
};

export type MutationinviteBusinessMembersArgs = {
  input: InviteBusinessMembersInput;
};

export type MutationissueSanuEdgeDeviceAccessTokenArgs = {
  input: IssueSanuEdgeDeviceAccessTokenInput;
};

export type MutationissueStayTicketsArgs = {
  input: IssueStayTicketsInput;
};

export type MutationjoinOrganizationArgs = {
  customFieldValue?: InputMaybe<Scalars["String"]["input"]>;
  organizationId: Scalars["ID"]["input"];
  role: OrganizationRole;
};

export type MutationleaveOrganizationArgs = {
  organizationId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationloadDataArgs = {
  target: LoadDataTarget;
};

export type MutationpartialUpdateOrganizationArgs = {
  id: Scalars["ID"]["input"];
  input: PartialUpdateOrganizationInput;
};

export type MutationpartialUpdateOrganizationMembershipArgs = {
  input: PartialUpdateOrganizationMembershipInput;
  organizationId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationpartialUpdateViewerSystemSettingsArgs = {
  input: UserSystemSettingsInput;
};

export type MutationpostStayReviewResponseArgs = {
  id: Scalars["ID"]["input"];
  input: PostStayReviewResponseInput;
};

export type MutationprocessCronJobArgs = {
  authHeader: Scalars["String"]["input"];
  job: CronJobName;
};

export type MutationprocessStripeEventArgs = {
  payload: Scalars["String"]["input"];
  signature: Scalars["String"]["input"];
};

export type MutationprocessTrustdockEventArgs = {
  payload: Scalars["String"]["input"];
  signature: Scalars["String"]["input"];
};

export type MutationregisterCoOwnersApplicationFileArgs = {
  input: RegisterCoOwnersApplicationFileInput;
};

export type MutationremoveIdentityArgs = {
  input: RemoveIdentityInput;
};

export type MutationsaveStayReviewV2DraftArgs = {
  accommodationReservationId: Scalars["ID"]["input"];
  input: StayReviewV2Input;
};

export type MutationscheduleStandardSubscriptionPauseArgs = {
  other: Scalars["String"]["input"];
  pauseDate: Scalars["PlainDate"]["input"];
  reason: Scalars["String"]["input"];
  resumeDate: Scalars["PlainDate"]["input"];
};

export type MutationscheduleStandardSubscriptionTerminationArgs = {
  questionnaire: UserSubscriptionTerminationQuestionnaireInput;
};

export type MutationselectWebinarScheduleArgs = {
  coOwnersApplicationId: Scalars["ID"]["input"];
  coOwnersWebinarScheduleId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationsendEmailToVerifyEmailArgs = {
  input: SendEmailToVerifyEmailInput;
};

export type MutationsendEmailToVerifyNewEmailArgs = {
  input: SendEmailToVerifyNewEmailInput;
};

export type MutationsubmitAdHocQuestionnaireResponseArgs = {
  input: SubmitAdHocQuestionnaireResponseInput;
};

export type MutationsubmitCoOwnersApplicationArgs = {
  input: CoOwnersApplicationInput;
};

export type MutationsubmitStayReviewV2Args = {
  accommodationReservationId: Scalars["ID"]["input"];
  input: StayReviewV2Input;
};

export type MutationupdateAccommodationReservationOptionsArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateAccommodationReservationOptionsInput;
};

export type MutationupdateCoOwnersApplicationOwnerInfoArgs = {
  id: Scalars["ID"]["input"];
  input: CoOwnersApplicationOwnerInfoInput;
};

export type MutationupdateFacilityReservationArgs = {
  input: UpdateFacilityReservationInput;
};

export type MutationupdateUserCompanionArgs = {
  id: Scalars["ID"]["input"];
  input: UserCompanionInput;
};

export type MutationupdateViewerArgs = {
  input: UpdateViewerInput;
};

export type MutationupdateViewerMarketingEmailConsentArgs = {
  accept: Scalars["Boolean"]["input"];
};

export type MutationupdateViewerNameArgs = {
  name: Scalars["String"]["input"];
  nameKana?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationverifyAddIdentityReauthArgs = {
  input: VerifyAddIdentityReauthInput;
};

export type MutationverifyCheckInQrCodeArgs = {
  input: VerifyCheckInQrCodeInput;
};

export type MutationverifyNewEmailArgs = {
  input: VerifyNewEmailInput;
};

/** アプリホーム画面のコンテンツ */
export type NativeAppHomeContent = {
  __typename?: "NativeAppHomeContent";
  /** 説明 */
  description?: Maybe<Scalars["String"]["output"]>;
  /** 画像 URL */
  imageUrl: UploadedFile;
  /** ラベル */
  label?: Maybe<NativeAppHomeContentLabel>;
  /** リンク */
  link: NativeAppHomeContentLink;
  /** タイトル */
  title?: Maybe<Scalars["String"]["output"]>;
};

export type NativeAppHomeContentLabel = {
  __typename?: "NativeAppHomeContentLabel";
  /** ラベルテキスト */
  text: Scalars["String"]["output"];
  /** タイプ */
  type: NativeAppHomeContentLabelType;
};

export const NativeAppHomeContentLabelType = {
  Accent: "Accent",
  Default: "Default",
} as const;

export type NativeAppHomeContentLabelType =
  (typeof NativeAppHomeContentLabelType)[keyof typeof NativeAppHomeContentLabelType];
export type NativeAppHomeContentLink = {
  __typename?: "NativeAppHomeContentLink";
  /** アクション */
  action: NativeAppHomeContentLinkAction;
  /** ラベル */
  label?: Maybe<Scalars["String"]["output"]>;
  /** パスもしくは URL */
  path: Scalars["String"]["output"];
};

export const NativeAppHomeContentLinkAction = {
  DrillDown: "DrillDown",
  ExternalBrowser: "ExternalBrowser",
  FullSheet: "FullSheet",
  Sheet: "Sheet",
} as const;

export type NativeAppHomeContentLinkAction =
  (typeof NativeAppHomeContentLinkAction)[keyof typeof NativeAppHomeContentLinkAction];
export const NativeAppHomeContentStatus = {
  Active: "Active",
  Draft: "Draft",
  Unpublished: "Unpublished",
} as const;

export type NativeAppHomeContentStatus =
  (typeof NativeAppHomeContentStatus)[keyof typeof NativeAppHomeContentStatus];
/** お知らせ */
export type News = {
  __typename?: "News";
  content: Scalars["String"]["output"];
  contentType: NewsContentType;
  displayCategory: NewsDisplayCategory;
  id: Scalars["ID"]["output"];
  publishedAt: Scalars["ZonedDateTime"]["output"];
  title: Scalars["String"]["output"];
};

/**
 * お知らせの種類
 * InternalPage を含むデータは取得できないようになっています
 */
export const NewsContentType = {
  /** 外部リンク */
  ExternalLink: "ExternalLink",
  /** お知らせ詳細 */
  HTML: "HTML",
  /**
   * 内部ページパス
   * このタイプは今後使用しません
   */
  InternalPage: "InternalPage",
} as const;

export type NewsContentType =
  (typeof NewsContentType)[keyof typeof NewsContentType];
export const NewsDisplayCategory = {
  /** ニュースレター（Archive Article） */
  NewsLetterArticle: "NewsLetterArticle",
  /** お知らせ */
  Notice: "Notice",
  /** サービスアップデート */
  ServiceUpdate: "ServiceUpdate",
} as const;

export type NewsDisplayCategory =
  (typeof NewsDisplayCategory)[keyof typeof NewsDisplayCategory];
/** お知らせのステータス */
export const NewsStatus = {
  /** 公開中 */
  Active: "Active",
  /** 下書き */
  Draft: "Draft",
  /** 非公開 */
  Unpublished: "Unpublished",
} as const;

export type NewsStatus = (typeof NewsStatus)[keyof typeof NewsStatus];
/**
 * 稼働制限の対象
 * （チケットマスタ更新用）
 */
export const OccupancyLimitTarget = {
  /** 都度宿泊のみ */
  Guest: "Guest",
  /** 制限なし */
  Unrestricted: "Unrestricted",
} as const;

export type OccupancyLimitTarget =
  (typeof OccupancyLimitTarget)[keyof typeof OccupancyLimitTarget];
export const OccupancyLimitTargetType = {
  Guest: "Guest",
  OrganizationMember: "OrganizationMember",
  StandardSubscriber: "StandardSubscriber",
  Unrestricted: "Unrestricted",
} as const;

export type OccupancyLimitTargetType =
  (typeof OccupancyLimitTargetType)[keyof typeof OccupancyLimitTargetType];
export type OneMoreCabinAccommodationReservationProvider = {
  __typename?: "OneMoreCabinAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  parentAccommodationReservationId: Scalars["ID"]["output"];
};

export type OnlineTravelAgentAccommodationReservationProvider = {
  __typename?: "OnlineTravelAgentAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  isIkyuDiamondMember: Scalars["Boolean"]["output"];
  leadAccommodationReservationId?: Maybe<Scalars["ID"]["output"]>;
};

export type OnsenAccommodationFacility = {
  __typename?: "OnsenAccommodationFacility";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** 付帯サービス温泉・サウナ向けドアロックのコントローラ属性情報 */
export type OnsenAndSaunaDoorLock = {
  __typename?: "OnsenAndSaunaDoorLock";
  pinCode?: Maybe<Scalars["String"]["output"]>;
};

/** 法人組織（単に"法人"とも） */
export type Organization = {
  __typename?: "Organization";
  /** メンバー向けの案内文 */
  announcementContent: Scalars["String"]["output"];
  /** SANU担当者 */
  assignedUser?: Maybe<User>;
  /** 請求先メールアドレス */
  billingEmail?: Maybe<Scalars["String"]["output"]>;
  /**
   * Bubble の Organization ID
   * 法人管理者のみ取得可能
   */
  bubbleId?: Maybe<Scalars["String"]["output"]>;
  /** 特定の契約プラン */
  contract: OrganizationYearlyContract;
  /** 全ての有効な契約プラン */
  contracts: Array<OrganizationYearlyContract>;
  /** 会社による運用コントロール */
  control: OrganizationControl;
  /**
   * 現在有効な年間契約
   * 通常これがある場合は予約ができる
   */
  currentContract?: Maybe<OrganizationYearlyContract>;
  /** 現在有効な契約プランまたは将来の契約プラン */
  currentOrUpcomingContract?: Maybe<OrganizationYearlyContract>;
  /** 請求書のデフォルト請求サイクル */
  defaultFrequency?: Maybe<OrganizationYearlyContractInvoiceFrequency>;
  /** 請求書のデフォルト支払い方法 */
  defaultPaymentMethod?: Maybe<OrganizationYearlyContractInvoicePaymentMethodType>;
  /** サービス上の表示名。未設定なら null */
  displayName?: Maybe<Scalars["String"]["output"]>;
  /**
   * 許可メールドメイン
   * 設定されていない場合は、任意のドメインでメンバー登録できる
   */
  emailDomainsForMember?: Maybe<Array<Scalars["String"]["output"]>>;
  id: Scalars["ID"]["output"];
  /** 招待用の組織コード */
  invitationCode: Scalars["String"]["output"];
  /** メンバー入力画面におけるカスタムフィールド */
  memberCustomField: OrganizationMemberCustomField;
  /** 組織のメンバー */
  members: Array<User>;
  /** メンバーの滞在実績や滞在予定 */
  membersStay: OrganizationMembersStay;
  /** 組織のメンバーシップ */
  memberships: Array<OrganizationMembership>;
  /** 組織の名前 */
  name: Scalars["String"]["output"];
  /** ユーザー登録の前に表示する情報 */
  onboardingInfo?: Maybe<OrganizationOnboardingInfo>;
  /** クレジットカード決済が有効かどうか */
  paymentMethodCardEnabled: Scalars["Boolean"]["output"];
  /** Stripe の顧客情報 */
  stripe: StripeCustomer;
  /**
   * 予約停止ステータス
   * Sanu側によって設定される。料金未払いなどの場合に使われる。
   */
  suspended: Scalars["Boolean"]["output"];
};

/** 法人組織（単に"法人"とも） */
export type OrganizationcontractArgs = {
  id: Scalars["ID"]["input"];
};

/** 法人組織（単に"法人"とも） */
export type OrganizationmembersArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** 法人組織（単に"法人"とも） */
export type OrganizationmembershipsArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** 会社による運用コントロール */
export type OrganizationControl = {
  __typename?: "OrganizationControl";
  /** メンバーあたりの年間最大泊数 */
  maxNightsPerMember?: Maybe<Scalars["Int"]["output"]>;
  /** 1ヶ月あたりの最大泊数 */
  maxNightsPerMonth?: Maybe<Scalars["Int"]["output"]>;
  /** 1滞在あたりの最大連泊数 */
  maxNightsPerStay?: Maybe<Scalars["Int"]["output"]>;
};

export type OrganizationMemberCustomField = {
  __typename?: "OrganizationMemberCustomField";
  /** カスタムフィールドが有効かどうか */
  enabled: Scalars["Boolean"]["output"];
  /** フィールド名 */
  name?: Maybe<Scalars["String"]["output"]>;
  /** フィールドのプレイスホルダー */
  placeholder?: Maybe<Scalars["String"]["output"]>;
  /** 必須かどうか */
  required: Scalars["Boolean"]["output"];
};

/**
 * 組織メンバーの予約に関するステータス
 * 年間契約は組織メンバーに公開せず、こちらを公開する
 */
export type OrganizationMemberNewReservationStatus = {
  __typename?: "OrganizationMemberNewReservationStatus";
  /** メンバー自身が最大同時予約数を既に保持しているかどうか */
  holdMaxInTotal: Scalars["Boolean"]["output"];
  /**
   * 自然月ごとの予約に関するステータス
   * 直近4ヶ月が返る
   */
  latestMonthlyReservationStatuses: Array<OrganizationMonthlyReservationStatus>;
  /**
   * 契約年ごとの予約に関するステータス
   * 現在および1つ先までの将来の契約年が返る
   */
  latestYearlyReservationStatuses: Array<OrganizationYearlyReservationStatus>;
  /**
   * 1滞在あたりの最大連泊数
   * 組織に設定された値があればそちらが反映される。
   */
  maxNightsPerStay: Scalars["Int"]["output"];
  /**
   * 予約が可能な状態かどうか。
   * SAUUによって組織がサスペンドされているか、組織管理者によってメンバーがサスペンドされているときは false になる。
   */
  suspended: Scalars["Boolean"]["output"];
};

export type OrganizationMemberPayload = {
  __typename?: "OrganizationMemberPayload";
  myself: Scalars["Boolean"]["output"];
  user: User;
};

/**
 * 組織メンバーごとの予約ステータス
 * 組織管理者によって設定される
 */
export const OrganizationMemberReservationStatus = {
  /** 予約不可 */
  NotUsable: "NotUsable",
  /** 予約可能 */
  Usable: "Usable",
} as const;

export type OrganizationMemberReservationStatus =
  (typeof OrganizationMemberReservationStatus)[keyof typeof OrganizationMemberReservationStatus];
export type OrganizationMembersStay = {
  __typename?: "OrganizationMembersStay";
  /**
   * 月別の利用泊数（実績）
   * 現在は直近2年間分が返るようにしている。
   */
  monthlyConsumedNights: Array<OrganizationPlanMonthlyConsumedNights>;
  /** 宿泊予約一覧 */
  reservations: Array<AccommodationReservation>;
  /**
   * エクスポート用の予約一覧
   * 全期間・全ステータスの予約を取得
   */
  reservationsForExport: Array<ReservationExportItem>;
  /**
   * 現在の契約期間における利用済み泊数
   * 滞在済みと予約済みを含む
   */
  usedNightsInCurrentContract: Scalars["Int"]["output"];
};

export type OrganizationMembersStayreservationsArgs = {
  excludeCancel?: InputMaybe<Scalars["Boolean"]["input"]>;
  month: Scalars["PlainYearMonth"]["input"];
};

/** 組織への所属 */
export type OrganizationMembership = {
  __typename?: "OrganizationMembership";
  customFieldValue?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  organization: Organization;
  reservationNewStatus: OrganizationMemberNewReservationStatus;
  reservationStatus: OrganizationMemberReservationStatus;
  role: OrganizationRole;
};

/** 法人メンバーの月毎の予約に関するステータス */
export type OrganizationMonthlyReservationStatus = {
  __typename?: "OrganizationMonthlyReservationStatus";
  /** この月にすでにメンバー自身の予約があるかどうか */
  alreadyHold: Scalars["Boolean"]["output"];
  /** この月に契約しているかどうか */
  isContracted: Scalars["Boolean"]["output"];
  /** この月の残りの泊数 */
  remainingNights: Scalars["Int"]["output"];
  /** 該当の月 */
  yearMonth: Scalars["PlainYearMonth"]["output"];
  /**
   * この月を含む契約年の予約に関するステータス
   * isContracted が true の場合に存在
   */
  yearlyReservationStatus?: Maybe<OrganizationYearlyReservationStatus>;
};

export type OrganizationOnboardingInfo = {
  __typename?: "OrganizationOnboardingInfo";
  /** メンバーが支払う1泊あたりの金額 */
  feePerNights: Scalars["Int"]["output"];
  /** 繁忙日料 */
  isPeakDayFeeFree: Scalars["Boolean"]["output"];
  /** 1滞在あたりの最大連泊数 */
  maxNightsPerStay?: Maybe<Scalars["Int"]["output"]>;
  /** 年間最大泊数 */
  nightsPerYear: Scalars["Int"]["output"];
};

export type OrganizationPlanMonthlyConsumedNights = {
  __typename?: "OrganizationPlanMonthlyConsumedNights";
  nights: Scalars["Int"]["output"];
  yearMonth: Scalars["PlainYearMonth"]["output"];
};

/** 組織における役割 */
export const OrganizationRole = {
  /** 組織の管理者 */
  Admin: "Admin",
  /** 組織のメンバー */
  Member: "Member",
} as const;

export type OrganizationRole =
  (typeof OrganizationRole)[keyof typeof OrganizationRole];
/**
 * 年間契約
 * ある1年間の契約を表す（契約上は、自動更新だが、レコードは分かれる）
 * つまり例えば2年間継続する場合は、別の OrganizationYearlyContract を作成する。
 * 組織メンバーには公開せず、組織管理者にのみ公開される。
 */
export type OrganizationYearlyContract = {
  __typename?: "OrganizationYearlyContract";
  /**
   * この契約の泊数を消化する予約。キャンセル済みも含む。
   *
   * 予約時の泊数判定（`OrganizationNightsManager`）が泊ごとに契約を引くのに合わせ、
   * 契約期間に 1 泊でも入る予約を返す。契約期間をまたぐ予約は前後どちらの契約からも見える。
   */
  accommodationReservations: Array<AccommodationReservation>;
  /** 何口契約か（実際の泊数とは必ずしも連動していない） */
  amountRecord: Scalars["Float"]["output"];
  /**
   * どのビジネスプランを契約しているか
   * これによってメンバーが負担する宿泊料金が決まる
   */
  businessPlan: BusinessPlan;
  /** 契約継続フラグ（契約終了5ヶ月前までに次期契約を自動作成するか） */
  continuationType: ContractContinuationType;
  /** 作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /**
   * この契約に紐づく有効な請求書の件数
   * void を除く請求書 (draft, open, paid, uncollectible) で判定
   */
  createdInvoiceCount: Scalars["Int"]["output"];
  /** 契約終了月 */
  endMonth: Scalars["PlainYearMonth"]["output"];
  id: Scalars["ID"]["output"];
  /** 無効化日時（無効化されていない場合はnull） */
  invalidatedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 現在、契約期間中かどうか */
  isCurrent: Scalars["Boolean"]["output"];
  /** 無効化されているかどうか */
  isInvalidated: Scalars["Boolean"]["output"];
  /** 次期契約の終了予定月（継続フラグがCONTINUEの場合のみ） */
  nextEndMonth?: Maybe<Scalars["PlainYearMonth"]["output"]>;
  /** 次期契約の開始予定月（継続フラグがCONTINUEの場合のみ） */
  nextStartMonth?: Maybe<Scalars["PlainYearMonth"]["output"]>;
  /** 1ヶ月あたりの最大泊数 */
  nightsPerMonth: Scalars["Int"]["output"];
  /** 年間最大泊数 */
  nightsPerYear: Scalars["Int"]["output"];
  /** 紐づく法人 */
  organization: Organization;
  /** 年間の残り利用可能宿泊数（nightsPerYear - usedNightsPerYear - scheduledNightsPerYear） */
  remainingNightsPerYear: Scalars["Int"]["output"];
  /** 年間の利用予定宿泊数（予約確定済みでチェックイン前） */
  scheduledNightsPerYear: Scalars["Int"]["output"];
  /** 契約開始月 */
  startMonth: Scalars["PlainYearMonth"]["output"];
  /** 契約ステータス（期間と削除状態から自動計算） */
  status: ContractStatus;
  /**
   * 合計料金（税込）
   * 口数とビジネスプランから計算される
   */
  totalFee: Scalars["Int"]["output"];
  /** 年間の利用済み宿泊数（チェックアウト済み + チェックイン済み） */
  usedNightsPerYear: Scalars["Int"]["output"];
};

export const OrganizationYearlyContractInvoiceFrequency = {
  /** 月間払い */
  Monthly: "Monthly",
  /** 年間一括払い */
  Yearly: "Yearly",
} as const;

export type OrganizationYearlyContractInvoiceFrequency =
  (typeof OrganizationYearlyContractInvoiceFrequency)[keyof typeof OrganizationYearlyContractInvoiceFrequency];
export const OrganizationYearlyContractInvoicePaymentMethodType = {
  /** 銀行振込 */
  BankTransfer: "BankTransfer",
  /** クレジットカード */
  CreditCard: "CreditCard",
} as const;

export type OrganizationYearlyContractInvoicePaymentMethodType =
  (typeof OrganizationYearlyContractInvoicePaymentMethodType)[keyof typeof OrganizationYearlyContractInvoicePaymentMethodType];
/** 組織年間契約に紐ずく請求書一覧のページネーション結果 */
export type OrganizationYearlyContractInvoicesResult = {
  __typename?: "OrganizationYearlyContractInvoicesResult";
  /** 返却された請求書の件数 */
  count: Scalars["Int"]["output"];
  /** 請求書データ */
  data: Array<StripeInvoice>;
  /** 次のページが存在するか */
  hasMore: Scalars["Boolean"]["output"];
  /** 次のページ取得用のカーソル（最後の請求書ID） */
  nextCursor?: Maybe<Scalars["ID"]["output"]>;
};

/** 契約一覧のソート対象カラム */
export const OrganizationYearlyContractSortField = {
  /** 継続タイプ */
  ContinuationType: "ContinuationType",
  /** 作成日 */
  CreatedAt: "CreatedAt",
  /** 契約終了月 */
  EndMonth: "EndMonth",
  /** 組織名 */
  OrganizationName: "OrganizationName",
  /** 契約開始月 */
  StartMonth: "StartMonth",
  /** ステータス */
  Status: "Status",
} as const;

export type OrganizationYearlyContractSortField =
  (typeof OrganizationYearlyContractSortField)[keyof typeof OrganizationYearlyContractSortField];
/** 契約一覧のソート条件 */
export type OrganizationYearlyContractSortInput = {
  /** ソート方向（デフォルト: desc） */
  direction?: InputMaybe<SortDirection>;
  /** ソート対象カラム */
  field: OrganizationYearlyContractSortField;
};

/** 組織年間契約のページネーション結果 */
export type OrganizationYearlyContractsResult = {
  __typename?: "OrganizationYearlyContractsResult";
  /** 返却された契約の件数 */
  count: Scalars["Int"]["output"];
  /** 契約データ */
  data: Array<OrganizationYearlyContract>;
  /** 次のページが存在するか */
  hasMore: Scalars["Boolean"]["output"];
  /** 次のページ取得用のカーソル（最後の契約ID） */
  nextCursor?: Maybe<Scalars["ID"]["output"]>;
};

/** 法人メンバーの契約年ごとの予約に関するステータス */
export type OrganizationYearlyReservationStatus = {
  __typename?: "OrganizationYearlyReservationStatus";
  /** 該当の契約年の終了月 */
  endYearMonth: Scalars["PlainYearMonth"]["output"];
  /** 年間最大泊数 */
  maxNights: Scalars["Int"]["output"];
  /** 現時点で利用可能な泊数 */
  remainingNights: Scalars["Int"]["output"];
  /** 該当の契約年の開始月 */
  startYearMonth: Scalars["PlainYearMonth"]["output"];
};

/** OTA予約検索結果: すでに事前登録済みの場合 */
export type OtaReservationLookupError = {
  __typename?: "OtaReservationLookupError";
  /** エラー種別 */
  case: OtaReservationLookupErrorCase;
};

export const OtaReservationLookupErrorCase = {
  /** すでに事前登録が済んでいる */
  AlreadyRegistered: "AlreadyRegistered",
} as const;

export type OtaReservationLookupErrorCase =
  (typeof OtaReservationLookupErrorCase)[keyof typeof OtaReservationLookupErrorCase];
/** OTA予約の検索結果 */
export type OtaReservationLookupResult =
  | OtaReservationLookupError
  | OtaReservationLookupSuccess;

/** OTA予約検索結果: 事前登録が必要な場合 */
export type OtaReservationLookupSuccess = {
  __typename?: "OtaReservationLookupSuccess";
  /** 施設タイプ名（例: SANU CABIN MOSS Medium） */
  architectureTypeName: Scalars["String"]["output"];
  /** オプション設備タイプ */
  facilityTypes: Array<AccommodationFacilityType>;
  /** チェックイン日（YYYY-MM-DD） */
  firstDate: Scalars["PlainDate"]["output"];
  /** チェックアウト日（YYYY-MM-DD） */
  lastDate: Scalars["PlainDate"]["output"];
  /** 事前登録ページのURL */
  preRegistrationUrl: Scalars["String"]["output"];
  /** 拠点名（例: 河口湖2nd） */
  siteName: Scalars["String"]["output"];
};

export const OwnerIntendedUsageType = {
  LongVacation: "LongVacation",
  MainlyWeekdays: "MainlyWeekdays",
  MainlyWeekends: "MainlyWeekends",
  WeekdaysOnly: "WeekdaysOnly",
  WeekendsOnly: "WeekendsOnly",
} as const;

export type OwnerIntendedUsageType =
  (typeof OwnerIntendedUsageType)[keyof typeof OwnerIntendedUsageType];
export const OwnerOrganizationBeneficialOwnerRelationshipType = {
  Creditor: "Creditor",
  Other: "Other",
  Representative: "Representative",
  Shareholder: "Shareholder",
} as const;

export type OwnerOrganizationBeneficialOwnerRelationshipType =
  (typeof OwnerOrganizationBeneficialOwnerRelationshipType)[keyof typeof OwnerOrganizationBeneficialOwnerRelationshipType];
export const OwnerOrganizationBusinessActivityType = {
  Construction: "Construction",
  FinanceInsurance: "FinanceInsurance",
  Manufacturing: "Manufacturing",
  Other: "Other",
  RealEstate: "RealEstate",
  Service: "Service",
  Transportation: "Transportation",
  WholesaleRetail: "WholesaleRetail",
} as const;

export type OwnerOrganizationBusinessActivityType =
  (typeof OwnerOrganizationBusinessActivityType)[keyof typeof OwnerOrganizationBusinessActivityType];
export const OwnerOrganizationRelationshipType = {
  Representative: "Representative",
  TransactionManager: "TransactionManager",
} as const;

export type OwnerOrganizationRelationshipType =
  (typeof OwnerOrganizationRelationshipType)[keyof typeof OwnerOrganizationRelationshipType];
/** (Co)Ownerのプラン */
export type OwnerPlan = {
  __typename?: "OwnerPlan";
  /** 部屋(FullOwnerの部屋所有の場合) */
  accommodation?: Maybe<Accommodation>;
  /** 設備 */
  accommodationFacilities: Array<AccommodationFacility>;
  /** 登録料の事前請求が必要かどうか */
  advancePaymentRequired: Scalars["Boolean"]["output"];
  /** 建築タイプ(Co-OwnersとFullOwnerの部屋所有の場合、FullOwnerの拠点所有=拠点投資家の場合は null) */
  architectureType?: Maybe<ArchitectureType>;
  /** バルコニー面積 */
  balconySizeSqm: Scalars["Float"]["output"];
  /** 基本料金 */
  baseAccommodationFeePerNight: Scalars["Int"]["output"];
  /**
   * Co-Owners 1口あたりの同時予約保持件数上限。
   * CoOwners 以外は null。
   */
  coOwnersMaxConcurrentReservationsPerUnit?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Co-Owners 1口あたりのHigh日数上限。
   * CoOwners かつ繁忙日制限あり（limitPeakDays=true）のプランのみ値を持ち、それ以外は null。
   */
  coOwnersMaxPeakDaysPerUnit?: Maybe<Scalars["Int"]["output"]>;
  /** CoOwnersプランの提供内容 */
  coOwnersPlanOfferings: Array<CoOwnersPlanOffering>;
  /** ドッグ棟フィルター */
  dogFriendlyFilter?: Maybe<AccommodationFacilityFilterType>;
  /** 権利形態 */
  formOfRights: Scalars["String"]["output"];
  /**
   * FullOwnerの利用規約（常に null を返す）
   * @deprecated Owners の規約は Terms / TermsRevision に統合した。個別の規約本文は Terms.individualDocument が持つ
   */
  fullOwnerContract?: Maybe<UploadedFile>;
  /** 客室面積 */
  guestRoomSizeSqm: Scalars["Float"]["output"];
  /**
   * 引き渡し開始予定年月
   * null の場合は、引き渡し開始予定年月が未登録（過去のプラン）。
   */
  handoverStartDate?: Maybe<Scalars["PlainYearMonth"]["output"]>;
  /**
   * 指定した宿泊日の所有クラス
   * 省略時は運用タイプと同じ基準（改定日時点の設定値）で解決する、改定ルール適用前の宿泊日は null
   */
  heldAccommodationClass?: Maybe<AccommodationClass>;
  id: Scalars["ID"]["output"];
  /** CoOwners プラン（管理者向け） */
  internalCoOwnersPlanOfferings: Array<CoOwnersPlanOffering>;
  /** 借地対象面積 */
  leasedLandSizeSqm: Scalars["Float"]["output"];
  /** // 繁忙日の制限有無 (CoOwners のみ) */
  limitPeakDays: Scalars["Boolean"]["output"];
  /** 管理名 */
  managedName: Scalars["String"]["output"];
  /** プラン名（拠点所有の場合は拠点名、部屋所有の場合は部屋名） */
  name: Scalars["String"]["output"];
  /** 他拠点利用基本料金、CoOwners の場合は baseAccommodationFeePerNight と同じ値 */
  nonOwnedBaseAccommodationFeePerNight: Scalars["Int"]["output"];
  /** 1口あたりの登録料（本来は`unit`prefixがついているべき） */
  registrationFee: Scalars["Int"]["output"];
  /** 拠点 */
  site: Site;
  /** 敷地面積 */
  siteSizeSqm: Scalars["Float"]["output"];
  /** 口数 */
  totalUnits: Scalars["Int"]["output"];
  /** CoOwners か FullOwner か */
  type: OwnerPlanType;
  /** 1口あたり火災保険料 */
  unitAnnualFireInsuranceFee: Scalars["Int"]["output"];
  /** 1口あたり借地料 */
  unitAnnualLandRentFee: Scalars["Int"]["output"];
  /** 1口あたり年間管理費 */
  unitAnnualMaintenanceFee: Scalars["Int"]["output"];
  /** 1口あたり温泉基本料金・更新料 */
  unitAnnualOnsenFee: Scalars["Int"]["output"];
  /** 1口あたり建物固定資産税 */
  unitAnnualPropertyTax: Scalars["Int"]["output"];
  /** 1口あたり修繕積立金 */
  unitAnnualRepairReserve: Scalars["Int"]["output"];
  /** 1口あたり申込金 */
  unitApplicationFee: Scalars["Int"]["output"];
  /** 1口あたり建物費 */
  unitBuildingFee: Scalars["Int"]["output"];
  /** 1口あたり年間の泊数 */
  unitNightsPerYear: Scalars["Int"]["output"];
  /** 1口あたり購入金額 */
  unitPurchaseAmount: Scalars["Int"]["output"];
};

/** (Co)Ownerのプラン */
export type OwnerPlancoOwnersPlanOfferingsArgs = {
  earlyAccessCode?: InputMaybe<Scalars["String"]["input"]>;
};

/** (Co)Ownerのプラン */
export type OwnerPlanheldAccommodationClassArgs = {
  night?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export const OwnerPlanType = {
  CoOwners: "CoOwners",
  FullOwner: "FullOwner",
} as const;

export type OwnerPlanType = (typeof OwnerPlanType)[keyof typeof OwnerPlanType];
export const OwnerPurchasePurposeType = {
  Other: "Other",
  SelfUse: "SelfUse",
} as const;

export type OwnerPurchasePurposeType =
  (typeof OwnerPurchasePurposeType)[keyof typeof OwnerPurchasePurposeType];
export type PartialUpdateOrganizationError = {
  __typename?: "PartialUpdateOrganizationError";
  message: Scalars["String"]["output"];
};

export type PartialUpdateOrganizationInput = {
  announcementContent?: InputMaybe<Scalars["String"]["input"]>;
  billingEmail?: InputMaybe<Scalars["String"]["input"]>;
  defaultFrequency?: InputMaybe<OrganizationYearlyContractInvoiceFrequency>;
  defaultPaymentMethod?: InputMaybe<OrganizationYearlyContractInvoicePaymentMethodType>;
  emailDomainsForMember?: InputMaybe<Array<Scalars["String"]["input"]>>;
  invitationCode?: InputMaybe<Scalars["String"]["input"]>;
  maxNightsPerMember?: InputMaybe<Scalars["Int"]["input"]>;
  maxNightsPerMonth?: InputMaybe<Scalars["Int"]["input"]>;
  maxNightsPerStay?: InputMaybe<Scalars["Int"]["input"]>;
  memberCustomFieldEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  memberCustomFieldName?: InputMaybe<Scalars["String"]["input"]>;
  memberCustomFieldPlaceholder?: InputMaybe<Scalars["String"]["input"]>;
  memberCustomFieldRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  paymentMethodCardEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  suspended?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PartialUpdateOrganizationMembershipError = {
  __typename?: "PartialUpdateOrganizationMembershipError";
  message: Scalars["String"]["output"];
};

export type PartialUpdateOrganizationMembershipInput = {
  customFieldValue?: InputMaybe<Scalars["String"]["input"]>;
  reservationStatus?: InputMaybe<OrganizationMemberReservationStatus>;
  role?: InputMaybe<OrganizationRole>;
};

export type PartialUpdateOrganizationMembershipPayload =
  | OrganizationMembership
  | PartialUpdateOrganizationMembershipError;

export type PartialUpdateOrganizationPayload =
  | Organization
  | PartialUpdateOrganizationError;

export const PaymentMethodType = {
  BankTransfer: "BankTransfer",
  Card: "Card",
} as const;

export type PaymentMethodType =
  (typeof PaymentMethodType)[keyof typeof PaymentMethodType];
/** PlainYearMonthのフィルタ条件 */
export type PlainYearMonthFilter = {
  /** 以上（gte）でフィルタする場合はtrue、完全一致の場合はfalse（デフォルト: false） */
  gte?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 以下（lte）でフィルタする場合はtrue、完全一致の場合はfalse（デフォルト: false） */
  lte?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** 値 */
  value: Scalars["PlainYearMonth"]["input"];
};

/** スマートプラグのデバイス情報 */
export type PlugDevice = {
  __typename?: "PlugDevice";
  /** デバイスのID */
  id: Scalars["ID"]["output"];
  /** 最終状態変更日時 */
  lastChangedAt: Scalars["ZonedDateTime"]["output"];
  /** ステータス */
  status: PlugDeviceStatus;
};

export const PlugDeviceStatus = {
  Available: "Available",
  InUse: "InUse",
  Unknown: "Unknown",
} as const;

export type PlugDeviceStatus =
  (typeof PlugDeviceStatus)[keyof typeof PlugDeviceStatus];
/** 新滞在レビュー回答投稿エラー */
export type PostStayReviewResponseError = {
  __typename?: "PostStayReviewResponseError";
  case: PostStayReviewResponseErrorCase;
};

export const PostStayReviewResponseErrorCase = {
  /** 権限がない（他人の予約） */
  NotAuthorized: "NotAuthorized",
  /** 指定した設問が存在しない */
  QuestionnaireNotFound: "QuestionnaireNotFound",
  /** 入力値が不正（必須フィールドが未指定） */
  ValidationError: "ValidationError",
} as const;

export type PostStayReviewResponseErrorCase =
  (typeof PostStayReviewResponseErrorCase)[keyof typeof PostStayReviewResponseErrorCase];
/**
 * 新滞在レビュー回答投稿の入力
 * 各入力値を省略した場合は元の値を保持する
 */
export type PostStayReviewResponseInput = {
  /** チェックアウト後の自由記入設問の回答 */
  freeTextAfterCheckOutAnswer?: InputMaybe<Scalars["String"]["input"]>;
  /** チェックアウト時の自由記入設問の回答 */
  freeTextAtCheckOutAnswer?: InputMaybe<Scalars["String"]["input"]>;
  /** 回答対象の設問のID */
  questionnaireId: Scalars["ID"]["input"];
  /**
   * 滞在の満足度
   * 1-5の5段階評価
   */
  rating?: InputMaybe<Scalars["Int"]["input"]>;
  /** チェックアウト後の選択式設問の回答（選択肢の key の配列） */
  selectionAfterCheckOutAnswer?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** チェックアウト時の選択式設問の回答（選択肢の key の配列） */
  selectionAtCheckOutAnswer?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type PostStayReviewResponsePayload =
  | PostStayReviewResponseError
  | StayReviewResponse;

export type PriceWithTaxRate = {
  __typename?: "PriceWithTaxRate";
  price: Scalars["Int"]["output"];
  taxRate: Scalars["Float"]["output"];
};

export type ProcessCronJobResponse = {
  __typename?: "ProcessCronJobResponse";
  body: Scalars["String"]["output"];
  status: Scalars["Int"]["output"];
};

export type ProcessStripeEventResponse = {
  __typename?: "ProcessStripeEventResponse";
  body: Scalars["String"]["output"];
  status: Scalars["Int"]["output"];
};

export type ProcessTrustdockEventResponse = {
  __typename?: "ProcessTrustdockEventResponse";
  body: Scalars["String"]["output"];
  status: Scalars["Int"]["output"];
};

export const PushNotificationPlatform = {
  Android: "Android",
  Apple: "Apple",
} as const;

export type PushNotificationPlatform =
  (typeof PushNotificationPlatform)[keyof typeof PushNotificationPlatform];
export type Query = {
  __typename?: "Query";
  /** 施設 (accommodation) を id で取得する。存在しない場合は null。認証不要。 */
  accommodation?: Maybe<Accommodation>;
  /** 宿泊施設の利用ブロック */
  accommodationAvailabilityBlock: AccommodationAvailabilityBlock;
  /** 予約ブロックカテゴリのマスタ一覧 */
  accommodationAvailabilityBlockCategoryInfos: Array<AccommodationAvailabilityBlockCategoryInfo>;
  /** 宿泊施設の利用ブロック一覧 */
  accommodationAvailabilityBlocks: Array<AccommodationAvailabilityBlock>;
  /** 宿泊予約 */
  accommodationReservation: AccommodationReservation;
  /**
   * 宿泊予約として可能なチェックアウト日
   * Accommodation.availabilities が可能なチェックイン日の候補を返すのに対して、
   * チェックイン日を選択した次のステップとして、可能なチェックアウト日の候補を返す。
   */
  accommodationReservationCheckOutAvailabilities: AccommodationReservationCheckOutAvailabilitiesPayload;
  /** 建築ページトップ */
  architectureTopPage: ContentArchitecturePageNavigation;
  /** 建築タイプページ */
  architectureTypePage: ContentArchitectureType;
  /** 建築タイプ一覧 */
  architectureTypes: Array<ArchitectureType>;
  /**
   * 単一エリアを slug で取得 (DXPJ 公開ページ用)。
   * 該当なし / 非公開の場合は null。
   */
  areaBySlug?: Maybe<Area>;
  /** published 済みの拠点を持つエリアの一覧。非公開を含む全件は internalAreas を使う。 */
  areas: Array<Area>;
  /** 予約ができるエリア一覧 */
  areasForReservation: Array<Area>;
  /** キャンセル可能なStay Giftチケット一覧を取得（Co-Owners/Owners向け） */
  cancellableStayGiftsForOwner: Array<StayTicket>;
  /** CoOwnersの申し込み */
  coOwnersApplication: CoOwnersApplication;
  /** 重要事項説明会スケジュール */
  coOwnersWebinarSchedule: CoOwnersWebinarSchedule;
  /**
   * 宿泊料金の見積もりが入ったドラフト予約
   * チェックイン日・チェックアウト日を選択した次のステップとして、
   * 予約フォームの下部で確定前に表示されるオブジェクトに相当。
   * 特にデータストアに永続化される前の予約であることに注意
   */
  draftAccommodationReservation: DraftAccommodationReservation;
  /**
   * provider を経由せず StayTicketMaster から直接見積もる、非会員向けの宿泊料金プレビュー。
   * 発行済み StayTicketUnit の実在を前提にしたフィールド（キャンセルポリシー等）は持たない。
   */
  draftAccommodationReservationByStayTicketMaster: DraftAccommodationReservationByStayTicketMasterResult;
  /** スタンダードプランの初月料金の見積もり */
  estimateStandardSubscriptionApplicationFee: EstimateStandardSubscriptionApplicationFeePayload;
  /** 宿泊予約をキャンセルした場合の料金の見積もり */
  estimatedCancelFeeOfAccommodationReservation: EstimatedCancelFeeOfAccommodationReservationPayload;
  /** 宿泊予約を変更する際にかかる変更手数料の見積もり */
  estimatedChangeFeeOfAccommodationReservation: EstimatedChangeFeeOfAccommodationReservationPayload;
  /** Co-Owners/Ownersプラン所有者が発行したStay Giftチケットをエクスポート用に取得 */
  exportStayGiftsForOwner: ExportStayGiftsPayload;
  /** 付帯サービスを取得 */
  facility?: Maybe<Facility>;
  /** 付帯サービス予約を取得 */
  facilityReservation?: Maybe<FacilityReservation>;
  /** Featureページ */
  featurePage: ContentArchitectureTypeFeature;
  /** 開発用のフック */
  hook?: Maybe<Scalars["String"]["output"]>;
  /** 宿泊施設の取得（ID指定） */
  internalAccommodation?: Maybe<Accommodation>;
  /** ブロック解放スケジュール一覧（管理者向け） */
  internalAccommodationAvailabilityBlockReleaseSchedules: Array<AccommodationAvailabilityBlockReleaseSchedule>;
  /**
   * すべての宿泊施設の機器一覧（Admin 用）
   * 拠点・部屋を横断してすべての機器情報を確認できる。status を問わず全件返す
   */
  internalAccommodationEquipments: Array<AccommodationEquipment>;
  /** 設備（サウナ・温泉など宿泊施設に備わる区分）の一覧 */
  internalAccommodationFacilities: Array<AccommodationFacility>;
  /** 設備詳細（管理者向け） */
  internalAccommodationFacility: AccommodationFacility;
  /** 宿泊施設お知らせ一覧 */
  internalAccommodationNotices: Array<AccommodationNotice>;
  /** 拠点の運用グループ一覧 */
  internalAccommodationOperationGroups: Array<AccommodationOperationGroup>;
  /** 予約一覧 */
  internalAccommodationReservationsBySearch: Array<AccommodationReservation>;
  /**
   * 予約一覧の CSV 用。引数と返す行は internalAccommodationReservationsBySearch と同じで、
   * 書き出しを閲覧と別の権限で絞るために root を分けている。
   */
  internalAccommodationReservationsForExport: Array<AccommodationReservation>;
  /**
   * 宿泊施設の一覧（code順）
   * siteIdsを指定すると、指定した拠点の宿泊施設のみを返す
   */
  internalAccommodations: Array<Accommodation>;
  /** 追加ゲスト料金ポリシーの一覧 */
  internalAdditionalGuestFeePolicies: Array<AdditionalGuestFeePolicy>;
  /** ID による追加ゲスト料金ポリシーの取得 */
  internalAdditionalGuestFeePolicyById?: Maybe<AdditionalGuestFeePolicy>;
  /**
   * 全ユーザーの管理ロールの割り当て。付与の新しい順。既定は有効なもの（未失効・未期限切れ）だけ。
   * 拠点スコープの付与権（PartnerSiteManager）では siteId が必須で、その拠点の割り当てのうち自分が付与・剥奪できるロール
   * （PartnerSiteStaff）の行だけ返し、PartnerSiteManager の行（自分の行を含む）は返さない。
   * 全拠点の付与権（SuperAdmin・RoleAdmin）も持つ主体は PartnerSiteManager を兼ねていても絞らず、複数の拠点の PartnerSiteManager は指定した拠点ごとに同じく絞る
   */
  internalAdminRoleAssignments: Array<AdminRoleAssignment>;
  /** 建築タイプ詳細（管理者向け） */
  internalArchitectureType: ArchitectureType;
  /** 建築タイプ一覧（管理者向け） */
  internalArchitectureTypes: Array<ArchitectureType>;
  /** エリア詳細 */
  internalArea: InternalArea;
  /** エリアガイド記事の全件（admin 用、sort 昇順） */
  internalAreaGuideArticles: Array<AreaGuideArticle>;
  /** エリア一覧（管理者向け、sort 昇順）。配下拠点の運用フラグ (published 等) を含む。 */
  internalAreas: Array<InternalArea>;
  /** Auth0ダッシュボードのベースURL（例: https://manage.auth0.com/dashboard/jp/sanu-dev） */
  internalAuth0DashboardBaseUrl: Scalars["String"]["output"];
  /** Auth0 Management APIからメールアドレスで検索したユーザー一覧 */
  internalAuth0UsersByEmail: Array<InternalAuth0User>;
  /** スタッフプラン登録可能なターム一覧 */
  internalAvailableStaffSemesters: Array<InternalAvailableStaffSemester>;
  /** 基本宿泊料金ポリシーの一覧 */
  internalBaseAccommodationFeePolicies: Array<RawBaseAccommodationFeePolicy>;
  /** Beds24 予約Block 削除の対象件数 (accommodationAvailabilityBlockId: null かつ beds24BlackBookingId: not null) */
  internalBeds24DeleteBlackBookingsTargetCount: Scalars["Int"]["output"];
  /** Beds24プロパティ情報をAPIから取得（JSON文字列で返却） */
  internalBeds24Property: Scalars["String"]["output"];
  /**
   * beds24 refresh token の有効性チェック（valid / error を JSON 文字列で返却）。
   * IP 環境・ローカル開発環境の Admin 限定
   */
  internalBeds24TokenStatus: Scalars["String"]["output"];
  /** 法人プランの一覧 */
  internalBusinessPlans: Array<BusinessPlan>;
  /** キャンセル料金ポリシーの一覧 */
  internalCancelFeePolicies: Array<RawCancelFeePolicy>;
  /** Co-Owners 申し込み */
  internalCoOwnersApplication?: Maybe<CoOwnersApplication>;
  /** Co-Owners 申し込み一覧 */
  internalCoOwnersApplications: Array<CoOwnersApplication>;
  /**
   * バクラク連携用CoOwners年次請求明細一覧
   * 対象は引渡完了（HandoverCompleted）の申込
   */
  internalCoOwnersBakurakuInvoiceAnnualPaymentItems: Array<CoOwnersBakurakuInvoiceAnnualPaymentItem>;
  /**
   * バクラク連携用CoOwners申込者一覧
   * 対象は入金完了前の全てのステータスの申込。送付先はユーザー単位なので同一申込者は 1 件にまとめる
   */
  internalCoOwnersBakurakuInvoiceRecipients: Array<CoOwnersBakurakuInvoiceRecipient>;
  /**
   * バクラク連携用CoOwners登録料請求明細一覧
   * 対象は登録料を事前請求する（advancePaymentRequired）契約締結済み（ContractSigned）の申込
   */
  internalCoOwnersBakurakuInvoiceRegistrationFeeItems: Array<CoOwnersBakurakuInvoiceRegistrationFeeItem>;
  /** バクラク連携用CoOwners残代金請求明細一覧 */
  internalCoOwnersBakurakuInvoiceRemainingPaymentItems: Array<CoOwnersBakurakuInvoiceRemainingPaymentItem>;
  /** 重要事項説明会一覧 */
  internalCoOwnersWebinarSchedules: Array<CoOwnersWebinarSchedule>;
  /** 建築家マスタ一覧（管理者向け、名前順） */
  internalContentArchitects: Array<ContentArchitect>;
  /** 設備コンテンツを設備 ID で引く（管理者向け）。未作成なら null */
  internalContentArchitecturalFeature?: Maybe<ContentArchitecturalFeature>;
  /** 建築ページ「基本の設備」マスタ一覧（管理者向け、sort 昇順） */
  internalContentArchitectureTypeBasicAmenities: Array<ContentArchitectureTypeBasicAmenity>;
  /**
   * 設備アメニティマスタ一覧（管理者向け、設備 → 名前順）。
   * accommodationFacilityId を指定するとその設備に属するものだけ返す
   */
  internalContentFacilityAmenities: Array<ContentArchitectureTypeVariantFacilityAmenity>;
  /**
   * Admin画面から、宿泊料金の見積もりが入ったドラフト予約
   * （予約フォームの下部で確定前に表示されるオブジェクトに相当）
   */
  internalDraftAccommodationReservation: DraftAccommodationReservation;
  /** 付帯サービス一覧を取得 */
  internalFacilities: Array<Facility>;
  /** 付帯サービスを取得 */
  internalFacility?: Maybe<Facility>;
  /** 付帯サービス予約一覧を取得 */
  internalFacilityReservations: Array<FacilityReservation>;
  /** 付帯サービスリソースのブロック一覧を取得 */
  internalFacilityResourceBlocks: Array<FacilityResourceBlock>;
  /**
   * 拠点ごとの未来の清掃量の一覧
   * 向こう2ヶ月分を返す
   * https://www.notion.so/sanu/Voyage-1b3d14f248a880a1801de9a485450222?pvs=4
   */
  internalFutureCleaningAmounts: InternalFutureCleaningAmountsPayload;
  /** ロックデバイス用の重複しないPINコードを生成する */
  internalGeneratePinCodeForLockDevice: Scalars["String"]["output"];
  /**
   * ユーザーの月次利用明細を生成する
   * 対象月（yearMonth）の予約に基づいて利用額を集計します
   * Ownersの家賃相殺計算用に作成した
   *
   * 対象月にチェックアウトしたものだけが計算対象なので注意
   * 例: 7/30チェックイン - 8/3チェックアウト: 8月が対象月
   */
  internalGenerateUserMonthlyStatement: InternalGenerateUserMonthlyStatementPayload;
  /**
   * 呼び出し元が internalAssignAdminRole で付与できるロールの一覧。siteId を渡すとその拠点に付与できるものに絞る。
   * 拠点スコープの付与権（PartnerSiteManager）では siteId が必須
   */
  internalGrantableAdminRoles: Array<InternalGrantableAdminRole>;
  /** ハイシーズン期間の一覧 */
  internalHighSeasonPeriods: Array<HighSeasonPeriod>;
  /**
   * 確認報告の一覧を新しい順に返す。
   * startFirstNight / endFirstNight は滞在の初日の範囲で絞り、片方だけの指定もできる。
   * id / type / siteId はいずれも絞り込みで、複数指定すると全てで絞る。
   * userId は宿泊者での絞り込みで、過去の違反履歴の取得に使う。
   */
  internalInspectionReports: Array<InspectionReport>;
  /**
   * IP 環境 beds24 セットアップの実行前見積もり（JSON 文字列で返却）。
   * DB カウントのみで beds24 への credit 消費なし。
   * fromDate / toDate（YYYY-MM-DD）は予約・ブロックの同期対象範囲
   */
  internalIpBeds24SetupEstimate: Scalars["String"]["output"];
  /** IP 環境 beds24 セットアップの進捗（JSON 文字列で返却、null = 未実行） */
  internalIpBeds24SetupStatus?: Maybe<Scalars["String"]["output"]>;
  /**
   * 確認日の清掃を取得する。予約が居ない部屋も空室として返す。
   * accommodationId を指定するとその部屋のみ、siteId のみなら拠点の全部屋。
   * 両方指定した場合は accommodationId が勝ち、どちらも未指定はエラー。
   * reservationId は accommodationId 指定時にのみ意味を持ち、キャンセルで
   * 在庫から引けなくなった予約の引き直しに使う
   */
  internalJtasInspections: Array<Inspection>;
  /** 地方税ポリシーの一覧。自治体名・税種別の順に並び、同じ自治体・税種別では有効開始日の新しい順 */
  internalLocalTaxPolicies: Array<LocalTaxPolicy>;
  /** 地方税ポリシーの詳細 */
  internalLocalTaxPolicy: LocalTaxPolicy;
  /** ネイティブアプリのホームコンテンツ取得 */
  internalNativeAppHomeContent?: Maybe<InternalNativeAppHomeContent>;
  /** ネイティブアプリのホームコンテンツ一覧 */
  internalNativeAppHomeContents: Array<InternalNativeAppHomeContent>;
  /** お知らせ一覧 */
  internalNews: Array<RawNews>;
  /** 指定 slug の one-shot スクリプト (ソース付き)。未登録の slug は null */
  internalOneShotScript?: Maybe<InternalOneShotScript>;
  /** レジストリに登録された one-shot スクリプト一覧 */
  internalOneShotScripts: Array<InternalOneShotScript>;
  /** 法人の詳細 */
  internalOrganization: Organization;
  /** 全法人の請求書一覧 */
  internalOrganizationYearlyContractInvoices: OrganizationYearlyContractInvoicesResult;
  /** 全法人の年間契約一覧 */
  internalOrganizationYearlyContracts: OrganizationYearlyContractsResult;
  /** 法人の一覧 */
  internalOrganizations: Array<Organization>;
  /** オーナープラン一覧 */
  internalOwnerPlans: Array<OwnerPlan>;
  /** スクリプト実行履歴 (新しい順)。slug 省略時は全スクリプト横断 */
  internalScriptExecutions: Array<InternalScriptExecution>;
  /** シーズン料金設定の一覧 */
  internalSeasonalFeeSettings: Array<SeasonalFeeSetting>;
  /** 拠点詳細 */
  internalSite: InternalSite;
  /** Nature Club のアクティビティプログラムを取得 */
  internalSiteActivityProgram?: Maybe<SiteActivityProgram>;
  /** Nature Club のアクティビティプログラム一覧を取得（削除済みを除く、作成日時の新しい順） */
  internalSiteActivityPrograms: Array<SiteActivityProgram>;
  /** 拠点FAQの一覧（管理者向け） */
  internalSiteFaqs: Array<RawSiteFaq>;
  /** 拠点ハイシーズン期間の一覧（管理者向け） */
  internalSiteHighSeasonPeriods: Array<SiteHighSeasonPeriod>;
  /** 拠点一覧。siteId を指定すると該当拠点のみ返す。省略時は予約可能な全拠点を返す。 */
  internalSites: Array<Site>;
  /** スタッフプラン契約詳細（管理画面用） */
  internalStaffContract: InternalStaffContract;
  /** スタッフプラン契約一覧（管理画面用） */
  internalStaffContracts: Array<InternalStaffContract>;
  /** スタッフプラン宿泊クレジット履歴（管理画面用） */
  internalStaffCreditTransactions: Array<InternalStaffCreditTransaction>;
  /** 社内スタッフグループの詳細（管理画面用） */
  internalStaffGroup: StaffGroup;
  /** 新滞在レビュー回答 */
  internalStayReviewResponse: StayReviewResponseWithReservation;
  /** 新滞在レビュー回答一覧 */
  internalStayReviewResponses: Array<StayReviewResponseWithReservation>;
  /** 滞在レビュー 2.0 が送信済みの宿泊予約。チェックアウト日（lastNight の翌日）の範囲で絞り、送信日時の降順で返す */
  internalStayReviewedAccommodationReservations: Array<AccommodationReservation>;
  /** コードによるチケットの取得 */
  internalStayTicketByCode?: Maybe<StayTicket>;
  /** ID によるチケットマスタの取得 */
  internalStayTicketMasterById?: Maybe<StayTicketMaster>;
  /** チケットマスター雛形一覧 */
  internalStayTicketMasterTemplates: Array<StayTicketMasterTemplate>;
  /** チケットマスタ一覧 */
  internalStayTicketMasters: Array<StayTicketMaster>;
  /** 宿泊チケットのテンプレート一覧 */
  internalStayTicketTemplates: Array<StayTicketTemplate>;
  /** 宿泊チケット一覧（管理画面用、ページネーション対応） */
  internalStayTickets: InternalStayTicketsResult;
  /** StripeダッシュボードのベースURL（例: https://dashboard.stripe.com/test） */
  internalStripeDashboardBaseUrl: Scalars["String"]["output"];
  /** 備品マスタを1件取得する。詳細画面のように id が既知の場合はこちらを使う */
  internalSupplyItemMaster?: Maybe<SupplyItemMaster>;
  /** 有効な備品マスタ一覧 */
  internalSupplyItemMasters: Array<SupplyItemMaster>;
  /** 部屋に設置されている備品を、部屋 > 建物タイプ > 拠点共通 の優先度で解決して返す */
  internalSupplyItems: Array<SupplyItem>;
  /** 規約一覧（共通規約と個別規約） */
  internalTerms: Array<Terms>;
  /** ユーザー */
  internalUser: User;
  /** オーナーシップ */
  internalUserOwnership: UserOwnership;
  /** オーナーシップ一覧 */
  internalUserOwnerships: Array<UserOwnership>;
  /** ユーザー統計情報 */
  internalUserStats: InternalUserStats;
  /** ユーザー一覧 */
  internalUsers: Array<User>;
  /** ユーザー一覧（検索） */
  internalUsersBySearch: Array<User>;
  /** ユーザー検索（ページネーション対応） */
  internalUsersSearch: InternalUserSearchResult;
  /**
   * OTA予約の予約参照番号で予約を検索し、事前登録URLまたはエラーを返す
   * 該当する予約がない場合は空配列を返す
   */
  lookupOtaReservationByReference: Array<OtaReservationLookupResult>;
  /** 現在のログインユーザー（ログインしなくても見れるがログイン情報で変化するページで利用する） */
  maybeViewer?: Maybe<User>;
  /** アプリホーム画面のコンテンツ一覧 */
  nativeAppHomeContents: Array<NativeAppHomeContent>;
  /** お知らせ一覧 */
  news: Array<News>;
  /** お知らせ詳細 */
  newsDetail: News;
  /** CoOwnersプランの提供内容 */
  offeredCoOwnersPlans: Array<OwnerPlan>;
  /** 法人組織 */
  organization: Organization;
  /** 招待コードから法人組織のIDを取得する */
  organizationIdByInvitationCode?: Maybe<Scalars["ID"]["output"]>;
  /** 組織メンバーの取得 */
  organizationMember: OrganizationMemberPayload;
  /** オーナープランの取得 */
  ownerPlan: OwnerPlan;
  /**
   * 指定期間のうち、繁忙日となる宿泊日。
   * 期間は予約できる範囲（今日〜1年後）に切り詰めて判定し、範囲外の日付は結果に含めない。
   * 繁忙日の定義は provider ごとの予約ルール改定の適用開始宿泊日によって変わるため provider を受け取る。
   * forBiz のルール移行が完了する 2028/5 宿泊以降は provider が不要になるので、その時点で引数から外す。
   */
  peakDays: Array<Scalars["PlainDate"]["output"]>;
  /** スマートプラグを取得 */
  plugDevice?: Maybe<PlugDevice>;
  /** 2027年度予約ルール改定の設定値を provider ごとに返す。 */
  reservationRuleRevision2027Policy: ReservationRuleRevision2027Policy;
  /**
   * ルームタイプを id で取得する。存在しない場合は null。認証不要。
   * 部屋タイプ予約の詳細モーダルなど、accommodation を介さず RoomType 単体で詳細を引くために使う。
   */
  roomType?: Maybe<RoomType>;
  /**
   * 部屋タイプ詳細ページ (公開)。拠点 slug と部屋タイプ slug で一意に引く。
   * 該当が無い場合は null (FE 側で notFound 表示)。
   */
  roomTypeBySlug?: Maybe<RoomType>;
  /**
   * 単一拠点を slug で取得 (DXPJ 公開ページ用)。
   * published 済みの拠点のみを返す (予約開始前の拠点も含む)。
   * 該当なし / 非公開の場合は null。
   */
  siteBySlug?: Maybe<Site>;
  /**
   * 社内スタッフグループの一覧
   * 発行したチケットや予約ブロックに紐づけるためのグループ
   * 基本的に組織図とマッチさせる
   */
  staffGroups: Array<StaffGroup>;
  /** 新滞在レビューの設問 */
  stayReviewQuestionnaire: StayReviewQuestionnaire;
  /** 滞在レビュー 2.0 の設問定義。設問は固定で、ラベルの正はサーバー側にある */
  stayReviewV2Form: StayReviewV2Form;
  /**
   * 宿泊チケットのユーザー向け情報をStayTicketUnitIdで取得する。
   * 返すのは masterやownership 由来の config のみで、個別チケットの情報（code / stayTickets 等）は含まない。
   * unit が存在しない場合は null。
   */
  stayTicketReservationInfo?: Maybe<StayTicketReservationInfo>;
  /** ユーザーに紐づいていない仮予約を `userAcceptCode` で取得する */
  tentativeAccommodationReservation: TentativeAccommodationReservationPayload;
  /** トップページコンテンツ */
  topPage: TopPage;
  /** コードから URL パスを取得する */
  urlFromCode?: Maybe<Scalars["String"]["output"]>;
  /** 同伴者 */
  userCompanion: UserCompanion;
  /** オーナーシップの取得 */
  userOwnership: UserOwnership;
  /** アカウント連携のセッショントークンを検証し、連携候補情報を返す */
  verifyAccountLinkSession: VerifyAccountLinkSessionPayload;
  /** 現在のログインユーザー（ログイン前提のページではこちらを利用すると良い） */
  viewer: User;
};

export type QueryaccommodationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryaccommodationAvailabilityBlockArgs = {
  id: Scalars["String"]["input"];
};

export type QueryaccommodationAvailabilityBlocksArgs = {
  accommodationScope?: InputMaybe<AccommodationScope>;
  endBeginNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endEndNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startBeginNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startEndNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export type QueryaccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryaccommodationReservationCheckOutAvailabilitiesArgs = {
  input: AccommodationReservationCheckOutAvailabilitiesInput;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryarchitectureTypePageArgs = {
  slug: Scalars["String"]["input"];
};

export type QueryarchitectureTypesArgs = {
  withPrivate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryareaBySlugArgs = {
  slug: Scalars["String"]["input"];
};

export type QueryareasForReservationArgs = {
  areaIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

export type QuerycoOwnersApplicationArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerycoOwnersWebinarScheduleArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerydraftAccommodationReservationArgs = {
  input: DraftAccommodationReservationInput;
};

export type QuerydraftAccommodationReservationByStayTicketMasterArgs = {
  input: DraftAccommodationReservationByStayTicketMasterInput;
};

export type QueryestimateStandardSubscriptionApplicationFeeArgs = {
  promotionCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryestimatedCancelFeeOfAccommodationReservationArgs = {
  id: Scalars["ID"]["input"];
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryestimatedChangeFeeOfAccommodationReservationArgs = {
  fromAccommodationReservationId: Scalars["ID"]["input"];
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  to: EstimatedChangeFeeOfAccommodationReservationInput;
};

export type QueryexportStayGiftsForOwnerArgs = {
  userOwnershipId?: InputMaybe<Scalars["ID"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryfacilityArgs = {
  accommodationReservationId: Scalars["ID"]["input"];
  facilityType: FacilityType;
};

export type QueryfacilityReservationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryfeaturePageArgs = {
  slug: Scalars["String"]["input"];
};

export type QueryhookArgs = {
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryinternalAccommodationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalAccommodationFacilityArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalAccommodationOperationGroupsArgs = {
  siteId: Scalars["ID"]["input"];
};

export type QueryinternalAccommodationReservationsBySearchArgs = {
  accommodationScope?: InputMaybe<AccommodationScope>;
  endFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export type QueryinternalAccommodationReservationsForExportArgs = {
  accommodationScope?: InputMaybe<AccommodationScope>;
  endFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  endLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startLastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export type QueryinternalAccommodationsArgs = {
  siteIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type QueryinternalAdditionalGuestFeePolicyByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalAdminRoleAssignmentsArgs = {
  includeInactive?: InputMaybe<Scalars["Boolean"]["input"]>;
  role?: InputMaybe<AdminRole>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryinternalArchitectureTypeArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalAreaArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalAuth0UsersByEmailArgs = {
  email: Scalars["String"]["input"];
};

export type QueryinternalBeds24PropertyArgs = {
  propertyId: Scalars["Int"]["input"];
};

export type QueryinternalCoOwnersApplicationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalCoOwnersBakurakuInvoiceAnnualPaymentItemsArgs = {
  programYear: Scalars["Int"]["input"];
};

export type QueryinternalContentArchitecturalFeatureArgs = {
  accommodationFacilityId: Scalars["ID"]["input"];
};

export type QueryinternalContentFacilityAmenitiesArgs = {
  accommodationFacilityId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryinternalDraftAccommodationReservationArgs = {
  input: DraftAccommodationReservationInput;
  waiveCleaningFee: Scalars["Boolean"]["input"];
};

export type QueryinternalFacilitiesArgs = {
  facilityType?: InputMaybe<FacilityType>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryinternalFacilityArgs = {
  accommodationReservationId?: InputMaybe<Scalars["ID"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type QueryinternalFacilityReservationsArgs = {
  endDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  facilityType?: InputMaybe<FacilityType>;
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  startDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  status?: InputMaybe<FacilityReservationStatusType>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryinternalFacilityResourceBlocksArgs = {
  blockType?: InputMaybe<FacilityResourceBlockType>;
  endDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  facilityType?: InputMaybe<FacilityType>;
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  startDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export type QueryinternalFutureCleaningAmountsArgs = {
  siteId: Scalars["ID"]["input"];
};

export type QueryinternalGenerateUserMonthlyStatementArgs = {
  userId: Scalars["ID"]["input"];
  yearMonth: Scalars["PlainYearMonth"]["input"];
};

export type QueryinternalGrantableAdminRolesArgs = {
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryinternalInspectionReportsArgs = {
  endFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
  startFirstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  type?: InputMaybe<InspectionReportType>;
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryinternalIpBeds24SetupEstimateArgs = {
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
  phases?: InputMaybe<Array<Scalars["String"]["input"]>>;
  toDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryinternalJtasInspectionsArgs = {
  accommodationId?: InputMaybe<Scalars["ID"]["input"]>;
  inspectionDate: Scalars["PlainDate"]["input"];
  reservationId?: InputMaybe<Scalars["ID"]["input"]>;
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryinternalLocalTaxPolicyArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalNativeAppHomeContentArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalOneShotScriptArgs = {
  slug: Scalars["ID"]["input"];
};

export type QueryinternalOrganizationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalOrganizationYearlyContractInvoicesArgs = {
  contractEndMonth?: InputMaybe<PlainYearMonthFilter>;
  contractIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  contractStartMonth?: InputMaybe<PlainYearMonthFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  organizationIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  startingAfter?: InputMaybe<Scalars["ID"]["input"]>;
  statuses?: InputMaybe<Array<StripeInvoiceStatus>>;
};

export type QueryinternalOrganizationYearlyContractsArgs = {
  contractIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  endMonth?: InputMaybe<PlainYearMonthFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  organizationIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  sort?: InputMaybe<OrganizationYearlyContractSortInput>;
  startMonth?: InputMaybe<PlainYearMonthFilter>;
  startingAfter?: InputMaybe<Scalars["ID"]["input"]>;
  statuses?: InputMaybe<Array<ContractStatus>>;
};

export type QueryinternalOrganizationsArgs = {
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryinternalScriptExecutionsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  slug?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryinternalSiteArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalSiteActivityProgramArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalSiteHighSeasonPeriodsArgs = {
  siteId: Scalars["ID"]["input"];
};

export type QueryinternalSitesArgs = {
  siteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryinternalStaffContractArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalStaffCreditTransactionsArgs = {
  contractId: Scalars["ID"]["input"];
};

export type QueryinternalStaffGroupArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalStayReviewResponseArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalStayReviewResponsesArgs = {
  endCheckOutDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
  startCheckOutDate?: InputMaybe<Scalars["PlainDate"]["input"]>;
};

export type QueryinternalStayReviewedAccommodationReservationsArgs = {
  endCheckOutDate: Scalars["PlainDate"]["input"];
  startCheckOutDate: Scalars["PlainDate"]["input"];
};

export type QueryinternalStayTicketByCodeArgs = {
  code: Scalars["String"]["input"];
};

export type QueryinternalStayTicketMasterByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalStayTicketsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<InternalStayTicketsOrderBy>;
  orderDir?: InputMaybe<SortDirection>;
  statuses?: InputMaybe<Array<StayTicketStatusType>>;
  stayTicketMasterId: Scalars["ID"]["input"];
};

export type QueryinternalSupplyItemMasterArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalSupplyItemsArgs = {
  accommodationId: Scalars["ID"]["input"];
};

export type QueryinternalUserArgs = {
  id: Scalars["String"]["input"];
};

export type QueryinternalUserOwnershipArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryinternalUsersBySearchArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryinternalUsersSearchArgs = {
  excludeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerylookupOtaReservationByReferenceArgs = {
  reference: Scalars["String"]["input"];
};

export type QuerynewsDetailArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryofferedCoOwnersPlansArgs = {
  earlyAccessCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryorganizationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryorganizationIdByInvitationCodeArgs = {
  invitationCode: Scalars["String"]["input"];
};

export type QueryorganizationMemberArgs = {
  userId: Scalars["ID"]["input"];
};

export type QueryownerPlanArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerypeakDaysArgs = {
  firstNight: Scalars["PlainDate"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

export type QueryplugDeviceArgs = {
  id: Scalars["String"]["input"];
};

export type QueryreservationRuleRevision2027PolicyArgs = {
  provider: AccommodationReservationProviderInput;
};

export type QueryroomTypeArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryroomTypeBySlugArgs = {
  roomTypeSlug: Scalars["String"]["input"];
  siteSlug: Scalars["String"]["input"];
};

export type QuerysiteBySlugArgs = {
  slug: Scalars["String"]["input"];
};

export type QuerystaffGroupsArgs = {
  includeInvalidated?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerystayTicketReservationInfoArgs = {
  stayTicketUnitId: Scalars["ID"]["input"];
};

export type QuerytentativeAccommodationReservationArgs = {
  code: Scalars["ID"]["input"];
};

export type QueryurlFromCodeArgs = {
  code: Scalars["String"]["input"];
};

export type QueryuserCompanionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryuserOwnershipArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryverifyAccountLinkSessionArgs = {
  input: VerifyAccountLinkSessionInput;
};

/** 基本宿泊料金ポリシー（管理者向け） */
export type RawBaseAccommodationFeePolicy = {
  __typename?: "RawBaseAccommodationFeePolicy";
  /** 宿泊料金のポリシー */
  dailyFeePolicy: Array<Scalars["Int"]["output"]>;
  /** 動的価格モード用の価格修正値 */
  feeModifier?: Maybe<Scalars["Int"]["output"]>;
  /** 価格修正タイプ（パーセンテージまたは固定値） */
  feeModifierType?: Maybe<FeeModifierType>;
  /** 料金設定ルール */
  feeRules: Array<AccommodationFeeRule>;
  id: Scalars["ID"]["output"];
  /** 内部向けの名前 */
  internalName: Scalars["String"]["output"];
  /** 宿泊費の一部または全部が第三者（タイアップ先等）の負担であるか */
  isThirdPartyCovered: Scalars["Boolean"]["output"];
  /** dailyFeePolicy に含まれない第三者負担額（泊毎） */
  thirdPartyCoveredDailyFeePolicy: Array<Scalars["Int"]["output"]>;
};

/** キャンセル料金のポリシー （管理者向け） */
export type RawCancelFeePolicy = {
  __typename?: "RawCancelFeePolicy";
  cancelFeePolicy: CancelFeePolicy;
  id: Scalars["ID"]["output"];
  internalDescription: Scalars["String"]["output"];
  internalName: Scalars["String"]["output"];
};

export type RawNews = {
  __typename?: "RawNews";
  content: Scalars["String"]["output"];
  contentType: NewsContentType;
  createdUser: User;
  displayCategory: NewsDisplayCategory;
  id: Scalars["ID"]["output"];
  publishedAt: Scalars["ZonedDateTime"]["output"];
  status: NewsStatus;
  targetPlans: Array<TargetPlanType>;
  title: Scalars["String"]["output"];
};

/** 拠点FAQ（管理者向け） */
export type RawSiteFaq = {
  __typename?: "RawSiteFaq";
  /** 回答 (HTML) */
  answer: Scalars["String"]["output"];
  /** 案内画像URL（チェックイン当日メール・拠点ページ・nativeappチェックインシートに表示） */
  guidanceImageUrl?: Maybe<Scalars["String"]["output"]>;
  /** ID */
  id: Scalars["ID"]["output"];
  /** 質問 */
  question: Scalars["String"]["output"];
  /** 拠点 */
  site: Site;
  /** 並び順 */
  sort?: Maybe<Scalars["Int"]["output"]>;
};

export type RedirectLocation = {
  __typename?: "RedirectLocation";
  path: Scalars["String"]["output"];
};

export type RegisterCoOwnersApplicationFileError = {
  __typename?: "RegisterCoOwnersApplicationFileError";
  case: RegisterCoOwnersApplicationFileErrorCase;
};

export const RegisterCoOwnersApplicationFileErrorCase = {
  AlreadyRegistered: "AlreadyRegistered",
  /** S3 にアップロードされていない */
  FileNotUploaded: "FileNotUploaded",
  /** ファイル名・保存先・種別・サイズのいずれかが不正 */
  InvalidFile: "InvalidFile",
  NotFound: "NotFound",
} as const;

export type RegisterCoOwnersApplicationFileErrorCase =
  (typeof RegisterCoOwnersApplicationFileErrorCase)[keyof typeof RegisterCoOwnersApplicationFileErrorCase];
export type RegisterCoOwnersApplicationFileInput = {
  coOwnersApplicationId: Scalars["ID"]["input"];
  fileName: Scalars["String"]["input"];
  /** アップロードポリシーで返された rawUrl */
  rawUrl: Scalars["String"]["input"];
};

export type RegisterCoOwnersApplicationFilePayload =
  | RegisterCoOwnersApplicationFileError
  | RegisterCoOwnersApplicationFileSuccess;

export type RegisterCoOwnersApplicationFileSuccess = {
  __typename?: "RegisterCoOwnersApplicationFileSuccess";
  file: CoOwnersApplicationFile;
};

/** アイデンティティ削除エラー */
export type RemoveIdentityError = {
  __typename?: "RemoveIdentityError";
  case: RemoveIdentityErrorCase;
};

/** アイデンティティ削除エラーケース */
export const RemoveIdentityErrorCase = {
  /** Appleトークンの失効に失敗したためアカウント連携を解除できない */
  AppleTokenRevocationFailed: "AppleTokenRevocationFailed",
  /** 指定のプロバイダーが見つからない */
  IdentityNotFound: "IdentityNotFound",
  /** 最後のアイデンティティは削除不可 */
  LastIdentity: "LastIdentity",
  /** 削除後に認証済みアイデンティティが残らない */
  NoVerifiedRemaining: "NoVerifiedRemaining",
  /** パスワードが未設定のためソーシャルアカウントを解除できない */
  PasswordNotSet: "PasswordNotSet",
  /** 認証されていない */
  Unauthorized: "Unauthorized",
} as const;

export type RemoveIdentityErrorCase =
  (typeof RemoveIdentityErrorCase)[keyof typeof RemoveIdentityErrorCase];
/** アイデンティティ削除の入力 */
export type RemoveIdentityInput = {
  /** 削除するプロバイダー */
  provider: IdentityProvider;
};

/** アイデンティティ削除結果 */
export type RemoveIdentityPayload = RemoveIdentityError | RemoveIdentitySuccess;

/** アイデンティティ削除成功 */
export type RemoveIdentitySuccess = {
  __typename?: "RemoveIdentitySuccess";
  /** 削除されたプロバイダー */
  removedProvider: IdentityProvider;
};

/** 付帯サービスレンタサイクル向けキーボックスのコントローラ属性情報 */
export type RentalCycleKeyBox = {
  __typename?: "RentalCycleKeyBox";
  comment?: Maybe<Scalars["String"]["output"]>;
  inUseAt?: Maybe<Scalars["String"]["output"]>;
  pinCode?: Maybe<Scalars["String"]["output"]>;
  reservationId: Scalars["ID"]["output"];
  returnedAt?: Maybe<Scalars["String"]["output"]>;
  usableFrom: Scalars["PlainDateTime"]["output"];
  usableTo: Scalars["PlainDateTime"]["output"];
};

/** エクスポート用の予約アイテム */
export type ReservationExportItem = {
  __typename?: "ReservationExportItem";
  /** 部屋コード */
  accommodationCode: Scalars["String"]["output"];
  /** チェックイン日 */
  checkInDate: Scalars["PlainDate"]["output"];
  /** チェックアウト日 */
  checkOutDate: Scalars["PlainDate"]["output"];
  /** 紐づく契約の開始日（該当契約がない場合はnull） */
  contractStartDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 予約作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** 予約ID */
  id: Scalars["ID"]["output"];
  /** 宿泊日数 */
  nights: Scalars["Int"]["output"];
  /** 宿泊人数（大人） */
  numberOfAdults: Scalars["Int"]["output"];
  /** 愛犬同伴数 */
  numberOfDogs: Scalars["Int"]["output"];
  /** 宿泊人数（6歳未満） */
  numberOfInfants: Scalars["Int"]["output"];
  /** 宿泊人数（小学生まで、12歳未満） */
  numberOfKids: Scalars["Int"]["output"];
  /** 所属企業名 */
  organizationName: Scalars["String"]["output"];
  /** 宿泊拠点 */
  siteName: Scalars["String"]["output"];
  /** 滞在コメント */
  stayComment?: Maybe<Scalars["String"]["output"]>;
  /** 滞在評価 */
  stayRating?: Maybe<Scalars["Int"]["output"]>;
  /** 滞在ステータス */
  stayStatus: AccommodationReservationStayStatus;
  /** 支払い総額 */
  totalAmount: Scalars["Int"]["output"];
  /** 最新予約更新日時 */
  updatedAt: Scalars["ZonedDateTime"]["output"];
  /** Eメールアドレス */
  userEmail: Scalars["String"]["output"];
  /** 名前 */
  userName: Scalars["String"]["output"];
};

export type ReservationPriceStatement = {
  __typename?: "ReservationPriceStatement";
  /** 宿泊税 */
  accommodationTax: Scalars["Int"]["output"];
  /** 追加設備利用料金(サウナ・温泉・ドッグランなど) */
  additionalFacilityFee: Scalars["Int"]["output"];
  /** 追加料金（Selection, LARGE, High日 など） */
  additionalFee: Scalars["Int"]["output"];
  /** 基本金額 */
  baseFee: Scalars["Int"]["output"];
  /** 入湯税 */
  bathingTax: Scalars["Int"]["output"];
  /** キャンセル料 */
  cancelFee: Scalars["Int"]["output"];
  /** 清掃料金(簡易清掃を含む) */
  cleaningFee: Scalars["Int"]["output"];
  /**
   * 有料備品利用料金
   * 税率ごとに細かく見たい場合は `consumedSuppliesFeeByTaxRate` を使う
   */
  consumedSuppliesFee: Scalars["Int"]["output"];
  /**
   * 有料備品利用料金(税率ごと)
   * 税率ごとに把握したい場合はこちらを使う
   * とにかく合計が知りたければ `consumedSuppliesFee` を使う
   */
  consumedSuppliesFeeByTaxRate: Array<PriceWithTaxRate>;
  /** 愛犬同伴追加料金 */
  dogFee: Scalars["Int"]["output"];
  /** EV充電追加料金 */
  evFee: Scalars["Int"]["output"];
  /** 付帯サービス予約利用料金 */
  facilityReservationFee: Scalars["Int"]["output"];
};

/**
 * 2027年度予約ルール改定の provider ごとの設定値。
 * forBiz は契約更新月から法人ごとに導出し、それ以外は 2027/4/1 固定。
 * forBiz の移行が完了する 2028/5 宿泊以降は不要になるので、その時点で @deprecated を経て削除する。
 */
export type ReservationRuleRevision2027Policy = {
  __typename?: "ReservationRuleRevision2027Policy";
  /**
   * ルール改定の案内を出し始める日
   * forBiz は新規約の適用開始日の 2 ヶ月前、forBiz 以外は一律で 10/1
   */
  announcementStartDate: Scalars["PlainDate"]["output"];
  /** ルール改定が適用される最初の宿泊日 */
  firstApplicableNight: Scalars["PlainDate"]["output"];
};

export type ReservationStatementItem = {
  __typename?: "ReservationStatementItem";
  /** 宿泊施設名 */
  accommodationName: Scalars["String"]["output"];
  /**
   * キャンセル日時
   * Stay Gift from Ownersの場合、3日前の15:00以降にキャンセルするとキャンセル料請求が発生する。
   * このタイミングを計算するためにキャンセル日時を含めている。
   */
  canceledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 利用日（YYYY-MM-DD） */
  date: Scalars["PlainDate"]["output"];
  /** 宿泊料金の詳細 */
  fee: AccommodationFee;
  /** 合計金額（税込） */
  price: Scalars["Int"]["output"];
  /** 料金内訳 */
  priceStatement: ReservationPriceStatement;
  /** 予約ID */
  reservationId: Scalars["ID"]["output"];
  /** ステータス（滞在済 / キャンセル など） */
  status: Scalars["String"]["output"];
  /** 予約種別（個人サブスク / Co-Owners / チケット など） */
  type: Scalars["String"]["output"];
};

export const ResourcePermission = {
  AccommodationsRead: "AccommodationsRead",
  /** 管理ロール（AdminRoleAssignment）の付与・剥奪・一覧。どのロールを付けられるかは @role の assignableRoles で決まる。 */
  AdminRolesWrite: "AdminRolesWrite",
  AvailabilityBlocksRead: "AvailabilityBlocksRead",
  CoOwnersRead: "CoOwnersRead",
  /** 開発用の口（hook・テスト SMS・テスト用ポイント付与）。 */
  DevToolsUse: "DevToolsUse",
  FacilitiesRead: "FacilitiesRead",
  /** 付帯サービス予約の清掃ステータスの更新。 */
  FacilityCleaningWrite: "FacilityCleaningWrite",
  FullOwnersRead: "FullOwnersRead",
  FullOwnersWrite: "FullOwnersWrite",
  InspectionsRead: "InspectionsRead",
  /** マシンプリンシパル。人間のロールには付与できない。 */
  JtasSyncWrite: "JtasSyncWrite",
  OrganizationsRead: "OrganizationsRead",
  ReservationsRead: "ReservationsRead",
  /** 予約一覧の書き出し（CSV）。閲覧（ReservationsRead）とは別に、一覧をファイルで持ち出せる主体を絞る。 */
  ReservationsUse: "ReservationsUse",
  ReservationsWrite: "ReservationsWrite",
  /** one-shot スクリプトの閲覧・実行。本番と preview では resolver が allowlist も見る。 */
  ScriptsUse: "ScriptsUse",
  SitesRead: "SitesRead",
  StayTicketsRead: "StayTicketsRead",
  /** 同伴者。住所・生年月日が non-null で leaf マスクできないため、関係ごと gate する。 */
  UserCompanionsRead: "UserCompanionsRead",
  /** Auth0 の連携 identity 参照。解除 (UsersIdentityWrite) とは別の権限。 */
  UsersIdentityRead: "UsersIdentityRead",
  UsersRead: "UsersRead",
  UsersWrite: "UsersWrite",
} as const;

export type ResourcePermission =
  (typeof ResourcePermission)[keyof typeof ResourcePermission];
export type ResumeStandardSubscriptionImmediatelyError = {
  __typename?: "ResumeStandardSubscriptionImmediatelyError";
  case: ResumeStandardSubscriptionImmediatelyErrorCase;
  info?: Maybe<Scalars["String"]["output"]>;
};

export const ResumeStandardSubscriptionImmediatelyErrorCase = {
  AlreadySubscribedError: "AlreadySubscribedError",
  InvalidOperation: "InvalidOperation",
  NoSubscriptionScheduleError: "NoSubscriptionScheduleError",
  StripeError: "StripeError",
  UnexpectedSubscriptionScheduleStatus: "UnexpectedSubscriptionScheduleStatus",
} as const;

export type ResumeStandardSubscriptionImmediatelyErrorCase =
  (typeof ResumeStandardSubscriptionImmediatelyErrorCase)[keyof typeof ResumeStandardSubscriptionImmediatelyErrorCase];
export type ResumeStandardSubscriptionImmediatelyPayload =
  | ResumeStandardSubscriptionImmediatelyError
  | Success;

/**
 * ルームタイプ。OTA Room Type と自社 Room Type を統合した統一モデル。
 * 複数の Accommodation が同じ RoomType を共有することがある。
 */
export type RoomType = {
  __typename?: "RoomType";
  /**
   * このルームタイプの建築タイプ。一覧での建築タイプ単位グルーピングや、
   * 定員・広さ等の表示に使う。architectureTypeId 未設定の場合は null。
   */
  architectureType?: Maybe<ArchitectureType>;
  /**
   * このルームタイプの日次の空き状況と料金。provider は料金計算に必須。
   *
   * 現状は StayTicket プロバイダーでのみ動作確認している。他のプロバイダーで利用する場合は、
   * 予約可能資産や予約可能期間の前提が変わりうるため、改めて実装を確認すること。
   */
  availabilities: RoomTypeAvailabilities;
  /**
   * provider を経由せず StayTicketMaster から直接解決した、日次の空き状況と料金。
   * 非会員向けの拠点ページプレビュー（発行済み StayTicketUnit を持たない）向け。
   */
  availabilitiesByStayTicketMaster: RoomTypeAvailabilities;
  /** 表示コンテンツ */
  content?: Maybe<ContentRoomType>;
  /**
   * 自社サイト向けの表示名。`displayNames` JSON から viewer locale (現状は ja 固定)
   * で解決される。未設定の場合は空文字 (呼び出し側でトルツメする想定)。
   */
  displayName: Scalars["String"]["output"];
  /** 特徴（温泉・サウナ・ペット可・富士山ビュー 等）。`sort` 昇順で並ぶ。 */
  features: Array<RoomTypeFeature>;
  id: Scalars["ID"]["output"];
  /**
   * 注意書き（例: "焚き火台なしのお部屋です"）。viewer locale で解決される。
   * 空文字 / 未設定の場合は null（呼び出し側でトルツメする想定）。
   */
  notes?: Maybe<Scalars["String"]["output"]>;
  /** このルームタイプが属する拠点。詳細表示の拠点名・地図リンク等に使う。 */
  site: Site;
  /**
   * URL 用 slug（拠点内でユニーク）。既存データには未設定のものがあり、
   * その場合は null（部屋タイプ詳細ページへの導線を出さない想定）。
   */
  slug?: Maybe<Scalars["String"]["output"]>;
};

/**
 * ルームタイプ。OTA Room Type と自社 Room Type を統合した統一モデル。
 * 複数の Accommodation が同じ RoomType を共有することがある。
 */
export type RoomTypeavailabilitiesArgs = {
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  lastNight?: InputMaybe<Scalars["PlainDate"]["input"]>;
  provider: AccommodationReservationProviderInput;
};

/**
 * ルームタイプ。OTA Room Type と自社 Room Type を統合した統一モデル。
 * 複数の Accommodation が同じ RoomType を共有することがある。
 */
export type RoomTypeavailabilitiesByStayTicketMasterArgs = {
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstNight: Scalars["PlainDate"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
  stayTicketMasterReference: StayTicketMasterReferenceInput;
};

/** ルームタイプの空室・料金まとめ */
export type RoomTypeAvailabilities = {
  __typename?: "RoomTypeAvailabilities";
  /** 予約可能な日の中での最安単価（「◯◯円〜」表示用）。空き（予約可能日）が無いときは null。 */
  fromPrice?: Maybe<Scalars["Int"]["output"]>;
  /** 各泊の空室情報（1要素=1泊） */
  nights: Array<RoomTypeAvailability>;
  /**
   * 空き・料金の解決元となった StayTicketMaster の ID。
   * availabilitiesByStayTicketMaster 経由のときのみ解決済みの値が入り、availabilities（provider経由）では常に null。
   */
  stayTicketMasterId?: Maybe<Scalars["ID"]["output"]>;
};

/** ルームタイプの日次空室情報 */
export type RoomTypeAvailability = {
  __typename?: "RoomTypeAvailability";
  /**
   * その日に空いている宿泊施設。
   * FE はここから連泊/延泊を積集合で導出し、1室を選んで従来の予約フローへ進む。
   */
  availableAccommodations: Array<Accommodation>;
  /** その日の残室数（「残り◯室」表示・連泊判定の材料） */
  availableCount: Scalars["Int"]["output"];
  /** その日に1室でも空きがあるか（= availableCount > 0、カレンダー○×用） */
  isAvailable: Scalars["Boolean"]["output"];
  /** その日 (CI) を起点に、いずれかの宿泊施設で通しで確保できる最大連泊数。 */
  maxConsecutiveNights: Scalars["Int"]["output"];
  /** 対象の宿泊日（1泊） */
  night: Scalars["PlainDate"]["output"];
  /**
   * その日・そのルームタイプの1泊単価（代表室で計算）。
   * 連泊割・人数追加・オプション・清掃料を含まない単泊基準（連泊割込み価格が要るマーケ施策では別途計算が必要）。
   */
  price: Scalars["Int"]["output"];
};

/** ルームタイプの特徴マスター。多対多で RoomType に紐付く。 */
export type RoomTypeFeature = {
  __typename?: "RoomTypeFeature";
  /** カテゴリ分類 */
  category: RoomTypeFeatureCategory;
  /** 表示用の名前。`name` JSON から viewer locale で解決される。 */
  displayName: Scalars["String"]["output"];
  /**
   * アイコン slug。FE 側で `/i/dx/<iconSlug>.svg` などにマッピングして表示する。
   * 未設定なら null。
   */
  iconSlug?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /**
   * 機械可読 slug (例: "sauna", "fuji-view", "dog-friendly")。
   * FE 側で表示する feature を絞る allow-list の key にもなる。
   */
  slug: Scalars["String"]["output"];
  /** 表示・組み立て時の並び順 (昇順、全体共通) */
  sort: Scalars["Int"]["output"];
};

/** ルームタイプの特徴カテゴリ */
export const RoomTypeFeatureCategory = {
  /** 設備（サウナ・温泉・EV充電器・ワーケーション・焚き火台 等） */
  Amenity: "Amenity",
  /** 階数（1階・2階） */
  Floor: "Floor",
  /** その他（ペット可 等） */
  Other: "Other",
  /** 景色（富士山ビュー・オーシャンビュー 等） */
  View: "View",
} as const;

export type RoomTypeFeatureCategory =
  (typeof RoomTypeFeatureCategory)[keyof typeof RoomTypeFeatureCategory];
/** Co-Owners充当特典（旧S2Oポイント） */
export type S2o = {
  __typename?: "S2o";
  /**
   * 台帳残高。Standard / Trial / Stay / 申込キャンセルの返却分の合計。
   * Stay 分を除いた額は weekdayTrialBalance。
   */
  balance: Scalars["Int"]["output"];
  /** 取引履歴 */
  points: Array<S2oPoint>;
  /**
   * Stay 宿泊で蓄積した充当特典。台帳の Stay 分（特例の手動付与）と宿泊履歴からの
   * 導出値の合計。対象宿泊が2回未満なら導出値は 0。
   */
  stayCreditBalance: Scalars["Int"]["output"];
  /**
   * 指定した Co-Owners プラン・口数で利用される Co-Owners充当特典（旧S2Oポイント）の額。
   * 蓄積額と1口あたり利用上限の二重制約を適用した確定額。CoOwners 以外のプランは 0。
   * useWeekdayTrial / useStayCredit で、申込画面のチェック状態に応じた額を返す。
   * Stay 分は初回申込でのみ算入する。
   */
  usedAmount: Scalars["Int"]["output"];
  userId: Scalars["ID"]["output"];
  /**
   * Weekday/Trial で蓄積した充当特典の残高。台帳残高のうち Stay 由来を除いたもの。
   * 申込キャンセルの返却分は元の由来を区別できないためこちらに含む。
   */
  weekdayTrialBalance: Scalars["Int"]["output"];
};

/** Co-Owners充当特典（旧S2Oポイント） */
export type S2ousedAmountArgs = {
  ownerPlanId: Scalars["ID"]["input"];
  units: Scalars["Int"]["input"];
  useStayCredit?: Scalars["Boolean"]["input"];
  useWeekdayTrial?: Scalars["Boolean"]["input"];
};

export type S2oPoint = {
  __typename?: "S2oPoint";
  /** 金額 */
  amount: Scalars["Int"]["output"];
  /** 付与日 */
  date: Scalars["PlainDate"]["output"];
  /** メモ（管理者向け） */
  note: Scalars["String"]["output"];
  /** ステータス */
  status: S2oPointStatus;
  /** トランザクションタイプ（管理者向け） */
  transactionType: S2oPointTransactionType;
  /** 更新日時（管理者向け） */
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

export const S2oPointAdminTransactionType = {
  /** 月額サブスクリプション支払い */
  MonthlySubscriptionPayment: "MonthlySubscriptionPayment",
  /** Stay 宿泊費支払い、検証段階のため蓄積はadmin手動付与経由のみ */
  StayGuestPayment: "StayGuestPayment",
  /** トライアル月額サブスクリプション支払い */
  TrialMonthlySubscriptionPayment: "TrialMonthlySubscriptionPayment",
} as const;

export type S2oPointAdminTransactionType =
  (typeof S2oPointAdminTransactionType)[keyof typeof S2oPointAdminTransactionType];
/** Co-Owners充当特典 のステータス */
export const S2oPointStatus = {
  /** 有効（利用可能） */
  Active: "Active",
  /** 期限切れ */
  Expired: "Expired",
  /** 利用済み・無効化済み */
  Unavailable: "Unavailable",
} as const;

export type S2oPointStatus =
  (typeof S2oPointStatus)[keyof typeof S2oPointStatus];
/** Co-Owners充当特典（旧S2Oポイント）のトランザクションタイプ */
export const S2oPointTransactionType = {
  /** キャンセルによる無効化 */
  CancellationInvalidation: "CancellationInvalidation",
  /** Co-Owners申し込み返金 */
  CoOwnerApplicationRefund: "CoOwnerApplicationRefund",
  /** Co-Owners申し込み利用 */
  CoOwnerApplicationUsage: "CoOwnerApplicationUsage",
  /** 入会金支払い */
  EnrollmentPayment: "EnrollmentPayment",
  /** 管理者による無効化 */
  InvalidatedByAdmin: "InvalidatedByAdmin",
  /** 手動調整（データマイグレーション等） */
  ManualAdjustment: "ManualAdjustment",
  /** 月額サブスクリプション支払い */
  MonthlySubscriptionPayment: "MonthlySubscriptionPayment",
  /** Stay 宿泊費支払い、検証段階のため蓄積はadmin手動付与経由のみ */
  StayGuestPayment: "StayGuestPayment",
  /** トライアルキャンセルによる無効化 */
  TrialCancellationInvalidation: "TrialCancellationInvalidation",
  /** トライアル月額サブスクリプション支払い */
  TrialMonthlySubscriptionPayment: "TrialMonthlySubscriptionPayment",
} as const;

export type S2oPointTransactionType =
  (typeof S2oPointTransactionType)[keyof typeof S2oPointTransactionType];
export type S3UploadPolicy = {
  __typename?: "S3UploadPolicy";
  /** POSTリクエストに含めるべきフィールドと値のリスト */
  fields: Array<S3UploadPolicyField>;
  /**
   * アップロード後の画像の URL
   * `https://<bucket>.s3.<region>.amazonaws.com/<key>` の形式となる
   */
  rawUrl: Scalars["String"]["output"];
  /** POSTリクエストを送信するためのURL */
  uploadUrl: Scalars["String"]["output"];
};

export type S3UploadPolicyField = {
  __typename?: "S3UploadPolicyField";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/** 施設に紐づくエッジデバイス */
export type SanuEdgeDevice = {
  __typename?: "SanuEdgeDevice";
  /** 紐づいた宿泊施設 */
  accommodation: Accommodation;
  /** 外部デバイスID */
  deviceId: Scalars["String"]["output"];
  /** デバイスの種別 */
  deviceType: SanuEdgeDeviceType;
  /** デバイスID */
  id: Scalars["ID"]["output"];
};

/** エッジデバイスの種別 */
export const SanuEdgeDeviceType = {
  /** サウナコントロールユニット */
  SaunaControlUnit: "SaunaControlUnit",
} as const;

export type SanuEdgeDeviceType =
  (typeof SanuEdgeDeviceType)[keyof typeof SanuEdgeDeviceType];
export const SanuFileType = {
  /** CoOwnersの定期建物賃貸借契約書・38条書面 */
  CoOwnersBuildingLeaseAgreement: "CoOwnersBuildingLeaseAgreement",
  /** CoOwnersの見積書 */
  CoOwnersEstimate: "CoOwnersEstimate",
  /** CoOwnersのお引き渡し時の書類 */
  CoOwnersHandoverDocument: "CoOwnersHandoverDocument",
  /** CoOwnersの重要事項説明書 */
  CoOwnersImportantMattersDocument: "CoOwnersImportantMattersDocument",
  /** CoOwnersのAdmin用ファイル */
  CoOwnersOtherFiles: "CoOwnersOtherFiles",
  /** CoOwnersの借地権付売買契約書 */
  CoOwnersSalesContract: "CoOwnersSalesContract",
  /** CoOwnersの共有者間協定書 */
  CoOwnershipAgreement: "CoOwnershipAgreement",
  /** FullOwnerの利用契約 */
  FullOwnerContract: "FullOwnerContract",
} as const;

export type SanuFileType = (typeof SanuFileType)[keyof typeof SanuFileType];
export type SanuIncAccommodationReservationProvider = {
  __typename?: "SanuIncAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  staffGroup?: Maybe<StaffGroup>;
  usage: AccommodationReservationProviderSanuIncUsage;
};

export const SanuOwnerPlanUserFileType = {
  CoOwnersBuildingLeaseAgreement: "CoOwnersBuildingLeaseAgreement",
  CoOwnersHandoverDocuments: "CoOwnersHandoverDocuments",
  CoOwnersImportantMatters: "CoOwnersImportantMatters",
  CoOwnersSaleContract: "CoOwnersSaleContract",
  CoOwnershipAgreement: "CoOwnershipAgreement",
} as const;

export type SanuOwnerPlanUserFileType =
  (typeof SanuOwnerPlanUserFileType)[keyof typeof SanuOwnerPlanUserFileType];
export type SaunaAccommodationFacility = {
  __typename?: "SaunaAccommodationFacility";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** サウナ機器の固有情報 */
export type SaunaEquipmentAttribute = {
  __typename?: "SaunaEquipmentAttribute";
  /** 制御対象のエッジデバイス ID（MQTT トピックの識別子） */
  deviceId: Scalars["String"]["output"];
};

export type SaveStayReviewV2DraftPayload = StayReviewV2 | StayReviewV2Error;

export type ScheduleStandardSubscriptionPauseError = {
  __typename?: "ScheduleStandardSubscriptionPauseError";
  case: ScheduleStandardSubscriptionPauseErrorCase;
};

export const ScheduleStandardSubscriptionPauseErrorCase = {
  InvalidOperation: "InvalidOperation",
  InvalidPauseDate: "InvalidPauseDate",
  InvalidResumeDate: "InvalidResumeDate",
  NoSubscriptionError: "NoSubscriptionError",
  NotPausableDateYet: "NotPausableDateYet",
  ReservationExists: "ReservationExists",
  StripeError: "StripeError",
} as const;

export type ScheduleStandardSubscriptionPauseErrorCase =
  (typeof ScheduleStandardSubscriptionPauseErrorCase)[keyof typeof ScheduleStandardSubscriptionPauseErrorCase];
export type ScheduleStandardSubscriptionPausePayload =
  | ScheduleStandardSubscriptionPauseError
  | Success;

export type ScheduleStandardSubscriptionTerminationError = {
  __typename?: "ScheduleStandardSubscriptionTerminationError";
  case: ScheduleStandardSubscriptionTerminationErrorCase;
};

export const ScheduleStandardSubscriptionTerminationErrorCase = {
  InvalidOperation: "InvalidOperation",
  NoSubscriptionError: "NoSubscriptionError",
  NotPausableDateYet: "NotPausableDateYet",
  ReservationExists: "ReservationExists",
  StripeError: "StripeError",
} as const;

export type ScheduleStandardSubscriptionTerminationErrorCase =
  (typeof ScheduleStandardSubscriptionTerminationErrorCase)[keyof typeof ScheduleStandardSubscriptionTerminationErrorCase];
export type ScheduleStandardSubscriptionTerminationPayload =
  | ScheduleStandardSubscriptionTerminationError
  | Success;

/** Grant を絞る軸。軸を足す = ここに値を足す + AdminRoleAssignment に列を足す + scopeKeyTypes.ts / scopeKeys.ts に表を足す。 */
export const ScopeDimension = {
  Site: "Site",
} as const;

export type ScopeDimension =
  (typeof ScopeDimension)[keyof typeof ScopeDimension];
export const ScriptExecutionStatus = {
  Failed: "Failed",
  Running: "Running",
  Success: "Success",
} as const;

export type ScriptExecutionStatus =
  (typeof ScriptExecutionStatus)[keyof typeof ScriptExecutionStatus];
export const ScriptLogLevel = {
  Error: "Error",
  Info: "Info",
  Warn: "Warn",
} as const;

export type ScriptLogLevel =
  (typeof ScriptLogLevel)[keyof typeof ScriptLogLevel];
/** シーズン料金設定 */
export type SeasonalFeeSetting = {
  __typename?: "SeasonalFeeSetting";
  additionalFee: Scalars["Int"]["output"];
  night: Scalars["PlainDate"]["output"];
};

export type SelectWebinarScheduleError = {
  __typename?: "SelectWebinarScheduleError";
  case: SelectWebinarScheduleErrorCase;
};

export const SelectWebinarScheduleErrorCase = {
  AlreadyCompleted: "AlreadyCompleted",
  AlreadySelected: "AlreadySelected",
  ApplicationNotFound: "ApplicationNotFound",
  InvalidWebinarSchedule: "InvalidWebinarSchedule",
  PermissionDenied: "PermissionDenied",
} as const;

export type SelectWebinarScheduleErrorCase =
  (typeof SelectWebinarScheduleErrorCase)[keyof typeof SelectWebinarScheduleErrorCase];
export type SelectWebinarSchedulePayload =
  | CoOwnersApplication
  | SelectWebinarScheduleError;

export type SendEmailToVerifyEmailInput = {
  /** 認証に成功した場合に遷移させるページ（パス以下を指定） */
  redirectAfterVerifiedPath?: InputMaybe<Scalars["String"]["input"]>;
};

export type SendEmailToVerifyNewEmailError = {
  __typename?: "SendEmailToVerifyNewEmailError";
  case: SendEmailToVerifyNewEmailErrorCase;
};

export const SendEmailToVerifyNewEmailErrorCase = {
  /** メールアドレスが他のユーザに既に使われている */
  EmailAlreadyUsed: "EmailAlreadyUsed",
  GeneralError: "GeneralError",
  /** 入力されたメールアドレスのフォーマットが不正 */
  InvalidEmailFormat: "InvalidEmailFormat",
  /** ソーシャルログインが主IDで、メール/パスワードが未登録のため変更不可 */
  NoEmailPasswordIdentity: "NoEmailPasswordIdentity",
  /** 同じメールアドレスが設定・確認済み */
  SameEmail: "SameEmail",
} as const;

export type SendEmailToVerifyNewEmailErrorCase =
  (typeof SendEmailToVerifyNewEmailErrorCase)[keyof typeof SendEmailToVerifyNewEmailErrorCase];
export type SendEmailToVerifyNewEmailInput = {
  newEmail: Scalars["String"]["input"];
};

export type SendEmailToVerifyNewEmailPayload =
  | SendEmailToVerifyNewEmailError
  | SendEmailToVerifyNewEmailSuccess;

export type SendEmailToVerifyNewEmailSuccess = {
  __typename?: "SendEmailToVerifyNewEmailSuccess";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SendPasswordResetEmailError = {
  __typename?: "SendPasswordResetEmailError";
  case?: Maybe<SendPasswordResetEmailErrorCase>;
};

export const SendPasswordResetEmailErrorCase = {
  GeneralError: "GeneralError",
} as const;

export type SendPasswordResetEmailErrorCase =
  (typeof SendPasswordResetEmailErrorCase)[keyof typeof SendPasswordResetEmailErrorCase];
export type SendPasswordResetEmailPayload =
  | SendPasswordResetEmailError
  | SendPasswordResetEmailSuccess;

export type SendPasswordResetEmailSuccess = {
  __typename?: "SendPasswordResetEmailSuccess";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** トップページ表示のサービスアップデート */
export type ServiceUpdate = {
  __typename?: "ServiceUpdate";
  /** 新しいかどうか */
  isNew: Scalars["Boolean"]["output"];
  /** 日付 */
  publishedAt: Scalars["ZonedDateTime"]["output"];
  /** タイトル */
  title: Scalars["String"]["output"];
  /** 遷移先URL */
  url: Scalars["String"]["output"];
};

/**
 * 拠点
 * 1-10程度の複数の宿泊施設が集まっている場所
 */
export type Site = {
  __typename?: "Site";
  /** 拠点に含まれる宿泊施設の一覧 */
  accommodations: Array<Accommodation>;
  /** 拠点に含まれる、予約ができる宿泊施設の一覧 */
  accommodationsForReservation: Array<Accommodation>;
  /** 拠点があるエリア */
  area: Area;
  /**
   * 拠点全体の日次空き状況・最低価格。roomTypesForReservation と同じフィルタ条件で対象roomTypeを絞り込み、
   * 日ごとに複数roomType横断で集約した値を返す。
   */
  availability: Array<SiteAvailabilityNight>;
  /**
   * Beds24プロパティID（未連携の場合はnull）
   * @deprecated Retool 互換のため温存。admin は InternalSite を使うこと
   */
  beds24PropertyId?: Maybe<Scalars["Int"]["output"]>;
  /** チェックイン認証方式 */
  checkInAuthenticationType: CheckInAuthenticationType;
  /** CoOwners申し込み者向け重説参加スケジュール */
  coOwnersWebinarSchedules: Array<CoOwnersWebinarSchedule>;
  /** 拠点のコンテンツ */
  content: SiteContent;
  /** カスタム予約リード月数（未設定の場合はデフォルトの3ヶ月を使用） */
  customReservationLeadMonths?: Maybe<Scalars["Int"]["output"]>;
  /** アーリーチェックイン機能が有効かどうか */
  earlyCheckInEnabled: Scalars["Boolean"]["output"];
  /**
   * この拠点に紐づく有効な設備一覧
   * providerが渡された場合、そのプロバイダーが予約可能な設備のみが表示
   */
  facilities: Array<Facility>;
  id: Scalars["ID"]["output"];
  /**
   * 遠方拠点かどうか
   * Areaにあっても良さそうだが、今後の展開が読めないのでSiteに生やしている。
   * Siteに生やした強い理由はないので、必要ならAreaに移動したりしてOK。
   */
  isRemote: Scalars["Boolean"]["output"];
  /**
   * 拠点の名前
   * 例：一宮1st、Amatsumi 安曇野
   */
  name: Scalars["String"]["output"];
  /** 拠点の開業日 */
  openingDate: Scalars["PlainDate"]["output"];
  /**
   * 拠点の番号
   * 「一宮1st」などの場合「1st」を指し、Amatsumi 安曇野のように番号がない場合は何も入らない。
   */
  ordinalName?: Maybe<Scalars["String"]["output"]>;
  /** 予約可能か？ */
  reservable: Scalars["Boolean"]["output"];
  /** 予約可能か？（オーナー向け） */
  reservableForOwnerEarlyAccess: Scalars["Boolean"]["output"];
  /**
   * ルームタイプ特徴マスター一覧（sort 昇順、全 site 共通）
   * @deprecated Retool 互換のため温存。admin は InternalSite を使うこと
   */
  roomTypeFeatures: Array<InternalRoomTypeFeature>;
  /**
   * ルームタイプ一覧
   * @deprecated Retool 互換のため温存。admin は InternalSite を使うこと
   */
  roomTypes: Array<InternalRoomType>;
  /**
   * 拠点に含まれる、予約ができるルームタイプの一覧。
   * internal の Site.roomTypes（管理用一覧）とは別物で、予約スコープ（reservableAssets）でフィルタされる。
   * 部屋(unit)が 1 件も紐づかない＝予約できないルームタイプは含まれない。
   * 並び順は「設備が少ない順」（RoomTypeFeature.sort 昇順を加味、DXPJ-86）。
   */
  roomTypesForReservation: Array<RoomType>;
  /**
   * 短い住所表示（例: "静岡県"）。
   * ContentSite.addressInJapan.line1 から派生して返す。
   */
  shortAddress?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
};

/**
 * 拠点
 * 1-10程度の複数の宿泊施設が集まっている場所
 */
export type SiteaccommodationsForReservationArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

/**
 * 拠点
 * 1-10程度の複数の宿泊施設が集まっている場所
 */
export type SiteavailabilityArgs = {
  architectureTypes: Array<Scalars["String"]["input"]>;
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  facilitySlugs: Array<Scalars["String"]["input"]>;
  firstNight: Scalars["PlainDate"]["input"];
  largeOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastNight: Scalars["PlainDate"]["input"];
  provider: AccommodationReservationProviderInput;
};

/**
 * 拠点
 * 1-10程度の複数の宿泊施設が集まっている場所
 */
export type SitefacilitiesArgs = {
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

/**
 * 拠点
 * 1-10程度の複数の宿泊施設が集まっている場所
 */
export type SiteroomTypesForReservationArgs = {
  architectureTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  evChargerAvailable?: InputMaybe<Scalars["Boolean"]["input"]>;
  facilitySlugs?: InputMaybe<Array<Scalars["String"]["input"]>>;
  largeOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

/**
 * 拠点ページ「アクセス」セクションの 1 つの移動手段グループ
 * 例: 「公共交通機関でお越しの方」「お車でお越しの方」
 */
export type SiteAccessRouteGroup = {
  __typename?: "SiteAccessRouteGroup";
  id: Scalars["ID"]["output"];
  /** この移動手段グループに含まれる地点（始点→経由→終点の順） */
  points: Array<SiteAccessRoutePoint>;
  /** 並び順 */
  sort: Scalars["Int"]["output"];
  /** グループ見出し（例: "公共交通機関でお越しの方"） */
  title: Scalars["String"]["output"];
  /** グループ見出し脇のアイコン */
  transportIcon: AccessRouteTransportIcon;
};

/**
 * アクセスルート上の地点。始点・経由・終点を同一モデルで扱う。
 * sort の昇順に並び、最後の地点（終点）の legToNextDescription は
 * 「終点 → 拠点」の区間を表す。
 */
export type SiteAccessRoutePoint = {
  __typename?: "SiteAccessRoutePoint";
  id: Scalars["ID"]["output"];
  /**
   * この地点から次の地点までの区間説明（例: "東海道新幹線 約45分"）
   * 最後の地点では「終点 → 拠点」の区間説明として使う
   */
  legToNextDescription?: Maybe<Scalars["String"]["output"]>;
  /** 地点名（例: "JR東京駅", "東京駅周辺", "門川交差点"） */
  name: Scalars["String"]["output"];
  /** 並び順 */
  sort: Scalars["Int"]["output"];
};

/**
 * Nature Club のアクティビティプログラム。拠点・エリア・部屋タイプページや予約一覧のカードに出し、
 * 予約は外部ページで行う。
 */
export type SiteActivityProgram = {
  __typename?: "SiteActivityProgram";
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** 説明文（viewer locale に解決済み）。未設定なら null */
  description?: Maybe<Scalars["String"]["output"]>;
  /** 外部の詳細・予約ページ URL */
  externalUrl: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image: UploadedFile;
  /** 説明文（全 locale）。カードでは 3 行に省略して表示する */
  localizedDescription: InternalLocalizedString;
  /** プログラム名（全 locale） */
  localizedTitle: InternalLocalizedString;
  /** 掲載終了日時（この時刻になったら外す）。null なら無期限 */
  publishEndAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 掲載開始日時。null なら登録した時点から掲載する */
  publishStartAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 掲載する拠点（admin の一覧・編集フォーム用。エリア・拠点の並び順） */
  sites: Array<InternalSite>;
  /** プログラム名（viewer locale に解決済み） */
  title: Scalars["String"]["output"];
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** 拠点の日次の空き状況・最低価格（Site.availability が複数roomType横断で集約した値） */
export type SiteAvailabilityNight = {
  __typename?: "SiteAvailabilityNight";
  /** 複数roomType横断で空きがある中の最安値。全roomTypeが満室の夜はnull。 */
  fromPrice?: Maybe<Scalars["Int"]["output"]>;
  /** その日に、いずれかのroomTypeで1室でも空きがあるか */
  isAvailable: Scalars["Boolean"]["output"];
  /** 対象の宿泊日（1泊） */
  night: Scalars["PlainDate"]["output"];
};

/** 拠点コンテンツ */
export type SiteContent = {
  __typename?: "SiteContent";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * 拠点へのアクセスルート（拠点ページ「アクセス」セクション）
   * 移動手段（公共交通機関 / お車 等）ごとにグループ化される
   */
  accessRouteGroups: Array<SiteAccessRouteGroup>;
  /** この拠点で現在掲載中の Nature Club アクティビティ（掲載期間内のもの、登録の古い順） */
  activityPrograms: Array<SiteActivityProgram>;
  /** 住所の多言語編集用の値（公開 prefecture/city/addressLine は解決済みの String） */
  addressForEdit?: Maybe<InternalSiteAddress>;
  /** 住所: 町名・番地以降（建物名・部屋番号を含む）。 viewer locale に解決済み（例: "富戸1234-5"）。 */
  addressLine?: Maybe<Scalars["String"]["output"]>;
  /** 住所: 市区町村。 viewer locale に解決済み（例: "伊東市"）。 */
  city?: Maybe<Scalars["String"]["output"]>;
  /** 拠点紹介文 */
  description?: Maybe<Scalars["String"]["output"]>;
  /** 拠点のfaq */
  faqs: Array<SiteFaq>;
  /** 拠点の Google Maps レビュー URL */
  googleMapsReviewUrl?: Maybe<Scalars["String"]["output"]>;
  /** 拠点の Google Maps URL */
  googleMapsUrl?: Maybe<Scalars["String"]["output"]>;
  /** ヒーロー画像 */
  heroImages: Array<UploadedFile>;
  /** 路面凍結情報URL */
  iceRoadInfoUrl?: Maybe<Scalars["String"]["output"]>;
  /** ID */
  id: Scalars["ID"]["output"];
  /**
   * 拠点の画像
   * 当初は Native App で利用
   */
  images: Array<UploadedFile>;
  /** 緯度 */
  latitude?: Maybe<Scalars["Float"]["output"]>;
  /** 経度 */
  longitude?: Maybe<Scalars["Float"]["output"]>;
  /** 拠点マップ画像 */
  mapImageUrl?: Maybe<Scalars["String"]["output"]>;
  /** 駐車場の台数表記（例: "各部屋1台"） */
  parkingCapacity?: Maybe<Scalars["String"]["output"]>;
  /** 駐車場の注釈（例: "2003・2019ご利用の方は、EV充電器の利用有無にかかわらず指定スペースへの駐車をお願い致します"） */
  parkingInfo?: Maybe<Scalars["String"]["output"]>;
  /** 住所: 郵便番号（言語非依存。例: "413-0001"） */
  postalCode?: Maybe<Scalars["String"]["output"]>;
  /** 住所: 都道府県。 viewer locale に解決済み（例: "静岡県"）。 編集用の多言語値は internal の prefectureTranslation。 */
  prefecture?: Maybe<Scalars["String"]["output"]>;
  /** 最終更新日時（編集履歴の表示用） */
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** 拠点のFAQ */
export type SiteFaq = {
  __typename?: "SiteFaq";
  /** 回答 (HTML) */
  answer: Scalars["String"]["output"];
  /** 案内画像URL（チェックイン当日メール・拠点ページ・nativeappチェックインシートに表示） */
  guidanceImageUrl?: Maybe<Scalars["String"]["output"]>;
  /** 質問 */
  question: Scalars["String"]["output"];
};

/** 拠点ハイシーズン期間（管理者向け） */
export type SiteHighSeasonPeriod = {
  __typename?: "SiteHighSeasonPeriod";
  /** 2027 年度以降の拠点追加料金 */
  additionalFeeAmount: Scalars["Int"]["output"];
  /** 終了日（1-31） */
  endDay: Scalars["Int"]["output"];
  /** 終了月（1-12） */
  endMonth: Scalars["Int"]["output"];
  /** ID */
  id: Scalars["ID"]["output"];
  /** ラベル（例: "夏シーズン"） */
  label: Scalars["String"]["output"];
  /** 拠点ID */
  siteId: Scalars["ID"]["output"];
  /** 開始日（1-31） */
  startDay: Scalars["Int"]["output"];
  /** 開始月（1-12） */
  startMonth: Scalars["Int"]["output"];
};

/** ソート方向 */
export const SortDirection = {
  /** 昇順 */
  Asc: "Asc",
  /** 降順 */
  Desc: "Desc",
} as const;

export type SortDirection = (typeof SortDirection)[keyof typeof SortDirection];
/** スタッフ用アクセスキー適用のトリガー種別。 */
export const StaffAccessKeyTrigger = {
  CancelReserve: "CancelReserve",
  ChangeReserve: "ChangeReserve",
  CheckOutReserve: "CheckOutReserve",
  CreateReserve: "CreateReserve",
  CronJob: "CronJob",
} as const;

export type StaffAccessKeyTrigger =
  (typeof StaffAccessKeyTrigger)[keyof typeof StaffAccessKeyTrigger];
/**
 * for Staff 契約
 * 従業員向け福利厚生プラン
 */
export type StaffContract = {
  __typename?: "StaffContract";
  /**
   * 今期の付与泊数
   * 当期（前半または後半）で付与された泊数
   */
  currentSemesterGrantedStayCredits: Scalars["Int"]["output"];
  /**
   * 今期の残り泊数
   * 当期（前半または後半）の残り宿泊数
   */
  currentSemesterStayCredits: Scalars["Int"]["output"];
  /** 利用開始日（契約開始日） */
  enrolledAt: Scalars["ZonedDateTime"]["output"];
  /** 利用開始日（PlainDate形式） */
  enrolledDate: Scalars["PlainDate"]["output"];
  id: Scalars["ID"]["output"];
  /**
   * 予約可能かどうか
   * status=Usable かつ terminatedDate が未来または null
   */
  isReservable: Scalars["Boolean"]["output"];
  /** 残りのピーク日数（今期） */
  remainingPeakDays: Scalars["Int"]["output"];
  /**
   * Semester別の宿泊数情報（現在と次のsemester）
   * 現在のsemesterと次のsemesterの宿泊数を配列で返す
   */
  semesterCredits: Array<StaffSemesterCredit>;
  /** 雇用形態 */
  staffType: StaffType;
  /**
   * 基本的なステータス
   * 予約できるかどうかなど
   */
  status: StaffContractStatus;
  /** 詳細なステータス */
  statusDetail: StaffContractStatusDetail;
  /** 利用停止日 */
  terminatedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 利用停止日（PlainDate形式） */
  terminatedDate?: Maybe<Scalars["PlainDate"]["output"]>;
};

/** for Staff 契約ステータス */
export const StaffContractStatus = {
  /** 契約なし */
  Neutral: "Neutral",
  /** 利用可能 */
  Usable: "Usable",
} as const;

export type StaffContractStatus =
  (typeof StaffContractStatus)[keyof typeof StaffContractStatus];
/** for Staff 契約詳細ステータス */
export const StaffContractStatusDetail = {
  /** デフォルト（契約なし） */
  NeutralDefault: "NeutralDefault",
  /** 契約終了済み */
  NeutralTerminated: "NeutralTerminated",
  /** 利用中（通常） */
  UsableDefault: "UsableDefault",
} as const;

export type StaffContractStatusDetail =
  (typeof StaffContractStatusDetail)[keyof typeof StaffContractStatusDetail];
/**
 * 社内スタッフグループ
 * 財務・アセットマネジメント向けに活用しており、現状全てのグループは格納されていない。
 * scriptディレクトリに同期用のスクリプトがあるので活用すること。
 *
 * SmartHRのデータと紐づけて、チームごとに各種リソースを財務的に管理する。
 */
export type StaffGroup = {
  __typename?: "StaffGroup";
  /** アーカイブ日時（この日時以降は新規ブロック作成時の選択肢から除外） */
  archivedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  createdAt: Scalars["ZonedDateTime"]["output"];
  /**
   * 親組織の名を含んだ名前
   * 例: 2nd Home事業本部/Co-Owners事業部/インサイドセールスグループ
   */
  fullName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 名前 */
  name: Scalars["String"]["output"];
  /** SmartHRとの紐付け用ID */
  smarthrId: Scalars["String"]["output"];
  /** 現在のステータス（archivedAtから計算） */
  status: StaffGroupStatus;
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** グループの有効/無効ステータス */
export const StaffGroupStatus = {
  /** 有効（選択肢として使用可能） */
  Active: "Active",
  /** 無効（選択肢から除外） */
  Inactive: "Inactive",
} as const;

export type StaffGroupStatus =
  (typeof StaffGroupStatus)[keyof typeof StaffGroupStatus];
export type StaffPlanAccommodationReservationProvider = {
  __typename?: "StaffPlanAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  staffContractId: Scalars["ID"]["output"];
};

/** for Staff ターム（前半/後半） */
export const StaffSemester = {
  /** 前半（1/1-6/30） */
  First: "First",
  /** 後半（7/1-12/31） */
  Second: "Second",
} as const;

export type StaffSemester = (typeof StaffSemester)[keyof typeof StaffSemester];
/** Semester別のスタッフ宿泊数情報 */
export type StaffSemesterCredit = {
  __typename?: "StaffSemesterCredit";
  /** 付与された宿泊数 */
  grantedStayCredits: Scalars["Int"]["output"];
  /** 残りのピーク日数 */
  remainingPeakDays: Scalars["Int"]["output"];
  /** 残り宿泊数 */
  remainingStayCredits: Scalars["Int"]["output"];
  /** Semester（前半/後半） */
  semester: StaffSemester;
  /** 年 */
  year: Scalars["Int"]["output"];
};

export const StaffStayCreditTransactionStatus = {
  Finalized: "Finalized",
  Open: "Open",
  Void: "Void",
} as const;

export type StaffStayCreditTransactionStatus =
  (typeof StaffStayCreditTransactionStatus)[keyof typeof StaffStayCreditTransactionStatus];
export const StaffStayCreditTransactionType = {
  GrantByBatch: "GrantByBatch",
  GrantByManual: "GrantByManual",
  RedeemByCancel: "RedeemByCancel",
  RedeemByNoShow: "RedeemByNoShow",
  RedeemByReserve: "RedeemByReserve",
} as const;

export type StaffStayCreditTransactionType =
  (typeof StaffStayCreditTransactionType)[keyof typeof StaffStayCreditTransactionType];
/** 従業員区分 */
export const StaffType = {
  /** 契約社員（2泊/ターム、繁忙期1日） */
  Contractor: "Contractor",
  /** 正社員（4泊/ターム、繁忙期2日） */
  Permanent: "Permanent",
} as const;

export type StaffType = (typeof StaffType)[keyof typeof StaffType];
export type StandardPlanAccommodationReservationProvider = {
  __typename?: "StandardPlanAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  userSubscriptionId?: Maybe<Scalars["ID"]["output"]>;
};

/** StayCreditEstimate の内訳1件（対象宿泊1予約分） */
export type StayCreditBreakdownItem = {
  __typename?: "StayCreditBreakdownItem";
  /** この宿泊の蓄積額（税抜 net / OTA 換算） */
  amount: Scalars["Int"]["output"];
  reservationId: Scalars["ID"]["output"];
};

/**
 * Co-Owners充当特典（Stay）の割引予測額。宿泊履歴から算出した読み取り専用の値。
 * 商談時にセールスが参照する「予測」であり、最終的な充当額は上限適用・CSの請求書確認を経て確定する。
 * S2oPoint 台帳には書き込まない（都度計算）。
 */
export type StayCreditEstimate = {
  __typename?: "StayCreditEstimate";
  /** 有効化条件（自社・OTA の対象宿泊が2回以上）を満たすか。未満は保留（申込時の適用対象外）。 */
  activatable: Scalars["Boolean"]["output"];
  /** 対象宿泊ごとの内訳。予約ごとの充当対象額の表示に使う。 */
  breakdown: Array<StayCreditBreakdownItem>;
  /** 蓄積対象として数えた宿泊回数 */
  qualifyingStayCount: Scalars["Int"]["output"];
  /** 有効化まであと何回の対象宿泊が必要か。有効化済みなら 0。 */
  remainingStayCount: Scalars["Int"]["output"];
  /** 対象宿泊の蓄積額合計（税抜・上限適用前）。有効化前でも算出される。 */
  total: Scalars["Int"]["output"];
};

export type StayDirectAccommodationReservationProvider = {
  __typename?: "StayDirectAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** エクスポート用のStay Giftチケット情報 */
export type StayGiftExportItem = {
  __typename?: "StayGiftExportItem";
  /** チケットコード */
  code: Scalars["String"]["output"];
  /** 招待URL */
  invitationUrl: Scalars["String"]["output"];
  /** 発行日 */
  issuedAt: Scalars["PlainDate"]["output"];
  /** チケットステータス */
  status: StayTicketStatusType;
  /** 利用可能期間（開始日） */
  validFrom: Scalars["PlainDate"]["output"];
  /** 利用可能期間（終了日） */
  validTo: Scalars["PlainDate"]["output"];
};

/** 滞在レビュー */
export type StayReview = {
  __typename?: "StayReview";
  /** レビューコメント */
  comment?: Maybe<Scalars["String"]["output"]>;
  /** 案内に関するコメント */
  commentForSigns?: Maybe<Scalars["String"]["output"]>;
  /** 今後利用してみたい食体験（複数選択可） */
  desiredFoodExperiences?: Maybe<Array<StayReviewFoodExperienceType>>;
  /** 今回の滞在中に行った体験（複数選択可） */
  experiencesDuringStay?: Maybe<Array<StayReviewExperienceType>>;
  /** 食体験の感想 */
  foodExperienceImpression?: Maybe<Scalars["String"]["output"]>;
  /**
   * 改善コメント
   * 改善ポイントで「その他」を選択した場合の自由記述コメント
   */
  improvementPointFree?: Maybe<Scalars["String"]["output"]>;
  /**
   * 改善ポイント
   * rating が4以下の場合に入力を促す
   */
  improvementPoints?: Maybe<Array<Scalars["String"]["output"]>>;
  /** 今回の滞在の感想や今後期待すること */
  overallImpressionForExperience?: Maybe<Scalars["String"]["output"]>;
  /**
   * 滞在の満足度
   * 1-5の5段階評価
   */
  rating: Scalars["Int"]["output"];
  /** ポスターを見たか（複数選択可） */
  sawPoster?: Maybe<Array<StayReviewPosterViewType>>;
  /** 夜間の足元の明るさや道案内 */
  signAndBrightnessInSite?: Maybe<StayReviewSignResponseType>;
  /** 駐車場から部屋までの案内 */
  signForApproach?: Maybe<StayReviewSignResponseType>;
  /** 駐車場の案内 */
  signForParking?: Maybe<StayReviewSignResponseType>;
  /** 拠点までの道案内 */
  signForWayToSite?: Maybe<StayReviewSignResponseType>;
  /** 利用した食体験（複数選択可） */
  usedFoodExperiences?: Maybe<Array<StayReviewFoodExperienceType>>;
};

/** 滞在レビュー 2.0 の評価軸 */
export const StayReviewAxis = {
  ArchitectureAndNature: "ArchitectureAndNature",
  Cleaning: "Cleaning",
  Equipment: "Equipment",
  GuidanceAndSupport: "GuidanceAndSupport",
} as const;

export type StayReviewAxis =
  (typeof StayReviewAxis)[keyof typeof StayReviewAxis];
export type StayReviewAxisDefinition = {
  __typename?: "StayReviewAxisDefinition";
  axis: StayReviewAxis;
  /** この軸で聞く「気になったもの」の種別（表示順） */
  concernKinds: Array<StayReviewConcernKindDefinition>;
  /** 見出しの下に添える、この軸で評価する対象の補足（例: 建物・内装・虫・騒音・アクセス） */
  description: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

/** 気になったものの選択肢。どの種別に属するかは stayReviewV2Form が返す */
export const StayReviewConcernDetail = {
  CheckInProcedureUnclear: "CheckInProcedureUnclear",
  CheckOutGuideNotFound: "CheckOutGuideNotFound",
  CheckOutTooManyTasks: "CheckOutTooManyTasks",
  DarkAtNight: "DarkAtNight",
  FarFromShops: "FarFromShops",
  FarFromStationOrAirport: "FarFromStationOrAirport",
  FewRestaurants: "FewRestaurants",
  KeyDidNotOpen: "KeyDidNotOpen",
  NarrowRoad: "NarrowRoad",
  NoiseFromEquipment: "NoiseFromEquipment",
  NoiseFromNeighborRoom: "NoiseFromNeighborRoom",
  NoiseFromOutside: "NoiseFromOutside",
  ParkingFarOrRoughRoad: "ParkingFarOrRoughRoad",
  ParkingLocationUnclear: "ParkingLocationUnclear",
  PoorSignalForKey: "PoorSignalForKey",
  RouteOrNavigationFailed: "RouteOrNavigationFailed",
  SignageOrEntranceUnclear: "SignageOrEntranceUnclear",
  SupportOperatorQuality: "SupportOperatorQuality",
  SupportSlowResponse: "SupportSlowResponse",
  SupportUnreachable: "SupportUnreachable",
} as const;

export type StayReviewConcernDetail =
  (typeof StayReviewConcernDetail)[keyof typeof StayReviewConcernDetail];
export type StayReviewConcernDetailOption = {
  __typename?: "StayReviewConcernDetailOption";
  label: Scalars["String"]["output"];
  value: StayReviewConcernDetail;
};

/** 気になったものの種別。どの軸に属するか・選択式か自由記述かは stayReviewV2Form が返す */
export const StayReviewConcernKind = {
  ArchitectureAndNatureOther: "ArchitectureAndNatureOther",
  ArrivalGuidanceOrParking: "ArrivalGuidanceOrParking",
  Breakage: "Breakage",
  BuildingDefect: "BuildingDefect",
  CheckOut: "CheckOut",
  CleaningOther: "CleaningOther",
  Dirt: "Dirt",
  EquipmentOther: "EquipmentOther",
  GuidanceAndSupportOther: "GuidanceAndSupportOther",
  Insects: "Insects",
  KeyOrCheckIn: "KeyOrCheckIn",
  LocationAccess: "LocationAccess",
  Noise: "Noise",
  Odor: "Odor",
  Shortage: "Shortage",
  Support: "Support",
  TrashOrHair: "TrashOrHair",
  UsageUnclear: "UsageUnclear",
} as const;

export type StayReviewConcernKind =
  (typeof StayReviewConcernKind)[keyof typeof StayReviewConcernKind];
export type StayReviewConcernKindDefinition = {
  __typename?: "StayReviewConcernKindDefinition";
  /** 自由記述で聞く種別のプレースホルダ。選択式の種別では null */
  commentPlaceholder?: Maybe<Scalars["String"]["output"]>;
  /** 選択式の種別の選択肢。自由記述の種別では空 */
  details: Array<StayReviewConcernDetailOption>;
  kind: StayReviewConcernKind;
  label: Scalars["String"]["output"];
};

export const StayReviewExperienceType = {
  /** 自然を感じながらコーヒーを飲む */
  DrinkingCoffee: "DrinkingCoffee",
  /** 夜ご飯を作って食卓を囲む（ピザの温めなど簡単な調理も含む） */
  MakingDinner: "MakingDinner",
  /** 該当しない */
  NotApplicable: "NotApplicable",
  /** 花を摘んでいける */
  PickingFlowers: "PickingFlowers",
} as const;

export type StayReviewExperienceType =
  (typeof StayReviewExperienceType)[keyof typeof StayReviewExperienceType];
export const StayReviewFoodExperienceType = {
  /** 冷凍パン */
  FrozenBread: "FrozenBread",
  /** 冷凍ピザ */
  FrozenPizza: "FrozenPizza",
  /** ハーブガーデン */
  HerbGarden: "HerbGarden",
  /** 利用していない */
  NotUsedOrNotApplicable: "NotUsedOrNotApplicable",
  /** スープ */
  Soup: "Soup",
  /** ワイン */
  Wine: "Wine",
} as const;

export type StayReviewFoodExperienceType =
  (typeof StayReviewFoodExperienceType)[keyof typeof StayReviewFoodExperienceType];
/** 自由記入設問 */
export type StayReviewFreeTextQuestion = {
  __typename?: "StayReviewFreeTextQuestion";
  key: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export const StayReviewMemorableExperience = {
  /** 空間の心地よさ */
  ComfortableSpace: "ComfortableSpace",
  /** 没頭する時間（仕事や読書など） */
  FocusedOnOwnTime: "FocusedOnOwnTime",
  /** 自然の音や景色 */
  NatureSoundsAndScenery: "NatureSoundsAndScenery",
  /** 外での体験（散歩や焚き火、サウナなど） */
  OutdoorActivities: "OutdoorActivities",
  /** 季節や生きものの気配。選択肢からは外したが、保存済みの回答を読めるよう残す */
  SeasonsAndCreatures: "SeasonsAndCreatures",
  /** 家族や友人とのひととき */
  TimeWithFamilyAndFriends: "TimeWithFamilyAndFriends",
} as const;

export type StayReviewMemorableExperience =
  (typeof StayReviewMemorableExperience)[keyof typeof StayReviewMemorableExperience];
export type StayReviewMemorableExperienceOption = {
  __typename?: "StayReviewMemorableExperienceOption";
  /** ラベルの横に添える例示（例: 仕事や読書など）。例示のない選択肢は null */
  description?: Maybe<Scalars["String"]["output"]>;
  label: Scalars["String"]["output"];
  value: StayReviewMemorableExperience;
};

export const StayReviewPosterViewType = {
  /** 見ていない／気づかなかった */
  NotSeenOrNoticed: "NotSeenOrNoticed",
  /** 見て「いいな」と思った */
  SeenAndLiked: "SeenAndLiked",
  /** 見て「体験してみたい」と思った */
  SeenAndWantToTry: "SeenAndWantToTry",
  /** 見たが特に印象はなかった */
  SeenButNoImpression: "SeenButNoImpression",
  /** ポスターを持ち帰った */
  TookPosterHome: "TookPosterHome",
  /** 書いてある体験をひとつ以上やった */
  TriedExperience: "TriedExperience",
} as const;

export type StayReviewPosterViewType =
  (typeof StayReviewPosterViewType)[keyof typeof StayReviewPosterViewType];
/** 新滞在レビュー設問テンプレート */
export type StayReviewQuestionnaire = {
  __typename?: "StayReviewQuestionnaire";
  /** チェックアウト後の自由記入設問 */
  freeTextAfterCheckOut: StayReviewFreeTextQuestion;
  /** チェックアウト時の自由記入設問 */
  freeTextAtCheckOut: StayReviewFreeTextQuestion;
  id: Scalars["ID"]["output"];
  /** チェックアウト後の選択式設問 */
  selectionAfterCheckOut: StayReviewSelectionQuestion;
  /** チェックアウト時の選択式設問 */
  selectionAtCheckOut: StayReviewSelectionQuestion;
};

/** 新滞在レビューの回答 */
export type StayReviewResponse = {
  __typename?: "StayReviewResponse";
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** チェックアウト後の自由記入設問の回答 */
  freeTextAfterCheckOutAnswer: Scalars["String"]["output"];
  /** チェックアウト時の自由記入設問の回答 */
  freeTextAtCheckOutAnswer: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** 回答した設問 */
  questionnaire: StayReviewQuestionnaire;
  /**
   * 滞在の満足度
   * 1-5の5段階評価
   */
  rating: Scalars["Int"]["output"];
  /** チェックアウト後の選択式設問の回答 */
  selectionAfterCheckOutAnswer: Array<StayReviewSelectionOption>;
  /** チェックアウト時の選択式設問の回答 */
  selectionAtCheckOutAnswer: Array<StayReviewSelectionOption>;
  updatedAt: Scalars["ZonedDateTime"]["output"];
};

/** 回答と予約情報を含む滞在レビュー回答（管理者向け） */
export type StayReviewResponseWithReservation = {
  __typename?: "StayReviewResponseWithReservation";
  accommodationReservation: AccommodationReservation;
  createdAt: Scalars["ZonedDateTime"]["output"];
  freeTextAfterCheckOutAnswer: Scalars["String"]["output"];
  freeTextAtCheckOutAnswer: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  questionnaire: StayReviewQuestionnaire;
  rating: Scalars["Int"]["output"];
  selectionAfterCheckOutAnswer: Array<StayReviewSelectionOption>;
  selectionAtCheckOutAnswer: Array<StayReviewSelectionOption>;
};

/** 新滞在レビュー設問の選択肢 */
export type StayReviewSelectionOption = {
  __typename?: "StayReviewSelectionOption";
  /** バージョン間で不変の安定キー（集計に使用） */
  key: Scalars["String"]["output"];
  /** 表示ラベル（変更可能） */
  label: Scalars["String"]["output"];
};

/** 選択式設問 */
export type StayReviewSelectionQuestion = {
  __typename?: "StayReviewSelectionQuestion";
  key: Scalars["String"]["output"];
  options: Array<StayReviewSelectionOption>;
  title: Scalars["String"]["output"];
};

export const StayReviewSignResponseType = {
  /** 分かりづらい／迷った */
  Difficult: "Difficult",
  /** 特に問題ない */
  NoProblem: "NoProblem",
  /** 利用していない・記憶にない */
  NotUseOrRemember: "NotUseOrRemember",
} as const;

export type StayReviewSignResponseType =
  (typeof StayReviewSignResponseType)[keyof typeof StayReviewSignResponseType];
/** 滞在レビュー 2.0（4 軸評価）。submittedAt が null の間は下書き */
export type StayReviewV2 = {
  __typename?: "StayReviewV2";
  /** 建築と自然環境の評価（1〜5）。下書き中の未回答は null */
  architectureAndNatureRating?: Maybe<Scalars["Int"]["output"]>;
  /** 清掃のクオリティの評価（1〜5）。下書き中の未回答は null */
  cleaningRating?: Maybe<Scalars["Int"]["output"]>;
  /** 滞在の感想・運営に伝えたいこと（自由記述）。書いていなければ null */
  comment?: Maybe<Scalars["String"]["output"]>;
  /** 気になったもの */
  concerns: Array<StayReviewV2Concern>;
  /** 設備と備品の評価（1〜5）。下書き中の未回答は null */
  equipmentRating?: Maybe<Scalars["Int"]["output"]>;
  /** 案内とサポートの評価（1〜5）。下書き中の未回答は null */
  guidanceAndSupportRating?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 心に残った体験（複数選択） */
  memorableExperiences: Array<StayReviewMemorableExperience>;
  /** 送信日時。null は下書き（途中離脱した内容の保持） */
  submittedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
};

/** 気になったもの。kind ごとに 1 件 */
export type StayReviewV2Concern = {
  __typename?: "StayReviewV2Concern";
  /** 自由記述の kind で書いた内容。書いていなければ null */
  comment?: Maybe<Scalars["String"]["output"]>;
  /** 選択式の kind で選んだ項目。自由記述の kind では空 */
  details: Array<StayReviewConcernDetail>;
  kind: StayReviewConcernKind;
};

export type StayReviewV2ConcernInput = {
  /** 自由記述の種別で書いた内容 */
  comment: Scalars["String"]["input"];
  /** 選択式の種別で選んだ項目。自由記述の種別では空 */
  details: Array<StayReviewConcernDetail>;
  kind: StayReviewConcernKind;
};

export type StayReviewV2Error = {
  __typename?: "StayReviewV2Error";
  case: StayReviewV2ErrorCase;
};

export const StayReviewV2ErrorCase = {
  /** 送信済みのレビューは下書き保存できない（更新は submitStayReviewV2 で行う） */
  AlreadySubmitted: "AlreadySubmitted",
  /** 権限がない（他人の予約） */
  NotAuthorized: "NotAuthorized",
  /** 記入できる期間外（チェックイン前、またはチェックアウト後 7 日を過ぎた） */
  OutOfPeriod: "OutOfPeriod",
  /** 入力値が不正（評価が 1〜5 の範囲外、送信時の評価未回答、種別に属さない選択肢など） */
  ValidationError: "ValidationError",
} as const;

export type StayReviewV2ErrorCase =
  (typeof StayReviewV2ErrorCase)[keyof typeof StayReviewV2ErrorCase];
/** 滞在レビュー 2.0 の設問定義 */
export type StayReviewV2Form = {
  __typename?: "StayReviewV2Form";
  axes: Array<StayReviewAxisDefinition>;
  memorableExperiences: Array<StayReviewMemorableExperienceOption>;
};

/** 滞在レビュー 2.0 の入力。下書き保存では評価を null のまま送れる */
export type StayReviewV2Input = {
  architectureAndNatureRating?: InputMaybe<Scalars["Int"]["input"]>;
  cleaningRating?: InputMaybe<Scalars["Int"]["input"]>;
  comment: Scalars["String"]["input"];
  concerns: Array<StayReviewV2ConcernInput>;
  equipmentRating?: InputMaybe<Scalars["Int"]["input"]>;
  guidanceAndSupportRating?: InputMaybe<Scalars["Int"]["input"]>;
  memorableExperiences: Array<StayReviewMemorableExperience>;
};

/**
 * 宿泊チケット。
 * 現状は1泊あたり1チケットになる。
 */
export type StayTicket = {
  __typename?: "StayTicket";
  /** このチケットで予約された予約情報（キャンセル分も含む） */
  accommodationReservations: Array<AccommodationReservation>;
  /** 利用するためのコード */
  code: Scalars["String"]["output"];
  /** 作成者 */
  createdByUser?: Maybe<User>;
  /** 送付先メールアドレス */
  destinationEmail?: Maybe<Scalars["String"]["output"]>;
  /**
   * 適用期限
   * これを過ぎると予約作成・予約変更ができなくなる。
   */
  expiresAt: Scalars["ZonedDateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** チケットマスタ（管理用） */
  master?: Maybe<StayTicketMaster>;
  /** 宿泊チケットの共通情報 */
  reservationInfo: StayTicketReservationInfo;
  /** 予約が作られた時刻 */
  reservedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 利用ステータス */
  status: StayTicketStatusType;
  /** 宿泊可能期間の終了日 */
  stayEndNight: Scalars["PlainDate"]["output"];
  /** 宿泊可能期間の開始日 */
  stayStartNight: Scalars["PlainDate"]["output"];
  /** Stay Ticket from Owners の場合のオーナーシップ */
  userOwnership?: Maybe<UserOwnership>;
};

export type StayTicketAccommodationReservationProvider = {
  __typename?: "StayTicketAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  stayTicketUnitId: Scalars["ID"]["output"];
};

export type StayTicketAcquisitionItem = {
  /**
   * オーナープランの年度
   * StayGiftFromOwnersの場合は必須
   */
  programYear?: InputMaybe<Scalars["Int"]["input"]>;
  /** チケット数 */
  quantity: Scalars["Int"]["input"];
  /**
   * UserOwnershipのID
   * StayGiftFromOwnersの場合は必須
   */
  userOwnershipId?: InputMaybe<Scalars["ID"]["input"]>;
};

export const StayTicketAcquisitionMode = {
  OwnerNightExchange: "OwnerNightExchange",
  Purchase: "Purchase",
} as const;

export type StayTicketAcquisitionMode =
  (typeof StayTicketAcquisitionMode)[keyof typeof StayTicketAcquisitionMode];
/** 宿泊チケットの振る舞いを規定する共通のビジネスルール */
export type StayTicketMaster = {
  __typename?: "StayTicketMaster";
  /** 3人目以降の追加ゲスト料金ポリシー（任意） */
  additionalGuestFeePolicy?: Maybe<AdditionalGuestFeePolicy>;
  /** 追加の注意事項 */
  additionalNoticeTypes: Array<AdditionalNoticeType>;
  /**
   * 予約可能な設備のリスト
   * 前提として、何も設備がついていない宿泊施設は常に予約できる。
   * その上で、設備がついている宿泊施設は、このリストにその設備が含まれる場合に予約できる。
   */
  availableAccommodationFacilities: Array<AccommodationFacility>;
  /** 予約可能な建築タイプのリスト */
  availableArchitectureTypes: Array<ArchitectureType>;
  /** 予約可能な拠点のリスト */
  availableSites: Array<Site>;
  /** 基本料金モード: 'Policy' は BaseAccommodationFeePolicy を使用、'Daily' は BaseAccommodationFeeDailyRate を使用 */
  baseAccommodationFeeMode: BaseAccommodationFeeMode;
  id: Scalars["ID"]["output"];
  /** シーズン料金の追加有無 */
  includeSeasonalFee: Scalars["Boolean"]["output"];
  /** 内部向けの説明 */
  internalDescription: Scalars["String"]["output"];
  /** アーカイブ済みかどうか */
  isArchived: Scalars["Boolean"]["output"];
  /** 一括利用かどうか */
  isBulkUsage: Scalars["Boolean"]["output"];
  /** 検索キー */
  lookupKey?: Maybe<Scalars["String"]["output"]>;
  /** ユーザーに表示する名称。 */
  name: Scalars["String"]["output"];
  /**
   * 予約時に表示される文章。
   * 構造化マークアップ（？）のフォーマットになる。
   */
  notice?: Maybe<Scalars["String"]["output"]>;
  /** 稼働制御の対象 */
  occupancyLimitTarget: OccupancyLimitTarget;
  /** 基本となる1泊ごとの宿泊料金のポリシー */
  rawBaseAccommodationFeePolicy: RawBaseAccommodationFeePolicy;
  /** キャンセル料金のポリシー */
  rawCancelFeePolicy: RawCancelFeePolicy;
  /** 管理部署 */
  staffGroup?: Maybe<StaffGroup>;
  /** チケット */
  stayTickets: Array<StayTicket>;
  /** 使用したチケットマスター雛形（任意） */
  template?: Maybe<StayTicketMasterTemplate>;
  /** このマスターに紐づくテンプレート */
  templates: Array<StayTicketTemplate>;
  /** チケット区分 */
  ticketCategory?: Maybe<TicketCategory>;
  /** 施設追加料金の請求をしないかどうか */
  waiveArchitectureTypeAdditionalFee: Scalars["Boolean"]["output"];
  /** 清掃料金の請求をしないかどうか */
  waiveCleaningFee: Scalars["Boolean"]["output"];
  /** 備品料金の請求をしないかどうか */
  waiveConsumedSuppliesFee: Scalars["Boolean"]["output"];
  /** dog料金の請求をしないかどうか */
  waiveDogFee: Scalars["Boolean"]["output"];
  /** ドッグラン料金の請求をしないかどうか */
  waiveDogRunFee: Scalars["Boolean"]["output"];
  /** EV Charger 料金の請求をしないかどうか */
  waiveEvChargerFee: Scalars["Boolean"]["output"];
  /** 温泉料金の請求をしないかどうか */
  waiveOnsenFee: Scalars["Boolean"]["output"];
  /** 繁忙日料金の請求をしないかどうか */
  waivePeakDayFee: Scalars["Boolean"]["output"];
  /** サウナ料金の請求をしないかどうか */
  waiveSaunaFee: Scalars["Boolean"]["output"];
  /** 拠点別ハイシーズン料金の請求をしないかどうか */
  waiveSiteAdditionalFee: Scalars["Boolean"]["output"];
};

/** 宿泊チケットの振る舞いを規定する共通のビジネスルール */
export type StayTicketMasterstayTicketsArgs = {
  includeExpiredTicket?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * provider を経由せず StayTicketMaster に辿り着くための入力。
 * RoomType.availabilitiesByStayTicketMaster が使う。
 */
export type StayTicketMasterReferenceInput =
  /** StayTicketTemplate.lookupKey。非会員プレビュー等、固定のテンプレートを指す。 */
  { templateLookupKey: Scalars["String"]["input"] };

/** 宿泊チケットマスターのデフォルト値雛形 */
export type StayTicketMasterTemplate = {
  __typename?: "StayTicketMasterTemplate";
  /** 3人目以降の追加ゲスト料金ポリシー（任意） */
  additionalGuestFeePolicy?: Maybe<AdditionalGuestFeePolicy>;
  /** 利用可能な施設タイプ */
  availableAccommodationFacilities: Array<AccommodationFacility>;
  /** 利用可能な建築タイプ */
  availableArchitectureTypes: Array<ArchitectureType>;
  /** 利用可能な拠点 */
  availableSites: Array<Site>;
  /** 基本料金モード */
  baseAccommodationFeeMode: BaseAccommodationFeeMode;
  id: Scalars["ID"]["output"];
  /** シーズン料金の追加有無 */
  includeSeasonalFee: Scalars["Boolean"]["output"];
  /** 管理用説明 */
  internalDescription?: Maybe<Scalars["String"]["output"]>;
  /** 一括利用かどうか */
  isBulkUsage: Scalars["Boolean"]["output"];
  /** 表示名 */
  name: Scalars["String"]["output"];
  /** 稼働制御の対象 */
  occupancyLimitTarget: OccupancyLimitTarget;
  /** 基本となる1泊ごとの宿泊料金のポリシー */
  rawBaseAccommodationFeePolicy?: Maybe<RawBaseAccommodationFeePolicy>;
  /** キャンセル料金のポリシー */
  rawCancelFeePolicy?: Maybe<RawCancelFeePolicy>;
  /** 一意識別子（FreePromo, FreeBase, Discount, Fixed など） */
  slug: Scalars["String"]["output"];
  /** 施設追加料金の請求をしないかどうか */
  waiveArchitectureTypeAdditionalFee: Scalars["Boolean"]["output"];
  /** 清掃料金の請求をしないかどうか */
  waiveCleaningFee: Scalars["Boolean"]["output"];
  /** 備品料金の請求をしないかどうか */
  waiveConsumedSuppliesFee: Scalars["Boolean"]["output"];
  /** dog料金の請求をしないかどうか */
  waiveDogFee: Scalars["Boolean"]["output"];
  /** ドッグラン料金の請求をしないかどうか */
  waiveDogRunFee: Scalars["Boolean"]["output"];
  /** EV Charger 料金の請求をしないかどうか */
  waiveEvChargerFee: Scalars["Boolean"]["output"];
  /** 温泉料金の請求をしないかどうか */
  waiveOnsenFee: Scalars["Boolean"]["output"];
  /** 繁忙日料金の請求をしないかどうか */
  waivePeakDayFee: Scalars["Boolean"]["output"];
  /** サウナ料金の請求をしないかどうか */
  waiveSaunaFee: Scalars["Boolean"]["output"];
  /** 拠点別ハイシーズン料金の請求をしないかどうか */
  waiveSiteAdditionalFee: Scalars["Boolean"]["output"];
};

export type StayTicketReservationInfo = {
  __typename?: "StayTicketReservationInfo";
  /**
   * 追加ゲスト料金（大人1人あたり、1泊）。基準人数を超えて1人目の単価。
   * AdditionalGuestFeePolicy が紐付いていない場合は null（追加料金なし）。
   */
  additionalGuestFeeAdultPricePerNight?: Maybe<Scalars["Int"]["output"]>;
  /**
   * 追加ゲスト料金（6-11歳の子供1人あたり、1泊）。基準人数を超えて1人目の単価。
   * AdditionalGuestFeePolicy が紐付いていない場合は null（追加料金なし）。
   */
  additionalGuestFeeKidsPricePerNight?: Maybe<Scalars["Int"]["output"]>;
  /**
   * 追加ゲスト料金が課金対象となる最小人数。
   * AdditionalGuestFeePolicy が紐付いていない場合は null（追加料金なし）。
   * 例: 基準人数 2 + 1 = 3 → 「3 名以上は追加料金あり」と案内する。
   * 将来 ArchitectureType / master ごとに基準人数を可変化する想定で
   * サーバ側から具体的な数値を返す設計とする。
   */
  additionalGuestFeeStartsAt?: Maybe<Scalars["Int"]["output"]>;
  /** 追加の注意事項 */
  additionalNoticeTypes: Array<AdditionalNoticeType>;
  /**
   * 予約可能な設備のリスト
   * 前提として、何も設備がついていない宿泊施設は常に予約できる。
   * その上で、設備がついている宿泊施設は、このリストにその設備が含まれる場合に予約できる。
   */
  availableAccommodationFacilityTypes: Array<AccommodationFacilityType>;
  /** 予約可能な建築タイプのリスト */
  availableArchitectureTypes: Array<ArchitectureType>;
  /** 予約可能な拠点のリスト */
  availableSites: Array<Site>;
  /**
   * キャンセル料金のポリシー
   * @deprecated Use AccommodationReservation.cancellationPolicy instead
   */
  cancelFeePolicy: CancelFeePolicy;
  /**
   * このチケットに設定された料金割引（feeModifier < 0 の料金ルール）。night 昇順。
   * チェックイン日・滞在日数に依存しない master 属性で、割引案内の表示に使う。
   * （「N 泊以上で◯◯OFF」の注意文に使うのは ruleType=ConsecutiveNightDiscount のみ。）
   * 料金割引が無い場合は空配列。
   */
  discounts: Array<AccommodationFeeDiscount>;
  /** ユーザーに表示する名称。 */
  name: Scalars["String"]["output"];
  /**
   * 予約時に表示される文章。
   * 構造化マークアップ（？）のフォーマットになる。
   */
  notice?: Maybe<Scalars["String"]["output"]>;
  /**
   * StayGiftFromOwners の場合の OwnerPlan の種類
   * 権利が Owners か Co-Owners かがわかる
   */
  ownerPlanType?: Maybe<OwnerPlanType>;
  /** 宿泊チケットのタイプ */
  type: StayTicketType;
  /** 清掃料金の請求をしないかどうか */
  waiveCleaningFee: Scalars["Boolean"]["output"];
  /** 備品料金の請求をしないかどうか */
  waiveConsumedSuppliesFee: Scalars["Boolean"]["output"];
  /** dog料金の請求をしないかどうか */
  waiveDogFee: Scalars["Boolean"]["output"];
  /** EV Charger 料金の請求をしないかどうか */
  waiveEvChargerFee: Scalars["Boolean"]["output"];
  /** 温泉料金の請求をしないかどうか */
  waiveOnsenFee: Scalars["Boolean"]["output"];
  /** サウナ料金の請求をしないかどうか */
  waiveSaunaFee: Scalars["Boolean"]["output"];
};

/** 宿泊チケットの利用ステータス */
export const StayTicketStatusType = {
  /** 適用期限が過ぎている（終了状態） */
  Expired: "Expired",
  /** 予約作成が可能 */
  Open: "Open",
  /** すでに予約が取られている */
  Reserved: "Reserved",
  /** 宿泊済み（終了状態） */
  Stayed: "Stayed",
  /** 無効化されている（終了状態） */
  Void: "Void",
} as const;

export type StayTicketStatusType =
  (typeof StayTicketStatusType)[keyof typeof StayTicketStatusType];
export type StayTicketTemplate = {
  __typename?: "StayTicketTemplate";
  /** 作成日時 */
  createdAt: Scalars["DateTime"]["output"];
  /** expiresAtを現在から何日後に設定するか */
  daysUntilExpiration?: Maybe<Scalars["Int"]["output"]>;
  /** stayEndNightを現在から何日後に設定するか */
  daysUntilLastStay?: Maybe<Scalars["Int"]["output"]>;
  /** 予約期限 */
  expiresAt: Scalars["ZonedDateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** チケット発行機能の有効／無効を設定する */
  isActive: Scalars["Boolean"]["output"];
  /** stayTicketMasterが同じでも異なる設定を入れる可能性があるので、lookupKeyで設定管理を行う */
  lookupKey: Scalars["String"]["output"];
  /** 宿泊チケットマスター */
  master: StayTicketMaster;
  /** 予約期限を固定で設定する場合に使用 */
  rawExpiresAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 宿泊可能終了日 */
  rawStayEndNight?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 宿泊可能開始日 */
  rawStayStartNight?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 宿泊可能終了日を固定で設定する場合に使用 */
  stayEndNight: Scalars["PlainDate"]["output"];
  /** 宿泊可能開始日を固定で設定する場合に使用 */
  stayStartNight: Scalars["PlainDate"]["output"];
};

/** 宿泊チケットのタイプ */
export const StayTicketType = {
  Regular: "Regular",
  StayGiftFromOwners: "StayGiftFromOwners",
} as const;

export type StayTicketType =
  (typeof StayTicketType)[keyof typeof StayTicketType];
/** 同一のビジネスルールを持つ宿泊チケットのまとまり */
export type StayTicketUnit = {
  __typename?: "StayTicketUnit";
  id: Scalars["ID"]["output"];
  /** 宿泊チケットの共通情報 */
  reservationInfo: StayTicketReservationInfo;
  /** 宿泊可能期間の終了日（複数のチケットがある場合、一番遅い日） */
  stayEndNight: Scalars["PlainDate"]["output"];
  /** 宿泊可能期間の開始日（複数のチケットがある場合、一番早い日） */
  stayStartNight: Scalars["PlainDate"]["output"];
  /**
   * チケットマスターID
   * （計測用）
   */
  stayTicketMasterId?: Maybe<Scalars["String"]["output"]>;
  /** 適用されたチケット */
  stayTickets: Array<StayTicket>;
};

export const StayTicketValidationError = {
  /** 同じ宿泊チケットが複数回指定されている */
  Duplicate: "Duplicate",
  /** 適用期間内に、現在の日付が当てはまらない */
  Expired: "Expired",
  /** 宿泊チケットのマスターが異なる */
  MasterMismatch: "MasterMismatch",
  /** 宿泊チケットが存在しない */
  NotFound: "NotFound",
  /** ユニット化できる宿泊チケット数の上限を超えている */
  UnitFull: "UnitFull",
  /** 宿泊チケットが使用済みまたは無効である */
  Unusable: "Unusable",
} as const;

export type StayTicketValidationError =
  (typeof StayTicketValidationError)[keyof typeof StayTicketValidationError];
export type StayTicketValidationResult = {
  __typename?: "StayTicketValidationResult";
  stayTicketCode: Scalars["String"]["output"];
  validationError?: Maybe<StayTicketValidationError>;
};

/**
 * Stripe のクレジットカード情報
 * 特に説明のないものは https://docs.stripe.com/api/cards/object を参照
 */
export type StripeCard = {
  __typename?: "StripeCard";
  brand: Scalars["String"]["output"];
  exp_month: Scalars["Int"]["output"];
  exp_year: Scalars["Int"]["output"];
  last4: Scalars["String"]["output"];
};

/**
 * Stripe の請求方法
 * https://docs.stripe.com/api/invoices/create#create_invoice-collection_method
 */
export const StripeCollectionMethod = {
  charge_automatically: "charge_automatically",
  send_invoice: "send_invoice",
} as const;

export type StripeCollectionMethod =
  (typeof StripeCollectionMethod)[keyof typeof StripeCollectionMethod];
/** customerId を経由して紐づく Stripe の顧客情報 */
export type StripeCustomer = {
  __typename?: "StripeCustomer";
  /** Customer ID */
  customerId: Scalars["String"]["output"];
  /**
   * デフォルトの支払い方法に設定されているクレジットカードの情報
   * Custoemr に設定された defaultPaymentMethod で type=card のもの
   */
  defaultCard?: Maybe<StripeCard>;
  /** 発行済みの請求書の一覧 */
  invoices: Array<StripeInvoice>;
};

/** customerId を経由して紐づく Stripe の顧客情報 */
export type StripeCustomerinvoicesArgs = {
  statuses?: InputMaybe<Array<StripeInvoiceStatus>>;
};

/**
 * Stripe の請求書情報
 * 特に説明のないものは https://docs.stripe.com/api/invoices/object を参照
 */
export type StripeInvoice = {
  __typename?: "StripeInvoice";
  collection_method?: Maybe<StripeCollectionMethod>;
  createdAt: Scalars["ZonedDateTime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  hosted_invoice_url?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  metadata_list: Array<StripeMetadataItem>;
  status: StripeInvoiceStatus;
  status_transitions?: Maybe<StripeInvoiceStatusTransitions>;
  subscription?: Maybe<StripeInvoiceSubscription>;
  total: Scalars["Int"]["output"];
};

/** Stripe の請求書のステータス */
export const StripeInvoiceStatus = {
  draft: "draft",
  open: "open",
  paid: "paid",
  uncollectible: "uncollectible",
  void: "void",
} as const;

export type StripeInvoiceStatus =
  (typeof StripeInvoiceStatus)[keyof typeof StripeInvoiceStatus];
/** Stripe 請求書のステータス遷移情報 */
export type StripeInvoiceStatusTransitions = {
  __typename?: "StripeInvoiceStatusTransitions";
  paid_at?: Maybe<Scalars["ZonedDateTime"]["output"]>;
};

export type StripeInvoiceSubscription = {
  __typename?: "StripeInvoiceSubscription";
  id: Scalars["ID"]["output"];
};

/** Stripe 請求書のメタデータの要素 */
export type StripeMetadataItem = {
  __typename?: "StripeMetadataItem";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type StripeRequireNextAction = {
  __typename?: "StripeRequireNextAction";
  clientSecret: Scalars["String"]["output"];
  /** Co-Owners 申込の場合 */
  coOwnersApplicationId?: Maybe<Scalars["String"]["output"]>;
};

export type SubmitAdHocQuestionnaireResponseError = {
  __typename?: "SubmitAdHocQuestionnaireResponseError";
  case: SubmitAdHocQuestionnaireResponseErrorCase;
};

export const SubmitAdHocQuestionnaireResponseErrorCase = {
  GeneralError: "GeneralError",
  TemplateNotFound: "TemplateNotFound",
} as const;

export type SubmitAdHocQuestionnaireResponseErrorCase =
  (typeof SubmitAdHocQuestionnaireResponseErrorCase)[keyof typeof SubmitAdHocQuestionnaireResponseErrorCase];
export type SubmitAdHocQuestionnaireResponseInput = {
  /** 回答のリスト */
  answers: Array<AdHocQuestionnaireAnswerInput>;
  /** アンケート回答に付随する任意のメタデータのJSON文字列（予約ID、行動ログなど） */
  metaJsonStr?: InputMaybe<Scalars["String"]["input"]>;
  /** アンケートテンプレートのID */
  questionnaireTemplateId: Scalars["ID"]["input"];
};

export type SubmitAdHocQuestionnaireResponsePayload =
  | SubmitAdHocQuestionnaireResponseError
  | Success;

export type SubmitCoOwnersApplicationError = {
  __typename?: "SubmitCoOwnersApplicationError";
  case: SubmitCoOwnersApplicationErrorCase;
};

export const SubmitCoOwnersApplicationErrorCase = {
  IdDocument1Invalid: "IdDocument1Invalid",
  IdDocument2Invalid: "IdDocument2Invalid",
  InvalidRequest: "InvalidRequest",
  NoBeneficialOwnerRelationshipFree: "NoBeneficialOwnerRelationshipFree",
  NoBusinessActivityFree: "NoBusinessActivityFree",
  NoIndividualEmployerName: "NoIndividualEmployerName",
  NoPurchasePurposeFree: "NoPurchasePurposeFree",
  NoSomeOfOrganizationName: "NoSomeOfOrganizationName",
  PaymentFailed: "PaymentFailed",
  PaymentRequiresAction: "PaymentRequiresAction",
  RegistryCertificateInvalid: "RegistryCertificateInvalid",
  UnitsOutOfRange: "UnitsOutOfRange",
} as const;

export type SubmitCoOwnersApplicationErrorCase =
  (typeof SubmitCoOwnersApplicationErrorCase)[keyof typeof SubmitCoOwnersApplicationErrorCase];
export type SubmitCoOwnersApplicationPayload =
  | CoOwnersApplication
  | StripeRequireNextAction
  | SubmitCoOwnersApplicationError;

export type SubmitStayReviewV2Payload = StayReviewV2 | StayReviewV2Error;

export type Success = {
  __typename?: "Success";
  _: Scalars["Boolean"]["output"];
};

/** ある部屋に置かれる備品。マスタと、その部屋に適用される補充基準数の組 */
export type SupplyItem = {
  __typename?: "SupplyItem";
  defaultQuantity: Scalars["Int"]["output"];
  master: SupplyItemMaster;
};

/** 備品の設置情報。対象は accommodation > architectureType > どちらも null（拠点共通）の優先順で決まる */
export type SupplyItemInstallation = {
  __typename?: "SupplyItemInstallation";
  accommodation?: Maybe<Accommodation>;
  architectureType?: Maybe<ArchitectureType>;
  defaultQuantity: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
};

/** 備品マスタ項目 */
export type SupplyItemMaster = {
  __typename?: "SupplyItemMaster";
  /** 備品種別。有料備品の免除ルール */
  category: SupplyItemMasterCategory;
  /** 備品マスタID */
  id: Scalars["ID"]["output"];
  /** 有効かどうか */
  isEnabled: Scalars["Boolean"]["output"];
  /** 表示名（スタッフ用） */
  namePrivate: Scalars["String"]["output"];
  /** 表示名（公開用） */
  namePublic: Scalars["String"]["output"];
  /** 単価（税抜） */
  price: Scalars["Int"]["output"];
  /** 並び順 */
  sort: Scalars["Int"]["output"];
  /** 消費税の種類 */
  taxRateType: ConsumptionTaxRateType;
  /** 単位（本、個など） */
  unit?: Maybe<Scalars["String"]["output"]>;
};

/** 備品の種別 */
export const SupplyItemMasterCategory = {
  Bread: "Bread",
  CoffeeBean: "CoffeeBean",
  Curry: "Curry",
  Firewood: "Firewood",
  FrozenDessert: "FrozenDessert",
  Other: "Other",
  Pizza: "Pizza",
  Rice: "Rice",
  Soup: "Soup",
  Toothbrush: "Toothbrush",
  Wine: "Wine",
} as const;

export type SupplyItemMasterCategory =
  (typeof SupplyItemMasterCategory)[keyof typeof SupplyItemMasterCategory];
/** 対象プランタイプ */
export const TargetPlanType = {
  /** 法人サブスク */
  BusinessSubscription: "BusinessSubscription",
  /** Co-Owners */
  CoOwners: "CoOwners",
  /** Owners(旧: Full-Owner) */
  FullOwner: "FullOwner",
  /** 個人サブスク */
  IndividualSubscription: "IndividualSubscription",
  /** プランなし */
  NoPlan: "NoPlan",
} as const;

export type TargetPlanType =
  (typeof TargetPlanType)[keyof typeof TargetPlanType];
export type TentativeAccommodationReservationError = {
  __typename?: "TentativeAccommodationReservationError";
  case: TentativeAccommodationReservationErrorCase;
};

export const TentativeAccommodationReservationErrorCase = {
  /** 有効期限切れ */
  Expired: "Expired",
  /** 異なるユーザーに紐づいている */
  NotAuthorized: "NotAuthorized",
  /** 仮予約が存在しない */
  NotFound: "NotFound",
  /** One more Cabin の親予約のユーザー */
  OneMoreCabinParentReservationUser: "OneMoreCabinParentReservationUser",
} as const;

export type TentativeAccommodationReservationErrorCase =
  (typeof TentativeAccommodationReservationErrorCase)[keyof typeof TentativeAccommodationReservationErrorCase];
export type TentativeAccommodationReservationPayload =
  | AccommodationReservation
  | RedirectLocation
  | TentativeAccommodationReservationError;

/**
 * 規約
 * プランごとに共通の規約を持つ、白馬オーナーなど例外として個別規約を持つ場合もある
 */
export type Terms = {
  __typename?: "Terms";
  /** 規約本文の URL。個別規約はそのファイル、共通規約はプラン共通の規約ページ */
  documentUrl: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** 個別規約の対象 OwnerPlan。共通規約は null */
  ownerPlan?: Maybe<OwnerPlan>;
  plan: TermsPlanType;
  /** 改定（改定日の降順） */
  revisions: Array<TermsRevision>;
};

/** 規約の対象プラン */
export const TermsPlanType = {
  BusinessPlan: "BusinessPlan",
  CoOwnersPlan: "CoOwnersPlan",
  FullOwnerPlan: "FullOwnerPlan",
  StandardPlan: "StandardPlan",
} as const;

export type TermsPlanType = (typeof TermsPlanType)[keyof typeof TermsPlanType];
/**
 * 規約の改定
 * 本文の更新を伴わない改定（料金変更など）も 1 件として扱う
 */
export type TermsRevision = {
  __typename?: "TermsRevision";
  /** 改定の説明文 */
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** 社内向けの改定内容の要約。会員には表示しない */
  internalSummary: Scalars["String"]["output"];
  /** 改定内容の詳細を案内するお知らせ */
  news?: Maybe<News>;
  /** 改定日 */
  revisedDate: Scalars["PlainDate"]["output"];
  /** 同意を求める対象の OwnerPlan。null は規約の適用者全員 */
  targetOwnerPlan?: Maybe<OwnerPlan>;
  terms: Terms;
};

/** チケット区分 */
export const TicketCategory = {
  /** Stay Gift */
  StayGift: "StayGift",
  /** Stay自社予約 */
  StaySelfBooking: "StaySelfBooking",
  /** タイアップ */
  Tieup: "Tieup",
  /** タイアップ（別途請求） */
  TieupSeparateBilling: "TieupSeparateBilling",
  /** 試泊（無償） */
  TrialFree: "TrialFree",
  /** 試泊（有償） */
  TrialPaid: "TrialPaid",
} as const;

export type TicketCategory =
  (typeof TicketCategory)[keyof typeof TicketCategory];
/** トップページコンテンツ */
export type TopPage = {
  __typename?: "TopPage";
  /** Archive article (ニュースレター) */
  archiveArticle?: Maybe<ArchiveArticle>;
  /** バナーコンテンツ */
  bannerContents: Array<TopPageBannerContent>;
  /** 最新のお知らせ1件 */
  news?: Maybe<News>;
  /** サービスアップデート */
  serviceUpdate?: Maybe<ServiceUpdate>;
};

/** トップページのバナーコンテンツ */
export type TopPageBannerContent = {
  __typename?: "TopPageBannerContent";
  /** 管理名 */
  name: Scalars["String"]["output"];
  /** 表示画像 */
  thumbnail: Scalars["String"]["output"];
  /** 遷移先URL */
  url: Scalars["String"]["output"];
};

/** Trial契約（12ヶ月お試しプラン） */
export type TrialContract = {
  __typename?: "TrialContract";
  /**
   * Co-Owners充当特典（旧S2Oポイント）累積額（円）
   * 月額料金（税抜）の100%を毎月付与
   */
  accumulatedS2oAmount: Scalars["Int"]["output"];
  /** 申込日 */
  appliedAt: Scalars["ZonedDateTime"]["output"];
  /** キャンセル日 */
  cancelledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * 現在の期間の付与泊数
   * 前半期間なら前半で付与された泊数、後半期間なら後半で付与された泊数
   * GrantBySubscriptionトランザクションの合計
   */
  currentPeriodGrantedStayCredits: Scalars["Int"]["output"];
  /**
   * 現在の期間の残り泊数
   * 前半期間なら前半の残り、後半期間なら後半の残り
   */
  currentPeriodStayCredits: Scalars["Int"]["output"];
  /** 契約終了日（利用開始日から12ヶ月後の前日） */
  endDate: Scalars["PlainDate"]["output"];
  /**
   * 利用開始日（契約開始日）
   * ユーザーが選択した翌月または翌々月の1日
   */
  enrolledAt: Scalars["ZonedDateTime"]["output"];
  /** 利用開始日（PlainDate形式） */
  enrolledDate: Scalars["PlainDate"]["output"];
  /** 前半期間の終了日（利用開始日から6ヶ月後の前日） */
  firstSemesterEndDate: Scalars["PlainDate"]["output"];
  /** 前半期間の付与泊数 */
  firstSemesterGrantedStayCredits: Scalars["Int"]["output"];
  /** 前半期間の残りピーク日数 */
  firstSemesterRemainingPeakDays: Scalars["Int"]["output"];
  /** 前半期間の残り泊数 */
  firstSemesterStayCredits: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  /** 残りのピーク日数（全期間の合計） */
  remainingPeakDays: Scalars["Int"]["output"];
  /**
   * 合計残り泊数
   * 前半4泊 + 後半4泊の合計から使用済み泊数を引いた数
   */
  remainingStayCredits: Scalars["Int"]["output"];
  /** 後半期間の付与泊数 */
  secondSemesterGrantedStayCredits: Scalars["Int"]["output"];
  /** 後半期間の残りピーク日数 */
  secondSemesterRemainingPeakDays: Scalars["Int"]["output"];
  /** 後半期間の開始日（利用開始日から6ヶ月後） */
  secondSemesterStartDate: Scalars["PlainDate"]["output"];
  /** 後半期間の残り泊数 */
  secondSemesterStayCredits: Scalars["Int"]["output"];
  /**
   * 基本的なステータス
   * 予約できるかどうか、宿泊できるかどうかなど
   */
  status: TrialContractStatus;
  /** 詳細なステータス */
  statusDetail: TrialContractStatusDetail;
  stripeSubscriptionId?: Maybe<Scalars["String"]["output"]>;
  /** Stripe連携情報 */
  stripeSubscriptionScheduleId?: Maybe<Scalars["String"]["output"]>;
  /** 決済失敗による新規予約の停止 */
  suspended: Scalars["Boolean"]["output"];
  /** 停止日時 */
  suspendedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 解約日 */
  terminatedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 合計付与泊数（常に8泊） */
  totalStayCredits: Scalars["Int"]["output"];
};

export const TrialContractStatus = {
  /** デフォルト（契約期間外） */
  Neutral: "Neutral",
  /** 利用の予定がある（利用予約ができる） */
  Planned: "Planned",
  /** 利用中（利用予約ができる＋利用ができる） */
  Usable: "Usable",
} as const;

export type TrialContractStatus =
  (typeof TrialContractStatus)[keyof typeof TrialContractStatus];
export const TrialContractStatusDetail = {
  /** デフォルト（契約なし） */
  NeutralDefault: "NeutralDefault",
  /** 契約終了済み */
  NeutralTerminated: "NeutralTerminated",
  /** 契約開始予定 */
  PlannedDefault: "PlannedDefault",
  /** 利用中（通常） */
  UsableDefault: "UsableDefault",
} as const;

export type TrialContractStatusDetail =
  (typeof TrialContractStatusDetail)[keyof typeof TrialContractStatusDetail];
export type TrialPlanAccommodationReservationProvider = {
  __typename?: "TrialPlanAccommodationReservationProvider";
  _?: Maybe<Scalars["Boolean"]["output"]>;
  trialContractId: Scalars["ID"]["output"];
};

export type UpdateAccommodationReservationInput = {
  accommodationId: Scalars["ID"]["input"];
  detail: AccommodationReservationDetailInput;
  firstNight: Scalars["PlainDate"]["input"];
  lastNight: Scalars["PlainDate"]["input"];
};

export type UpdateAccommodationReservationOptionsError = {
  __typename?: "UpdateAccommodationReservationOptionsError";
  case: UpdateAccommodationReservationOptionsErrorCase;
};

export const UpdateAccommodationReservationOptionsErrorCase = {
  /** オプションを更新できる予約ステータスではない */
  DeniedByStatus: "DeniedByStatus",
  /**
   * 未知のエラー
   * チェックイン画面で利用されるためエラーもレスポンスとして返す
   */
  UnknownError: "UnknownError",
} as const;

export type UpdateAccommodationReservationOptionsErrorCase =
  (typeof UpdateAccommodationReservationOptionsErrorCase)[keyof typeof UpdateAccommodationReservationOptionsErrorCase];
export type UpdateAccommodationReservationOptionsInput = {
  bringDog: Scalars["Boolean"]["input"];
  /**
   * 人数情報 (省略時は変更しない)。
   * 指定された場合は detail を更新し、StayTicket master の AdditionalGuestFeePolicy 由来の
   * calculated_additional_guest_fee 行を partial に再計算する。
   */
  guestCounts?: InputMaybe<GuestCountsInput>;
  numberOfDogs: Scalars["Int"]["input"];
  useEvCharger: Scalars["Boolean"]["input"];
};

export type UpdateAccommodationReservationOptionsPayload =
  | AccommodationReservation
  | UpdateAccommodationReservationOptionsError;

export type UpdateCoOwnersApplicationOwnerInfoError = {
  __typename?: "UpdateCoOwnersApplicationOwnerInfoError";
  case: UpdateCoOwnersApplicationOwnerInfoErrorCase;
};

export const UpdateCoOwnersApplicationOwnerInfoErrorCase = {
  /** 詳細情報の種類が一致しない */
  DetailTypeMismatch: "DetailTypeMismatch",
  /** データが存在しない */
  NotFound: "NotFound",
  /** 権限がない（申込者本人でない） */
  Unauthorized: "Unauthorized",
} as const;

export type UpdateCoOwnersApplicationOwnerInfoErrorCase =
  (typeof UpdateCoOwnersApplicationOwnerInfoErrorCase)[keyof typeof UpdateCoOwnersApplicationOwnerInfoErrorCase];
export type UpdateCoOwnersApplicationOwnerInfoPayload =
  | CoOwnersApplication
  | UpdateCoOwnersApplicationOwnerInfoError;

export type UpdateFacilityReservationError = {
  __typename?: "UpdateFacilityReservationError";
  case: UpdateFacilityReservationErrorCase;
};

export const UpdateFacilityReservationErrorCase = {
  CommentPeriodExpired: "CommentPeriodExpired",
  InvalidAttribute: "InvalidAttribute",
  InvalidTransition: "InvalidTransition",
  NotAuthorized: "NotAuthorized",
  OutsideUsablePeriod: "OutsideUsablePeriod",
  ReservationNotFound: "ReservationNotFound",
  UsageFlowNotSupported: "UsageFlowNotSupported",
} as const;

export type UpdateFacilityReservationErrorCase =
  (typeof UpdateFacilityReservationErrorCase)[keyof typeof UpdateFacilityReservationErrorCase];
/** 付帯サービス予約更新入力 */
export type UpdateFacilityReservationInput = {
  controllerAttribute: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type UpdateFacilityReservationPayload =
  | UpdateFacilityReservationError
  | UpdateFacilityReservationSuccess;

export type UpdateFacilityReservationSuccess = {
  __typename?: "UpdateFacilityReservationSuccess";
  reservation: FacilityReservation;
};

export type UpdateViewerInput = {
  addressInJapan?: InputMaybe<AddressInJapanInput>;
  addressInternational?: InputMaybe<AddressInternationalInput>;
  addressIsInJapan: Scalars["Boolean"]["input"];
  birthDate: Scalars["PlainDate"]["input"];
  /**
   * 車保有状況
   * 任意だが入力した後に null で上書きできない
   */
  carOwnershipStatus?: InputMaybe<UserProfileCarOwnershipStatus>;
  facePhoto?: InputMaybe<UploadedFileInput>;
  /**
   * 性別
   * 任意だが入力した後に null で上書きできない
   */
  gender?: InputMaybe<GenderType>;
  /**
   * 世帯構成
   * 任意だが入力した後に null で上書きできない
   */
  householdComposition?: InputMaybe<UserProfileHouseholdComposition>;
  name: Scalars["String"]["input"];
  nameKana?: InputMaybe<Scalars["String"]["input"]>;
  nationality: CountryEnum;
  /**
   * 愛犬数
   * 任意だが入力した後に null で上書きできない（0 になる）
   */
  numberOfDogs?: InputMaybe<Scalars["Int"]["input"]>;
  passportNumber?: InputMaybe<Scalars["String"]["input"]>;
  passportPhoto?: InputMaybe<UploadedFileInput>;
  phoneNumber: Scalars["String"]["input"];
  /**
   * 職業(フリーテキスト)
   * 任意だが入力した後に null で上書きできない（空文字列は可）
   */
  professionFree?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * 職業
   * 任意だが入力した後に null で上書きできない
   */
  professionType?: InputMaybe<UserProfileProfessionType>;
};

export type UploadedFile = {
  __typename?: "UploadedFile";
  /** 画像と紐付ける任意のキャプション。 */
  caption?: Maybe<Scalars["String"]["output"]>;
  /**
   * アップロード後のファイルの URL。
   * この URL でファイルにアクセスすることはできない。
   * このファイルを持つエンティティの update mutation に渡すことを想定した値。
   */
  rawUrl: Scalars["String"]["output"];
  /**
   * 期限付きの Presigned URL。
   * 一般ユーザの場合、自分がアップロードしたファイルしか見ることができない。
   * 他のユーザがアップロードした画像の場合は URL の取得に失敗する。
   */
  url: Scalars["String"]["output"];
};

export type UploadedFileInput = {
  /** 画像と紐付ける任意のキャプション。 */
  caption?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * アップロードしたファイルの URL。
   * `https://<bucket>.s3.<region>.amazonaws.com/<key>` の形式。
   */
  rawUrl: Scalars["String"]["input"];
};

/**
 * ユーザー（会員）
 * Webアプリにログインできる、メールアドレスを持っている。
 * 特に SANU 2nd Home を利用するユーザーのことを、会員と呼ぶ。
 */
export type User = {
  __typename?: "User";
  /** マーケメール配信に同意しているか、未回答の場合は null。 */
  acceptMarketingEmail?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * トップ画面からアクセスできる予約カレンダーのリスト
   * 複数なのは、例えば StandardPlan と CoOwners を併用している場合などがあるため
   */
  accessibleReservationCalendars: Array<AccessibleReservationCalendarType>;
  /**
   * 持っている宿泊予約
   * （現在はチェックアウトしていないもので仮予約以外を全て返す。デフォルトの挙動やページングなど、別途定義する）
   */
  accommodationReservations: Array<AccommodationReservation>;
  /** AdHocアンケートの回答一覧 */
  adHocQuestionnaireResponses: Array<AdHocQuestionnaireResponse>;
  /** 管理ロールの割り当て。本人か SuperAdmin / Admin のみ読める。既定は有効なもの（未失効・未期限切れ）だけ */
  adminRoleAssignments: Array<AdminRoleAssignment>;
  /**
   * 対象ユーザーが所有者のすべての宿泊予約
   * (キャンセル・仮予約も含む)
   */
  allAccommodationReservations: Array<AccommodationReservation>;
  /** ユーザーに紐づく App インストールの一覧 */
  appInstallations: Array<UserAppInstallation>;
  /** ユーザーに紐づく Auth0 ユーザーの一覧 */
  auth0Users: Array<Auth0User>;
  /**
   * Bubble の User ID
   * 支払い履歴へのリンクに使用
   */
  bubbleId?: Maybe<Scalars["String"]["output"]>;
  /** CoOwnersの申し込みの情報 */
  coOwnersApplications: Array<CoOwnersApplication>;
  /** 共同オーナーの情報 */
  coOwnerships: Array<UserOwnership>;
  /** 登録されている同伴者 */
  companions?: Maybe<Array<UserCompanion>>;
  /** ユーザー作成日時 */
  createdAt: Scalars["DateTime"]["output"];
  /** 当月の利用済みメンバー特典ドリンクチケット */
  currentMonthUsedDrinkTicket?: Maybe<MemberPerksNowhereDrinkTicket>;
  /** ユーザー削除日時 */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** ログインメールアドレス */
  email: Scalars["String"]["output"];
  /** ログインメールアドレスが確認済みかどうか */
  emailVerified: Scalars["Boolean"]["output"];
  /** Full-Owner 契約でこのユーザーが行った本人確認の一覧（新しい順） */
  fullOwnerIdentityVerifications: Array<IdentityVerification>;
  /** フルオーナーの情報 */
  fullOwnerships: Array<UserOwnership>;
  /**
   * 予約可能なプランを 1 つ以上保有しているか
   * （accessibleReservationCalendars が 1 件以上あるかと同義）
   */
  hasReservablePlan: Scalars["Boolean"]["output"];
  /** 未払いの宿泊料金があるかどうか */
  hasUnpaidAccommodationFee: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** Auth0に紐づくアイデンティティ一覧（ソーシャルログイン等） */
  identities: Array<UserIdentity>;
  /** Intercom Messenger 用の JWT トークン */
  intercomJwt?: Maybe<Scalars["String"]["output"]>;
  /** SuperAdmin か Admin（unrestricted なロール）を持つか。旧 admin フラグは見ない。ロールの内訳は adminRoleAssignments */
  isAdmin: Scalars["Boolean"]["output"];
  /** メンバー特典ドリンクチケット利用対象者か否か */
  isEligibleMemberForDrinkTicketPerks: Scalars["Boolean"]["output"];
  /** Stay Gift が購入可能か */
  isEligibleToPurchaseStayGift: Scalars["Boolean"]["output"];
  /** 宿泊予約に必要なプロフィールを入力済みかどうか */
  isFilledRequiredProfile: Scalars["Boolean"]["output"];
  /** どのプランにも入っていないゲストかどうか */
  isGuest: Scalars["Boolean"]["output"];
  /** 対象のプラン（Subscription、Business、CoOwners、FullOwner）を持っているメンバーかどうか */
  isMember: Scalars["Boolean"]["output"];
  /**
   * プロフィール
   * (未作成/削除済みの場合にnullを返す)
   */
  maybeProfile?: Maybe<UserProfile>;
  /** 氏名 */
  name: Scalars["String"]["output"];
  /** 氏名のふりがな */
  nameKana?: Maybe<Scalars["String"]["output"]>;
  /** 所属企業 */
  organization?: Maybe<Organization>;
  /** 所属企業の詳細情報 */
  organizationMembership?: Maybe<OrganizationMembership>;
  /** ペルソナ分析メトリクス（内部API用） */
  personaMetrics: UserPersonaMetrics;
  /** 電話番号 */
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  /** プロフィール */
  profile: UserProfile;
  /**
   * 同意が必要な改定
   * 全ての契約中プランの規約の改定のうち、改定日を迎えていて未同意のもの全て。
   * provider を指定すると、その provider での予約に適用される規約の改定に絞る。
   * provider に適用される改定に同意するまで、その provider で予約の作成・変更ができない
   */
  requiredTermsAgreements: Array<TermsRevision>;
  /** Co-Owners充当特典（旧S2Oポイント） */
  s2o: S2o;
  /**
   * for Staff契約の情報（従業員向け福利厚生プラン）
   * 契約が存在しない場合はnull
   */
  staffContract?: Maybe<StaffContract>;
  /** Co-Owners充当特典（Stay）の割引予測額（内部API用・読み取り専用） */
  stayCreditEstimate: StayCreditEstimate;
  /** 保有宿泊チケット */
  stayTickets: Array<StayTicket>;
  /** 宿泊した回数 */
  stayedReservationCount: Scalars["Int"]["output"];
  /** Stripe の情報 */
  stripe: StripeCustomer;
  /** サブスクリプションの情報 */
  subscription: UserSubscription;
  /** システム設定 */
  systemSettings: UserSystemSettings;
  /**
   * Trial契約の情報（12ヶ月お試しプラン）
   * 契約が存在しない場合はnull
   */
  trialContract?: Maybe<TrialContract>;
  /** 持っている仮予約 */
  unconfirmedAccommodationReservations: Array<AccommodationReservation>;
  /** ユーザー情報更新日時 */
  updatedAt: Scalars["DateTime"]["output"];
  /**
   * Zendesk の User ID
   * 問い合わせ対応時のユーザー照会に使用
   */
  zendeskId?: Maybe<Scalars["String"]["output"]>;
};

/**
 * ユーザー（会員）
 * Webアプリにログインできる、メールアドレスを持っている。
 * 特に SANU 2nd Home を利用するユーザーのことを、会員と呼ぶ。
 */
export type UseradminRoleAssignmentsArgs = {
  includeInactive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * ユーザー（会員）
 * Webアプリにログインできる、メールアドレスを持っている。
 * 特に SANU 2nd Home を利用するユーザーのことを、会員と呼ぶ。
 */
export type UserrequiredTermsAgreementsArgs = {
  provider?: InputMaybe<AccommodationReservationProviderInput>;
};

export type UserAppInstallation = {
  __typename?: "UserAppInstallation";
  /** 作成日時 */
  createdAt: Scalars["ZonedDateTime"]["output"];
  /** FCM トークン */
  fcmToken: Scalars["String"]["output"];
  /** ID */
  id: Scalars["ID"]["output"];
  /** インストール ID */
  installationId: Scalars["String"]["output"];
  /** プラットフォーム */
  platform: PushNotificationPlatform;
  /** 登録時のアプリのバージョン */
  registeredAppVersion?: Maybe<Scalars["String"]["output"]>;
  /** デバイスモデル */
  registeredDeviceModel?: Maybe<Scalars["String"]["output"]>;
  /** 登録時のデバイスの OS バージョン */
  registeredOsVersion?: Maybe<Scalars["String"]["output"]>;
  /** 更新日時 */
  updatedAt: Scalars["ZonedDateTime"]["output"];
  /** ユーザー */
  user: User;
};

export type UserCompanion = {
  __typename?: "UserCompanion";
  /** 住所 */
  address: Address;
  /** 生年月日 */
  birthDate: Scalars["PlainDate"]["output"];
  /** 性別 */
  gender: GenderType;
  id: Scalars["ID"]["output"];
  /** 氏名 */
  name: Scalars["String"]["output"];
  /** 国籍 */
  nationality?: Maybe<CountryEnum>;
  /** パスポート番号（日本国内に住所を有しない・かつ国籍が日本でない場合） */
  passportNumber?: Maybe<Scalars["String"]["output"]>;
  /** パスポート写真（日本国内に住所を有しない・かつ国籍が日本でない場合） */
  passportPhoto?: Maybe<UploadedFile>;
  /** 電話番号 */
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  /** 職業 */
  professionType?: Maybe<UserProfileProfessionType>;
};

export type UserCompanionInput = {
  addressInJapan?: InputMaybe<AddressInJapanInput>;
  addressInternational?: InputMaybe<AddressInternationalInput>;
  addressIsInJapan: Scalars["Boolean"]["input"];
  birthDate: Scalars["PlainDate"]["input"];
  gender: GenderType;
  name: Scalars["String"]["input"];
  nationality?: InputMaybe<CountryEnum>;
  passportNumber?: InputMaybe<Scalars["String"]["input"]>;
  passportPhoto?: InputMaybe<UploadedFileInput>;
  phoneNumber: Scalars["String"]["input"];
  professionType?: InputMaybe<UserProfileProfessionType>;
};

export const UserFileType = {
  /** CoOwners法人名義の場合の登記簿謄本（履歴事項全部証明書） */
  RegistryCertificate: "RegistryCertificate",
  /** 顔写真 */
  UserFacePhoto: "UserFacePhoto",
  /** 本人確認書類1 */
  UserIdentityDocument1: "UserIdentityDocument1",
  /** 本人確認書類2 */
  UserIdentityDocument2: "UserIdentityDocument2",
  /** パスポート写真 */
  UserPassportPhoto: "UserPassportPhoto",
} as const;

export type UserFileType = (typeof UserFileType)[keyof typeof UserFileType];
/** Auth0に紐づくアイデンティティ情報 */
export type UserIdentity = {
  __typename?: "UserIdentity";
  /**
   * パスワードが自動生成されたものかどうか（ソーシャルサインアップ時に自動作成された場合true）。
   * EmailPasswordプロバイダーのみ有効、それ以外はnull。
   */
  autoGeneratedPassword?: Maybe<Scalars["Boolean"]["output"]>;
  /** Auth0のコネクション名 */
  connection: Scalars["String"]["output"];
  /** アイデンティティのメールアドレス */
  email?: Maybe<Scalars["String"]["output"]>;
  /** メールアドレスが確認済みかどうか */
  emailVerified: Scalars["Boolean"]["output"];
  /** Apple Private Relayメールアドレスかどうか */
  isAppleRelay: Scalars["Boolean"]["output"];
  /** ソーシャルプロバイダーかどうか */
  isSocial: Scalars["Boolean"]["output"];
  /** ローカルDB（auth0_users.linked_identities）に同期済みかどうか */
  isSyncedLocally: Scalars["Boolean"]["output"];
  /** プロバイダー種別 */
  provider: IdentityProvider;
  /** Auth0ユーザーID */
  userId: Scalars["String"]["output"];
};

export type UserMonthlyStatement = {
  __typename?: "UserMonthlyStatement";
  /** 予約明細一覧 */
  reservationStatements: Array<ReservationStatementItem>;
  /** 合計金額（税込） */
  totalPrice: Scalars["Int"]["output"];
  /** 対象ユーザー */
  user: User;
  /** 対象年月 */
  yearMonth: Scalars["PlainYearMonth"]["output"];
};

/** オーナーとして所有済みの物件情報 */
export type UserOwnership = {
  __typename?: "UserOwnership";
  /** CoOwner 申し込み */
  coOwnersApplication?: Maybe<CoOwnersApplication>;
  /** 現在の年度の報情 */
  currentYearStatus: UserOwnershipProgramYearStatus;
  /** 名義人（個人：ユーザー名／法人：会社名） */
  holderName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /**
   * 年間あたりの繁忙日の最大宿泊可能数(High日)
   * （月割りのない場合の最大値）
   * FullOwner は 2027 program year から適用されるため、それ以前の期間中は null。
   */
  maxPeakDaysPerYear?: Maybe<Scalars["Int"]["output"]>;
  /**
   * 年間あたりの拠点ハイシーズンの最大宿泊可能数
   * （月割りのない場合の最大値）
   */
  maxSiteHighSeasonDaysPerYear?: Maybe<Scalars["Int"]["output"]>;
  /** 次回お支払日 */
  nextPaymentDate: Scalars["PlainDate"]["output"];
  /**
   * 次の年度の情報
   * 10月1日以降になると返るようになる
   */
  nextYearStatus?: Maybe<UserOwnershipProgramYearStatus>;
  /**
   * 年間利用泊数
   * （月割りのない場合の最大値）
   */
  nightsPerYear: Scalars["Int"]["output"];
  /** プラン */
  plan: OwnerPlan;
  /** 口数 */
  units: Scalars["Int"]["output"];
  /** 利用終了日 */
  usageEndDate: Scalars["PlainDate"]["output"];
  /** 利用開始日 */
  usageStartDate: Scalars["PlainDate"]["output"];
  /** このオーナーシップのユーザー */
  user: User;
};

/** オーナー機能における年度ごとの情報 */
export type UserOwnershipProgramYearStatus = {
  __typename?: "UserOwnershipProgramYearStatus";
  /** 年度の終わり */
  endDate: Scalars["PlainDate"]["output"];
  /** 残りの泊数 */
  remainingNights: Scalars["Int"]["output"];
  /**
   * 残りの泊数のうち繁忙日の残り。
   * 限度日数を持つプラン (limitPeakDays=true) のみ値を持ち、それ以外は null。
   */
  remainingPeakDays?: Maybe<Scalars["Int"]["output"]>;
  /**
   * 残りの泊数のうち拠点ハイシーズン期間の残り。
   * FullOwner のみ値を持ち、CoOwners や拠点ハイシーズン期間の登録されていない拠点の owner は null。
   */
  remainingSiteHighSeasonDays?: Maybe<Scalars["Int"]["output"]>;
  /** 年度の始まり */
  startDate: Scalars["PlainDate"]["output"];
  /** 年度 */
  year: Scalars["Int"]["output"];
};

/**
 * ユーザーペルソナ分析のメトリクス
 * 各指標は0-100のスコア
 */
export type UserPersonaMetrics = {
  __typename?: "UserPersonaMetrics";
  /** 探索性スコア（訪問済みサイト数を元に計算） */
  exploration: Scalars["Int"]["output"];
  /** 利用頻度スコア（過去6ヶ月の予約回数を元に計算） */
  frequency: Scalars["Int"]["output"];
  /** 投資額スコア（累計支払額を元に計算） */
  investment: Scalars["Int"]["output"];
  /** ロイヤリティスコア（継続利用月数を元に計算） */
  loyalty: Scalars["Int"]["output"];
  /** 季節性スコア（ピークシーズン利用率を元に計算） */
  seasonality: Scalars["Int"]["output"];
};

/**
 * ユーザーのプロフィール
 * ユーザー自身についての情報。
 * 宿泊に際しての法律・条例的な必要条件になるものもここに含まれる。
 */
export type UserProfile = {
  __typename?: "UserProfile";
  /** 住所 */
  address?: Maybe<Address>;
  /** 生年月日 */
  birthDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 車保有状況 */
  carOwnershipStatus?: Maybe<UserProfileCarOwnershipStatus>;
  /** 顔写真 */
  facePhoto?: Maybe<UploadedFile>;
  /** 性別 */
  gender?: Maybe<GenderType>;
  /** 世帯構成 */
  householdComposition?: Maybe<UserProfileHouseholdComposition>;
  id: Scalars["ID"]["output"];
  /** 国籍 */
  nationality?: Maybe<CountryEnum>;
  /** 愛犬数 */
  numberOfDogs?: Maybe<Scalars["Int"]["output"]>;
  /** パスポート番号（日本国内に住所を有しない・かつ国籍が日本でない場合） */
  passportNumber?: Maybe<Scalars["String"]["output"]>;
  /** パスポート写真（日本国内に住所を有しない・かつ国籍が日本でない場合） */
  passportPhoto?: Maybe<UploadedFile>;
  /** 職業(フリーテキスト) */
  professionFree?: Maybe<Scalars["String"]["output"]>;
  /** 職業 */
  professionType?: Maybe<UserProfileProfessionType>;
  user: User;
};

export const UserProfileCarOwnershipStatus = {
  /** カーシェア契約あり */
  WithCarShare: "WithCarShare",
  /** 自家用車あり */
  WithOwnCar: "WithOwnCar",
  /** 自家用車・カーシェア契約なし */
  WithoutAny: "WithoutAny",
} as const;

export type UserProfileCarOwnershipStatus =
  (typeof UserProfileCarOwnershipStatus)[keyof typeof UserProfileCarOwnershipStatus];
export const UserProfileHouseholdComposition = {
  /** ファミリー（子供あり） */
  FamilyWithKids: "FamilyWithKids",
  /** 夫婦・カップルのみ（子供なし） */
  FamilyWithoutKids: "FamilyWithoutKids",
  /** その他 */
  Other: "Other",
  /** 単身 */
  Single: "Single",
} as const;

export type UserProfileHouseholdComposition =
  (typeof UserProfileHouseholdComposition)[keyof typeof UserProfileHouseholdComposition];
export const UserProfileProfessionType = {
  /**
   * 公務員（旧）
   * @deprecated 新しい選択肢を使用してください
   */
  CivilServant: "CivilServant",
  /** 公務員・団体職員 */
  CivilServantOrOrganizationEmployee: "CivilServantOrOrganizationEmployee",
  /**
   * 会社員（旧）
   * @deprecated 新しい選択肢を使用してください
   */
  CompanyEmployee: "CompanyEmployee",
  /** 会社員（出社中心） */
  CompanyEmployeeOffice: "CompanyEmployeeOffice",
  /** 会社員（リモートワーク中心） */
  CompanyEmployeeRemote: "CompanyEmployeeRemote",
  /**
   * 会社経営 / 役員（旧）
   * @deprecated 新しい選択肢を使用してください
   */
  ExecutiveOrDirector: "ExecutiveOrDirector",
  /** 経営者・会社役員・開業医・士業 */
  ExecutiveOrProfessional: "ExecutiveOrProfessional",
  /** 専業主婦・主夫 */
  FullTimeHomemaker: "FullTimeHomemaker",
  /**
   * 団体職員（旧）
   * @deprecated 新しい選択肢を使用してください
   */
  OrganizationEmployee: "OrganizationEmployee",
  /** その他 */
  Other: "Other",
  /**
   * 教授 / 教員（旧）
   * @deprecated 新しい選択肢を使用してください
   */
  ProfessorOrTeacher: "ProfessorOrTeacher",
  /** 個人事業主・フリーランス */
  SelfEmployedOrFreelancer: "SelfEmployedOrFreelancer",
  /** 学生 */
  Student: "Student",
  /**
   * 無職・未成年（旧）
   * @deprecated 新しい選択肢を使用してください
   */
  UnemployedOrMinor: "UnemployedOrMinor",
} as const;

export type UserProfileProfessionType =
  (typeof UserProfileProfessionType)[keyof typeof UserProfileProfessionType];
export type UserSubscription = {
  __typename?: "UserSubscription";
  /** Standardプランで蓄積した Co-Owners充当特典（旧S2Oポイント）の累計額 */
  accumulatedS2oAmount: Scalars["Int"]["output"];
  /** 利用申込日 */
  appliedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * 毎月の決済日
   * - status=Usable の場合は現行のサブスクリプションの決済日
   * - status=Planed の場合は予定しているサブスクリプションの決済日
   * 概念的には statusDetail=UsableToPause の場合は復帰前と復帰後の2つのサイクルがありうるので注意。
   */
  billingCycleDay?: Maybe<Scalars["Int"]["output"]>;
  /** 利用開始日（実績） */
  enrolledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 利用開始予定日 */
  enrollmentScheduledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** 直近一週間の追加予約ができる期間 */
  next7DaysReservationPeriod?: Maybe<UserSubscriptionNext7DaysReservationPeriod>;
  /**
   * 休会可能日
   * いますぐ休会した時に休会予定日に選択可能な日
   */
  pausableDates: Array<Scalars["PlainDate"]["output"]>;
  /** この日以降、休会可能 */
  pausableFrom?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 休会予定日 */
  pauseScheduledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 休会日（実績） */
  pausedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * Weekdayプラン規約改定への同意が必要かどうか
   * 既存会員（2026/01/12以前に申込）かつ未同意の場合にtrue
   * @deprecated 規約の同意は Terms / TermsRevision に統合した。未同意の改定は User.requiredTermsAgreements で取る
   */
  requiresWeekdayTermsAgreement: Scalars["Boolean"]["output"];
  /** 毎月の予約サイクル定義 */
  reservationCycle?: Maybe<UserSubscriptionReservationCycle>;
  /** 直近以降の予約サイクル期間 */
  reservationCyclePeriods: Array<UserSubscriptionReservationCyclePeriod>;
  /** 休会復帰予定日 */
  resumeScheduledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 休会復帰日（実績） */
  resumedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * 基本的なステータス
   * 予約できるかどうか、宿泊できるかどうかなどであれば、こちらで十分。
   */
  status: UserSubscriptionStatus;
  /** 詳細なステータス */
  statusDetail: UserSubscriptionStatusDetail;
  stripeCurrentSubscriptionId?: Maybe<Scalars["String"]["output"]>;
  stripeCurrentSubscriptionScheduleId?: Maybe<Scalars["String"]["output"]>;
  stripeUpcomingSubscriptionScheduleId?: Maybe<Scalars["String"]["output"]>;
  /** 決済失敗による、新規予約の停止 */
  suspended: Scalars["Boolean"]["output"];
  /** 利用停止中の場合の停止日時 */
  suspendedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * 解約可能日
   * いますぐ解約した時に解約予定日になる日
   */
  terminatableDate?: Maybe<Scalars["PlainDate"]["output"]>;
  /** この日以降、解約可能 */
  terminatableFrom?: Maybe<Scalars["PlainDate"]["output"]>;
  /** 解約日（実績） */
  terminatedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /** 解約禁止理由 */
  terminationProhibitReason: UserSubscriptionTerminationProhibitReason;
  /** 解約予定日 */
  terminationScheduledAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
  /**
   * Weekdayプラン規約改定への同意日時
   * nullの場合は未同意
   */
  weekdayTermsAgreedAt?: Maybe<Scalars["ZonedDateTime"]["output"]>;
};

export type UserSubscriptionreservationCyclePeriodsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserSubscriptionNext7DaysReservationPeriod = {
  __typename?: "UserSubscriptionNext7DaysReservationPeriod";
  /** lastNight として選択可能な最終日 */
  end: Scalars["PlainDate"]["output"];
  /** firstNight として選択可能な最初の日 */
  start: Scalars["PlainDate"]["output"];
};

export type UserSubscriptionReservationCycle = {
  __typename?: "UserSubscriptionReservationCycle";
  /**
   * 予約サイクルの終了日
   * 空の場合は、startDay と同じ月の月末とする。
   */
  endDay?: Maybe<Scalars["Int"]["output"]>;
  /** 予約サイクルの開始日 */
  startDay: Scalars["Int"]["output"];
};

export type UserSubscriptionReservationCyclePeriod = {
  __typename?: "UserSubscriptionReservationCyclePeriod";
  /** 追加料金が発生する泊数（宿泊済みおよび予約しているものをカウント） */
  additionalNights: Scalars["Int"]["output"];
  end: Scalars["PlainDate"]["output"];
  /**
   * アクティブな予約があるかどうか
   * ある場合は、一週間前予約としてのみ予約可能
   */
  hasActiveReservation: Scalars["Boolean"]["output"];
  /** 追加料金なしで泊まれる残りの泊数（宿泊済みおよび予約しているものをカウント） */
  remainingBaseNights: Scalars["Int"]["output"];
  start: Scalars["PlainDate"]["output"];
  /**
   * 予約サイクルでサブスクとして宿泊済みまたは予約している泊数
   * 8泊目以降の追加料金に影響する
   */
  stayedAndReservedNights: Scalars["Int"]["output"];
};

export const UserSubscriptionStatus = {
  Neutral: "Neutral",
  Planed: "Planed",
  Usable: "Usable",
} as const;

export type UserSubscriptionStatus =
  (typeof UserSubscriptionStatus)[keyof typeof UserSubscriptionStatus];
export const UserSubscriptionStatusDetail = {
  NeutralDefault: "NeutralDefault",
  NeutralTerminated: "NeutralTerminated",
  PlanedDefault: "PlanedDefault",
  PlanedToResume: "PlanedToResume",
  UsableDefault: "UsableDefault",
  UsableToPause: "UsableToPause",
  UsableToTerminate: "UsableToTerminate",
} as const;

export type UserSubscriptionStatusDetail =
  (typeof UserSubscriptionStatusDetail)[keyof typeof UserSubscriptionStatusDetail];
export const UserSubscriptionTerminationProhibitReason = {
  /** InvalidOperation（異常系） */
  InvalidOperation: "InvalidOperation",
  /** 想定外の繊維（異常系） */
  InvalidStatusTransition: "InvalidStatusTransition",
  /** 解約可能 */
  NoReason: "NoReason",
  /** NoSubscription（異常系） */
  NoSubscription: "NoSubscription",
  /** 解約できない期間 */
  NotPausableDateYet: "NotPausableDateYet",
  /** 予約があるため */
  ReservationExists: "ReservationExists",
  /** 不明なエラー（異常系） */
  UnknownError: "UnknownError",
} as const;

export type UserSubscriptionTerminationProhibitReason =
  (typeof UserSubscriptionTerminationProhibitReason)[keyof typeof UserSubscriptionTerminationProhibitReason];
/** 解約アンケート */
export type UserSubscriptionTerminationQuestionnaireInput = {
  /** 解約の背景 */
  backgroundOfTermination: Scalars["String"]["input"];
  /** 満足した点（その他を選択した場合） */
  detailOfSatisfactionOfUse?: InputMaybe<Scalars["String"]["input"]>;
  /** 解約理由（その他を選択した場合） */
  detailOfTerminationReason?: InputMaybe<Scalars["String"]["input"]>;
  /** 改善点 */
  improvementPoint: Scalars["String"]["input"];
  /** １番の解約理由 */
  primaryReasonOfTermination: Scalars["String"]["input"];
  /** 解約理由 */
  reasonsOfTermination: Array<Scalars["String"]["input"]>;
  /** 満足した点 */
  satisfactionsOfUse: Array<Scalars["String"]["input"]>;
  /** 今後の情報受信について */
  whetherToReceiveInformation: Scalars["Boolean"]["input"];
};

export type UserSystemSettings = {
  __typename?: "UserSystemSettings";
  /** ハウスルールの表示 */
  hasSeenHouseRules: Scalars["Boolean"]["output"];
};

export type UserSystemSettingsInput = {
  hasSeenHouseRules?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** アカウント連携セッション検証のエラーレスポンス */
export type VerifyAccountLinkSessionError = {
  __typename?: "VerifyAccountLinkSessionError";
  /** エラーケース */
  case: VerifyAccountLinkSessionErrorCase;
};

/** アカウント連携セッション検証のエラーケース */
export const VerifyAccountLinkSessionErrorCase = {
  /** セッショントークンが無効または期限切れ */
  InvalidSessionToken: "InvalidSessionToken",
} as const;

export type VerifyAccountLinkSessionErrorCase =
  (typeof VerifyAccountLinkSessionErrorCase)[keyof typeof VerifyAccountLinkSessionErrorCase];
/** アカウント連携セッション検証の入力 */
export type VerifyAccountLinkSessionInput = {
  /** Auth0から渡されたセッショントークン */
  sessionToken: Scalars["String"]["input"];
};

/** アカウント連携セッション検証の結果 */
export type VerifyAccountLinkSessionPayload =
  | VerifyAccountLinkSessionError
  | VerifyAccountLinkSessionSuccess;

/** アカウント連携セッション検証の成功レスポンス */
export type VerifyAccountLinkSessionSuccess = {
  __typename?: "VerifyAccountLinkSessionSuccess";
  /** 連携先の既存アカウント（同じメールアドレスの認証済み auth0| アカウント） */
  candidateIdentity: AccountLinkIdentity;
  /** 現在のログインに使用されたアイデンティティ */
  currentIdentity: AccountLinkIdentity;
  /** メールアドレス */
  email: Scalars["String"]["output"];
};

/** アイデンティティ追加再認証エラー */
export type VerifyAddIdentityReauthError = {
  __typename?: "VerifyAddIdentityReauthError";
  case: VerifyAddIdentityReauthErrorCase;
};

/** アイデンティティ追加再認証エラーケース */
export const VerifyAddIdentityReauthErrorCase = {
  /** 再認証したユーザーが期待するIDと一致しない */
  IdentityMismatch: "IdentityMismatch",
  /** intent tokenが無効または期限切れ */
  InvalidIntentToken: "InvalidIntentToken",
  /** Auth0とのトークン交換に失敗 */
  TokenExchangeFailed: "TokenExchangeFailed",
} as const;

export type VerifyAddIdentityReauthErrorCase =
  (typeof VerifyAddIdentityReauthErrorCase)[keyof typeof VerifyAddIdentityReauthErrorCase];
/** アイデンティティ追加再認証の入力 */
export type VerifyAddIdentityReauthInput = {
  /** Auth0から返されたauthorization code */
  code: Scalars["String"]["input"];
  /** ラウンドトリップ用のstate (intent token) */
  state: Scalars["String"]["input"];
};

/** アイデンティティ追加再認証の結果 */
export type VerifyAddIdentityReauthPayload =
  | VerifyAddIdentityReauthError
  | VerifyAddIdentityReauthRedirect;

/** アイデンティティ追加再認証: 対象プロバイダーへリダイレクト */
export type VerifyAddIdentityReauthRedirect = {
  __typename?: "VerifyAddIdentityReauthRedirect";
  /** 対象プロバイダーのOAuth認可URL */
  redirectUrl: Scalars["String"]["output"];
};

export type VerifyCheckInQrCodeError = {
  __typename?: "VerifyCheckInQrCodeError";
  case: VerifyCheckInQrCodeErrorCase;
};

export const VerifyCheckInQrCodeErrorCase = {
  /** 既に使用済み */
  AlreadyUsed: "AlreadyUsed",
  /** コードの有効期限切れ */
  Expired: "Expired",
  /** 無効なコード */
  InvalidCode: "InvalidCode",
  /** サイトが一致しない */
  SiteMismatch: "SiteMismatch",
} as const;

export type VerifyCheckInQrCodeErrorCase =
  (typeof VerifyCheckInQrCodeErrorCase)[keyof typeof VerifyCheckInQrCodeErrorCase];
export type VerifyCheckInQrCodeInput = {
  /** QRコード */
  code: Scalars["String"]["input"];
  /** サイトのslug */
  siteSlug: Scalars["String"]["input"];
};

export type VerifyCheckInQrCodePayload =
  | VerifyCheckInQrCodeError
  | VerifyCheckInQrCodeSuccess;

export type VerifyCheckInQrCodeSuccess = {
  __typename?: "VerifyCheckInQrCodeSuccess";
  /** 検証が成功した予約ID */
  accommodationReservationId: Scalars["ID"]["output"];
};

export type VerifyNewEmailError = {
  __typename?: "VerifyNewEmailError";
  case: VerifyNewEmailErrorCase;
};

export const VerifyNewEmailErrorCase = {
  /**
   * 直前に確認メールを送ったメールアドレスと異なる
   * メールアドレス入力からやり直してもらう
   */
  DifferentEmail: "DifferentEmail",
  GeneralError: "GeneralError",
  /** メールアドレスもしくは確認コードが間違っている */
  InvalidEmailOrCode: "InvalidEmailOrCode",
} as const;

export type VerifyNewEmailErrorCase =
  (typeof VerifyNewEmailErrorCase)[keyof typeof VerifyNewEmailErrorCase];
export type VerifyNewEmailInput = {
  /** システム（Auth0）からメールで送信された確認コード */
  code: Scalars["String"]["input"];
  newEmail: Scalars["String"]["input"];
};

export type VerifyNewEmailPayload = VerifyNewEmailError | VerifyNewEmailSuccess;

export type VerifyNewEmailSuccess = {
  __typename?: "VerifyNewEmailSuccess";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** 付帯サービス洗濯乾燥機の稼働状況のコントローラ属性情報（機器の状態はこの ID で PlugDevice を引く） */
export type WashingMachineTracker = {
  __typename?: "WashingMachineTracker";
  controllerId?: Maybe<Scalars["String"]["output"]>;
};

/** Wi-Fi 接続方法（SSID とパスワードの組） */
export type WifiConnection = {
  __typename?: "WifiConnection";
  /** パスワード */
  password: Scalars["String"]["output"];
  /** SSID */
  ssid: Scalars["String"]["output"];
};

/** Wi-Fi 機器の固有情報 */
export type WifiEquipmentAttribute = {
  __typename?: "WifiEquipmentAttribute";
  /** 主接続方法 */
  primary: WifiConnection;
  /**
   * 副接続方法
   * （存在しない施設では null）
   */
  secondary?: Maybe<WifiConnection>;
};

export type WorkationAccommodationFacility = {
  __typename?: "WorkationAccommodationFacility";
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ZendeskSyncUserError = {
  __typename?: "ZendeskSyncUserError";
  case: ZendeskSyncUserErrorCase;
};

export const ZendeskSyncUserErrorCase = {
  UserEmailNotVerified: "UserEmailNotVerified",
  UserNotFound: "UserNotFound",
  /**
   * Zendesk API が permanent なエラー（401 / 403 / 404 等）を返した。
   * 再試行せず Slack にメンション通知して諦める。
   */
  ZendeskApiPermanentError: "ZendeskApiPermanentError",
  /**
   * Zendesk API が transient なエラー（409 / 422 / 429 / 5xx）を返した。
   * qstash の自動再試行に乗せる。
   */
  ZendeskApiTransientError: "ZendeskApiTransientError",
  ZendeskIdNotFound: "ZendeskIdNotFound",
  ZendeskIdUpdateError: "ZendeskIdUpdateError",
} as const;

export type ZendeskSyncUserErrorCase =
  (typeof ZendeskSyncUserErrorCase)[keyof typeof ZendeskSyncUserErrorCase];
export type ZendeskSyncUserResult = Success | ZendeskSyncUserError;

export type leaveOrganizationPayload = LeaveOrganizationError | Success;

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<
  TResult,
  TParent = Record<PropertyKey, never>,
  TContext = Record<PropertyKey, never>,
  TArgs = Record<PropertyKey, never>,
> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> {
  subscribe: SubscriptionSubscribeFn<
    { [key in TKey]: TResult },
    TParent,
    TContext,
    TArgs
  >;
  resolve?: SubscriptionResolveFn<
    TResult,
    { [key in TKey]: TResult },
    TContext,
    TArgs
  >;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = Record<PropertyKey, never>,
  TContext = Record<PropertyKey, never>,
  TArgs = Record<PropertyKey, never>,
> =
  | ((
      ...args: any[]
    ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<
  TTypes,
  TParent = Record<PropertyKey, never>,
  TContext = Record<PropertyKey, never>,
> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<
  T = Record<PropertyKey, never>,
  TContext = Record<PropertyKey, never>,
> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<
  TResult = Record<PropertyKey, never>,
  TParent = Record<PropertyKey, never>,
  TContext = Record<PropertyKey, never>,
  TArgs = Record<PropertyKey, never>,
> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  AcceptAccommodationReservationPayload:
    | (Omit<AcceptAccommodationReservationError, "case"> & {
        case: _RefType["AcceptAccommodationReservationErrorCase"];
      } & { __typename: "AcceptAccommodationReservationError" })
    | (AccommodationReservationMapper & {
        __typename: "AccommodationReservation";
      });
  AccommodationEquipmentAttribute:
    | (MusicConnectEquipmentAttributeMapper & {
        __typename: "MusicConnectEquipmentAttribute";
      })
    | (SaunaEquipmentAttributeMapper & {
        __typename: "SaunaEquipmentAttribute";
      })
    | (WifiEquipmentAttributeMapper & { __typename: "WifiEquipmentAttribute" });
  AccommodationReservationProvider:
    | (BusinessPlanAccommodationReservationProvider & {
        __typename: "BusinessPlanAccommodationReservationProvider";
      })
    | (CoOwnersPlanAccommodationReservationProvider & {
        __typename: "CoOwnersPlanAccommodationReservationProvider";
      })
    | (FullOwnerPlanAccommodationReservationProvider & {
        __typename: "FullOwnerPlanAccommodationReservationProvider";
      })
    | (OneMoreCabinAccommodationReservationProvider & {
        __typename: "OneMoreCabinAccommodationReservationProvider";
      })
    | (OnlineTravelAgentAccommodationReservationProvider & {
        __typename: "OnlineTravelAgentAccommodationReservationProvider";
      })
    | (SanuIncAccommodationReservationProviderMapper & {
        __typename: "SanuIncAccommodationReservationProvider";
      })
    | (StaffPlanAccommodationReservationProvider & {
        __typename: "StaffPlanAccommodationReservationProvider";
      })
    | (StandardPlanAccommodationReservationProvider & {
        __typename: "StandardPlanAccommodationReservationProvider";
      })
    | (StayDirectAccommodationReservationProvider & {
        __typename: "StayDirectAccommodationReservationProvider";
      })
    | (StayTicketAccommodationReservationProvider & {
        __typename: "StayTicketAccommodationReservationProvider";
      })
    | (TrialPlanAccommodationReservationProvider & {
        __typename: "TrialPlanAccommodationReservationProvider";
      });
  AcquireStayTicketsPayload:
    | (Omit<AcquireStayTicketsError, "case"> & {
        case: _RefType["AcquireStayTicketsErrorCase"];
      } & { __typename: "AcquireStayTicketsError" })
    | (Omit<AcquireStayTicketsResult, "tickets"> & {
        tickets: Array<_RefType["StayTicket"]>;
      } & { __typename: "AcquireStayTicketsResult" });
  ActivateMemberPerksDrinkTicketPayload:
    | (Omit<ActivateMemberPerksDrinkTicketError, "case"> & {
        case: _RefType["ActivateMemberPerksDrinkTicketErrorCase"];
      } & { __typename: "ActivateMemberPerksDrinkTicketError" })
    | (Success & { __typename: "Success" });
  Address:
    | (AddressInJapan & { __typename: "AddressInJapan" })
    | (Omit<AddressInternational, "country"> & {
        country: _RefType["CountryEnum"];
      } & { __typename: "AddressInternational" });
  AgreeToTermsPayload:
    | (Omit<AgreeToTermsError, "case"> & {
        case: _RefType["AgreeToTermsErrorCase"];
      } & { __typename: "AgreeToTermsError" })
    | (Success & { __typename: "Success" });
  AgreeToWeekdayTermsPayload:
    | (Omit<AgreeToWeekdayTermsError, "case"> & {
        case: _RefType["AgreeToWeekdayTermsErrorCase"];
      } & { __typename: "AgreeToWeekdayTermsError" })
    | (Success & { __typename: "Success" });
  ApplyToTrialSubscriptionPayload:
    | (Omit<ApplyToTrialSubscriptionError, "case"> & {
        case: _RefType["ApplyToTrialSubscriptionErrorCase"];
      } & { __typename: "ApplyToTrialSubscriptionError" })
    | (StripeRequireNextAction & { __typename: "StripeRequireNextAction" })
    | (Success & { __typename: "Success" });
  ApplyToWeekdaySubscriptionPayload:
    | (Omit<ApplyToWeekdaySubscriptionError, "case"> & {
        case: _RefType["ApplyToWeekdaySubscriptionErrorCase"];
      } & { __typename: "ApplyToWeekdaySubscriptionError" })
    | (StripeRequireNextAction & { __typename: "StripeRequireNextAction" })
    | (Success & { __typename: "Success" });
  Beds24BookingMessageResult:
    | (Omit<Beds24BookingMessageError, "case"> & {
        case: _RefType["Beds24BookingMessageErrorCase"];
      } & { __typename: "Beds24BookingMessageError" })
    | (Success & { __typename: "Success" });
  Beds24SyncFollowingReservationsResultPayload:
    | (Omit<CancelAccommodationReservationError, "case"> & {
        case: _RefType["CancelAccommodationReservationErrorCase"];
      } & { __typename: "CancelAccommodationReservationError" })
    | (Omit<ChangeAccommodationReservationError, "case"> & {
        case: _RefType["ChangeAccommodationReservationErrorCase"];
      } & { __typename: "ChangeAccommodationReservationError" });
  Beds24WebhookResult:
    | (Omit<Beds24WebhookError, "case"> & {
        case: _RefType["Beds24WebhookErrorCase"];
      } & { __typename: "Beds24WebhookError" })
    | (Omit<Beds24WebhookSuccess, "case"> & {
        case: _RefType["Beds24WebhookSuccessCase"];
      } & { __typename: "Beds24WebhookSuccess" });
  CancelAccommodationReservationPayload:
    | (AccommodationReservationMapper & {
        __typename: "AccommodationReservation";
      })
    | (Omit<CancelAccommodationReservationError, "case"> & {
        case: _RefType["CancelAccommodationReservationErrorCase"];
      } & { __typename: "CancelAccommodationReservationError" });
  CancelCoOwnersApplicationPayload:
    | (Omit<CancelCoOwnersApplicationError, "case"> & {
        case: _RefType["CancelCoOwnersApplicationErrorCase"];
      } & { __typename: "CancelCoOwnersApplicationError" })
    | (Success & { __typename: "Success" });
  CancelFacilityReservationPayload:
    | (Omit<CancelFacilityReservationError, "case"> & {
        case: _RefType["CancelFacilityReservationErrorCase"];
      } & { __typename: "CancelFacilityReservationError" })
    | (Success & { __typename: "Success" });
  CancelFeePolicy:
    | (CancelFeeFixedPolicy & { __typename: "CancelFeeFixedPolicy" })
    | (CancelFeeRatePolicy & { __typename: "CancelFeeRatePolicy" });
  CancelStandardSubscriptionApplicationPayload:
    | (Omit<CancelStandardSubscriptionApplicationError, "case"> & {
        case: _RefType["CancelStandardSubscriptionApplicationErrorCase"];
      } & { __typename: "CancelStandardSubscriptionApplicationError" })
    | (Success & { __typename: "Success" });
  CancelStandardSubscriptionPausePayload:
    | (Omit<CancelStandardSubscriptionPauseError, "case"> & {
        case: _RefType["CancelStandardSubscriptionPauseErrorCase"];
      } & { __typename: "CancelStandardSubscriptionPauseError" })
    | (Success & { __typename: "Success" });
  CancelStandardSubscriptionResumePayload:
    | (Omit<CancelStandardSubscriptionResumeError, "case"> & {
        case: _RefType["CancelStandardSubscriptionResumeErrorCase"];
      } & { __typename: "CancelStandardSubscriptionResumeError" })
    | (Success & { __typename: "Success" });
  CancelStandardSubscriptionTerminationPayload:
    | (Omit<CancelStandardSubscriptionTerminationError, "case"> & {
        case: _RefType["CancelStandardSubscriptionTerminationErrorCase"];
      } & { __typename: "CancelStandardSubscriptionTerminationError" })
    | (Success & { __typename: "Success" });
  CancelStayGiftsPayload:
    | (Omit<CancelStayGiftsError, "case"> & {
        case: _RefType["CancelStayGiftsErrorCase"];
      } & { __typename: "CancelStayGiftsError" })
    | (Omit<CancelStayGiftsResult, "cancelledTickets"> & {
        cancelledTickets: Array<_RefType["StayTicket"]>;
      } & { __typename: "CancelStayGiftsResult" });
  CancelTrialSubscriptionPayload:
    | (Omit<CancelTrialSubscriptionError, "case"> & {
        case: _RefType["CancelTrialSubscriptionErrorCase"];
      } & { __typename: "CancelTrialSubscriptionError" })
    | (Success & { __typename: "Success" });
  ChangeAccommodationReservationPayload:
    | (AccommodationReservationMapper & {
        __typename: "AccommodationReservation";
      })
    | (Omit<ChangeAccommodationReservationError, "case"> & {
        case: _RefType["ChangeAccommodationReservationErrorCase"];
      } & { __typename: "ChangeAccommodationReservationError" });
  CheckInAccommodationReservationPayload:
    | (AccommodationReservationMapper & {
        __typename: "AccommodationReservation";
      })
    | (Omit<CheckInAccommodationReservationError, "case"> & {
        case: _RefType["CheckInAccommodationReservationErrorCase"];
      } & { __typename: "CheckInAccommodationReservationError" });
  CheckOutAccommodationReservationPayload:
    | (AccommodationReservationMapper & {
        __typename: "AccommodationReservation";
      })
    | (Omit<CheckOutAccommodationReservationError, "case"> & {
        case: _RefType["CheckOutAccommodationReservationErrorCase"];
      } & { __typename: "CheckOutAccommodationReservationError" });
  CoOwnersApplicantInfoDetail:
    | (CoOwnersApplicantInfoDetailIndividualMapper & {
        __typename: "CoOwnersApplicantInfoDetailIndividual";
      })
    | (CoOwnersApplicantInfoDetailOrganizationMapper & {
        __typename: "CoOwnersApplicantInfoDetailOrganization";
      });
  CompleteAddIdentityPayload:
    | (Omit<CompleteAddIdentityError, "case"> & {
        case: _RefType["CompleteAddIdentityErrorCase"];
      } & { __typename: "CompleteAddIdentityError" })
    | (CompleteAddIdentitySuccess & {
        __typename: "CompleteAddIdentitySuccess";
      });
  ConfirmTentativeAccommodationReservationPayload:
    | (AccommodationReservationMapper & {
        __typename: "AccommodationReservation";
      })
    | (Omit<ConfirmTentativeAccommodationReservationError, "case"> & {
        case: _RefType["ConfirmTentativeAccommodationReservationErrorCase"];
      } & { __typename: "ConfirmTentativeAccommodationReservationError" });
  CreateAccommodationReservationPayload:
    | (AccommodationReservationMapper & {
        __typename: "AccommodationReservation";
      })
    | (Omit<CreateAccommodationReservationError, "case"> & {
        case: _RefType["CreateAccommodationReservationErrorCase"];
      } & { __typename: "CreateAccommodationReservationError" });
  CreateCoOwnersApplicationFileDownloadUrlPayload:
    | (Omit<CreateCoOwnersApplicationFileDownloadUrlError, "case"> & {
        case: _RefType["CreateCoOwnersApplicationFileDownloadUrlErrorCase"];
      } & { __typename: "CreateCoOwnersApplicationFileDownloadUrlError" })
    | (CreateCoOwnersApplicationFileDownloadUrlSuccess & {
        __typename: "CreateCoOwnersApplicationFileDownloadUrlSuccess";
      });
  CreateFacilityReservationPayload:
    | (Omit<CreateFacilityReservationError, "case"> & {
        case: _RefType["CreateFacilityReservationErrorCase"];
      } & { __typename: "CreateFacilityReservationError" })
    | (Omit<CreateFacilityReservationSuccess, "reservation"> & {
        reservation: _RefType["FacilityReservation"];
      } & { __typename: "CreateFacilityReservationSuccess" });
  CreateOrUpdateUserAppInstallationPayload:
    | (Omit<CreateOrUpdateUserAppInstallationError, "case"> & {
        case: _RefType["CreateOrUpdateUserAppInstallationErrorCase"];
      } & { __typename: "CreateOrUpdateUserAppInstallationError" })
    | (Success & { __typename: "Success" });
  CreateWebviewSessionPayload:
    | (Omit<CreateWebviewSessionError, "case"> & {
        case: _RefType["CreateWebviewSessionErrorCase"];
      } & { __typename: "CreateWebviewSessionError" })
    | (CreateWebviewSessionSuccess & {
        __typename: "CreateWebviewSessionSuccess";
      });
  DeleteUserAppInstallationPayload:
    | (Omit<DeleteUserAppInstallationError, "case"> & {
        case: _RefType["DeleteUserAppInstallationErrorCase"];
      } & { __typename: "DeleteUserAppInstallationError" })
    | (Success & { __typename: "Success" });
  DeleteViewerPayload:
    | (Omit<DeleteViewerError, "case"> & {
        case: _RefType["DeleteViewerErrorCase"];
      } & { __typename: "DeleteViewerError" })
    | (Success & { __typename: "Success" });
  EstimateStandardSubscriptionApplicationFeePayload:
    | (Omit<EstimateStandardSubscriptionApplicationError, "case"> & {
        case: _RefType["EstimateStandardSubscriptionApplicationErrorCase"];
      } & { __typename: "EstimateStandardSubscriptionApplicationError" })
    | (EstimateStandardSubscriptionApplicationSuccess & {
        __typename: "EstimateStandardSubscriptionApplicationSuccess";
      });
  EstimatedCancelFeeOfAccommodationReservationPayload:
    | (Omit<EstimatedCancelFeeOfAccommodationReservationError, "case"> & {
        case: _RefType["EstimatedCancelFeeOfAccommodationReservationErrorCase"];
      } & { __typename: "EstimatedCancelFeeOfAccommodationReservationError" })
    | (Omit<EstimatedChargeOfAccommodationReservation, "items"> & {
        items: Array<_RefType["EstimatedChargeOfAccommodationReservationItem"]>;
      } & { __typename: "EstimatedChargeOfAccommodationReservation" });
  EstimatedChangeFeeOfAccommodationReservationPayload:
    | (Omit<EstimatedChangeFeeOfAccommodationReservationError, "case"> & {
        case: _RefType["EstimatedChangeFeeOfAccommodationReservationErrorCase"];
      } & { __typename: "EstimatedChangeFeeOfAccommodationReservationError" })
    | (Omit<EstimatedChargeOfAccommodationReservation, "items"> & {
        items: Array<_RefType["EstimatedChargeOfAccommodationReservationItem"]>;
      } & { __typename: "EstimatedChargeOfAccommodationReservation" });
  FacilityControllerAttribute:
    | (CoWorkingSpaceDoorLock & { __typename: "CoWorkingSpaceDoorLock" })
    | (EvChargerLock & { __typename: "EvChargerLock" })
    | (OnsenAndSaunaDoorLock & { __typename: "OnsenAndSaunaDoorLock" })
    | (RentalCycleKeyBox & { __typename: "RentalCycleKeyBox" })
    | (WashingMachineTracker & { __typename: "WashingMachineTracker" });
  FileUploadPolicyPayload:
    | (Omit<CreateFileUploadPolicyError, "case"> & {
        case: _RefType["CreateFileUploadPolicyErrorCase"];
      } & { __typename: "CreateFileUploadPolicyError" })
    | (CreateFileUploadPolicySuccess & {
        __typename: "CreateFileUploadPolicySuccess";
      });
  FinalizeAccountLinkPayload:
    | (Omit<FinalizeAccountLinkError, "case"> & {
        case: _RefType["FinalizeAccountLinkErrorCase"];
      } & { __typename: "FinalizeAccountLinkError" })
    | (FinalizeAccountLinkSuccess & {
        __typename: "FinalizeAccountLinkSuccess";
      });
  GenerateCheckInQrCodePayload:
    | (Omit<GenerateCheckInQrCodeError, "case"> & {
        case: _RefType["GenerateCheckInQrCodeErrorCase"];
      } & { __typename: "GenerateCheckInQrCodeError" })
    | (Omit<GenerateCheckInQrCodeSuccess, "checkInQrCode"> & {
        checkInQrCode: _RefType["CheckInQrCode"];
      } & { __typename: "GenerateCheckInQrCodeSuccess" });
  HubSpotSyncContactResult:
    | (Omit<HubSpotSyncContactError, "case"> & {
        case: _RefType["HubSpotSyncContactErrorCase"];
      } & { __typename: "HubSpotSyncContactError" })
    | (Success & { __typename: "Success" });
  HubSpotSyncDealResult:
    | (Omit<HubSpotSyncDealError, "case"> & {
        case: _RefType["HubSpotSyncDealErrorCase"];
      } & { __typename: "HubSpotSyncDealError" })
    | (Success & { __typename: "Success" });
  InitiateAccountLinkPayload:
    | (Omit<InitiateAccountLinkError, "case"> & {
        case: _RefType["InitiateAccountLinkErrorCase"];
      } & { __typename: "InitiateAccountLinkError" })
    | (InitiateAccountLinkSuccess & {
        __typename: "InitiateAccountLinkSuccess";
      });
  InitiateAddIdentityPayload:
    | (Omit<InitiateAddIdentityError, "case"> & {
        case: _RefType["InitiateAddIdentityErrorCase"];
      } & { __typename: "InitiateAddIdentityError" })
    | (InitiateAddIdentitySuccess & {
        __typename: "InitiateAddIdentitySuccess";
      });
  InternalAddLocalTaxPolicyPayload:
    | (Omit<InternalAddLocalTaxPolicyError, "case"> & {
        case: _RefType["InternalAddLocalTaxPolicyErrorCase"];
      } & { __typename: "InternalAddLocalTaxPolicyError" })
    | (LocalTaxPolicyMapper & { __typename: "LocalTaxPolicy" });
  InternalAdjustOwnerStayCreditPayload:
    | (Omit<InternalAdjustOwnerStayCreditError, "case"> & {
        case: _RefType["InternalAdjustOwnerStayCreditErrorCase"];
      } & { __typename: "InternalAdjustOwnerStayCreditError" })
    | (Success & { __typename: "Success" });
  InternalAdjustStaffCreditsResult:
    | (Omit<InternalAdjustStaffCreditsError, "case"> & {
        case: _RefType["InternalAdjustStaffCreditsErrorCase"];
      } & { __typename: "InternalAdjustStaffCreditsError" })
    | (Omit<InternalAdjustStaffCreditsSuccess, "contract"> & {
        contract: _RefType["StaffContract"];
      } & { __typename: "InternalAdjustStaffCreditsSuccess" });
  InternalAppendS2oPointsToCoOwnersApplicationPayload:
    | (Omit<InternalAppendS2oPointsToCoOwnersApplicationError, "case"> & {
        case: _RefType["InternalAppendS2oPointsToCoOwnersApplicationErrorCase"];
      } & { __typename: "InternalAppendS2oPointsToCoOwnersApplicationError" })
    | (Success & { __typename: "Success" });
  InternalApplyGuestAccessKeyPayload:
    | (InternalApplyGuestAccessKeyError & {
        __typename: "InternalApplyGuestAccessKeyError";
      })
    | (Success & { __typename: "Success" });
  InternalApplyStaffAccessKeyPayload:
    | (InternalApplyStaffAccessKeyError & {
        __typename: "InternalApplyStaffAccessKeyError";
      })
    | (Success & { __typename: "Success" });
  InternalAssignAccessCodeToAccommodationReservationPayload:
    | (AccommodationReservationMapper & {
        __typename: "AccommodationReservation";
      })
    | (InternalAssignAccessCodeToAccommodationReservationError & {
        __typename: "InternalAssignAccessCodeToAccommodationReservationError";
      });
  InternalAssignAdminRolePayload:
    | (AdminRoleAssignmentMapper & { __typename: "AdminRoleAssignment" })
    | (Omit<InternalAssignAdminRoleError, "code"> & {
        code: _RefType["InternalAssignAdminRoleErrorCode"];
      } & { __typename: "InternalAssignAdminRoleError" });
  InternalBulkCreateOrganizationYearlyContractInvoicesPayload:
    | (Omit<
        InternalBulkCreateOrganizationYearlyContractInvoicesError,
        "case"
      > & {
        case: _RefType["InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase"];
      } & {
        __typename: "InternalBulkCreateOrganizationYearlyContractInvoicesError";
      })
    | (InternalBulkCreateOrganizationYearlyContractInvoicesSuccess & {
        __typename: "InternalBulkCreateOrganizationYearlyContractInvoicesSuccess";
      });
  InternalCancelCoOwnersApplicationPayload:
    | (CoOwnersApplicationMapper & { __typename: "CoOwnersApplication" })
    | (Omit<InternalCancelCoOwnersApplicationError, "case"> & {
        case: _RefType["InternalCancelCoOwnersApplicationErrorCase"];
      } & { __typename: "InternalCancelCoOwnersApplicationError" });
  InternalCreateAccommodationEquipmentPayload:
    | (AccommodationEquipmentMapper & { __typename: "AccommodationEquipment" })
    | (Omit<InternalAccommodationEquipmentError, "case"> & {
        case: _RefType["InternalAccommodationEquipmentErrorCase"];
      } & { __typename: "InternalAccommodationEquipmentError" });
  InternalCreateAccommodationOperationGroupPayload:
    | (AccommodationOperationGroupMapper & {
        __typename: "AccommodationOperationGroup";
      })
    | (Omit<InternalCreateAccommodationOperationGroupError, "case"> & {
        case: _RefType["InternalCreateAccommodationOperationGroupErrorCase"];
      } & { __typename: "InternalCreateAccommodationOperationGroupError" });
  InternalCreateCoOwnersIdentityVerificationPayload:
    | (IdentityVerificationMapper & { __typename: "IdentityVerification" })
    | (Omit<InternalCreateCoOwnersIdentityVerificationError, "case"> & {
        case: _RefType["InternalCreateCoOwnersIdentityVerificationErrorCase"];
      } & { __typename: "InternalCreateCoOwnersIdentityVerificationError" });
  InternalCreateConsumedSuppliesFeeItemsPayload:
    | (Omit<InternalCreateConsumedSuppliesFeeItemsError, "case"> & {
        case: _RefType["InternalCreateConsumedSuppliesFeeItemsErrorCase"];
      } & { __typename: "InternalCreateConsumedSuppliesFeeItemsError" })
    | (Success & { __typename: "Success" });
  InternalCreateFacilityReservationPayload:
    | (Omit<InternalCreateFacilityReservationError, "case"> & {
        case: _RefType["InternalCreateFacilityReservationErrorCase"];
      } & { __typename: "InternalCreateFacilityReservationError" })
    | (Success & { __typename: "Success" });
  InternalCreateFullOwnerIdentityVerificationPayload:
    | (IdentityVerificationMapper & { __typename: "IdentityVerification" })
    | (Omit<InternalCreateFullOwnerIdentityVerificationError, "case"> & {
        case: _RefType["InternalCreateFullOwnerIdentityVerificationErrorCase"];
      } & { __typename: "InternalCreateFullOwnerIdentityVerificationError" });
  InternalCreateLocalTaxPolicyPayload:
    | (Omit<InternalCreateLocalTaxPolicyError, "case"> & {
        case: _RefType["InternalCreateLocalTaxPolicyErrorCase"];
      } & { __typename: "InternalCreateLocalTaxPolicyError" })
    | (LocalTaxPolicyMapper & { __typename: "LocalTaxPolicy" });
  InternalCreateOrUpdateAccommodationNoticePayload:
    | (AccommodationNoticeMapper & { __typename: "AccommodationNotice" })
    | (Omit<InternalCreateOrUpdateAccommodationNoticeError, "case"> & {
        case: _RefType["InternalCreateOrUpdateAccommodationNoticeErrorCase"];
      } & { __typename: "InternalCreateOrUpdateAccommodationNoticeError" });
  InternalCreateOrUpdateAccommodationPayload:
    | (AccommodationMapper & { __typename: "Accommodation" })
    | (InternalCreateOrUpdateAccommodationError & {
        __typename: "InternalCreateOrUpdateAccommodationError";
      });
  InternalCreateOrUpdateAdditionalGuestFeePolicyPayload:
    | (AdditionalGuestFeePolicyMapper & {
        __typename: "AdditionalGuestFeePolicy";
      })
    | (Omit<InternalCreateOrUpdateAdditionalGuestFeePolicyError, "case"> & {
        case: _RefType["InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase"];
      } & {
        __typename: "InternalCreateOrUpdateAdditionalGuestFeePolicyError";
      });
  InternalCreateOrUpdateBaseAccommodationFeePolicyPayload:
    | (Omit<InternalCreateOrUpdateBaseAccommodationFeePolicyError, "case"> & {
        case: _RefType["InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase"];
      } & {
        __typename: "InternalCreateOrUpdateBaseAccommodationFeePolicyError";
      })
    | (Omit<RawBaseAccommodationFeePolicy, "feeModifierType" | "feeRules"> & {
        feeModifierType?: Maybe<_RefType["FeeModifierType"]>;
        feeRules: Array<_RefType["AccommodationFeeRule"]>;
      } & { __typename: "RawBaseAccommodationFeePolicy" });
  InternalCreateOrUpdateBusinessPlanPayload:
    | (BusinessPlan & { __typename: "BusinessPlan" })
    | (Omit<InternalCreateOrUpdateBusinessPlanError, "case"> & {
        case: _RefType["InternalCreateOrUpdateBusinessPlanErrorCase"];
      } & { __typename: "InternalCreateOrUpdateBusinessPlanError" });
  InternalCreateOrUpdateCancelFeePolicyPayload:
    | (Omit<InternalCreateOrUpdateCancelFeePolicyError, "case"> & {
        case: _RefType["InternalCreateOrUpdateCancelFeePolicyErrorCase"];
      } & { __typename: "InternalCreateOrUpdateCancelFeePolicyError" })
    | (Omit<RawCancelFeePolicy, "cancelFeePolicy"> & {
        cancelFeePolicy: _RefType["CancelFeePolicy"];
      } & { __typename: "RawCancelFeePolicy" });
  InternalCreateOrUpdateCoOwnersPlanOfferingPayload:
    | (CoOwnersPlanOfferingMapper & { __typename: "CoOwnersPlanOffering" })
    | (Omit<InternalCreateOrUpdateCoOwnersPlanOfferingError, "case"> & {
        case: _RefType["InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase"];
      } & { __typename: "InternalCreateOrUpdateCoOwnersPlanOfferingError" });
  InternalCreateOrUpdateCoOwnersWebinarSchedulePayload:
    | (CoOwnersWebinarScheduleMapper & {
        __typename: "CoOwnersWebinarSchedule";
      })
    | (Omit<InternalCreateOrUpdateCoOwnersWebinarScheduleError, "case"> & {
        case: _RefType["InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase"];
      } & { __typename: "InternalCreateOrUpdateCoOwnersWebinarScheduleError" });
  InternalCreateOrUpdateContentArchitectPayload:
    | (ContentArchitectMapper & { __typename: "ContentArchitect" })
    | (Omit<InternalArchitectureContentError, "case"> & {
        case: _RefType["InternalArchitectureContentErrorCase"];
      } & { __typename: "InternalArchitectureContentError" });
  InternalCreateOrUpdateContentArchitecturalFeaturePayload:
    | (ContentArchitecturalFeatureMapper & {
        __typename: "ContentArchitecturalFeature";
      })
    | (Omit<InternalArchitectureContentError, "case"> & {
        case: _RefType["InternalArchitectureContentErrorCase"];
      } & { __typename: "InternalArchitectureContentError" });
  InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload:
    | (ContentArchitecturalFeatureUsageRuleMapper & {
        __typename: "ContentArchitecturalFeatureUsageRule";
      })
    | (Omit<InternalArchitectureContentError, "case"> & {
        case: _RefType["InternalArchitectureContentErrorCase"];
      } & { __typename: "InternalArchitectureContentError" });
  InternalCreateOrUpdateContentArchitectureTypePayload:
    | (ContentArchitectureTypeMapper & {
        __typename: "ContentArchitectureType";
      })
    | (Omit<InternalArchitectureContentError, "case"> & {
        case: _RefType["InternalArchitectureContentErrorCase"];
      } & { __typename: "InternalArchitectureContentError" });
  InternalCreateOrUpdateContentArchitectureTypeVariantPayload:
    | (Omit<
        ContentArchitectureTypeVariant,
        | "accommodationFacilities"
        | "facilityDetails"
        | "imageUrls"
        | "kind"
        | "sites"
      > & {
        accommodationFacilities: Array<_RefType["AccommodationFacility"]>;
        facilityDetails: _RefType["ContentFacilityDetails"];
        imageUrls: Array<_RefType["UploadedFile"]>;
        kind: _RefType["ContentArchitectureTypeVariantKind"];
        sites: Array<_RefType["ContentArchitectureTypeVariantSite"]>;
      } & { __typename: "ContentArchitectureTypeVariant" })
    | (Omit<InternalArchitectureContentError, "case"> & {
        case: _RefType["InternalArchitectureContentErrorCase"];
      } & { __typename: "InternalArchitectureContentError" });
  InternalCreateOrUpdateContentBasicAmenityPayload:
    | (ContentArchitectureTypeBasicAmenityMapper & {
        __typename: "ContentArchitectureTypeBasicAmenity";
      })
    | (Omit<InternalArchitectureContentError, "case"> & {
        case: _RefType["InternalArchitectureContentErrorCase"];
      } & { __typename: "InternalArchitectureContentError" });
  InternalCreateOrUpdateContentFacilityAmenityPayload:
    | (ContentArchitectureTypeVariantFacilityAmenityMapper & {
        __typename: "ContentArchitectureTypeVariantFacilityAmenity";
      })
    | (Omit<InternalArchitectureContentError, "case"> & {
        case: _RefType["InternalArchitectureContentErrorCase"];
      } & { __typename: "InternalArchitectureContentError" });
  InternalCreateOrUpdateFacilityPayload:
    | (Omit<InternalCreateOrUpdateFacilityError, "case"> & {
        case: _RefType["InternalCreateOrUpdateFacilityErrorCase"];
      } & { __typename: "InternalCreateOrUpdateFacilityError" })
    | (Success & { __typename: "Success" });
  InternalCreateOrUpdateFacilityResourceBlockPayload:
    | (Omit<InternalCreateOrUpdateFacilityResourceBlockError, "case"> & {
        case: _RefType["InternalCreateOrUpdateFacilityResourceBlockErrorCase"];
      } & { __typename: "InternalCreateOrUpdateFacilityResourceBlockError" })
    | (Success & { __typename: "Success" });
  InternalCreateOrUpdateNativeAppHomeContentPayload:
    | (Omit<InternalCreateOrUpdateNativeAppHomeContentError, "case"> & {
        case: _RefType["InternalCreateOrUpdateNativeAppHomeContentErrorCase"];
      } & { __typename: "InternalCreateOrUpdateNativeAppHomeContentError" })
    | (InternalNativeAppHomeContentMapper & {
        __typename: "InternalNativeAppHomeContent";
      });
  InternalCreateOrUpdateNewsPayload:
    | (Omit<InternalCreateOrUpdateNewsError, "case"> & {
        case: _RefType["InternalCreateOrUpdateNewsErrorCase"];
      } & { __typename: "InternalCreateOrUpdateNewsError" })
    | (NewsMapper & { __typename: "News" });
  InternalCreateOrUpdateOrganizationPayload:
    | (Omit<InternalCreateOrUpdateOrganizationError, "case"> & {
        case: _RefType["InternalCreateOrUpdateOrganizationErrorCase"];
      } & { __typename: "InternalCreateOrUpdateOrganizationError" })
    | (OrganizationMapper & { __typename: "Organization" });
  InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload:
    | (Omit<
        InternalCreateOrUpdateOrganizationYearlyContractInvoiceError,
        "case"
      > & {
        case: _RefType["InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase"];
      } & {
        __typename: "InternalCreateOrUpdateOrganizationYearlyContractInvoiceError";
      })
    | (Success & { __typename: "Success" });
  InternalCreateOrUpdateOrganizationYearlyContractPayload:
    | (InternalCreateOrUpdateOrganizationYearlyContractError & {
        __typename: "InternalCreateOrUpdateOrganizationYearlyContractError";
      })
    | (OrganizationYearlyContractMapper & {
        __typename: "OrganizationYearlyContract";
      });
  InternalCreateOrUpdateOwnerPlanPayload:
    | (Omit<InternalCreateOrUpdateOwnerPlanError, "case"> & {
        case: _RefType["InternalCreateOrUpdateOwnerPlanErrorCase"];
      } & { __typename: "InternalCreateOrUpdateOwnerPlanError" })
    | (OwnerPlanMapper & { __typename: "OwnerPlan" });
  InternalCreateOrUpdateSiteActivityProgramPayload:
    | (Omit<InternalCreateOrUpdateSiteActivityProgramError, "case"> & {
        case: _RefType["InternalCreateOrUpdateSiteActivityProgramErrorCase"];
      } & { __typename: "InternalCreateOrUpdateSiteActivityProgramError" })
    | (SiteActivityProgramMapper & { __typename: "SiteActivityProgram" });
  InternalCreateOrUpdateSiteFaqPayload:
    | (Omit<InternalCreateOrUpdateSiteFaqError, "case"> & {
        case: _RefType["InternalCreateOrUpdateSiteFaqErrorCase"];
      } & { __typename: "InternalCreateOrUpdateSiteFaqError" })
    | (RawSiteFaqMapper & { __typename: "RawSiteFaq" });
  InternalCreateOrUpdateStaffGroupPayload:
    | (Omit<InternalCreateOrUpdateStaffGroupError, "case"> & {
        case: _RefType["InternalCreateOrUpdateStaffGroupErrorCase"];
      } & { __typename: "InternalCreateOrUpdateStaffGroupError" })
    | (StaffGroupMapper & { __typename: "StaffGroup" });
  InternalCreateOrUpdateStayTicketMasterPayload:
    | (Omit<InternalCreateOrUpdateStayTicketMasterError, "case"> & {
        case: _RefType["InternalCreateOrUpdateStayTicketMasterErrorCase"];
      } & { __typename: "InternalCreateOrUpdateStayTicketMasterError" })
    | (StayTicketMasterMapper & { __typename: "StayTicketMaster" });
  InternalCreateOrUpdateStayTicketMasterTemplatePayload:
    | (Omit<InternalCreateOrUpdateStayTicketMasterTemplateError, "case"> & {
        case: _RefType["InternalCreateOrUpdateStayTicketMasterTemplateErrorCase"];
      } & { __typename: "InternalCreateOrUpdateStayTicketMasterTemplateError" })
    | (StayTicketMasterTemplateMapper & {
        __typename: "StayTicketMasterTemplate";
      });
  InternalCreateOrUpdateSupplyItemInstallationsPayload:
    | (Omit<InternalCreateOrUpdateSupplyItemInstallationsError, "case"> & {
        case: _RefType["InternalCreateOrUpdateSupplyItemInstallationsErrorCase"];
      } & { __typename: "InternalCreateOrUpdateSupplyItemInstallationsError" })
    | (Success & { __typename: "Success" });
  InternalCreateOrUpdateSupplyItemMasterPayload:
    | (Omit<InternalCreateOrUpdateSupplyItemMasterError, "case"> & {
        case: _RefType["InternalCreateOrUpdateSupplyItemMasterErrorCase"];
      } & { __typename: "InternalCreateOrUpdateSupplyItemMasterError" })
    | (SupplyItemMasterMapper & { __typename: "SupplyItemMaster" });
  InternalCreateSitePayload:
    | (Omit<InternalCreateSiteError, "case"> & {
        case: _RefType["InternalCreateSiteErrorCase"];
      } & { __typename: "InternalCreateSiteError" })
    | (InternalSiteMapper & { __typename: "InternalSite" });
  InternalCreateStayTicketTemplatePayload:
    | (InternalCreateOrUpdateStayTicketTemplateError & {
        __typename: "InternalCreateOrUpdateStayTicketTemplateError";
      })
    | (StayTicketTemplateMapper & { __typename: "StayTicketTemplate" });
  InternalCreateTermsRevisionPayload:
    | (Omit<InternalCreateTermsRevisionError, "case"> & {
        case: _RefType["InternalCreateTermsRevisionErrorCase"];
      } & { __typename: "InternalCreateTermsRevisionError" })
    | (TermsMapper & { __typename: "Terms" });
  InternalDeleteAccommodationEquipmentPayload:
    | (Omit<InternalAccommodationEquipmentError, "case"> & {
        case: _RefType["InternalAccommodationEquipmentErrorCase"];
      } & { __typename: "InternalAccommodationEquipmentError" })
    | (InternalDeleteAccommodationEquipmentSuccess & {
        __typename: "InternalDeleteAccommodationEquipmentSuccess";
      });
  InternalDeleteArchitectureContentPayload:
    | (Omit<InternalArchitectureContentError, "case"> & {
        case: _RefType["InternalArchitectureContentErrorCase"];
      } & { __typename: "InternalArchitectureContentError" })
    | (Success & { __typename: "Success" });
  InternalDeleteFacilityResourceBlockPayload:
    | (Omit<InternalDeleteFacilityResourceBlockError, "case"> & {
        case: _RefType["InternalDeleteFacilityResourceBlockErrorCase"];
      } & { __typename: "InternalDeleteFacilityResourceBlockError" })
    | (Success & { __typename: "Success" });
  InternalDeleteLocalTaxPolicyPayload:
    | (Omit<InternalDeleteLocalTaxPolicyError, "case"> & {
        case: _RefType["InternalDeleteLocalTaxPolicyErrorCase"];
      } & { __typename: "InternalDeleteLocalTaxPolicyError" })
    | (Success & { __typename: "Success" });
  InternalDeleteSupplyItemInstallationPayload:
    | (Omit<InternalDeleteSupplyItemInstallationError, "case"> & {
        case: _RefType["InternalDeleteSupplyItemInstallationErrorCase"];
      } & { __typename: "InternalDeleteSupplyItemInstallationError" })
    | (Success & { __typename: "Success" });
  InternalDeleteSupplyItemMasterPayload:
    | (Omit<InternalDeleteSupplyItemMasterError, "case"> & {
        case: _RefType["InternalDeleteSupplyItemMasterErrorCase"];
      } & { __typename: "InternalDeleteSupplyItemMasterError" })
    | (Success & { __typename: "Success" });
  InternalFutureCleaningAmountsPayload:
    | (Omit<InternalFutureCleaningAmounts, "list"> & {
        list: Array<_RefType["InternalFutureCleaningAmount"]>;
      } & { __typename: "InternalFutureCleaningAmounts" })
    | (InternalFutureCleaningAmountsError & {
        __typename: "InternalFutureCleaningAmountsError";
      });
  InternalGenerateUserMonthlyStatementPayload:
    | (Omit<InternalGenerateUserMonthlyStatementError, "case"> & {
        case: _RefType["InternalGenerateUserMonthlyStatementErrorCase"];
      } & { __typename: "InternalGenerateUserMonthlyStatementError" })
    | (UserMonthlyStatementMapper & { __typename: "UserMonthlyStatement" });
  InternalInvalidateOrganizationYearlyContractInvoicePayload:
    | (Omit<
        InternalInvalidateOrganizationYearlyContractInvoiceError,
        "case"
      > & {
        case: _RefType["InternalInvalidateOrganizationYearlyContractInvoiceErrorCase"];
      } & {
        __typename: "InternalInvalidateOrganizationYearlyContractInvoiceError";
      })
    | (Success & { __typename: "Success" });
  InternalInvalidateOrganizationYearlyContractPayload:
    | (Omit<InternalInvalidateOrganizationYearlyContractError, "case"> & {
        case: _RefType["InternalInvalidateOrganizationYearlyContractErrorCase"];
      } & { __typename: "InternalInvalidateOrganizationYearlyContractError" })
    | (Success & { __typename: "Success" });
  InternalInvalidateS2oPointsPayload:
    | (Omit<InternalInvalidateS2oPointsError, "case"> & {
        case: _RefType["InternalInvalidateS2oPointsErrorCase"];
      } & { __typename: "InternalInvalidateS2oPointsError" })
    | (Success & { __typename: "Success" });
  InternalIssueS2oPointsPayload:
    | (Omit<InternalIssueS2oPointsError, "case"> & {
        case: _RefType["InternalIssueS2oPointsErrorCase"];
      } & { __typename: "InternalIssueS2oPointsError" })
    | (Success & { __typename: "Success" });
  InternalJtasCreateOrUpdateInspectionStatusesPayload:
    | (Omit<InternalJtasCreateOrUpdateInspectionStatusesError, "case"> & {
        case: _RefType["InternalJtasCreateOrUpdateInspectionStatusesErrorCase"];
      } & { __typename: "InternalJtasCreateOrUpdateInspectionStatusesError" })
    | (Success & { __typename: "Success" });
  InternalJtasCreateOrUpdateSupplyReportPayload:
    | (Omit<InternalJtasCreateOrUpdateSupplyReportError, "case"> & {
        case: _RefType["InternalJtasCreateOrUpdateSupplyReportErrorCase"];
      } & { __typename: "InternalJtasCreateOrUpdateSupplyReportError" })
    | (Success & { __typename: "Success" });
  InternalJtasCreateOrUpdateViolationReportPayload:
    | (Omit<InternalJtasCreateOrUpdateViolationReportError, "case"> & {
        case: _RefType["InternalJtasCreateOrUpdateViolationReportErrorCase"];
      } & { __typename: "InternalJtasCreateOrUpdateViolationReportError" })
    | (Success & { __typename: "Success" });
  InternalJtasDeleteViolationReportPayload:
    | (Omit<InternalJtasDeleteViolationReportError, "case"> & {
        case: _RefType["InternalJtasDeleteViolationReportErrorCase"];
      } & { __typename: "InternalJtasDeleteViolationReportError" })
    | (Success & { __typename: "Success" });
  InternalLeaveOrganizationPayload:
    | (Omit<InternalLeaveOrganizationError, "case"> & {
        case: _RefType["InternalLeaveOrganizationErrorCase"];
      } & { __typename: "InternalLeaveOrganizationError" })
    | (Success & { __typename: "Success" });
  InternalMarkCoOwnersApplicationPlannedForSalePayload:
    | (CoOwnersApplicationMapper & { __typename: "CoOwnersApplication" })
    | (Omit<InternalMarkCoOwnersApplicationPlannedForSaleError, "case"> & {
        case: _RefType["InternalMarkCoOwnersApplicationPlannedForSaleErrorCase"];
      } & { __typename: "InternalMarkCoOwnersApplicationPlannedForSaleError" });
  InternalMarkCoOwnersApplicationSoldPayload:
    | (CoOwnersApplicationMapper & { __typename: "CoOwnersApplication" })
    | (Omit<InternalMarkCoOwnersApplicationSoldError, "case"> & {
        case: _RefType["InternalMarkCoOwnersApplicationSoldErrorCase"];
      } & { __typename: "InternalMarkCoOwnersApplicationSoldError" });
  InternalPartialUpdateOrganizationPayload:
    | (InternalPartialUpdateOrganizationError & {
        __typename: "InternalPartialUpdateOrganizationError";
      })
    | (OrganizationMapper & { __typename: "Organization" });
  InternalReleaseAccessKeyPayload:
    | (InternalReleaseAccessKeyError & {
        __typename: "InternalReleaseAccessKeyError";
      })
    | (Success & { __typename: "Success" });
  InternalRemoveLocalTaxPolicyPayload:
    | (Omit<InternalRemoveLocalTaxPolicyError, "case"> & {
        case: _RefType["InternalRemoveLocalTaxPolicyErrorCase"];
      } & { __typename: "InternalRemoveLocalTaxPolicyError" })
    | (LocalTaxPolicyMapper & { __typename: "LocalTaxPolicy" });
  InternalRevokeAdminRolePayload:
    | (AdminRoleAssignmentMapper & { __typename: "AdminRoleAssignment" })
    | (Omit<InternalRevokeAdminRoleError, "code"> & {
        code: _RefType["InternalRevokeAdminRoleErrorCode"];
      } & { __typename: "InternalRevokeAdminRoleError" });
  InternalRunOneShotScriptResult:
    | (Omit<InternalRunOneShotScriptError, "case"> & {
        case: _RefType["InternalRunOneShotScriptErrorCase"];
      } & { __typename: "InternalRunOneShotScriptError" })
    | (InternalScriptExecutionMapper & {
        __typename: "InternalScriptExecution";
      });
  InternalSendPushNotificationsPayload:
    | (Omit<InternalSendPushNotificationsError, "case"> & {
        case: _RefType["InternalSendPushNotificationsErrorCase"];
      } & { __typename: "InternalSendPushNotificationsError" })
    | (InternalSendPushNotificationsResult & {
        __typename: "InternalSendPushNotificationsResult";
      });
  InternalStartStaffPlanResult:
    | (Omit<InternalStartStaffPlanError, "case"> & {
        case: _RefType["InternalStartStaffPlanErrorCase"];
      } & { __typename: "InternalStartStaffPlanError" })
    | (Omit<InternalStartStaffPlanSuccess, "contract"> & {
        contract: _RefType["StaffContract"];
      } & { __typename: "InternalStartStaffPlanSuccess" });
  InternalStopStaffPlanResult:
    | (Omit<InternalStopStaffPlanError, "case"> & {
        case: _RefType["InternalStopStaffPlanErrorCase"];
      } & { __typename: "InternalStopStaffPlanError" })
    | (Omit<InternalStopStaffPlanSuccess, "contract"> & {
        contract: _RefType["StaffContract"];
      } & { __typename: "InternalStopStaffPlanSuccess" });
  InternalUpdateAccommodationEquipmentPayload:
    | (AccommodationEquipmentMapper & { __typename: "AccommodationEquipment" })
    | (Omit<InternalAccommodationEquipmentError, "case"> & {
        case: _RefType["InternalAccommodationEquipmentErrorCase"];
      } & { __typename: "InternalAccommodationEquipmentError" });
  InternalUpdateAccommodationOperationGroupSettingPayload:
    | (Omit<AccommodationOperationGroupSetting, "class" | "operationType"> & {
        class: _RefType["AccommodationClass"];
        operationType: _RefType["AccommodationOperationType"];
      } & { __typename: "AccommodationOperationGroupSetting" })
    | (Omit<InternalUpdateAccommodationOperationGroupSettingError, "case"> & {
        case: _RefType["InternalUpdateAccommodationOperationGroupSettingErrorCase"];
      } & {
        __typename: "InternalUpdateAccommodationOperationGroupSettingError";
      });
  InternalUpdateAreaPayload:
    | (InternalAreaMapper & { __typename: "InternalArea" })
    | (Omit<InternalUpdateAreaError, "case"> & {
        case: _RefType["InternalUpdateAreaErrorCase"];
      } & { __typename: "InternalUpdateAreaError" });
  InternalUpdateCoOwnersApplicationDetailPayload:
    | (CoOwnersApplicationMapper & { __typename: "CoOwnersApplication" })
    | (Omit<InternalUpdateCoOwnersApplicationDetailError, "case"> & {
        case: _RefType["InternalUpdateCoOwnersApplicationDetailErrorCase"];
      } & { __typename: "InternalUpdateCoOwnersApplicationDetailError" });
  InternalUpdateCoOwnersApplicationFilePayload:
    | (CoOwnersApplicationFileMapper & {
        __typename: "CoOwnersApplicationFile";
      })
    | (Omit<InternalUpdateCoOwnersApplicationFileError, "case"> & {
        case: _RefType["InternalUpdateCoOwnersApplicationFileErrorCase"];
      } & { __typename: "InternalUpdateCoOwnersApplicationFileError" });
  InternalUpdateCoOwnersApplicationInfoPayload:
    | (CoOwnersApplicationMapper & { __typename: "CoOwnersApplication" })
    | (Omit<InternalUpdateCoOwnersApplicationInfoError, "case"> & {
        case: _RefType["InternalUpdateCoOwnersApplicationInfoErrorCase"];
      } & { __typename: "InternalUpdateCoOwnersApplicationInfoError" });
  InternalUpdateCoOwnersApplicationStatusPayload:
    | (CoOwnersApplicationMapper & { __typename: "CoOwnersApplication" })
    | (Omit<InternalUpdateCoOwnersApplicationStatusError, "case"> & {
        case: _RefType["InternalUpdateCoOwnersApplicationStatusErrorCase"];
      } & { __typename: "InternalUpdateCoOwnersApplicationStatusError" });
  InternalUpdateFacilityContentImagesPayload:
    | (InternalCommonError & { __typename: "InternalCommonError" })
    | (Success & { __typename: "Success" });
  InternalUpdateFacilityReservationCleaningPayload:
    | (Omit<InternalUpdateFacilityReservationCleaningError, "case"> & {
        case: _RefType["InternalUpdateFacilityReservationCleaningErrorCase"];
      } & { __typename: "InternalUpdateFacilityReservationCleaningError" })
    | (Success & { __typename: "Success" });
  InternalUpdateFacilityReservationDataSyncPayload:
    | (Omit<InternalUpdateFacilityReservationDataSyncError, "case"> & {
        case: _RefType["InternalUpdateFacilityReservationDataSyncErrorCase"];
      } & { __typename: "InternalUpdateFacilityReservationDataSyncError" })
    | (Success & { __typename: "Success" });
  InternalUpdateIdentityVerificationPayload:
    | (Omit<InternalUpdateIdentityVerificationError, "case"> & {
        case: _RefType["InternalUpdateIdentityVerificationErrorCase"];
      } & { __typename: "InternalUpdateIdentityVerificationError" })
    | (Success & { __typename: "Success" });
  InternalUpdateIndividualTermsDocumentPayload:
    | (Omit<InternalUpdateIndividualTermsDocumentError, "case"> & {
        case: _RefType["InternalUpdateIndividualTermsDocumentErrorCase"];
      } & { __typename: "InternalUpdateIndividualTermsDocumentError" })
    | (TermsMapper & { __typename: "Terms" });
  InternalUpdateInspectionViolationHandlingPayload:
    | (Omit<InternalUpdateInspectionViolationHandlingError, "case"> & {
        case: _RefType["InternalUpdateInspectionViolationHandlingErrorCase"];
      } & { __typename: "InternalUpdateInspectionViolationHandlingError" })
    | (Success & { __typename: "Success" });
  InternalUpdateLocalTaxPolicyPayload:
    | (Omit<InternalUpdateLocalTaxPolicyError, "case"> & {
        case: _RefType["InternalUpdateLocalTaxPolicyErrorCase"];
      } & { __typename: "InternalUpdateLocalTaxPolicyError" })
    | (LocalTaxPolicyMapper & { __typename: "LocalTaxPolicy" });
  InternalUpdateSiteImagesPayload:
    | (InternalCommonError & { __typename: "InternalCommonError" })
    | (Success & { __typename: "Success" });
  InternalUpdateSiteParametersPayload:
    | (InternalSiteMapper & { __typename: "InternalSite" })
    | (InternalUpdateSiteParametersError & {
        __typename: "InternalUpdateSiteParametersError";
      });
  InternalUpdateSitePayload:
    | (InternalSiteMapper & { __typename: "InternalSite" })
    | (Omit<InternalUpdateSiteError, "case"> & {
        case: _RefType["InternalUpdateSiteErrorCase"];
      } & { __typename: "InternalUpdateSiteError" });
  InternalUpdateStayTicketPayload:
    | (InternalUpdateStayTicketInvalidStatusError & {
        __typename: "InternalUpdateStayTicketInvalidStatusError";
      })
    | (InternalUpdateStayTicketNotFoundError & {
        __typename: "InternalUpdateStayTicketNotFoundError";
      })
    | (StayTicketMapper & { __typename: "StayTicket" });
  InternalUpsertConsumedSupplyFeeItemWaiversPayload:
    | (InternalUpsertConsumedSupplyFeeItemWaiversError & {
        __typename: "InternalUpsertConsumedSupplyFeeItemWaiversError";
      })
    | (Success & { __typename: "Success" });
  InternalVoidCoOwnersApplicationPayload:
    | (CoOwnersApplicationMapper & { __typename: "CoOwnersApplication" })
    | (Omit<InternalVoidCoOwnersApplicationError, "case"> & {
        case: _RefType["InternalVoidCoOwnersApplicationErrorCase"];
      } & { __typename: "InternalVoidCoOwnersApplicationError" });
  InviteBusinessMembersPayload:
    | (Omit<InviteBusinessMembersError, "case"> & {
        case: _RefType["InviteBusinessMembersErrorCase"];
      } & { __typename: "InviteBusinessMembersError" })
    | (InviteBusinessMembersSuccess & {
        __typename: "InviteBusinessMembersSuccess";
      });
  IssueSanuEdgeDeviceAccessTokenPayload:
    | (Omit<IssueSanuEdgeDeviceAccessTokenError, "case"> & {
        case: _RefType["IssueSanuEdgeDeviceAccessTokenErrorCase"];
      } & { __typename: "IssueSanuEdgeDeviceAccessTokenError" })
    | (Omit<IssueSanuEdgeDeviceAccessTokenSuccess, "device"> & {
        device: _RefType["SanuEdgeDevice"];
      } & { __typename: "IssueSanuEdgeDeviceAccessTokenSuccess" });
  IssueStayTicketsPayload:
    | (Omit<IssueStayTicketsError, "case"> & {
        case: _RefType["IssueStayTicketsErrorCase"];
      } & { __typename: "IssueStayTicketsError" })
    | (Omit<IssueStayTicketsResult, "tickets"> & {
        tickets: Array<_RefType["StayTicket"]>;
      } & { __typename: "IssueStayTicketsResult" });
  JoinOrganizationPayload:
    | (Omit<JoinOrganizationError, "case"> & {
        case: _RefType["JoinOrganizationErrorCase"];
      } & { __typename: "JoinOrganizationError" })
    | (Success & { __typename: "Success" });
  LeaveOrganizationByViewerPayload:
    | (Omit<LeaveOrganizationByViewerError, "case"> & {
        case: _RefType["LeaveOrganizationErrorCase"];
      } & { __typename: "LeaveOrganizationByViewerError" })
    | (Success & { __typename: "Success" });
  OtaReservationLookupResult:
    | (Omit<OtaReservationLookupError, "case"> & {
        case: _RefType["OtaReservationLookupErrorCase"];
      } & { __typename: "OtaReservationLookupError" })
    | (Omit<OtaReservationLookupSuccess, "facilityTypes"> & {
        facilityTypes: Array<_RefType["AccommodationFacilityType"]>;
      } & { __typename: "OtaReservationLookupSuccess" });
  PartialUpdateOrganizationMembershipPayload:
    | (OrganizationMembershipMapper & { __typename: "OrganizationMembership" })
    | (PartialUpdateOrganizationMembershipError & {
        __typename: "PartialUpdateOrganizationMembershipError";
      });
  PartialUpdateOrganizationPayload:
    | (OrganizationMapper & { __typename: "Organization" })
    | (PartialUpdateOrganizationError & {
        __typename: "PartialUpdateOrganizationError";
      });
  PostStayReviewResponsePayload:
    | (Omit<PostStayReviewResponseError, "case"> & {
        case: _RefType["PostStayReviewResponseErrorCase"];
      } & { __typename: "PostStayReviewResponseError" })
    | (StayReviewResponseMapper & { __typename: "StayReviewResponse" });
  RegisterCoOwnersApplicationFilePayload:
    | (Omit<RegisterCoOwnersApplicationFileError, "case"> & {
        case: _RefType["RegisterCoOwnersApplicationFileErrorCase"];
      } & { __typename: "RegisterCoOwnersApplicationFileError" })
    | (Omit<RegisterCoOwnersApplicationFileSuccess, "file"> & {
        file: _RefType["CoOwnersApplicationFile"];
      } & { __typename: "RegisterCoOwnersApplicationFileSuccess" });
  RemoveIdentityPayload:
    | (Omit<RemoveIdentityError, "case"> & {
        case: _RefType["RemoveIdentityErrorCase"];
      } & { __typename: "RemoveIdentityError" })
    | (Omit<RemoveIdentitySuccess, "removedProvider"> & {
        removedProvider: _RefType["IdentityProvider"];
      } & { __typename: "RemoveIdentitySuccess" });
  ResumeStandardSubscriptionImmediatelyPayload:
    | (Omit<ResumeStandardSubscriptionImmediatelyError, "case"> & {
        case: _RefType["ResumeStandardSubscriptionImmediatelyErrorCase"];
      } & { __typename: "ResumeStandardSubscriptionImmediatelyError" })
    | (Success & { __typename: "Success" });
  SaveStayReviewV2DraftPayload:
    | (StayReviewV2Mapper & { __typename: "StayReviewV2" })
    | (Omit<StayReviewV2Error, "case"> & {
        case: _RefType["StayReviewV2ErrorCase"];
      } & { __typename: "StayReviewV2Error" });
  ScheduleStandardSubscriptionPausePayload:
    | (Omit<ScheduleStandardSubscriptionPauseError, "case"> & {
        case: _RefType["ScheduleStandardSubscriptionPauseErrorCase"];
      } & { __typename: "ScheduleStandardSubscriptionPauseError" })
    | (Success & { __typename: "Success" });
  ScheduleStandardSubscriptionTerminationPayload:
    | (Omit<ScheduleStandardSubscriptionTerminationError, "case"> & {
        case: _RefType["ScheduleStandardSubscriptionTerminationErrorCase"];
      } & { __typename: "ScheduleStandardSubscriptionTerminationError" })
    | (Success & { __typename: "Success" });
  SelectWebinarSchedulePayload:
    | (CoOwnersApplicationMapper & { __typename: "CoOwnersApplication" })
    | (Omit<SelectWebinarScheduleError, "case"> & {
        case: _RefType["SelectWebinarScheduleErrorCase"];
      } & { __typename: "SelectWebinarScheduleError" });
  SendEmailToVerifyNewEmailPayload:
    | (Omit<SendEmailToVerifyNewEmailError, "case"> & {
        case: _RefType["SendEmailToVerifyNewEmailErrorCase"];
      } & { __typename: "SendEmailToVerifyNewEmailError" })
    | (SendEmailToVerifyNewEmailSuccess & {
        __typename: "SendEmailToVerifyNewEmailSuccess";
      });
  SendPasswordResetEmailPayload:
    | (Omit<SendPasswordResetEmailError, "case"> & {
        case?: Maybe<_RefType["SendPasswordResetEmailErrorCase"]>;
      } & { __typename: "SendPasswordResetEmailError" })
    | (SendPasswordResetEmailSuccess & {
        __typename: "SendPasswordResetEmailSuccess";
      });
  SubmitAdHocQuestionnaireResponsePayload:
    | (Omit<SubmitAdHocQuestionnaireResponseError, "case"> & {
        case: _RefType["SubmitAdHocQuestionnaireResponseErrorCase"];
      } & { __typename: "SubmitAdHocQuestionnaireResponseError" })
    | (Success & { __typename: "Success" });
  SubmitCoOwnersApplicationPayload:
    | (CoOwnersApplicationMapper & { __typename: "CoOwnersApplication" })
    | (StripeRequireNextAction & { __typename: "StripeRequireNextAction" })
    | (Omit<SubmitCoOwnersApplicationError, "case"> & {
        case: _RefType["SubmitCoOwnersApplicationErrorCase"];
      } & { __typename: "SubmitCoOwnersApplicationError" });
  SubmitStayReviewV2Payload:
    | (StayReviewV2Mapper & { __typename: "StayReviewV2" })
    | (Omit<StayReviewV2Error, "case"> & {
        case: _RefType["StayReviewV2ErrorCase"];
      } & { __typename: "StayReviewV2Error" });
  TentativeAccommodationReservationPayload:
    | (AccommodationReservationMapper & {
        __typename: "AccommodationReservation";
      })
    | (RedirectLocation & { __typename: "RedirectLocation" })
    | (Omit<TentativeAccommodationReservationError, "case"> & {
        case: _RefType["TentativeAccommodationReservationErrorCase"];
      } & { __typename: "TentativeAccommodationReservationError" });
  UpdateAccommodationReservationOptionsPayload:
    | (AccommodationReservationMapper & {
        __typename: "AccommodationReservation";
      })
    | (Omit<UpdateAccommodationReservationOptionsError, "case"> & {
        case: _RefType["UpdateAccommodationReservationOptionsErrorCase"];
      } & { __typename: "UpdateAccommodationReservationOptionsError" });
  UpdateCoOwnersApplicationOwnerInfoPayload:
    | (CoOwnersApplicationMapper & { __typename: "CoOwnersApplication" })
    | (Omit<UpdateCoOwnersApplicationOwnerInfoError, "case"> & {
        case: _RefType["UpdateCoOwnersApplicationOwnerInfoErrorCase"];
      } & { __typename: "UpdateCoOwnersApplicationOwnerInfoError" });
  UpdateFacilityReservationPayload:
    | (Omit<UpdateFacilityReservationError, "case"> & {
        case: _RefType["UpdateFacilityReservationErrorCase"];
      } & { __typename: "UpdateFacilityReservationError" })
    | (Omit<UpdateFacilityReservationSuccess, "reservation"> & {
        reservation: _RefType["FacilityReservation"];
      } & { __typename: "UpdateFacilityReservationSuccess" });
  VerifyAccountLinkSessionPayload:
    | (Omit<VerifyAccountLinkSessionError, "case"> & {
        case: _RefType["VerifyAccountLinkSessionErrorCase"];
      } & { __typename: "VerifyAccountLinkSessionError" })
    | (VerifyAccountLinkSessionSuccess & {
        __typename: "VerifyAccountLinkSessionSuccess";
      });
  VerifyAddIdentityReauthPayload:
    | (Omit<VerifyAddIdentityReauthError, "case"> & {
        case: _RefType["VerifyAddIdentityReauthErrorCase"];
      } & { __typename: "VerifyAddIdentityReauthError" })
    | (VerifyAddIdentityReauthRedirect & {
        __typename: "VerifyAddIdentityReauthRedirect";
      });
  VerifyCheckInQrCodePayload:
    | (Omit<VerifyCheckInQrCodeError, "case"> & {
        case: _RefType["VerifyCheckInQrCodeErrorCase"];
      } & { __typename: "VerifyCheckInQrCodeError" })
    | (VerifyCheckInQrCodeSuccess & {
        __typename: "VerifyCheckInQrCodeSuccess";
      });
  VerifyNewEmailPayload:
    | (Omit<VerifyNewEmailError, "case"> & {
        case: _RefType["VerifyNewEmailErrorCase"];
      } & { __typename: "VerifyNewEmailError" })
    | (VerifyNewEmailSuccess & { __typename: "VerifyNewEmailSuccess" });
  ZendeskSyncUserResult:
    | (Success & { __typename: "Success" })
    | (Omit<ZendeskSyncUserError, "case"> & {
        case: _RefType["ZendeskSyncUserErrorCase"];
      } & { __typename: "ZendeskSyncUserError" });
  leaveOrganizationPayload:
    | (Omit<LeaveOrganizationError, "case"> & {
        case: _RefType["LeaveOrganizationErrorCase"];
      } & { __typename: "LeaveOrganizationError" })
    | (Success & { __typename: "Success" });
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AcceptAccommodationReservationError: ResolverTypeWrapper<
    Omit<AcceptAccommodationReservationError, "case"> & {
      case: ResolversTypes["AcceptAccommodationReservationErrorCase"];
    }
  >;
  AcceptAccommodationReservationErrorCase: ResolverTypeWrapper<
    | "UserAcceptCodeNotFound"
    | "NotAuthorized"
    | "OwnerOfStayGiftFromOwnersError"
  >;
  AcceptAccommodationReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["AcceptAccommodationReservationPayload"]
  >;
  AccessKeyType: ResolverTypeWrapper<"SiteCleaningStaff" | "SiteManager">;
  AccessRouteTransportIcon: ResolverTypeWrapper<
    "Train" | "Car" | "Bus" | "Plane" | "Ferry" | "Walk" | "Bicycle" | "Other"
  >;
  AccessibleReservationCalendarType: ResolverTypeWrapper<
    | "StandardPlan"
    | "TrialPlan"
    | "StaffPlan"
    | "CoOwnersPlan"
    | "FullOwnerPlan"
    | "BusinessPlan"
  >;
  Accommodation: ResolverTypeWrapper<AccommodationMapper>;
  ID: ResolverTypeWrapper<Scalars["ID"]["output"]>;
  AccommodationAccessKey: ResolverTypeWrapper<AccommodationAccessKeyMapper>;
  AccommodationAvailability: ResolverTypeWrapper<AccommodationAvailabilityMapper>;
  AccommodationAvailabilityBlock: ResolverTypeWrapper<AccommodationAvailabilityBlockMapper>;
  AccommodationAvailabilityBlockCategory: ResolverTypeWrapper<
    | "CleaningSpecial"
    | "CleaningAdjustment"
    | "CleaningOther"
    | "MaintenanceInspection"
    | "MaintenanceConstruction"
    | "MaintenanceLandscape"
    | "MaintenanceOther"
    | "OpsTroubleWaiting"
    | "OpsTemporaryClose"
    | "OpsLastMinuteCancellation"
    | "OpsBeforeOpening"
    | "OpsOther"
    | "CustomerSupport"
    | "OtherShooting"
    | "ReservationForBusiness"
    | "ReservationForStaff"
    | "ReservationForStakeholder"
    | "ReservationForEvent"
    | "ReservationForEarlyCheckIn"
    | "OnlineTravelAgent"
    | "ReservationOther"
    | "AccommodationMaintenance"
    | "AccommodationSpecChange"
    | "BeforeFirstUse"
    | "LandscapeMaintenance"
    | "LastMinuteCancellation"
    | "PromotionalUse"
    | "SpecialCleaning"
    | "Trouble"
  >;
  AccommodationAvailabilityBlockCategoryInfo: ResolverTypeWrapper<
    Omit<AccommodationAvailabilityBlockCategoryInfo, "key"> & {
      key: ResolversTypes["AccommodationAvailabilityBlockCategory"];
    }
  >;
  AccommodationAvailabilityBlockReleaseSchedule: ResolverTypeWrapper<AccommodationAvailabilityBlockReleaseSchedule>;
  AccommodationClass: ResolverTypeWrapper<"E" | "F" | "G">;
  AccommodationClassRelation: ResolverTypeWrapper<"Higher" | "Same" | "Lower">;
  AccommodationContent: ResolverTypeWrapper<AccommodationContent>;
  AccommodationEquipment: ResolverTypeWrapper<AccommodationEquipmentMapper>;
  AccommodationEquipmentAttribute: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["AccommodationEquipmentAttribute"]
  >;
  AccommodationEquipmentStatusType: ResolverTypeWrapper<
    "Draft" | "Preview" | "PublishedForSanuStaff" | "Published"
  >;
  AccommodationEquipmentType: ResolverTypeWrapper<
    "Wifi" | "MusicConnect" | "Sauna"
  >;
  AccommodationFacility: ResolverTypeWrapper<AccommodationFacilityMapper>;
  AccommodationFacilityFilterType: ResolverTypeWrapper<"Include" | "Exclude">;
  AccommodationFacilityType: ResolverTypeWrapper<
    "DogFriendly" | "Workation" | "Sauna" | "Onsen" | "EVCharger" | "DogRun"
  >;
  AccommodationFee: ResolverTypeWrapper<AccommodationFeeMapper>;
  AccommodationFeeApplicability: ResolverTypeWrapper<AccommodationFeeApplicability>;
  AccommodationFeeDiscount: ResolverTypeWrapper<
    Omit<AccommodationFeeDiscount, "feeModifierType" | "ruleType"> & {
      feeModifierType: ResolversTypes["FeeModifierType"];
      ruleType: ResolversTypes["AccommodationFeeRuleType"];
    }
  >;
  AccommodationFeeInput: AccommodationFeeInput;
  AccommodationFeeItem: ResolverTypeWrapper<AccommodationFeeItemMapper>;
  Float: ResolverTypeWrapper<Scalars["Float"]["output"]>;
  AccommodationFeeItemInput: AccommodationFeeItemInput;
  AccommodationFeeItemPerType: ResolverTypeWrapper<"PerNight" | "PerStay">;
  AccommodationFeeRule: ResolverTypeWrapper<
    Omit<AccommodationFeeRule, "feeModifierType" | "ruleType"> & {
      feeModifierType: ResolversTypes["FeeModifierType"];
      ruleType: ResolversTypes["AccommodationFeeRuleType"];
    }
  >;
  AccommodationFeeRuleInput: AccommodationFeeRuleInput;
  AccommodationFeeRuleType: ResolverTypeWrapper<
    "ConsecutiveNightDiscount" | "FreeNight" | "NightFeeModifier"
  >;
  AccommodationFeeStatus: ResolverTypeWrapper<
    | "Draft"
    | "Open"
    | "InvoiceOpen"
    | "InvoicePaid"
    | "InvoiceRequiresAction"
    | "InvoicePaymentFailed"
    | "Unknown"
  >;
  AccommodationNotice: ResolverTypeWrapper<AccommodationNoticeMapper>;
  AccommodationNoticeStatus: ResolverTypeWrapper<
    "Active" | "Draft" | "Unpublished"
  >;
  AccommodationOperationGroup: ResolverTypeWrapper<AccommodationOperationGroupMapper>;
  AccommodationOperationGroupSetting: ResolverTypeWrapper<
    Omit<AccommodationOperationGroupSetting, "class" | "operationType"> & {
      class: ResolversTypes["AccommodationClass"];
      operationType: ResolversTypes["AccommodationOperationType"];
    }
  >;
  AccommodationOperationType: ResolverTypeWrapper<
    "CoOwners" | "FullOwner" | "Open"
  >;
  AccommodationReservation: ResolverTypeWrapper<AccommodationReservationMapper>;
  AccommodationReservationAdditionalKeySet: ResolverTypeWrapper<AccommodationReservationAdditionalKeySetMapper>;
  AccommodationReservationChange: ResolverTypeWrapper<AccommodationReservationChange>;
  AccommodationReservationCheckOutAvailabilitiesInput: AccommodationReservationCheckOutAvailabilitiesInput;
  AccommodationReservationCheckOutAvailabilitiesPayload: ResolverTypeWrapper<
    Omit<AccommodationReservationCheckOutAvailabilitiesPayload, "items"> & {
      items: Array<ResolversTypes["AccommodationReservationCheckOutItem"]>;
    }
  >;
  AccommodationReservationCheckOutItem: ResolverTypeWrapper<AccommodationReservationCheckOutItemMapper>;
  AccommodationReservationDetail: ResolverTypeWrapper<AccommodationReservationDetailMapper>;
  AccommodationReservationDetailInput: AccommodationReservationDetailInput;
  AccommodationReservationMutationScope: ResolverTypeWrapper<
    "NoLimit" | "OnlyExit" | "Freezed"
  >;
  AccommodationReservationOptions: ResolverTypeWrapper<AccommodationReservationOptionsMapper>;
  AccommodationReservationOtaDetail: ResolverTypeWrapper<AccommodationReservationOtaDetail>;
  AccommodationReservationProvider: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["AccommodationReservationProvider"]
  >;
  AccommodationReservationProviderInput: AccommodationReservationProviderInput;
  AccommodationReservationProviderSanuIncUsage: ResolverTypeWrapper<
    | "PromotionStay"
    | "StakeholderStay"
    | "EmployeeOperationalStay"
    | "SanuStay"
    | "CleaningBlock"
    | "CleaningInternalUse"
    | "InvoicePaymentStay"
    | "TroubleStay"
    | "OneMoreCabinManual"
    | "RetreatPlan"
    | "OnlineTravelAgent"
    | "PromotionalStay"
    | "TroubleCoverStay"
    | "BusinessStay"
    | "BeforeOpeningStay"
    | "OtherStay"
  >;
  AccommodationReservationProviderType: ResolverTypeWrapper<
    | "StandardPlan"
    | "TrialPlan"
    | "StaffPlan"
    | "CoOwnersPlan"
    | "FullOwnerPlan"
    | "BusinessPlan"
    | "StayTicket"
    | "StayDirect"
    | "OneMoreCabin"
    | "SanuInc"
    | "OnlineTravelAgent"
  >;
  AccommodationReservationStayStatus: ResolverTypeWrapper<
    "Tentative" | "WillStay" | "Staying" | "Stayed" | "StayCanceled" | "NoStay"
  >;
  AccommodationScope: AccommodationScope;
  AccountLinkIdentity: ResolverTypeWrapper<AccountLinkIdentity>;
  AccountLinkPlatform: ResolverTypeWrapper<"Web" | "Native">;
  AcquireStayTicketsError: ResolverTypeWrapper<
    Omit<AcquireStayTicketsError, "case"> & {
      case: ResolversTypes["AcquireStayTicketsErrorCase"];
    }
  >;
  AcquireStayTicketsErrorCase: ResolverTypeWrapper<
    "InvalidRequest" | "NotAuthorized" | "PaymentFailed"
  >;
  AcquireStayTicketsInput: AcquireStayTicketsInput;
  AcquireStayTicketsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["AcquireStayTicketsPayload"]
  >;
  AcquireStayTicketsResult: ResolverTypeWrapper<
    Omit<AcquireStayTicketsResult, "tickets"> & {
      tickets: Array<ResolversTypes["StayTicket"]>;
    }
  >;
  ActivateMemberPerksDrinkTicketError: ResolverTypeWrapper<
    Omit<ActivateMemberPerksDrinkTicketError, "case"> & {
      case: ResolversTypes["ActivateMemberPerksDrinkTicketErrorCase"];
    }
  >;
  ActivateMemberPerksDrinkTicketErrorCase: ResolverTypeWrapper<
    "IsNotEligible" | "HasAlreadyActivated"
  >;
  ActivateMemberPerksDrinkTicketPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["ActivateMemberPerksDrinkTicketPayload"]
  >;
  AdHocQuestionnaireAnswerInput: AdHocQuestionnaireAnswerInput;
  AdHocQuestionnaireAnswerValueInput: AdHocQuestionnaireAnswerValueInput;
  AdHocQuestionnaireMultipleSelectInput: AdHocQuestionnaireMultipleSelectInput;
  AdHocQuestionnaireResponse: ResolverTypeWrapper<AdHocQuestionnaireResponseMapper>;
  AdditionalGuestFeePolicy: ResolverTypeWrapper<AdditionalGuestFeePolicyMapper>;
  AdditionalNoticeType: ResolverTypeWrapper<"Transfer" | "Refund">;
  Address: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>["Address"]>;
  AddressInJapan: ResolverTypeWrapper<AddressInJapan>;
  AddressInJapanInput: AddressInJapanInput;
  AddressInternational: ResolverTypeWrapper<
    Omit<AddressInternational, "country"> & {
      country: ResolversTypes["CountryEnum"];
    }
  >;
  AddressInternationalInput: AddressInternationalInput;
  AdminRole: ResolverTypeWrapper<
    | "SuperAdmin"
    | "Admin"
    | "RoleAdmin"
    | "OpsSupport"
    | "PartnerSiteOperator"
    | "PartnerSiteManager"
    | "PartnerSiteStaff"
  >;
  AdminRoleAssignment: ResolverTypeWrapper<AdminRoleAssignmentMapper>;
  AgreeToTermsError: ResolverTypeWrapper<
    Omit<AgreeToTermsError, "case"> & {
      case: ResolversTypes["AgreeToTermsErrorCase"];
    }
  >;
  AgreeToTermsErrorCase: ResolverTypeWrapper<"NotFound">;
  AgreeToTermsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["AgreeToTermsPayload"]
  >;
  AgreeToWeekdayTermsError: ResolverTypeWrapper<
    Omit<AgreeToWeekdayTermsError, "case"> & {
      case: ResolversTypes["AgreeToWeekdayTermsErrorCase"];
    }
  >;
  AgreeToWeekdayTermsErrorCase: ResolverTypeWrapper<
    "NotSubscribed" | "AlreadyAgreed"
  >;
  AgreeToWeekdayTermsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["AgreeToWeekdayTermsPayload"]
  >;
  ApplyToTrialSubscriptionError: ResolverTypeWrapper<
    Omit<ApplyToTrialSubscriptionError, "case"> & {
      case: ResolversTypes["ApplyToTrialSubscriptionErrorCase"];
    }
  >;
  ApplyToTrialSubscriptionErrorCase: ResolverTypeWrapper<
    | "InvalidOperation"
    | "InvalidEnrollmentMonth"
    | "DuplicationError"
    | "PaymentError"
  >;
  ApplyToTrialSubscriptionPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["ApplyToTrialSubscriptionPayload"]
  >;
  ApplyToWeekdaySubscriptionError: ResolverTypeWrapper<
    Omit<ApplyToWeekdaySubscriptionError, "case"> & {
      case: ResolversTypes["ApplyToWeekdaySubscriptionErrorCase"];
    }
  >;
  ApplyToWeekdaySubscriptionErrorCase: ResolverTypeWrapper<
    | "InvalidOperation"
    | "InvalidStartDate"
    | "DuplicationError"
    | "PaymentError"
    | "InvalidPromotionCode"
  >;
  ApplyToWeekdaySubscriptionPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["ApplyToWeekdaySubscriptionPayload"]
  >;
  ArchitectureType: ResolverTypeWrapper<ArchitectureTypeMapper>;
  ArchitectureTypeSeries: ResolverTypeWrapper<"Original" | "Selection">;
  ArchitectureTypeSize: ResolverTypeWrapper<"Small" | "Medium" | "Large">;
  ArchiveArticle: ResolverTypeWrapper<ArchiveArticle>;
  Area: ResolverTypeWrapper<AreaMapper>;
  AreaContent: ResolverTypeWrapper<AreaContentMapper>;
  AreaGuideArticle: ResolverTypeWrapper<AreaGuideArticleMapper>;
  AreaGuideSpot: ResolverTypeWrapper<AreaGuideSpotMapper>;
  AreaGuideSpotCategory: ResolverTypeWrapper<
    "FoodStore" | "CafeRestaurant" | "NatureSpot" | "Events" | "Others" | "Shop"
  >;
  Auth0User: ResolverTypeWrapper<Auth0UserMapper>;
  BaseAccommodationFeeMode: ResolverTypeWrapper<"Policy" | "Daily">;
  BaseAccommodationFeePolicy: ResolverTypeWrapper<BaseAccommodationFeePolicy>;
  Beds24Booking: Beds24Booking;
  Beds24BookingDetail: ResolverTypeWrapper<Beds24BookingDetail>;
  Beds24BookingEvent: Beds24BookingEvent;
  Beds24BookingFee: ResolverTypeWrapper<Beds24BookingFee>;
  Beds24BookingGroup: Beds24BookingGroup;
  Beds24BookingMessageError: ResolverTypeWrapper<
    Omit<Beds24BookingMessageError, "case"> & {
      case: ResolversTypes["Beds24BookingMessageErrorCase"];
    }
  >;
  Beds24BookingMessageErrorCase: ResolverTypeWrapper<
    "InvalidEmail" | "GeneralError"
  >;
  Beds24BookingMessageKind: ResolverTypeWrapper<
    | "TentativeReservationCreated"
    | "ReservationReminderBefore2Day"
    | "ReservationReminderToday"
  >;
  Beds24BookingMessageResult: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["Beds24BookingMessageResult"]
  >;
  Beds24BookingMessageResultPayload: ResolverTypeWrapper<
    Omit<Beds24BookingMessageResultPayload, "result"> & {
      result: ResolversTypes["Beds24BookingMessageResult"];
    }
  >;
  Beds24InfoItem: Beds24InfoItem;
  Beds24InvoiceItem: Beds24InvoiceItem;
  Beds24Message: Beds24Message;
  Beds24SyncFollowingReservationsResultPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["Beds24SyncFollowingReservationsResultPayload"]
  >;
  Beds24WebhookError: ResolverTypeWrapper<
    Omit<Beds24WebhookError, "case"> & {
      case: ResolversTypes["Beds24WebhookErrorCase"];
    }
  >;
  Beds24WebhookErrorCase: ResolverTypeWrapper<
    | "BookingStatusNotSupported"
    | "ReservationNotFound"
    | "UnsupportedProvider"
    | "GeneralError"
  >;
  Beds24WebhookResult: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["Beds24WebhookResult"]
  >;
  Beds24WebhookResultPayload: ResolverTypeWrapper<
    Omit<Beds24WebhookResultPayload, "reservation" | "result"> & {
      reservation?: Maybe<ResolversTypes["AccommodationReservation"]>;
      result: ResolversTypes["Beds24WebhookResult"];
    }
  >;
  Beds24WebhookSuccess: ResolverTypeWrapper<
    Omit<Beds24WebhookSuccess, "case"> & {
      case: ResolversTypes["Beds24WebhookSuccessCase"];
    }
  >;
  Beds24WebhookSuccessCase: ResolverTypeWrapper<
    | "BookingNotAssigned"
    | "ReservationCreated"
    | "ReservationChanged"
    | "ReservationCanceled"
    | "ReservationDetailUpdated"
    | "ProcessingSkipped"
  >;
  BillingMethod: ResolverTypeWrapper<"AutoCharge" | "Manual">;
  BulkCreateOrganizationYearlyContractInvoicesInput: BulkCreateOrganizationYearlyContractInvoicesInput;
  BundleStayTicketsPayload: ResolverTypeWrapper<
    Omit<
      BundleStayTicketsPayload,
      "stayTicketUnit" | "stayTicketsValidationResult"
    > & {
      stayTicketUnit?: Maybe<ResolversTypes["StayTicketUnit"]>;
      stayTicketsValidationResult: Array<
        ResolversTypes["StayTicketValidationResult"]
      >;
    }
  >;
  BusinessPlan: ResolverTypeWrapper<BusinessPlan>;
  BusinessPlanAccommodationReservationProvider: ResolverTypeWrapper<BusinessPlanAccommodationReservationProvider>;
  CancelAccommodationReservationError: ResolverTypeWrapper<
    Omit<CancelAccommodationReservationError, "case"> & {
      case: ResolversTypes["CancelAccommodationReservationErrorCase"];
    }
  >;
  CancelAccommodationReservationErrorCase: ResolverTypeWrapper<
    | "CancelRuleError"
    | "NotAuthorized"
    | "CancelPaymentFailed"
    | "CancelTemporarilyUnavailable"
    | "HasActiveFacilityReservation"
  >;
  CancelAccommodationReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CancelAccommodationReservationPayload"]
  >;
  CancelCoOwnersApplicationError: ResolverTypeWrapper<
    Omit<CancelCoOwnersApplicationError, "case"> & {
      case: ResolversTypes["CancelCoOwnersApplicationErrorCase"];
    }
  >;
  CancelCoOwnersApplicationErrorCase: ResolverTypeWrapper<
    | "NotFound"
    | "PermissionDenied"
    | "StripeRefundError"
    | "AlreadyCancelled"
    | "CannotCancelAfterHandover"
  >;
  CancelCoOwnersApplicationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CancelCoOwnersApplicationPayload"]
  >;
  CancelFacilityReservationError: ResolverTypeWrapper<
    Omit<CancelFacilityReservationError, "case"> & {
      case: ResolversTypes["CancelFacilityReservationErrorCase"];
    }
  >;
  CancelFacilityReservationErrorCase: ResolverTypeWrapper<
    | "ReservationNotFound"
    | "AlreadyCanceled"
    | "NotCancelable"
    | "NotAuthorized"
    | "PastReserveDeadline"
  >;
  CancelFacilityReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CancelFacilityReservationPayload"]
  >;
  CancelFeeFixedPolicy: ResolverTypeWrapper<CancelFeeFixedPolicy>;
  CancelFeeFixedPolicyInput: CancelFeeFixedPolicyInput;
  CancelFeePolicy: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CancelFeePolicy"]
  >;
  CancelFeeRatePolicy: ResolverTypeWrapper<CancelFeeRatePolicy>;
  CancelFeeRatePolicyInput: CancelFeeRatePolicyInput;
  CancelStandardSubscriptionApplicationError: ResolverTypeWrapper<
    Omit<CancelStandardSubscriptionApplicationError, "case"> & {
      case: ResolversTypes["CancelStandardSubscriptionApplicationErrorCase"];
    }
  >;
  CancelStandardSubscriptionApplicationErrorCase: ResolverTypeWrapper<
    | "InvalidOperation"
    | "ReservationExists"
    | "NoSubscriptionScheduleError"
    | "StripeError"
    | "UnknownError"
  >;
  CancelStandardSubscriptionApplicationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CancelStandardSubscriptionApplicationPayload"]
  >;
  CancelStandardSubscriptionPauseError: ResolverTypeWrapper<
    Omit<CancelStandardSubscriptionPauseError, "case"> & {
      case: ResolversTypes["CancelStandardSubscriptionPauseErrorCase"];
    }
  >;
  CancelStandardSubscriptionPauseErrorCase: ResolverTypeWrapper<
    | "InvalidOperation"
    | "NoSubscriptionError"
    | "NoSubscriptionScheduleError"
    | "SubscriptionScheduleInvalidTrigger"
    | "StripeError"
  >;
  CancelStandardSubscriptionPausePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CancelStandardSubscriptionPausePayload"]
  >;
  CancelStandardSubscriptionResumeError: ResolverTypeWrapper<
    Omit<CancelStandardSubscriptionResumeError, "case"> & {
      case: ResolversTypes["CancelStandardSubscriptionResumeErrorCase"];
    }
  >;
  CancelStandardSubscriptionResumeErrorCase: ResolverTypeWrapper<
    "InvalidOperation" | "GeneralError"
  >;
  CancelStandardSubscriptionResumePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CancelStandardSubscriptionResumePayload"]
  >;
  CancelStandardSubscriptionTerminationError: ResolverTypeWrapper<
    Omit<CancelStandardSubscriptionTerminationError, "case"> & {
      case: ResolversTypes["CancelStandardSubscriptionTerminationErrorCase"];
    }
  >;
  CancelStandardSubscriptionTerminationErrorCase: ResolverTypeWrapper<
    | "InvalidOperation"
    | "NoSubscriptionError"
    | "NotTerminating"
    | "StripeError"
  >;
  CancelStandardSubscriptionTerminationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CancelStandardSubscriptionTerminationPayload"]
  >;
  CancelStayGiftsError: ResolverTypeWrapper<
    Omit<CancelStayGiftsError, "case"> & {
      case: ResolversTypes["CancelStayGiftsErrorCase"];
    }
  >;
  CancelStayGiftsErrorCase: ResolverTypeWrapper<
    "NotAuthorized" | "NotFound" | "InvalidState"
  >;
  CancelStayGiftsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CancelStayGiftsPayload"]
  >;
  CancelStayGiftsResult: ResolverTypeWrapper<
    Omit<CancelStayGiftsResult, "cancelledTickets"> & {
      cancelledTickets: Array<ResolversTypes["StayTicket"]>;
    }
  >;
  CancelTrialSubscriptionError: ResolverTypeWrapper<
    Omit<CancelTrialSubscriptionError, "case"> & {
      case: ResolversTypes["CancelTrialSubscriptionErrorCase"];
    }
  >;
  CancelTrialSubscriptionErrorCase: ResolverTypeWrapper<
    | "ContractNotFound"
    | "InvalidOperation"
    | "ReservationExists"
    | "StripeError"
  >;
  CancelTrialSubscriptionPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CancelTrialSubscriptionPayload"]
  >;
  CancellationFeeTier: ResolverTypeWrapper<CancellationFeeTierMapper>;
  CancellationPolicyContent: ResolverTypeWrapper<CancellationPolicyContentMapper>;
  CancellationPolicySection: ResolverTypeWrapper<CancellationPolicySectionMapper>;
  ChangeAccommodationAvailabilityBlockInput: ChangeAccommodationAvailabilityBlockInput;
  ChangeAccommodationReservationError: ResolverTypeWrapper<
    Omit<ChangeAccommodationReservationError, "case"> & {
      case: ResolversTypes["ChangeAccommodationReservationErrorCase"];
    }
  >;
  ChangeAccommodationReservationErrorCase: ResolverTypeWrapper<
    | "ResourceUnavailable"
    | "ReservationOverlapError"
    | "MaxReservationsExceededError"
    | "MonthlyReservationLimitExceededError"
    | "InvalidReservationPeriodError"
    | "CycleDuplicationError"
    | "Next7DaysDuplicationError"
    | "OwnerStayCreditInsufficientError"
    | "TrialStayCreditInsufficientError"
    | "TrialContractSuspended"
    | "SubscriptionSuspended"
    | "UnpaidAccommodationFeeError"
    | "PeakDaysLimitExceededError"
    | "PeakDayOwnerOnlyError"
    | "SiteHighSeasonLimitExceededError"
    | "MaxNightsPerMonthExceededError"
    | "MaxNightsPerYearExceededError"
    | "StayTicketError"
    | "ChangePaymentFailed"
    | "MutationScopeError"
    | "HasConflictingFacilityReservation"
    | "TermsNotAgreedError"
    | "UnexpectedError"
  >;
  ChangeAccommodationReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["ChangeAccommodationReservationPayload"]
  >;
  CheckInAccommodationReservationError: ResolverTypeWrapper<
    Omit<CheckInAccommodationReservationError, "case"> & {
      case: ResolversTypes["CheckInAccommodationReservationErrorCase"];
    }
  >;
  CheckInAccommodationReservationErrorCase: ResolverTypeWrapper<
    | "CheckInRuleError"
    | "NoAccessCode"
    | "AuthenticationRequired"
    | "AlreadyCheckedIn"
  >;
  CheckInAccommodationReservationInput: CheckInAccommodationReservationInput;
  CheckInAccommodationReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CheckInAccommodationReservationPayload"]
  >;
  CheckInAuthenticationType: ResolverTypeWrapper<"NotRequired" | "QrCode">;
  CheckInQrCode: ResolverTypeWrapper<
    Omit<CheckInQrCode, "status"> & {
      status: ResolversTypes["CheckInQrCodeStatus"];
    }
  >;
  CheckInQrCodeStatus: ResolverTypeWrapper<"Pending" | "Verified" | "Failed">;
  CheckOutAccommodationReservationError: ResolverTypeWrapper<
    Omit<CheckOutAccommodationReservationError, "case"> & {
      case: ResolversTypes["CheckOutAccommodationReservationErrorCase"];
    }
  >;
  CheckOutAccommodationReservationErrorCase: ResolverTypeWrapper<
    | "CheckOutRuleError"
    | "NotAuthorized"
    | "AlreadyCheckedOut"
    | "QuestionnaireNotFound"
    | "ValidationError"
  >;
  CheckOutAccommodationReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CheckOutAccommodationReservationPayload"]
  >;
  CoOwnerPeakDaysRatio: ResolverTypeWrapper<"OneHalf" | "TwoThirds">;
  CoOwnersApplicantInfo: ResolverTypeWrapper<CoOwnersApplicantInfoMapper>;
  CoOwnersApplicantInfoDetail: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CoOwnersApplicantInfoDetail"]
  >;
  CoOwnersApplicantInfoDetailIndividual: ResolverTypeWrapper<CoOwnersApplicantInfoDetailIndividualMapper>;
  CoOwnersApplicantInfoDetailOrganization: ResolverTypeWrapper<CoOwnersApplicantInfoDetailOrganizationMapper>;
  CoOwnersApplication: ResolverTypeWrapper<CoOwnersApplicationMapper>;
  CoOwnersApplicationDetailInput: CoOwnersApplicationDetailInput;
  CoOwnersApplicationDetails: CoOwnersApplicationDetails;
  CoOwnersApplicationEvents: ResolverTypeWrapper<CoOwnersApplicationEventsMapper>;
  CoOwnersApplicationFile: ResolverTypeWrapper<CoOwnersApplicationFileMapper>;
  CoOwnersApplicationIndividualInput: CoOwnersApplicationIndividualInput;
  CoOwnersApplicationInfoInput: CoOwnersApplicationInfoInput;
  CoOwnersApplicationInput: CoOwnersApplicationInput;
  CoOwnersApplicationOrganizationInput: CoOwnersApplicationOrganizationInput;
  CoOwnersApplicationOwnerInfoInput: CoOwnersApplicationOwnerInfoInput;
  CoOwnersApplicationStatus: ResolverTypeWrapper<
    | "InReview"
    | "Approved"
    | "Rejected"
    | "AwaitingApplicationPayment"
    | "Completed"
    | "InvitedToDisclosure"
    | "ParticipatedInDisclosure"
    | "ContractSigned"
    | "AdvancePaymentReceived"
    | "PaymentReceived"
    | "HandoverCompleted"
    | "Cancelled"
    | "Void"
    | "PlannedForSale"
    | "Sold"
  >;
  CoOwnersApplicationStatusInput: CoOwnersApplicationStatusInput;
  CoOwnersBakurakuInvoiceAnnualPaymentItem: ResolverTypeWrapper<CoOwnersBakurakuInvoiceAnnualPaymentItemMapper>;
  CoOwnersBakurakuInvoiceRecipient: ResolverTypeWrapper<CoOwnersBakurakuInvoiceRecipientMapper>;
  CoOwnersBakurakuInvoiceRegistrationFeeItem: ResolverTypeWrapper<CoOwnersBakurakuInvoiceRegistrationFeeItemMapper>;
  CoOwnersBakurakuInvoiceRemainingPaymentItem: ResolverTypeWrapper<CoOwnersBakurakuInvoiceRemainingPaymentItemMapper>;
  CoOwnersPlanAccommodationReservationProvider: ResolverTypeWrapper<CoOwnersPlanAccommodationReservationProvider>;
  CoOwnersPlanOffering: ResolverTypeWrapper<CoOwnersPlanOfferingMapper>;
  CoOwnersUnitSale: ResolverTypeWrapper<CoOwnersUnitSaleMapper>;
  CoOwnersWebinarSchedule: ResolverTypeWrapper<CoOwnersWebinarScheduleMapper>;
  CoWorkingSpaceDoorLock: ResolverTypeWrapper<CoWorkingSpaceDoorLock>;
  CoWorkingSpaceKey: ResolverTypeWrapper<CoWorkingSpaceKeyMapper>;
  CompleteAddIdentityError: ResolverTypeWrapper<
    Omit<CompleteAddIdentityError, "case"> & {
      case: ResolversTypes["CompleteAddIdentityErrorCase"];
    }
  >;
  CompleteAddIdentityErrorCase: ResolverTypeWrapper<
    | "InvalidIntentToken"
    | "TokenExchangeFailed"
    | "AlreadyLinkedToAnotherAccount"
  >;
  CompleteAddIdentityInput: CompleteAddIdentityInput;
  CompleteAddIdentityPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CompleteAddIdentityPayload"]
  >;
  CompleteAddIdentitySuccess: ResolverTypeWrapper<CompleteAddIdentitySuccess>;
  ConfirmTentativeAccommodationReservationError: ResolverTypeWrapper<
    Omit<ConfirmTentativeAccommodationReservationError, "case"> & {
      case: ResolversTypes["ConfirmTentativeAccommodationReservationErrorCase"];
    }
  >;
  ConfirmTentativeAccommodationReservationErrorCase: ResolverTypeWrapper<
    | "TentativeDeadlineExceeded"
    | "NotAuthorized"
    | "InvalidStatus"
    | "GeneralError"
  >;
  ConfirmTentativeAccommodationReservationInput: ConfirmTentativeAccommodationReservationInput;
  ConfirmTentativeAccommodationReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["ConfirmTentativeAccommodationReservationPayload"]
  >;
  ConsumedSuppliesFee: ResolverTypeWrapper<
    Omit<ConsumedSuppliesFee, "items"> & {
      items: Array<ResolversTypes["ConsumedSuppliesFeeItem"]>;
    }
  >;
  ConsumedSuppliesFeeItem: ResolverTypeWrapper<ConsumedSuppliesFeeItemMapper>;
  ConsumedSuppliesFeeItemInput: ConsumedSuppliesFeeItemInput;
  ConsumedSupplyFeeItemWaiver: ResolverTypeWrapper<ConsumedSupplyFeeItemWaiverMapper>;
  ConsumedSupplyFeeItemWaiverInput: ConsumedSupplyFeeItemWaiverInput;
  ConsumedSupplyFeeItemWaiverType: ResolverTypeWrapper<
    "HighestUnitPrice" | "BySupplyItemMasterCategory"
  >;
  ConsumptionTaxRateType: ResolverTypeWrapper<"Standard" | "Reduced">;
  ContentArchitect: ResolverTypeWrapper<ContentArchitectMapper>;
  ContentArchitecturalFeature: ResolverTypeWrapper<ContentArchitecturalFeatureMapper>;
  ContentArchitecturalFeatureUsageRule: ResolverTypeWrapper<ContentArchitecturalFeatureUsageRuleMapper>;
  ContentArchitecturePageNavigation: ResolverTypeWrapper<
    Omit<
      ContentArchitecturePageNavigation,
      "feature" | "originalSeries" | "selectionSeries"
    > & {
      feature: Array<ResolversTypes["ContentArchitecturePageNavigationItem"]>;
      originalSeries: Array<
        ResolversTypes["ContentArchitecturePageNavigationItem"]
      >;
      selectionSeries: Array<
        ResolversTypes["ContentArchitecturePageNavigationItem"]
      >;
    }
  >;
  ContentArchitecturePageNavigationItem: ResolverTypeWrapper<
    Omit<ContentArchitecturePageNavigationItem, "thumbnail"> & {
      thumbnail: ResolversTypes["UploadedFile"];
    }
  >;
  ContentArchitecturePageNavigationSubItem: ResolverTypeWrapper<ContentArchitecturePageNavigationSubItem>;
  ContentArchitectureType: ResolverTypeWrapper<ContentArchitectureTypeMapper>;
  ContentArchitectureTypeBasicAmenity: ResolverTypeWrapper<ContentArchitectureTypeBasicAmenityMapper>;
  ContentArchitectureTypeExperience: ResolverTypeWrapper<
    Omit<ContentArchitectureTypeExperience, "imageUrl"> & {
      imageUrl: ResolversTypes["UploadedFile"];
    }
  >;
  ContentArchitectureTypeFeature: ResolverTypeWrapper<
    Omit<
      ContentArchitectureTypeFeature,
      "facilityDetails" | "imageUrls" | "sitesByArchitectureType" | "usageRule"
    > & {
      facilityDetails: ResolversTypes["ContentFacilityDetails"];
      imageUrls: Array<ResolversTypes["UploadedFile"]>;
      sitesByArchitectureType: Array<
        ResolversTypes["ContentArchitectureTypeFeatureSite"]
      >;
      usageRule?: Maybe<
        ResolversTypes["ContentArchitectureTypeFeatureUsageRule"]
      >;
    }
  >;
  ContentArchitectureTypeFeatureSite: ResolverTypeWrapper<
    Omit<ContentArchitectureTypeFeatureSite, "sites"> & {
      sites: Array<ResolversTypes["ContentArchitectureTypeVariantSite"]>;
    }
  >;
  ContentArchitectureTypeFeatureUsageRule: ResolverTypeWrapper<
    Omit<ContentArchitectureTypeFeatureUsageRule, "ruleItems"> & {
      ruleItems: Array<
        ResolversTypes["ContentArchitectureTypeFeatureUsageRuleItem"]
      >;
    }
  >;
  ContentArchitectureTypeFeatureUsageRuleItem: ResolverTypeWrapper<
    Omit<ContentArchitectureTypeFeatureUsageRuleItem, "imageUrl"> & {
      imageUrl?: Maybe<ResolversTypes["UploadedFile"]>;
    }
  >;
  ContentArchitectureTypeSite: ResolverTypeWrapper<ContentArchitectureTypeSite>;
  ContentArchitectureTypeVariant: ResolverTypeWrapper<
    Omit<
      ContentArchitectureTypeVariant,
      | "accommodationFacilities"
      | "facilityDetails"
      | "imageUrls"
      | "kind"
      | "sites"
    > & {
      accommodationFacilities: Array<ResolversTypes["AccommodationFacility"]>;
      facilityDetails: ResolversTypes["ContentFacilityDetails"];
      imageUrls: Array<ResolversTypes["UploadedFile"]>;
      kind: ResolversTypes["ContentArchitectureTypeVariantKind"];
      sites: Array<ResolversTypes["ContentArchitectureTypeVariantSite"]>;
    }
  >;
  ContentArchitectureTypeVariantFacilityAmenity: ResolverTypeWrapper<ContentArchitectureTypeVariantFacilityAmenityMapper>;
  ContentArchitectureTypeVariantKind: ResolverTypeWrapper<
    "Variation" | "Option"
  >;
  ContentArchitectureTypeVariantSite: ResolverTypeWrapper<
    Omit<ContentArchitectureTypeVariantSite, "accommodations"> & {
      accommodations: Array<ResolversTypes["Accommodation"]>;
    }
  >;
  ContentFacilityAmenityReferenceCounts: ResolverTypeWrapper<ContentFacilityAmenityReferenceCounts>;
  ContentFacilityDetails: ResolverTypeWrapper<
    Omit<ContentFacilityDetails, "facilityAmenities"> & {
      facilityAmenities: Array<
        ResolversTypes["ContentArchitectureTypeVariantFacilityAmenity"]
      >;
    }
  >;
  ContentRoomType: ResolverTypeWrapper<ContentRoomTypeMapper>;
  ContractContinuationType: ResolverTypeWrapper<"Continue" | "Cancel">;
  ContractStatus: ResolverTypeWrapper<
    "Expired" | "Scheduled" | "Active" | "Invalidated"
  >;
  CountryEnum: ResolverTypeWrapper<
    | "JPN"
    | "KOR"
    | "CHN"
    | "TWN"
    | "HKG"
    | "GBR"
    | "USA"
    | "DEU"
    | "FRA"
    | "AFG"
    | "ALB"
    | "DZA"
    | "ASM"
    | "AND"
    | "AGO"
    | "AIA"
    | "ATA"
    | "ATG"
    | "ARG"
    | "ARM"
    | "ABW"
    | "AUS"
    | "AUT"
    | "AZE"
    | "BHS"
    | "BHR"
    | "BGD"
    | "BRB"
    | "BLR"
    | "BEL"
    | "BLZ"
    | "BEN"
    | "BMU"
    | "BTN"
    | "BOL"
    | "BIH"
    | "BWA"
    | "BRA"
    | "IOT"
    | "BRN"
    | "BGR"
    | "BFA"
    | "BDI"
    | "KHM"
    | "CMR"
    | "CAN"
    | "CPV"
    | "CYM"
    | "CAF"
    | "TCD"
    | "CHI"
    | "CHL"
    | "CXR"
    | "CCK"
    | "COL"
    | "COM"
    | "COG"
    | "COK"
    | "CRI"
    | "CIV"
    | "HRV"
    | "CUB"
    | "CYP"
    | "CZE"
    | "PRK"
    | "COD"
    | "DNK"
    | "DJI"
    | "DMA"
    | "DOM"
    | "SWZ"
    | "ECU"
    | "EGY"
    | "SLV"
    | "GNQ"
    | "ERI"
    | "EST"
    | "ETH"
    | "FLK"
    | "FRO"
    | "FJI"
    | "FIN"
    | "GUF"
    | "PYF"
    | "GAB"
    | "GMB"
    | "GEO"
    | "GHA"
    | "GIB"
    | "GRC"
    | "GRL"
    | "GRD"
    | "GLP"
    | "GUM"
    | "GTM"
    | "GIN"
    | "GNB"
    | "GUY"
    | "HTI"
    | "HND"
    | "HUN"
    | "ISL"
    | "IND"
    | "IDN"
    | "IRN"
    | "IRQ"
    | "IRL"
    | "IMN"
    | "ISR"
    | "ITA"
    | "JAM"
    | "JON"
    | "JOR"
    | "KSV"
    | "KAS"
    | "KAZ"
    | "KEN"
    | "KIR"
    | "KWT"
    | "KGZ"
    | "LAO"
    | "LVA"
    | "LBN"
    | "LSO"
    | "LBR"
    | "LBY"
    | "LIE"
    | "LTU"
    | "LUX"
    | "MAC"
    | "MDG"
    | "MWI"
    | "MYS"
    | "MDV"
    | "MLI"
    | "MLT"
    | "MHL"
    | "MTQ"
    | "MRT"
    | "MUS"
    | "MYT"
    | "MEX"
    | "FSM"
    | "MID"
    | "MDA"
    | "MCO"
    | "MNG"
    | "MNE"
    | "MSR"
    | "MAR"
    | "MOZ"
    | "MMR"
    | "MKD"
    | "NAM"
    | "NRU"
    | "NPL"
    | "NLD"
    | "ANT"
    | "NCL"
    | "NZL"
    | "NIC"
    | "NER"
    | "NGA"
    | "NIU"
    | "NFK"
    | "MNP"
    | "NOR"
    | "OMN"
    | "PAK"
    | "PLW"
    | "PSE"
    | "PAN"
    | "PNG"
    | "PRY"
    | "PER"
    | "PHL"
    | "PCN"
    | "POL"
    | "PRT"
    | "PRI"
    | "QAT"
    | "REU"
    | "ROU"
    | "RUS"
    | "RWA"
    | "SSD"
    | "SHN"
    | "KNA"
    | "LCA"
    | "SPM"
    | "VCT"
    | "WSM"
    | "SMR"
    | "STP"
    | "SAU"
    | "SEN"
    | "SRB"
    | "SYC"
    | "SLE"
    | "SGP"
    | "SVK"
    | "SVN"
    | "SLB"
    | "SOM"
    | "ZAF"
    | "ESP"
    | "LKA"
    | "SDN"
    | "SUR"
    | "SJM"
    | "SWE"
    | "CHE"
    | "SYR"
    | "TJK"
    | "TZA"
    | "THA"
    | "TLS"
    | "TGO"
    | "TKL"
    | "TON"
    | "TTO"
    | "TUN"
    | "TUR"
    | "TKM"
    | "TCA"
    | "TUV"
    | "UGA"
    | "UKR"
    | "ARE"
    | "URY"
    | "UZB"
    | "VUT"
    | "VAT"
    | "VEN"
    | "VNM"
    | "VGB"
    | "VIR"
    | "WAK"
    | "WLF"
    | "ESH"
    | "YEM"
    | "ZMB"
    | "ZWE"
    | "ZZZ"
  >;
  CreateAccommodationAvailabilityBlockInput: CreateAccommodationAvailabilityBlockInput;
  CreateAccommodationReservationError: ResolverTypeWrapper<
    Omit<CreateAccommodationReservationError, "case"> & {
      case: ResolversTypes["CreateAccommodationReservationErrorCase"];
    }
  >;
  CreateAccommodationReservationErrorCase: ResolverTypeWrapper<
    | "ResourceUnavailable"
    | "ReservationOverlapError"
    | "MaxReservationsExceededError"
    | "MonthlyReservationLimitExceededError"
    | "InvalidReservationPeriodError"
    | "CycleDuplicationError"
    | "Next7DaysDuplicationError"
    | "OwnerStayCreditInsufficientError"
    | "TrialStayCreditInsufficientError"
    | "TrialContractSuspended"
    | "SubscriptionSuspended"
    | "UnpaidAccommodationFeeError"
    | "PeakDaysLimitExceededError"
    | "PeakDayOwnerOnlyError"
    | "SiteHighSeasonLimitExceededError"
    | "MaxNightsPerMonthExceededError"
    | "MaxNightsPerYearExceededError"
    | "StayTicketError"
    | "OwnerOfStayGiftFromOwnersError"
    | "SanuIncStaffGroupIdRequiredError"
    | "WeekdayTermsNotAgreedError"
    | "TermsNotAgreedError"
    | "MonthlyNightLimitExceededError"
    | "UnexpectedError"
  >;
  CreateAccommodationReservationInput: CreateAccommodationReservationInput;
  CreateAccommodationReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CreateAccommodationReservationPayload"]
  >;
  CreateCoOwnersApplicationFileDownloadUrlError: ResolverTypeWrapper<
    Omit<CreateCoOwnersApplicationFileDownloadUrlError, "case"> & {
      case: ResolversTypes["CreateCoOwnersApplicationFileDownloadUrlErrorCase"];
    }
  >;
  CreateCoOwnersApplicationFileDownloadUrlErrorCase: ResolverTypeWrapper<"NotFound">;
  CreateCoOwnersApplicationFileDownloadUrlPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CreateCoOwnersApplicationFileDownloadUrlPayload"]
  >;
  CreateCoOwnersApplicationFileDownloadUrlSuccess: ResolverTypeWrapper<CreateCoOwnersApplicationFileDownloadUrlSuccess>;
  CreateCoOwnersApplicationFileUploadPolicyInput: CreateCoOwnersApplicationFileUploadPolicyInput;
  CreateFacilityReservationError: ResolverTypeWrapper<
    Omit<CreateFacilityReservationError, "case"> & {
      case: ResolversTypes["CreateFacilityReservationErrorCase"];
    }
  >;
  CreateFacilityReservationErrorCase: ResolverTypeWrapper<
    | "ResourceUnavailable"
    | "ServiceNotAvailable"
    | "InvalidStartDate"
    | "PastReserveDeadline"
    | "FeePolicyNotFound"
    | "NoAccommodationReservation"
    | "AccommodationReservationPeriodMismatch"
    | "InvalidFacilityFieldData"
    | "InvalidSlotSelection"
    | "ProviderNotEligible"
    | "TemporarilyUnavailable"
  >;
  CreateFacilityReservationInput: CreateFacilityReservationInput;
  CreateFacilityReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CreateFacilityReservationPayload"]
  >;
  CreateFacilityReservationSuccess: ResolverTypeWrapper<
    Omit<CreateFacilityReservationSuccess, "reservation"> & {
      reservation: ResolversTypes["FacilityReservation"];
    }
  >;
  CreateFileUploadPolicyError: ResolverTypeWrapper<
    Omit<CreateFileUploadPolicyError, "case"> & {
      case: ResolversTypes["CreateFileUploadPolicyErrorCase"];
    }
  >;
  CreateFileUploadPolicyErrorCase: ResolverTypeWrapper<
    "GeneralError" | "ResourceIdRequired" | "NotFound"
  >;
  CreateFileUploadPolicySuccess: ResolverTypeWrapper<CreateFileUploadPolicySuccess>;
  CreateFullOwnerContractUploadPolicyInput: CreateFullOwnerContractUploadPolicyInput;
  CreateOrUpdateBaseAccommodationFeePolicyInput: CreateOrUpdateBaseAccommodationFeePolicyInput;
  CreateOrUpdateBusinessPlanInput: CreateOrUpdateBusinessPlanInput;
  CreateOrUpdateCancelFeePolicyInput: CreateOrUpdateCancelFeePolicyInput;
  CreateOrUpdateOrganizationInput: CreateOrUpdateOrganizationInput;
  CreateOrUpdateOrganizationYearlyContractInput: CreateOrUpdateOrganizationYearlyContractInput;
  CreateOrUpdateOrganizationYearlyContractInvoiceInput: CreateOrUpdateOrganizationYearlyContractInvoiceInput;
  CreateOrUpdateStaffGroupInput: CreateOrUpdateStaffGroupInput;
  CreateOrUpdateUserAppInstallationError: ResolverTypeWrapper<
    Omit<CreateOrUpdateUserAppInstallationError, "case"> & {
      case: ResolversTypes["CreateOrUpdateUserAppInstallationErrorCase"];
    }
  >;
  CreateOrUpdateUserAppInstallationErrorCase: ResolverTypeWrapper<"GeneralError">;
  CreateOrUpdateUserAppInstallationInput: CreateOrUpdateUserAppInstallationInput;
  CreateOrUpdateUserAppInstallationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CreateOrUpdateUserAppInstallationPayload"]
  >;
  CreateSanuOwnerPlanFileUploadPolicyInput: CreateSanuOwnerPlanFileUploadPolicyInput;
  CreateSanuOwnerPlanUserFileUploadPolicyInput: CreateSanuOwnerPlanUserFileUploadPolicyInput;
  CreateStripeCardSetupIntentOfOrganizationPayload: ResolverTypeWrapper<CreateStripeCardSetupIntentOfOrganizationPayload>;
  CreateStripeCardSetupIntentOfViewerPayload: ResolverTypeWrapper<CreateStripeCardSetupIntentOfViewerPayload>;
  CreateUserFileUploadPolicyInput: CreateUserFileUploadPolicyInput;
  CreateWebviewSessionError: ResolverTypeWrapper<
    Omit<CreateWebviewSessionError, "case"> & {
      case: ResolversTypes["CreateWebviewSessionErrorCase"];
    }
  >;
  CreateWebviewSessionErrorCase: ResolverTypeWrapper<"Unauthorized">;
  CreateWebviewSessionInput: CreateWebviewSessionInput;
  CreateWebviewSessionPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["CreateWebviewSessionPayload"]
  >;
  CreateWebviewSessionSuccess: ResolverTypeWrapper<CreateWebviewSessionSuccess>;
  CronJobName: ResolverTypeWrapper<
    | "CancelExceededTentativeAccommodationReservations"
    | "SyncBubbleSupplyItemMasters"
    | "CreateCleaningTasks"
    | "AutoTransitionCoOwnersHandover"
    | "JobsAt0300Jst"
    | "CreateNextOrganizationYearlyContracts"
    | "ApplyGuestAccessKeys"
    | "SendCheckOutGuideMails"
    | "CheckGuestAccessKeys"
    | "OpenDraftInvoices"
    | "SendCheckInAndCheckOutTodayReminders"
    | "SyncBeds24FuturePrices"
    | "CheckOutExceededAccommodationReservations"
    | "ReleaseExpiredAccessKeys"
    | "CalculateAndOpenAccommodationFees"
    | "JobsAt1500Jst"
    | "DetermineEarlyCheckInEligibility"
    | "SendCleaningTasksDailyReminder"
    | "SendCoOwnersWebinarReminderMails"
    | "SendCoOwnersIdentityVerificationReminderMails"
    | "SendIchinomiyaNoticeMails"
    | "CloseSupplyReports"
    | "IssueInvoicesOfAccommodationFees"
    | "SendFacilityReservationUsageEndReminders"
    | "SmartPlugStatusUpdate"
    | "FetchModifiedBeds24Bookings"
    | "GrantStaffStayCredits"
    | "ScheduledReleaseReservationBlocks"
    | "RotateMonthlyStaffAccessKeys"
    | "RotateDailyStaffAccessKeys"
    | "SyncCoOwnersIdentityVerifications"
    | "FetchCoOwnersIdentityVerificationEvidence"
  >;
  DailyRateTarget: ResolverTypeWrapper<"SanuInc" | "OnlineTravelAgent">;
  DateTime: ResolverTypeWrapper<Scalars["DateTime"]["output"]>;
  Decimal: ResolverTypeWrapper<Scalars["Decimal"]["output"]>;
  DeleteUserAppInstallationError: ResolverTypeWrapper<
    Omit<DeleteUserAppInstallationError, "case"> & {
      case: ResolversTypes["DeleteUserAppInstallationErrorCase"];
    }
  >;
  DeleteUserAppInstallationErrorCase: ResolverTypeWrapper<
    "GeneralError" | "NotFound"
  >;
  DeleteUserAppInstallationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["DeleteUserAppInstallationPayload"]
  >;
  DeleteViewerError: ResolverTypeWrapper<
    Omit<DeleteViewerError, "case"> & {
      case: ResolversTypes["DeleteViewerErrorCase"];
    }
  >;
  DeleteViewerErrorCase: ResolverTypeWrapper<
    | "Auth0UserNotDeleted"
    | "PendingAccommodationReservations"
    | "PendingCoOwnersApplications"
    | "StripePaymentMethodNotDeleted"
    | "UserDataNotDeleted"
    | "UserOrganizationAdmin"
    | "UserOwnershipActive"
    | "UserSubscriptionActive"
  >;
  DeleteViewerPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["DeleteViewerPayload"]
  >;
  DisclosureAssistantType: ResolverTypeWrapper<
    "Representative" | "PersonInCharge"
  >;
  DogfriendlyAccommodationFacility: ResolverTypeWrapper<DogfriendlyAccommodationFacility>;
  DraftAccommodationReservation: ResolverTypeWrapper<DraftAccommodationReservationMapper>;
  DraftAccommodationReservationByStayTicketMasterInput: DraftAccommodationReservationByStayTicketMasterInput;
  DraftAccommodationReservationByStayTicketMasterResult: ResolverTypeWrapper<
    Omit<DraftAccommodationReservationByStayTicketMasterResult, "fee"> & {
      fee: ResolversTypes["AccommodationFee"];
    }
  >;
  DraftAccommodationReservationInput: DraftAccommodationReservationInput;
  DraftAccommodationReservationOptionsInput: DraftAccommodationReservationOptionsInput;
  EVChargerAccommodationFacility: ResolverTypeWrapper<EVChargerAccommodationFacility>;
  EarlyCheckInPriceSlot: ResolverTypeWrapper<EarlyCheckInPriceSlot>;
  EarlyCheckInStatus: ResolverTypeWrapper<"Hidden" | "Visible" | "Available">;
  EstimateStandardSubscriptionApplicationError: ResolverTypeWrapper<
    Omit<EstimateStandardSubscriptionApplicationError, "case"> & {
      case: ResolversTypes["EstimateStandardSubscriptionApplicationErrorCase"];
    }
  >;
  EstimateStandardSubscriptionApplicationErrorCase: ResolverTypeWrapper<
    "InvalidPromotionCode" | "HasPriorTransaction"
  >;
  EstimateStandardSubscriptionApplicationFeePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["EstimateStandardSubscriptionApplicationFeePayload"]
  >;
  EstimateStandardSubscriptionApplicationSuccess: ResolverTypeWrapper<EstimateStandardSubscriptionApplicationSuccess>;
  EstimatedCancelFeeOfAccommodationReservationError: ResolverTypeWrapper<
    Omit<EstimatedCancelFeeOfAccommodationReservationError, "case"> & {
      case: ResolversTypes["EstimatedCancelFeeOfAccommodationReservationErrorCase"];
    }
  >;
  EstimatedCancelFeeOfAccommodationReservationErrorCase: ResolverTypeWrapper<"GeneralError">;
  EstimatedCancelFeeOfAccommodationReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["EstimatedCancelFeeOfAccommodationReservationPayload"]
  >;
  EstimatedChangeFeeOfAccommodationReservationError: ResolverTypeWrapper<
    Omit<EstimatedChangeFeeOfAccommodationReservationError, "case"> & {
      case: ResolversTypes["EstimatedChangeFeeOfAccommodationReservationErrorCase"];
    }
  >;
  EstimatedChangeFeeOfAccommodationReservationErrorCase: ResolverTypeWrapper<"GeneralError">;
  EstimatedChangeFeeOfAccommodationReservationInput: EstimatedChangeFeeOfAccommodationReservationInput;
  EstimatedChangeFeeOfAccommodationReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["EstimatedChangeFeeOfAccommodationReservationPayload"]
  >;
  EstimatedChargeOfAccommodationReservation: ResolverTypeWrapper<
    Omit<EstimatedChargeOfAccommodationReservation, "items"> & {
      items: Array<
        ResolversTypes["EstimatedChargeOfAccommodationReservationItem"]
      >;
    }
  >;
  EstimatedChargeOfAccommodationReservationItem: ResolverTypeWrapper<
    Omit<EstimatedChargeOfAccommodationReservationItem, "chargeType"> & {
      chargeType: ResolversTypes["EstimatedChargeOfAccommodationReservationItemType"];
    }
  >;
  EstimatedChargeOfAccommodationReservationItemType: ResolverTypeWrapper<
    "Fee" | "OwnerStayCredit" | "TrialStayCredit" | "StaffStayCredit"
  >;
  EvChargerLock: ResolverTypeWrapper<EvChargerLock>;
  ExportStayGiftsPayload: ResolverTypeWrapper<
    Omit<ExportStayGiftsPayload, "tickets"> & {
      tickets: Array<ResolversTypes["StayGiftExportItem"]>;
    }
  >;
  Facility: ResolverTypeWrapper<FacilityMapper>;
  FacilityBaseFeePolicy: ResolverTypeWrapper<FacilityBaseFeePolicyMapper>;
  FacilityCancelFeePolicy: ResolverTypeWrapper<FacilityCancelFeePolicyMapper>;
  FacilityController: ResolverTypeWrapper<FacilityControllerMapper>;
  FacilityControllerAttribute: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["FacilityControllerAttribute"]
  >;
  FacilityCustomFieldItem: ResolverTypeWrapper<
    Omit<FacilityCustomFieldItem, "type"> & {
      type: ResolversTypes["FacilityFieldType"];
    }
  >;
  FacilityCustomFieldItemInput: FacilityCustomFieldItemInput;
  FacilityCustomFieldValue: ResolverTypeWrapper<FacilityCustomFieldValueMapper>;
  FacilityCustomFieldValueInput: FacilityCustomFieldValueInput;
  FacilityDiscountFeePolicy: ResolverTypeWrapper<
    Omit<FacilityDiscountFeePolicy, "discountModifierType"> & {
      discountModifierType: ResolversTypes["FeeModifierType"];
    }
  >;
  FacilityFee: ResolverTypeWrapper<
    Omit<FacilityFee, "items"> & {
      items: Array<ResolversTypes["FacilityFeeItem"]>;
    }
  >;
  FacilityFeeItem: ResolverTypeWrapper<FacilityFeeItemMapper>;
  FacilityFieldType: ResolverTypeWrapper<"Text" | "SingleSelect">;
  FacilityInvoiceLabelPart: ResolverTypeWrapper<
    Omit<FacilityInvoiceLabelPart, "format" | "type"> & {
      format?: Maybe<ResolversTypes["FacilityInvoiceLabelPeriodFormat"]>;
      type: ResolversTypes["FacilityInvoiceLabelPartType"];
    }
  >;
  FacilityInvoiceLabelPartInput: FacilityInvoiceLabelPartInput;
  FacilityInvoiceLabelPartType: ResolverTypeWrapper<"Text" | "ReservePeriod">;
  FacilityInvoiceLabelPeriodFormat: ResolverTypeWrapper<"Date" | "DateTime">;
  FacilityReservation: ResolverTypeWrapper<FacilityReservationMapper>;
  FacilityReservationCleaningReport: ResolverTypeWrapper<FacilityReservationCleaningReportMapper>;
  FacilityReservationCleaningStatus: ResolverTypeWrapper<
    "Pending" | "Completed"
  >;
  FacilityReservationDataSync: ResolverTypeWrapper<FacilityReservationDataSyncMapper>;
  FacilityReservationDataSyncStatus: ResolverTypeWrapper<"Pending" | "Synced">;
  FacilityReservationStatusType: ResolverTypeWrapper<"Reserved" | "Canceled">;
  FacilityResource: ResolverTypeWrapper<FacilityResourceMapper>;
  FacilityResourceBlock: ResolverTypeWrapper<FacilityResourceBlockMapper>;
  FacilityResourceBlockType: ResolverTypeWrapper<"Admin" | "User">;
  FacilityResourceControllerType: ResolverTypeWrapper<
    | "CoWorkingSpaceDoorLock"
    | "OnsenAndSaunaDoorLock"
    | "EvChargerLock"
    | "RentalCycleKeyBox"
    | "WashingMachineTracker"
  >;
  FacilitySlot: ResolverTypeWrapper<FacilitySlotMapper>;
  FacilitySlotAvailability: ResolverTypeWrapper<FacilitySlotAvailabilityMapper>;
  FacilitySlotUnavailableReason: ResolverTypeWrapper<
    | "Past"
    | "DeadlinePassed"
    | "OutsideOperatingHours"
    | "AlreadyReserved"
    | "Blocked"
  >;
  FacilityStatusType: ResolverTypeWrapper<"Draft" | "Preview" | "Published">;
  FacilityType: ResolverTypeWrapper<
    | "RentalCar"
    | "RentalCycle"
    | "Barbecue"
    | "OnsenAndSauna"
    | "EvCharger"
    | "CoWorkingSpace"
    | "WashingMachine"
  >;
  FacilityUnitType: ResolverTypeWrapper<"Night" | "Reservation" | "Slot">;
  FeeModifierType: ResolverTypeWrapper<"Percentage" | "Value">;
  FieldTierPermission: ResolverTypeWrapper<
    | "UsersPiiRead"
    | "UsersCommercialRead"
    | "UsersRestrictedRead"
    | "ReservationsKeysRead"
    | "AccommodationsKeysRead"
    | "StayTicketsPiiRead"
    | "CoOwnersRestrictedRead"
    | "AvailabilityBlocksCommercialRead"
  >;
  FileCopyTarget: ResolverTypeWrapper<
    | "userPicture"
    | "area"
    | "architectureType"
    | "banner"
    | "ownerPlan"
    | "ownerApplication"
  >;
  FileUploadPolicyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["FileUploadPolicyPayload"]
  >;
  FinalizeAccountLinkError: ResolverTypeWrapper<
    Omit<FinalizeAccountLinkError, "case"> & {
      case: ResolversTypes["FinalizeAccountLinkErrorCase"];
    }
  >;
  FinalizeAccountLinkErrorCase: ResolverTypeWrapper<
    "InvalidIntentToken" | "TokenExchangeFailed" | "IdentityMismatch"
  >;
  FinalizeAccountLinkInput: FinalizeAccountLinkInput;
  FinalizeAccountLinkPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["FinalizeAccountLinkPayload"]
  >;
  FinalizeAccountLinkSuccess: ResolverTypeWrapper<FinalizeAccountLinkSuccess>;
  FinancialAssetsBracketType: ResolverTypeWrapper<
    | "Below5Mil"
    | "From5MilTo10Mil"
    | "From10MilTo30Mil"
    | "From30MilTo50Mil"
    | "From50MilTo100Mil"
    | "From100MilTo300Mil"
    | "Above300Mil"
    | "DoNotKnowWillNotSay"
  >;
  FullOwnerPlanAccommodationReservationProvider: ResolverTypeWrapper<FullOwnerPlanAccommodationReservationProvider>;
  GenderType: ResolverTypeWrapper<"Male" | "Female" | "NoAnswer">;
  GenerateCheckInQrCodeError: ResolverTypeWrapper<
    Omit<GenerateCheckInQrCodeError, "case"> & {
      case: ResolversTypes["GenerateCheckInQrCodeErrorCase"];
    }
  >;
  GenerateCheckInQrCodeErrorCase: ResolverTypeWrapper<
    "ReservationNotFound" | "Unauthorized" | "QrCodeNotRequired"
  >;
  GenerateCheckInQrCodeInput: GenerateCheckInQrCodeInput;
  GenerateCheckInQrCodePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["GenerateCheckInQrCodePayload"]
  >;
  GenerateCheckInQrCodeSuccess: ResolverTypeWrapper<
    Omit<GenerateCheckInQrCodeSuccess, "checkInQrCode"> & {
      checkInQrCode: ResolversTypes["CheckInQrCode"];
    }
  >;
  GeoLocation: ResolverTypeWrapper<GeoLocation>;
  GeoLocationInput: GeoLocationInput;
  GuestAccessKeyTrigger: ResolverTypeWrapper<
    "CreateReserve" | "ChangeReserve" | "CancelReserve"
  >;
  GuestCountsInput: GuestCountsInput;
  HighSeasonPeriod: ResolverTypeWrapper<HighSeasonPeriodMapper>;
  HighSeasonType: ResolverTypeWrapper<
    "NewYear" | "GoldenWeek" | "Obon" | "SilverWeek"
  >;
  HubSpotSyncContactError: ResolverTypeWrapper<
    Omit<HubSpotSyncContactError, "case"> & {
      case: ResolversTypes["HubSpotSyncContactErrorCase"];
    }
  >;
  HubSpotSyncContactErrorCase: ResolverTypeWrapper<"UserNotFound">;
  HubSpotSyncContactResult: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["HubSpotSyncContactResult"]
  >;
  HubSpotSyncDealError: ResolverTypeWrapper<
    Omit<HubSpotSyncDealError, "case"> & {
      case: ResolversTypes["HubSpotSyncDealErrorCase"];
    }
  >;
  HubSpotSyncDealErrorCase: ResolverTypeWrapper<
    "ApplicationNotFound" | "DealNotFound"
  >;
  HubSpotSyncDealResult: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["HubSpotSyncDealResult"]
  >;
  IdentificationDocumentType: ResolverTypeWrapper<
    | "DriverLicense"
    | "MyNumberCard"
    | "Passport"
    | "ResidenceCard"
    | "BasicResidentRegisterCard"
    | "Undetermined"
  >;
  IdentityProvider: ResolverTypeWrapper<"EmailPassword" | "Google" | "Apple">;
  IdentityVerification: ResolverTypeWrapper<IdentityVerificationMapper>;
  IdentityVerificationMethod: ResolverTypeWrapper<
    "IcChipAndSelfie" | "RestrictedDeliveryMail" | "InPersonPhotoId"
  >;
  IdentityVerificationResult: ResolverTypeWrapper<"Approved" | "Denied">;
  IdentityVerificationStatus: ResolverTypeWrapper<
    | "NotStarted"
    | "Accepted"
    | "PlansSelected"
    | "DocumentSubmitted"
    | "InProgress"
    | "Verified"
  >;
  IncomeBracketType: ResolverTypeWrapper<
    | "Below5Mil"
    | "From5MilTo8Mil"
    | "From8MilTo10Mil"
    | "From10MilTo15Mil"
    | "From15MilTo20Mil"
    | "From20MilTo30Mil"
    | "Above30Mil"
    | "DoNotKnowWillNotSay"
  >;
  InitiateAccountLinkError: ResolverTypeWrapper<
    Omit<InitiateAccountLinkError, "case"> & {
      case: ResolversTypes["InitiateAccountLinkErrorCase"];
    }
  >;
  InitiateAccountLinkErrorCase: ResolverTypeWrapper<"InvalidSessionToken">;
  InitiateAccountLinkInput: InitiateAccountLinkInput;
  InitiateAccountLinkPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InitiateAccountLinkPayload"]
  >;
  InitiateAccountLinkSuccess: ResolverTypeWrapper<InitiateAccountLinkSuccess>;
  InitiateAddIdentityError: ResolverTypeWrapper<
    Omit<InitiateAddIdentityError, "case"> & {
      case: ResolversTypes["InitiateAddIdentityErrorCase"];
    }
  >;
  InitiateAddIdentityErrorCase: ResolverTypeWrapper<
    "AlreadyLinked" | "Unauthorized"
  >;
  InitiateAddIdentityInput: InitiateAddIdentityInput;
  InitiateAddIdentityPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InitiateAddIdentityPayload"]
  >;
  InitiateAddIdentitySuccess: ResolverTypeWrapper<InitiateAddIdentitySuccess>;
  Inspection: ResolverTypeWrapper<
    Omit<Inspection, "accommodation" | "reservation" | "status"> & {
      accommodation: ResolversTypes["Accommodation"];
      reservation?: Maybe<ResolversTypes["AccommodationReservation"]>;
      status: ResolversTypes["InspectionStatusType"];
    }
  >;
  InspectionReport: ResolverTypeWrapper<InspectionReportMapper>;
  InspectionReportType: ResolverTypeWrapper<"Supply" | "Violation">;
  InspectionStatusType: ResolverTypeWrapper<
    "NotStarted" | "Started" | "InspectionRequired" | "Inspected"
  >;
  InspectionSupplyItem: ResolverTypeWrapper<InspectionSupplyItemMapper>;
  InspectionViolationHandling: ResolverTypeWrapper<InspectionViolationHandlingMapper>;
  InspectionViolationHandlingStatus: ResolverTypeWrapper<
    "Pending" | "Assessed" | "Handled"
  >;
  InspectionViolationItem: ResolverTypeWrapper<InspectionViolationItemMapper>;
  InspectionViolationSeverity: ResolverTypeWrapper<
    "NotAssessed" | "High" | "Medium" | "Low"
  >;
  InternalAccommodationEquipmentError: ResolverTypeWrapper<
    Omit<InternalAccommodationEquipmentError, "case"> & {
      case: ResolversTypes["InternalAccommodationEquipmentErrorCase"];
    }
  >;
  InternalAccommodationEquipmentErrorCase: ResolverTypeWrapper<
    | "AccommodationNotFound"
    | "EquipmentNotFound"
    | "DuplicateEquipmentType"
    | "AttributeTypeMismatch"
    | "SanuEdgeDeviceNotFound"
  >;
  InternalAddLocalTaxPolicyError: ResolverTypeWrapper<
    Omit<InternalAddLocalTaxPolicyError, "case"> & {
      case: ResolversTypes["InternalAddLocalTaxPolicyErrorCase"];
    }
  >;
  InternalAddLocalTaxPolicyErrorCase: ResolverTypeWrapper<"OverlappingEffectivePeriod">;
  InternalAddLocalTaxPolicyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalAddLocalTaxPolicyPayload"]
  >;
  InternalAddLocalTaxPolicyTargetInput: InternalAddLocalTaxPolicyTargetInput;
  InternalAdjustOwnerStayCreditError: ResolverTypeWrapper<
    Omit<InternalAdjustOwnerStayCreditError, "case"> & {
      case: ResolversTypes["InternalAdjustOwnerStayCreditErrorCase"];
    }
  >;
  InternalAdjustOwnerStayCreditErrorCase: ResolverTypeWrapper<
    "OwnershipNotFound" | "InvalidAmount" | "InsufficientBalance"
  >;
  InternalAdjustOwnerStayCreditPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalAdjustOwnerStayCreditPayload"]
  >;
  InternalAdjustStaffCreditsError: ResolverTypeWrapper<
    Omit<InternalAdjustStaffCreditsError, "case"> & {
      case: ResolversTypes["InternalAdjustStaffCreditsErrorCase"];
    }
  >;
  InternalAdjustStaffCreditsErrorCase: ResolverTypeWrapper<
    | "ContractNotFound"
    | "NotAuthorized"
    | "InsufficientBalance"
    | "InvalidInput"
  >;
  InternalAdjustStaffCreditsResult: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalAdjustStaffCreditsResult"]
  >;
  InternalAdjustStaffCreditsSuccess: ResolverTypeWrapper<
    Omit<InternalAdjustStaffCreditsSuccess, "contract"> & {
      contract: ResolversTypes["StaffContract"];
    }
  >;
  InternalAdminRoleAssignee: ResolverTypeWrapper<InternalAdminRoleAssignee>;
  InternalAppendS2oPointsToCoOwnersApplicationError: ResolverTypeWrapper<
    Omit<InternalAppendS2oPointsToCoOwnersApplicationError, "case"> & {
      case: ResolversTypes["InternalAppendS2oPointsToCoOwnersApplicationErrorCase"];
    }
  >;
  InternalAppendS2oPointsToCoOwnersApplicationErrorCase: ResolverTypeWrapper<
    | "CoOwnersApplicationNotFound"
    | "CoOwnersApplicationInvalid"
    | "InsufficientS2oPointBalance"
    | "InvalidAmount"
  >;
  InternalAppendS2oPointsToCoOwnersApplicationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalAppendS2oPointsToCoOwnersApplicationPayload"]
  >;
  InternalApplyGuestAccessKeyError: ResolverTypeWrapper<InternalApplyGuestAccessKeyError>;
  InternalApplyGuestAccessKeyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalApplyGuestAccessKeyPayload"]
  >;
  InternalApplyStaffAccessKeyError: ResolverTypeWrapper<InternalApplyStaffAccessKeyError>;
  InternalApplyStaffAccessKeyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalApplyStaffAccessKeyPayload"]
  >;
  InternalArchitectureContentError: ResolverTypeWrapper<
    Omit<InternalArchitectureContentError, "case"> & {
      case: ResolversTypes["InternalArchitectureContentErrorCase"];
    }
  >;
  InternalArchitectureContentErrorCase: ResolverTypeWrapper<
    | "ArchitectureTypeNotFound"
    | "ArchitectRequired"
    | "SortRequired"
    | "InvalidUrl"
    | "InvalidImage"
    | "ResourceNotFound"
    | "ContentNotFound"
    | "NameRequired"
    | "InUse"
  >;
  InternalArchitectureContentImageKind: ResolverTypeWrapper<
    | "ArchitectureType"
    | "Architect"
    | "BasicAmenityIcon"
    | "Variant"
    | "Feature"
    | "FeatureUsageRule"
  >;
  InternalArea: ResolverTypeWrapper<InternalAreaMapper>;
  InternalAssignAccessCodeToAccommodationReservationError: ResolverTypeWrapper<InternalAssignAccessCodeToAccommodationReservationError>;
  InternalAssignAccessCodeToAccommodationReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalAssignAccessCodeToAccommodationReservationPayload"]
  >;
  InternalAssignAdminRoleError: ResolverTypeWrapper<
    Omit<InternalAssignAdminRoleError, "code"> & {
      code: ResolversTypes["InternalAssignAdminRoleErrorCode"];
    }
  >;
  InternalAssignAdminRoleErrorCode: ResolverTypeWrapper<
    | "InvalidAssignee"
    | "RoleNotGrantable"
    | "SelfAssignment"
    | "UserNotFound"
    | "ScopeRequired"
    | "ScopeNotAllowed"
    | "SiteNotGrantable"
    | "SiteNotFound"
    | "ExpiresAtNotInFuture"
    | "AlreadyAssigned"
  >;
  InternalAssignAdminRoleInput: InternalAssignAdminRoleInput;
  InternalAssignAdminRolePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalAssignAdminRolePayload"]
  >;
  InternalAuth0Identity: ResolverTypeWrapper<InternalAuth0Identity>;
  InternalAuth0User: ResolverTypeWrapper<InternalAuth0User>;
  InternalAvailableStaffSemester: ResolverTypeWrapper<
    Omit<InternalAvailableStaffSemester, "semester"> & {
      semester: ResolversTypes["StaffSemester"];
    }
  >;
  InternalBeds24SyncFuturePricesResult: ResolverTypeWrapper<
    Omit<
      InternalBeds24SyncFuturePricesResult,
      "skippedRoomTypes" | "targets"
    > & {
      skippedRoomTypes: Array<
        ResolversTypes["InternalBeds24SyncFuturePricesSkip"]
      >;
      targets: Array<ResolversTypes["InternalBeds24SyncFuturePricesTarget"]>;
    }
  >;
  InternalBeds24SyncFuturePricesSkip: ResolverTypeWrapper<
    Omit<InternalBeds24SyncFuturePricesSkip, "roomType"> & {
      roomType: ResolversTypes["RoomType"];
    }
  >;
  InternalBeds24SyncFuturePricesTarget: ResolverTypeWrapper<
    Omit<InternalBeds24SyncFuturePricesTarget, "roomType"> & {
      roomType: ResolversTypes["RoomType"];
    }
  >;
  InternalBulkCreateAccommodationAvailabilityBlockFailure: ResolverTypeWrapper<
    Omit<InternalBulkCreateAccommodationAvailabilityBlockFailure, "input"> & {
      input: ResolversTypes["InternalBulkCreateAccommodationAvailabilityBlockFailureInput"];
    }
  >;
  InternalBulkCreateAccommodationAvailabilityBlockFailureInput: ResolverTypeWrapper<
    Omit<
      InternalBulkCreateAccommodationAvailabilityBlockFailureInput,
      "category"
    > & { category: ResolversTypes["AccommodationAvailabilityBlockCategory"] }
  >;
  InternalBulkCreateAccommodationAvailabilityBlocksPayload: ResolverTypeWrapper<
    Omit<
      InternalBulkCreateAccommodationAvailabilityBlocksPayload,
      "failed" | "success"
    > & {
      failed: Array<
        ResolversTypes["InternalBulkCreateAccommodationAvailabilityBlockFailure"]
      >;
      success: Array<ResolversTypes["AccommodationAvailabilityBlock"]>;
    }
  >;
  InternalBulkCreateOrganizationYearlyContractInvoicesError: ResolverTypeWrapper<
    Omit<InternalBulkCreateOrganizationYearlyContractInvoicesError, "case"> & {
      case: ResolversTypes["InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase"];
    }
  >;
  InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase: ResolverTypeWrapper<
    | "CardIsNotRegistered"
    | "ContractIsInvalidated"
    | "CustomerEmailRequired"
    | "DueDateIsInPast"
    | "ScheduledOpenDateOutOfRange"
    | "CreationFailed"
  >;
  InternalBulkCreateOrganizationYearlyContractInvoicesPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalBulkCreateOrganizationYearlyContractInvoicesPayload"]
  >;
  InternalBulkCreateOrganizationYearlyContractInvoicesSuccess: ResolverTypeWrapper<InternalBulkCreateOrganizationYearlyContractInvoicesSuccess>;
  InternalBulkDeleteAccommodationAvailabilityBlockFailure: ResolverTypeWrapper<InternalBulkDeleteAccommodationAvailabilityBlockFailure>;
  InternalBulkDeleteAccommodationAvailabilityBlocksPayload: ResolverTypeWrapper<InternalBulkDeleteAccommodationAvailabilityBlocksPayload>;
  InternalBulkUpdateSeasonalFeeSettingsError: ResolverTypeWrapper<InternalBulkUpdateSeasonalFeeSettingsError>;
  InternalBulkUpdateSeasonalFeeSettingsInput: InternalBulkUpdateSeasonalFeeSettingsInput;
  InternalBulkUpdateSeasonalFeeSettingsPayload: ResolverTypeWrapper<InternalBulkUpdateSeasonalFeeSettingsPayload>;
  InternalBulkUpdateStayTicketMasterInput: InternalBulkUpdateStayTicketMasterInput;
  InternalBulkUpdateStayTicketMastersError: ResolverTypeWrapper<InternalBulkUpdateStayTicketMastersError>;
  InternalBulkUpdateStayTicketMastersPayload: ResolverTypeWrapper<InternalBulkUpdateStayTicketMastersPayload>;
  InternalCancelCoOwnersApplicationError: ResolverTypeWrapper<
    Omit<InternalCancelCoOwnersApplicationError, "case"> & {
      case: ResolversTypes["InternalCancelCoOwnersApplicationErrorCase"];
    }
  >;
  InternalCancelCoOwnersApplicationErrorCase: ResolverTypeWrapper<
    | "NotFound"
    | "PermissionDenied"
    | "StripeRefundError"
    | "AlreadyCancelled"
    | "CannotCancelAfterHandover"
  >;
  InternalCancelCoOwnersApplicationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCancelCoOwnersApplicationPayload"]
  >;
  InternalCommonError: ResolverTypeWrapper<InternalCommonError>;
  InternalContentRoomType: ResolverTypeWrapper<InternalContentRoomTypeMapper>;
  InternalCreateAccommodationAvailabilityBlockReleaseScheduleInput: InternalCreateAccommodationAvailabilityBlockReleaseScheduleInput;
  InternalCreateAccommodationEquipmentInput: InternalCreateAccommodationEquipmentInput;
  InternalCreateAccommodationEquipmentPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateAccommodationEquipmentPayload"]
  >;
  InternalCreateAccommodationOperationGroupError: ResolverTypeWrapper<
    Omit<InternalCreateAccommodationOperationGroupError, "case"> & {
      case: ResolversTypes["InternalCreateAccommodationOperationGroupErrorCase"];
    }
  >;
  InternalCreateAccommodationOperationGroupErrorCase: ResolverTypeWrapper<
    | "SiteNotFound"
    | "ArchitectureTypeNotFound"
    | "AlreadyExists"
    | "InvalidAdditionalFee"
  >;
  InternalCreateAccommodationOperationGroupInput: InternalCreateAccommodationOperationGroupInput;
  InternalCreateAccommodationOperationGroupPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateAccommodationOperationGroupPayload"]
  >;
  InternalCreateAccommodationReservationInput: InternalCreateAccommodationReservationInput;
  InternalCreateArchitectureContentImageUploadPolicyInput: InternalCreateArchitectureContentImageUploadPolicyInput;
  InternalCreateAreaImageUploadPolicyInput: InternalCreateAreaImageUploadPolicyInput;
  InternalCreateAreaInput: InternalCreateAreaInput;
  InternalCreateCoOwnersIdentityVerificationError: ResolverTypeWrapper<
    Omit<InternalCreateCoOwnersIdentityVerificationError, "case"> & {
      case: ResolversTypes["InternalCreateCoOwnersIdentityVerificationErrorCase"];
    }
  >;
  InternalCreateCoOwnersIdentityVerificationErrorCase: ResolverTypeWrapper<
    "ActiveVerificationExists" | "UnsupportedMethod"
  >;
  InternalCreateCoOwnersIdentityVerificationInput: InternalCreateCoOwnersIdentityVerificationInput;
  InternalCreateCoOwnersIdentityVerificationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateCoOwnersIdentityVerificationPayload"]
  >;
  InternalCreateConsumedSuppliesFeeItemsError: ResolverTypeWrapper<
    Omit<InternalCreateConsumedSuppliesFeeItemsError, "case"> & {
      case: ResolversTypes["InternalCreateConsumedSuppliesFeeItemsErrorCase"];
    }
  >;
  InternalCreateConsumedSuppliesFeeItemsErrorCase: ResolverTypeWrapper<
    "ExternalCleaningTaskIdNotMatch" | "AccommodationFeeIsNotOpen"
  >;
  InternalCreateConsumedSuppliesFeeItemsInput: InternalCreateConsumedSuppliesFeeItemsInput;
  InternalCreateConsumedSuppliesFeeItemsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateConsumedSuppliesFeeItemsPayload"]
  >;
  InternalCreateFacilityImageUploadPolicyInput: InternalCreateFacilityImageUploadPolicyInput;
  InternalCreateFacilityInput: InternalCreateFacilityInput;
  InternalCreateFacilityReservationError: ResolverTypeWrapper<
    Omit<InternalCreateFacilityReservationError, "case"> & {
      case: ResolversTypes["InternalCreateFacilityReservationErrorCase"];
    }
  >;
  InternalCreateFacilityReservationErrorCase: ResolverTypeWrapper<
    | "ResourceUnavailable"
    | "ServiceNotAvailable"
    | "NoAccommodationReservation"
    | "FeePolicyNotFound"
    | "InvalidStartDate"
    | "PastReserveDeadline"
    | "ProviderNotEligible"
    | "AccommodationReservationPeriodMismatch"
    | "InvalidFacilityFieldData"
    | "InvalidSlotSelection"
    | "TemporarilyUnavailable"
    | "InvalidDiscount"
  >;
  InternalCreateFacilityReservationInput: InternalCreateFacilityReservationInput;
  InternalCreateFacilityReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateFacilityReservationPayload"]
  >;
  InternalCreateFullOwnerIdentityVerificationError: ResolverTypeWrapper<
    Omit<InternalCreateFullOwnerIdentityVerificationError, "case"> & {
      case: ResolversTypes["InternalCreateFullOwnerIdentityVerificationErrorCase"];
    }
  >;
  InternalCreateFullOwnerIdentityVerificationErrorCase: ResolverTypeWrapper<
    "ActiveVerificationExists" | "UnsupportedMethod"
  >;
  InternalCreateFullOwnerIdentityVerificationInput: InternalCreateFullOwnerIdentityVerificationInput;
  InternalCreateFullOwnerIdentityVerificationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateFullOwnerIdentityVerificationPayload"]
  >;
  InternalCreateLocalTaxPolicyError: ResolverTypeWrapper<
    Omit<InternalCreateLocalTaxPolicyError, "case"> & {
      case: ResolversTypes["InternalCreateLocalTaxPolicyErrorCase"];
    }
  >;
  InternalCreateLocalTaxPolicyErrorCase: ResolverTypeWrapper<
    "InvalidInput" | "InvalidBrackets" | "OverlappingEffectivePeriod"
  >;
  InternalCreateLocalTaxPolicyInput: InternalCreateLocalTaxPolicyInput;
  InternalCreateLocalTaxPolicyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateLocalTaxPolicyPayload"]
  >;
  InternalCreateOrUpdateAccommodationContentInput: InternalCreateOrUpdateAccommodationContentInput;
  InternalCreateOrUpdateAccommodationError: ResolverTypeWrapper<InternalCreateOrUpdateAccommodationError>;
  InternalCreateOrUpdateAccommodationInput: InternalCreateOrUpdateAccommodationInput;
  InternalCreateOrUpdateAccommodationNoticeError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateAccommodationNoticeError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateAccommodationNoticeErrorCase"];
    }
  >;
  InternalCreateOrUpdateAccommodationNoticeErrorCase: ResolverTypeWrapper<"InvalidInput">;
  InternalCreateOrUpdateAccommodationNoticeInput: InternalCreateOrUpdateAccommodationNoticeInput;
  InternalCreateOrUpdateAccommodationNoticePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateAccommodationNoticePayload"]
  >;
  InternalCreateOrUpdateAccommodationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateAccommodationPayload"]
  >;
  InternalCreateOrUpdateAdditionalGuestFeePolicyError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateAdditionalGuestFeePolicyError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase"];
    }
  >;
  InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase: ResolverTypeWrapper<
    "InvalidInput" | "ResourceNotFound"
  >;
  InternalCreateOrUpdateAdditionalGuestFeePolicyInput: InternalCreateOrUpdateAdditionalGuestFeePolicyInput;
  InternalCreateOrUpdateAdditionalGuestFeePolicyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateAdditionalGuestFeePolicyPayload"]
  >;
  InternalCreateOrUpdateArchitectureTypeInput: InternalCreateOrUpdateArchitectureTypeInput;
  InternalCreateOrUpdateAreaGuideArticleInput: InternalCreateOrUpdateAreaGuideArticleInput;
  InternalCreateOrUpdateAreaGuideSpotInput: InternalCreateOrUpdateAreaGuideSpotInput;
  InternalCreateOrUpdateBaseAccommodationFeePolicyError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateBaseAccommodationFeePolicyError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase"];
    }
  >;
  InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase: ResolverTypeWrapper<
    "InvalidInput" | "ResourceNotFound" | "DatabaseError"
  >;
  InternalCreateOrUpdateBaseAccommodationFeePolicyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateBaseAccommodationFeePolicyPayload"]
  >;
  InternalCreateOrUpdateBusinessPlanError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateBusinessPlanError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateBusinessPlanErrorCase"];
    }
  >;
  InternalCreateOrUpdateBusinessPlanErrorCase: ResolverTypeWrapper<
    "InvalidInput" | "DuplicatedName"
  >;
  InternalCreateOrUpdateBusinessPlanPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateBusinessPlanPayload"]
  >;
  InternalCreateOrUpdateCancelFeePolicyError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateCancelFeePolicyError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateCancelFeePolicyErrorCase"];
    }
  >;
  InternalCreateOrUpdateCancelFeePolicyErrorCase: ResolverTypeWrapper<
    "InvalidInput" | "ResourceNotFound"
  >;
  InternalCreateOrUpdateCancelFeePolicyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateCancelFeePolicyPayload"]
  >;
  InternalCreateOrUpdateCoOwnersPlanOfferingError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateCoOwnersPlanOfferingError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase"];
    }
  >;
  InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase: ResolverTypeWrapper<"InvalidInput">;
  InternalCreateOrUpdateCoOwnersPlanOfferingInput: InternalCreateOrUpdateCoOwnersPlanOfferingInput;
  InternalCreateOrUpdateCoOwnersPlanOfferingPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateCoOwnersPlanOfferingPayload"]
  >;
  InternalCreateOrUpdateCoOwnersWebinarScheduleError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateCoOwnersWebinarScheduleError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase"];
    }
  >;
  InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase: ResolverTypeWrapper<"InvalidInput">;
  InternalCreateOrUpdateCoOwnersWebinarScheduleInput: InternalCreateOrUpdateCoOwnersWebinarScheduleInput;
  InternalCreateOrUpdateCoOwnersWebinarSchedulePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateCoOwnersWebinarSchedulePayload"]
  >;
  InternalCreateOrUpdateContentArchitectInput: InternalCreateOrUpdateContentArchitectInput;
  InternalCreateOrUpdateContentArchitectPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateContentArchitectPayload"]
  >;
  InternalCreateOrUpdateContentArchitecturalFeatureInput: InternalCreateOrUpdateContentArchitecturalFeatureInput;
  InternalCreateOrUpdateContentArchitecturalFeaturePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateContentArchitecturalFeaturePayload"]
  >;
  InternalCreateOrUpdateContentArchitecturalFeatureUsageRuleInput: InternalCreateOrUpdateContentArchitecturalFeatureUsageRuleInput;
  InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload"]
  >;
  InternalCreateOrUpdateContentArchitectureTypeBasicAmenityInput: InternalCreateOrUpdateContentArchitectureTypeBasicAmenityInput;
  InternalCreateOrUpdateContentArchitectureTypeInput: InternalCreateOrUpdateContentArchitectureTypeInput;
  InternalCreateOrUpdateContentArchitectureTypePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateContentArchitectureTypePayload"]
  >;
  InternalCreateOrUpdateContentArchitectureTypeVariantInput: InternalCreateOrUpdateContentArchitectureTypeVariantInput;
  InternalCreateOrUpdateContentArchitectureTypeVariantPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateContentArchitectureTypeVariantPayload"]
  >;
  InternalCreateOrUpdateContentBasicAmenityPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateContentBasicAmenityPayload"]
  >;
  InternalCreateOrUpdateContentFacilityAmenityInput: InternalCreateOrUpdateContentFacilityAmenityInput;
  InternalCreateOrUpdateContentFacilityAmenityPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateContentFacilityAmenityPayload"]
  >;
  InternalCreateOrUpdateFacilityBaseFeePolicyInput: InternalCreateOrUpdateFacilityBaseFeePolicyInput;
  InternalCreateOrUpdateFacilityCancelFeePolicyInput: InternalCreateOrUpdateFacilityCancelFeePolicyInput;
  InternalCreateOrUpdateFacilityControllerInput: InternalCreateOrUpdateFacilityControllerInput;
  InternalCreateOrUpdateFacilityError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateFacilityError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateFacilityErrorCase"];
    }
  >;
  InternalCreateOrUpdateFacilityErrorCase: ResolverTypeWrapper<
    | "SiteNotFound"
    | "FacilityNotFound"
    | "InvalidControllerAttribute"
    | "InvalidCustomInvoiceLabel"
    | "CustomInvoiceLabelRequiresReserveEnabled"
  >;
  InternalCreateOrUpdateFacilityPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateFacilityPayload"]
  >;
  InternalCreateOrUpdateFacilityResourceBlockError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateFacilityResourceBlockError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateFacilityResourceBlockErrorCase"];
    }
  >;
  InternalCreateOrUpdateFacilityResourceBlockErrorCase: ResolverTypeWrapper<
    "ResourceNotFound" | "BlockNotFound"
  >;
  InternalCreateOrUpdateFacilityResourceBlockInput: InternalCreateOrUpdateFacilityResourceBlockInput;
  InternalCreateOrUpdateFacilityResourceBlockPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateFacilityResourceBlockPayload"]
  >;
  InternalCreateOrUpdateFacilityResourceInput: InternalCreateOrUpdateFacilityResourceInput;
  InternalCreateOrUpdateFacilitySlotInput: InternalCreateOrUpdateFacilitySlotInput;
  InternalCreateOrUpdateNativeAppHomeContentError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateNativeAppHomeContentError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateNativeAppHomeContentErrorCase"];
    }
  >;
  InternalCreateOrUpdateNativeAppHomeContentErrorCase: ResolverTypeWrapper<
    "InvalidInput" | "NotFound" | "OptimisticLockConflict" | "DatabaseError"
  >;
  InternalCreateOrUpdateNativeAppHomeContentPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateNativeAppHomeContentPayload"]
  >;
  InternalCreateOrUpdateNewsError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateNewsError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateNewsErrorCase"];
    }
  >;
  InternalCreateOrUpdateNewsErrorCase: ResolverTypeWrapper<
    | "InternalPageIsNoLongerUsed"
    | "UrlIsRequiredForExternalLink"
    | "ContentIsRequiredForHTML"
  >;
  InternalCreateOrUpdateNewsInput: InternalCreateOrUpdateNewsInput;
  InternalCreateOrUpdateNewsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateNewsPayload"]
  >;
  InternalCreateOrUpdateOrganizationError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateOrganizationError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateOrganizationErrorCase"];
    }
  >;
  InternalCreateOrUpdateOrganizationErrorCase: ResolverTypeWrapper<
    "InvalidInput" | "DuplicatedInvitationCode" | "AssignedUserNotFound"
  >;
  InternalCreateOrUpdateOrganizationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateOrganizationPayload"]
  >;
  InternalCreateOrUpdateOrganizationYearlyContractError: ResolverTypeWrapper<InternalCreateOrUpdateOrganizationYearlyContractError>;
  InternalCreateOrUpdateOrganizationYearlyContractInvoiceError: ResolverTypeWrapper<
    Omit<
      InternalCreateOrUpdateOrganizationYearlyContractInvoiceError,
      "case"
    > & {
      case: ResolversTypes["InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase"];
    }
  >;
  InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase: ResolverTypeWrapper<
    | "CardIsNotRegistered"
    | "ContractIsInvalidated"
    | "CustomerEmailRequired"
    | "InvoiceIsNotDraft"
    | "ContractIdRequired"
    | "MissingRequiredFields"
    | "DueDateIsInPast"
    | "YearMonthOutOfContractPeriod"
    | "ScheduledOpenDateOutOfRange"
  >;
  InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload"]
  >;
  InternalCreateOrUpdateOrganizationYearlyContractPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateOrganizationYearlyContractPayload"]
  >;
  InternalCreateOrUpdateOwnerPlanError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateOwnerPlanError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateOwnerPlanErrorCase"];
    }
  >;
  InternalCreateOrUpdateOwnerPlanErrorCase: ResolverTypeWrapper<
    | "InvalidInput"
    | "SiteAndArchitectureTypeRequiedForCoOwners"
    | "AccommodationRequiredForFullOwner"
    | "SiteNotFound"
    | "ArchitectureTypeNotFound"
    | "AccommodationNotFound"
    | "OwnerPlanNotFound"
    | "OperationGroupSettingNotFound"
  >;
  InternalCreateOrUpdateOwnerPlanInput: InternalCreateOrUpdateOwnerPlanInput;
  InternalCreateOrUpdateOwnerPlanPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateOwnerPlanPayload"]
  >;
  InternalCreateOrUpdateSiteAccessRouteGroupInput: InternalCreateOrUpdateSiteAccessRouteGroupInput;
  InternalCreateOrUpdateSiteActivityProgramError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateSiteActivityProgramError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateSiteActivityProgramErrorCase"];
    }
  >;
  InternalCreateOrUpdateSiteActivityProgramErrorCase: ResolverTypeWrapper<
    | "ActivityProgramNotFound"
    | "TitleRequired"
    | "SiteNotFound"
    | "InvalidPublicationPeriod"
    | "InvalidExternalUrl"
  >;
  InternalCreateOrUpdateSiteActivityProgramPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateSiteActivityProgramPayload"]
  >;
  InternalCreateOrUpdateSiteFaqError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateSiteFaqError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateSiteFaqErrorCase"];
    }
  >;
  InternalCreateOrUpdateSiteFaqErrorCase: ResolverTypeWrapper<
    "QuestionIsEmpty" | "AnswerIsEmpty"
  >;
  InternalCreateOrUpdateSiteFaqInput: InternalCreateOrUpdateSiteFaqInput;
  InternalCreateOrUpdateSiteFaqPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateSiteFaqPayload"]
  >;
  InternalCreateOrUpdateSiteImagesInput: InternalCreateOrUpdateSiteImagesInput;
  InternalCreateOrUpdateStaffGroupError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateStaffGroupError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateStaffGroupErrorCase"];
    }
  >;
  InternalCreateOrUpdateStaffGroupErrorCase: ResolverTypeWrapper<
    "DuplicatedSmarthrId" | "NotFound"
  >;
  InternalCreateOrUpdateStaffGroupPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateStaffGroupPayload"]
  >;
  InternalCreateOrUpdateStayTicketMasterError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateStayTicketMasterError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateStayTicketMasterErrorCase"];
    }
  >;
  InternalCreateOrUpdateStayTicketMasterErrorCase: ResolverTypeWrapper<"InvalidInput">;
  InternalCreateOrUpdateStayTicketMasterInput: InternalCreateOrUpdateStayTicketMasterInput;
  InternalCreateOrUpdateStayTicketMasterPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateStayTicketMasterPayload"]
  >;
  InternalCreateOrUpdateStayTicketMasterTemplateError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateStayTicketMasterTemplateError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateStayTicketMasterTemplateErrorCase"];
    }
  >;
  InternalCreateOrUpdateStayTicketMasterTemplateErrorCase: ResolverTypeWrapper<"InvalidInput">;
  InternalCreateOrUpdateStayTicketMasterTemplateInput: InternalCreateOrUpdateStayTicketMasterTemplateInput;
  InternalCreateOrUpdateStayTicketMasterTemplatePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateStayTicketMasterTemplatePayload"]
  >;
  InternalCreateOrUpdateStayTicketTemplateError: ResolverTypeWrapper<InternalCreateOrUpdateStayTicketTemplateError>;
  InternalCreateOrUpdateStayTicketTemplateInput: InternalCreateOrUpdateStayTicketTemplateInput;
  InternalCreateOrUpdateSupplyItemInstallationInput: InternalCreateOrUpdateSupplyItemInstallationInput;
  InternalCreateOrUpdateSupplyItemInstallationsError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateSupplyItemInstallationsError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateSupplyItemInstallationsErrorCase"];
    }
  >;
  InternalCreateOrUpdateSupplyItemInstallationsErrorCase: ResolverTypeWrapper<
    | "SupplyItemMasterNotFound"
    | "SiteNotFound"
    | "InstallationNotFound"
    | "DuplicateInstallation"
    | "InvalidInstallationReference"
    | "TemporarilyUnavailable"
  >;
  InternalCreateOrUpdateSupplyItemInstallationsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateSupplyItemInstallationsPayload"]
  >;
  InternalCreateOrUpdateSupplyItemMasterError: ResolverTypeWrapper<
    Omit<InternalCreateOrUpdateSupplyItemMasterError, "case"> & {
      case: ResolversTypes["InternalCreateOrUpdateSupplyItemMasterErrorCase"];
    }
  >;
  InternalCreateOrUpdateSupplyItemMasterErrorCase: ResolverTypeWrapper<
    "SupplyItemMasterNotFound" | "RequiredFieldMissing"
  >;
  InternalCreateOrUpdateSupplyItemMasterInput: InternalCreateOrUpdateSupplyItemMasterInput;
  InternalCreateOrUpdateSupplyItemMasterPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateOrUpdateSupplyItemMasterPayload"]
  >;
  InternalCreateOtaRoomUnitInput: InternalCreateOtaRoomUnitInput;
  InternalCreateRoomTypeImageUploadPolicyInput: InternalCreateRoomTypeImageUploadPolicyInput;
  InternalCreateRoomTypeInput: InternalCreateRoomTypeInput;
  InternalCreateSiteActivityProgramInput: InternalCreateSiteActivityProgramInput;
  InternalCreateSiteError: ResolverTypeWrapper<
    Omit<InternalCreateSiteError, "case"> & {
      case: ResolversTypes["InternalCreateSiteErrorCase"];
    }
  >;
  InternalCreateSiteErrorCase: ResolverTypeWrapper<
    "RemoteLockLocationNotFound" | "SiteNotPublished"
  >;
  InternalCreateSiteFaqImageUploadPolicyInput: InternalCreateSiteFaqImageUploadPolicyInput;
  InternalCreateSiteHighSeasonPeriodInput: InternalCreateSiteHighSeasonPeriodInput;
  InternalCreateSiteImageUploadPolicyInput: InternalCreateSiteImageUploadPolicyInput;
  InternalCreateSiteInput: InternalCreateSiteInput;
  InternalCreateSitePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateSitePayload"]
  >;
  InternalCreateStayTicketTemplatePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateStayTicketTemplatePayload"]
  >;
  InternalCreateTermsRevisionError: ResolverTypeWrapper<
    Omit<InternalCreateTermsRevisionError, "case"> & {
      case: ResolversTypes["InternalCreateTermsRevisionErrorCase"];
    }
  >;
  InternalCreateTermsRevisionErrorCase: ResolverTypeWrapper<
    "InvalidInput" | "ResourceNotFound" | "AlreadyExists"
  >;
  InternalCreateTermsRevisionInput: InternalCreateTermsRevisionInput;
  InternalCreateTermsRevisionPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalCreateTermsRevisionPayload"]
  >;
  InternalDeleteAccommodationEquipmentPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalDeleteAccommodationEquipmentPayload"]
  >;
  InternalDeleteAccommodationEquipmentSuccess: ResolverTypeWrapper<InternalDeleteAccommodationEquipmentSuccess>;
  InternalDeleteArchitectureContentPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalDeleteArchitectureContentPayload"]
  >;
  InternalDeleteFacilityResourceBlockError: ResolverTypeWrapper<
    Omit<InternalDeleteFacilityResourceBlockError, "case"> & {
      case: ResolversTypes["InternalDeleteFacilityResourceBlockErrorCase"];
    }
  >;
  InternalDeleteFacilityResourceBlockErrorCase: ResolverTypeWrapper<
    "BlockNotFound" | "CannotDeleteUserBlock"
  >;
  InternalDeleteFacilityResourceBlockPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalDeleteFacilityResourceBlockPayload"]
  >;
  InternalDeleteLocalTaxPolicyError: ResolverTypeWrapper<
    Omit<InternalDeleteLocalTaxPolicyError, "case"> & {
      case: ResolversTypes["InternalDeleteLocalTaxPolicyErrorCase"];
    }
  >;
  InternalDeleteLocalTaxPolicyErrorCase: ResolverTypeWrapper<"LinkedToSiteOrAccommodation">;
  InternalDeleteLocalTaxPolicyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalDeleteLocalTaxPolicyPayload"]
  >;
  InternalDeleteSupplyItemInstallationError: ResolverTypeWrapper<
    Omit<InternalDeleteSupplyItemInstallationError, "case"> & {
      case: ResolversTypes["InternalDeleteSupplyItemInstallationErrorCase"];
    }
  >;
  InternalDeleteSupplyItemInstallationErrorCase: ResolverTypeWrapper<"InstallationNotFound">;
  InternalDeleteSupplyItemInstallationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalDeleteSupplyItemInstallationPayload"]
  >;
  InternalDeleteSupplyItemMasterError: ResolverTypeWrapper<
    Omit<InternalDeleteSupplyItemMasterError, "case"> & {
      case: ResolversTypes["InternalDeleteSupplyItemMasterErrorCase"];
    }
  >;
  InternalDeleteSupplyItemMasterErrorCase: ResolverTypeWrapper<
    "SupplyItemMasterNotFound" | "HasActiveInstallations"
  >;
  InternalDeleteSupplyItemMasterPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalDeleteSupplyItemMasterPayload"]
  >;
  InternalFacilityController: ResolverTypeWrapper<
    Omit<InternalFacilityController, "type"> & {
      type: ResolversTypes["FacilityResourceControllerType"];
    }
  >;
  InternalFacilityReservationDiscountInput: InternalFacilityReservationDiscountInput;
  InternalFutureCleaningAmount: ResolverTypeWrapper<
    Omit<InternalFutureCleaningAmount, "accommodations"> & {
      accommodations: Array<ResolversTypes["Accommodation"]>;
    }
  >;
  InternalFutureCleaningAmountByFacility: ResolverTypeWrapper<InternalFutureCleaningAmountByFacility>;
  InternalFutureCleaningAmounts: ResolverTypeWrapper<
    Omit<InternalFutureCleaningAmounts, "list"> & {
      list: Array<ResolversTypes["InternalFutureCleaningAmount"]>;
    }
  >;
  InternalFutureCleaningAmountsError: ResolverTypeWrapper<InternalFutureCleaningAmountsError>;
  InternalFutureCleaningAmountsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalFutureCleaningAmountsPayload"]
  >;
  InternalGenerateUserMonthlyStatementError: ResolverTypeWrapper<
    Omit<InternalGenerateUserMonthlyStatementError, "case"> & {
      case: ResolversTypes["InternalGenerateUserMonthlyStatementErrorCase"];
    }
  >;
  InternalGenerateUserMonthlyStatementErrorCase: ResolverTypeWrapper<"UserNotFound">;
  InternalGenerateUserMonthlyStatementPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalGenerateUserMonthlyStatementPayload"]
  >;
  InternalGrantableAdminRole: ResolverTypeWrapper<
    Omit<InternalGrantableAdminRole, "role" | "scope"> & {
      role: ResolversTypes["AdminRole"];
      scope?: Maybe<ResolversTypes["ScopeDimension"]>;
    }
  >;
  InternalInvalidateOrganizationYearlyContractError: ResolverTypeWrapper<
    Omit<InternalInvalidateOrganizationYearlyContractError, "case"> & {
      case: ResolversTypes["InternalInvalidateOrganizationYearlyContractErrorCase"];
    }
  >;
  InternalInvalidateOrganizationYearlyContractErrorCase: ResolverTypeWrapper<"ReservationsExistInContractPeriod">;
  InternalInvalidateOrganizationYearlyContractInvoiceError: ResolverTypeWrapper<
    Omit<InternalInvalidateOrganizationYearlyContractInvoiceError, "case"> & {
      case: ResolversTypes["InternalInvalidateOrganizationYearlyContractInvoiceErrorCase"];
    }
  >;
  InternalInvalidateOrganizationYearlyContractInvoiceErrorCase: ResolverTypeWrapper<
    "InvoiceIsAlreadyInvalidated" | "InvoiceIsPaid" | "InvoiceIsUncollectible"
  >;
  InternalInvalidateOrganizationYearlyContractInvoicePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalInvalidateOrganizationYearlyContractInvoicePayload"]
  >;
  InternalInvalidateOrganizationYearlyContractPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalInvalidateOrganizationYearlyContractPayload"]
  >;
  InternalInvalidateS2oPointsError: ResolverTypeWrapper<
    Omit<InternalInvalidateS2oPointsError, "case"> & {
      case: ResolversTypes["InternalInvalidateS2oPointsErrorCase"];
    }
  >;
  InternalInvalidateS2oPointsErrorCase: ResolverTypeWrapper<"UserNotFound">;
  InternalInvalidateS2oPointsInput: InternalInvalidateS2oPointsInput;
  InternalInvalidateS2oPointsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalInvalidateS2oPointsPayload"]
  >;
  InternalInvalidateStayTicketsByCodeResult: ResolverTypeWrapper<
    Omit<
      InternalInvalidateStayTicketsByCodeResult,
      "invalidatedTickets" | "skippedTickets"
    > & {
      invalidatedTickets: Array<ResolversTypes["StayTicket"]>;
      skippedTickets: Array<ResolversTypes["StayTicket"]>;
    }
  >;
  InternalIssueS2oPointsError: ResolverTypeWrapper<
    Omit<InternalIssueS2oPointsError, "case"> & {
      case: ResolversTypes["InternalIssueS2oPointsErrorCase"];
    }
  >;
  InternalIssueS2oPointsErrorCase: ResolverTypeWrapper<
    | "UserNotFound"
    | "TrialContractNotFound"
    | "InsufficientBalance"
    | "InvalidDate"
    | "InvalidAmount"
    | "InvalidTransactionType"
  >;
  InternalIssueS2oPointsInput: InternalIssueS2oPointsInput;
  InternalIssueS2oPointsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalIssueS2oPointsPayload"]
  >;
  InternalJtasCreateOrUpdateInspectionStatusesError: ResolverTypeWrapper<
    Omit<InternalJtasCreateOrUpdateInspectionStatusesError, "case"> & {
      case: ResolversTypes["InternalJtasCreateOrUpdateInspectionStatusesErrorCase"];
    }
  >;
  InternalJtasCreateOrUpdateInspectionStatusesErrorCase: ResolverTypeWrapper<"ReservationNotFound">;
  InternalJtasCreateOrUpdateInspectionStatusesInput: InternalJtasCreateOrUpdateInspectionStatusesInput;
  InternalJtasCreateOrUpdateInspectionStatusesPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalJtasCreateOrUpdateInspectionStatusesPayload"]
  >;
  InternalJtasCreateOrUpdateSupplyReportError: ResolverTypeWrapper<
    Omit<InternalJtasCreateOrUpdateSupplyReportError, "case"> & {
      case: ResolversTypes["InternalJtasCreateOrUpdateSupplyReportErrorCase"];
    }
  >;
  InternalJtasCreateOrUpdateSupplyReportErrorCase: ResolverTypeWrapper<
    | "ReservationNotFound"
    | "SupplyItemMasterNotFound"
    | "SupplyReportClosed"
    | "ReservationCanceled"
    | "MediaFetchFailed"
  >;
  InternalJtasCreateOrUpdateSupplyReportInput: InternalJtasCreateOrUpdateSupplyReportInput;
  InternalJtasCreateOrUpdateSupplyReportPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalJtasCreateOrUpdateSupplyReportPayload"]
  >;
  InternalJtasCreateOrUpdateViolationReportError: ResolverTypeWrapper<
    Omit<InternalJtasCreateOrUpdateViolationReportError, "case"> & {
      case: ResolversTypes["InternalJtasCreateOrUpdateViolationReportErrorCase"];
    }
  >;
  InternalJtasCreateOrUpdateViolationReportErrorCase: ResolverTypeWrapper<
    "ReservationNotFound" | "MediaFetchFailed" | "ViolationReportClosed"
  >;
  InternalJtasCreateOrUpdateViolationReportInput: InternalJtasCreateOrUpdateViolationReportInput;
  InternalJtasCreateOrUpdateViolationReportPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalJtasCreateOrUpdateViolationReportPayload"]
  >;
  InternalJtasDeleteViolationReportError: ResolverTypeWrapper<
    Omit<InternalJtasDeleteViolationReportError, "case"> & {
      case: ResolversTypes["InternalJtasDeleteViolationReportErrorCase"];
    }
  >;
  InternalJtasDeleteViolationReportErrorCase: ResolverTypeWrapper<
    "ViolationReportNotFound" | "ViolationReportClosed"
  >;
  InternalJtasDeleteViolationReportInput: InternalJtasDeleteViolationReportInput;
  InternalJtasDeleteViolationReportPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalJtasDeleteViolationReportPayload"]
  >;
  InternalJtasInspectionStatusInput: InternalJtasInspectionStatusInput;
  InternalJtasSupplyItemInput: InternalJtasSupplyItemInput;
  InternalJtasViolationItemInput: InternalJtasViolationItemInput;
  InternalLeaveOrganizationError: ResolverTypeWrapper<
    Omit<InternalLeaveOrganizationError, "case"> & {
      case: ResolversTypes["InternalLeaveOrganizationErrorCase"];
    }
  >;
  InternalLeaveOrganizationErrorCase: ResolverTypeWrapper<"HasActiveReservation">;
  InternalLeaveOrganizationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalLeaveOrganizationPayload"]
  >;
  InternalLocalTaxFixedAmountInput: InternalLocalTaxFixedAmountInput;
  InternalLocalTaxFixedRateInput: InternalLocalTaxFixedRateInput;
  InternalLocalTaxRuleInput: InternalLocalTaxRuleInput;
  InternalLocalTaxSteppedAmountInput: InternalLocalTaxSteppedAmountInput;
  InternalLocalTaxSteppedBracketInput: InternalLocalTaxSteppedBracketInput;
  InternalLocalizedString: ResolverTypeWrapper<InternalLocalizedString>;
  InternalLocalizedStringInput: InternalLocalizedStringInput;
  InternalMarkCoOwnersApplicationPlannedForSaleError: ResolverTypeWrapper<
    Omit<InternalMarkCoOwnersApplicationPlannedForSaleError, "case"> & {
      case: ResolversTypes["InternalMarkCoOwnersApplicationPlannedForSaleErrorCase"];
    }
  >;
  InternalMarkCoOwnersApplicationPlannedForSaleErrorCase: ResolverTypeWrapper<
    | "NotFound"
    | "PermissionDenied"
    | "InvalidStatusTransition"
    | "OwnershipNotFound"
    | "InvalidSaleUnits"
    | "SaleMonthBeforeHandover"
    | "SaleMonthBeforePreviousSale"
    | "SaleMonthRequiresCreditRestore"
    | "NextYearStayCreditsInUse"
    | "TemporarilyUnavailable"
  >;
  InternalMarkCoOwnersApplicationPlannedForSalePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalMarkCoOwnersApplicationPlannedForSalePayload"]
  >;
  InternalMarkCoOwnersApplicationSoldError: ResolverTypeWrapper<
    Omit<InternalMarkCoOwnersApplicationSoldError, "case"> & {
      case: ResolversTypes["InternalMarkCoOwnersApplicationSoldErrorCase"];
    }
  >;
  InternalMarkCoOwnersApplicationSoldErrorCase: ResolverTypeWrapper<
    | "NotFound"
    | "PermissionDenied"
    | "InvalidStatusTransition"
    | "HasActiveReservations"
    | "HasActiveStayGifts"
    | "OwnershipNotFound"
  >;
  InternalMarkCoOwnersApplicationSoldPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalMarkCoOwnersApplicationSoldPayload"]
  >;
  InternalNativeAppHomeContent: ResolverTypeWrapper<InternalNativeAppHomeContentMapper>;
  InternalNativeAppHomeContentInput: InternalNativeAppHomeContentInput;
  InternalOneShotScript: ResolverTypeWrapper<InternalOneShotScriptMapper>;
  InternalOtaRoomUnit: ResolverTypeWrapper<InternalOtaRoomUnitMapper>;
  InternalPartialUpdateOrganizationError: ResolverTypeWrapper<InternalPartialUpdateOrganizationError>;
  InternalPartialUpdateOrganizationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalPartialUpdateOrganizationPayload"]
  >;
  InternalRegisterCoOwnersApplicationFileInput: InternalRegisterCoOwnersApplicationFileInput;
  InternalReleaseAccessKeyError: ResolverTypeWrapper<InternalReleaseAccessKeyError>;
  InternalReleaseAccessKeyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalReleaseAccessKeyPayload"]
  >;
  InternalRemoveLocalTaxPolicyError: ResolverTypeWrapper<
    Omit<InternalRemoveLocalTaxPolicyError, "case"> & {
      case: ResolversTypes["InternalRemoveLocalTaxPolicyErrorCase"];
    }
  >;
  InternalRemoveLocalTaxPolicyErrorCase: ResolverTypeWrapper<"UsedForTaxCalculation">;
  InternalRemoveLocalTaxPolicyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalRemoveLocalTaxPolicyPayload"]
  >;
  InternalRemoveLocalTaxPolicyTargetInput: InternalRemoveLocalTaxPolicyTargetInput;
  InternalReorderAccommodationInput: InternalReorderAccommodationInput;
  InternalReorderArchitectureContentInput: InternalReorderArchitectureContentInput;
  InternalReorderAreaInput: InternalReorderAreaInput;
  InternalReorderInput: InternalReorderInput;
  InternalReorderSiteFaqInput: InternalReorderSiteFaqInput;
  InternalReorderSiteInput: InternalReorderSiteInput;
  InternalRevokeAdminRoleError: ResolverTypeWrapper<
    Omit<InternalRevokeAdminRoleError, "code"> & {
      code: ResolversTypes["InternalRevokeAdminRoleErrorCode"];
    }
  >;
  InternalRevokeAdminRoleErrorCode: ResolverTypeWrapper<
    "NotFound" | "AlreadyRevoked" | "RoleNotRevocable" | "SelfRevocation"
  >;
  InternalRevokeAdminRolePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalRevokeAdminRolePayload"]
  >;
  InternalRoomType: ResolverTypeWrapper<InternalRoomTypeMapper>;
  InternalRoomTypeFeature: ResolverTypeWrapper<InternalRoomTypeFeatureMapper>;
  InternalRunOneShotScriptError: ResolverTypeWrapper<
    Omit<InternalRunOneShotScriptError, "case"> & {
      case: ResolversTypes["InternalRunOneShotScriptErrorCase"];
    }
  >;
  InternalRunOneShotScriptErrorCase: ResolverTypeWrapper<
    | "ScriptNotFound"
    | "ConfirmationRequired"
    | "ConfirmationMismatch"
    | "DryRunNotSupported"
    | "AlreadyRunning"
  >;
  InternalRunOneShotScriptInput: InternalRunOneShotScriptInput;
  InternalRunOneShotScriptResult: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalRunOneShotScriptResult"]
  >;
  InternalScriptAffectedCount: ResolverTypeWrapper<InternalScriptAffectedCountMapper>;
  InternalScriptExecution: ResolverTypeWrapper<InternalScriptExecutionMapper>;
  InternalScriptExecutionActor: ResolverTypeWrapper<InternalScriptExecutionActorMapper>;
  InternalScriptExecutionLogLine: ResolverTypeWrapper<InternalScriptExecutionLogLineMapper>;
  InternalSendPushNotificationsError: ResolverTypeWrapper<
    Omit<InternalSendPushNotificationsError, "case"> & {
      case: ResolversTypes["InternalSendPushNotificationsErrorCase"];
    }
  >;
  InternalSendPushNotificationsErrorCase: ResolverTypeWrapper<
    "InvalidInput" | "NoAppInstallations"
  >;
  InternalSendPushNotificationsInput: InternalSendPushNotificationsInput;
  InternalSendPushNotificationsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalSendPushNotificationsPayload"]
  >;
  InternalSendPushNotificationsResult: ResolverTypeWrapper<InternalSendPushNotificationsResult>;
  InternalSite: ResolverTypeWrapper<InternalSiteMapper>;
  InternalSiteAccessRoutePointInput: InternalSiteAccessRoutePointInput;
  InternalSiteAddress: ResolverTypeWrapper<InternalSiteAddressMapper>;
  InternalStaffContract: ResolverTypeWrapper<InternalStaffContractMapper>;
  InternalStaffCreditTransaction: ResolverTypeWrapper<InternalStaffCreditTransactionMapper>;
  InternalStartStaffPlanError: ResolverTypeWrapper<
    Omit<InternalStartStaffPlanError, "case"> & {
      case: ResolversTypes["InternalStartStaffPlanErrorCase"];
    }
  >;
  InternalStartStaffPlanErrorCase: ResolverTypeWrapper<
    "AlreadyActive" | "InvalidNights" | "InvalidSemester" | "NotAuthorized"
  >;
  InternalStartStaffPlanResult: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalStartStaffPlanResult"]
  >;
  InternalStartStaffPlanSuccess: ResolverTypeWrapper<
    Omit<InternalStartStaffPlanSuccess, "contract"> & {
      contract: ResolversTypes["StaffContract"];
    }
  >;
  InternalStayTicketsOrderBy: ResolverTypeWrapper<
    "CreatedAt" | "ExpiresAt" | "StayStartNight" | "StayEndNight" | "Code"
  >;
  InternalStayTicketsResult: ResolverTypeWrapper<
    Omit<InternalStayTicketsResult, "items"> & {
      items: Array<ResolversTypes["StayTicket"]>;
    }
  >;
  InternalStopStaffPlanError: ResolverTypeWrapper<
    Omit<InternalStopStaffPlanError, "case"> & {
      case: ResolversTypes["InternalStopStaffPlanErrorCase"];
    }
  >;
  InternalStopStaffPlanErrorCase: ResolverTypeWrapper<
    "NotActive" | "FutureReservationsExist" | "NotAuthorized"
  >;
  InternalStopStaffPlanResult: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalStopStaffPlanResult"]
  >;
  InternalStopStaffPlanSuccess: ResolverTypeWrapper<
    Omit<InternalStopStaffPlanSuccess, "contract"> & {
      contract: ResolversTypes["StaffContract"];
    }
  >;
  InternalUnlinkIdentityPayload: ResolverTypeWrapper<InternalUnlinkIdentityPayload>;
  InternalUpdateAccommodationAvailabilityBlockReleaseScheduleInput: InternalUpdateAccommodationAvailabilityBlockReleaseScheduleInput;
  InternalUpdateAccommodationEquipmentInput: InternalUpdateAccommodationEquipmentInput;
  InternalUpdateAccommodationEquipmentPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateAccommodationEquipmentPayload"]
  >;
  InternalUpdateAccommodationOperationGroupSettingError: ResolverTypeWrapper<
    Omit<InternalUpdateAccommodationOperationGroupSettingError, "case"> & {
      case: ResolversTypes["InternalUpdateAccommodationOperationGroupSettingErrorCase"];
    }
  >;
  InternalUpdateAccommodationOperationGroupSettingErrorCase: ResolverTypeWrapper<
    | "NotFound"
    | "SiteReservable"
    | "UserOwnershipExists"
    | "InvalidAdditionalFee"
  >;
  InternalUpdateAccommodationOperationGroupSettingInput: InternalUpdateAccommodationOperationGroupSettingInput;
  InternalUpdateAccommodationOperationGroupSettingPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateAccommodationOperationGroupSettingPayload"]
  >;
  InternalUpdateAccommodationReservationInput: InternalUpdateAccommodationReservationInput;
  InternalUpdateAreaContentInput: InternalUpdateAreaContentInput;
  InternalUpdateAreaError: ResolverTypeWrapper<
    Omit<InternalUpdateAreaError, "case"> & {
      case: ResolversTypes["InternalUpdateAreaErrorCase"];
    }
  >;
  InternalUpdateAreaErrorCase: ResolverTypeWrapper<"OptimisticLockConflict">;
  InternalUpdateAreaInput: InternalUpdateAreaInput;
  InternalUpdateAreaPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateAreaPayload"]
  >;
  InternalUpdateCoOwnersApplicationDetailError: ResolverTypeWrapper<
    Omit<InternalUpdateCoOwnersApplicationDetailError, "case"> & {
      case: ResolversTypes["InternalUpdateCoOwnersApplicationDetailErrorCase"];
    }
  >;
  InternalUpdateCoOwnersApplicationDetailErrorCase: ResolverTypeWrapper<
    "NotFound" | "DetailTypeMismatch"
  >;
  InternalUpdateCoOwnersApplicationDetailPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateCoOwnersApplicationDetailPayload"]
  >;
  InternalUpdateCoOwnersApplicationFileError: ResolverTypeWrapper<
    Omit<InternalUpdateCoOwnersApplicationFileError, "case"> & {
      case: ResolversTypes["InternalUpdateCoOwnersApplicationFileErrorCase"];
    }
  >;
  InternalUpdateCoOwnersApplicationFileErrorCase: ResolverTypeWrapper<"NotFound">;
  InternalUpdateCoOwnersApplicationFilePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateCoOwnersApplicationFilePayload"]
  >;
  InternalUpdateCoOwnersApplicationInfoError: ResolverTypeWrapper<
    Omit<InternalUpdateCoOwnersApplicationInfoError, "case"> & {
      case: ResolversTypes["InternalUpdateCoOwnersApplicationInfoErrorCase"];
    }
  >;
  InternalUpdateCoOwnersApplicationInfoErrorCase: ResolverTypeWrapper<
    "NotFound" | "IdDocument1Invalid" | "IdDocument2Invalid" | "InvalidInput"
  >;
  InternalUpdateCoOwnersApplicationInfoPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateCoOwnersApplicationInfoPayload"]
  >;
  InternalUpdateCoOwnersApplicationStatusError: ResolverTypeWrapper<
    Omit<InternalUpdateCoOwnersApplicationStatusError, "case"> & {
      case: ResolversTypes["InternalUpdateCoOwnersApplicationStatusErrorCase"];
    }
  >;
  InternalUpdateCoOwnersApplicationStatusErrorCase: ResolverTypeWrapper<
    | "NotFound"
    | "InvalidStatusTransition"
    | "MissingDesiredHandoverDate"
    | "IdentityVerificationNotApproved"
  >;
  InternalUpdateCoOwnersApplicationStatusPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateCoOwnersApplicationStatusPayload"]
  >;
  InternalUpdateFacilityContentImagesInput: InternalUpdateFacilityContentImagesInput;
  InternalUpdateFacilityContentImagesPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateFacilityContentImagesPayload"]
  >;
  InternalUpdateFacilityInput: InternalUpdateFacilityInput;
  InternalUpdateFacilityReservationCleaningError: ResolverTypeWrapper<
    Omit<InternalUpdateFacilityReservationCleaningError, "case"> & {
      case: ResolversTypes["InternalUpdateFacilityReservationCleaningErrorCase"];
    }
  >;
  InternalUpdateFacilityReservationCleaningErrorCase: ResolverTypeWrapper<"ReservationNotFound">;
  InternalUpdateFacilityReservationCleaningPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateFacilityReservationCleaningPayload"]
  >;
  InternalUpdateFacilityReservationDataSyncError: ResolverTypeWrapper<
    Omit<InternalUpdateFacilityReservationDataSyncError, "case"> & {
      case: ResolversTypes["InternalUpdateFacilityReservationDataSyncErrorCase"];
    }
  >;
  InternalUpdateFacilityReservationDataSyncErrorCase: ResolverTypeWrapper<"ReservationNotFound">;
  InternalUpdateFacilityReservationDataSyncPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateFacilityReservationDataSyncPayload"]
  >;
  InternalUpdateIdentityVerificationError: ResolverTypeWrapper<
    Omit<InternalUpdateIdentityVerificationError, "case"> & {
      case: ResolversTypes["InternalUpdateIdentityVerificationErrorCase"];
    }
  >;
  InternalUpdateIdentityVerificationErrorCase: ResolverTypeWrapper<
    "NotFound" | "InvalidStatusTransition" | "ResultRequiredWhenVerified"
  >;
  InternalUpdateIdentityVerificationInput: InternalUpdateIdentityVerificationInput;
  InternalUpdateIdentityVerificationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateIdentityVerificationPayload"]
  >;
  InternalUpdateIndividualTermsDocumentError: ResolverTypeWrapper<
    Omit<InternalUpdateIndividualTermsDocumentError, "case"> & {
      case: ResolversTypes["InternalUpdateIndividualTermsDocumentErrorCase"];
    }
  >;
  InternalUpdateIndividualTermsDocumentErrorCase: ResolverTypeWrapper<
    "InvalidInput" | "ResourceNotFound"
  >;
  InternalUpdateIndividualTermsDocumentInput: InternalUpdateIndividualTermsDocumentInput;
  InternalUpdateIndividualTermsDocumentPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateIndividualTermsDocumentPayload"]
  >;
  InternalUpdateInspectionViolationHandlingError: ResolverTypeWrapper<
    Omit<InternalUpdateInspectionViolationHandlingError, "case"> & {
      case: ResolversTypes["InternalUpdateInspectionViolationHandlingErrorCase"];
    }
  >;
  InternalUpdateInspectionViolationHandlingErrorCase: ResolverTypeWrapper<
    | "InspectionReportNotFound"
    | "ViolationNotReported"
    | "SeverityNotAssessed"
    | "NothingToUpdate"
  >;
  InternalUpdateInspectionViolationHandlingInput: InternalUpdateInspectionViolationHandlingInput;
  InternalUpdateInspectionViolationHandlingPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateInspectionViolationHandlingPayload"]
  >;
  InternalUpdateLocalTaxPolicyError: ResolverTypeWrapper<
    Omit<InternalUpdateLocalTaxPolicyError, "case"> & {
      case: ResolversTypes["InternalUpdateLocalTaxPolicyErrorCase"];
    }
  >;
  InternalUpdateLocalTaxPolicyErrorCase: ResolverTypeWrapper<
    | "EffectiveToBeforeEffectiveFrom"
    | "OverlappingEffectivePeriod"
    | "UsedAfterEffectiveTo"
  >;
  InternalUpdateLocalTaxPolicyInput: InternalUpdateLocalTaxPolicyInput;
  InternalUpdateLocalTaxPolicyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateLocalTaxPolicyPayload"]
  >;
  InternalUpdateRoomTypeContentInput: InternalUpdateRoomTypeContentInput;
  InternalUpdateRoomTypeInput: InternalUpdateRoomTypeInput;
  InternalUpdateSiteActivityProgramInput: InternalUpdateSiteActivityProgramInput;
  InternalUpdateSiteContentInput: InternalUpdateSiteContentInput;
  InternalUpdateSiteError: ResolverTypeWrapper<
    Omit<InternalUpdateSiteError, "case"> & {
      case: ResolversTypes["InternalUpdateSiteErrorCase"];
    }
  >;
  InternalUpdateSiteErrorCase: ResolverTypeWrapper<
    | "OptimisticLockConflict"
    | "RemoteLockLocationNotFound"
    | "OperationGroupSettingMissing"
    | "SiteNotPublished"
  >;
  InternalUpdateSiteHighSeasonPeriodInput: InternalUpdateSiteHighSeasonPeriodInput;
  InternalUpdateSiteImagesPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateSiteImagesPayload"]
  >;
  InternalUpdateSiteInput: InternalUpdateSiteInput;
  InternalUpdateSiteParametersError: ResolverTypeWrapper<InternalUpdateSiteParametersError>;
  InternalUpdateSiteParametersInput: InternalUpdateSiteParametersInput;
  InternalUpdateSiteParametersPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateSiteParametersPayload"]
  >;
  InternalUpdateSitePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateSitePayload"]
  >;
  InternalUpdateStayTicketInput: InternalUpdateStayTicketInput;
  InternalUpdateStayTicketInvalidStatusError: ResolverTypeWrapper<InternalUpdateStayTicketInvalidStatusError>;
  InternalUpdateStayTicketNotFoundError: ResolverTypeWrapper<InternalUpdateStayTicketNotFoundError>;
  InternalUpdateStayTicketPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpdateStayTicketPayload"]
  >;
  InternalUpdateUserInput: InternalUpdateUserInput;
  InternalUpsertBaseAccommodationFeeDailyRateError: ResolverTypeWrapper<InternalUpsertBaseAccommodationFeeDailyRateError>;
  InternalUpsertBaseAccommodationFeeDailyRateInput: InternalUpsertBaseAccommodationFeeDailyRateInput;
  InternalUpsertBaseAccommodationFeeDailyRatesPayload: ResolverTypeWrapper<InternalUpsertBaseAccommodationFeeDailyRatesPayload>;
  InternalUpsertConsumedSupplyFeeItemWaiversError: ResolverTypeWrapper<InternalUpsertConsumedSupplyFeeItemWaiversError>;
  InternalUpsertConsumedSupplyFeeItemWaiversInput: InternalUpsertConsumedSupplyFeeItemWaiversInput;
  InternalUpsertConsumedSupplyFeeItemWaiversPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalUpsertConsumedSupplyFeeItemWaiversPayload"]
  >;
  InternalUserSearchResult: ResolverTypeWrapper<
    Omit<InternalUserSearchResult, "users"> & {
      users: Array<ResolversTypes["User"]>;
    }
  >;
  InternalUserStats: ResolverTypeWrapper<InternalUserStats>;
  InternalVoidCoOwnersApplicationError: ResolverTypeWrapper<
    Omit<InternalVoidCoOwnersApplicationError, "case"> & {
      case: ResolversTypes["InternalVoidCoOwnersApplicationErrorCase"];
    }
  >;
  InternalVoidCoOwnersApplicationErrorCase: ResolverTypeWrapper<
    | "NotFound"
    | "PermissionDenied"
    | "InvalidStatusTransition"
    | "HasActiveReservations"
    | "HasActiveStayGifts"
    | "OwnershipNotFound"
  >;
  InternalVoidCoOwnersApplicationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InternalVoidCoOwnersApplicationPayload"]
  >;
  InviteBusinessMembersError: ResolverTypeWrapper<
    Omit<InviteBusinessMembersError, "case"> & {
      case: ResolversTypes["InviteBusinessMembersErrorCase"];
    }
  >;
  InviteBusinessMembersErrorCase: ResolverTypeWrapper<
    | "NotOrganizationAdmin"
    | "EmptyEmails"
    | "ExceedsMaxRecipients"
    | "InvalidEmailFormat"
  >;
  InviteBusinessMembersInput: InviteBusinessMembersInput;
  InviteBusinessMembersPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["InviteBusinessMembersPayload"]
  >;
  InviteBusinessMembersSuccess: ResolverTypeWrapper<InviteBusinessMembersSuccess>;
  IssueSanuEdgeDeviceAccessTokenError: ResolverTypeWrapper<
    Omit<IssueSanuEdgeDeviceAccessTokenError, "case"> & {
      case: ResolversTypes["IssueSanuEdgeDeviceAccessTokenErrorCase"];
    }
  >;
  IssueSanuEdgeDeviceAccessTokenErrorCase: ResolverTypeWrapper<
    "ReservationNotFound" | "Unauthorized" | "DeviceNotAccessible" | "NoDevice"
  >;
  IssueSanuEdgeDeviceAccessTokenInput: IssueSanuEdgeDeviceAccessTokenInput;
  IssueSanuEdgeDeviceAccessTokenPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["IssueSanuEdgeDeviceAccessTokenPayload"]
  >;
  IssueSanuEdgeDeviceAccessTokenSuccess: ResolverTypeWrapper<
    Omit<IssueSanuEdgeDeviceAccessTokenSuccess, "device"> & {
      device: ResolversTypes["SanuEdgeDevice"];
    }
  >;
  IssueStayTicketsError: ResolverTypeWrapper<
    Omit<IssueStayTicketsError, "case"> & {
      case: ResolversTypes["IssueStayTicketsErrorCase"];
    }
  >;
  IssueStayTicketsErrorCase: ResolverTypeWrapper<"InvalidRequest">;
  IssueStayTicketsInput: IssueStayTicketsInput;
  IssueStayTicketsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["IssueStayTicketsPayload"]
  >;
  IssueStayTicketsResult: ResolverTypeWrapper<
    Omit<IssueStayTicketsResult, "tickets"> & {
      tickets: Array<ResolversTypes["StayTicket"]>;
    }
  >;
  JoinOrganizationError: ResolverTypeWrapper<
    Omit<JoinOrganizationError, "case"> & {
      case: ResolversTypes["JoinOrganizationErrorCase"];
    }
  >;
  JoinOrganizationErrorCase: ResolverTypeWrapper<"AlreadyBelongsToOrganization">;
  JoinOrganizationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["JoinOrganizationPayload"]
  >;
  LeaveOrganizationByViewerError: ResolverTypeWrapper<
    Omit<LeaveOrganizationByViewerError, "case"> & {
      case: ResolversTypes["LeaveOrganizationErrorCase"];
    }
  >;
  LeaveOrganizationByViewerPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["LeaveOrganizationByViewerPayload"]
  >;
  LeaveOrganizationError: ResolverTypeWrapper<
    Omit<LeaveOrganizationError, "case"> & {
      case: ResolversTypes["LeaveOrganizationErrorCase"];
    }
  >;
  LeaveOrganizationErrorCase: ResolverTypeWrapper<
    "HasActiveReservation" | "NotBelongsToOrganization"
  >;
  LoadDataOutput: ResolverTypeWrapper<LoadDataOutput>;
  LoadDataOutputResult: ResolverTypeWrapper<LoadDataOutputResult>;
  LoadDataOutputResultError: ResolverTypeWrapper<LoadDataOutputResultError>;
  LoadDataTarget: ResolverTypeWrapper<
    | "all"
    | "asset"
    | "business"
    | "user"
    | "announcement"
    | "ticket"
    | "owner"
    | "reservation"
  >;
  LocalTaxBracket: ResolverTypeWrapper<LocalTaxBracketMapper>;
  LocalTaxPolicy: ResolverTypeWrapper<LocalTaxPolicyMapper>;
  LocalTaxPolicyType: ResolverTypeWrapper<
    "FixedAmount" | "SteppedAmount" | "FixedRate"
  >;
  LocalTaxType: ResolverTypeWrapper<"AccommodationTax" | "BathingTax">;
  MemberPerksNowhereDrinkTicket: ResolverTypeWrapper<MemberPerksNowhereDrinkTicketMapper>;
  MusicConnectEquipmentAttribute: ResolverTypeWrapper<MusicConnectEquipmentAttributeMapper>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  NativeAppHomeContent: ResolverTypeWrapper<NativeAppHomeContentMapper>;
  NativeAppHomeContentLabel: ResolverTypeWrapper<
    Omit<NativeAppHomeContentLabel, "type"> & {
      type: ResolversTypes["NativeAppHomeContentLabelType"];
    }
  >;
  NativeAppHomeContentLabelType: ResolverTypeWrapper<"Default" | "Accent">;
  NativeAppHomeContentLink: ResolverTypeWrapper<
    Omit<NativeAppHomeContentLink, "action"> & {
      action: ResolversTypes["NativeAppHomeContentLinkAction"];
    }
  >;
  NativeAppHomeContentLinkAction: ResolverTypeWrapper<
    "Sheet" | "FullSheet" | "DrillDown" | "ExternalBrowser"
  >;
  NativeAppHomeContentStatus: ResolverTypeWrapper<
    "Draft" | "Active" | "Unpublished"
  >;
  News: ResolverTypeWrapper<NewsMapper>;
  NewsContentType: ResolverTypeWrapper<
    "HTML" | "ExternalLink" | "InternalPage"
  >;
  NewsDisplayCategory: ResolverTypeWrapper<
    "Notice" | "ServiceUpdate" | "NewsLetterArticle"
  >;
  NewsStatus: ResolverTypeWrapper<"Active" | "Draft" | "Unpublished">;
  OccupancyLimitTarget: ResolverTypeWrapper<"Unrestricted" | "Guest">;
  OccupancyLimitTargetType: ResolverTypeWrapper<
    "Guest" | "OrganizationMember" | "StandardSubscriber" | "Unrestricted"
  >;
  OneMoreCabinAccommodationReservationProvider: ResolverTypeWrapper<OneMoreCabinAccommodationReservationProvider>;
  OnlineTravelAgentAccommodationReservationProvider: ResolverTypeWrapper<OnlineTravelAgentAccommodationReservationProvider>;
  OnsenAccommodationFacility: ResolverTypeWrapper<OnsenAccommodationFacility>;
  OnsenAndSaunaDoorLock: ResolverTypeWrapper<OnsenAndSaunaDoorLock>;
  Organization: ResolverTypeWrapper<OrganizationMapper>;
  OrganizationControl: ResolverTypeWrapper<OrganizationControl>;
  OrganizationMemberCustomField: ResolverTypeWrapper<OrganizationMemberCustomField>;
  OrganizationMemberNewReservationStatus: ResolverTypeWrapper<OrganizationMemberNewReservationStatus>;
  OrganizationMemberPayload: ResolverTypeWrapper<
    Omit<OrganizationMemberPayload, "user"> & { user: ResolversTypes["User"] }
  >;
  OrganizationMemberReservationStatus: ResolverTypeWrapper<
    "Usable" | "NotUsable"
  >;
  OrganizationMembersStay: ResolverTypeWrapper<OrganizationMembersStayMapper>;
  OrganizationMembership: ResolverTypeWrapper<OrganizationMembershipMapper>;
  OrganizationMonthlyReservationStatus: ResolverTypeWrapper<OrganizationMonthlyReservationStatus>;
  OrganizationOnboardingInfo: ResolverTypeWrapper<OrganizationOnboardingInfo>;
  OrganizationPlanMonthlyConsumedNights: ResolverTypeWrapper<OrganizationPlanMonthlyConsumedNights>;
  OrganizationRole: ResolverTypeWrapper<"Admin" | "Member">;
  OrganizationYearlyContract: ResolverTypeWrapper<OrganizationYearlyContractMapper>;
  OrganizationYearlyContractInvoiceFrequency: ResolverTypeWrapper<
    "Yearly" | "Monthly"
  >;
  OrganizationYearlyContractInvoicePaymentMethodType: ResolverTypeWrapper<
    "BankTransfer" | "CreditCard"
  >;
  OrganizationYearlyContractInvoicesResult: ResolverTypeWrapper<
    Omit<OrganizationYearlyContractInvoicesResult, "data"> & {
      data: Array<ResolversTypes["StripeInvoice"]>;
    }
  >;
  OrganizationYearlyContractSortField: ResolverTypeWrapper<
    | "CreatedAt"
    | "StartMonth"
    | "EndMonth"
    | "OrganizationName"
    | "Status"
    | "ContinuationType"
  >;
  OrganizationYearlyContractSortInput: OrganizationYearlyContractSortInput;
  OrganizationYearlyContractsResult: ResolverTypeWrapper<
    Omit<OrganizationYearlyContractsResult, "data"> & {
      data: Array<ResolversTypes["OrganizationYearlyContract"]>;
    }
  >;
  OrganizationYearlyReservationStatus: ResolverTypeWrapper<OrganizationYearlyReservationStatus>;
  OtaReservationLookupError: ResolverTypeWrapper<
    Omit<OtaReservationLookupError, "case"> & {
      case: ResolversTypes["OtaReservationLookupErrorCase"];
    }
  >;
  OtaReservationLookupErrorCase: ResolverTypeWrapper<"AlreadyRegistered">;
  OtaReservationLookupResult: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["OtaReservationLookupResult"]
  >;
  OtaReservationLookupSuccess: ResolverTypeWrapper<
    Omit<OtaReservationLookupSuccess, "facilityTypes"> & {
      facilityTypes: Array<ResolversTypes["AccommodationFacilityType"]>;
    }
  >;
  OwnerIntendedUsageType: ResolverTypeWrapper<
    | "WeekdaysOnly"
    | "MainlyWeekdays"
    | "WeekendsOnly"
    | "MainlyWeekends"
    | "LongVacation"
  >;
  OwnerOrganizationBeneficialOwnerRelationshipType: ResolverTypeWrapper<
    "Representative" | "Shareholder" | "Creditor" | "Other"
  >;
  OwnerOrganizationBusinessActivityType: ResolverTypeWrapper<
    | "RealEstate"
    | "Construction"
    | "Manufacturing"
    | "Service"
    | "Transportation"
    | "WholesaleRetail"
    | "FinanceInsurance"
    | "Other"
  >;
  OwnerOrganizationRelationshipType: ResolverTypeWrapper<
    "Representative" | "TransactionManager"
  >;
  OwnerPlan: ResolverTypeWrapper<OwnerPlanMapper>;
  OwnerPlanType: ResolverTypeWrapper<"CoOwners" | "FullOwner">;
  OwnerPurchasePurposeType: ResolverTypeWrapper<"SelfUse" | "Other">;
  PartialUpdateOrganizationError: ResolverTypeWrapper<PartialUpdateOrganizationError>;
  PartialUpdateOrganizationInput: PartialUpdateOrganizationInput;
  PartialUpdateOrganizationMembershipError: ResolverTypeWrapper<PartialUpdateOrganizationMembershipError>;
  PartialUpdateOrganizationMembershipInput: PartialUpdateOrganizationMembershipInput;
  PartialUpdateOrganizationMembershipPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["PartialUpdateOrganizationMembershipPayload"]
  >;
  PartialUpdateOrganizationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["PartialUpdateOrganizationPayload"]
  >;
  PaymentMethodType: ResolverTypeWrapper<"Card" | "BankTransfer">;
  PlainDate: ResolverTypeWrapper<Scalars["PlainDate"]["output"]>;
  PlainDateTime: ResolverTypeWrapper<Scalars["PlainDateTime"]["output"]>;
  PlainYearMonth: ResolverTypeWrapper<Scalars["PlainYearMonth"]["output"]>;
  PlainYearMonthFilter: PlainYearMonthFilter;
  PlugDevice: ResolverTypeWrapper<PlugDeviceMapper>;
  PlugDeviceStatus: ResolverTypeWrapper<"InUse" | "Available" | "Unknown">;
  PostStayReviewResponseError: ResolverTypeWrapper<
    Omit<PostStayReviewResponseError, "case"> & {
      case: ResolversTypes["PostStayReviewResponseErrorCase"];
    }
  >;
  PostStayReviewResponseErrorCase: ResolverTypeWrapper<
    "NotAuthorized" | "QuestionnaireNotFound" | "ValidationError"
  >;
  PostStayReviewResponseInput: PostStayReviewResponseInput;
  PostStayReviewResponsePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["PostStayReviewResponsePayload"]
  >;
  PriceWithTaxRate: ResolverTypeWrapper<PriceWithTaxRate>;
  ProcessCronJobResponse: ResolverTypeWrapper<ProcessCronJobResponse>;
  ProcessStripeEventResponse: ResolverTypeWrapper<ProcessStripeEventResponse>;
  ProcessTrustdockEventResponse: ResolverTypeWrapper<ProcessTrustdockEventResponse>;
  PushNotificationPlatform: ResolverTypeWrapper<"Android" | "Apple">;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  RawBaseAccommodationFeePolicy: ResolverTypeWrapper<
    Omit<RawBaseAccommodationFeePolicy, "feeModifierType" | "feeRules"> & {
      feeModifierType?: Maybe<ResolversTypes["FeeModifierType"]>;
      feeRules: Array<ResolversTypes["AccommodationFeeRule"]>;
    }
  >;
  RawCancelFeePolicy: ResolverTypeWrapper<
    Omit<RawCancelFeePolicy, "cancelFeePolicy"> & {
      cancelFeePolicy: ResolversTypes["CancelFeePolicy"];
    }
  >;
  RawNews: ResolverTypeWrapper<RawNewsMapper>;
  RawSiteFaq: ResolverTypeWrapper<RawSiteFaqMapper>;
  RedirectLocation: ResolverTypeWrapper<RedirectLocation>;
  RegisterCoOwnersApplicationFileError: ResolverTypeWrapper<
    Omit<RegisterCoOwnersApplicationFileError, "case"> & {
      case: ResolversTypes["RegisterCoOwnersApplicationFileErrorCase"];
    }
  >;
  RegisterCoOwnersApplicationFileErrorCase: ResolverTypeWrapper<
    "NotFound" | "InvalidFile" | "FileNotUploaded" | "AlreadyRegistered"
  >;
  RegisterCoOwnersApplicationFileInput: RegisterCoOwnersApplicationFileInput;
  RegisterCoOwnersApplicationFilePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["RegisterCoOwnersApplicationFilePayload"]
  >;
  RegisterCoOwnersApplicationFileSuccess: ResolverTypeWrapper<
    Omit<RegisterCoOwnersApplicationFileSuccess, "file"> & {
      file: ResolversTypes["CoOwnersApplicationFile"];
    }
  >;
  RemoveIdentityError: ResolverTypeWrapper<
    Omit<RemoveIdentityError, "case"> & {
      case: ResolversTypes["RemoveIdentityErrorCase"];
    }
  >;
  RemoveIdentityErrorCase: ResolverTypeWrapper<
    | "LastIdentity"
    | "IdentityNotFound"
    | "Unauthorized"
    | "NoVerifiedRemaining"
    | "PasswordNotSet"
    | "AppleTokenRevocationFailed"
  >;
  RemoveIdentityInput: RemoveIdentityInput;
  RemoveIdentityPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["RemoveIdentityPayload"]
  >;
  RemoveIdentitySuccess: ResolverTypeWrapper<
    Omit<RemoveIdentitySuccess, "removedProvider"> & {
      removedProvider: ResolversTypes["IdentityProvider"];
    }
  >;
  RentalCycleKeyBox: ResolverTypeWrapper<RentalCycleKeyBox>;
  ReservationExportItem: ResolverTypeWrapper<
    Omit<ReservationExportItem, "stayStatus"> & {
      stayStatus: ResolversTypes["AccommodationReservationStayStatus"];
    }
  >;
  ReservationPriceStatement: ResolverTypeWrapper<ReservationPriceStatementMapper>;
  ReservationRuleRevision2027Policy: ResolverTypeWrapper<ReservationRuleRevision2027Policy>;
  ReservationStatementItem: ResolverTypeWrapper<ReservationStatementItemMapper>;
  ResourcePermission: ResolverTypeWrapper<
    | "UsersRead"
    | "UsersWrite"
    | "UsersIdentityRead"
    | "UserCompanionsRead"
    | "ReservationsRead"
    | "ReservationsWrite"
    | "ReservationsUse"
    | "AvailabilityBlocksRead"
    | "SitesRead"
    | "AccommodationsRead"
    | "InspectionsRead"
    | "FacilitiesRead"
    | "FacilityCleaningWrite"
    | "StayTicketsRead"
    | "OrganizationsRead"
    | "CoOwnersRead"
    | "FullOwnersRead"
    | "FullOwnersWrite"
    | "AdminRolesWrite"
    | "ScriptsUse"
    | "DevToolsUse"
    | "JtasSyncWrite"
  >;
  ResumeStandardSubscriptionImmediatelyError: ResolverTypeWrapper<
    Omit<ResumeStandardSubscriptionImmediatelyError, "case"> & {
      case: ResolversTypes["ResumeStandardSubscriptionImmediatelyErrorCase"];
    }
  >;
  ResumeStandardSubscriptionImmediatelyErrorCase: ResolverTypeWrapper<
    | "InvalidOperation"
    | "AlreadySubscribedError"
    | "NoSubscriptionScheduleError"
    | "UnexpectedSubscriptionScheduleStatus"
    | "StripeError"
  >;
  ResumeStandardSubscriptionImmediatelyPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["ResumeStandardSubscriptionImmediatelyPayload"]
  >;
  RoomType: ResolverTypeWrapper<RoomTypeMapper>;
  RoomTypeAvailabilities: ResolverTypeWrapper<RoomTypeAvailabilitiesMapper>;
  RoomTypeAvailability: ResolverTypeWrapper<RoomTypeAvailabilityMapper>;
  RoomTypeFeature: ResolverTypeWrapper<RoomTypeFeatureMapper>;
  RoomTypeFeatureCategory: ResolverTypeWrapper<
    "Amenity" | "Floor" | "Other" | "View"
  >;
  S2o: ResolverTypeWrapper<S2oMapper>;
  S2oPoint: ResolverTypeWrapper<S2oPointMapper>;
  S2oPointAdminTransactionType: ResolverTypeWrapper<
    | "TrialMonthlySubscriptionPayment"
    | "MonthlySubscriptionPayment"
    | "StayGuestPayment"
  >;
  S2oPointStatus: ResolverTypeWrapper<"Active" | "Expired" | "Unavailable">;
  S2oPointTransactionType: ResolverTypeWrapper<
    | "EnrollmentPayment"
    | "MonthlySubscriptionPayment"
    | "CancellationInvalidation"
    | "CoOwnerApplicationUsage"
    | "CoOwnerApplicationRefund"
    | "TrialMonthlySubscriptionPayment"
    | "TrialCancellationInvalidation"
    | "InvalidatedByAdmin"
    | "ManualAdjustment"
    | "StayGuestPayment"
  >;
  S3UploadPolicy: ResolverTypeWrapper<S3UploadPolicy>;
  S3UploadPolicyField: ResolverTypeWrapper<S3UploadPolicyField>;
  SanuEdgeDevice: ResolverTypeWrapper<SanuEdgeDeviceMapper>;
  SanuEdgeDeviceType: ResolverTypeWrapper<"SaunaControlUnit">;
  SanuFileType: ResolverTypeWrapper<
    | "CoOwnersEstimate"
    | "CoOwnersImportantMattersDocument"
    | "CoOwnersSalesContract"
    | "CoOwnersBuildingLeaseAgreement"
    | "CoOwnershipAgreement"
    | "CoOwnersHandoverDocument"
    | "CoOwnersOtherFiles"
    | "FullOwnerContract"
  >;
  SanuIncAccommodationReservationProvider: ResolverTypeWrapper<SanuIncAccommodationReservationProviderMapper>;
  SanuOwnerPlanUserFileType: ResolverTypeWrapper<
    | "CoOwnersImportantMatters"
    | "CoOwnersSaleContract"
    | "CoOwnersBuildingLeaseAgreement"
    | "CoOwnershipAgreement"
    | "CoOwnersHandoverDocuments"
  >;
  SaunaAccommodationFacility: ResolverTypeWrapper<SaunaAccommodationFacility>;
  SaunaEquipmentAttribute: ResolverTypeWrapper<SaunaEquipmentAttributeMapper>;
  SaveStayReviewV2DraftPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["SaveStayReviewV2DraftPayload"]
  >;
  ScheduleStandardSubscriptionPauseError: ResolverTypeWrapper<
    Omit<ScheduleStandardSubscriptionPauseError, "case"> & {
      case: ResolversTypes["ScheduleStandardSubscriptionPauseErrorCase"];
    }
  >;
  ScheduleStandardSubscriptionPauseErrorCase: ResolverTypeWrapper<
    | "InvalidOperation"
    | "NotPausableDateYet"
    | "ReservationExists"
    | "NoSubscriptionError"
    | "InvalidPauseDate"
    | "InvalidResumeDate"
    | "StripeError"
  >;
  ScheduleStandardSubscriptionPausePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["ScheduleStandardSubscriptionPausePayload"]
  >;
  ScheduleStandardSubscriptionTerminationError: ResolverTypeWrapper<
    Omit<ScheduleStandardSubscriptionTerminationError, "case"> & {
      case: ResolversTypes["ScheduleStandardSubscriptionTerminationErrorCase"];
    }
  >;
  ScheduleStandardSubscriptionTerminationErrorCase: ResolverTypeWrapper<
    | "InvalidOperation"
    | "NotPausableDateYet"
    | "ReservationExists"
    | "NoSubscriptionError"
    | "StripeError"
  >;
  ScheduleStandardSubscriptionTerminationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["ScheduleStandardSubscriptionTerminationPayload"]
  >;
  ScopeDimension: ResolverTypeWrapper<"Site">;
  ScriptExecutionStatus: ResolverTypeWrapper<"Running" | "Success" | "Failed">;
  ScriptLogLevel: ResolverTypeWrapper<"Info" | "Warn" | "Error">;
  SeasonalFeeSetting: ResolverTypeWrapper<SeasonalFeeSettingMapper>;
  SelectWebinarScheduleError: ResolverTypeWrapper<
    Omit<SelectWebinarScheduleError, "case"> & {
      case: ResolversTypes["SelectWebinarScheduleErrorCase"];
    }
  >;
  SelectWebinarScheduleErrorCase: ResolverTypeWrapper<
    | "AlreadySelected"
    | "ApplicationNotFound"
    | "PermissionDenied"
    | "InvalidWebinarSchedule"
    | "AlreadyCompleted"
  >;
  SelectWebinarSchedulePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["SelectWebinarSchedulePayload"]
  >;
  SendEmailToVerifyEmailInput: SendEmailToVerifyEmailInput;
  SendEmailToVerifyNewEmailError: ResolverTypeWrapper<
    Omit<SendEmailToVerifyNewEmailError, "case"> & {
      case: ResolversTypes["SendEmailToVerifyNewEmailErrorCase"];
    }
  >;
  SendEmailToVerifyNewEmailErrorCase: ResolverTypeWrapper<
    | "GeneralError"
    | "EmailAlreadyUsed"
    | "SameEmail"
    | "NoEmailPasswordIdentity"
    | "InvalidEmailFormat"
  >;
  SendEmailToVerifyNewEmailInput: SendEmailToVerifyNewEmailInput;
  SendEmailToVerifyNewEmailPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["SendEmailToVerifyNewEmailPayload"]
  >;
  SendEmailToVerifyNewEmailSuccess: ResolverTypeWrapper<SendEmailToVerifyNewEmailSuccess>;
  SendPasswordResetEmailError: ResolverTypeWrapper<
    Omit<SendPasswordResetEmailError, "case"> & {
      case?: Maybe<ResolversTypes["SendPasswordResetEmailErrorCase"]>;
    }
  >;
  SendPasswordResetEmailErrorCase: ResolverTypeWrapper<"GeneralError">;
  SendPasswordResetEmailPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["SendPasswordResetEmailPayload"]
  >;
  SendPasswordResetEmailSuccess: ResolverTypeWrapper<SendPasswordResetEmailSuccess>;
  ServiceUpdate: ResolverTypeWrapper<ServiceUpdate>;
  Site: ResolverTypeWrapper<SiteMapper>;
  SiteAccessRouteGroup: ResolverTypeWrapper<SiteAccessRouteGroupMapper>;
  SiteAccessRoutePoint: ResolverTypeWrapper<SiteAccessRoutePointMapper>;
  SiteActivityProgram: ResolverTypeWrapper<SiteActivityProgramMapper>;
  SiteAvailabilityNight: ResolverTypeWrapper<SiteAvailabilityNightMapper>;
  SiteContent: ResolverTypeWrapper<SiteContentMapper>;
  SiteFaq: ResolverTypeWrapper<SiteFaq>;
  SiteHighSeasonPeriod: ResolverTypeWrapper<SiteHighSeasonPeriod>;
  SortDirection: ResolverTypeWrapper<"Asc" | "Desc">;
  StaffAccessKeyTrigger: ResolverTypeWrapper<
    | "CronJob"
    | "CreateReserve"
    | "ChangeReserve"
    | "CancelReserve"
    | "CheckOutReserve"
  >;
  StaffContract: ResolverTypeWrapper<StaffContractMapper>;
  StaffContractStatus: ResolverTypeWrapper<"Neutral" | "Usable">;
  StaffContractStatusDetail: ResolverTypeWrapper<
    "NeutralDefault" | "NeutralTerminated" | "UsableDefault"
  >;
  StaffGroup: ResolverTypeWrapper<StaffGroupMapper>;
  StaffGroupStatus: ResolverTypeWrapper<"Active" | "Inactive">;
  StaffPlanAccommodationReservationProvider: ResolverTypeWrapper<StaffPlanAccommodationReservationProvider>;
  StaffSemester: ResolverTypeWrapper<"First" | "Second">;
  StaffSemesterCredit: ResolverTypeWrapper<
    Omit<StaffSemesterCredit, "semester"> & {
      semester: ResolversTypes["StaffSemester"];
    }
  >;
  StaffStayCreditTransactionStatus: ResolverTypeWrapper<
    "Open" | "Finalized" | "Void"
  >;
  StaffStayCreditTransactionType: ResolverTypeWrapper<
    | "GrantByManual"
    | "GrantByBatch"
    | "RedeemByReserve"
    | "RedeemByNoShow"
    | "RedeemByCancel"
  >;
  StaffType: ResolverTypeWrapper<"Permanent" | "Contractor">;
  StandardPlanAccommodationReservationProvider: ResolverTypeWrapper<StandardPlanAccommodationReservationProvider>;
  StayCreditBreakdownItem: ResolverTypeWrapper<StayCreditBreakdownItem>;
  StayCreditEstimate: ResolverTypeWrapper<StayCreditEstimate>;
  StayDirectAccommodationReservationProvider: ResolverTypeWrapper<StayDirectAccommodationReservationProvider>;
  StayGiftExportItem: ResolverTypeWrapper<
    Omit<StayGiftExportItem, "status"> & {
      status: ResolversTypes["StayTicketStatusType"];
    }
  >;
  StayReview: ResolverTypeWrapper<StayReviewMapper>;
  StayReviewAxis: ResolverTypeWrapper<
    "ArchitectureAndNature" | "Cleaning" | "Equipment" | "GuidanceAndSupport"
  >;
  StayReviewAxisDefinition: ResolverTypeWrapper<
    Omit<StayReviewAxisDefinition, "axis" | "concernKinds"> & {
      axis: ResolversTypes["StayReviewAxis"];
      concernKinds: Array<ResolversTypes["StayReviewConcernKindDefinition"]>;
    }
  >;
  StayReviewConcernDetail: ResolverTypeWrapper<
    | "NoiseFromNeighborRoom"
    | "NoiseFromEquipment"
    | "NoiseFromOutside"
    | "FarFromStationOrAirport"
    | "NarrowRoad"
    | "FarFromShops"
    | "FewRestaurants"
    | "SupportUnreachable"
    | "SupportSlowResponse"
    | "SupportOperatorQuality"
    | "KeyDidNotOpen"
    | "CheckInProcedureUnclear"
    | "PoorSignalForKey"
    | "CheckOutGuideNotFound"
    | "CheckOutTooManyTasks"
    | "SignageOrEntranceUnclear"
    | "RouteOrNavigationFailed"
    | "ParkingLocationUnclear"
    | "DarkAtNight"
    | "ParkingFarOrRoughRoad"
  >;
  StayReviewConcernDetailOption: ResolverTypeWrapper<
    Omit<StayReviewConcernDetailOption, "value"> & {
      value: ResolversTypes["StayReviewConcernDetail"];
    }
  >;
  StayReviewConcernKind: ResolverTypeWrapper<
    | "BuildingDefect"
    | "Insects"
    | "Noise"
    | "LocationAccess"
    | "ArchitectureAndNatureOther"
    | "Dirt"
    | "TrashOrHair"
    | "Odor"
    | "CleaningOther"
    | "Breakage"
    | "Shortage"
    | "UsageUnclear"
    | "EquipmentOther"
    | "Support"
    | "KeyOrCheckIn"
    | "CheckOut"
    | "ArrivalGuidanceOrParking"
    | "GuidanceAndSupportOther"
  >;
  StayReviewConcernKindDefinition: ResolverTypeWrapper<
    Omit<StayReviewConcernKindDefinition, "details" | "kind"> & {
      details: Array<ResolversTypes["StayReviewConcernDetailOption"]>;
      kind: ResolversTypes["StayReviewConcernKind"];
    }
  >;
  StayReviewExperienceType: ResolverTypeWrapper<
    "PickingFlowers" | "MakingDinner" | "DrinkingCoffee" | "NotApplicable"
  >;
  StayReviewFoodExperienceType: ResolverTypeWrapper<
    | "FrozenPizza"
    | "FrozenBread"
    | "Soup"
    | "Wine"
    | "HerbGarden"
    | "NotUsedOrNotApplicable"
  >;
  StayReviewFreeTextQuestion: ResolverTypeWrapper<StayReviewFreeTextQuestion>;
  StayReviewMemorableExperience: ResolverTypeWrapper<
    | "NatureSoundsAndScenery"
    | "SeasonsAndCreatures"
    | "TimeWithFamilyAndFriends"
    | "FocusedOnOwnTime"
    | "OutdoorActivities"
    | "ComfortableSpace"
  >;
  StayReviewMemorableExperienceOption: ResolverTypeWrapper<
    Omit<StayReviewMemorableExperienceOption, "value"> & {
      value: ResolversTypes["StayReviewMemorableExperience"];
    }
  >;
  StayReviewPosterViewType: ResolverTypeWrapper<
    | "NotSeenOrNoticed"
    | "SeenButNoImpression"
    | "SeenAndLiked"
    | "SeenAndWantToTry"
    | "TriedExperience"
    | "TookPosterHome"
  >;
  StayReviewQuestionnaire: ResolverTypeWrapper<StayReviewQuestionnaireMapper>;
  StayReviewResponse: ResolverTypeWrapper<StayReviewResponseMapper>;
  StayReviewResponseWithReservation: ResolverTypeWrapper<StayReviewResponseWithReservationMapper>;
  StayReviewSelectionOption: ResolverTypeWrapper<StayReviewSelectionOption>;
  StayReviewSelectionQuestion: ResolverTypeWrapper<StayReviewSelectionQuestion>;
  StayReviewSignResponseType: ResolverTypeWrapper<
    "Difficult" | "NoProblem" | "NotUseOrRemember"
  >;
  StayReviewV2: ResolverTypeWrapper<StayReviewV2Mapper>;
  StayReviewV2Concern: ResolverTypeWrapper<StayReviewV2ConcernMapper>;
  StayReviewV2ConcernInput: StayReviewV2ConcernInput;
  StayReviewV2Error: ResolverTypeWrapper<
    Omit<StayReviewV2Error, "case"> & {
      case: ResolversTypes["StayReviewV2ErrorCase"];
    }
  >;
  StayReviewV2ErrorCase: ResolverTypeWrapper<
    "NotAuthorized" | "OutOfPeriod" | "ValidationError" | "AlreadySubmitted"
  >;
  StayReviewV2Form: ResolverTypeWrapper<
    Omit<StayReviewV2Form, "axes" | "memorableExperiences"> & {
      axes: Array<ResolversTypes["StayReviewAxisDefinition"]>;
      memorableExperiences: Array<
        ResolversTypes["StayReviewMemorableExperienceOption"]
      >;
    }
  >;
  StayReviewV2Input: StayReviewV2Input;
  StayTicket: ResolverTypeWrapper<StayTicketMapper>;
  StayTicketAccommodationReservationProvider: ResolverTypeWrapper<StayTicketAccommodationReservationProvider>;
  StayTicketAcquisitionItem: StayTicketAcquisitionItem;
  StayTicketAcquisitionMode: ResolverTypeWrapper<
    "Purchase" | "OwnerNightExchange"
  >;
  StayTicketMaster: ResolverTypeWrapper<StayTicketMasterMapper>;
  StayTicketMasterReferenceInput: StayTicketMasterReferenceInput;
  StayTicketMasterTemplate: ResolverTypeWrapper<StayTicketMasterTemplateMapper>;
  StayTicketReservationInfo: ResolverTypeWrapper<StayTicketReservationInfoMapper>;
  StayTicketStatusType: ResolverTypeWrapper<
    "Open" | "Reserved" | "Stayed" | "Void" | "Expired"
  >;
  StayTicketTemplate: ResolverTypeWrapper<StayTicketTemplateMapper>;
  StayTicketType: ResolverTypeWrapper<"Regular" | "StayGiftFromOwners">;
  StayTicketUnit: ResolverTypeWrapper<StayTicketUnitMapper>;
  StayTicketValidationError: ResolverTypeWrapper<
    | "Expired"
    | "NotFound"
    | "MasterMismatch"
    | "UnitFull"
    | "Unusable"
    | "Duplicate"
  >;
  StayTicketValidationResult: ResolverTypeWrapper<
    Omit<StayTicketValidationResult, "validationError"> & {
      validationError?: Maybe<ResolversTypes["StayTicketValidationError"]>;
    }
  >;
  StripeCard: ResolverTypeWrapper<StripeCard>;
  StripeCollectionMethod: ResolverTypeWrapper<
    "charge_automatically" | "send_invoice"
  >;
  StripeCustomer: ResolverTypeWrapper<StripeCustomerMapper>;
  StripeInvoice: ResolverTypeWrapper<
    Omit<StripeInvoice, "collection_method" | "status"> & {
      collection_method?: Maybe<ResolversTypes["StripeCollectionMethod"]>;
      status: ResolversTypes["StripeInvoiceStatus"];
    }
  >;
  StripeInvoiceStatus: ResolverTypeWrapper<
    "draft" | "open" | "paid" | "uncollectible" | "void"
  >;
  StripeInvoiceStatusTransitions: ResolverTypeWrapper<StripeInvoiceStatusTransitions>;
  StripeInvoiceSubscription: ResolverTypeWrapper<StripeInvoiceSubscription>;
  StripeMetadataItem: ResolverTypeWrapper<StripeMetadataItem>;
  StripeRequireNextAction: ResolverTypeWrapper<StripeRequireNextAction>;
  SubmitAdHocQuestionnaireResponseError: ResolverTypeWrapper<
    Omit<SubmitAdHocQuestionnaireResponseError, "case"> & {
      case: ResolversTypes["SubmitAdHocQuestionnaireResponseErrorCase"];
    }
  >;
  SubmitAdHocQuestionnaireResponseErrorCase: ResolverTypeWrapper<
    "TemplateNotFound" | "GeneralError"
  >;
  SubmitAdHocQuestionnaireResponseInput: SubmitAdHocQuestionnaireResponseInput;
  SubmitAdHocQuestionnaireResponsePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["SubmitAdHocQuestionnaireResponsePayload"]
  >;
  SubmitCoOwnersApplicationError: ResolverTypeWrapper<
    Omit<SubmitCoOwnersApplicationError, "case"> & {
      case: ResolversTypes["SubmitCoOwnersApplicationErrorCase"];
    }
  >;
  SubmitCoOwnersApplicationErrorCase: ResolverTypeWrapper<
    | "InvalidRequest"
    | "IdDocument1Invalid"
    | "IdDocument2Invalid"
    | "RegistryCertificateInvalid"
    | "UnitsOutOfRange"
    | "NoPurchasePurposeFree"
    | "NoIndividualEmployerName"
    | "NoSomeOfOrganizationName"
    | "NoBusinessActivityFree"
    | "NoBeneficialOwnerRelationshipFree"
    | "PaymentFailed"
    | "PaymentRequiresAction"
  >;
  SubmitCoOwnersApplicationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["SubmitCoOwnersApplicationPayload"]
  >;
  SubmitStayReviewV2Payload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["SubmitStayReviewV2Payload"]
  >;
  Success: ResolverTypeWrapper<Success>;
  SupplyItem: ResolverTypeWrapper<SupplyItemMapper>;
  SupplyItemInstallation: ResolverTypeWrapper<SupplyItemInstallationMapper>;
  SupplyItemMaster: ResolverTypeWrapper<SupplyItemMasterMapper>;
  SupplyItemMasterCategory: ResolverTypeWrapper<
    | "Wine"
    | "CoffeeBean"
    | "Curry"
    | "Soup"
    | "Bread"
    | "Rice"
    | "Firewood"
    | "Pizza"
    | "FrozenDessert"
    | "Toothbrush"
    | "Other"
  >;
  TargetPlanType: ResolverTypeWrapper<
    | "NoPlan"
    | "IndividualSubscription"
    | "BusinessSubscription"
    | "CoOwners"
    | "FullOwner"
  >;
  TentativeAccommodationReservationError: ResolverTypeWrapper<
    Omit<TentativeAccommodationReservationError, "case"> & {
      case: ResolversTypes["TentativeAccommodationReservationErrorCase"];
    }
  >;
  TentativeAccommodationReservationErrorCase: ResolverTypeWrapper<
    | "NotFound"
    | "Expired"
    | "NotAuthorized"
    | "OneMoreCabinParentReservationUser"
  >;
  TentativeAccommodationReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["TentativeAccommodationReservationPayload"]
  >;
  Terms: ResolverTypeWrapper<TermsMapper>;
  TermsPlanType: ResolverTypeWrapper<
    "StandardPlan" | "CoOwnersPlan" | "FullOwnerPlan" | "BusinessPlan"
  >;
  TermsRevision: ResolverTypeWrapper<TermsRevisionMapper>;
  TicketCategory: ResolverTypeWrapper<
    | "TrialPaid"
    | "TrialFree"
    | "StaySelfBooking"
    | "StayGift"
    | "Tieup"
    | "TieupSeparateBilling"
  >;
  TopPage: ResolverTypeWrapper<
    Omit<TopPage, "news"> & { news?: Maybe<ResolversTypes["News"]> }
  >;
  TopPageBannerContent: ResolverTypeWrapper<TopPageBannerContent>;
  TrialContract: ResolverTypeWrapper<TrialContractMapper>;
  TrialContractStatus: ResolverTypeWrapper<"Neutral" | "Planned" | "Usable">;
  TrialContractStatusDetail: ResolverTypeWrapper<
    "NeutralDefault" | "NeutralTerminated" | "UsableDefault" | "PlannedDefault"
  >;
  TrialPlanAccommodationReservationProvider: ResolverTypeWrapper<TrialPlanAccommodationReservationProvider>;
  UpdateAccommodationReservationInput: UpdateAccommodationReservationInput;
  UpdateAccommodationReservationOptionsError: ResolverTypeWrapper<
    Omit<UpdateAccommodationReservationOptionsError, "case"> & {
      case: ResolversTypes["UpdateAccommodationReservationOptionsErrorCase"];
    }
  >;
  UpdateAccommodationReservationOptionsErrorCase: ResolverTypeWrapper<
    "DeniedByStatus" | "UnknownError"
  >;
  UpdateAccommodationReservationOptionsInput: UpdateAccommodationReservationOptionsInput;
  UpdateAccommodationReservationOptionsPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["UpdateAccommodationReservationOptionsPayload"]
  >;
  UpdateCoOwnersApplicationOwnerInfoError: ResolverTypeWrapper<
    Omit<UpdateCoOwnersApplicationOwnerInfoError, "case"> & {
      case: ResolversTypes["UpdateCoOwnersApplicationOwnerInfoErrorCase"];
    }
  >;
  UpdateCoOwnersApplicationOwnerInfoErrorCase: ResolverTypeWrapper<
    "NotFound" | "DetailTypeMismatch" | "Unauthorized"
  >;
  UpdateCoOwnersApplicationOwnerInfoPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["UpdateCoOwnersApplicationOwnerInfoPayload"]
  >;
  UpdateFacilityReservationError: ResolverTypeWrapper<
    Omit<UpdateFacilityReservationError, "case"> & {
      case: ResolversTypes["UpdateFacilityReservationErrorCase"];
    }
  >;
  UpdateFacilityReservationErrorCase: ResolverTypeWrapper<
    | "ReservationNotFound"
    | "NotAuthorized"
    | "InvalidAttribute"
    | "UsageFlowNotSupported"
    | "InvalidTransition"
    | "OutsideUsablePeriod"
    | "CommentPeriodExpired"
  >;
  UpdateFacilityReservationInput: UpdateFacilityReservationInput;
  UpdateFacilityReservationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["UpdateFacilityReservationPayload"]
  >;
  UpdateFacilityReservationSuccess: ResolverTypeWrapper<
    Omit<UpdateFacilityReservationSuccess, "reservation"> & {
      reservation: ResolversTypes["FacilityReservation"];
    }
  >;
  UpdateViewerInput: UpdateViewerInput;
  UploadedFile: ResolverTypeWrapper<UploadedFileMapper>;
  UploadedFileInput: UploadedFileInput;
  User: ResolverTypeWrapper<UserMapper>;
  UserAppInstallation: ResolverTypeWrapper<UserAppInstallationMapper>;
  UserCompanion: ResolverTypeWrapper<
    Omit<
      UserCompanion,
      "address" | "gender" | "nationality" | "passportPhoto" | "professionType"
    > & {
      address: ResolversTypes["Address"];
      gender: ResolversTypes["GenderType"];
      nationality?: Maybe<ResolversTypes["CountryEnum"]>;
      passportPhoto?: Maybe<ResolversTypes["UploadedFile"]>;
      professionType?: Maybe<ResolversTypes["UserProfileProfessionType"]>;
    }
  >;
  UserCompanionInput: UserCompanionInput;
  UserFileType: ResolverTypeWrapper<
    | "UserFacePhoto"
    | "UserPassportPhoto"
    | "UserIdentityDocument1"
    | "UserIdentityDocument2"
    | "RegistryCertificate"
  >;
  UserIdentity: ResolverTypeWrapper<UserIdentityMapper>;
  UserMonthlyStatement: ResolverTypeWrapper<UserMonthlyStatementMapper>;
  UserOwnership: ResolverTypeWrapper<UserOwnershipMapper>;
  UserOwnershipProgramYearStatus: ResolverTypeWrapper<UserOwnershipProgramYearStatus>;
  UserPersonaMetrics: ResolverTypeWrapper<UserPersonaMetrics>;
  UserProfile: ResolverTypeWrapper<
    Omit<
      UserProfile,
      | "address"
      | "carOwnershipStatus"
      | "facePhoto"
      | "gender"
      | "householdComposition"
      | "nationality"
      | "passportPhoto"
      | "professionType"
      | "user"
    > & {
      address?: Maybe<ResolversTypes["Address"]>;
      carOwnershipStatus?: Maybe<
        ResolversTypes["UserProfileCarOwnershipStatus"]
      >;
      facePhoto?: Maybe<ResolversTypes["UploadedFile"]>;
      gender?: Maybe<ResolversTypes["GenderType"]>;
      householdComposition?: Maybe<
        ResolversTypes["UserProfileHouseholdComposition"]
      >;
      nationality?: Maybe<ResolversTypes["CountryEnum"]>;
      passportPhoto?: Maybe<ResolversTypes["UploadedFile"]>;
      professionType?: Maybe<ResolversTypes["UserProfileProfessionType"]>;
      user: ResolversTypes["User"];
    }
  >;
  UserProfileCarOwnershipStatus: ResolverTypeWrapper<
    "WithOwnCar" | "WithCarShare" | "WithoutAny"
  >;
  UserProfileHouseholdComposition: ResolverTypeWrapper<
    "Single" | "FamilyWithKids" | "FamilyWithoutKids" | "Other"
  >;
  UserProfileProfessionType: ResolverTypeWrapper<
    | "CompanyEmployeeOffice"
    | "CompanyEmployeeRemote"
    | "ExecutiveOrProfessional"
    | "SelfEmployedOrFreelancer"
    | "CivilServantOrOrganizationEmployee"
    | "Student"
    | "FullTimeHomemaker"
    | "Other"
    | "CompanyEmployee"
    | "ExecutiveOrDirector"
    | "ProfessorOrTeacher"
    | "CivilServant"
    | "OrganizationEmployee"
    | "UnemployedOrMinor"
  >;
  UserSubscription: ResolverTypeWrapper<UserSubscriptionMapper>;
  UserSubscriptionNext7DaysReservationPeriod: ResolverTypeWrapper<UserSubscriptionNext7DaysReservationPeriod>;
  UserSubscriptionReservationCycle: ResolverTypeWrapper<UserSubscriptionReservationCycle>;
  UserSubscriptionReservationCyclePeriod: ResolverTypeWrapper<UserSubscriptionReservationCyclePeriod>;
  UserSubscriptionStatus: ResolverTypeWrapper<"Neutral" | "Planed" | "Usable">;
  UserSubscriptionStatusDetail: ResolverTypeWrapper<
    | "NeutralDefault"
    | "NeutralTerminated"
    | "UsableDefault"
    | "UsableToTerminate"
    | "UsableToPause"
    | "PlanedDefault"
    | "PlanedToResume"
  >;
  UserSubscriptionTerminationProhibitReason: ResolverTypeWrapper<
    | "NoReason"
    | "ReservationExists"
    | "NotPausableDateYet"
    | "InvalidOperation"
    | "NoSubscription"
    | "InvalidStatusTransition"
    | "UnknownError"
  >;
  UserSubscriptionTerminationQuestionnaireInput: UserSubscriptionTerminationQuestionnaireInput;
  UserSystemSettings: ResolverTypeWrapper<UserSystemSettings>;
  UserSystemSettingsInput: UserSystemSettingsInput;
  VerifyAccountLinkSessionError: ResolverTypeWrapper<
    Omit<VerifyAccountLinkSessionError, "case"> & {
      case: ResolversTypes["VerifyAccountLinkSessionErrorCase"];
    }
  >;
  VerifyAccountLinkSessionErrorCase: ResolverTypeWrapper<"InvalidSessionToken">;
  VerifyAccountLinkSessionInput: VerifyAccountLinkSessionInput;
  VerifyAccountLinkSessionPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["VerifyAccountLinkSessionPayload"]
  >;
  VerifyAccountLinkSessionSuccess: ResolverTypeWrapper<VerifyAccountLinkSessionSuccess>;
  VerifyAddIdentityReauthError: ResolverTypeWrapper<
    Omit<VerifyAddIdentityReauthError, "case"> & {
      case: ResolversTypes["VerifyAddIdentityReauthErrorCase"];
    }
  >;
  VerifyAddIdentityReauthErrorCase: ResolverTypeWrapper<
    "InvalidIntentToken" | "TokenExchangeFailed" | "IdentityMismatch"
  >;
  VerifyAddIdentityReauthInput: VerifyAddIdentityReauthInput;
  VerifyAddIdentityReauthPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["VerifyAddIdentityReauthPayload"]
  >;
  VerifyAddIdentityReauthRedirect: ResolverTypeWrapper<VerifyAddIdentityReauthRedirect>;
  VerifyCheckInQrCodeError: ResolverTypeWrapper<
    Omit<VerifyCheckInQrCodeError, "case"> & {
      case: ResolversTypes["VerifyCheckInQrCodeErrorCase"];
    }
  >;
  VerifyCheckInQrCodeErrorCase: ResolverTypeWrapper<
    "InvalidCode" | "Expired" | "AlreadyUsed" | "SiteMismatch"
  >;
  VerifyCheckInQrCodeInput: VerifyCheckInQrCodeInput;
  VerifyCheckInQrCodePayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["VerifyCheckInQrCodePayload"]
  >;
  VerifyCheckInQrCodeSuccess: ResolverTypeWrapper<VerifyCheckInQrCodeSuccess>;
  VerifyNewEmailError: ResolverTypeWrapper<
    Omit<VerifyNewEmailError, "case"> & {
      case: ResolversTypes["VerifyNewEmailErrorCase"];
    }
  >;
  VerifyNewEmailErrorCase: ResolverTypeWrapper<
    "GeneralError" | "InvalidEmailOrCode" | "DifferentEmail"
  >;
  VerifyNewEmailInput: VerifyNewEmailInput;
  VerifyNewEmailPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["VerifyNewEmailPayload"]
  >;
  VerifyNewEmailSuccess: ResolverTypeWrapper<VerifyNewEmailSuccess>;
  WashingMachineTracker: ResolverTypeWrapper<WashingMachineTracker>;
  WifiConnection: ResolverTypeWrapper<WifiConnectionMapper>;
  WifiEquipmentAttribute: ResolverTypeWrapper<WifiEquipmentAttributeMapper>;
  WorkationAccommodationFacility: ResolverTypeWrapper<WorkationAccommodationFacility>;
  ZendeskSyncUserError: ResolverTypeWrapper<
    Omit<ZendeskSyncUserError, "case"> & {
      case: ResolversTypes["ZendeskSyncUserErrorCase"];
    }
  >;
  ZendeskSyncUserErrorCase: ResolverTypeWrapper<
    | "ZendeskApiTransientError"
    | "ZendeskApiPermanentError"
    | "UserNotFound"
    | "UserEmailNotVerified"
    | "ZendeskIdNotFound"
    | "ZendeskIdUpdateError"
  >;
  ZendeskSyncUserResult: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["ZendeskSyncUserResult"]
  >;
  ZonedDateTime: ResolverTypeWrapper<Scalars["ZonedDateTime"]["output"]>;
  leaveOrganizationPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["leaveOrganizationPayload"]
  >;
  Boolean: ResolverTypeWrapper<Scalars["Boolean"]["output"]>;
  Int: ResolverTypeWrapper<Scalars["Int"]["output"]>;
  String: ResolverTypeWrapper<Scalars["String"]["output"]>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AcceptAccommodationReservationError: AcceptAccommodationReservationError;
  AcceptAccommodationReservationPayload: ResolversUnionTypes<ResolversParentTypes>["AcceptAccommodationReservationPayload"];
  Accommodation: AccommodationMapper;
  ID: Scalars["ID"]["output"];
  AccommodationAccessKey: AccommodationAccessKeyMapper;
  AccommodationAvailability: AccommodationAvailabilityMapper;
  AccommodationAvailabilityBlock: AccommodationAvailabilityBlockMapper;
  AccommodationAvailabilityBlockCategoryInfo: AccommodationAvailabilityBlockCategoryInfo;
  AccommodationAvailabilityBlockReleaseSchedule: AccommodationAvailabilityBlockReleaseSchedule;
  AccommodationContent: AccommodationContent;
  AccommodationEquipment: AccommodationEquipmentMapper;
  AccommodationEquipmentAttribute: ResolversUnionTypes<ResolversParentTypes>["AccommodationEquipmentAttribute"];
  AccommodationFacility: AccommodationFacilityMapper;
  AccommodationFee: AccommodationFeeMapper;
  AccommodationFeeApplicability: AccommodationFeeApplicability;
  AccommodationFeeDiscount: AccommodationFeeDiscount;
  AccommodationFeeInput: AccommodationFeeInput;
  AccommodationFeeItem: AccommodationFeeItemMapper;
  Float: Scalars["Float"]["output"];
  AccommodationFeeItemInput: AccommodationFeeItemInput;
  AccommodationFeeRule: AccommodationFeeRule;
  AccommodationFeeRuleInput: AccommodationFeeRuleInput;
  AccommodationNotice: AccommodationNoticeMapper;
  AccommodationOperationGroup: AccommodationOperationGroupMapper;
  AccommodationOperationGroupSetting: AccommodationOperationGroupSetting;
  AccommodationReservation: AccommodationReservationMapper;
  AccommodationReservationAdditionalKeySet: AccommodationReservationAdditionalKeySetMapper;
  AccommodationReservationChange: AccommodationReservationChange;
  AccommodationReservationCheckOutAvailabilitiesInput: AccommodationReservationCheckOutAvailabilitiesInput;
  AccommodationReservationCheckOutAvailabilitiesPayload: Omit<
    AccommodationReservationCheckOutAvailabilitiesPayload,
    "items"
  > & {
    items: Array<ResolversParentTypes["AccommodationReservationCheckOutItem"]>;
  };
  AccommodationReservationCheckOutItem: AccommodationReservationCheckOutItemMapper;
  AccommodationReservationDetail: AccommodationReservationDetailMapper;
  AccommodationReservationDetailInput: AccommodationReservationDetailInput;
  AccommodationReservationOptions: AccommodationReservationOptionsMapper;
  AccommodationReservationOtaDetail: AccommodationReservationOtaDetail;
  AccommodationReservationProvider: ResolversUnionTypes<ResolversParentTypes>["AccommodationReservationProvider"];
  AccommodationReservationProviderInput: AccommodationReservationProviderInput;
  AccommodationScope: AccommodationScope;
  AccountLinkIdentity: AccountLinkIdentity;
  AcquireStayTicketsError: AcquireStayTicketsError;
  AcquireStayTicketsInput: AcquireStayTicketsInput;
  AcquireStayTicketsPayload: ResolversUnionTypes<ResolversParentTypes>["AcquireStayTicketsPayload"];
  AcquireStayTicketsResult: Omit<AcquireStayTicketsResult, "tickets"> & {
    tickets: Array<ResolversParentTypes["StayTicket"]>;
  };
  ActivateMemberPerksDrinkTicketError: ActivateMemberPerksDrinkTicketError;
  ActivateMemberPerksDrinkTicketPayload: ResolversUnionTypes<ResolversParentTypes>["ActivateMemberPerksDrinkTicketPayload"];
  AdHocQuestionnaireAnswerInput: AdHocQuestionnaireAnswerInput;
  AdHocQuestionnaireAnswerValueInput: AdHocQuestionnaireAnswerValueInput;
  AdHocQuestionnaireMultipleSelectInput: AdHocQuestionnaireMultipleSelectInput;
  AdHocQuestionnaireResponse: AdHocQuestionnaireResponseMapper;
  AdditionalGuestFeePolicy: AdditionalGuestFeePolicyMapper;
  Address: ResolversUnionTypes<ResolversParentTypes>["Address"];
  AddressInJapan: AddressInJapan;
  AddressInJapanInput: AddressInJapanInput;
  AddressInternational: AddressInternational;
  AddressInternationalInput: AddressInternationalInput;
  AdminRoleAssignment: AdminRoleAssignmentMapper;
  AgreeToTermsError: AgreeToTermsError;
  AgreeToTermsPayload: ResolversUnionTypes<ResolversParentTypes>["AgreeToTermsPayload"];
  AgreeToWeekdayTermsError: AgreeToWeekdayTermsError;
  AgreeToWeekdayTermsPayload: ResolversUnionTypes<ResolversParentTypes>["AgreeToWeekdayTermsPayload"];
  ApplyToTrialSubscriptionError: ApplyToTrialSubscriptionError;
  ApplyToTrialSubscriptionPayload: ResolversUnionTypes<ResolversParentTypes>["ApplyToTrialSubscriptionPayload"];
  ApplyToWeekdaySubscriptionError: ApplyToWeekdaySubscriptionError;
  ApplyToWeekdaySubscriptionPayload: ResolversUnionTypes<ResolversParentTypes>["ApplyToWeekdaySubscriptionPayload"];
  ArchitectureType: ArchitectureTypeMapper;
  ArchiveArticle: ArchiveArticle;
  Area: AreaMapper;
  AreaContent: AreaContentMapper;
  AreaGuideArticle: AreaGuideArticleMapper;
  AreaGuideSpot: AreaGuideSpotMapper;
  Auth0User: Auth0UserMapper;
  BaseAccommodationFeePolicy: BaseAccommodationFeePolicy;
  Beds24Booking: Beds24Booking;
  Beds24BookingDetail: Beds24BookingDetail;
  Beds24BookingEvent: Beds24BookingEvent;
  Beds24BookingFee: Beds24BookingFee;
  Beds24BookingGroup: Beds24BookingGroup;
  Beds24BookingMessageError: Beds24BookingMessageError;
  Beds24BookingMessageResult: ResolversUnionTypes<ResolversParentTypes>["Beds24BookingMessageResult"];
  Beds24BookingMessageResultPayload: Omit<
    Beds24BookingMessageResultPayload,
    "result"
  > & { result: ResolversParentTypes["Beds24BookingMessageResult"] };
  Beds24InfoItem: Beds24InfoItem;
  Beds24InvoiceItem: Beds24InvoiceItem;
  Beds24Message: Beds24Message;
  Beds24SyncFollowingReservationsResultPayload: ResolversUnionTypes<ResolversParentTypes>["Beds24SyncFollowingReservationsResultPayload"];
  Beds24WebhookError: Beds24WebhookError;
  Beds24WebhookResult: ResolversUnionTypes<ResolversParentTypes>["Beds24WebhookResult"];
  Beds24WebhookResultPayload: Omit<
    Beds24WebhookResultPayload,
    "reservation" | "result"
  > & {
    reservation?: Maybe<ResolversParentTypes["AccommodationReservation"]>;
    result: ResolversParentTypes["Beds24WebhookResult"];
  };
  Beds24WebhookSuccess: Beds24WebhookSuccess;
  BulkCreateOrganizationYearlyContractInvoicesInput: BulkCreateOrganizationYearlyContractInvoicesInput;
  BundleStayTicketsPayload: Omit<
    BundleStayTicketsPayload,
    "stayTicketUnit" | "stayTicketsValidationResult"
  > & {
    stayTicketUnit?: Maybe<ResolversParentTypes["StayTicketUnit"]>;
    stayTicketsValidationResult: Array<
      ResolversParentTypes["StayTicketValidationResult"]
    >;
  };
  BusinessPlan: BusinessPlan;
  BusinessPlanAccommodationReservationProvider: BusinessPlanAccommodationReservationProvider;
  CancelAccommodationReservationError: CancelAccommodationReservationError;
  CancelAccommodationReservationPayload: ResolversUnionTypes<ResolversParentTypes>["CancelAccommodationReservationPayload"];
  CancelCoOwnersApplicationError: CancelCoOwnersApplicationError;
  CancelCoOwnersApplicationPayload: ResolversUnionTypes<ResolversParentTypes>["CancelCoOwnersApplicationPayload"];
  CancelFacilityReservationError: CancelFacilityReservationError;
  CancelFacilityReservationPayload: ResolversUnionTypes<ResolversParentTypes>["CancelFacilityReservationPayload"];
  CancelFeeFixedPolicy: CancelFeeFixedPolicy;
  CancelFeeFixedPolicyInput: CancelFeeFixedPolicyInput;
  CancelFeePolicy: ResolversUnionTypes<ResolversParentTypes>["CancelFeePolicy"];
  CancelFeeRatePolicy: CancelFeeRatePolicy;
  CancelFeeRatePolicyInput: CancelFeeRatePolicyInput;
  CancelStandardSubscriptionApplicationError: CancelStandardSubscriptionApplicationError;
  CancelStandardSubscriptionApplicationPayload: ResolversUnionTypes<ResolversParentTypes>["CancelStandardSubscriptionApplicationPayload"];
  CancelStandardSubscriptionPauseError: CancelStandardSubscriptionPauseError;
  CancelStandardSubscriptionPausePayload: ResolversUnionTypes<ResolversParentTypes>["CancelStandardSubscriptionPausePayload"];
  CancelStandardSubscriptionResumeError: CancelStandardSubscriptionResumeError;
  CancelStandardSubscriptionResumePayload: ResolversUnionTypes<ResolversParentTypes>["CancelStandardSubscriptionResumePayload"];
  CancelStandardSubscriptionTerminationError: CancelStandardSubscriptionTerminationError;
  CancelStandardSubscriptionTerminationPayload: ResolversUnionTypes<ResolversParentTypes>["CancelStandardSubscriptionTerminationPayload"];
  CancelStayGiftsError: CancelStayGiftsError;
  CancelStayGiftsPayload: ResolversUnionTypes<ResolversParentTypes>["CancelStayGiftsPayload"];
  CancelStayGiftsResult: Omit<CancelStayGiftsResult, "cancelledTickets"> & {
    cancelledTickets: Array<ResolversParentTypes["StayTicket"]>;
  };
  CancelTrialSubscriptionError: CancelTrialSubscriptionError;
  CancelTrialSubscriptionPayload: ResolversUnionTypes<ResolversParentTypes>["CancelTrialSubscriptionPayload"];
  CancellationFeeTier: CancellationFeeTierMapper;
  CancellationPolicyContent: CancellationPolicyContentMapper;
  CancellationPolicySection: CancellationPolicySectionMapper;
  ChangeAccommodationAvailabilityBlockInput: ChangeAccommodationAvailabilityBlockInput;
  ChangeAccommodationReservationError: ChangeAccommodationReservationError;
  ChangeAccommodationReservationPayload: ResolversUnionTypes<ResolversParentTypes>["ChangeAccommodationReservationPayload"];
  CheckInAccommodationReservationError: CheckInAccommodationReservationError;
  CheckInAccommodationReservationInput: CheckInAccommodationReservationInput;
  CheckInAccommodationReservationPayload: ResolversUnionTypes<ResolversParentTypes>["CheckInAccommodationReservationPayload"];
  CheckInQrCode: CheckInQrCode;
  CheckOutAccommodationReservationError: CheckOutAccommodationReservationError;
  CheckOutAccommodationReservationPayload: ResolversUnionTypes<ResolversParentTypes>["CheckOutAccommodationReservationPayload"];
  CoOwnersApplicantInfo: CoOwnersApplicantInfoMapper;
  CoOwnersApplicantInfoDetail: ResolversUnionTypes<ResolversParentTypes>["CoOwnersApplicantInfoDetail"];
  CoOwnersApplicantInfoDetailIndividual: CoOwnersApplicantInfoDetailIndividualMapper;
  CoOwnersApplicantInfoDetailOrganization: CoOwnersApplicantInfoDetailOrganizationMapper;
  CoOwnersApplication: CoOwnersApplicationMapper;
  CoOwnersApplicationDetailInput: CoOwnersApplicationDetailInput;
  CoOwnersApplicationDetails: CoOwnersApplicationDetails;
  CoOwnersApplicationEvents: CoOwnersApplicationEventsMapper;
  CoOwnersApplicationFile: CoOwnersApplicationFileMapper;
  CoOwnersApplicationIndividualInput: CoOwnersApplicationIndividualInput;
  CoOwnersApplicationInfoInput: CoOwnersApplicationInfoInput;
  CoOwnersApplicationInput: CoOwnersApplicationInput;
  CoOwnersApplicationOrganizationInput: CoOwnersApplicationOrganizationInput;
  CoOwnersApplicationOwnerInfoInput: CoOwnersApplicationOwnerInfoInput;
  CoOwnersApplicationStatusInput: CoOwnersApplicationStatusInput;
  CoOwnersBakurakuInvoiceAnnualPaymentItem: CoOwnersBakurakuInvoiceAnnualPaymentItemMapper;
  CoOwnersBakurakuInvoiceRecipient: CoOwnersBakurakuInvoiceRecipientMapper;
  CoOwnersBakurakuInvoiceRegistrationFeeItem: CoOwnersBakurakuInvoiceRegistrationFeeItemMapper;
  CoOwnersBakurakuInvoiceRemainingPaymentItem: CoOwnersBakurakuInvoiceRemainingPaymentItemMapper;
  CoOwnersPlanAccommodationReservationProvider: CoOwnersPlanAccommodationReservationProvider;
  CoOwnersPlanOffering: CoOwnersPlanOfferingMapper;
  CoOwnersUnitSale: CoOwnersUnitSaleMapper;
  CoOwnersWebinarSchedule: CoOwnersWebinarScheduleMapper;
  CoWorkingSpaceDoorLock: CoWorkingSpaceDoorLock;
  CoWorkingSpaceKey: CoWorkingSpaceKeyMapper;
  CompleteAddIdentityError: CompleteAddIdentityError;
  CompleteAddIdentityInput: CompleteAddIdentityInput;
  CompleteAddIdentityPayload: ResolversUnionTypes<ResolversParentTypes>["CompleteAddIdentityPayload"];
  CompleteAddIdentitySuccess: CompleteAddIdentitySuccess;
  ConfirmTentativeAccommodationReservationError: ConfirmTentativeAccommodationReservationError;
  ConfirmTentativeAccommodationReservationInput: ConfirmTentativeAccommodationReservationInput;
  ConfirmTentativeAccommodationReservationPayload: ResolversUnionTypes<ResolversParentTypes>["ConfirmTentativeAccommodationReservationPayload"];
  ConsumedSuppliesFee: Omit<ConsumedSuppliesFee, "items"> & {
    items: Array<ResolversParentTypes["ConsumedSuppliesFeeItem"]>;
  };
  ConsumedSuppliesFeeItem: ConsumedSuppliesFeeItemMapper;
  ConsumedSuppliesFeeItemInput: ConsumedSuppliesFeeItemInput;
  ConsumedSupplyFeeItemWaiver: ConsumedSupplyFeeItemWaiverMapper;
  ConsumedSupplyFeeItemWaiverInput: ConsumedSupplyFeeItemWaiverInput;
  ContentArchitect: ContentArchitectMapper;
  ContentArchitecturalFeature: ContentArchitecturalFeatureMapper;
  ContentArchitecturalFeatureUsageRule: ContentArchitecturalFeatureUsageRuleMapper;
  ContentArchitecturePageNavigation: Omit<
    ContentArchitecturePageNavigation,
    "feature" | "originalSeries" | "selectionSeries"
  > & {
    feature: Array<
      ResolversParentTypes["ContentArchitecturePageNavigationItem"]
    >;
    originalSeries: Array<
      ResolversParentTypes["ContentArchitecturePageNavigationItem"]
    >;
    selectionSeries: Array<
      ResolversParentTypes["ContentArchitecturePageNavigationItem"]
    >;
  };
  ContentArchitecturePageNavigationItem: Omit<
    ContentArchitecturePageNavigationItem,
    "thumbnail"
  > & { thumbnail: ResolversParentTypes["UploadedFile"] };
  ContentArchitecturePageNavigationSubItem: ContentArchitecturePageNavigationSubItem;
  ContentArchitectureType: ContentArchitectureTypeMapper;
  ContentArchitectureTypeBasicAmenity: ContentArchitectureTypeBasicAmenityMapper;
  ContentArchitectureTypeExperience: Omit<
    ContentArchitectureTypeExperience,
    "imageUrl"
  > & { imageUrl: ResolversParentTypes["UploadedFile"] };
  ContentArchitectureTypeFeature: Omit<
    ContentArchitectureTypeFeature,
    "facilityDetails" | "imageUrls" | "sitesByArchitectureType" | "usageRule"
  > & {
    facilityDetails: ResolversParentTypes["ContentFacilityDetails"];
    imageUrls: Array<ResolversParentTypes["UploadedFile"]>;
    sitesByArchitectureType: Array<
      ResolversParentTypes["ContentArchitectureTypeFeatureSite"]
    >;
    usageRule?: Maybe<
      ResolversParentTypes["ContentArchitectureTypeFeatureUsageRule"]
    >;
  };
  ContentArchitectureTypeFeatureSite: Omit<
    ContentArchitectureTypeFeatureSite,
    "sites"
  > & {
    sites: Array<ResolversParentTypes["ContentArchitectureTypeVariantSite"]>;
  };
  ContentArchitectureTypeFeatureUsageRule: Omit<
    ContentArchitectureTypeFeatureUsageRule,
    "ruleItems"
  > & {
    ruleItems: Array<
      ResolversParentTypes["ContentArchitectureTypeFeatureUsageRuleItem"]
    >;
  };
  ContentArchitectureTypeFeatureUsageRuleItem: Omit<
    ContentArchitectureTypeFeatureUsageRuleItem,
    "imageUrl"
  > & { imageUrl?: Maybe<ResolversParentTypes["UploadedFile"]> };
  ContentArchitectureTypeSite: ContentArchitectureTypeSite;
  ContentArchitectureTypeVariant: Omit<
    ContentArchitectureTypeVariant,
    "accommodationFacilities" | "facilityDetails" | "imageUrls" | "sites"
  > & {
    accommodationFacilities: Array<
      ResolversParentTypes["AccommodationFacility"]
    >;
    facilityDetails: ResolversParentTypes["ContentFacilityDetails"];
    imageUrls: Array<ResolversParentTypes["UploadedFile"]>;
    sites: Array<ResolversParentTypes["ContentArchitectureTypeVariantSite"]>;
  };
  ContentArchitectureTypeVariantFacilityAmenity: ContentArchitectureTypeVariantFacilityAmenityMapper;
  ContentArchitectureTypeVariantSite: Omit<
    ContentArchitectureTypeVariantSite,
    "accommodations"
  > & { accommodations: Array<ResolversParentTypes["Accommodation"]> };
  ContentFacilityAmenityReferenceCounts: ContentFacilityAmenityReferenceCounts;
  ContentFacilityDetails: Omit<ContentFacilityDetails, "facilityAmenities"> & {
    facilityAmenities: Array<
      ResolversParentTypes["ContentArchitectureTypeVariantFacilityAmenity"]
    >;
  };
  ContentRoomType: ContentRoomTypeMapper;
  CreateAccommodationAvailabilityBlockInput: CreateAccommodationAvailabilityBlockInput;
  CreateAccommodationReservationError: CreateAccommodationReservationError;
  CreateAccommodationReservationInput: CreateAccommodationReservationInput;
  CreateAccommodationReservationPayload: ResolversUnionTypes<ResolversParentTypes>["CreateAccommodationReservationPayload"];
  CreateCoOwnersApplicationFileDownloadUrlError: CreateCoOwnersApplicationFileDownloadUrlError;
  CreateCoOwnersApplicationFileDownloadUrlPayload: ResolversUnionTypes<ResolversParentTypes>["CreateCoOwnersApplicationFileDownloadUrlPayload"];
  CreateCoOwnersApplicationFileDownloadUrlSuccess: CreateCoOwnersApplicationFileDownloadUrlSuccess;
  CreateCoOwnersApplicationFileUploadPolicyInput: CreateCoOwnersApplicationFileUploadPolicyInput;
  CreateFacilityReservationError: CreateFacilityReservationError;
  CreateFacilityReservationInput: CreateFacilityReservationInput;
  CreateFacilityReservationPayload: ResolversUnionTypes<ResolversParentTypes>["CreateFacilityReservationPayload"];
  CreateFacilityReservationSuccess: Omit<
    CreateFacilityReservationSuccess,
    "reservation"
  > & { reservation: ResolversParentTypes["FacilityReservation"] };
  CreateFileUploadPolicyError: CreateFileUploadPolicyError;
  CreateFileUploadPolicySuccess: CreateFileUploadPolicySuccess;
  CreateFullOwnerContractUploadPolicyInput: CreateFullOwnerContractUploadPolicyInput;
  CreateOrUpdateBaseAccommodationFeePolicyInput: CreateOrUpdateBaseAccommodationFeePolicyInput;
  CreateOrUpdateBusinessPlanInput: CreateOrUpdateBusinessPlanInput;
  CreateOrUpdateCancelFeePolicyInput: CreateOrUpdateCancelFeePolicyInput;
  CreateOrUpdateOrganizationInput: CreateOrUpdateOrganizationInput;
  CreateOrUpdateOrganizationYearlyContractInput: CreateOrUpdateOrganizationYearlyContractInput;
  CreateOrUpdateOrganizationYearlyContractInvoiceInput: CreateOrUpdateOrganizationYearlyContractInvoiceInput;
  CreateOrUpdateStaffGroupInput: CreateOrUpdateStaffGroupInput;
  CreateOrUpdateUserAppInstallationError: CreateOrUpdateUserAppInstallationError;
  CreateOrUpdateUserAppInstallationInput: CreateOrUpdateUserAppInstallationInput;
  CreateOrUpdateUserAppInstallationPayload: ResolversUnionTypes<ResolversParentTypes>["CreateOrUpdateUserAppInstallationPayload"];
  CreateSanuOwnerPlanFileUploadPolicyInput: CreateSanuOwnerPlanFileUploadPolicyInput;
  CreateSanuOwnerPlanUserFileUploadPolicyInput: CreateSanuOwnerPlanUserFileUploadPolicyInput;
  CreateStripeCardSetupIntentOfOrganizationPayload: CreateStripeCardSetupIntentOfOrganizationPayload;
  CreateStripeCardSetupIntentOfViewerPayload: CreateStripeCardSetupIntentOfViewerPayload;
  CreateUserFileUploadPolicyInput: CreateUserFileUploadPolicyInput;
  CreateWebviewSessionError: CreateWebviewSessionError;
  CreateWebviewSessionInput: CreateWebviewSessionInput;
  CreateWebviewSessionPayload: ResolversUnionTypes<ResolversParentTypes>["CreateWebviewSessionPayload"];
  CreateWebviewSessionSuccess: CreateWebviewSessionSuccess;
  DateTime: Scalars["DateTime"]["output"];
  Decimal: Scalars["Decimal"]["output"];
  DeleteUserAppInstallationError: DeleteUserAppInstallationError;
  DeleteUserAppInstallationPayload: ResolversUnionTypes<ResolversParentTypes>["DeleteUserAppInstallationPayload"];
  DeleteViewerError: DeleteViewerError;
  DeleteViewerPayload: ResolversUnionTypes<ResolversParentTypes>["DeleteViewerPayload"];
  DogfriendlyAccommodationFacility: DogfriendlyAccommodationFacility;
  DraftAccommodationReservation: DraftAccommodationReservationMapper;
  DraftAccommodationReservationByStayTicketMasterInput: DraftAccommodationReservationByStayTicketMasterInput;
  DraftAccommodationReservationByStayTicketMasterResult: Omit<
    DraftAccommodationReservationByStayTicketMasterResult,
    "fee"
  > & { fee: ResolversParentTypes["AccommodationFee"] };
  DraftAccommodationReservationInput: DraftAccommodationReservationInput;
  DraftAccommodationReservationOptionsInput: DraftAccommodationReservationOptionsInput;
  EVChargerAccommodationFacility: EVChargerAccommodationFacility;
  EarlyCheckInPriceSlot: EarlyCheckInPriceSlot;
  EstimateStandardSubscriptionApplicationError: EstimateStandardSubscriptionApplicationError;
  EstimateStandardSubscriptionApplicationFeePayload: ResolversUnionTypes<ResolversParentTypes>["EstimateStandardSubscriptionApplicationFeePayload"];
  EstimateStandardSubscriptionApplicationSuccess: EstimateStandardSubscriptionApplicationSuccess;
  EstimatedCancelFeeOfAccommodationReservationError: EstimatedCancelFeeOfAccommodationReservationError;
  EstimatedCancelFeeOfAccommodationReservationPayload: ResolversUnionTypes<ResolversParentTypes>["EstimatedCancelFeeOfAccommodationReservationPayload"];
  EstimatedChangeFeeOfAccommodationReservationError: EstimatedChangeFeeOfAccommodationReservationError;
  EstimatedChangeFeeOfAccommodationReservationInput: EstimatedChangeFeeOfAccommodationReservationInput;
  EstimatedChangeFeeOfAccommodationReservationPayload: ResolversUnionTypes<ResolversParentTypes>["EstimatedChangeFeeOfAccommodationReservationPayload"];
  EstimatedChargeOfAccommodationReservation: Omit<
    EstimatedChargeOfAccommodationReservation,
    "items"
  > & {
    items: Array<
      ResolversParentTypes["EstimatedChargeOfAccommodationReservationItem"]
    >;
  };
  EstimatedChargeOfAccommodationReservationItem: EstimatedChargeOfAccommodationReservationItem;
  EvChargerLock: EvChargerLock;
  ExportStayGiftsPayload: Omit<ExportStayGiftsPayload, "tickets"> & {
    tickets: Array<ResolversParentTypes["StayGiftExportItem"]>;
  };
  Facility: FacilityMapper;
  FacilityBaseFeePolicy: FacilityBaseFeePolicyMapper;
  FacilityCancelFeePolicy: FacilityCancelFeePolicyMapper;
  FacilityController: FacilityControllerMapper;
  FacilityControllerAttribute: ResolversUnionTypes<ResolversParentTypes>["FacilityControllerAttribute"];
  FacilityCustomFieldItem: FacilityCustomFieldItem;
  FacilityCustomFieldItemInput: FacilityCustomFieldItemInput;
  FacilityCustomFieldValue: FacilityCustomFieldValueMapper;
  FacilityCustomFieldValueInput: FacilityCustomFieldValueInput;
  FacilityDiscountFeePolicy: FacilityDiscountFeePolicy;
  FacilityFee: Omit<FacilityFee, "items"> & {
    items: Array<ResolversParentTypes["FacilityFeeItem"]>;
  };
  FacilityFeeItem: FacilityFeeItemMapper;
  FacilityInvoiceLabelPart: FacilityInvoiceLabelPart;
  FacilityInvoiceLabelPartInput: FacilityInvoiceLabelPartInput;
  FacilityReservation: FacilityReservationMapper;
  FacilityReservationCleaningReport: FacilityReservationCleaningReportMapper;
  FacilityReservationDataSync: FacilityReservationDataSyncMapper;
  FacilityResource: FacilityResourceMapper;
  FacilityResourceBlock: FacilityResourceBlockMapper;
  FacilitySlot: FacilitySlotMapper;
  FacilitySlotAvailability: FacilitySlotAvailabilityMapper;
  FileUploadPolicyPayload: ResolversUnionTypes<ResolversParentTypes>["FileUploadPolicyPayload"];
  FinalizeAccountLinkError: FinalizeAccountLinkError;
  FinalizeAccountLinkInput: FinalizeAccountLinkInput;
  FinalizeAccountLinkPayload: ResolversUnionTypes<ResolversParentTypes>["FinalizeAccountLinkPayload"];
  FinalizeAccountLinkSuccess: FinalizeAccountLinkSuccess;
  FullOwnerPlanAccommodationReservationProvider: FullOwnerPlanAccommodationReservationProvider;
  GenerateCheckInQrCodeError: GenerateCheckInQrCodeError;
  GenerateCheckInQrCodeInput: GenerateCheckInQrCodeInput;
  GenerateCheckInQrCodePayload: ResolversUnionTypes<ResolversParentTypes>["GenerateCheckInQrCodePayload"];
  GenerateCheckInQrCodeSuccess: Omit<
    GenerateCheckInQrCodeSuccess,
    "checkInQrCode"
  > & { checkInQrCode: ResolversParentTypes["CheckInQrCode"] };
  GeoLocation: GeoLocation;
  GeoLocationInput: GeoLocationInput;
  GuestCountsInput: GuestCountsInput;
  HighSeasonPeriod: HighSeasonPeriodMapper;
  HubSpotSyncContactError: HubSpotSyncContactError;
  HubSpotSyncContactResult: ResolversUnionTypes<ResolversParentTypes>["HubSpotSyncContactResult"];
  HubSpotSyncDealError: HubSpotSyncDealError;
  HubSpotSyncDealResult: ResolversUnionTypes<ResolversParentTypes>["HubSpotSyncDealResult"];
  IdentityVerification: IdentityVerificationMapper;
  InitiateAccountLinkError: InitiateAccountLinkError;
  InitiateAccountLinkInput: InitiateAccountLinkInput;
  InitiateAccountLinkPayload: ResolversUnionTypes<ResolversParentTypes>["InitiateAccountLinkPayload"];
  InitiateAccountLinkSuccess: InitiateAccountLinkSuccess;
  InitiateAddIdentityError: InitiateAddIdentityError;
  InitiateAddIdentityInput: InitiateAddIdentityInput;
  InitiateAddIdentityPayload: ResolversUnionTypes<ResolversParentTypes>["InitiateAddIdentityPayload"];
  InitiateAddIdentitySuccess: InitiateAddIdentitySuccess;
  Inspection: Omit<Inspection, "accommodation" | "reservation"> & {
    accommodation: ResolversParentTypes["Accommodation"];
    reservation?: Maybe<ResolversParentTypes["AccommodationReservation"]>;
  };
  InspectionReport: InspectionReportMapper;
  InspectionSupplyItem: InspectionSupplyItemMapper;
  InspectionViolationHandling: InspectionViolationHandlingMapper;
  InspectionViolationItem: InspectionViolationItemMapper;
  InternalAccommodationEquipmentError: InternalAccommodationEquipmentError;
  InternalAddLocalTaxPolicyError: InternalAddLocalTaxPolicyError;
  InternalAddLocalTaxPolicyPayload: ResolversUnionTypes<ResolversParentTypes>["InternalAddLocalTaxPolicyPayload"];
  InternalAddLocalTaxPolicyTargetInput: InternalAddLocalTaxPolicyTargetInput;
  InternalAdjustOwnerStayCreditError: InternalAdjustOwnerStayCreditError;
  InternalAdjustOwnerStayCreditPayload: ResolversUnionTypes<ResolversParentTypes>["InternalAdjustOwnerStayCreditPayload"];
  InternalAdjustStaffCreditsError: InternalAdjustStaffCreditsError;
  InternalAdjustStaffCreditsResult: ResolversUnionTypes<ResolversParentTypes>["InternalAdjustStaffCreditsResult"];
  InternalAdjustStaffCreditsSuccess: Omit<
    InternalAdjustStaffCreditsSuccess,
    "contract"
  > & { contract: ResolversParentTypes["StaffContract"] };
  InternalAdminRoleAssignee: InternalAdminRoleAssignee;
  InternalAppendS2oPointsToCoOwnersApplicationError: InternalAppendS2oPointsToCoOwnersApplicationError;
  InternalAppendS2oPointsToCoOwnersApplicationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalAppendS2oPointsToCoOwnersApplicationPayload"];
  InternalApplyGuestAccessKeyError: InternalApplyGuestAccessKeyError;
  InternalApplyGuestAccessKeyPayload: ResolversUnionTypes<ResolversParentTypes>["InternalApplyGuestAccessKeyPayload"];
  InternalApplyStaffAccessKeyError: InternalApplyStaffAccessKeyError;
  InternalApplyStaffAccessKeyPayload: ResolversUnionTypes<ResolversParentTypes>["InternalApplyStaffAccessKeyPayload"];
  InternalArchitectureContentError: InternalArchitectureContentError;
  InternalArea: InternalAreaMapper;
  InternalAssignAccessCodeToAccommodationReservationError: InternalAssignAccessCodeToAccommodationReservationError;
  InternalAssignAccessCodeToAccommodationReservationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalAssignAccessCodeToAccommodationReservationPayload"];
  InternalAssignAdminRoleError: InternalAssignAdminRoleError;
  InternalAssignAdminRoleInput: InternalAssignAdminRoleInput;
  InternalAssignAdminRolePayload: ResolversUnionTypes<ResolversParentTypes>["InternalAssignAdminRolePayload"];
  InternalAuth0Identity: InternalAuth0Identity;
  InternalAuth0User: InternalAuth0User;
  InternalAvailableStaffSemester: InternalAvailableStaffSemester;
  InternalBeds24SyncFuturePricesResult: Omit<
    InternalBeds24SyncFuturePricesResult,
    "skippedRoomTypes" | "targets"
  > & {
    skippedRoomTypes: Array<
      ResolversParentTypes["InternalBeds24SyncFuturePricesSkip"]
    >;
    targets: Array<
      ResolversParentTypes["InternalBeds24SyncFuturePricesTarget"]
    >;
  };
  InternalBeds24SyncFuturePricesSkip: Omit<
    InternalBeds24SyncFuturePricesSkip,
    "roomType"
  > & { roomType: ResolversParentTypes["RoomType"] };
  InternalBeds24SyncFuturePricesTarget: Omit<
    InternalBeds24SyncFuturePricesTarget,
    "roomType"
  > & { roomType: ResolversParentTypes["RoomType"] };
  InternalBulkCreateAccommodationAvailabilityBlockFailure: Omit<
    InternalBulkCreateAccommodationAvailabilityBlockFailure,
    "input"
  > & {
    input: ResolversParentTypes["InternalBulkCreateAccommodationAvailabilityBlockFailureInput"];
  };
  InternalBulkCreateAccommodationAvailabilityBlockFailureInput: InternalBulkCreateAccommodationAvailabilityBlockFailureInput;
  InternalBulkCreateAccommodationAvailabilityBlocksPayload: Omit<
    InternalBulkCreateAccommodationAvailabilityBlocksPayload,
    "failed" | "success"
  > & {
    failed: Array<
      ResolversParentTypes["InternalBulkCreateAccommodationAvailabilityBlockFailure"]
    >;
    success: Array<ResolversParentTypes["AccommodationAvailabilityBlock"]>;
  };
  InternalBulkCreateOrganizationYearlyContractInvoicesError: InternalBulkCreateOrganizationYearlyContractInvoicesError;
  InternalBulkCreateOrganizationYearlyContractInvoicesPayload: ResolversUnionTypes<ResolversParentTypes>["InternalBulkCreateOrganizationYearlyContractInvoicesPayload"];
  InternalBulkCreateOrganizationYearlyContractInvoicesSuccess: InternalBulkCreateOrganizationYearlyContractInvoicesSuccess;
  InternalBulkDeleteAccommodationAvailabilityBlockFailure: InternalBulkDeleteAccommodationAvailabilityBlockFailure;
  InternalBulkDeleteAccommodationAvailabilityBlocksPayload: InternalBulkDeleteAccommodationAvailabilityBlocksPayload;
  InternalBulkUpdateSeasonalFeeSettingsError: InternalBulkUpdateSeasonalFeeSettingsError;
  InternalBulkUpdateSeasonalFeeSettingsInput: InternalBulkUpdateSeasonalFeeSettingsInput;
  InternalBulkUpdateSeasonalFeeSettingsPayload: InternalBulkUpdateSeasonalFeeSettingsPayload;
  InternalBulkUpdateStayTicketMasterInput: InternalBulkUpdateStayTicketMasterInput;
  InternalBulkUpdateStayTicketMastersError: InternalBulkUpdateStayTicketMastersError;
  InternalBulkUpdateStayTicketMastersPayload: InternalBulkUpdateStayTicketMastersPayload;
  InternalCancelCoOwnersApplicationError: InternalCancelCoOwnersApplicationError;
  InternalCancelCoOwnersApplicationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCancelCoOwnersApplicationPayload"];
  InternalCommonError: InternalCommonError;
  InternalContentRoomType: InternalContentRoomTypeMapper;
  InternalCreateAccommodationAvailabilityBlockReleaseScheduleInput: InternalCreateAccommodationAvailabilityBlockReleaseScheduleInput;
  InternalCreateAccommodationEquipmentInput: InternalCreateAccommodationEquipmentInput;
  InternalCreateAccommodationEquipmentPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateAccommodationEquipmentPayload"];
  InternalCreateAccommodationOperationGroupError: InternalCreateAccommodationOperationGroupError;
  InternalCreateAccommodationOperationGroupInput: InternalCreateAccommodationOperationGroupInput;
  InternalCreateAccommodationOperationGroupPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateAccommodationOperationGroupPayload"];
  InternalCreateAccommodationReservationInput: InternalCreateAccommodationReservationInput;
  InternalCreateArchitectureContentImageUploadPolicyInput: InternalCreateArchitectureContentImageUploadPolicyInput;
  InternalCreateAreaImageUploadPolicyInput: InternalCreateAreaImageUploadPolicyInput;
  InternalCreateAreaInput: InternalCreateAreaInput;
  InternalCreateCoOwnersIdentityVerificationError: InternalCreateCoOwnersIdentityVerificationError;
  InternalCreateCoOwnersIdentityVerificationInput: InternalCreateCoOwnersIdentityVerificationInput;
  InternalCreateCoOwnersIdentityVerificationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateCoOwnersIdentityVerificationPayload"];
  InternalCreateConsumedSuppliesFeeItemsError: InternalCreateConsumedSuppliesFeeItemsError;
  InternalCreateConsumedSuppliesFeeItemsInput: InternalCreateConsumedSuppliesFeeItemsInput;
  InternalCreateConsumedSuppliesFeeItemsPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateConsumedSuppliesFeeItemsPayload"];
  InternalCreateFacilityImageUploadPolicyInput: InternalCreateFacilityImageUploadPolicyInput;
  InternalCreateFacilityInput: InternalCreateFacilityInput;
  InternalCreateFacilityReservationError: InternalCreateFacilityReservationError;
  InternalCreateFacilityReservationInput: InternalCreateFacilityReservationInput;
  InternalCreateFacilityReservationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateFacilityReservationPayload"];
  InternalCreateFullOwnerIdentityVerificationError: InternalCreateFullOwnerIdentityVerificationError;
  InternalCreateFullOwnerIdentityVerificationInput: InternalCreateFullOwnerIdentityVerificationInput;
  InternalCreateFullOwnerIdentityVerificationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateFullOwnerIdentityVerificationPayload"];
  InternalCreateLocalTaxPolicyError: InternalCreateLocalTaxPolicyError;
  InternalCreateLocalTaxPolicyInput: InternalCreateLocalTaxPolicyInput;
  InternalCreateLocalTaxPolicyPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateLocalTaxPolicyPayload"];
  InternalCreateOrUpdateAccommodationContentInput: InternalCreateOrUpdateAccommodationContentInput;
  InternalCreateOrUpdateAccommodationError: InternalCreateOrUpdateAccommodationError;
  InternalCreateOrUpdateAccommodationInput: InternalCreateOrUpdateAccommodationInput;
  InternalCreateOrUpdateAccommodationNoticeError: InternalCreateOrUpdateAccommodationNoticeError;
  InternalCreateOrUpdateAccommodationNoticeInput: InternalCreateOrUpdateAccommodationNoticeInput;
  InternalCreateOrUpdateAccommodationNoticePayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateAccommodationNoticePayload"];
  InternalCreateOrUpdateAccommodationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateAccommodationPayload"];
  InternalCreateOrUpdateAdditionalGuestFeePolicyError: InternalCreateOrUpdateAdditionalGuestFeePolicyError;
  InternalCreateOrUpdateAdditionalGuestFeePolicyInput: InternalCreateOrUpdateAdditionalGuestFeePolicyInput;
  InternalCreateOrUpdateAdditionalGuestFeePolicyPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateAdditionalGuestFeePolicyPayload"];
  InternalCreateOrUpdateArchitectureTypeInput: InternalCreateOrUpdateArchitectureTypeInput;
  InternalCreateOrUpdateAreaGuideArticleInput: InternalCreateOrUpdateAreaGuideArticleInput;
  InternalCreateOrUpdateAreaGuideSpotInput: InternalCreateOrUpdateAreaGuideSpotInput;
  InternalCreateOrUpdateBaseAccommodationFeePolicyError: InternalCreateOrUpdateBaseAccommodationFeePolicyError;
  InternalCreateOrUpdateBaseAccommodationFeePolicyPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateBaseAccommodationFeePolicyPayload"];
  InternalCreateOrUpdateBusinessPlanError: InternalCreateOrUpdateBusinessPlanError;
  InternalCreateOrUpdateBusinessPlanPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateBusinessPlanPayload"];
  InternalCreateOrUpdateCancelFeePolicyError: InternalCreateOrUpdateCancelFeePolicyError;
  InternalCreateOrUpdateCancelFeePolicyPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateCancelFeePolicyPayload"];
  InternalCreateOrUpdateCoOwnersPlanOfferingError: InternalCreateOrUpdateCoOwnersPlanOfferingError;
  InternalCreateOrUpdateCoOwnersPlanOfferingInput: InternalCreateOrUpdateCoOwnersPlanOfferingInput;
  InternalCreateOrUpdateCoOwnersPlanOfferingPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateCoOwnersPlanOfferingPayload"];
  InternalCreateOrUpdateCoOwnersWebinarScheduleError: InternalCreateOrUpdateCoOwnersWebinarScheduleError;
  InternalCreateOrUpdateCoOwnersWebinarScheduleInput: InternalCreateOrUpdateCoOwnersWebinarScheduleInput;
  InternalCreateOrUpdateCoOwnersWebinarSchedulePayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateCoOwnersWebinarSchedulePayload"];
  InternalCreateOrUpdateContentArchitectInput: InternalCreateOrUpdateContentArchitectInput;
  InternalCreateOrUpdateContentArchitectPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateContentArchitectPayload"];
  InternalCreateOrUpdateContentArchitecturalFeatureInput: InternalCreateOrUpdateContentArchitecturalFeatureInput;
  InternalCreateOrUpdateContentArchitecturalFeaturePayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateContentArchitecturalFeaturePayload"];
  InternalCreateOrUpdateContentArchitecturalFeatureUsageRuleInput: InternalCreateOrUpdateContentArchitecturalFeatureUsageRuleInput;
  InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload"];
  InternalCreateOrUpdateContentArchitectureTypeBasicAmenityInput: InternalCreateOrUpdateContentArchitectureTypeBasicAmenityInput;
  InternalCreateOrUpdateContentArchitectureTypeInput: InternalCreateOrUpdateContentArchitectureTypeInput;
  InternalCreateOrUpdateContentArchitectureTypePayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateContentArchitectureTypePayload"];
  InternalCreateOrUpdateContentArchitectureTypeVariantInput: InternalCreateOrUpdateContentArchitectureTypeVariantInput;
  InternalCreateOrUpdateContentArchitectureTypeVariantPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateContentArchitectureTypeVariantPayload"];
  InternalCreateOrUpdateContentBasicAmenityPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateContentBasicAmenityPayload"];
  InternalCreateOrUpdateContentFacilityAmenityInput: InternalCreateOrUpdateContentFacilityAmenityInput;
  InternalCreateOrUpdateContentFacilityAmenityPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateContentFacilityAmenityPayload"];
  InternalCreateOrUpdateFacilityBaseFeePolicyInput: InternalCreateOrUpdateFacilityBaseFeePolicyInput;
  InternalCreateOrUpdateFacilityCancelFeePolicyInput: InternalCreateOrUpdateFacilityCancelFeePolicyInput;
  InternalCreateOrUpdateFacilityControllerInput: InternalCreateOrUpdateFacilityControllerInput;
  InternalCreateOrUpdateFacilityError: InternalCreateOrUpdateFacilityError;
  InternalCreateOrUpdateFacilityPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateFacilityPayload"];
  InternalCreateOrUpdateFacilityResourceBlockError: InternalCreateOrUpdateFacilityResourceBlockError;
  InternalCreateOrUpdateFacilityResourceBlockInput: InternalCreateOrUpdateFacilityResourceBlockInput;
  InternalCreateOrUpdateFacilityResourceBlockPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateFacilityResourceBlockPayload"];
  InternalCreateOrUpdateFacilityResourceInput: InternalCreateOrUpdateFacilityResourceInput;
  InternalCreateOrUpdateFacilitySlotInput: InternalCreateOrUpdateFacilitySlotInput;
  InternalCreateOrUpdateNativeAppHomeContentError: InternalCreateOrUpdateNativeAppHomeContentError;
  InternalCreateOrUpdateNativeAppHomeContentPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateNativeAppHomeContentPayload"];
  InternalCreateOrUpdateNewsError: InternalCreateOrUpdateNewsError;
  InternalCreateOrUpdateNewsInput: InternalCreateOrUpdateNewsInput;
  InternalCreateOrUpdateNewsPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateNewsPayload"];
  InternalCreateOrUpdateOrganizationError: InternalCreateOrUpdateOrganizationError;
  InternalCreateOrUpdateOrganizationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateOrganizationPayload"];
  InternalCreateOrUpdateOrganizationYearlyContractError: InternalCreateOrUpdateOrganizationYearlyContractError;
  InternalCreateOrUpdateOrganizationYearlyContractInvoiceError: InternalCreateOrUpdateOrganizationYearlyContractInvoiceError;
  InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload"];
  InternalCreateOrUpdateOrganizationYearlyContractPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateOrganizationYearlyContractPayload"];
  InternalCreateOrUpdateOwnerPlanError: InternalCreateOrUpdateOwnerPlanError;
  InternalCreateOrUpdateOwnerPlanInput: InternalCreateOrUpdateOwnerPlanInput;
  InternalCreateOrUpdateOwnerPlanPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateOwnerPlanPayload"];
  InternalCreateOrUpdateSiteAccessRouteGroupInput: InternalCreateOrUpdateSiteAccessRouteGroupInput;
  InternalCreateOrUpdateSiteActivityProgramError: InternalCreateOrUpdateSiteActivityProgramError;
  InternalCreateOrUpdateSiteActivityProgramPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateSiteActivityProgramPayload"];
  InternalCreateOrUpdateSiteFaqError: InternalCreateOrUpdateSiteFaqError;
  InternalCreateOrUpdateSiteFaqInput: InternalCreateOrUpdateSiteFaqInput;
  InternalCreateOrUpdateSiteFaqPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateSiteFaqPayload"];
  InternalCreateOrUpdateSiteImagesInput: InternalCreateOrUpdateSiteImagesInput;
  InternalCreateOrUpdateStaffGroupError: InternalCreateOrUpdateStaffGroupError;
  InternalCreateOrUpdateStaffGroupPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateStaffGroupPayload"];
  InternalCreateOrUpdateStayTicketMasterError: InternalCreateOrUpdateStayTicketMasterError;
  InternalCreateOrUpdateStayTicketMasterInput: InternalCreateOrUpdateStayTicketMasterInput;
  InternalCreateOrUpdateStayTicketMasterPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateStayTicketMasterPayload"];
  InternalCreateOrUpdateStayTicketMasterTemplateError: InternalCreateOrUpdateStayTicketMasterTemplateError;
  InternalCreateOrUpdateStayTicketMasterTemplateInput: InternalCreateOrUpdateStayTicketMasterTemplateInput;
  InternalCreateOrUpdateStayTicketMasterTemplatePayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateStayTicketMasterTemplatePayload"];
  InternalCreateOrUpdateStayTicketTemplateError: InternalCreateOrUpdateStayTicketTemplateError;
  InternalCreateOrUpdateStayTicketTemplateInput: InternalCreateOrUpdateStayTicketTemplateInput;
  InternalCreateOrUpdateSupplyItemInstallationInput: InternalCreateOrUpdateSupplyItemInstallationInput;
  InternalCreateOrUpdateSupplyItemInstallationsError: InternalCreateOrUpdateSupplyItemInstallationsError;
  InternalCreateOrUpdateSupplyItemInstallationsPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateSupplyItemInstallationsPayload"];
  InternalCreateOrUpdateSupplyItemMasterError: InternalCreateOrUpdateSupplyItemMasterError;
  InternalCreateOrUpdateSupplyItemMasterInput: InternalCreateOrUpdateSupplyItemMasterInput;
  InternalCreateOrUpdateSupplyItemMasterPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateOrUpdateSupplyItemMasterPayload"];
  InternalCreateOtaRoomUnitInput: InternalCreateOtaRoomUnitInput;
  InternalCreateRoomTypeImageUploadPolicyInput: InternalCreateRoomTypeImageUploadPolicyInput;
  InternalCreateRoomTypeInput: InternalCreateRoomTypeInput;
  InternalCreateSiteActivityProgramInput: InternalCreateSiteActivityProgramInput;
  InternalCreateSiteError: InternalCreateSiteError;
  InternalCreateSiteFaqImageUploadPolicyInput: InternalCreateSiteFaqImageUploadPolicyInput;
  InternalCreateSiteHighSeasonPeriodInput: InternalCreateSiteHighSeasonPeriodInput;
  InternalCreateSiteImageUploadPolicyInput: InternalCreateSiteImageUploadPolicyInput;
  InternalCreateSiteInput: InternalCreateSiteInput;
  InternalCreateSitePayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateSitePayload"];
  InternalCreateStayTicketTemplatePayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateStayTicketTemplatePayload"];
  InternalCreateTermsRevisionError: InternalCreateTermsRevisionError;
  InternalCreateTermsRevisionInput: InternalCreateTermsRevisionInput;
  InternalCreateTermsRevisionPayload: ResolversUnionTypes<ResolversParentTypes>["InternalCreateTermsRevisionPayload"];
  InternalDeleteAccommodationEquipmentPayload: ResolversUnionTypes<ResolversParentTypes>["InternalDeleteAccommodationEquipmentPayload"];
  InternalDeleteAccommodationEquipmentSuccess: InternalDeleteAccommodationEquipmentSuccess;
  InternalDeleteArchitectureContentPayload: ResolversUnionTypes<ResolversParentTypes>["InternalDeleteArchitectureContentPayload"];
  InternalDeleteFacilityResourceBlockError: InternalDeleteFacilityResourceBlockError;
  InternalDeleteFacilityResourceBlockPayload: ResolversUnionTypes<ResolversParentTypes>["InternalDeleteFacilityResourceBlockPayload"];
  InternalDeleteLocalTaxPolicyError: InternalDeleteLocalTaxPolicyError;
  InternalDeleteLocalTaxPolicyPayload: ResolversUnionTypes<ResolversParentTypes>["InternalDeleteLocalTaxPolicyPayload"];
  InternalDeleteSupplyItemInstallationError: InternalDeleteSupplyItemInstallationError;
  InternalDeleteSupplyItemInstallationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalDeleteSupplyItemInstallationPayload"];
  InternalDeleteSupplyItemMasterError: InternalDeleteSupplyItemMasterError;
  InternalDeleteSupplyItemMasterPayload: ResolversUnionTypes<ResolversParentTypes>["InternalDeleteSupplyItemMasterPayload"];
  InternalFacilityController: InternalFacilityController;
  InternalFacilityReservationDiscountInput: InternalFacilityReservationDiscountInput;
  InternalFutureCleaningAmount: Omit<
    InternalFutureCleaningAmount,
    "accommodations"
  > & { accommodations: Array<ResolversParentTypes["Accommodation"]> };
  InternalFutureCleaningAmountByFacility: InternalFutureCleaningAmountByFacility;
  InternalFutureCleaningAmounts: Omit<InternalFutureCleaningAmounts, "list"> & {
    list: Array<ResolversParentTypes["InternalFutureCleaningAmount"]>;
  };
  InternalFutureCleaningAmountsError: InternalFutureCleaningAmountsError;
  InternalFutureCleaningAmountsPayload: ResolversUnionTypes<ResolversParentTypes>["InternalFutureCleaningAmountsPayload"];
  InternalGenerateUserMonthlyStatementError: InternalGenerateUserMonthlyStatementError;
  InternalGenerateUserMonthlyStatementPayload: ResolversUnionTypes<ResolversParentTypes>["InternalGenerateUserMonthlyStatementPayload"];
  InternalGrantableAdminRole: InternalGrantableAdminRole;
  InternalInvalidateOrganizationYearlyContractError: InternalInvalidateOrganizationYearlyContractError;
  InternalInvalidateOrganizationYearlyContractInvoiceError: InternalInvalidateOrganizationYearlyContractInvoiceError;
  InternalInvalidateOrganizationYearlyContractInvoicePayload: ResolversUnionTypes<ResolversParentTypes>["InternalInvalidateOrganizationYearlyContractInvoicePayload"];
  InternalInvalidateOrganizationYearlyContractPayload: ResolversUnionTypes<ResolversParentTypes>["InternalInvalidateOrganizationYearlyContractPayload"];
  InternalInvalidateS2oPointsError: InternalInvalidateS2oPointsError;
  InternalInvalidateS2oPointsInput: InternalInvalidateS2oPointsInput;
  InternalInvalidateS2oPointsPayload: ResolversUnionTypes<ResolversParentTypes>["InternalInvalidateS2oPointsPayload"];
  InternalInvalidateStayTicketsByCodeResult: Omit<
    InternalInvalidateStayTicketsByCodeResult,
    "invalidatedTickets" | "skippedTickets"
  > & {
    invalidatedTickets: Array<ResolversParentTypes["StayTicket"]>;
    skippedTickets: Array<ResolversParentTypes["StayTicket"]>;
  };
  InternalIssueS2oPointsError: InternalIssueS2oPointsError;
  InternalIssueS2oPointsInput: InternalIssueS2oPointsInput;
  InternalIssueS2oPointsPayload: ResolversUnionTypes<ResolversParentTypes>["InternalIssueS2oPointsPayload"];
  InternalJtasCreateOrUpdateInspectionStatusesError: InternalJtasCreateOrUpdateInspectionStatusesError;
  InternalJtasCreateOrUpdateInspectionStatusesInput: InternalJtasCreateOrUpdateInspectionStatusesInput;
  InternalJtasCreateOrUpdateInspectionStatusesPayload: ResolversUnionTypes<ResolversParentTypes>["InternalJtasCreateOrUpdateInspectionStatusesPayload"];
  InternalJtasCreateOrUpdateSupplyReportError: InternalJtasCreateOrUpdateSupplyReportError;
  InternalJtasCreateOrUpdateSupplyReportInput: InternalJtasCreateOrUpdateSupplyReportInput;
  InternalJtasCreateOrUpdateSupplyReportPayload: ResolversUnionTypes<ResolversParentTypes>["InternalJtasCreateOrUpdateSupplyReportPayload"];
  InternalJtasCreateOrUpdateViolationReportError: InternalJtasCreateOrUpdateViolationReportError;
  InternalJtasCreateOrUpdateViolationReportInput: InternalJtasCreateOrUpdateViolationReportInput;
  InternalJtasCreateOrUpdateViolationReportPayload: ResolversUnionTypes<ResolversParentTypes>["InternalJtasCreateOrUpdateViolationReportPayload"];
  InternalJtasDeleteViolationReportError: InternalJtasDeleteViolationReportError;
  InternalJtasDeleteViolationReportInput: InternalJtasDeleteViolationReportInput;
  InternalJtasDeleteViolationReportPayload: ResolversUnionTypes<ResolversParentTypes>["InternalJtasDeleteViolationReportPayload"];
  InternalJtasInspectionStatusInput: InternalJtasInspectionStatusInput;
  InternalJtasSupplyItemInput: InternalJtasSupplyItemInput;
  InternalJtasViolationItemInput: InternalJtasViolationItemInput;
  InternalLeaveOrganizationError: InternalLeaveOrganizationError;
  InternalLeaveOrganizationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalLeaveOrganizationPayload"];
  InternalLocalTaxFixedAmountInput: InternalLocalTaxFixedAmountInput;
  InternalLocalTaxFixedRateInput: InternalLocalTaxFixedRateInput;
  InternalLocalTaxRuleInput: InternalLocalTaxRuleInput;
  InternalLocalTaxSteppedAmountInput: InternalLocalTaxSteppedAmountInput;
  InternalLocalTaxSteppedBracketInput: InternalLocalTaxSteppedBracketInput;
  InternalLocalizedString: InternalLocalizedString;
  InternalLocalizedStringInput: InternalLocalizedStringInput;
  InternalMarkCoOwnersApplicationPlannedForSaleError: InternalMarkCoOwnersApplicationPlannedForSaleError;
  InternalMarkCoOwnersApplicationPlannedForSalePayload: ResolversUnionTypes<ResolversParentTypes>["InternalMarkCoOwnersApplicationPlannedForSalePayload"];
  InternalMarkCoOwnersApplicationSoldError: InternalMarkCoOwnersApplicationSoldError;
  InternalMarkCoOwnersApplicationSoldPayload: ResolversUnionTypes<ResolversParentTypes>["InternalMarkCoOwnersApplicationSoldPayload"];
  InternalNativeAppHomeContent: InternalNativeAppHomeContentMapper;
  InternalNativeAppHomeContentInput: InternalNativeAppHomeContentInput;
  InternalOneShotScript: InternalOneShotScriptMapper;
  InternalOtaRoomUnit: InternalOtaRoomUnitMapper;
  InternalPartialUpdateOrganizationError: InternalPartialUpdateOrganizationError;
  InternalPartialUpdateOrganizationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalPartialUpdateOrganizationPayload"];
  InternalRegisterCoOwnersApplicationFileInput: InternalRegisterCoOwnersApplicationFileInput;
  InternalReleaseAccessKeyError: InternalReleaseAccessKeyError;
  InternalReleaseAccessKeyPayload: ResolversUnionTypes<ResolversParentTypes>["InternalReleaseAccessKeyPayload"];
  InternalRemoveLocalTaxPolicyError: InternalRemoveLocalTaxPolicyError;
  InternalRemoveLocalTaxPolicyPayload: ResolversUnionTypes<ResolversParentTypes>["InternalRemoveLocalTaxPolicyPayload"];
  InternalRemoveLocalTaxPolicyTargetInput: InternalRemoveLocalTaxPolicyTargetInput;
  InternalReorderAccommodationInput: InternalReorderAccommodationInput;
  InternalReorderArchitectureContentInput: InternalReorderArchitectureContentInput;
  InternalReorderAreaInput: InternalReorderAreaInput;
  InternalReorderInput: InternalReorderInput;
  InternalReorderSiteFaqInput: InternalReorderSiteFaqInput;
  InternalReorderSiteInput: InternalReorderSiteInput;
  InternalRevokeAdminRoleError: InternalRevokeAdminRoleError;
  InternalRevokeAdminRolePayload: ResolversUnionTypes<ResolversParentTypes>["InternalRevokeAdminRolePayload"];
  InternalRoomType: InternalRoomTypeMapper;
  InternalRoomTypeFeature: InternalRoomTypeFeatureMapper;
  InternalRunOneShotScriptError: InternalRunOneShotScriptError;
  InternalRunOneShotScriptInput: InternalRunOneShotScriptInput;
  InternalRunOneShotScriptResult: ResolversUnionTypes<ResolversParentTypes>["InternalRunOneShotScriptResult"];
  InternalScriptAffectedCount: InternalScriptAffectedCountMapper;
  InternalScriptExecution: InternalScriptExecutionMapper;
  InternalScriptExecutionActor: InternalScriptExecutionActorMapper;
  InternalScriptExecutionLogLine: InternalScriptExecutionLogLineMapper;
  InternalSendPushNotificationsError: InternalSendPushNotificationsError;
  InternalSendPushNotificationsInput: InternalSendPushNotificationsInput;
  InternalSendPushNotificationsPayload: ResolversUnionTypes<ResolversParentTypes>["InternalSendPushNotificationsPayload"];
  InternalSendPushNotificationsResult: InternalSendPushNotificationsResult;
  InternalSite: InternalSiteMapper;
  InternalSiteAccessRoutePointInput: InternalSiteAccessRoutePointInput;
  InternalSiteAddress: InternalSiteAddressMapper;
  InternalStaffContract: InternalStaffContractMapper;
  InternalStaffCreditTransaction: InternalStaffCreditTransactionMapper;
  InternalStartStaffPlanError: InternalStartStaffPlanError;
  InternalStartStaffPlanResult: ResolversUnionTypes<ResolversParentTypes>["InternalStartStaffPlanResult"];
  InternalStartStaffPlanSuccess: Omit<
    InternalStartStaffPlanSuccess,
    "contract"
  > & { contract: ResolversParentTypes["StaffContract"] };
  InternalStayTicketsResult: Omit<InternalStayTicketsResult, "items"> & {
    items: Array<ResolversParentTypes["StayTicket"]>;
  };
  InternalStopStaffPlanError: InternalStopStaffPlanError;
  InternalStopStaffPlanResult: ResolversUnionTypes<ResolversParentTypes>["InternalStopStaffPlanResult"];
  InternalStopStaffPlanSuccess: Omit<
    InternalStopStaffPlanSuccess,
    "contract"
  > & { contract: ResolversParentTypes["StaffContract"] };
  InternalUnlinkIdentityPayload: InternalUnlinkIdentityPayload;
  InternalUpdateAccommodationAvailabilityBlockReleaseScheduleInput: InternalUpdateAccommodationAvailabilityBlockReleaseScheduleInput;
  InternalUpdateAccommodationEquipmentInput: InternalUpdateAccommodationEquipmentInput;
  InternalUpdateAccommodationEquipmentPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateAccommodationEquipmentPayload"];
  InternalUpdateAccommodationOperationGroupSettingError: InternalUpdateAccommodationOperationGroupSettingError;
  InternalUpdateAccommodationOperationGroupSettingInput: InternalUpdateAccommodationOperationGroupSettingInput;
  InternalUpdateAccommodationOperationGroupSettingPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateAccommodationOperationGroupSettingPayload"];
  InternalUpdateAccommodationReservationInput: InternalUpdateAccommodationReservationInput;
  InternalUpdateAreaContentInput: InternalUpdateAreaContentInput;
  InternalUpdateAreaError: InternalUpdateAreaError;
  InternalUpdateAreaInput: InternalUpdateAreaInput;
  InternalUpdateAreaPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateAreaPayload"];
  InternalUpdateCoOwnersApplicationDetailError: InternalUpdateCoOwnersApplicationDetailError;
  InternalUpdateCoOwnersApplicationDetailPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateCoOwnersApplicationDetailPayload"];
  InternalUpdateCoOwnersApplicationFileError: InternalUpdateCoOwnersApplicationFileError;
  InternalUpdateCoOwnersApplicationFilePayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateCoOwnersApplicationFilePayload"];
  InternalUpdateCoOwnersApplicationInfoError: InternalUpdateCoOwnersApplicationInfoError;
  InternalUpdateCoOwnersApplicationInfoPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateCoOwnersApplicationInfoPayload"];
  InternalUpdateCoOwnersApplicationStatusError: InternalUpdateCoOwnersApplicationStatusError;
  InternalUpdateCoOwnersApplicationStatusPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateCoOwnersApplicationStatusPayload"];
  InternalUpdateFacilityContentImagesInput: InternalUpdateFacilityContentImagesInput;
  InternalUpdateFacilityContentImagesPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateFacilityContentImagesPayload"];
  InternalUpdateFacilityInput: InternalUpdateFacilityInput;
  InternalUpdateFacilityReservationCleaningError: InternalUpdateFacilityReservationCleaningError;
  InternalUpdateFacilityReservationCleaningPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateFacilityReservationCleaningPayload"];
  InternalUpdateFacilityReservationDataSyncError: InternalUpdateFacilityReservationDataSyncError;
  InternalUpdateFacilityReservationDataSyncPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateFacilityReservationDataSyncPayload"];
  InternalUpdateIdentityVerificationError: InternalUpdateIdentityVerificationError;
  InternalUpdateIdentityVerificationInput: InternalUpdateIdentityVerificationInput;
  InternalUpdateIdentityVerificationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateIdentityVerificationPayload"];
  InternalUpdateIndividualTermsDocumentError: InternalUpdateIndividualTermsDocumentError;
  InternalUpdateIndividualTermsDocumentInput: InternalUpdateIndividualTermsDocumentInput;
  InternalUpdateIndividualTermsDocumentPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateIndividualTermsDocumentPayload"];
  InternalUpdateInspectionViolationHandlingError: InternalUpdateInspectionViolationHandlingError;
  InternalUpdateInspectionViolationHandlingInput: InternalUpdateInspectionViolationHandlingInput;
  InternalUpdateInspectionViolationHandlingPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateInspectionViolationHandlingPayload"];
  InternalUpdateLocalTaxPolicyError: InternalUpdateLocalTaxPolicyError;
  InternalUpdateLocalTaxPolicyInput: InternalUpdateLocalTaxPolicyInput;
  InternalUpdateLocalTaxPolicyPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateLocalTaxPolicyPayload"];
  InternalUpdateRoomTypeContentInput: InternalUpdateRoomTypeContentInput;
  InternalUpdateRoomTypeInput: InternalUpdateRoomTypeInput;
  InternalUpdateSiteActivityProgramInput: InternalUpdateSiteActivityProgramInput;
  InternalUpdateSiteContentInput: InternalUpdateSiteContentInput;
  InternalUpdateSiteError: InternalUpdateSiteError;
  InternalUpdateSiteHighSeasonPeriodInput: InternalUpdateSiteHighSeasonPeriodInput;
  InternalUpdateSiteImagesPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateSiteImagesPayload"];
  InternalUpdateSiteInput: InternalUpdateSiteInput;
  InternalUpdateSiteParametersError: InternalUpdateSiteParametersError;
  InternalUpdateSiteParametersInput: InternalUpdateSiteParametersInput;
  InternalUpdateSiteParametersPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateSiteParametersPayload"];
  InternalUpdateSitePayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateSitePayload"];
  InternalUpdateStayTicketInput: InternalUpdateStayTicketInput;
  InternalUpdateStayTicketInvalidStatusError: InternalUpdateStayTicketInvalidStatusError;
  InternalUpdateStayTicketNotFoundError: InternalUpdateStayTicketNotFoundError;
  InternalUpdateStayTicketPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpdateStayTicketPayload"];
  InternalUpdateUserInput: InternalUpdateUserInput;
  InternalUpsertBaseAccommodationFeeDailyRateError: InternalUpsertBaseAccommodationFeeDailyRateError;
  InternalUpsertBaseAccommodationFeeDailyRateInput: InternalUpsertBaseAccommodationFeeDailyRateInput;
  InternalUpsertBaseAccommodationFeeDailyRatesPayload: InternalUpsertBaseAccommodationFeeDailyRatesPayload;
  InternalUpsertConsumedSupplyFeeItemWaiversError: InternalUpsertConsumedSupplyFeeItemWaiversError;
  InternalUpsertConsumedSupplyFeeItemWaiversInput: InternalUpsertConsumedSupplyFeeItemWaiversInput;
  InternalUpsertConsumedSupplyFeeItemWaiversPayload: ResolversUnionTypes<ResolversParentTypes>["InternalUpsertConsumedSupplyFeeItemWaiversPayload"];
  InternalUserSearchResult: Omit<InternalUserSearchResult, "users"> & {
    users: Array<ResolversParentTypes["User"]>;
  };
  InternalUserStats: InternalUserStats;
  InternalVoidCoOwnersApplicationError: InternalVoidCoOwnersApplicationError;
  InternalVoidCoOwnersApplicationPayload: ResolversUnionTypes<ResolversParentTypes>["InternalVoidCoOwnersApplicationPayload"];
  InviteBusinessMembersError: InviteBusinessMembersError;
  InviteBusinessMembersInput: InviteBusinessMembersInput;
  InviteBusinessMembersPayload: ResolversUnionTypes<ResolversParentTypes>["InviteBusinessMembersPayload"];
  InviteBusinessMembersSuccess: InviteBusinessMembersSuccess;
  IssueSanuEdgeDeviceAccessTokenError: IssueSanuEdgeDeviceAccessTokenError;
  IssueSanuEdgeDeviceAccessTokenInput: IssueSanuEdgeDeviceAccessTokenInput;
  IssueSanuEdgeDeviceAccessTokenPayload: ResolversUnionTypes<ResolversParentTypes>["IssueSanuEdgeDeviceAccessTokenPayload"];
  IssueSanuEdgeDeviceAccessTokenSuccess: Omit<
    IssueSanuEdgeDeviceAccessTokenSuccess,
    "device"
  > & { device: ResolversParentTypes["SanuEdgeDevice"] };
  IssueStayTicketsError: IssueStayTicketsError;
  IssueStayTicketsInput: IssueStayTicketsInput;
  IssueStayTicketsPayload: ResolversUnionTypes<ResolversParentTypes>["IssueStayTicketsPayload"];
  IssueStayTicketsResult: Omit<IssueStayTicketsResult, "tickets"> & {
    tickets: Array<ResolversParentTypes["StayTicket"]>;
  };
  JoinOrganizationError: JoinOrganizationError;
  JoinOrganizationPayload: ResolversUnionTypes<ResolversParentTypes>["JoinOrganizationPayload"];
  LeaveOrganizationByViewerError: LeaveOrganizationByViewerError;
  LeaveOrganizationByViewerPayload: ResolversUnionTypes<ResolversParentTypes>["LeaveOrganizationByViewerPayload"];
  LeaveOrganizationError: LeaveOrganizationError;
  LoadDataOutput: LoadDataOutput;
  LoadDataOutputResult: LoadDataOutputResult;
  LoadDataOutputResultError: LoadDataOutputResultError;
  LocalTaxBracket: LocalTaxBracketMapper;
  LocalTaxPolicy: LocalTaxPolicyMapper;
  MemberPerksNowhereDrinkTicket: MemberPerksNowhereDrinkTicketMapper;
  MusicConnectEquipmentAttribute: MusicConnectEquipmentAttributeMapper;
  Mutation: Record<PropertyKey, never>;
  NativeAppHomeContent: NativeAppHomeContentMapper;
  NativeAppHomeContentLabel: NativeAppHomeContentLabel;
  NativeAppHomeContentLink: NativeAppHomeContentLink;
  News: NewsMapper;
  OneMoreCabinAccommodationReservationProvider: OneMoreCabinAccommodationReservationProvider;
  OnlineTravelAgentAccommodationReservationProvider: OnlineTravelAgentAccommodationReservationProvider;
  OnsenAccommodationFacility: OnsenAccommodationFacility;
  OnsenAndSaunaDoorLock: OnsenAndSaunaDoorLock;
  Organization: OrganizationMapper;
  OrganizationControl: OrganizationControl;
  OrganizationMemberCustomField: OrganizationMemberCustomField;
  OrganizationMemberNewReservationStatus: OrganizationMemberNewReservationStatus;
  OrganizationMemberPayload: Omit<OrganizationMemberPayload, "user"> & {
    user: ResolversParentTypes["User"];
  };
  OrganizationMembersStay: OrganizationMembersStayMapper;
  OrganizationMembership: OrganizationMembershipMapper;
  OrganizationMonthlyReservationStatus: OrganizationMonthlyReservationStatus;
  OrganizationOnboardingInfo: OrganizationOnboardingInfo;
  OrganizationPlanMonthlyConsumedNights: OrganizationPlanMonthlyConsumedNights;
  OrganizationYearlyContract: OrganizationYearlyContractMapper;
  OrganizationYearlyContractInvoicesResult: Omit<
    OrganizationYearlyContractInvoicesResult,
    "data"
  > & { data: Array<ResolversParentTypes["StripeInvoice"]> };
  OrganizationYearlyContractSortInput: OrganizationYearlyContractSortInput;
  OrganizationYearlyContractsResult: Omit<
    OrganizationYearlyContractsResult,
    "data"
  > & { data: Array<ResolversParentTypes["OrganizationYearlyContract"]> };
  OrganizationYearlyReservationStatus: OrganizationYearlyReservationStatus;
  OtaReservationLookupError: OtaReservationLookupError;
  OtaReservationLookupResult: ResolversUnionTypes<ResolversParentTypes>["OtaReservationLookupResult"];
  OtaReservationLookupSuccess: OtaReservationLookupSuccess;
  OwnerPlan: OwnerPlanMapper;
  PartialUpdateOrganizationError: PartialUpdateOrganizationError;
  PartialUpdateOrganizationInput: PartialUpdateOrganizationInput;
  PartialUpdateOrganizationMembershipError: PartialUpdateOrganizationMembershipError;
  PartialUpdateOrganizationMembershipInput: PartialUpdateOrganizationMembershipInput;
  PartialUpdateOrganizationMembershipPayload: ResolversUnionTypes<ResolversParentTypes>["PartialUpdateOrganizationMembershipPayload"];
  PartialUpdateOrganizationPayload: ResolversUnionTypes<ResolversParentTypes>["PartialUpdateOrganizationPayload"];
  PlainDate: Scalars["PlainDate"]["output"];
  PlainDateTime: Scalars["PlainDateTime"]["output"];
  PlainYearMonth: Scalars["PlainYearMonth"]["output"];
  PlainYearMonthFilter: PlainYearMonthFilter;
  PlugDevice: PlugDeviceMapper;
  PostStayReviewResponseError: PostStayReviewResponseError;
  PostStayReviewResponseInput: PostStayReviewResponseInput;
  PostStayReviewResponsePayload: ResolversUnionTypes<ResolversParentTypes>["PostStayReviewResponsePayload"];
  PriceWithTaxRate: PriceWithTaxRate;
  ProcessCronJobResponse: ProcessCronJobResponse;
  ProcessStripeEventResponse: ProcessStripeEventResponse;
  ProcessTrustdockEventResponse: ProcessTrustdockEventResponse;
  Query: Record<PropertyKey, never>;
  RawBaseAccommodationFeePolicy: Omit<
    RawBaseAccommodationFeePolicy,
    "feeRules"
  > & { feeRules: Array<ResolversParentTypes["AccommodationFeeRule"]> };
  RawCancelFeePolicy: Omit<RawCancelFeePolicy, "cancelFeePolicy"> & {
    cancelFeePolicy: ResolversParentTypes["CancelFeePolicy"];
  };
  RawNews: RawNewsMapper;
  RawSiteFaq: RawSiteFaqMapper;
  RedirectLocation: RedirectLocation;
  RegisterCoOwnersApplicationFileError: RegisterCoOwnersApplicationFileError;
  RegisterCoOwnersApplicationFileInput: RegisterCoOwnersApplicationFileInput;
  RegisterCoOwnersApplicationFilePayload: ResolversUnionTypes<ResolversParentTypes>["RegisterCoOwnersApplicationFilePayload"];
  RegisterCoOwnersApplicationFileSuccess: Omit<
    RegisterCoOwnersApplicationFileSuccess,
    "file"
  > & { file: ResolversParentTypes["CoOwnersApplicationFile"] };
  RemoveIdentityError: RemoveIdentityError;
  RemoveIdentityInput: RemoveIdentityInput;
  RemoveIdentityPayload: ResolversUnionTypes<ResolversParentTypes>["RemoveIdentityPayload"];
  RemoveIdentitySuccess: RemoveIdentitySuccess;
  RentalCycleKeyBox: RentalCycleKeyBox;
  ReservationExportItem: ReservationExportItem;
  ReservationPriceStatement: ReservationPriceStatementMapper;
  ReservationRuleRevision2027Policy: ReservationRuleRevision2027Policy;
  ReservationStatementItem: ReservationStatementItemMapper;
  ResumeStandardSubscriptionImmediatelyError: ResumeStandardSubscriptionImmediatelyError;
  ResumeStandardSubscriptionImmediatelyPayload: ResolversUnionTypes<ResolversParentTypes>["ResumeStandardSubscriptionImmediatelyPayload"];
  RoomType: RoomTypeMapper;
  RoomTypeAvailabilities: RoomTypeAvailabilitiesMapper;
  RoomTypeAvailability: RoomTypeAvailabilityMapper;
  RoomTypeFeature: RoomTypeFeatureMapper;
  S2o: S2oMapper;
  S2oPoint: S2oPointMapper;
  S3UploadPolicy: S3UploadPolicy;
  S3UploadPolicyField: S3UploadPolicyField;
  SanuEdgeDevice: SanuEdgeDeviceMapper;
  SanuIncAccommodationReservationProvider: SanuIncAccommodationReservationProviderMapper;
  SaunaAccommodationFacility: SaunaAccommodationFacility;
  SaunaEquipmentAttribute: SaunaEquipmentAttributeMapper;
  SaveStayReviewV2DraftPayload: ResolversUnionTypes<ResolversParentTypes>["SaveStayReviewV2DraftPayload"];
  ScheduleStandardSubscriptionPauseError: ScheduleStandardSubscriptionPauseError;
  ScheduleStandardSubscriptionPausePayload: ResolversUnionTypes<ResolversParentTypes>["ScheduleStandardSubscriptionPausePayload"];
  ScheduleStandardSubscriptionTerminationError: ScheduleStandardSubscriptionTerminationError;
  ScheduleStandardSubscriptionTerminationPayload: ResolversUnionTypes<ResolversParentTypes>["ScheduleStandardSubscriptionTerminationPayload"];
  SeasonalFeeSetting: SeasonalFeeSettingMapper;
  SelectWebinarScheduleError: SelectWebinarScheduleError;
  SelectWebinarSchedulePayload: ResolversUnionTypes<ResolversParentTypes>["SelectWebinarSchedulePayload"];
  SendEmailToVerifyEmailInput: SendEmailToVerifyEmailInput;
  SendEmailToVerifyNewEmailError: SendEmailToVerifyNewEmailError;
  SendEmailToVerifyNewEmailInput: SendEmailToVerifyNewEmailInput;
  SendEmailToVerifyNewEmailPayload: ResolversUnionTypes<ResolversParentTypes>["SendEmailToVerifyNewEmailPayload"];
  SendEmailToVerifyNewEmailSuccess: SendEmailToVerifyNewEmailSuccess;
  SendPasswordResetEmailError: SendPasswordResetEmailError;
  SendPasswordResetEmailPayload: ResolversUnionTypes<ResolversParentTypes>["SendPasswordResetEmailPayload"];
  SendPasswordResetEmailSuccess: SendPasswordResetEmailSuccess;
  ServiceUpdate: ServiceUpdate;
  Site: SiteMapper;
  SiteAccessRouteGroup: SiteAccessRouteGroupMapper;
  SiteAccessRoutePoint: SiteAccessRoutePointMapper;
  SiteActivityProgram: SiteActivityProgramMapper;
  SiteAvailabilityNight: SiteAvailabilityNightMapper;
  SiteContent: SiteContentMapper;
  SiteFaq: SiteFaq;
  SiteHighSeasonPeriod: SiteHighSeasonPeriod;
  StaffContract: StaffContractMapper;
  StaffGroup: StaffGroupMapper;
  StaffPlanAccommodationReservationProvider: StaffPlanAccommodationReservationProvider;
  StaffSemesterCredit: StaffSemesterCredit;
  StandardPlanAccommodationReservationProvider: StandardPlanAccommodationReservationProvider;
  StayCreditBreakdownItem: StayCreditBreakdownItem;
  StayCreditEstimate: StayCreditEstimate;
  StayDirectAccommodationReservationProvider: StayDirectAccommodationReservationProvider;
  StayGiftExportItem: StayGiftExportItem;
  StayReview: StayReviewMapper;
  StayReviewAxisDefinition: Omit<StayReviewAxisDefinition, "concernKinds"> & {
    concernKinds: Array<
      ResolversParentTypes["StayReviewConcernKindDefinition"]
    >;
  };
  StayReviewConcernDetailOption: StayReviewConcernDetailOption;
  StayReviewConcernKindDefinition: Omit<
    StayReviewConcernKindDefinition,
    "details"
  > & { details: Array<ResolversParentTypes["StayReviewConcernDetailOption"]> };
  StayReviewFreeTextQuestion: StayReviewFreeTextQuestion;
  StayReviewMemorableExperienceOption: StayReviewMemorableExperienceOption;
  StayReviewQuestionnaire: StayReviewQuestionnaireMapper;
  StayReviewResponse: StayReviewResponseMapper;
  StayReviewResponseWithReservation: StayReviewResponseWithReservationMapper;
  StayReviewSelectionOption: StayReviewSelectionOption;
  StayReviewSelectionQuestion: StayReviewSelectionQuestion;
  StayReviewV2: StayReviewV2Mapper;
  StayReviewV2Concern: StayReviewV2ConcernMapper;
  StayReviewV2ConcernInput: StayReviewV2ConcernInput;
  StayReviewV2Error: StayReviewV2Error;
  StayReviewV2Form: Omit<StayReviewV2Form, "axes" | "memorableExperiences"> & {
    axes: Array<ResolversParentTypes["StayReviewAxisDefinition"]>;
    memorableExperiences: Array<
      ResolversParentTypes["StayReviewMemorableExperienceOption"]
    >;
  };
  StayReviewV2Input: StayReviewV2Input;
  StayTicket: StayTicketMapper;
  StayTicketAccommodationReservationProvider: StayTicketAccommodationReservationProvider;
  StayTicketAcquisitionItem: StayTicketAcquisitionItem;
  StayTicketMaster: StayTicketMasterMapper;
  StayTicketMasterReferenceInput: StayTicketMasterReferenceInput;
  StayTicketMasterTemplate: StayTicketMasterTemplateMapper;
  StayTicketReservationInfo: StayTicketReservationInfoMapper;
  StayTicketTemplate: StayTicketTemplateMapper;
  StayTicketUnit: StayTicketUnitMapper;
  StayTicketValidationResult: StayTicketValidationResult;
  StripeCard: StripeCard;
  StripeCustomer: StripeCustomerMapper;
  StripeInvoice: StripeInvoice;
  StripeInvoiceStatusTransitions: StripeInvoiceStatusTransitions;
  StripeInvoiceSubscription: StripeInvoiceSubscription;
  StripeMetadataItem: StripeMetadataItem;
  StripeRequireNextAction: StripeRequireNextAction;
  SubmitAdHocQuestionnaireResponseError: SubmitAdHocQuestionnaireResponseError;
  SubmitAdHocQuestionnaireResponseInput: SubmitAdHocQuestionnaireResponseInput;
  SubmitAdHocQuestionnaireResponsePayload: ResolversUnionTypes<ResolversParentTypes>["SubmitAdHocQuestionnaireResponsePayload"];
  SubmitCoOwnersApplicationError: SubmitCoOwnersApplicationError;
  SubmitCoOwnersApplicationPayload: ResolversUnionTypes<ResolversParentTypes>["SubmitCoOwnersApplicationPayload"];
  SubmitStayReviewV2Payload: ResolversUnionTypes<ResolversParentTypes>["SubmitStayReviewV2Payload"];
  Success: Success;
  SupplyItem: SupplyItemMapper;
  SupplyItemInstallation: SupplyItemInstallationMapper;
  SupplyItemMaster: SupplyItemMasterMapper;
  TentativeAccommodationReservationError: TentativeAccommodationReservationError;
  TentativeAccommodationReservationPayload: ResolversUnionTypes<ResolversParentTypes>["TentativeAccommodationReservationPayload"];
  Terms: TermsMapper;
  TermsRevision: TermsRevisionMapper;
  TopPage: Omit<TopPage, "news"> & {
    news?: Maybe<ResolversParentTypes["News"]>;
  };
  TopPageBannerContent: TopPageBannerContent;
  TrialContract: TrialContractMapper;
  TrialPlanAccommodationReservationProvider: TrialPlanAccommodationReservationProvider;
  UpdateAccommodationReservationInput: UpdateAccommodationReservationInput;
  UpdateAccommodationReservationOptionsError: UpdateAccommodationReservationOptionsError;
  UpdateAccommodationReservationOptionsInput: UpdateAccommodationReservationOptionsInput;
  UpdateAccommodationReservationOptionsPayload: ResolversUnionTypes<ResolversParentTypes>["UpdateAccommodationReservationOptionsPayload"];
  UpdateCoOwnersApplicationOwnerInfoError: UpdateCoOwnersApplicationOwnerInfoError;
  UpdateCoOwnersApplicationOwnerInfoPayload: ResolversUnionTypes<ResolversParentTypes>["UpdateCoOwnersApplicationOwnerInfoPayload"];
  UpdateFacilityReservationError: UpdateFacilityReservationError;
  UpdateFacilityReservationInput: UpdateFacilityReservationInput;
  UpdateFacilityReservationPayload: ResolversUnionTypes<ResolversParentTypes>["UpdateFacilityReservationPayload"];
  UpdateFacilityReservationSuccess: Omit<
    UpdateFacilityReservationSuccess,
    "reservation"
  > & { reservation: ResolversParentTypes["FacilityReservation"] };
  UpdateViewerInput: UpdateViewerInput;
  UploadedFile: UploadedFileMapper;
  UploadedFileInput: UploadedFileInput;
  User: UserMapper;
  UserAppInstallation: UserAppInstallationMapper;
  UserCompanion: Omit<UserCompanion, "address" | "passportPhoto"> & {
    address: ResolversParentTypes["Address"];
    passportPhoto?: Maybe<ResolversParentTypes["UploadedFile"]>;
  };
  UserCompanionInput: UserCompanionInput;
  UserIdentity: UserIdentityMapper;
  UserMonthlyStatement: UserMonthlyStatementMapper;
  UserOwnership: UserOwnershipMapper;
  UserOwnershipProgramYearStatus: UserOwnershipProgramYearStatus;
  UserPersonaMetrics: UserPersonaMetrics;
  UserProfile: Omit<
    UserProfile,
    "address" | "facePhoto" | "passportPhoto" | "user"
  > & {
    address?: Maybe<ResolversParentTypes["Address"]>;
    facePhoto?: Maybe<ResolversParentTypes["UploadedFile"]>;
    passportPhoto?: Maybe<ResolversParentTypes["UploadedFile"]>;
    user: ResolversParentTypes["User"];
  };
  UserSubscription: UserSubscriptionMapper;
  UserSubscriptionNext7DaysReservationPeriod: UserSubscriptionNext7DaysReservationPeriod;
  UserSubscriptionReservationCycle: UserSubscriptionReservationCycle;
  UserSubscriptionReservationCyclePeriod: UserSubscriptionReservationCyclePeriod;
  UserSubscriptionTerminationQuestionnaireInput: UserSubscriptionTerminationQuestionnaireInput;
  UserSystemSettings: UserSystemSettings;
  UserSystemSettingsInput: UserSystemSettingsInput;
  VerifyAccountLinkSessionError: VerifyAccountLinkSessionError;
  VerifyAccountLinkSessionInput: VerifyAccountLinkSessionInput;
  VerifyAccountLinkSessionPayload: ResolversUnionTypes<ResolversParentTypes>["VerifyAccountLinkSessionPayload"];
  VerifyAccountLinkSessionSuccess: VerifyAccountLinkSessionSuccess;
  VerifyAddIdentityReauthError: VerifyAddIdentityReauthError;
  VerifyAddIdentityReauthInput: VerifyAddIdentityReauthInput;
  VerifyAddIdentityReauthPayload: ResolversUnionTypes<ResolversParentTypes>["VerifyAddIdentityReauthPayload"];
  VerifyAddIdentityReauthRedirect: VerifyAddIdentityReauthRedirect;
  VerifyCheckInQrCodeError: VerifyCheckInQrCodeError;
  VerifyCheckInQrCodeInput: VerifyCheckInQrCodeInput;
  VerifyCheckInQrCodePayload: ResolversUnionTypes<ResolversParentTypes>["VerifyCheckInQrCodePayload"];
  VerifyCheckInQrCodeSuccess: VerifyCheckInQrCodeSuccess;
  VerifyNewEmailError: VerifyNewEmailError;
  VerifyNewEmailInput: VerifyNewEmailInput;
  VerifyNewEmailPayload: ResolversUnionTypes<ResolversParentTypes>["VerifyNewEmailPayload"];
  VerifyNewEmailSuccess: VerifyNewEmailSuccess;
  WashingMachineTracker: WashingMachineTracker;
  WifiConnection: WifiConnectionMapper;
  WifiEquipmentAttribute: WifiEquipmentAttributeMapper;
  WorkationAccommodationFacility: WorkationAccommodationFacility;
  ZendeskSyncUserError: ZendeskSyncUserError;
  ZendeskSyncUserResult: ResolversUnionTypes<ResolversParentTypes>["ZendeskSyncUserResult"];
  ZonedDateTime: Scalars["ZonedDateTime"]["output"];
  leaveOrganizationPayload: ResolversUnionTypes<ResolversParentTypes>["leaveOrganizationPayload"];
  Boolean: Scalars["Boolean"]["output"];
  Int: Scalars["Int"]["output"];
  String: Scalars["String"]["output"];
};

export type accessDirectiveArgs = {
  permission: ResourcePermission;
};

export type accessDirectiveResolver<
  Result,
  Parent,
  ContextType = Context,
  Args = accessDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type fieldMetaDirectiveArgs = {
  requiresPurpose?: Scalars["Boolean"]["input"];
  tier: Scalars["Int"]["input"];
};

export type fieldMetaDirectiveResolver<
  Result,
  Parent,
  ContextType = Context,
  Args = fieldMetaDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type isContentDirectiveArgs = {};

export type isContentDirectiveResolver<
  Result,
  Parent,
  ContextType = Context,
  Args = isContentDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type maskedDirectiveArgs = {
  permission: FieldTierPermission;
};

export type maskedDirectiveResolver<
  Result,
  Parent,
  ContextType = Context,
  Args = maskedDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type resourceMetaDirectiveArgs = {
  audited?: Scalars["Boolean"]["input"];
  machineOnly?: Scalars["Boolean"]["input"];
};

export type resourceMetaDirectiveResolver<
  Result,
  Parent,
  ContextType = Context,
  Args = resourceMetaDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type roleDirectiveArgs = {
  assignableRoles?: Maybe<Array<AdminRole>>;
  fieldGrants?: Maybe<Array<FieldTierPermission>>;
  grants?: Maybe<Array<ResourcePermission>>;
  scope?: Maybe<ScopeDimension>;
  unrestricted?: Scalars["Boolean"]["input"];
};

export type roleDirectiveResolver<
  Result,
  Parent,
  ContextType = Context,
  Args = roleDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type scopedDirectiveArgs = {
  arg?: Maybe<Scalars["String"]["input"]>;
  dimension: ScopeDimension;
  of?: Maybe<Scalars["String"]["input"]>;
};

export type scopedDirectiveResolver<
  Result,
  Parent,
  ContextType = Context,
  Args = scopedDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AcceptAccommodationReservationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["AcceptAccommodationReservationError"] =
    ResolversParentTypes["AcceptAccommodationReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["AcceptAccommodationReservationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcceptAccommodationReservationErrorCaseResolvers =
  EnumResolverSignature<
    {
      NotAuthorized?: any;
      OwnerOfStayGiftFromOwnersError?: any;
      UserAcceptCodeNotFound?: any;
    },
    ResolversTypes["AcceptAccommodationReservationErrorCase"]
  >;

export type AcceptAccommodationReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["AcceptAccommodationReservationPayload"] =
    ResolversParentTypes["AcceptAccommodationReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AcceptAccommodationReservationError" | "AccommodationReservation",
    ParentType,
    ContextType
  >;
};

export type AccessKeyTypeResolvers = EnumResolverSignature<
  { SiteCleaningStaff?: any; SiteManager?: any },
  ResolversTypes["AccessKeyType"]
>;

export type AccessRouteTransportIconResolvers = EnumResolverSignature<
  {
    Bicycle?: any;
    Bus?: any;
    Car?: any;
    Ferry?: any;
    Other?: any;
    Plane?: any;
    Train?: any;
    Walk?: any;
  },
  ResolversTypes["AccessRouteTransportIcon"]
>;

export type AccessibleReservationCalendarTypeResolvers = EnumResolverSignature<
  {
    BusinessPlan?: any;
    CoOwnersPlan?: any;
    FullOwnerPlan?: any;
    StaffPlan?: any;
    StandardPlan?: any;
    TrialPlan?: any;
  },
  ResolversTypes["AccessibleReservationCalendarType"]
>;

export type AccommodationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Accommodation"] =
    ResolversParentTypes["Accommodation"],
> = {
  accessKey?: Resolver<
    Maybe<ResolversTypes["AccommodationAccessKey"]>,
    ParentType,
    ContextType,
    RequireFields<AccommodationaccessKeyArgs, "keyType">
  >;
  accommodationClass?: Resolver<
    Maybe<ResolversTypes["AccommodationClass"]>,
    ParentType,
    ContextType,
    RequireFields<AccommodationaccommodationClassArgs, "night" | "provider">
  >;
  architectureType?: Resolver<
    ResolversTypes["ArchitectureType"],
    ParentType,
    ContextType
  >;
  availabilities?: Resolver<
    Array<ResolversTypes["AccommodationAvailability"]>,
    ParentType,
    ContextType,
    RequireFields<AccommodationavailabilitiesArgs, "internal">
  >;
  classRelation?: Resolver<
    Maybe<ResolversTypes["AccommodationClassRelation"]>,
    ParentType,
    ContextType,
    RequireFields<AccommodationclassRelationArgs, "night" | "provider">
  >;
  code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  content?: Resolver<
    ResolversTypes["AccommodationContent"],
    ParentType,
    ContextType
  >;
  equipments?: Resolver<
    Array<ResolversTypes["AccommodationEquipment"]>,
    ParentType,
    ContextType
  >;
  facilities?: Resolver<
    Array<ResolversTypes["AccommodationFacility"]>,
    ParentType,
    ContextType
  >;
  facilityTypes?: Resolver<
    Array<ResolversTypes["AccommodationFacilityType"]>,
    ParentType,
    ContextType,
    RequireFields<AccommodationfacilityTypesArgs, "date">
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  isOwned?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    Partial<AccommodationisOwnedArgs>
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  notices?: Resolver<
    Array<ResolversTypes["AccommodationNotice"]>,
    ParentType,
    ContextType
  >;
  operationType?: Resolver<
    Maybe<ResolversTypes["AccommodationOperationType"]>,
    ParentType,
    ContextType
  >;
  remoteLockDeviceId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  roomType?: Resolver<
    Maybe<ResolversTypes["RoomType"]>,
    ParentType,
    ContextType
  >;
  sanuEdgeDevices?: Resolver<
    Array<ResolversTypes["SanuEdgeDevice"]>,
    ParentType,
    ContextType
  >;
  site?: Resolver<ResolversTypes["Site"], ParentType, ContextType>;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccommodationAccessKeyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationAccessKey"] =
    ResolversParentTypes["AccommodationAccessKey"],
> = {
  endsAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  isSynced?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  pin?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  startsAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
};

export type AccommodationAvailabilityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationAvailability"] =
    ResolversParentTypes["AccommodationAvailability"],
> = {
  block?: Resolver<
    Maybe<ResolversTypes["AccommodationAvailabilityBlock"]>,
    ParentType,
    ContextType
  >;
  date?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  guaranteedPrice?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  isAvailable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
};

export type AccommodationAvailabilityBlockResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationAvailabilityBlock"] =
    ResolversParentTypes["AccommodationAvailabilityBlock"],
> = {
  accommodation?: Resolver<
    Maybe<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType
  >;
  beginNight?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  bulkCreateId?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  category?: Resolver<
    ResolversTypes["AccommodationAvailabilityBlockCategory"],
    ParentType,
    ContextType
  >;
  categoryInfo?: Resolver<
    ResolversTypes["AccommodationAvailabilityBlockCategoryInfo"],
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  createdByUser?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType
  >;
  endNight?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  isTentative?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  note?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  site?: Resolver<ResolversTypes["Site"], ParentType, ContextType>;
  staffGroup?: Resolver<
    Maybe<ResolversTypes["StaffGroup"]>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  updatedByUser?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType
  >;
};

export type AccommodationAvailabilityBlockCategoryResolvers =
  EnumResolverSignature<
    {
      AccommodationMaintenance?: any;
      AccommodationSpecChange?: any;
      BeforeFirstUse?: any;
      CleaningAdjustment?: any;
      CleaningOther?: any;
      CleaningSpecial?: any;
      CustomerSupport?: any;
      LandscapeMaintenance?: any;
      LastMinuteCancellation?: any;
      MaintenanceConstruction?: any;
      MaintenanceInspection?: any;
      MaintenanceLandscape?: any;
      MaintenanceOther?: any;
      OnlineTravelAgent?: any;
      OpsBeforeOpening?: any;
      OpsLastMinuteCancellation?: any;
      OpsOther?: any;
      OpsTemporaryClose?: any;
      OpsTroubleWaiting?: any;
      OtherShooting?: any;
      PromotionalUse?: any;
      ReservationForBusiness?: any;
      ReservationForEarlyCheckIn?: any;
      ReservationForEvent?: any;
      ReservationForStaff?: any;
      ReservationForStakeholder?: any;
      ReservationOther?: any;
      SpecialCleaning?: any;
      Trouble?: any;
    },
    ResolversTypes["AccommodationAvailabilityBlockCategory"]
  >;

export type AccommodationAvailabilityBlockCategoryInfoResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["AccommodationAvailabilityBlockCategoryInfo"] =
    ResolversParentTypes["AccommodationAvailabilityBlockCategoryInfo"],
> = {
  categoryGroup?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  key?: Resolver<
    ResolversTypes["AccommodationAvailabilityBlockCategory"],
    ParentType,
    ContextType
  >;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  note?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type AccommodationAvailabilityBlockReleaseScheduleResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["AccommodationAvailabilityBlockReleaseSchedule"] =
    ResolversParentTypes["AccommodationAvailabilityBlockReleaseSchedule"],
> = {
  blockRoomCountUpperLimit?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  daysBeforeCheckin?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  siteId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
};

export type AccommodationClassResolvers = EnumResolverSignature<
  { E?: any; F?: any; G?: any },
  ResolversTypes["AccommodationClass"]
>;

export type AccommodationClassRelationResolvers = EnumResolverSignature<
  { Higher?: any; Lower?: any; Same?: any },
  ResolversTypes["AccommodationClassRelation"]
>;

export type AccommodationContentResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationContent"] =
    ResolversParentTypes["AccommodationContent"],
> = {
  manualUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
};

export type AccommodationEquipmentResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationEquipment"] =
    ResolversParentTypes["AccommodationEquipment"],
> = {
  accommodation?: Resolver<
    ResolversTypes["Accommodation"],
    ParentType,
    ContextType
  >;
  attribute?: Resolver<
    Maybe<ResolversTypes["AccommodationEquipmentAttribute"]>,
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes["AccommodationEquipmentStatusType"],
    ParentType,
    ContextType
  >;
  type?: Resolver<
    ResolversTypes["AccommodationEquipmentType"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccommodationEquipmentAttributeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationEquipmentAttribute"] =
    ResolversParentTypes["AccommodationEquipmentAttribute"],
> = {
  __resolveType?: TypeResolveFn<
    | "MusicConnectEquipmentAttribute"
    | "SaunaEquipmentAttribute"
    | "WifiEquipmentAttribute",
    ParentType,
    ContextType
  >;
};

export type AccommodationEquipmentStatusTypeResolvers = EnumResolverSignature<
  { Draft?: any; Preview?: any; Published?: any; PublishedForSanuStaff?: any },
  ResolversTypes["AccommodationEquipmentStatusType"]
>;

export type AccommodationEquipmentTypeResolvers = EnumResolverSignature<
  { MusicConnect?: any; Sauna?: any; Wifi?: any },
  ResolversTypes["AccommodationEquipmentType"]
>;

export type AccommodationFacilityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationFacility"] =
    ResolversParentTypes["AccommodationFacility"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<
    ResolversTypes["AccommodationFacilityType"],
    ParentType,
    ContextType
  >;
};

export type AccommodationFacilityFilterTypeResolvers = EnumResolverSignature<
  { Exclude?: any; Include?: any },
  ResolversTypes["AccommodationFacilityFilterType"]
>;

export type AccommodationFacilityTypeResolvers = EnumResolverSignature<
  {
    DogFriendly?: any;
    DogRun?: any;
    EVCharger?: any;
    Onsen?: any;
    Sauna?: any;
    Workation?: any;
  },
  ResolversTypes["AccommodationFacilityType"]
>;

export type AccommodationFeeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationFee"] =
    ResolversParentTypes["AccommodationFee"],
> = {
  billingMethod?: Resolver<
    ResolversTypes["BillingMethod"],
    ParentType,
    ContextType
  >;
  billingMethodManualDetail?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  consumedSupplyFeeItemWaivers?: Resolver<
    Array<ResolversTypes["ConsumedSupplyFeeItemWaiver"]>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Array<ResolversTypes["AccommodationFeeItem"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<
    Maybe<ResolversTypes["AccommodationFeeStatus"]>,
    ParentType,
    ContextType
  >;
  stripeInvoiceId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  totalAmount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type AccommodationFeeApplicabilityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationFeeApplicability"] =
    ResolversParentTypes["AccommodationFeeApplicability"],
> = {
  waiveArchitectureTypeAdditionalFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveDogFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waiveDogRunFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waiveEvChargerFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveOnsenFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waiveSaunaFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
};

export type AccommodationFeeDiscountResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationFeeDiscount"] =
    ResolversParentTypes["AccommodationFeeDiscount"],
> = {
  feeModifier?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  feeModifierType?: Resolver<
    ResolversTypes["FeeModifierType"],
    ParentType,
    ContextType
  >;
  night?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  ruleType?: Resolver<
    ResolversTypes["AccommodationFeeRuleType"],
    ParentType,
    ContextType
  >;
};

export type AccommodationFeeItemResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationFeeItem"] =
    ResolversParentTypes["AccommodationFeeItem"],
> = {
  amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  key?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  night?: Resolver<Maybe<ResolversTypes["PlainDate"]>, ParentType, ContextType>;
  stayTicket?: Resolver<
    Maybe<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType
  >;
  taxRate?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  type?: Resolver<
    ResolversTypes["AccommodationFeeItemPerType"],
    ParentType,
    ContextType
  >;
};

export type AccommodationFeeItemPerTypeResolvers = EnumResolverSignature<
  { PerNight?: any; PerStay?: any },
  ResolversTypes["AccommodationFeeItemPerType"]
>;

export type AccommodationFeeRuleResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationFeeRule"] =
    ResolversParentTypes["AccommodationFeeRule"],
> = {
  feeModifier?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  feeModifierType?: Resolver<
    ResolversTypes["FeeModifierType"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  night?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  ruleType?: Resolver<
    ResolversTypes["AccommodationFeeRuleType"],
    ParentType,
    ContextType
  >;
};

export type AccommodationFeeRuleTypeResolvers = EnumResolverSignature<
  { ConsecutiveNightDiscount?: any; FreeNight?: any; NightFeeModifier?: any },
  ResolversTypes["AccommodationFeeRuleType"]
>;

export type AccommodationFeeStatusResolvers = EnumResolverSignature<
  {
    Draft?: any;
    InvoiceOpen?: any;
    InvoicePaid?: any;
    InvoicePaymentFailed?: any;
    InvoiceRequiresAction?: any;
    Open?: any;
    Unknown?: any;
  },
  ResolversTypes["AccommodationFeeStatus"]
>;

export type AccommodationNoticeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationNotice"] =
    ResolversParentTypes["AccommodationNotice"],
> = {
  accommodations?: Resolver<
    Array<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType
  >;
  brief?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  createdUser?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  externalUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  lastUpdatedUser?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  sendEmailToExpectedUsers?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  startDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes["AccommodationNoticeStatus"],
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccommodationNoticeStatusResolvers = EnumResolverSignature<
  { Active?: any; Draft?: any; Unpublished?: any },
  ResolversTypes["AccommodationNoticeStatus"]
>;

export type AccommodationOperationGroupResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationOperationGroup"] =
    ResolversParentTypes["AccommodationOperationGroup"],
> = {
  architectureType?: Resolver<
    ResolversTypes["ArchitectureType"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  settings?: Resolver<
    Array<ResolversTypes["AccommodationOperationGroupSetting"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccommodationOperationGroupSettingResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["AccommodationOperationGroupSetting"] =
    ResolversParentTypes["AccommodationOperationGroupSetting"],
> = {
  additionalFeeForBusinessPlan?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  additionalFeeForClassEOwner?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  additionalFeeForClassFOwner?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  class?: Resolver<
    ResolversTypes["AccommodationClass"],
    ParentType,
    ContextType
  >;
  effectiveFrom?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  operationType?: Resolver<
    ResolversTypes["AccommodationOperationType"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccommodationOperationTypeResolvers = EnumResolverSignature<
  { CoOwners?: any; FullOwner?: any; Open?: any },
  ResolversTypes["AccommodationOperationType"]
>;

export type AccommodationReservationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationReservation"] =
    ResolversParentTypes["AccommodationReservation"],
> = {
  accessCode?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  accommodation?: Resolver<
    ResolversTypes["Accommodation"],
    ParentType,
    ContextType
  >;
  accommodationNotices?: Resolver<
    Array<ResolversTypes["AccommodationNotice"]>,
    ParentType,
    ContextType
  >;
  additionalKeySet?: Resolver<
    ResolversTypes["AccommodationReservationAdditionalKeySet"],
    ParentType,
    ContextType
  >;
  canCancel?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  canCheckIn?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  canCheckOut?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  canReserveOneMoreCabin?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  canceledAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  cancellationPolicyContent?: Resolver<
    Maybe<ResolversTypes["CancellationPolicyContent"]>,
    ParentType,
    ContextType
  >;
  checkInQrCode?: Resolver<
    Maybe<ResolversTypes["CheckInQrCode"]>,
    ParentType,
    ContextType
  >;
  checkedInAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  checkedInGeoLocation?: Resolver<
    Maybe<ResolversTypes["GeoLocation"]>,
    ParentType,
    ContextType
  >;
  checkedOutAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  consumedSuppliesFee?: Resolver<
    ResolversTypes["ConsumedSuppliesFee"],
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  createdUser?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType
  >;
  currentEarlyCheckInFee?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  detail?: Resolver<
    ResolversTypes["AccommodationReservationDetail"],
    ParentType,
    ContextType
  >;
  earlyCheckInEligible?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  earlyCheckInPriceTable?: Resolver<
    Maybe<Array<ResolversTypes["EarlyCheckInPriceSlot"]>>,
    ParentType,
    ContextType
  >;
  earlyCheckInStatus?: Resolver<
    ResolversTypes["EarlyCheckInStatus"],
    ParentType,
    ContextType
  >;
  facilities?: Resolver<
    Array<ResolversTypes["Facility"]>,
    ParentType,
    ContextType
  >;
  facilityFee?: Resolver<
    ResolversTypes["FacilityFee"],
    ParentType,
    ContextType
  >;
  facilityReservations?: Resolver<
    Array<ResolversTypes["FacilityReservation"]>,
    ParentType,
    ContextType,
    Partial<AccommodationReservationfacilityReservationsArgs>
  >;
  fee?: Resolver<ResolversTypes["AccommodationFee"], ParentType, ContextType>;
  feeApplicability?: Resolver<
    ResolversTypes["AccommodationFeeApplicability"],
    ParentType,
    ContextType
  >;
  firstDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  firstNight?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  guestName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  hasCanceled?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  hasSanuDevices?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  invitationUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  isFacilityReservable?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      AccommodationReservationisFacilityReservableArgs,
      "facilityType"
    >
  >;
  isRoomTypeReservation?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  isSaunaControlAccessible?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  isTentative?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  lastDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  lastNight?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  localTaxPolicies?: Resolver<
    Array<ResolversTypes["LocalTaxPolicy"]>,
    ParentType,
    ContextType
  >;
  mutationScope?: Resolver<
    ResolversTypes["AccommodationReservationMutationScope"],
    ParentType,
    ContextType
  >;
  nights?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  oneMoreCabinAccommodationReservation?: Resolver<
    Maybe<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType
  >;
  otaDetail?: Resolver<
    Maybe<ResolversTypes["AccommodationReservationOtaDetail"]>,
    ParentType,
    ContextType
  >;
  provider?: Resolver<
    ResolversTypes["AccommodationReservationProvider"],
    ParentType,
    ContextType
  >;
  reservedFrom?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  reservedTo?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  review?: Resolver<
    Maybe<ResolversTypes["StayReview"]>,
    ParentType,
    ContextType
  >;
  standardCheckInTime?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  stayReviewResponse?: Resolver<
    Maybe<ResolversTypes["StayReviewResponse"]>,
    ParentType,
    ContextType
  >;
  stayReviewV2?: Resolver<
    Maybe<ResolversTypes["StayReviewV2"]>,
    ParentType,
    ContextType
  >;
  stayStatus?: Resolver<
    ResolversTypes["AccommodationReservationStayStatus"],
    ParentType,
    ContextType
  >;
  stayTicketUnit?: Resolver<
    Maybe<ResolversTypes["StayTicketUnit"]>,
    ParentType,
    ContextType
  >;
  tentativeDeadline?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  user?: Resolver<Maybe<ResolversTypes["User"]>, ParentType, ContextType>;
  userAcceptCode?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  userCompanions?: Resolver<
    Array<ResolversTypes["UserCompanion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccommodationReservationAdditionalKeySetResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["AccommodationReservationAdditionalKeySet"] =
    ResolversParentTypes["AccommodationReservationAdditionalKeySet"],
> = {
  coWorkingSpaceKey?: Resolver<
    Maybe<ResolversTypes["CoWorkingSpaceKey"]>,
    ParentType,
    ContextType
  >;
};

export type AccommodationReservationChangeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationReservationChange"] =
    ResolversParentTypes["AccommodationReservationChange"],
> = {
  from?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  to?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type AccommodationReservationCheckOutAvailabilitiesPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["AccommodationReservationCheckOutAvailabilitiesPayload"] =
    ResolversParentTypes["AccommodationReservationCheckOutAvailabilitiesPayload"],
> = {
  items?: Resolver<
    Array<ResolversTypes["AccommodationReservationCheckOutItem"]>,
    ParentType,
    ContextType
  >;
};

export type AccommodationReservationCheckOutItemResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["AccommodationReservationCheckOutItem"] =
    ResolversParentTypes["AccommodationReservationCheckOutItem"],
> = {
  additionalNightsFee?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  available?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  block?: Resolver<
    Maybe<ResolversTypes["AccommodationAvailabilityBlock"]>,
    ParentType,
    ContextType
  >;
  date?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  discounts?: Resolver<
    Array<ResolversTypes["AccommodationFeeDiscount"]>,
    ParentType,
    ContextType
  >;
};

export type AccommodationReservationDetailResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationReservationDetail"] =
    ResolversParentTypes["AccommodationReservationDetail"],
> = {
  allowRoomChange?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  bringDog?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  earlyCheckInFee?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  earlyCheckInSlot?: Resolver<
    Maybe<ResolversTypes["EarlyCheckInPriceSlot"]>,
    ParentType,
    ContextType
  >;
  internalStamp?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  nextLocation?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  numberOfAdults?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  numberOfDogs?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  numberOfInfants?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  numberOfKids?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  numberOfTotalChildren?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  previousLocation?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  useEvCharger?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
};

export type AccommodationReservationMutationScopeResolvers =
  EnumResolverSignature<
    { Freezed?: any; NoLimit?: any; OnlyExit?: any },
    ResolversTypes["AccommodationReservationMutationScope"]
  >;

export type AccommodationReservationOptionsResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationReservationOptions"] =
    ResolversParentTypes["AccommodationReservationOptions"],
> = {
  bringDog?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  numberOfDogs?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  useEvCharger?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
};

export type AccommodationReservationOtaDetailResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationReservationOtaDetail"] =
    ResolversParentTypes["AccommodationReservationOtaDetail"],
> = {
  address?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  apiMessage?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  apiReference?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  apiSource?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  arrivalTime?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  bookingTime?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  cancelTime?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  channel?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  commission?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  countryCode?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deposit?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  firstName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  languageCode?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  lastName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  modifiedTime?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  notes?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  pricePerRoom?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  rateDescription?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  reference?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  referer?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
};

export type AccommodationReservationProviderResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccommodationReservationProvider"] =
    ResolversParentTypes["AccommodationReservationProvider"],
> = {
  __resolveType?: TypeResolveFn<
    | "BusinessPlanAccommodationReservationProvider"
    | "CoOwnersPlanAccommodationReservationProvider"
    | "FullOwnerPlanAccommodationReservationProvider"
    | "OneMoreCabinAccommodationReservationProvider"
    | "OnlineTravelAgentAccommodationReservationProvider"
    | "SanuIncAccommodationReservationProvider"
    | "StaffPlanAccommodationReservationProvider"
    | "StandardPlanAccommodationReservationProvider"
    | "StayDirectAccommodationReservationProvider"
    | "StayTicketAccommodationReservationProvider"
    | "TrialPlanAccommodationReservationProvider",
    ParentType,
    ContextType
  >;
};

export type AccommodationReservationProviderSanuIncUsageResolvers =
  EnumResolverSignature<
    {
      BeforeOpeningStay?: any;
      BusinessStay?: any;
      CleaningBlock?: any;
      CleaningInternalUse?: any;
      EmployeeOperationalStay?: any;
      InvoicePaymentStay?: any;
      OneMoreCabinManual?: any;
      OnlineTravelAgent?: any;
      OtherStay?: any;
      PromotionStay?: any;
      PromotionalStay?: any;
      RetreatPlan?: any;
      SanuStay?: any;
      StakeholderStay?: any;
      TroubleCoverStay?: any;
      TroubleStay?: any;
    },
    ResolversTypes["AccommodationReservationProviderSanuIncUsage"]
  >;

export type AccommodationReservationProviderTypeResolvers =
  EnumResolverSignature<
    {
      BusinessPlan?: any;
      CoOwnersPlan?: any;
      FullOwnerPlan?: any;
      OneMoreCabin?: any;
      OnlineTravelAgent?: any;
      SanuInc?: any;
      StaffPlan?: any;
      StandardPlan?: any;
      StayDirect?: any;
      StayTicket?: any;
      TrialPlan?: any;
    },
    ResolversTypes["AccommodationReservationProviderType"]
  >;

export type AccommodationReservationStayStatusResolvers = EnumResolverSignature<
  {
    NoStay?: any;
    StayCanceled?: any;
    Stayed?: any;
    Staying?: any;
    Tentative?: any;
    WillStay?: any;
  },
  ResolversTypes["AccommodationReservationStayStatus"]
>;

export type AccountLinkIdentityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AccountLinkIdentity"] =
    ResolversParentTypes["AccountLinkIdentity"],
> = {
  connection?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  provider?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type AccountLinkPlatformResolvers = EnumResolverSignature<
  { Native?: any; Web?: any },
  ResolversTypes["AccountLinkPlatform"]
>;

export type AcquireStayTicketsErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AcquireStayTicketsError"] =
    ResolversParentTypes["AcquireStayTicketsError"],
> = {
  case?: Resolver<
    ResolversTypes["AcquireStayTicketsErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcquireStayTicketsErrorCaseResolvers = EnumResolverSignature<
  { InvalidRequest?: any; NotAuthorized?: any; PaymentFailed?: any },
  ResolversTypes["AcquireStayTicketsErrorCase"]
>;

export type AcquireStayTicketsPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AcquireStayTicketsPayload"] =
    ResolversParentTypes["AcquireStayTicketsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AcquireStayTicketsError" | "AcquireStayTicketsResult",
    ParentType,
    ContextType
  >;
};

export type AcquireStayTicketsResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AcquireStayTicketsResult"] =
    ResolversParentTypes["AcquireStayTicketsResult"],
> = {
  tickets?: Resolver<
    Array<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivateMemberPerksDrinkTicketErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ActivateMemberPerksDrinkTicketError"] =
    ResolversParentTypes["ActivateMemberPerksDrinkTicketError"],
> = {
  case?: Resolver<
    ResolversTypes["ActivateMemberPerksDrinkTicketErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivateMemberPerksDrinkTicketErrorCaseResolvers =
  EnumResolverSignature<
    { HasAlreadyActivated?: any; IsNotEligible?: any },
    ResolversTypes["ActivateMemberPerksDrinkTicketErrorCase"]
  >;

export type ActivateMemberPerksDrinkTicketPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ActivateMemberPerksDrinkTicketPayload"] =
    ResolversParentTypes["ActivateMemberPerksDrinkTicketPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "ActivateMemberPerksDrinkTicketError" | "Success",
    ParentType,
    ContextType
  >;
};

export type AdHocQuestionnaireResponseResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AdHocQuestionnaireResponse"] =
    ResolversParentTypes["AdHocQuestionnaireResponse"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  questionnaireTemplateId?: Resolver<
    ResolversTypes["ID"],
    ParentType,
    ContextType
  >;
};

export type AdditionalGuestFeePolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AdditionalGuestFeePolicy"] =
    ResolversParentTypes["AdditionalGuestFeePolicy"],
> = {
  adultPrices?: Resolver<Array<ResolversTypes["Int"]>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  internalName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  kidsPrices?: Resolver<Array<ResolversTypes["Int"]>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdditionalNoticeTypeResolvers = EnumResolverSignature<
  { Refund?: any; Transfer?: any },
  ResolversTypes["AdditionalNoticeType"]
>;

export type AddressResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Address"] =
    ResolversParentTypes["Address"],
> = {
  __resolveType?: TypeResolveFn<
    "AddressInJapan" | "AddressInternational",
    ParentType,
    ContextType
  >;
};

export type AddressInJapanResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AddressInJapan"] =
    ResolversParentTypes["AddressInJapan"],
> = {
  line1?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  line2?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressInternationalResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AddressInternational"] =
    ResolversParentTypes["AddressInternational"],
> = {
  city?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  country?: Resolver<ResolversTypes["CountryEnum"], ParentType, ContextType>;
  line1?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  line2?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  stateProvince?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRoleResolvers = EnumResolverSignature<
  {
    Admin?: any;
    OpsSupport?: any;
    PartnerSiteManager?: any;
    PartnerSiteOperator?: any;
    PartnerSiteStaff?: any;
    RoleAdmin?: any;
    SuperAdmin?: any;
  },
  ResolversTypes["AdminRole"]
>;

export type AdminRoleAssignmentResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AdminRoleAssignment"] =
    ResolversParentTypes["AdminRoleAssignment"],
> = {
  assignee?: Resolver<
    ResolversTypes["InternalAdminRoleAssignee"],
    ParentType,
    ContextType
  >;
  expiresAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  grantedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  grantedByUser?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  revokedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  revokedByUser?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType
  >;
  role?: Resolver<ResolversTypes["AdminRole"], ParentType, ContextType>;
  site?: Resolver<Maybe<ResolversTypes["Site"]>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreeToTermsErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AgreeToTermsError"] =
    ResolversParentTypes["AgreeToTermsError"],
> = {
  case?: Resolver<
    ResolversTypes["AgreeToTermsErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreeToTermsErrorCaseResolvers = EnumResolverSignature<
  { NotFound?: any },
  ResolversTypes["AgreeToTermsErrorCase"]
>;

export type AgreeToTermsPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AgreeToTermsPayload"] =
    ResolversParentTypes["AgreeToTermsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AgreeToTermsError" | "Success",
    ParentType,
    ContextType
  >;
};

export type AgreeToWeekdayTermsErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AgreeToWeekdayTermsError"] =
    ResolversParentTypes["AgreeToWeekdayTermsError"],
> = {
  case?: Resolver<
    ResolversTypes["AgreeToWeekdayTermsErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreeToWeekdayTermsErrorCaseResolvers = EnumResolverSignature<
  { AlreadyAgreed?: any; NotSubscribed?: any },
  ResolversTypes["AgreeToWeekdayTermsErrorCase"]
>;

export type AgreeToWeekdayTermsPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AgreeToWeekdayTermsPayload"] =
    ResolversParentTypes["AgreeToWeekdayTermsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AgreeToWeekdayTermsError" | "Success",
    ParentType,
    ContextType
  >;
};

export type ApplyToTrialSubscriptionErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ApplyToTrialSubscriptionError"] =
    ResolversParentTypes["ApplyToTrialSubscriptionError"],
> = {
  case?: Resolver<
    ResolversTypes["ApplyToTrialSubscriptionErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplyToTrialSubscriptionErrorCaseResolvers = EnumResolverSignature<
  {
    DuplicationError?: any;
    InvalidEnrollmentMonth?: any;
    InvalidOperation?: any;
    PaymentError?: any;
  },
  ResolversTypes["ApplyToTrialSubscriptionErrorCase"]
>;

export type ApplyToTrialSubscriptionPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ApplyToTrialSubscriptionPayload"] =
    ResolversParentTypes["ApplyToTrialSubscriptionPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "ApplyToTrialSubscriptionError" | "StripeRequireNextAction" | "Success",
    ParentType,
    ContextType
  >;
};

export type ApplyToWeekdaySubscriptionErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ApplyToWeekdaySubscriptionError"] =
    ResolversParentTypes["ApplyToWeekdaySubscriptionError"],
> = {
  case?: Resolver<
    ResolversTypes["ApplyToWeekdaySubscriptionErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplyToWeekdaySubscriptionErrorCaseResolvers =
  EnumResolverSignature<
    {
      DuplicationError?: any;
      InvalidOperation?: any;
      InvalidPromotionCode?: any;
      InvalidStartDate?: any;
      PaymentError?: any;
    },
    ResolversTypes["ApplyToWeekdaySubscriptionErrorCase"]
  >;

export type ApplyToWeekdaySubscriptionPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ApplyToWeekdaySubscriptionPayload"] =
    ResolversParentTypes["ApplyToWeekdaySubscriptionPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "ApplyToWeekdaySubscriptionError" | "StripeRequireNextAction" | "Success",
    ParentType,
    ContextType
  >;
};

export type ArchitectureTypeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ArchitectureType"] =
    ResolversParentTypes["ArchitectureType"],
> = {
  accommodations?: Resolver<
    Array<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType
  >;
  accommodationsCount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  additionalFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  capacity?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  content?: Resolver<
    ResolversTypes["ContentArchitectureType"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  internalContent?: Resolver<
    Maybe<ResolversTypes["ContentArchitectureType"]>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  published?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  series?: Resolver<
    ResolversTypes["ArchitectureTypeSeries"],
    ParentType,
    ContextType
  >;
  seriesName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  seriesShortName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  size?: Resolver<
    Maybe<ResolversTypes["ArchitectureTypeSize"]>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type ArchitectureTypeSeriesResolvers = EnumResolverSignature<
  { Original?: any; Selection?: any },
  ResolversTypes["ArchitectureTypeSeries"]
>;

export type ArchitectureTypeSizeResolvers = EnumResolverSignature<
  { Large?: any; Medium?: any; Small?: any },
  ResolversTypes["ArchitectureTypeSize"]
>;

export type ArchiveArticleResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ArchiveArticle"] =
    ResolversParentTypes["ArchiveArticle"],
> = {
  isNew?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  publishedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  url?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type AreaResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Area"] =
    ResolversParentTypes["Area"],
> = {
  content?: Resolver<ResolversTypes["AreaContent"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sites?: Resolver<Array<ResolversTypes["Site"]>, ParentType, ContextType>;
  sitesForReservation?: Resolver<
    Array<ResolversTypes["Site"]>,
    ParentType,
    ContextType,
    Partial<AreasitesForReservationArgs>
  >;
  slug?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type AreaContentResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AreaContent"] =
    ResolversParentTypes["AreaContent"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  accessFromTokyoDescription?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  allCapsName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  catchCopy?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  guideArticles?: Resolver<
    Array<ResolversTypes["AreaGuideArticle"]>,
    ParentType,
    ContextType
  >;
  guideSpotMapListUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  guideSpotTips?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  guideSpotTipsTitle?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  guideSpots?: Resolver<
    Array<ResolversTypes["AreaGuideSpot"]>,
    ParentType,
    ContextType
  >;
  heroImages?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  reservationFormCoverImageUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  roadConditionLiveCameraUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  shortAddress?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
};

export type AreaGuideArticleResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AreaGuideArticle"] =
    ResolversParentTypes["AreaGuideArticle"],
> = {
  areas?: Resolver<
    Array<ResolversTypes["InternalArea"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  publishedDate?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  thumbnail?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  url?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type AreaGuideSpotResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["AreaGuideSpot"] =
    ResolversParentTypes["AreaGuideSpot"],
> = {
  businessHours?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  categories?: Resolver<
    Array<ResolversTypes["AreaGuideSpotCategory"]>,
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  images?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  mapUrl?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  publishEndDate?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  publishStartDate?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  publishedNow?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes["String"]>, ParentType, ContextType>;
  websiteUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
};

export type AreaGuideSpotCategoryResolvers = EnumResolverSignature<
  {
    CafeRestaurant?: any;
    Events?: any;
    FoodStore?: any;
    NatureSpot?: any;
    Others?: any;
    Shop?: any;
  },
  ResolversTypes["AreaGuideSpotCategory"]
>;

export type Auth0UserResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Auth0User"] =
    ResolversParentTypes["Auth0User"],
> = {
  id?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  linkedIdentities?: Resolver<
    Array<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
};

export type BaseAccommodationFeeModeResolvers = EnumResolverSignature<
  { Daily?: any; Policy?: any },
  ResolversTypes["BaseAccommodationFeeMode"]
>;

export type BaseAccommodationFeePolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["BaseAccommodationFeePolicy"] =
    ResolversParentTypes["BaseAccommodationFeePolicy"],
> = {
  dailyFeePolicy?: Resolver<
    Maybe<Array<ResolversTypes["Int"]>>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  internalName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type Beds24BookingDetailResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Beds24BookingDetail"] =
    ResolversParentTypes["Beds24BookingDetail"],
> = {
  fee?: Resolver<ResolversTypes["Beds24BookingFee"], ParentType, ContextType>;
  isGroupBooking?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  masterBookingId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
};

export type Beds24BookingFeeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Beds24BookingFee"] =
    ResolversParentTypes["Beds24BookingFee"],
> = {
  perRoomAmount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  totalAmount?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  totalUnpaidAmount?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
};

export type Beds24BookingMessageErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Beds24BookingMessageError"] =
    ResolversParentTypes["Beds24BookingMessageError"],
> = {
  case?: Resolver<
    ResolversTypes["Beds24BookingMessageErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Beds24BookingMessageErrorCaseResolvers = EnumResolverSignature<
  { GeneralError?: any; InvalidEmail?: any },
  ResolversTypes["Beds24BookingMessageErrorCase"]
>;

export type Beds24BookingMessageKindResolvers = EnumResolverSignature<
  {
    ReservationReminderBefore2Day?: any;
    ReservationReminderToday?: any;
    TentativeReservationCreated?: any;
  },
  ResolversTypes["Beds24BookingMessageKind"]
>;

export type Beds24BookingMessageResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Beds24BookingMessageResult"] =
    ResolversParentTypes["Beds24BookingMessageResult"],
> = {
  __resolveType?: TypeResolveFn<
    "Beds24BookingMessageError" | "Success",
    ParentType,
    ContextType
  >;
};

export type Beds24BookingMessageResultPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Beds24BookingMessageResultPayload"] =
    ResolversParentTypes["Beds24BookingMessageResultPayload"],
> = {
  result?: Resolver<
    ResolversTypes["Beds24BookingMessageResult"],
    ParentType,
    ContextType
  >;
};

export type Beds24SyncFollowingReservationsResultPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["Beds24SyncFollowingReservationsResultPayload"] =
    ResolversParentTypes["Beds24SyncFollowingReservationsResultPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "CancelAccommodationReservationError"
    | "ChangeAccommodationReservationError",
    ParentType,
    ContextType
  >;
};

export type Beds24WebhookErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Beds24WebhookError"] =
    ResolversParentTypes["Beds24WebhookError"],
> = {
  case?: Resolver<
    ResolversTypes["Beds24WebhookErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Beds24WebhookErrorCaseResolvers = EnumResolverSignature<
  {
    BookingStatusNotSupported?: any;
    GeneralError?: any;
    ReservationNotFound?: any;
    UnsupportedProvider?: any;
  },
  ResolversTypes["Beds24WebhookErrorCase"]
>;

export type Beds24WebhookResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Beds24WebhookResult"] =
    ResolversParentTypes["Beds24WebhookResult"],
> = {
  __resolveType?: TypeResolveFn<
    "Beds24WebhookError" | "Beds24WebhookSuccess",
    ParentType,
    ContextType
  >;
};

export type Beds24WebhookResultPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Beds24WebhookResultPayload"] =
    ResolversParentTypes["Beds24WebhookResultPayload"],
> = {
  bookingDetail?: Resolver<
    Maybe<ResolversTypes["Beds24BookingDetail"]>,
    ParentType,
    ContextType
  >;
  changes?: Resolver<
    Maybe<Array<ResolversTypes["AccommodationReservationChange"]>>,
    ParentType,
    ContextType
  >;
  message?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  reservation?: Resolver<
    Maybe<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType
  >;
  result?: Resolver<
    ResolversTypes["Beds24WebhookResult"],
    ParentType,
    ContextType
  >;
};

export type Beds24WebhookSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Beds24WebhookSuccess"] =
    ResolversParentTypes["Beds24WebhookSuccess"],
> = {
  case?: Resolver<
    ResolversTypes["Beds24WebhookSuccessCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Beds24WebhookSuccessCaseResolvers = EnumResolverSignature<
  {
    BookingNotAssigned?: any;
    ProcessingSkipped?: any;
    ReservationCanceled?: any;
    ReservationChanged?: any;
    ReservationCreated?: any;
    ReservationDetailUpdated?: any;
  },
  ResolversTypes["Beds24WebhookSuccessCase"]
>;

export type BillingMethodResolvers = EnumResolverSignature<
  { AutoCharge?: any; Manual?: any },
  ResolversTypes["BillingMethod"]
>;

export type BundleStayTicketsPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["BundleStayTicketsPayload"] =
    ResolversParentTypes["BundleStayTicketsPayload"],
> = {
  stayTicketUnit?: Resolver<
    Maybe<ResolversTypes["StayTicketUnit"]>,
    ParentType,
    ContextType
  >;
  stayTicketsValidationResult?: Resolver<
    Array<ResolversTypes["StayTicketValidationResult"]>,
    ParentType,
    ContextType
  >;
};

export type BusinessPlanResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["BusinessPlan"] =
    ResolversParentTypes["BusinessPlan"],
> = {
  feePerNights?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  feePerNum?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  isPeakDayFeeFree?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessPlanAccommodationReservationProviderResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["BusinessPlanAccommodationReservationProvider"] =
    ResolversParentTypes["BusinessPlanAccommodationReservationProvider"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelAccommodationReservationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CancelAccommodationReservationError"] =
    ResolversParentTypes["CancelAccommodationReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["CancelAccommodationReservationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelAccommodationReservationErrorCaseResolvers =
  EnumResolverSignature<
    {
      CancelPaymentFailed?: any;
      CancelRuleError?: any;
      CancelTemporarilyUnavailable?: any;
      HasActiveFacilityReservation?: any;
      NotAuthorized?: any;
    },
    ResolversTypes["CancelAccommodationReservationErrorCase"]
  >;

export type CancelAccommodationReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CancelAccommodationReservationPayload"] =
    ResolversParentTypes["CancelAccommodationReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AccommodationReservation" | "CancelAccommodationReservationError",
    ParentType,
    ContextType
  >;
};

export type CancelCoOwnersApplicationErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancelCoOwnersApplicationError"] =
    ResolversParentTypes["CancelCoOwnersApplicationError"],
> = {
  case?: Resolver<
    ResolversTypes["CancelCoOwnersApplicationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelCoOwnersApplicationErrorCaseResolvers = EnumResolverSignature<
  {
    AlreadyCancelled?: any;
    CannotCancelAfterHandover?: any;
    NotFound?: any;
    PermissionDenied?: any;
    StripeRefundError?: any;
  },
  ResolversTypes["CancelCoOwnersApplicationErrorCase"]
>;

export type CancelCoOwnersApplicationPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancelCoOwnersApplicationPayload"] =
    ResolversParentTypes["CancelCoOwnersApplicationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CancelCoOwnersApplicationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type CancelFacilityReservationErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancelFacilityReservationError"] =
    ResolversParentTypes["CancelFacilityReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["CancelFacilityReservationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelFacilityReservationErrorCaseResolvers = EnumResolverSignature<
  {
    AlreadyCanceled?: any;
    NotAuthorized?: any;
    NotCancelable?: any;
    PastReserveDeadline?: any;
    ReservationNotFound?: any;
  },
  ResolversTypes["CancelFacilityReservationErrorCase"]
>;

export type CancelFacilityReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancelFacilityReservationPayload"] =
    ResolversParentTypes["CancelFacilityReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CancelFacilityReservationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type CancelFeeFixedPolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancelFeeFixedPolicy"] =
    ResolversParentTypes["CancelFeeFixedPolicy"],
> = {
  before1DaysFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  before3DaysFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  before7DaysFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  immediate?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelFeePolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancelFeePolicy"] =
    ResolversParentTypes["CancelFeePolicy"],
> = {
  __resolveType?: TypeResolveFn<
    "CancelFeeFixedPolicy" | "CancelFeeRatePolicy",
    ParentType,
    ContextType
  >;
};

export type CancelFeeRatePolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancelFeeRatePolicy"] =
    ResolversParentTypes["CancelFeeRatePolicy"],
> = {
  before1DaysRate?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  before3DaysRate?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  before7DaysRate?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  immediate?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelStandardSubscriptionApplicationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CancelStandardSubscriptionApplicationError"] =
    ResolversParentTypes["CancelStandardSubscriptionApplicationError"],
> = {
  case?: Resolver<
    ResolversTypes["CancelStandardSubscriptionApplicationErrorCase"],
    ParentType,
    ContextType
  >;
  stripeRequestId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelStandardSubscriptionApplicationErrorCaseResolvers =
  EnumResolverSignature<
    {
      InvalidOperation?: any;
      NoSubscriptionScheduleError?: any;
      ReservationExists?: any;
      StripeError?: any;
      UnknownError?: any;
    },
    ResolversTypes["CancelStandardSubscriptionApplicationErrorCase"]
  >;

export type CancelStandardSubscriptionApplicationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CancelStandardSubscriptionApplicationPayload"] =
    ResolversParentTypes["CancelStandardSubscriptionApplicationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CancelStandardSubscriptionApplicationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type CancelStandardSubscriptionPauseErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CancelStandardSubscriptionPauseError"] =
    ResolversParentTypes["CancelStandardSubscriptionPauseError"],
> = {
  case?: Resolver<
    ResolversTypes["CancelStandardSubscriptionPauseErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelStandardSubscriptionPauseErrorCaseResolvers =
  EnumResolverSignature<
    {
      InvalidOperation?: any;
      NoSubscriptionError?: any;
      NoSubscriptionScheduleError?: any;
      StripeError?: any;
      SubscriptionScheduleInvalidTrigger?: any;
    },
    ResolversTypes["CancelStandardSubscriptionPauseErrorCase"]
  >;

export type CancelStandardSubscriptionPausePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CancelStandardSubscriptionPausePayload"] =
    ResolversParentTypes["CancelStandardSubscriptionPausePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CancelStandardSubscriptionPauseError" | "Success",
    ParentType,
    ContextType
  >;
};

export type CancelStandardSubscriptionResumeErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CancelStandardSubscriptionResumeError"] =
    ResolversParentTypes["CancelStandardSubscriptionResumeError"],
> = {
  case?: Resolver<
    ResolversTypes["CancelStandardSubscriptionResumeErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelStandardSubscriptionResumeErrorCaseResolvers =
  EnumResolverSignature<
    { GeneralError?: any; InvalidOperation?: any },
    ResolversTypes["CancelStandardSubscriptionResumeErrorCase"]
  >;

export type CancelStandardSubscriptionResumePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CancelStandardSubscriptionResumePayload"] =
    ResolversParentTypes["CancelStandardSubscriptionResumePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CancelStandardSubscriptionResumeError" | "Success",
    ParentType,
    ContextType
  >;
};

export type CancelStandardSubscriptionTerminationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CancelStandardSubscriptionTerminationError"] =
    ResolversParentTypes["CancelStandardSubscriptionTerminationError"],
> = {
  case?: Resolver<
    ResolversTypes["CancelStandardSubscriptionTerminationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelStandardSubscriptionTerminationErrorCaseResolvers =
  EnumResolverSignature<
    {
      InvalidOperation?: any;
      NoSubscriptionError?: any;
      NotTerminating?: any;
      StripeError?: any;
    },
    ResolversTypes["CancelStandardSubscriptionTerminationErrorCase"]
  >;

export type CancelStandardSubscriptionTerminationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CancelStandardSubscriptionTerminationPayload"] =
    ResolversParentTypes["CancelStandardSubscriptionTerminationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CancelStandardSubscriptionTerminationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type CancelStayGiftsErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancelStayGiftsError"] =
    ResolversParentTypes["CancelStayGiftsError"],
> = {
  case?: Resolver<
    ResolversTypes["CancelStayGiftsErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelStayGiftsErrorCaseResolvers = EnumResolverSignature<
  { InvalidState?: any; NotAuthorized?: any; NotFound?: any },
  ResolversTypes["CancelStayGiftsErrorCase"]
>;

export type CancelStayGiftsPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancelStayGiftsPayload"] =
    ResolversParentTypes["CancelStayGiftsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CancelStayGiftsError" | "CancelStayGiftsResult",
    ParentType,
    ContextType
  >;
};

export type CancelStayGiftsResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancelStayGiftsResult"] =
    ResolversParentTypes["CancelStayGiftsResult"],
> = {
  cancelledTickets?: Resolver<
    Array<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelTrialSubscriptionErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancelTrialSubscriptionError"] =
    ResolversParentTypes["CancelTrialSubscriptionError"],
> = {
  case?: Resolver<
    ResolversTypes["CancelTrialSubscriptionErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelTrialSubscriptionErrorCaseResolvers = EnumResolverSignature<
  {
    ContractNotFound?: any;
    InvalidOperation?: any;
    ReservationExists?: any;
    StripeError?: any;
  },
  ResolversTypes["CancelTrialSubscriptionErrorCase"]
>;

export type CancelTrialSubscriptionPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancelTrialSubscriptionPayload"] =
    ResolversParentTypes["CancelTrialSubscriptionPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CancelTrialSubscriptionError" | "Success",
    ParentType,
    ContextType
  >;
};

export type CancellationFeeTierResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancellationFeeTier"] =
    ResolversParentTypes["CancellationFeeTier"],
> = {
  feeDescription?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type CancellationPolicyContentResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancellationPolicyContent"] =
    ResolversParentTypes["CancellationPolicyContent"],
> = {
  sections?: Resolver<
    Array<ResolversTypes["CancellationPolicySection"]>,
    ParentType,
    ContextType
  >;
};

export type CancellationPolicySectionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CancellationPolicySection"] =
    ResolversParentTypes["CancellationPolicySection"],
> = {
  changeDeadlineDescription?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  conditionLabel?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  noShowDescription?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  tiers?: Resolver<
    Array<ResolversTypes["CancellationFeeTier"]>,
    ParentType,
    ContextType
  >;
};

export type ChangeAccommodationReservationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ChangeAccommodationReservationError"] =
    ResolversParentTypes["ChangeAccommodationReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["ChangeAccommodationReservationErrorCase"],
    ParentType,
    ContextType
  >;
  internalCode?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChangeAccommodationReservationErrorCaseResolvers =
  EnumResolverSignature<
    {
      ChangePaymentFailed?: any;
      CycleDuplicationError?: any;
      HasConflictingFacilityReservation?: any;
      InvalidReservationPeriodError?: any;
      MaxNightsPerMonthExceededError?: any;
      MaxNightsPerYearExceededError?: any;
      MaxReservationsExceededError?: any;
      MonthlyReservationLimitExceededError?: any;
      MutationScopeError?: any;
      Next7DaysDuplicationError?: any;
      OwnerStayCreditInsufficientError?: any;
      PeakDayOwnerOnlyError?: any;
      PeakDaysLimitExceededError?: any;
      ReservationOverlapError?: any;
      ResourceUnavailable?: any;
      SiteHighSeasonLimitExceededError?: any;
      StayTicketError?: any;
      SubscriptionSuspended?: any;
      TermsNotAgreedError?: any;
      TrialContractSuspended?: any;
      TrialStayCreditInsufficientError?: any;
      UnexpectedError?: any;
      UnpaidAccommodationFeeError?: any;
    },
    ResolversTypes["ChangeAccommodationReservationErrorCase"]
  >;

export type ChangeAccommodationReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ChangeAccommodationReservationPayload"] =
    ResolversParentTypes["ChangeAccommodationReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AccommodationReservation" | "ChangeAccommodationReservationError",
    ParentType,
    ContextType
  >;
};

export type CheckInAccommodationReservationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CheckInAccommodationReservationError"] =
    ResolversParentTypes["CheckInAccommodationReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["CheckInAccommodationReservationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckInAccommodationReservationErrorCaseResolvers =
  EnumResolverSignature<
    {
      AlreadyCheckedIn?: any;
      AuthenticationRequired?: any;
      CheckInRuleError?: any;
      NoAccessCode?: any;
    },
    ResolversTypes["CheckInAccommodationReservationErrorCase"]
  >;

export type CheckInAccommodationReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CheckInAccommodationReservationPayload"] =
    ResolversParentTypes["CheckInAccommodationReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AccommodationReservation" | "CheckInAccommodationReservationError",
    ParentType,
    ContextType
  >;
};

export type CheckInAuthenticationTypeResolvers = EnumResolverSignature<
  { NotRequired?: any; QrCode?: any },
  ResolversTypes["CheckInAuthenticationType"]
>;

export type CheckInQrCodeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CheckInQrCode"] =
    ResolversParentTypes["CheckInQrCode"],
> = {
  code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  expiresAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes["CheckInQrCodeStatus"],
    ParentType,
    ContextType
  >;
  verifiedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
};

export type CheckInQrCodeStatusResolvers = EnumResolverSignature<
  { Failed?: any; Pending?: any; Verified?: any },
  ResolversTypes["CheckInQrCodeStatus"]
>;

export type CheckOutAccommodationReservationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CheckOutAccommodationReservationError"] =
    ResolversParentTypes["CheckOutAccommodationReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["CheckOutAccommodationReservationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckOutAccommodationReservationErrorCaseResolvers =
  EnumResolverSignature<
    {
      AlreadyCheckedOut?: any;
      CheckOutRuleError?: any;
      NotAuthorized?: any;
      QuestionnaireNotFound?: any;
      ValidationError?: any;
    },
    ResolversTypes["CheckOutAccommodationReservationErrorCase"]
  >;

export type CheckOutAccommodationReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CheckOutAccommodationReservationPayload"] =
    ResolversParentTypes["CheckOutAccommodationReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AccommodationReservation" | "CheckOutAccommodationReservationError",
    ParentType,
    ContextType
  >;
};

export type CoOwnerPeakDaysRatioResolvers = EnumResolverSignature<
  { OneHalf?: any; TwoThirds?: any },
  ResolversTypes["CoOwnerPeakDaysRatio"]
>;

export type CoOwnersApplicantInfoResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CoOwnersApplicantInfo"] =
    ResolversParentTypes["CoOwnersApplicantInfo"],
> = {
  detail?: Resolver<
    ResolversTypes["CoOwnersApplicantInfoDetail"],
    ParentType,
    ContextType
  >;
  identificationDocument1?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  identificationDocument2?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  identificationDocumentType?: Resolver<
    ResolversTypes["IdentificationDocumentType"],
    ParentType,
    ContextType
  >;
  isPep?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  purchasePurpose?: Resolver<
    Maybe<ResolversTypes["OwnerPurchasePurposeType"]>,
    ParentType,
    ContextType
  >;
  purchasePurposeFree?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
};

export type CoOwnersApplicantInfoDetailResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CoOwnersApplicantInfoDetail"] =
    ResolversParentTypes["CoOwnersApplicantInfoDetail"],
> = {
  __resolveType?: TypeResolveFn<
    | "CoOwnersApplicantInfoDetailIndividual"
    | "CoOwnersApplicantInfoDetailOrganization",
    ParentType,
    ContextType
  >;
};

export type CoOwnersApplicantInfoDetailIndividualResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CoOwnersApplicantInfoDetailIndividual"] =
    ResolversParentTypes["CoOwnersApplicantInfoDetailIndividual"],
> = {
  employerName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  householdIncome?: Resolver<
    Maybe<ResolversTypes["IncomeBracketType"]>,
    ParentType,
    ContextType
  >;
  intendedUsage?: Resolver<
    Maybe<ResolversTypes["OwnerIntendedUsageType"]>,
    ParentType,
    ContextType
  >;
  personalFinancialAssets?: Resolver<
    Maybe<ResolversTypes["FinancialAssetsBracketType"]>,
    ParentType,
    ContextType
  >;
  useLoan?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoOwnersApplicantInfoDetailOrganizationResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CoOwnersApplicantInfoDetailOrganization"] =
    ResolversParentTypes["CoOwnersApplicantInfoDetailOrganization"],
> = {
  beneficialOwnerAddress?: Resolver<
    Maybe<ResolversTypes["AddressInJapan"]>,
    ParentType,
    ContextType
  >;
  beneficialOwnerBirthDate?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  beneficialOwnerName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  beneficialOwnerOthers?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  beneficialOwnerRelationship?: Resolver<
    Maybe<ResolversTypes["OwnerOrganizationBeneficialOwnerRelationshipType"]>,
    ParentType,
    ContextType
  >;
  beneficialOwnerRelationshipFree?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  businessActivity?: Resolver<
    Maybe<ResolversTypes["OwnerOrganizationBusinessActivityType"]>,
    ParentType,
    ContextType
  >;
  businessActivityFree?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  organizationAddress?: Resolver<
    Maybe<ResolversTypes["AddressInJapan"]>,
    ParentType,
    ContextType
  >;
  organizationName?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  organizationRelationship?: Resolver<
    Maybe<ResolversTypes["OwnerOrganizationRelationshipType"]>,
    ParentType,
    ContextType
  >;
  registryCertificateDocuments?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  representativeName?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoOwnersApplicationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CoOwnersApplication"] =
    ResolversParentTypes["CoOwnersApplication"],
> = {
  additionalPurchaseDiscountAmount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  additionalPurchaseDiscountNote?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  advancePaymentRequired?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  allFiles?: Resolver<
    Array<ResolversTypes["CoOwnersApplicationFile"]>,
    ParentType,
    ContextType,
    RequireFields<CoOwnersApplicationallFilesArgs, "includeDeleted">
  >;
  applicant?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  applicantInfo?: Resolver<
    ResolversTypes["CoOwnersApplicantInfo"],
    ParentType,
    ContextType
  >;
  applicationFeePaymentMethod?: Resolver<
    Maybe<ResolversTypes["PaymentMethodType"]>,
    ParentType,
    ContextType
  >;
  comment?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  desiredHandoverDate?: Resolver<
    Maybe<ResolversTypes["PlainYearMonth"]>,
    ParentType,
    ContextType
  >;
  disclosureAssitant?: Resolver<
    Maybe<ResolversTypes["DisclosureAssistantType"]>,
    ParentType,
    ContextType
  >;
  employeeReferralDiscountAmount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  events?: Resolver<
    ResolversTypes["CoOwnersApplicationEvents"],
    ParentType,
    ContextType
  >;
  files?: Resolver<
    Array<ResolversTypes["CoOwnersApplicationFile"]>,
    ParentType,
    ContextType
  >;
  friendReferralDiscountAmount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  hasCoOwnersApplicationRequiredFieldsFilled?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  identityVerifications?: Resolver<
    Array<ResolversTypes["IdentityVerification"]>,
    ParentType,
    ContextType
  >;
  invitationCode?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  otherDiscountAmount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  otherDiscountNote?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  otherFiles?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  ownerPlan?: Resolver<ResolversTypes["OwnerPlan"], ParentType, ContextType>;
  registrationFeePaymentMethod?: Resolver<
    Maybe<ResolversTypes["PaymentMethodType"]>,
    ParentType,
    ContextType
  >;
  remainingAmountPaymentMethod?: Resolver<
    Maybe<ResolversTypes["PaymentMethodType"]>,
    ParentType,
    ContextType
  >;
  requestedOtherWebinarSchedule?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  s2oPoint?: Resolver<
    Maybe<ResolversTypes["S2oPoint"]>,
    ParentType,
    ContextType
  >;
  selectedWebinarSchedule?: Resolver<
    Maybe<ResolversTypes["CoOwnersWebinarSchedule"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes["CoOwnersApplicationStatus"],
    ParentType,
    ContextType
  >;
  unitSales?: Resolver<
    Array<ResolversTypes["CoOwnersUnitSale"]>,
    ParentType,
    ContextType
  >;
  units?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  webinarSchedules?: Resolver<
    Array<ResolversTypes["CoOwnersWebinarSchedule"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoOwnersApplicationEventsResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CoOwnersApplicationEvents"] =
    ResolversParentTypes["CoOwnersApplicationEvents"],
> = {
  advancePaymentReceivedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  cancelledAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  completedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  contractSignedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  handoverCompletedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  invitedToDisclosureAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  participatedInDisclosureAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  paymentReceivedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  reviewedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  submittedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
};

export type CoOwnersApplicationFileResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CoOwnersApplicationFile"] =
    ResolversParentTypes["CoOwnersApplicationFile"],
> = {
  contentType?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  deletedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  deletedBy?: Resolver<Maybe<ResolversTypes["User"]>, ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  size?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  uploadedBy?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  visibleToApplicant?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoOwnersApplicationStatusResolvers = EnumResolverSignature<
  {
    AdvancePaymentReceived?: any;
    Approved?: any;
    AwaitingApplicationPayment?: any;
    Cancelled?: any;
    Completed?: any;
    ContractSigned?: any;
    HandoverCompleted?: any;
    InReview?: any;
    InvitedToDisclosure?: any;
    ParticipatedInDisclosure?: any;
    PaymentReceived?: any;
    PlannedForSale?: any;
    Rejected?: any;
    Sold?: any;
    Void?: any;
  },
  ResolversTypes["CoOwnersApplicationStatus"]
>;

export type CoOwnersBakurakuInvoiceAnnualPaymentItemResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CoOwnersBakurakuInvoiceAnnualPaymentItem"] =
    ResolversParentTypes["CoOwnersBakurakuInvoiceAnnualPaymentItem"],
> = {
  amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  applicant?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  date?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  documentNumber?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  note?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  paymentDueDate?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  recipientCode?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  taxRate?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  unit?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type CoOwnersBakurakuInvoiceRecipientResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CoOwnersBakurakuInvoiceRecipient"] =
    ResolversParentTypes["CoOwnersBakurakuInvoiceRecipient"],
> = {
  code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  departmentName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  email?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  emailDelivery?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  recipientName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type CoOwnersBakurakuInvoiceRegistrationFeeItemResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CoOwnersBakurakuInvoiceRegistrationFeeItem"] =
    ResolversParentTypes["CoOwnersBakurakuInvoiceRegistrationFeeItem"],
> = {
  amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  applicant?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  date?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  documentNumber?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  note?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  paymentDueDate?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  recipientCode?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  taxRate?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  unit?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type CoOwnersBakurakuInvoiceRemainingPaymentItemResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CoOwnersBakurakuInvoiceRemainingPaymentItem"] =
    ResolversParentTypes["CoOwnersBakurakuInvoiceRemainingPaymentItem"],
> = {
  amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  applicant?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  date?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  documentNumber?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  note?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  paymentDueDate?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  recipientCode?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  taxRate?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  unit?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type CoOwnersPlanAccommodationReservationProviderResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CoOwnersPlanAccommodationReservationProvider"] =
    ResolversParentTypes["CoOwnersPlanAccommodationReservationProvider"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  userOwnershipId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoOwnersPlanOfferingResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CoOwnersPlanOffering"] =
    ResolversParentTypes["CoOwnersPlanOffering"],
> = {
  earlyAccessCode?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  estimate?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  isHidden?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isSoldOut?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  units?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoOwnersUnitSaleResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CoOwnersUnitSale"] =
    ResolversParentTypes["CoOwnersUnitSale"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  saleYearMonth?: Resolver<
    ResolversTypes["PlainYearMonth"],
    ParentType,
    ContextType
  >;
  soldAt?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
  units?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type CoOwnersWebinarScheduleResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CoOwnersWebinarSchedule"] =
    ResolversParentTypes["CoOwnersWebinarSchedule"],
> = {
  coOwnersApplications?: Resolver<
    Maybe<Array<ResolversTypes["CoOwnersApplication"]>>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  site?: Resolver<ResolversTypes["Site"], ParentType, ContextType>;
  startsAt?: Resolver<ResolversTypes["ZonedDateTime"], ParentType, ContextType>;
  url?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoWorkingSpaceDoorLockResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CoWorkingSpaceDoorLock"] =
    ResolversParentTypes["CoWorkingSpaceDoorLock"],
> = {
  keyUrl?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoWorkingSpaceKeyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CoWorkingSpaceKey"] =
    ResolversParentTypes["CoWorkingSpaceKey"],
> = {
  availableFrom?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  availableTo?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  instructionUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  keyUrl?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type CompleteAddIdentityErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CompleteAddIdentityError"] =
    ResolversParentTypes["CompleteAddIdentityError"],
> = {
  case?: Resolver<
    ResolversTypes["CompleteAddIdentityErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompleteAddIdentityErrorCaseResolvers = EnumResolverSignature<
  {
    AlreadyLinkedToAnotherAccount?: any;
    InvalidIntentToken?: any;
    TokenExchangeFailed?: any;
  },
  ResolversTypes["CompleteAddIdentityErrorCase"]
>;

export type CompleteAddIdentityPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CompleteAddIdentityPayload"] =
    ResolversParentTypes["CompleteAddIdentityPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CompleteAddIdentityError" | "CompleteAddIdentitySuccess",
    ParentType,
    ContextType
  >;
};

export type CompleteAddIdentitySuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CompleteAddIdentitySuccess"] =
    ResolversParentTypes["CompleteAddIdentitySuccess"],
> = {
  redirectUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfirmTentativeAccommodationReservationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ConfirmTentativeAccommodationReservationError"] =
    ResolversParentTypes["ConfirmTentativeAccommodationReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["ConfirmTentativeAccommodationReservationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfirmTentativeAccommodationReservationErrorCaseResolvers =
  EnumResolverSignature<
    {
      GeneralError?: any;
      InvalidStatus?: any;
      NotAuthorized?: any;
      TentativeDeadlineExceeded?: any;
    },
    ResolversTypes["ConfirmTentativeAccommodationReservationErrorCase"]
  >;

export type ConfirmTentativeAccommodationReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ConfirmTentativeAccommodationReservationPayload"] =
    ResolversParentTypes["ConfirmTentativeAccommodationReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "AccommodationReservation"
    | "ConfirmTentativeAccommodationReservationError",
    ParentType,
    ContextType
  >;
};

export type ConsumedSuppliesFeeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ConsumedSuppliesFee"] =
    ResolversParentTypes["ConsumedSuppliesFee"],
> = {
  items?: Resolver<
    Array<ResolversTypes["ConsumedSuppliesFeeItem"]>,
    ParentType,
    ContextType
  >;
  totalAmount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type ConsumedSuppliesFeeItemResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ConsumedSuppliesFeeItem"] =
    ResolversParentTypes["ConsumedSuppliesFeeItem"],
> = {
  amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  reportedQuantity?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  taxRate?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  unitAmount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type ConsumedSupplyFeeItemWaiverResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ConsumedSupplyFeeItemWaiver"] =
    ResolversParentTypes["ConsumedSupplyFeeItemWaiver"],
> = {
  createdAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  supplyItemMasterCategory?: Resolver<
    Maybe<ResolversTypes["SupplyItemMasterCategory"]>,
    ParentType,
    ContextType
  >;
  type?: Resolver<
    ResolversTypes["ConsumedSupplyFeeItemWaiverType"],
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
};

export type ConsumedSupplyFeeItemWaiverTypeResolvers = EnumResolverSignature<
  { BySupplyItemMasterCategory?: any; HighestUnitPrice?: any },
  ResolversTypes["ConsumedSupplyFeeItemWaiverType"]
>;

export type ConsumptionTaxRateTypeResolvers = EnumResolverSignature<
  { Reduced?: any; Standard?: any },
  ResolversTypes["ConsumptionTaxRateType"]
>;

export type ContentArchitectResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ContentArchitect"] =
    ResolversParentTypes["ContentArchitect"],
> = {
  architectureTypes?: Resolver<
    Array<ResolversTypes["ArchitectureType"]>,
    ParentType,
    ContextType
  >;
  bio?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  company?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes["UploadedFile"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  nameEn?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentArchitecturalFeatureResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ContentArchitecturalFeature"] =
    ResolversParentTypes["ContentArchitecturalFeature"],
> = {
  accommodationFacilities?: Resolver<
    Array<ResolversTypes["AccommodationFacility"]>,
    ParentType,
    ContextType
  >;
  availabilityNote?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  description?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  facilityAmenities?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeVariantFacilityAmenity"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  imageUrls?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  ruleNoteMarkup?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  ruleTitle?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  rules?: Resolver<
    Array<ResolversTypes["ContentArchitecturalFeatureUsageRule"]>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  thumbnailImageUrl?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  usageConditionsDescription?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  usageFeesDescriptionMarkup?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentArchitecturalFeatureUsageRuleResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ContentArchitecturalFeatureUsageRule"] =
    ResolversParentTypes["ContentArchitecturalFeatureUsageRule"],
> = {
  bodyMarkup?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  imageUrl?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentArchitecturePageNavigationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ContentArchitecturePageNavigation"] =
    ResolversParentTypes["ContentArchitecturePageNavigation"],
> = {
  feature?: Resolver<
    Array<ResolversTypes["ContentArchitecturePageNavigationItem"]>,
    ParentType,
    ContextType
  >;
  originalSeries?: Resolver<
    Array<ResolversTypes["ContentArchitecturePageNavigationItem"]>,
    ParentType,
    ContextType
  >;
  selectionSeries?: Resolver<
    Array<ResolversTypes["ContentArchitecturePageNavigationItem"]>,
    ParentType,
    ContextType
  >;
};

export type ContentArchitecturePageNavigationItemResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ContentArchitecturePageNavigationItem"] =
    ResolversParentTypes["ContentArchitecturePageNavigationItem"],
> = {
  area?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  path?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  subItems?: Resolver<
    Maybe<Array<ResolversTypes["ContentArchitecturePageNavigationSubItem"]>>,
    ParentType,
    ContextType
  >;
  thumbnail?: Resolver<ResolversTypes["UploadedFile"], ParentType, ContextType>;
};

export type ContentArchitecturePageNavigationSubItemResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ContentArchitecturePageNavigationSubItem"] =
    ResolversParentTypes["ContentArchitecturePageNavigationSubItem"],
> = {
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  path?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type ContentArchitectureTypeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ContentArchitectureType"] =
    ResolversParentTypes["ContentArchitectureType"],
> = {
  amenitiesInstructionsUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  architect?: Resolver<
    ResolversTypes["ContentArchitect"],
    ParentType,
    ContextType
  >;
  architectComment?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  architectureType?: Resolver<
    ResolversTypes["ArchitectureType"],
    ParentType,
    ContextType
  >;
  area?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  basicAmenities?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeBasicAmenity"]>,
    ParentType,
    ContextType
  >;
  capacityDescription?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  customEmailCoverImageUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  description?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  emailCoverImageUrl?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  equipmentsListUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  experiences?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeExperience"]>,
    ParentType,
    ContextType
  >;
  floorPlanImageUrl?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  imageUrls?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  options?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeVariant"]>,
    ParentType,
    ContextType
  >;
  sites?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeSite"]>,
    ParentType,
    ContextType
  >;
  sizeDescription?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sizeSqm?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  thumbnailImageUrl?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  variations?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeVariant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentArchitectureTypeBasicAmenityResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ContentArchitectureTypeBasicAmenity"] =
    ResolversParentTypes["ContentArchitectureTypeBasicAmenity"],
> = {
  architectureTypes?: Resolver<
    Array<ResolversTypes["ArchitectureType"]>,
    ParentType,
    ContextType
  >;
  iconUrl?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentArchitectureTypeExperienceResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ContentArchitectureTypeExperience"] =
    ResolversParentTypes["ContentArchitectureTypeExperience"],
> = {
  descriptionMarkup?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  imageUrl?: Resolver<ResolversTypes["UploadedFile"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type ContentArchitectureTypeFeatureResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ContentArchitectureTypeFeature"] =
    ResolversParentTypes["ContentArchitectureTypeFeature"],
> = {
  availabilityNote?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  description?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  facilityDetails?: Resolver<
    ResolversTypes["ContentFacilityDetails"],
    ParentType,
    ContextType
  >;
  imageUrls?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sitesByArchitectureType?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeFeatureSite"]>,
    ParentType,
    ContextType
  >;
  usageRule?: Resolver<
    Maybe<ResolversTypes["ContentArchitectureTypeFeatureUsageRule"]>,
    ParentType,
    ContextType
  >;
};

export type ContentArchitectureTypeFeatureSiteResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ContentArchitectureTypeFeatureSite"] =
    ResolversParentTypes["ContentArchitectureTypeFeatureSite"],
> = {
  architectureTypeName?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  sites?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeVariantSite"]>,
    ParentType,
    ContextType
  >;
};

export type ContentArchitectureTypeFeatureUsageRuleResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ContentArchitectureTypeFeatureUsageRule"] =
    ResolversParentTypes["ContentArchitectureTypeFeatureUsageRule"],
> = {
  noteMarkup?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  ruleItems?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeFeatureUsageRuleItem"]>,
    ParentType,
    ContextType
  >;
  title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type ContentArchitectureTypeFeatureUsageRuleItemResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ContentArchitectureTypeFeatureUsageRuleItem"] =
    ResolversParentTypes["ContentArchitectureTypeFeatureUsageRuleItem"],
> = {
  bodyMarkup?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  imageUrl?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
};

export type ContentArchitectureTypeSiteResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ContentArchitectureTypeSite"] =
    ResolversParentTypes["ContentArchitectureTypeSite"],
> = {
  isOpeningSoon?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type ContentArchitectureTypeVariantResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ContentArchitectureTypeVariant"] =
    ResolversParentTypes["ContentArchitectureTypeVariant"],
> = {
  accommodationFacilities?: Resolver<
    Array<ResolversTypes["AccommodationFacility"]>,
    ParentType,
    ContextType
  >;
  brief?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  description?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  facilityDetails?: Resolver<
    ResolversTypes["ContentFacilityDetails"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  imageUrls?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  kind?: Resolver<
    ResolversTypes["ContentArchitectureTypeVariantKind"],
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sites?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeVariantSite"]>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentArchitectureTypeVariantFacilityAmenityResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ContentArchitectureTypeVariantFacilityAmenity"] =
    ResolversParentTypes["ContentArchitectureTypeVariantFacilityAmenity"],
> = {
  accommodationFacility?: Resolver<
    ResolversTypes["AccommodationFacility"],
    ParentType,
    ContextType
  >;
  descriptionMarkup?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  referenceCounts?: Resolver<
    ResolversTypes["ContentFacilityAmenityReferenceCounts"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentArchitectureTypeVariantKindResolvers = EnumResolverSignature<
  { Option?: any; Variation?: any },
  ResolversTypes["ContentArchitectureTypeVariantKind"]
>;

export type ContentArchitectureTypeVariantSiteResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ContentArchitectureTypeVariantSite"] =
    ResolversParentTypes["ContentArchitectureTypeVariantSite"],
> = {
  accommodations?: Resolver<
    Array<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type ContentFacilityAmenityReferenceCountsResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ContentFacilityAmenityReferenceCounts"] =
    ResolversParentTypes["ContentFacilityAmenityReferenceCounts"],
> = {
  features?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  options?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  variations?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type ContentFacilityDetailsResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ContentFacilityDetails"] =
    ResolversParentTypes["ContentFacilityDetails"],
> = {
  facilityAmenities?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeVariantFacilityAmenity"]>,
    ParentType,
    ContextType
  >;
  usageConditionsDescription?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  usageFeesDescriptionMarkup?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
};

export type ContentRoomTypeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ContentRoomType"] =
    ResolversParentTypes["ContentRoomType"],
> = {
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  heroImages?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType,
    Partial<ContentRoomTypeheroImagesArgs>
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
};

export type ContractContinuationTypeResolvers = EnumResolverSignature<
  { Cancel?: any; Continue?: any },
  ResolversTypes["ContractContinuationType"]
>;

export type ContractStatusResolvers = EnumResolverSignature<
  { Active?: any; Expired?: any; Invalidated?: any; Scheduled?: any },
  ResolversTypes["ContractStatus"]
>;

export type CountryEnumResolvers = EnumResolverSignature<
  {
    ABW?: any;
    AFG?: any;
    AGO?: any;
    AIA?: any;
    ALB?: any;
    AND?: any;
    ANT?: any;
    ARE?: any;
    ARG?: any;
    ARM?: any;
    ASM?: any;
    ATA?: any;
    ATG?: any;
    AUS?: any;
    AUT?: any;
    AZE?: any;
    BDI?: any;
    BEL?: any;
    BEN?: any;
    BFA?: any;
    BGD?: any;
    BGR?: any;
    BHR?: any;
    BHS?: any;
    BIH?: any;
    BLR?: any;
    BLZ?: any;
    BMU?: any;
    BOL?: any;
    BRA?: any;
    BRB?: any;
    BRN?: any;
    BTN?: any;
    BWA?: any;
    CAF?: any;
    CAN?: any;
    CCK?: any;
    CHE?: any;
    CHI?: any;
    CHL?: any;
    CHN?: any;
    CIV?: any;
    CMR?: any;
    COD?: any;
    COG?: any;
    COK?: any;
    COL?: any;
    COM?: any;
    CPV?: any;
    CRI?: any;
    CUB?: any;
    CXR?: any;
    CYM?: any;
    CYP?: any;
    CZE?: any;
    DEU?: any;
    DJI?: any;
    DMA?: any;
    DNK?: any;
    DOM?: any;
    DZA?: any;
    ECU?: any;
    EGY?: any;
    ERI?: any;
    ESH?: any;
    ESP?: any;
    EST?: any;
    ETH?: any;
    FIN?: any;
    FJI?: any;
    FLK?: any;
    FRA?: any;
    FRO?: any;
    FSM?: any;
    GAB?: any;
    GBR?: any;
    GEO?: any;
    GHA?: any;
    GIB?: any;
    GIN?: any;
    GLP?: any;
    GMB?: any;
    GNB?: any;
    GNQ?: any;
    GRC?: any;
    GRD?: any;
    GRL?: any;
    GTM?: any;
    GUF?: any;
    GUM?: any;
    GUY?: any;
    HKG?: any;
    HND?: any;
    HRV?: any;
    HTI?: any;
    HUN?: any;
    IDN?: any;
    IMN?: any;
    IND?: any;
    IOT?: any;
    IRL?: any;
    IRN?: any;
    IRQ?: any;
    ISL?: any;
    ISR?: any;
    ITA?: any;
    JAM?: any;
    JON?: any;
    JOR?: any;
    JPN?: any;
    KAS?: any;
    KAZ?: any;
    KEN?: any;
    KGZ?: any;
    KHM?: any;
    KIR?: any;
    KNA?: any;
    KOR?: any;
    KSV?: any;
    KWT?: any;
    LAO?: any;
    LBN?: any;
    LBR?: any;
    LBY?: any;
    LCA?: any;
    LIE?: any;
    LKA?: any;
    LSO?: any;
    LTU?: any;
    LUX?: any;
    LVA?: any;
    MAC?: any;
    MAR?: any;
    MCO?: any;
    MDA?: any;
    MDG?: any;
    MDV?: any;
    MEX?: any;
    MHL?: any;
    MID?: any;
    MKD?: any;
    MLI?: any;
    MLT?: any;
    MMR?: any;
    MNE?: any;
    MNG?: any;
    MNP?: any;
    MOZ?: any;
    MRT?: any;
    MSR?: any;
    MTQ?: any;
    MUS?: any;
    MWI?: any;
    MYS?: any;
    MYT?: any;
    NAM?: any;
    NCL?: any;
    NER?: any;
    NFK?: any;
    NGA?: any;
    NIC?: any;
    NIU?: any;
    NLD?: any;
    NOR?: any;
    NPL?: any;
    NRU?: any;
    NZL?: any;
    OMN?: any;
    PAK?: any;
    PAN?: any;
    PCN?: any;
    PER?: any;
    PHL?: any;
    PLW?: any;
    PNG?: any;
    POL?: any;
    PRI?: any;
    PRK?: any;
    PRT?: any;
    PRY?: any;
    PSE?: any;
    PYF?: any;
    QAT?: any;
    REU?: any;
    ROU?: any;
    RUS?: any;
    RWA?: any;
    SAU?: any;
    SDN?: any;
    SEN?: any;
    SGP?: any;
    SHN?: any;
    SJM?: any;
    SLB?: any;
    SLE?: any;
    SLV?: any;
    SMR?: any;
    SOM?: any;
    SPM?: any;
    SRB?: any;
    SSD?: any;
    STP?: any;
    SUR?: any;
    SVK?: any;
    SVN?: any;
    SWE?: any;
    SWZ?: any;
    SYC?: any;
    SYR?: any;
    TCA?: any;
    TCD?: any;
    TGO?: any;
    THA?: any;
    TJK?: any;
    TKL?: any;
    TKM?: any;
    TLS?: any;
    TON?: any;
    TTO?: any;
    TUN?: any;
    TUR?: any;
    TUV?: any;
    TWN?: any;
    TZA?: any;
    UGA?: any;
    UKR?: any;
    URY?: any;
    USA?: any;
    UZB?: any;
    VAT?: any;
    VCT?: any;
    VEN?: any;
    VGB?: any;
    VIR?: any;
    VNM?: any;
    VUT?: any;
    WAK?: any;
    WLF?: any;
    WSM?: any;
    YEM?: any;
    ZAF?: any;
    ZMB?: any;
    ZWE?: any;
    ZZZ?: any;
  },
  ResolversTypes["CountryEnum"]
>;

export type CreateAccommodationReservationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CreateAccommodationReservationError"] =
    ResolversParentTypes["CreateAccommodationReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["CreateAccommodationReservationErrorCase"],
    ParentType,
    ContextType
  >;
  internalCode?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAccommodationReservationErrorCaseResolvers =
  EnumResolverSignature<
    {
      CycleDuplicationError?: any;
      InvalidReservationPeriodError?: any;
      MaxNightsPerMonthExceededError?: any;
      MaxNightsPerYearExceededError?: any;
      MaxReservationsExceededError?: any;
      MonthlyNightLimitExceededError?: any;
      MonthlyReservationLimitExceededError?: any;
      Next7DaysDuplicationError?: any;
      OwnerOfStayGiftFromOwnersError?: any;
      OwnerStayCreditInsufficientError?: any;
      PeakDayOwnerOnlyError?: any;
      PeakDaysLimitExceededError?: any;
      ReservationOverlapError?: any;
      ResourceUnavailable?: any;
      SanuIncStaffGroupIdRequiredError?: any;
      SiteHighSeasonLimitExceededError?: any;
      StayTicketError?: any;
      SubscriptionSuspended?: any;
      TermsNotAgreedError?: any;
      TrialContractSuspended?: any;
      TrialStayCreditInsufficientError?: any;
      UnexpectedError?: any;
      UnpaidAccommodationFeeError?: any;
      WeekdayTermsNotAgreedError?: any;
    },
    ResolversTypes["CreateAccommodationReservationErrorCase"]
  >;

export type CreateAccommodationReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CreateAccommodationReservationPayload"] =
    ResolversParentTypes["CreateAccommodationReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AccommodationReservation" | "CreateAccommodationReservationError",
    ParentType,
    ContextType
  >;
};

export type CreateCoOwnersApplicationFileDownloadUrlErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CreateCoOwnersApplicationFileDownloadUrlError"] =
    ResolversParentTypes["CreateCoOwnersApplicationFileDownloadUrlError"],
> = {
  case?: Resolver<
    ResolversTypes["CreateCoOwnersApplicationFileDownloadUrlErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateCoOwnersApplicationFileDownloadUrlErrorCaseResolvers =
  EnumResolverSignature<
    { NotFound?: any },
    ResolversTypes["CreateCoOwnersApplicationFileDownloadUrlErrorCase"]
  >;

export type CreateCoOwnersApplicationFileDownloadUrlPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CreateCoOwnersApplicationFileDownloadUrlPayload"] =
    ResolversParentTypes["CreateCoOwnersApplicationFileDownloadUrlPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "CreateCoOwnersApplicationFileDownloadUrlError"
    | "CreateCoOwnersApplicationFileDownloadUrlSuccess",
    ParentType,
    ContextType
  >;
};

export type CreateCoOwnersApplicationFileDownloadUrlSuccessResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CreateCoOwnersApplicationFileDownloadUrlSuccess"] =
    ResolversParentTypes["CreateCoOwnersApplicationFileDownloadUrlSuccess"],
> = {
  url?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFacilityReservationErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CreateFacilityReservationError"] =
    ResolversParentTypes["CreateFacilityReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["CreateFacilityReservationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFacilityReservationErrorCaseResolvers = EnumResolverSignature<
  {
    AccommodationReservationPeriodMismatch?: any;
    FeePolicyNotFound?: any;
    InvalidFacilityFieldData?: any;
    InvalidSlotSelection?: any;
    InvalidStartDate?: any;
    NoAccommodationReservation?: any;
    PastReserveDeadline?: any;
    ProviderNotEligible?: any;
    ResourceUnavailable?: any;
    ServiceNotAvailable?: any;
    TemporarilyUnavailable?: any;
  },
  ResolversTypes["CreateFacilityReservationErrorCase"]
>;

export type CreateFacilityReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CreateFacilityReservationPayload"] =
    ResolversParentTypes["CreateFacilityReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CreateFacilityReservationError" | "CreateFacilityReservationSuccess",
    ParentType,
    ContextType
  >;
};

export type CreateFacilityReservationSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CreateFacilityReservationSuccess"] =
    ResolversParentTypes["CreateFacilityReservationSuccess"],
> = {
  reservation?: Resolver<
    ResolversTypes["FacilityReservation"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFileUploadPolicyErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CreateFileUploadPolicyError"] =
    ResolversParentTypes["CreateFileUploadPolicyError"],
> = {
  case?: Resolver<
    ResolversTypes["CreateFileUploadPolicyErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFileUploadPolicyErrorCaseResolvers = EnumResolverSignature<
  { GeneralError?: any; NotFound?: any; ResourceIdRequired?: any },
  ResolversTypes["CreateFileUploadPolicyErrorCase"]
>;

export type CreateFileUploadPolicySuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CreateFileUploadPolicySuccess"] =
    ResolversParentTypes["CreateFileUploadPolicySuccess"],
> = {
  policy?: Resolver<ResolversTypes["S3UploadPolicy"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateOrUpdateUserAppInstallationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CreateOrUpdateUserAppInstallationError"] =
    ResolversParentTypes["CreateOrUpdateUserAppInstallationError"],
> = {
  case?: Resolver<
    ResolversTypes["CreateOrUpdateUserAppInstallationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateOrUpdateUserAppInstallationErrorCaseResolvers =
  EnumResolverSignature<
    { GeneralError?: any },
    ResolversTypes["CreateOrUpdateUserAppInstallationErrorCase"]
  >;

export type CreateOrUpdateUserAppInstallationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CreateOrUpdateUserAppInstallationPayload"] =
    ResolversParentTypes["CreateOrUpdateUserAppInstallationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CreateOrUpdateUserAppInstallationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type CreateStripeCardSetupIntentOfOrganizationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CreateStripeCardSetupIntentOfOrganizationPayload"] =
    ResolversParentTypes["CreateStripeCardSetupIntentOfOrganizationPayload"],
> = {
  clientSecret?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type CreateStripeCardSetupIntentOfViewerPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["CreateStripeCardSetupIntentOfViewerPayload"] =
    ResolversParentTypes["CreateStripeCardSetupIntentOfViewerPayload"],
> = {
  clientSecret?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type CreateWebviewSessionErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CreateWebviewSessionError"] =
    ResolversParentTypes["CreateWebviewSessionError"],
> = {
  case?: Resolver<
    ResolversTypes["CreateWebviewSessionErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWebviewSessionErrorCaseResolvers = EnumResolverSignature<
  { Unauthorized?: any },
  ResolversTypes["CreateWebviewSessionErrorCase"]
>;

export type CreateWebviewSessionPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CreateWebviewSessionPayload"] =
    ResolversParentTypes["CreateWebviewSessionPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CreateWebviewSessionError" | "CreateWebviewSessionSuccess",
    ParentType,
    ContextType
  >;
};

export type CreateWebviewSessionSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["CreateWebviewSessionSuccess"] =
    ResolversParentTypes["CreateWebviewSessionSuccess"],
> = {
  url?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CronJobNameResolvers = EnumResolverSignature<
  {
    ApplyGuestAccessKeys?: any;
    AutoTransitionCoOwnersHandover?: any;
    CalculateAndOpenAccommodationFees?: any;
    CancelExceededTentativeAccommodationReservations?: any;
    CheckGuestAccessKeys?: any;
    CheckOutExceededAccommodationReservations?: any;
    CloseSupplyReports?: any;
    CreateCleaningTasks?: any;
    CreateNextOrganizationYearlyContracts?: any;
    DetermineEarlyCheckInEligibility?: any;
    FetchCoOwnersIdentityVerificationEvidence?: any;
    FetchModifiedBeds24Bookings?: any;
    GrantStaffStayCredits?: any;
    IssueInvoicesOfAccommodationFees?: any;
    JobsAt0300Jst?: any;
    JobsAt1500Jst?: any;
    OpenDraftInvoices?: any;
    ReleaseExpiredAccessKeys?: any;
    RotateDailyStaffAccessKeys?: any;
    RotateMonthlyStaffAccessKeys?: any;
    ScheduledReleaseReservationBlocks?: any;
    SendCheckInAndCheckOutTodayReminders?: any;
    SendCheckOutGuideMails?: any;
    SendCleaningTasksDailyReminder?: any;
    SendCoOwnersIdentityVerificationReminderMails?: any;
    SendCoOwnersWebinarReminderMails?: any;
    SendFacilityReservationUsageEndReminders?: any;
    SendIchinomiyaNoticeMails?: any;
    SmartPlugStatusUpdate?: any;
    SyncBeds24FuturePrices?: any;
    SyncBubbleSupplyItemMasters?: any;
    SyncCoOwnersIdentityVerifications?: any;
  },
  ResolversTypes["CronJobName"]
>;

export type DailyRateTargetResolvers = EnumResolverSignature<
  { OnlineTravelAgent?: any; SanuInc?: any },
  ResolversTypes["DailyRateTarget"]
>;

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes["DateTime"],
  any
> {
  name: "DateTime";
}

export interface DecimalScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes["Decimal"],
  any
> {
  name: "Decimal";
}

export type DeleteUserAppInstallationErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["DeleteUserAppInstallationError"] =
    ResolversParentTypes["DeleteUserAppInstallationError"],
> = {
  case?: Resolver<
    ResolversTypes["DeleteUserAppInstallationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUserAppInstallationErrorCaseResolvers = EnumResolverSignature<
  { GeneralError?: any; NotFound?: any },
  ResolversTypes["DeleteUserAppInstallationErrorCase"]
>;

export type DeleteUserAppInstallationPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["DeleteUserAppInstallationPayload"] =
    ResolversParentTypes["DeleteUserAppInstallationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "DeleteUserAppInstallationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type DeleteViewerErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["DeleteViewerError"] =
    ResolversParentTypes["DeleteViewerError"],
> = {
  case?: Resolver<
    ResolversTypes["DeleteViewerErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteViewerErrorCaseResolvers = EnumResolverSignature<
  {
    Auth0UserNotDeleted?: any;
    PendingAccommodationReservations?: any;
    PendingCoOwnersApplications?: any;
    StripePaymentMethodNotDeleted?: any;
    UserDataNotDeleted?: any;
    UserOrganizationAdmin?: any;
    UserOwnershipActive?: any;
    UserSubscriptionActive?: any;
  },
  ResolversTypes["DeleteViewerErrorCase"]
>;

export type DeleteViewerPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["DeleteViewerPayload"] =
    ResolversParentTypes["DeleteViewerPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "DeleteViewerError" | "Success",
    ParentType,
    ContextType
  >;
};

export type DisclosureAssistantTypeResolvers = EnumResolverSignature<
  { PersonInCharge?: any; Representative?: any },
  ResolversTypes["DisclosureAssistantType"]
>;

export type DogfriendlyAccommodationFacilityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["DogfriendlyAccommodationFacility"] =
    ResolversParentTypes["DogfriendlyAccommodationFacility"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
};

export type DraftAccommodationReservationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["DraftAccommodationReservation"] =
    ResolversParentTypes["DraftAccommodationReservation"],
> = {
  accommodation?: Resolver<
    ResolversTypes["Accommodation"],
    ParentType,
    ContextType
  >;
  accommodationNotices?: Resolver<
    Array<ResolversTypes["AccommodationNotice"]>,
    ParentType,
    ContextType
  >;
  additionalNights?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  canSelectAllowRoomChange?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  cancellationPolicyContent?: Resolver<
    Maybe<ResolversTypes["CancellationPolicyContent"]>,
    ParentType,
    ContextType
  >;
  fee?: Resolver<ResolversTypes["AccommodationFee"], ParentType, ContextType>;
  feeApplicability?: Resolver<
    ResolversTypes["AccommodationFeeApplicability"],
    ParentType,
    ContextType
  >;
  firstDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  firstNight?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  lastDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  lastNight?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  localTaxPolicies?: Resolver<
    Array<ResolversTypes["LocalTaxPolicy"]>,
    ParentType,
    ContextType
  >;
  nights?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  options?: Resolver<
    ResolversTypes["AccommodationReservationOptions"],
    ParentType,
    ContextType
  >;
  reservedFrom?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  reservedTo?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  standardCheckInTime?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  stayTicketUnit?: Resolver<
    Maybe<ResolversTypes["StayTicketUnit"]>,
    ParentType,
    ContextType
  >;
};

export type DraftAccommodationReservationByStayTicketMasterResultResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["DraftAccommodationReservationByStayTicketMasterResult"] =
    ResolversParentTypes["DraftAccommodationReservationByStayTicketMasterResult"],
> = {
  fee?: Resolver<ResolversTypes["AccommodationFee"], ParentType, ContextType>;
};

export type EVChargerAccommodationFacilityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["EVChargerAccommodationFacility"] =
    ResolversParentTypes["EVChargerAccommodationFacility"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
};

export type EarlyCheckInPriceSlotResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["EarlyCheckInPriceSlot"] =
    ResolversParentTypes["EarlyCheckInPriceSlot"],
> = {
  endHour?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  price?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  startHour?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type EarlyCheckInStatusResolvers = EnumResolverSignature<
  { Available?: any; Hidden?: any; Visible?: any },
  ResolversTypes["EarlyCheckInStatus"]
>;

export type EstimateStandardSubscriptionApplicationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["EstimateStandardSubscriptionApplicationError"] =
    ResolversParentTypes["EstimateStandardSubscriptionApplicationError"],
> = {
  case?: Resolver<
    ResolversTypes["EstimateStandardSubscriptionApplicationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EstimateStandardSubscriptionApplicationErrorCaseResolvers =
  EnumResolverSignature<
    { HasPriorTransaction?: any; InvalidPromotionCode?: any },
    ResolversTypes["EstimateStandardSubscriptionApplicationErrorCase"]
  >;

export type EstimateStandardSubscriptionApplicationFeePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["EstimateStandardSubscriptionApplicationFeePayload"] =
    ResolversParentTypes["EstimateStandardSubscriptionApplicationFeePayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "EstimateStandardSubscriptionApplicationError"
    | "EstimateStandardSubscriptionApplicationSuccess",
    ParentType,
    ContextType
  >;
};

export type EstimateStandardSubscriptionApplicationSuccessResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["EstimateStandardSubscriptionApplicationSuccess"] =
    ResolversParentTypes["EstimateStandardSubscriptionApplicationSuccess"],
> = {
  amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EstimatedCancelFeeOfAccommodationReservationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["EstimatedCancelFeeOfAccommodationReservationError"] =
    ResolversParentTypes["EstimatedCancelFeeOfAccommodationReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["EstimatedCancelFeeOfAccommodationReservationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EstimatedCancelFeeOfAccommodationReservationErrorCaseResolvers =
  EnumResolverSignature<
    { GeneralError?: any },
    ResolversTypes["EstimatedCancelFeeOfAccommodationReservationErrorCase"]
  >;

export type EstimatedCancelFeeOfAccommodationReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["EstimatedCancelFeeOfAccommodationReservationPayload"] =
    ResolversParentTypes["EstimatedCancelFeeOfAccommodationReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "EstimatedCancelFeeOfAccommodationReservationError"
    | "EstimatedChargeOfAccommodationReservation",
    ParentType,
    ContextType
  >;
};

export type EstimatedChangeFeeOfAccommodationReservationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["EstimatedChangeFeeOfAccommodationReservationError"] =
    ResolversParentTypes["EstimatedChangeFeeOfAccommodationReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["EstimatedChangeFeeOfAccommodationReservationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EstimatedChangeFeeOfAccommodationReservationErrorCaseResolvers =
  EnumResolverSignature<
    { GeneralError?: any },
    ResolversTypes["EstimatedChangeFeeOfAccommodationReservationErrorCase"]
  >;

export type EstimatedChangeFeeOfAccommodationReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["EstimatedChangeFeeOfAccommodationReservationPayload"] =
    ResolversParentTypes["EstimatedChangeFeeOfAccommodationReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "EstimatedChangeFeeOfAccommodationReservationError"
    | "EstimatedChargeOfAccommodationReservation",
    ParentType,
    ContextType
  >;
};

export type EstimatedChargeOfAccommodationReservationResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["EstimatedChargeOfAccommodationReservation"] =
    ResolversParentTypes["EstimatedChargeOfAccommodationReservation"],
> = {
  items?: Resolver<
    Array<ResolversTypes["EstimatedChargeOfAccommodationReservationItem"]>,
    ParentType,
    ContextType
  >;
  totalAmountOfFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EstimatedChargeOfAccommodationReservationItemResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["EstimatedChargeOfAccommodationReservationItem"] =
    ResolversParentTypes["EstimatedChargeOfAccommodationReservationItem"],
> = {
  amountOfFee?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  chargeType?: Resolver<
    ResolversTypes["EstimatedChargeOfAccommodationReservationItemType"],
    ParentType,
    ContextType
  >;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  night?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
};

export type EstimatedChargeOfAccommodationReservationItemTypeResolvers =
  EnumResolverSignature<
    {
      Fee?: any;
      OwnerStayCredit?: any;
      StaffStayCredit?: any;
      TrialStayCredit?: any;
    },
    ResolversTypes["EstimatedChargeOfAccommodationReservationItemType"]
  >;

export type EvChargerLockResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["EvChargerLock"] =
    ResolversParentTypes["EvChargerLock"],
> = {
  controllerId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  expireAt?: Resolver<ResolversTypes["ZonedDateTime"], ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportStayGiftsPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ExportStayGiftsPayload"] =
    ResolversParentTypes["ExportStayGiftsPayload"],
> = {
  tickets?: Resolver<
    Array<ResolversTypes["StayGiftExportItem"]>,
    ParentType,
    ContextType
  >;
};

export type FacilityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Facility"] =
    ResolversParentTypes["Facility"],
> = {
  baseFeePolicies?: Resolver<
    Array<ResolversTypes["FacilityBaseFeePolicy"]>,
    ParentType,
    ContextType
  >;
  cancelDeadlineDaysBefore?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  cancelDeadlineHour?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  cancelFeePolicies?: Resolver<
    Array<ResolversTypes["FacilityCancelFeePolicy"]>,
    ParentType,
    ContextType
  >;
  cancelRuleUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  contentDetail?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  contentGuide?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  contentImages?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  contentNotice?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  contentUsage?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  customFields?: Resolver<
    Maybe<Array<ResolversTypes["FacilityCustomFieldItem"]>>,
    ParentType,
    ContextType
  >;
  description?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  detailUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  discountFeePolicies?: Resolver<
    Array<ResolversTypes["FacilityDiscountFeePolicy"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  image?: Resolver<ResolversTypes["UploadedFile"], ParentType, ContextType>;
  isCleaningReportEnabled?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  isDataSyncEnabled?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  isReservable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isReserveEnabled?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  isReserved?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isUsable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isVisibleEnabled?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  reserveDeadlineDaysBefore?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  reserveDeadlineHour?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  resources?: Resolver<
    Array<ResolversTypes["FacilityResource"]>,
    ParentType,
    ContextType
  >;
  sites?: Resolver<Array<ResolversTypes["Site"]>, ParentType, ContextType>;
  slots?: Resolver<
    Array<ResolversTypes["FacilitySlot"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes["FacilityStatusType"],
    ParentType,
    ContextType
  >;
  termsLabel?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  termsUrl?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes["FacilityType"], ParentType, ContextType>;
  unitType?: Resolver<
    ResolversTypes["FacilityUnitType"],
    ParentType,
    ContextType
  >;
};

export type FacilityBaseFeePolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityBaseFeePolicy"] =
    ResolversParentTypes["FacilityBaseFeePolicy"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  resource?: Resolver<
    Maybe<ResolversTypes["FacilityResource"]>,
    ParentType,
    ContextType
  >;
  unit?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  unitFeeAmount?: Resolver<ResolversTypes["Decimal"], ParentType, ContextType>;
};

export type FacilityCancelFeePolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityCancelFeePolicy"] =
    ResolversParentTypes["FacilityCancelFeePolicy"],
> = {
  deadlineDaysBefore?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  deadlineHour?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  feeModifierType?: Resolver<
    ResolversTypes["FeeModifierType"],
    ParentType,
    ContextType
  >;
  feeValue?: Resolver<ResolversTypes["Decimal"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  resource?: Resolver<
    Maybe<ResolversTypes["FacilityResource"]>,
    ParentType,
    ContextType
  >;
};

export type FacilityControllerResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityController"] =
    ResolversParentTypes["FacilityController"],
> = {
  attribute?: Resolver<
    Maybe<ResolversTypes["FacilityControllerAttribute"]>,
    ParentType,
    ContextType
  >;
  controllerAttribute?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  type?: Resolver<
    ResolversTypes["FacilityResourceControllerType"],
    ParentType,
    ContextType
  >;
};

export type FacilityControllerAttributeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityControllerAttribute"] =
    ResolversParentTypes["FacilityControllerAttribute"],
> = {
  __resolveType?: TypeResolveFn<
    | "CoWorkingSpaceDoorLock"
    | "EvChargerLock"
    | "OnsenAndSaunaDoorLock"
    | "RentalCycleKeyBox"
    | "WashingMachineTracker",
    ParentType,
    ContextType
  >;
};

export type FacilityCustomFieldItemResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityCustomFieldItem"] =
    ResolversParentTypes["FacilityCustomFieldItem"],
> = {
  caption?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  options?: Resolver<
    Maybe<Array<ResolversTypes["String"]>>,
    ParentType,
    ContextType
  >;
  placeholder?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  required?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["FacilityFieldType"], ParentType, ContextType>;
};

export type FacilityCustomFieldValueResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityCustomFieldValue"] =
    ResolversParentTypes["FacilityCustomFieldValue"],
> = {
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  value?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type FacilityDiscountFeePolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityDiscountFeePolicy"] =
    ResolversParentTypes["FacilityDiscountFeePolicy"],
> = {
  discountModifierType?: Resolver<
    ResolversTypes["FeeModifierType"],
    ParentType,
    ContextType
  >;
  discountValue?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type FacilityFeeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityFee"] =
    ResolversParentTypes["FacilityFee"],
> = {
  items?: Resolver<
    Array<ResolversTypes["FacilityFeeItem"]>,
    ParentType,
    ContextType
  >;
  totalAmount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type FacilityFeeItemResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityFeeItem"] =
    ResolversParentTypes["FacilityFeeItem"],
> = {
  amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  taxRate?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
};

export type FacilityFieldTypeResolvers = EnumResolverSignature<
  { SingleSelect?: any; Text?: any },
  ResolversTypes["FacilityFieldType"]
>;

export type FacilityInvoiceLabelPartResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityInvoiceLabelPart"] =
    ResolversParentTypes["FacilityInvoiceLabelPart"],
> = {
  format?: Resolver<
    Maybe<ResolversTypes["FacilityInvoiceLabelPeriodFormat"]>,
    ParentType,
    ContextType
  >;
  type?: Resolver<
    ResolversTypes["FacilityInvoiceLabelPartType"],
    ParentType,
    ContextType
  >;
  value?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
};

export type FacilityInvoiceLabelPartTypeResolvers = EnumResolverSignature<
  { ReservePeriod?: any; Text?: any },
  ResolversTypes["FacilityInvoiceLabelPartType"]
>;

export type FacilityInvoiceLabelPeriodFormatResolvers = EnumResolverSignature<
  { Date?: any; DateTime?: any },
  ResolversTypes["FacilityInvoiceLabelPeriodFormat"]
>;

export type FacilityReservationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityReservation"] =
    ResolversParentTypes["FacilityReservation"],
> = {
  accommodationReservation?: Resolver<
    ResolversTypes["AccommodationReservation"],
    ParentType,
    ContextType
  >;
  canceledAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  chargedFeeAmount?: Resolver<
    ResolversTypes["Decimal"],
    ParentType,
    ContextType
  >;
  cleaningReport?: Resolver<
    Maybe<ResolversTypes["FacilityReservationCleaningReport"]>,
    ParentType,
    ContextType
  >;
  controllers?: Resolver<
    Array<ResolversTypes["FacilityController"]>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  customFieldValues?: Resolver<
    Array<ResolversTypes["FacilityCustomFieldValue"]>,
    ParentType,
    ContextType
  >;
  dataSync?: Resolver<
    Maybe<ResolversTypes["FacilityReservationDataSync"]>,
    ParentType,
    ContextType
  >;
  discountAmount?: Resolver<ResolversTypes["Decimal"], ParentType, ContextType>;
  discountReason?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  endAt?: Resolver<ResolversTypes["PlainDateTime"], ParentType, ContextType>;
  estimatedCancelFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  guestName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  isCancelable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  resource?: Resolver<
    ResolversTypes["FacilityResource"],
    ParentType,
    ContextType
  >;
  resourceLabel?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  startAt?: Resolver<ResolversTypes["PlainDateTime"], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes["FacilityReservationStatusType"],
    ParentType,
    ContextType
  >;
  termsAgreedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  totalFeeAmount?: Resolver<ResolversTypes["Decimal"], ParentType, ContextType>;
  unitFeeAmount?: Resolver<ResolversTypes["Decimal"], ParentType, ContextType>;
  unitType?: Resolver<
    ResolversTypes["FacilityUnitType"],
    ParentType,
    ContextType
  >;
  units?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  user?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
};

export type FacilityReservationCleaningReportResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityReservationCleaningReport"] =
    ResolversParentTypes["FacilityReservationCleaningReport"],
> = {
  status?: Resolver<
    ResolversTypes["FacilityReservationCleaningStatus"],
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
};

export type FacilityReservationCleaningStatusResolvers = EnumResolverSignature<
  { Completed?: any; Pending?: any },
  ResolversTypes["FacilityReservationCleaningStatus"]
>;

export type FacilityReservationDataSyncResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityReservationDataSync"] =
    ResolversParentTypes["FacilityReservationDataSync"],
> = {
  status?: Resolver<
    ResolversTypes["FacilityReservationDataSyncStatus"],
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
};

export type FacilityReservationDataSyncStatusResolvers = EnumResolverSignature<
  { Pending?: any; Synced?: any },
  ResolversTypes["FacilityReservationDataSyncStatus"]
>;

export type FacilityReservationStatusTypeResolvers = EnumResolverSignature<
  { Canceled?: any; Reserved?: any },
  ResolversTypes["FacilityReservationStatusType"]
>;

export type FacilityResourceResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityResource"] =
    ResolversParentTypes["FacilityResource"],
> = {
  baseFeePolicies?: Resolver<
    Array<ResolversTypes["FacilityBaseFeePolicy"]>,
    ParentType,
    ContextType
  >;
  controllers?: Resolver<
    Array<ResolversTypes["FacilityController"]>,
    ParentType,
    ContextType,
    RequireFields<FacilityResourcecontrollersArgs, "accommodationReservationId">
  >;
  customInvoiceLabel?: Resolver<
    Maybe<Array<ResolversTypes["FacilityInvoiceLabelPart"]>>,
    ParentType,
    ContextType
  >;
  facility?: Resolver<ResolversTypes["Facility"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  isReservable?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    Partial<FacilityResourceisReservableArgs>
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  resourceControllers?: Resolver<
    Array<ResolversTypes["InternalFacilityController"]>,
    ParentType,
    ContextType
  >;
  slotAvailabilities?: Resolver<
    Array<ResolversTypes["FacilitySlotAvailability"]>,
    ParentType,
    ContextType,
    Partial<FacilityResourceslotAvailabilitiesArgs>
  >;
};

export type FacilityResourceBlockResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilityResourceBlock"] =
    ResolversParentTypes["FacilityResourceBlock"],
> = {
  endAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  resource?: Resolver<
    ResolversTypes["FacilityResource"],
    ParentType,
    ContextType
  >;
  resourceBlockType?: Resolver<
    ResolversTypes["FacilityResourceBlockType"],
    ParentType,
    ContextType
  >;
  startAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
};

export type FacilityResourceBlockTypeResolvers = EnumResolverSignature<
  { Admin?: any; User?: any },
  ResolversTypes["FacilityResourceBlockType"]
>;

export type FacilityResourceControllerTypeResolvers = EnumResolverSignature<
  {
    CoWorkingSpaceDoorLock?: any;
    EvChargerLock?: any;
    OnsenAndSaunaDoorLock?: any;
    RentalCycleKeyBox?: any;
    WashingMachineTracker?: any;
  },
  ResolversTypes["FacilityResourceControllerType"]
>;

export type FacilitySlotResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilitySlot"] =
    ResolversParentTypes["FacilitySlot"],
> = {
  endHour?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  endMinute?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  resource?: Resolver<
    Maybe<ResolversTypes["FacilityResource"]>,
    ParentType,
    ContextType
  >;
  startHour?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  startMinute?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type FacilitySlotAvailabilityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FacilitySlotAvailability"] =
    ResolversParentTypes["FacilitySlotAvailability"],
> = {
  date?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  isReservable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  slotId?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  unavailableReason?: Resolver<
    Maybe<ResolversTypes["FacilitySlotUnavailableReason"]>,
    ParentType,
    ContextType
  >;
};

export type FacilitySlotUnavailableReasonResolvers = EnumResolverSignature<
  {
    AlreadyReserved?: any;
    Blocked?: any;
    DeadlinePassed?: any;
    OutsideOperatingHours?: any;
    Past?: any;
  },
  ResolversTypes["FacilitySlotUnavailableReason"]
>;

export type FacilityStatusTypeResolvers = EnumResolverSignature<
  { Draft?: any; Preview?: any; Published?: any },
  ResolversTypes["FacilityStatusType"]
>;

export type FacilityTypeResolvers = EnumResolverSignature<
  {
    Barbecue?: any;
    CoWorkingSpace?: any;
    EvCharger?: any;
    OnsenAndSauna?: any;
    RentalCar?: any;
    RentalCycle?: any;
    WashingMachine?: any;
  },
  ResolversTypes["FacilityType"]
>;

export type FacilityUnitTypeResolvers = EnumResolverSignature<
  { Night?: any; Reservation?: any; Slot?: any },
  ResolversTypes["FacilityUnitType"]
>;

export type FeeModifierTypeResolvers = EnumResolverSignature<
  { Percentage?: any; Value?: any },
  ResolversTypes["FeeModifierType"]
>;

export type FieldTierPermissionResolvers = EnumResolverSignature<
  {
    AccommodationsKeysRead?: any;
    AvailabilityBlocksCommercialRead?: any;
    CoOwnersRestrictedRead?: any;
    ReservationsKeysRead?: any;
    StayTicketsPiiRead?: any;
    UsersCommercialRead?: any;
    UsersPiiRead?: any;
    UsersRestrictedRead?: any;
  },
  ResolversTypes["FieldTierPermission"]
>;

export type FileCopyTargetResolvers = EnumResolverSignature<
  {
    architectureType?: any;
    area?: any;
    banner?: any;
    ownerApplication?: any;
    ownerPlan?: any;
    userPicture?: any;
  },
  ResolversTypes["FileCopyTarget"]
>;

export type FileUploadPolicyPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FileUploadPolicyPayload"] =
    ResolversParentTypes["FileUploadPolicyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CreateFileUploadPolicyError" | "CreateFileUploadPolicySuccess",
    ParentType,
    ContextType
  >;
};

export type FinalizeAccountLinkErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FinalizeAccountLinkError"] =
    ResolversParentTypes["FinalizeAccountLinkError"],
> = {
  case?: Resolver<
    ResolversTypes["FinalizeAccountLinkErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinalizeAccountLinkErrorCaseResolvers = EnumResolverSignature<
  {
    IdentityMismatch?: any;
    InvalidIntentToken?: any;
    TokenExchangeFailed?: any;
  },
  ResolversTypes["FinalizeAccountLinkErrorCase"]
>;

export type FinalizeAccountLinkPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FinalizeAccountLinkPayload"] =
    ResolversParentTypes["FinalizeAccountLinkPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "FinalizeAccountLinkError" | "FinalizeAccountLinkSuccess",
    ParentType,
    ContextType
  >;
};

export type FinalizeAccountLinkSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["FinalizeAccountLinkSuccess"] =
    ResolversParentTypes["FinalizeAccountLinkSuccess"],
> = {
  continueUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialAssetsBracketTypeResolvers = EnumResolverSignature<
  {
    Above300Mil?: any;
    Below5Mil?: any;
    DoNotKnowWillNotSay?: any;
    From5MilTo10Mil?: any;
    From10MilTo30Mil?: any;
    From30MilTo50Mil?: any;
    From50MilTo100Mil?: any;
    From100MilTo300Mil?: any;
  },
  ResolversTypes["FinancialAssetsBracketType"]
>;

export type FullOwnerPlanAccommodationReservationProviderResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["FullOwnerPlanAccommodationReservationProvider"] =
    ResolversParentTypes["FullOwnerPlanAccommodationReservationProvider"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  userOwnershipId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenderTypeResolvers = EnumResolverSignature<
  { Female?: any; Male?: any; NoAnswer?: any },
  ResolversTypes["GenderType"]
>;

export type GenerateCheckInQrCodeErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["GenerateCheckInQrCodeError"] =
    ResolversParentTypes["GenerateCheckInQrCodeError"],
> = {
  case?: Resolver<
    ResolversTypes["GenerateCheckInQrCodeErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateCheckInQrCodeErrorCaseResolvers = EnumResolverSignature<
  { QrCodeNotRequired?: any; ReservationNotFound?: any; Unauthorized?: any },
  ResolversTypes["GenerateCheckInQrCodeErrorCase"]
>;

export type GenerateCheckInQrCodePayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["GenerateCheckInQrCodePayload"] =
    ResolversParentTypes["GenerateCheckInQrCodePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "GenerateCheckInQrCodeError" | "GenerateCheckInQrCodeSuccess",
    ParentType,
    ContextType
  >;
};

export type GenerateCheckInQrCodeSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["GenerateCheckInQrCodeSuccess"] =
    ResolversParentTypes["GenerateCheckInQrCodeSuccess"],
> = {
  checkInQrCode?: Resolver<
    ResolversTypes["CheckInQrCode"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeoLocationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["GeoLocation"] =
    ResolversParentTypes["GeoLocation"],
> = {
  latitude?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  longitude?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
};

export type GuestAccessKeyTriggerResolvers = EnumResolverSignature<
  { CancelReserve?: any; ChangeReserve?: any; CreateReserve?: any },
  ResolversTypes["GuestAccessKeyTrigger"]
>;

export type HighSeasonPeriodResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["HighSeasonPeriod"] =
    ResolversParentTypes["HighSeasonPeriod"],
> = {
  endDay?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  endMonth?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  startDay?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  startMonth?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["HighSeasonType"], ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
};

export type HighSeasonTypeResolvers = EnumResolverSignature<
  { GoldenWeek?: any; NewYear?: any; Obon?: any; SilverWeek?: any },
  ResolversTypes["HighSeasonType"]
>;

export type HubSpotSyncContactErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["HubSpotSyncContactError"] =
    ResolversParentTypes["HubSpotSyncContactError"],
> = {
  case?: Resolver<
    ResolversTypes["HubSpotSyncContactErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HubSpotSyncContactErrorCaseResolvers = EnumResolverSignature<
  { UserNotFound?: any },
  ResolversTypes["HubSpotSyncContactErrorCase"]
>;

export type HubSpotSyncContactResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["HubSpotSyncContactResult"] =
    ResolversParentTypes["HubSpotSyncContactResult"],
> = {
  __resolveType?: TypeResolveFn<
    "HubSpotSyncContactError" | "Success",
    ParentType,
    ContextType
  >;
};

export type HubSpotSyncDealErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["HubSpotSyncDealError"] =
    ResolversParentTypes["HubSpotSyncDealError"],
> = {
  case?: Resolver<
    ResolversTypes["HubSpotSyncDealErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HubSpotSyncDealErrorCaseResolvers = EnumResolverSignature<
  { ApplicationNotFound?: any; DealNotFound?: any },
  ResolversTypes["HubSpotSyncDealErrorCase"]
>;

export type HubSpotSyncDealResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["HubSpotSyncDealResult"] =
    ResolversParentTypes["HubSpotSyncDealResult"],
> = {
  __resolveType?: TypeResolveFn<
    "HubSpotSyncDealError" | "Success",
    ParentType,
    ContextType
  >;
};

export type IdentificationDocumentTypeResolvers = EnumResolverSignature<
  {
    BasicResidentRegisterCard?: any;
    DriverLicense?: any;
    MyNumberCard?: any;
    Passport?: any;
    ResidenceCard?: any;
    Undetermined?: any;
  },
  ResolversTypes["IdentificationDocumentType"]
>;

export type IdentityProviderResolvers = EnumResolverSignature<
  { Apple?: any; EmailPassword?: any; Google?: any },
  ResolversTypes["IdentityProvider"]
>;

export type IdentityVerificationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["IdentityVerification"] =
    ResolversParentTypes["IdentityVerification"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  method?: Resolver<
    ResolversTypes["IdentityVerificationMethod"],
    ParentType,
    ContextType
  >;
  note?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  ownerPlan?: Resolver<
    Maybe<ResolversTypes["OwnerPlan"]>,
    ParentType,
    ContextType
  >;
  result?: Resolver<
    Maybe<ResolversTypes["IdentityVerificationResult"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes["IdentityVerificationStatus"],
    ParentType,
    ContextType
  >;
  submissionPageUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  submissionPageUrlExpiresAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  trustdockOperationPageUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  trustdockVerificationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdentityVerificationMethodResolvers = EnumResolverSignature<
  {
    IcChipAndSelfie?: any;
    InPersonPhotoId?: any;
    RestrictedDeliveryMail?: any;
  },
  ResolversTypes["IdentityVerificationMethod"]
>;

export type IdentityVerificationResultResolvers = EnumResolverSignature<
  { Approved?: any; Denied?: any },
  ResolversTypes["IdentityVerificationResult"]
>;

export type IdentityVerificationStatusResolvers = EnumResolverSignature<
  {
    Accepted?: any;
    DocumentSubmitted?: any;
    InProgress?: any;
    NotStarted?: any;
    PlansSelected?: any;
    Verified?: any;
  },
  ResolversTypes["IdentityVerificationStatus"]
>;

export type IncomeBracketTypeResolvers = EnumResolverSignature<
  {
    Above30Mil?: any;
    Below5Mil?: any;
    DoNotKnowWillNotSay?: any;
    From5MilTo8Mil?: any;
    From8MilTo10Mil?: any;
    From10MilTo15Mil?: any;
    From15MilTo20Mil?: any;
    From20MilTo30Mil?: any;
  },
  ResolversTypes["IncomeBracketType"]
>;

export type InitiateAccountLinkErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InitiateAccountLinkError"] =
    ResolversParentTypes["InitiateAccountLinkError"],
> = {
  case?: Resolver<
    ResolversTypes["InitiateAccountLinkErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiateAccountLinkErrorCaseResolvers = EnumResolverSignature<
  { InvalidSessionToken?: any },
  ResolversTypes["InitiateAccountLinkErrorCase"]
>;

export type InitiateAccountLinkPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InitiateAccountLinkPayload"] =
    ResolversParentTypes["InitiateAccountLinkPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InitiateAccountLinkError" | "InitiateAccountLinkSuccess",
    ParentType,
    ContextType
  >;
};

export type InitiateAccountLinkSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InitiateAccountLinkSuccess"] =
    ResolversParentTypes["InitiateAccountLinkSuccess"],
> = {
  redirectUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiateAddIdentityErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InitiateAddIdentityError"] =
    ResolversParentTypes["InitiateAddIdentityError"],
> = {
  case?: Resolver<
    ResolversTypes["InitiateAddIdentityErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiateAddIdentityErrorCaseResolvers = EnumResolverSignature<
  { AlreadyLinked?: any; Unauthorized?: any },
  ResolversTypes["InitiateAddIdentityErrorCase"]
>;

export type InitiateAddIdentityPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InitiateAddIdentityPayload"] =
    ResolversParentTypes["InitiateAddIdentityPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InitiateAddIdentityError" | "InitiateAddIdentitySuccess",
    ParentType,
    ContextType
  >;
};

export type InitiateAddIdentitySuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InitiateAddIdentitySuccess"] =
    ResolversParentTypes["InitiateAddIdentitySuccess"],
> = {
  redirectUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InspectionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Inspection"] =
    ResolversParentTypes["Inspection"],
> = {
  accommodation?: Resolver<
    ResolversTypes["Accommodation"],
    ParentType,
    ContextType
  >;
  inspectionDate?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
  reservation?: Resolver<
    Maybe<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes["InspectionStatusType"],
    ParentType,
    ContextType
  >;
};

export type InspectionReportResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InspectionReport"] =
    ResolversParentTypes["InspectionReport"],
> = {
  closedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  externalViolationReportId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  reservation?: Resolver<
    ResolversTypes["AccommodationReservation"],
    ParentType,
    ContextType
  >;
  supplyItemMedia?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  supplyItems?: Resolver<
    Array<ResolversTypes["InspectionSupplyItem"]>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  violationDescription?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  violationHandling?: Resolver<
    Maybe<ResolversTypes["InspectionViolationHandling"]>,
    ParentType,
    ContextType
  >;
  violationItems?: Resolver<
    Array<ResolversTypes["InspectionViolationItem"]>,
    ParentType,
    ContextType
  >;
  violationMedia?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
};

export type InspectionReportTypeResolvers = EnumResolverSignature<
  { Supply?: any; Violation?: any },
  ResolversTypes["InspectionReportType"]
>;

export type InspectionStatusTypeResolvers = EnumResolverSignature<
  {
    Inspected?: any;
    InspectionRequired?: any;
    NotStarted?: any;
    Started?: any;
  },
  ResolversTypes["InspectionStatusType"]
>;

export type InspectionSupplyItemResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InspectionSupplyItem"] =
    ResolversParentTypes["InspectionSupplyItem"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type InspectionViolationHandlingResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InspectionViolationHandling"] =
    ResolversParentTypes["InspectionViolationHandling"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  severity?: Resolver<
    ResolversTypes["InspectionViolationSeverity"],
    ParentType,
    ContextType
  >;
  severityAssessedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  severityAssessedByUser?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes["InspectionViolationHandlingStatus"],
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  warningActionAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  warningActionByUser?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType
  >;
  warningActionNote?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
};

export type InspectionViolationHandlingStatusResolvers = EnumResolverSignature<
  { Assessed?: any; Handled?: any; Pending?: any },
  ResolversTypes["InspectionViolationHandlingStatus"]
>;

export type InspectionViolationItemResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InspectionViolationItem"] =
    ResolversParentTypes["InspectionViolationItem"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  typeId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  typeName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type InspectionViolationSeverityResolvers = EnumResolverSignature<
  { High?: any; Low?: any; Medium?: any; NotAssessed?: any },
  ResolversTypes["InspectionViolationSeverity"]
>;

export type InternalAccommodationEquipmentErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalAccommodationEquipmentError"] =
    ResolversParentTypes["InternalAccommodationEquipmentError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalAccommodationEquipmentErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalAccommodationEquipmentErrorCaseResolvers =
  EnumResolverSignature<
    {
      AccommodationNotFound?: any;
      AttributeTypeMismatch?: any;
      DuplicateEquipmentType?: any;
      EquipmentNotFound?: any;
      SanuEdgeDeviceNotFound?: any;
    },
    ResolversTypes["InternalAccommodationEquipmentErrorCase"]
  >;

export type InternalAddLocalTaxPolicyErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalAddLocalTaxPolicyError"] =
    ResolversParentTypes["InternalAddLocalTaxPolicyError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalAddLocalTaxPolicyErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalAddLocalTaxPolicyErrorCaseResolvers = EnumResolverSignature<
  { OverlappingEffectivePeriod?: any },
  ResolversTypes["InternalAddLocalTaxPolicyErrorCase"]
>;

export type InternalAddLocalTaxPolicyPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalAddLocalTaxPolicyPayload"] =
    ResolversParentTypes["InternalAddLocalTaxPolicyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalAddLocalTaxPolicyError" | "LocalTaxPolicy",
    ParentType,
    ContextType
  >;
};

export type InternalAdjustOwnerStayCreditErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalAdjustOwnerStayCreditError"] =
    ResolversParentTypes["InternalAdjustOwnerStayCreditError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalAdjustOwnerStayCreditErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalAdjustOwnerStayCreditErrorCaseResolvers =
  EnumResolverSignature<
    { InsufficientBalance?: any; InvalidAmount?: any; OwnershipNotFound?: any },
    ResolversTypes["InternalAdjustOwnerStayCreditErrorCase"]
  >;

export type InternalAdjustOwnerStayCreditPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalAdjustOwnerStayCreditPayload"] =
    ResolversParentTypes["InternalAdjustOwnerStayCreditPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalAdjustOwnerStayCreditError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalAdjustStaffCreditsErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalAdjustStaffCreditsError"] =
    ResolversParentTypes["InternalAdjustStaffCreditsError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalAdjustStaffCreditsErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalAdjustStaffCreditsErrorCaseResolvers =
  EnumResolverSignature<
    {
      ContractNotFound?: any;
      InsufficientBalance?: any;
      InvalidInput?: any;
      NotAuthorized?: any;
    },
    ResolversTypes["InternalAdjustStaffCreditsErrorCase"]
  >;

export type InternalAdjustStaffCreditsResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalAdjustStaffCreditsResult"] =
    ResolversParentTypes["InternalAdjustStaffCreditsResult"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalAdjustStaffCreditsError" | "InternalAdjustStaffCreditsSuccess",
    ParentType,
    ContextType
  >;
};

export type InternalAdjustStaffCreditsSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalAdjustStaffCreditsSuccess"] =
    ResolversParentTypes["InternalAdjustStaffCreditsSuccess"],
> = {
  contract?: Resolver<ResolversTypes["StaffContract"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalAdminRoleAssigneeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalAdminRoleAssignee"] =
    ResolversParentTypes["InternalAdminRoleAssignee"],
> = {
  email?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type InternalAppendS2oPointsToCoOwnersApplicationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalAppendS2oPointsToCoOwnersApplicationError"] =
    ResolversParentTypes["InternalAppendS2oPointsToCoOwnersApplicationError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalAppendS2oPointsToCoOwnersApplicationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalAppendS2oPointsToCoOwnersApplicationErrorCaseResolvers =
  EnumResolverSignature<
    {
      CoOwnersApplicationInvalid?: any;
      CoOwnersApplicationNotFound?: any;
      InsufficientS2oPointBalance?: any;
      InvalidAmount?: any;
    },
    ResolversTypes["InternalAppendS2oPointsToCoOwnersApplicationErrorCase"]
  >;

export type InternalAppendS2oPointsToCoOwnersApplicationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalAppendS2oPointsToCoOwnersApplicationPayload"] =
    ResolversParentTypes["InternalAppendS2oPointsToCoOwnersApplicationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalAppendS2oPointsToCoOwnersApplicationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalApplyGuestAccessKeyErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalApplyGuestAccessKeyError"] =
    ResolversParentTypes["InternalApplyGuestAccessKeyError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalApplyGuestAccessKeyPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalApplyGuestAccessKeyPayload"] =
    ResolversParentTypes["InternalApplyGuestAccessKeyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalApplyGuestAccessKeyError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalApplyStaffAccessKeyErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalApplyStaffAccessKeyError"] =
    ResolversParentTypes["InternalApplyStaffAccessKeyError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalApplyStaffAccessKeyPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalApplyStaffAccessKeyPayload"] =
    ResolversParentTypes["InternalApplyStaffAccessKeyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalApplyStaffAccessKeyError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalArchitectureContentErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalArchitectureContentError"] =
    ResolversParentTypes["InternalArchitectureContentError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalArchitectureContentErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalArchitectureContentErrorCaseResolvers =
  EnumResolverSignature<
    {
      ArchitectRequired?: any;
      ArchitectureTypeNotFound?: any;
      ContentNotFound?: any;
      InUse?: any;
      InvalidImage?: any;
      InvalidUrl?: any;
      NameRequired?: any;
      ResourceNotFound?: any;
      SortRequired?: any;
    },
    ResolversTypes["InternalArchitectureContentErrorCase"]
  >;

export type InternalArchitectureContentImageKindResolvers =
  EnumResolverSignature<
    {
      Architect?: any;
      ArchitectureType?: any;
      BasicAmenityIcon?: any;
      Feature?: any;
      FeatureUsageRule?: any;
      Variant?: any;
    },
    ResolversTypes["InternalArchitectureContentImageKind"]
  >;

export type InternalAreaResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalArea"] =
    ResolversParentTypes["InternalArea"],
> = {
  content?: Resolver<ResolversTypes["AreaContent"], ParentType, ContextType>;
  guideSpots?: Resolver<
    Array<ResolversTypes["AreaGuideSpot"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  localizedName?: Resolver<
    ResolversTypes["InternalLocalizedString"],
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sites?: Resolver<
    Array<ResolversTypes["InternalSite"]>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalAssignAccessCodeToAccommodationReservationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalAssignAccessCodeToAccommodationReservationError"] =
    ResolversParentTypes["InternalAssignAccessCodeToAccommodationReservationError"],
> = {
  internalCode?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalAssignAccessCodeToAccommodationReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalAssignAccessCodeToAccommodationReservationPayload"] =
    ResolversParentTypes["InternalAssignAccessCodeToAccommodationReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "AccommodationReservation"
    | "InternalAssignAccessCodeToAccommodationReservationError",
    ParentType,
    ContextType
  >;
};

export type InternalAssignAdminRoleErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalAssignAdminRoleError"] =
    ResolversParentTypes["InternalAssignAdminRoleError"],
> = {
  code?: Resolver<
    ResolversTypes["InternalAssignAdminRoleErrorCode"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalAssignAdminRoleErrorCodeResolvers = EnumResolverSignature<
  {
    AlreadyAssigned?: any;
    ExpiresAtNotInFuture?: any;
    InvalidAssignee?: any;
    RoleNotGrantable?: any;
    ScopeNotAllowed?: any;
    ScopeRequired?: any;
    SelfAssignment?: any;
    SiteNotFound?: any;
    SiteNotGrantable?: any;
    UserNotFound?: any;
  },
  ResolversTypes["InternalAssignAdminRoleErrorCode"]
>;

export type InternalAssignAdminRolePayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalAssignAdminRolePayload"] =
    ResolversParentTypes["InternalAssignAdminRolePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AdminRoleAssignment" | "InternalAssignAdminRoleError",
    ParentType,
    ContextType
  >;
};

export type InternalAuth0IdentityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalAuth0Identity"] =
    ResolversParentTypes["InternalAuth0Identity"],
> = {
  connection?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  isSocial?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  profileEmail?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  profileEmailVerified?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  provider?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type InternalAuth0UserResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalAuth0User"] =
    ResolversParentTypes["InternalAuth0User"],
> = {
  email?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  emailVerified?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  identities?: Resolver<
    Array<ResolversTypes["InternalAuth0Identity"]>,
    ParentType,
    ContextType
  >;
  userId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type InternalAvailableStaffSemesterResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalAvailableStaffSemester"] =
    ResolversParentTypes["InternalAvailableStaffSemester"],
> = {
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  semester?: Resolver<ResolversTypes["StaffSemester"], ParentType, ContextType>;
  year?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type InternalBeds24SyncFuturePricesResultResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBeds24SyncFuturePricesResult"] =
    ResolversParentTypes["InternalBeds24SyncFuturePricesResult"],
> = {
  dryRun?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  processedNightCount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  skippedRoomTypes?: Resolver<
    Array<ResolversTypes["InternalBeds24SyncFuturePricesSkip"]>,
    ParentType,
    ContextType
  >;
  targets?: Resolver<
    Array<ResolversTypes["InternalBeds24SyncFuturePricesTarget"]>,
    ParentType,
    ContextType
  >;
};

export type InternalBeds24SyncFuturePricesSkipResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBeds24SyncFuturePricesSkip"] =
    ResolversParentTypes["InternalBeds24SyncFuturePricesSkip"],
> = {
  reason?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  roomType?: Resolver<ResolversTypes["RoomType"], ParentType, ContextType>;
};

export type InternalBeds24SyncFuturePricesTargetResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBeds24SyncFuturePricesTarget"] =
    ResolversParentTypes["InternalBeds24SyncFuturePricesTarget"],
> = {
  blackoutRangeCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  priceRangeCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  roomType?: Resolver<ResolversTypes["RoomType"], ParentType, ContextType>;
};

export type InternalBulkCreateAccommodationAvailabilityBlockFailureResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBulkCreateAccommodationAvailabilityBlockFailure"] =
    ResolversParentTypes["InternalBulkCreateAccommodationAvailabilityBlockFailure"],
> = {
  input?: Resolver<
    ResolversTypes["InternalBulkCreateAccommodationAvailabilityBlockFailureInput"],
    ParentType,
    ContextType
  >;
  reason?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type InternalBulkCreateAccommodationAvailabilityBlockFailureInputResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBulkCreateAccommodationAvailabilityBlockFailureInput"] =
    ResolversParentTypes["InternalBulkCreateAccommodationAvailabilityBlockFailureInput"],
> = {
  accommodationId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  beginNight?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  category?: Resolver<
    ResolversTypes["AccommodationAvailabilityBlockCategory"],
    ParentType,
    ContextType
  >;
  endNight?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  isTentative?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  siteId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  staffGroupId?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
};

export type InternalBulkCreateAccommodationAvailabilityBlocksPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBulkCreateAccommodationAvailabilityBlocksPayload"] =
    ResolversParentTypes["InternalBulkCreateAccommodationAvailabilityBlocksPayload"],
> = {
  failed?: Resolver<
    Array<
      ResolversTypes["InternalBulkCreateAccommodationAvailabilityBlockFailure"]
    >,
    ParentType,
    ContextType
  >;
  success?: Resolver<
    Array<ResolversTypes["AccommodationAvailabilityBlock"]>,
    ParentType,
    ContextType
  >;
};

export type InternalBulkCreateOrganizationYearlyContractInvoicesErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBulkCreateOrganizationYearlyContractInvoicesError"] =
    ResolversParentTypes["InternalBulkCreateOrganizationYearlyContractInvoicesError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase"],
    ParentType,
    ContextType
  >;
  createdCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  orphanedInvoiceIds?: Resolver<
    Array<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalBulkCreateOrganizationYearlyContractInvoicesErrorCaseResolvers =
  EnumResolverSignature<
    {
      CardIsNotRegistered?: any;
      ContractIsInvalidated?: any;
      CreationFailed?: any;
      CustomerEmailRequired?: any;
      DueDateIsInPast?: any;
      ScheduledOpenDateOutOfRange?: any;
    },
    ResolversTypes["InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase"]
  >;

export type InternalBulkCreateOrganizationYearlyContractInvoicesPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBulkCreateOrganizationYearlyContractInvoicesPayload"] =
    ResolversParentTypes["InternalBulkCreateOrganizationYearlyContractInvoicesPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "InternalBulkCreateOrganizationYearlyContractInvoicesError"
    | "InternalBulkCreateOrganizationYearlyContractInvoicesSuccess",
    ParentType,
    ContextType
  >;
};

export type InternalBulkCreateOrganizationYearlyContractInvoicesSuccessResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBulkCreateOrganizationYearlyContractInvoicesSuccess"] =
    ResolversParentTypes["InternalBulkCreateOrganizationYearlyContractInvoicesSuccess"],
> = {
  invoiceIds?: Resolver<
    Array<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalBulkDeleteAccommodationAvailabilityBlockFailureResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBulkDeleteAccommodationAvailabilityBlockFailure"] =
    ResolversParentTypes["InternalBulkDeleteAccommodationAvailabilityBlockFailure"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type InternalBulkDeleteAccommodationAvailabilityBlocksPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBulkDeleteAccommodationAvailabilityBlocksPayload"] =
    ResolversParentTypes["InternalBulkDeleteAccommodationAvailabilityBlocksPayload"],
> = {
  failed?: Resolver<
    Array<
      ResolversTypes["InternalBulkDeleteAccommodationAvailabilityBlockFailure"]
    >,
    ParentType,
    ContextType
  >;
  successIds?: Resolver<Array<ResolversTypes["ID"]>, ParentType, ContextType>;
};

export type InternalBulkUpdateSeasonalFeeSettingsErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBulkUpdateSeasonalFeeSettingsError"] =
    ResolversParentTypes["InternalBulkUpdateSeasonalFeeSettingsError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  night?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type InternalBulkUpdateSeasonalFeeSettingsPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBulkUpdateSeasonalFeeSettingsPayload"] =
    ResolversParentTypes["InternalBulkUpdateSeasonalFeeSettingsPayload"],
> = {
  created?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  errors?: Resolver<
    Array<ResolversTypes["InternalBulkUpdateSeasonalFeeSettingsError"]>,
    ParentType,
    ContextType
  >;
  updated?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type InternalBulkUpdateStayTicketMastersErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBulkUpdateStayTicketMastersError"] =
    ResolversParentTypes["InternalBulkUpdateStayTicketMastersError"],
> = {
  id?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type InternalBulkUpdateStayTicketMastersPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalBulkUpdateStayTicketMastersPayload"] =
    ResolversParentTypes["InternalBulkUpdateStayTicketMastersPayload"],
> = {
  errors?: Resolver<
    Array<ResolversTypes["InternalBulkUpdateStayTicketMastersError"]>,
    ParentType,
    ContextType
  >;
  skipped?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type InternalCancelCoOwnersApplicationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCancelCoOwnersApplicationError"] =
    ResolversParentTypes["InternalCancelCoOwnersApplicationError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCancelCoOwnersApplicationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCancelCoOwnersApplicationErrorCaseResolvers =
  EnumResolverSignature<
    {
      AlreadyCancelled?: any;
      CannotCancelAfterHandover?: any;
      NotFound?: any;
      PermissionDenied?: any;
      StripeRefundError?: any;
    },
    ResolversTypes["InternalCancelCoOwnersApplicationErrorCase"]
  >;

export type InternalCancelCoOwnersApplicationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCancelCoOwnersApplicationPayload"] =
    ResolversParentTypes["InternalCancelCoOwnersApplicationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CoOwnersApplication" | "InternalCancelCoOwnersApplicationError",
    ParentType,
    ContextType
  >;
};

export type InternalCommonErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalCommonError"] =
    ResolversParentTypes["InternalCommonError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalContentRoomTypeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalContentRoomType"] =
    ResolversParentTypes["InternalContentRoomType"],
> = {
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  heroImages?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
};

export type InternalCreateAccommodationEquipmentPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateAccommodationEquipmentPayload"] =
    ResolversParentTypes["InternalCreateAccommodationEquipmentPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AccommodationEquipment" | "InternalAccommodationEquipmentError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateAccommodationOperationGroupErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateAccommodationOperationGroupError"] =
    ResolversParentTypes["InternalCreateAccommodationOperationGroupError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateAccommodationOperationGroupErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateAccommodationOperationGroupErrorCaseResolvers =
  EnumResolverSignature<
    {
      AlreadyExists?: any;
      ArchitectureTypeNotFound?: any;
      InvalidAdditionalFee?: any;
      SiteNotFound?: any;
    },
    ResolversTypes["InternalCreateAccommodationOperationGroupErrorCase"]
  >;

export type InternalCreateAccommodationOperationGroupPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateAccommodationOperationGroupPayload"] =
    ResolversParentTypes["InternalCreateAccommodationOperationGroupPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "AccommodationOperationGroup"
    | "InternalCreateAccommodationOperationGroupError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateCoOwnersIdentityVerificationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateCoOwnersIdentityVerificationError"] =
    ResolversParentTypes["InternalCreateCoOwnersIdentityVerificationError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateCoOwnersIdentityVerificationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateCoOwnersIdentityVerificationErrorCaseResolvers =
  EnumResolverSignature<
    { ActiveVerificationExists?: any; UnsupportedMethod?: any },
    ResolversTypes["InternalCreateCoOwnersIdentityVerificationErrorCase"]
  >;

export type InternalCreateCoOwnersIdentityVerificationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateCoOwnersIdentityVerificationPayload"] =
    ResolversParentTypes["InternalCreateCoOwnersIdentityVerificationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "IdentityVerification" | "InternalCreateCoOwnersIdentityVerificationError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateConsumedSuppliesFeeItemsErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateConsumedSuppliesFeeItemsError"] =
    ResolversParentTypes["InternalCreateConsumedSuppliesFeeItemsError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateConsumedSuppliesFeeItemsErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateConsumedSuppliesFeeItemsErrorCaseResolvers =
  EnumResolverSignature<
    { AccommodationFeeIsNotOpen?: any; ExternalCleaningTaskIdNotMatch?: any },
    ResolversTypes["InternalCreateConsumedSuppliesFeeItemsErrorCase"]
  >;

export type InternalCreateConsumedSuppliesFeeItemsPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateConsumedSuppliesFeeItemsPayload"] =
    ResolversParentTypes["InternalCreateConsumedSuppliesFeeItemsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateConsumedSuppliesFeeItemsError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalCreateFacilityReservationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateFacilityReservationError"] =
    ResolversParentTypes["InternalCreateFacilityReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateFacilityReservationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateFacilityReservationErrorCaseResolvers =
  EnumResolverSignature<
    {
      AccommodationReservationPeriodMismatch?: any;
      FeePolicyNotFound?: any;
      InvalidDiscount?: any;
      InvalidFacilityFieldData?: any;
      InvalidSlotSelection?: any;
      InvalidStartDate?: any;
      NoAccommodationReservation?: any;
      PastReserveDeadline?: any;
      ProviderNotEligible?: any;
      ResourceUnavailable?: any;
      ServiceNotAvailable?: any;
      TemporarilyUnavailable?: any;
    },
    ResolversTypes["InternalCreateFacilityReservationErrorCase"]
  >;

export type InternalCreateFacilityReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateFacilityReservationPayload"] =
    ResolversParentTypes["InternalCreateFacilityReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateFacilityReservationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalCreateFullOwnerIdentityVerificationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateFullOwnerIdentityVerificationError"] =
    ResolversParentTypes["InternalCreateFullOwnerIdentityVerificationError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateFullOwnerIdentityVerificationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateFullOwnerIdentityVerificationErrorCaseResolvers =
  EnumResolverSignature<
    { ActiveVerificationExists?: any; UnsupportedMethod?: any },
    ResolversTypes["InternalCreateFullOwnerIdentityVerificationErrorCase"]
  >;

export type InternalCreateFullOwnerIdentityVerificationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateFullOwnerIdentityVerificationPayload"] =
    ResolversParentTypes["InternalCreateFullOwnerIdentityVerificationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "IdentityVerification" | "InternalCreateFullOwnerIdentityVerificationError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateLocalTaxPolicyErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalCreateLocalTaxPolicyError"] =
    ResolversParentTypes["InternalCreateLocalTaxPolicyError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateLocalTaxPolicyErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateLocalTaxPolicyErrorCaseResolvers =
  EnumResolverSignature<
    {
      InvalidBrackets?: any;
      InvalidInput?: any;
      OverlappingEffectivePeriod?: any;
    },
    ResolversTypes["InternalCreateLocalTaxPolicyErrorCase"]
  >;

export type InternalCreateLocalTaxPolicyPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateLocalTaxPolicyPayload"] =
    ResolversParentTypes["InternalCreateLocalTaxPolicyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateLocalTaxPolicyError" | "LocalTaxPolicy",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateAccommodationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateAccommodationError"] =
    ResolversParentTypes["InternalCreateOrUpdateAccommodationError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateAccommodationNoticeErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateAccommodationNoticeError"] =
    ResolversParentTypes["InternalCreateOrUpdateAccommodationNoticeError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateAccommodationNoticeErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateAccommodationNoticeErrorCaseResolvers =
  EnumResolverSignature<
    { InvalidInput?: any },
    ResolversTypes["InternalCreateOrUpdateAccommodationNoticeErrorCase"]
  >;

export type InternalCreateOrUpdateAccommodationNoticePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateAccommodationNoticePayload"] =
    ResolversParentTypes["InternalCreateOrUpdateAccommodationNoticePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AccommodationNotice" | "InternalCreateOrUpdateAccommodationNoticeError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateAccommodationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateAccommodationPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateAccommodationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "Accommodation" | "InternalCreateOrUpdateAccommodationError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateAdditionalGuestFeePolicyErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateAdditionalGuestFeePolicyError"] =
    ResolversParentTypes["InternalCreateOrUpdateAdditionalGuestFeePolicyError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCaseResolvers =
  EnumResolverSignature<
    { InvalidInput?: any; ResourceNotFound?: any },
    ResolversTypes["InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase"]
  >;

export type InternalCreateOrUpdateAdditionalGuestFeePolicyPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateAdditionalGuestFeePolicyPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateAdditionalGuestFeePolicyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "AdditionalGuestFeePolicy"
    | "InternalCreateOrUpdateAdditionalGuestFeePolicyError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateBaseAccommodationFeePolicyErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateBaseAccommodationFeePolicyError"] =
    ResolversParentTypes["InternalCreateOrUpdateBaseAccommodationFeePolicyError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCaseResolvers =
  EnumResolverSignature<
    { DatabaseError?: any; InvalidInput?: any; ResourceNotFound?: any },
    ResolversTypes["InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase"]
  >;

export type InternalCreateOrUpdateBaseAccommodationFeePolicyPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateBaseAccommodationFeePolicyPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateBaseAccommodationFeePolicyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "InternalCreateOrUpdateBaseAccommodationFeePolicyError"
    | "RawBaseAccommodationFeePolicy",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateBusinessPlanErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateBusinessPlanError"] =
    ResolversParentTypes["InternalCreateOrUpdateBusinessPlanError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateBusinessPlanErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateBusinessPlanErrorCaseResolvers =
  EnumResolverSignature<
    { DuplicatedName?: any; InvalidInput?: any },
    ResolversTypes["InternalCreateOrUpdateBusinessPlanErrorCase"]
  >;

export type InternalCreateOrUpdateBusinessPlanPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateBusinessPlanPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateBusinessPlanPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "BusinessPlan" | "InternalCreateOrUpdateBusinessPlanError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateCancelFeePolicyErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateCancelFeePolicyError"] =
    ResolversParentTypes["InternalCreateOrUpdateCancelFeePolicyError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateCancelFeePolicyErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateCancelFeePolicyErrorCaseResolvers =
  EnumResolverSignature<
    { InvalidInput?: any; ResourceNotFound?: any },
    ResolversTypes["InternalCreateOrUpdateCancelFeePolicyErrorCase"]
  >;

export type InternalCreateOrUpdateCancelFeePolicyPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateCancelFeePolicyPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateCancelFeePolicyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateCancelFeePolicyError" | "RawCancelFeePolicy",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateCoOwnersPlanOfferingErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateCoOwnersPlanOfferingError"] =
    ResolversParentTypes["InternalCreateOrUpdateCoOwnersPlanOfferingError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateCoOwnersPlanOfferingErrorCaseResolvers =
  EnumResolverSignature<
    { InvalidInput?: any },
    ResolversTypes["InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase"]
  >;

export type InternalCreateOrUpdateCoOwnersPlanOfferingPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateCoOwnersPlanOfferingPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateCoOwnersPlanOfferingPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CoOwnersPlanOffering" | "InternalCreateOrUpdateCoOwnersPlanOfferingError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateCoOwnersWebinarScheduleErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateCoOwnersWebinarScheduleError"] =
    ResolversParentTypes["InternalCreateOrUpdateCoOwnersWebinarScheduleError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCaseResolvers =
  EnumResolverSignature<
    { InvalidInput?: any },
    ResolversTypes["InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase"]
  >;

export type InternalCreateOrUpdateCoOwnersWebinarSchedulePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateCoOwnersWebinarSchedulePayload"] =
    ResolversParentTypes["InternalCreateOrUpdateCoOwnersWebinarSchedulePayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "CoOwnersWebinarSchedule"
    | "InternalCreateOrUpdateCoOwnersWebinarScheduleError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateContentArchitectPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateContentArchitectPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateContentArchitectPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "ContentArchitect" | "InternalArchitectureContentError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateContentArchitecturalFeaturePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateContentArchitecturalFeaturePayload"] =
    ResolversParentTypes["InternalCreateOrUpdateContentArchitecturalFeaturePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "ContentArchitecturalFeature" | "InternalArchitectureContentError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload"] =
    ResolversParentTypes["InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "ContentArchitecturalFeatureUsageRule" | "InternalArchitectureContentError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateContentArchitectureTypePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateContentArchitectureTypePayload"] =
    ResolversParentTypes["InternalCreateOrUpdateContentArchitectureTypePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "ContentArchitectureType" | "InternalArchitectureContentError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateContentArchitectureTypeVariantPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateContentArchitectureTypeVariantPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateContentArchitectureTypeVariantPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "ContentArchitectureTypeVariant" | "InternalArchitectureContentError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateContentBasicAmenityPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateContentBasicAmenityPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateContentBasicAmenityPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "ContentArchitectureTypeBasicAmenity" | "InternalArchitectureContentError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateContentFacilityAmenityPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateContentFacilityAmenityPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateContentFacilityAmenityPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "ContentArchitectureTypeVariantFacilityAmenity"
    | "InternalArchitectureContentError",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateFacilityErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateFacilityError"] =
    ResolversParentTypes["InternalCreateOrUpdateFacilityError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateFacilityErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateFacilityErrorCaseResolvers =
  EnumResolverSignature<
    {
      CustomInvoiceLabelRequiresReserveEnabled?: any;
      FacilityNotFound?: any;
      InvalidControllerAttribute?: any;
      InvalidCustomInvoiceLabel?: any;
      SiteNotFound?: any;
    },
    ResolversTypes["InternalCreateOrUpdateFacilityErrorCase"]
  >;

export type InternalCreateOrUpdateFacilityPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateFacilityPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateFacilityPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateFacilityError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateFacilityResourceBlockErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateFacilityResourceBlockError"] =
    ResolversParentTypes["InternalCreateOrUpdateFacilityResourceBlockError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateFacilityResourceBlockErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateFacilityResourceBlockErrorCaseResolvers =
  EnumResolverSignature<
    { BlockNotFound?: any; ResourceNotFound?: any },
    ResolversTypes["InternalCreateOrUpdateFacilityResourceBlockErrorCase"]
  >;

export type InternalCreateOrUpdateFacilityResourceBlockPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateFacilityResourceBlockPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateFacilityResourceBlockPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateFacilityResourceBlockError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateNativeAppHomeContentErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateNativeAppHomeContentError"] =
    ResolversParentTypes["InternalCreateOrUpdateNativeAppHomeContentError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateNativeAppHomeContentErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateNativeAppHomeContentErrorCaseResolvers =
  EnumResolverSignature<
    {
      DatabaseError?: any;
      InvalidInput?: any;
      NotFound?: any;
      OptimisticLockConflict?: any;
    },
    ResolversTypes["InternalCreateOrUpdateNativeAppHomeContentErrorCase"]
  >;

export type InternalCreateOrUpdateNativeAppHomeContentPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateNativeAppHomeContentPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateNativeAppHomeContentPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "InternalCreateOrUpdateNativeAppHomeContentError"
    | "InternalNativeAppHomeContent",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateNewsErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalCreateOrUpdateNewsError"] =
    ResolversParentTypes["InternalCreateOrUpdateNewsError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateNewsErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateNewsErrorCaseResolvers =
  EnumResolverSignature<
    {
      ContentIsRequiredForHTML?: any;
      InternalPageIsNoLongerUsed?: any;
      UrlIsRequiredForExternalLink?: any;
    },
    ResolversTypes["InternalCreateOrUpdateNewsErrorCase"]
  >;

export type InternalCreateOrUpdateNewsPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalCreateOrUpdateNewsPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateNewsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateNewsError" | "News",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateOrganizationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateOrganizationError"] =
    ResolversParentTypes["InternalCreateOrUpdateOrganizationError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateOrganizationErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateOrganizationErrorCaseResolvers =
  EnumResolverSignature<
    {
      AssignedUserNotFound?: any;
      DuplicatedInvitationCode?: any;
      InvalidInput?: any;
    },
    ResolversTypes["InternalCreateOrUpdateOrganizationErrorCase"]
  >;

export type InternalCreateOrUpdateOrganizationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateOrganizationPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateOrganizationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateOrganizationError" | "Organization",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateOrganizationYearlyContractErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateOrganizationYearlyContractError"] =
    ResolversParentTypes["InternalCreateOrUpdateOrganizationYearlyContractError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateOrganizationYearlyContractInvoiceError"] =
    ResolversParentTypes["InternalCreateOrUpdateOrganizationYearlyContractInvoiceError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCaseResolvers =
  EnumResolverSignature<
    {
      CardIsNotRegistered?: any;
      ContractIdRequired?: any;
      ContractIsInvalidated?: any;
      CustomerEmailRequired?: any;
      DueDateIsInPast?: any;
      InvoiceIsNotDraft?: any;
      MissingRequiredFields?: any;
      ScheduledOpenDateOutOfRange?: any;
      YearMonthOutOfContractPeriod?: any;
    },
    ResolversTypes["InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase"]
  >;

export type InternalCreateOrUpdateOrganizationYearlyContractInvoicePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload"] =
    ResolversParentTypes["InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateOrganizationYearlyContractInvoiceError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateOrganizationYearlyContractPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateOrganizationYearlyContractPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateOrganizationYearlyContractPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "InternalCreateOrUpdateOrganizationYearlyContractError"
    | "OrganizationYearlyContract",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateOwnerPlanErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateOwnerPlanError"] =
    ResolversParentTypes["InternalCreateOrUpdateOwnerPlanError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateOwnerPlanErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateOwnerPlanErrorCaseResolvers =
  EnumResolverSignature<
    {
      AccommodationNotFound?: any;
      AccommodationRequiredForFullOwner?: any;
      ArchitectureTypeNotFound?: any;
      InvalidInput?: any;
      OperationGroupSettingNotFound?: any;
      OwnerPlanNotFound?: any;
      SiteAndArchitectureTypeRequiedForCoOwners?: any;
      SiteNotFound?: any;
    },
    ResolversTypes["InternalCreateOrUpdateOwnerPlanErrorCase"]
  >;

export type InternalCreateOrUpdateOwnerPlanPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateOwnerPlanPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateOwnerPlanPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateOwnerPlanError" | "OwnerPlan",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateSiteActivityProgramErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateSiteActivityProgramError"] =
    ResolversParentTypes["InternalCreateOrUpdateSiteActivityProgramError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateSiteActivityProgramErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateSiteActivityProgramErrorCaseResolvers =
  EnumResolverSignature<
    {
      ActivityProgramNotFound?: any;
      InvalidExternalUrl?: any;
      InvalidPublicationPeriod?: any;
      SiteNotFound?: any;
      TitleRequired?: any;
    },
    ResolversTypes["InternalCreateOrUpdateSiteActivityProgramErrorCase"]
  >;

export type InternalCreateOrUpdateSiteActivityProgramPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateSiteActivityProgramPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateSiteActivityProgramPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateSiteActivityProgramError" | "SiteActivityProgram",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateSiteFaqErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateSiteFaqError"] =
    ResolversParentTypes["InternalCreateOrUpdateSiteFaqError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateSiteFaqErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateSiteFaqErrorCaseResolvers =
  EnumResolverSignature<
    { AnswerIsEmpty?: any; QuestionIsEmpty?: any },
    ResolversTypes["InternalCreateOrUpdateSiteFaqErrorCase"]
  >;

export type InternalCreateOrUpdateSiteFaqPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateSiteFaqPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateSiteFaqPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateSiteFaqError" | "RawSiteFaq",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateStaffGroupErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateStaffGroupError"] =
    ResolversParentTypes["InternalCreateOrUpdateStaffGroupError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateStaffGroupErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateStaffGroupErrorCaseResolvers =
  EnumResolverSignature<
    { DuplicatedSmarthrId?: any; NotFound?: any },
    ResolversTypes["InternalCreateOrUpdateStaffGroupErrorCase"]
  >;

export type InternalCreateOrUpdateStaffGroupPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateStaffGroupPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateStaffGroupPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateStaffGroupError" | "StaffGroup",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateStayTicketMasterErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateStayTicketMasterError"] =
    ResolversParentTypes["InternalCreateOrUpdateStayTicketMasterError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateStayTicketMasterErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateStayTicketMasterErrorCaseResolvers =
  EnumResolverSignature<
    { InvalidInput?: any },
    ResolversTypes["InternalCreateOrUpdateStayTicketMasterErrorCase"]
  >;

export type InternalCreateOrUpdateStayTicketMasterPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateStayTicketMasterPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateStayTicketMasterPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateStayTicketMasterError" | "StayTicketMaster",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateStayTicketMasterTemplateErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateStayTicketMasterTemplateError"] =
    ResolversParentTypes["InternalCreateOrUpdateStayTicketMasterTemplateError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateStayTicketMasterTemplateErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateStayTicketMasterTemplateErrorCaseResolvers =
  EnumResolverSignature<
    { InvalidInput?: any },
    ResolversTypes["InternalCreateOrUpdateStayTicketMasterTemplateErrorCase"]
  >;

export type InternalCreateOrUpdateStayTicketMasterTemplatePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateStayTicketMasterTemplatePayload"] =
    ResolversParentTypes["InternalCreateOrUpdateStayTicketMasterTemplatePayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "InternalCreateOrUpdateStayTicketMasterTemplateError"
    | "StayTicketMasterTemplate",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateStayTicketTemplateErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateStayTicketTemplateError"] =
    ResolversParentTypes["InternalCreateOrUpdateStayTicketTemplateError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateSupplyItemInstallationsErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateSupplyItemInstallationsError"] =
    ResolversParentTypes["InternalCreateOrUpdateSupplyItemInstallationsError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateSupplyItemInstallationsErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateSupplyItemInstallationsErrorCaseResolvers =
  EnumResolverSignature<
    {
      DuplicateInstallation?: any;
      InstallationNotFound?: any;
      InvalidInstallationReference?: any;
      SiteNotFound?: any;
      SupplyItemMasterNotFound?: any;
      TemporarilyUnavailable?: any;
    },
    ResolversTypes["InternalCreateOrUpdateSupplyItemInstallationsErrorCase"]
  >;

export type InternalCreateOrUpdateSupplyItemInstallationsPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateSupplyItemInstallationsPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateSupplyItemInstallationsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateSupplyItemInstallationsError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalCreateOrUpdateSupplyItemMasterErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateSupplyItemMasterError"] =
    ResolversParentTypes["InternalCreateOrUpdateSupplyItemMasterError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateOrUpdateSupplyItemMasterErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateOrUpdateSupplyItemMasterErrorCaseResolvers =
  EnumResolverSignature<
    { RequiredFieldMissing?: any; SupplyItemMasterNotFound?: any },
    ResolversTypes["InternalCreateOrUpdateSupplyItemMasterErrorCase"]
  >;

export type InternalCreateOrUpdateSupplyItemMasterPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateOrUpdateSupplyItemMasterPayload"] =
    ResolversParentTypes["InternalCreateOrUpdateSupplyItemMasterPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateSupplyItemMasterError" | "SupplyItemMaster",
    ParentType,
    ContextType
  >;
};

export type InternalCreateSiteErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalCreateSiteError"] =
    ResolversParentTypes["InternalCreateSiteError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateSiteErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateSiteErrorCaseResolvers = EnumResolverSignature<
  { RemoteLockLocationNotFound?: any; SiteNotPublished?: any },
  ResolversTypes["InternalCreateSiteErrorCase"]
>;

export type InternalCreateSitePayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalCreateSitePayload"] =
    ResolversParentTypes["InternalCreateSitePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateSiteError" | "InternalSite",
    ParentType,
    ContextType
  >;
};

export type InternalCreateStayTicketTemplatePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateStayTicketTemplatePayload"] =
    ResolversParentTypes["InternalCreateStayTicketTemplatePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateOrUpdateStayTicketTemplateError" | "StayTicketTemplate",
    ParentType,
    ContextType
  >;
};

export type InternalCreateTermsRevisionErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalCreateTermsRevisionError"] =
    ResolversParentTypes["InternalCreateTermsRevisionError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalCreateTermsRevisionErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalCreateTermsRevisionErrorCaseResolvers =
  EnumResolverSignature<
    { AlreadyExists?: any; InvalidInput?: any; ResourceNotFound?: any },
    ResolversTypes["InternalCreateTermsRevisionErrorCase"]
  >;

export type InternalCreateTermsRevisionPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalCreateTermsRevisionPayload"] =
    ResolversParentTypes["InternalCreateTermsRevisionPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCreateTermsRevisionError" | "Terms",
    ParentType,
    ContextType
  >;
};

export type InternalDeleteAccommodationEquipmentPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalDeleteAccommodationEquipmentPayload"] =
    ResolversParentTypes["InternalDeleteAccommodationEquipmentPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "InternalAccommodationEquipmentError"
    | "InternalDeleteAccommodationEquipmentSuccess",
    ParentType,
    ContextType
  >;
};

export type InternalDeleteAccommodationEquipmentSuccessResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalDeleteAccommodationEquipmentSuccess"] =
    ResolversParentTypes["InternalDeleteAccommodationEquipmentSuccess"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalDeleteArchitectureContentPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalDeleteArchitectureContentPayload"] =
    ResolversParentTypes["InternalDeleteArchitectureContentPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalArchitectureContentError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalDeleteFacilityResourceBlockErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalDeleteFacilityResourceBlockError"] =
    ResolversParentTypes["InternalDeleteFacilityResourceBlockError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalDeleteFacilityResourceBlockErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalDeleteFacilityResourceBlockErrorCaseResolvers =
  EnumResolverSignature<
    { BlockNotFound?: any; CannotDeleteUserBlock?: any },
    ResolversTypes["InternalDeleteFacilityResourceBlockErrorCase"]
  >;

export type InternalDeleteFacilityResourceBlockPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalDeleteFacilityResourceBlockPayload"] =
    ResolversParentTypes["InternalDeleteFacilityResourceBlockPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalDeleteFacilityResourceBlockError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalDeleteLocalTaxPolicyErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalDeleteLocalTaxPolicyError"] =
    ResolversParentTypes["InternalDeleteLocalTaxPolicyError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalDeleteLocalTaxPolicyErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalDeleteLocalTaxPolicyErrorCaseResolvers =
  EnumResolverSignature<
    { LinkedToSiteOrAccommodation?: any },
    ResolversTypes["InternalDeleteLocalTaxPolicyErrorCase"]
  >;

export type InternalDeleteLocalTaxPolicyPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalDeleteLocalTaxPolicyPayload"] =
    ResolversParentTypes["InternalDeleteLocalTaxPolicyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalDeleteLocalTaxPolicyError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalDeleteSupplyItemInstallationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalDeleteSupplyItemInstallationError"] =
    ResolversParentTypes["InternalDeleteSupplyItemInstallationError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalDeleteSupplyItemInstallationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalDeleteSupplyItemInstallationErrorCaseResolvers =
  EnumResolverSignature<
    { InstallationNotFound?: any },
    ResolversTypes["InternalDeleteSupplyItemInstallationErrorCase"]
  >;

export type InternalDeleteSupplyItemInstallationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalDeleteSupplyItemInstallationPayload"] =
    ResolversParentTypes["InternalDeleteSupplyItemInstallationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalDeleteSupplyItemInstallationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalDeleteSupplyItemMasterErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalDeleteSupplyItemMasterError"] =
    ResolversParentTypes["InternalDeleteSupplyItemMasterError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalDeleteSupplyItemMasterErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalDeleteSupplyItemMasterErrorCaseResolvers =
  EnumResolverSignature<
    { HasActiveInstallations?: any; SupplyItemMasterNotFound?: any },
    ResolversTypes["InternalDeleteSupplyItemMasterErrorCase"]
  >;

export type InternalDeleteSupplyItemMasterPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalDeleteSupplyItemMasterPayload"] =
    ResolversParentTypes["InternalDeleteSupplyItemMasterPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalDeleteSupplyItemMasterError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalFacilityControllerResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalFacilityController"] =
    ResolversParentTypes["InternalFacilityController"],
> = {
  attribute?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  type?: Resolver<
    ResolversTypes["FacilityResourceControllerType"],
    ParentType,
    ContextType
  >;
};

export type InternalFutureCleaningAmountResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalFutureCleaningAmount"] =
    ResolversParentTypes["InternalFutureCleaningAmount"],
> = {
  accommodations?: Resolver<
    Array<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType
  >;
  amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  amountByFacilities?: Resolver<
    Array<ResolversTypes["InternalFutureCleaningAmountByFacility"]>,
    ParentType,
    ContextType
  >;
  date?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
};

export type InternalFutureCleaningAmountByFacilityResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalFutureCleaningAmountByFacility"] =
    ResolversParentTypes["InternalFutureCleaningAmountByFacility"],
> = {
  amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  facilityCombinationName?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
};

export type InternalFutureCleaningAmountsResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalFutureCleaningAmounts"] =
    ResolversParentTypes["InternalFutureCleaningAmounts"],
> = {
  list?: Resolver<
    Array<ResolversTypes["InternalFutureCleaningAmount"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalFutureCleaningAmountsErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalFutureCleaningAmountsError"] =
    ResolversParentTypes["InternalFutureCleaningAmountsError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalFutureCleaningAmountsPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalFutureCleaningAmountsPayload"] =
    ResolversParentTypes["InternalFutureCleaningAmountsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalFutureCleaningAmounts" | "InternalFutureCleaningAmountsError",
    ParentType,
    ContextType
  >;
};

export type InternalGenerateUserMonthlyStatementErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalGenerateUserMonthlyStatementError"] =
    ResolversParentTypes["InternalGenerateUserMonthlyStatementError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalGenerateUserMonthlyStatementErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalGenerateUserMonthlyStatementErrorCaseResolvers =
  EnumResolverSignature<
    { UserNotFound?: any },
    ResolversTypes["InternalGenerateUserMonthlyStatementErrorCase"]
  >;

export type InternalGenerateUserMonthlyStatementPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalGenerateUserMonthlyStatementPayload"] =
    ResolversParentTypes["InternalGenerateUserMonthlyStatementPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalGenerateUserMonthlyStatementError" | "UserMonthlyStatement",
    ParentType,
    ContextType
  >;
};

export type InternalGrantableAdminRoleResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalGrantableAdminRole"] =
    ResolversParentTypes["InternalGrantableAdminRole"],
> = {
  role?: Resolver<ResolversTypes["AdminRole"], ParentType, ContextType>;
  scope?: Resolver<
    Maybe<ResolversTypes["ScopeDimension"]>,
    ParentType,
    ContextType
  >;
};

export type InternalInvalidateOrganizationYearlyContractErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalInvalidateOrganizationYearlyContractError"] =
    ResolversParentTypes["InternalInvalidateOrganizationYearlyContractError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalInvalidateOrganizationYearlyContractErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalInvalidateOrganizationYearlyContractErrorCaseResolvers =
  EnumResolverSignature<
    { ReservationsExistInContractPeriod?: any },
    ResolversTypes["InternalInvalidateOrganizationYearlyContractErrorCase"]
  >;

export type InternalInvalidateOrganizationYearlyContractInvoiceErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalInvalidateOrganizationYearlyContractInvoiceError"] =
    ResolversParentTypes["InternalInvalidateOrganizationYearlyContractInvoiceError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalInvalidateOrganizationYearlyContractInvoiceErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalInvalidateOrganizationYearlyContractInvoiceErrorCaseResolvers =
  EnumResolverSignature<
    {
      InvoiceIsAlreadyInvalidated?: any;
      InvoiceIsPaid?: any;
      InvoiceIsUncollectible?: any;
    },
    ResolversTypes["InternalInvalidateOrganizationYearlyContractInvoiceErrorCase"]
  >;

export type InternalInvalidateOrganizationYearlyContractInvoicePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalInvalidateOrganizationYearlyContractInvoicePayload"] =
    ResolversParentTypes["InternalInvalidateOrganizationYearlyContractInvoicePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalInvalidateOrganizationYearlyContractInvoiceError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalInvalidateOrganizationYearlyContractPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalInvalidateOrganizationYearlyContractPayload"] =
    ResolversParentTypes["InternalInvalidateOrganizationYearlyContractPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalInvalidateOrganizationYearlyContractError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalInvalidateS2oPointsErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalInvalidateS2oPointsError"] =
    ResolversParentTypes["InternalInvalidateS2oPointsError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalInvalidateS2oPointsErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalInvalidateS2oPointsErrorCaseResolvers =
  EnumResolverSignature<
    { UserNotFound?: any },
    ResolversTypes["InternalInvalidateS2oPointsErrorCase"]
  >;

export type InternalInvalidateS2oPointsPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalInvalidateS2oPointsPayload"] =
    ResolversParentTypes["InternalInvalidateS2oPointsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalInvalidateS2oPointsError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalInvalidateStayTicketsByCodeResultResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalInvalidateStayTicketsByCodeResult"] =
    ResolversParentTypes["InternalInvalidateStayTicketsByCodeResult"],
> = {
  invalidatedTickets?: Resolver<
    Array<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType
  >;
  notFoundCodes?: Resolver<
    Array<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  skippedTickets?: Resolver<
    Array<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType
  >;
};

export type InternalIssueS2oPointsErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalIssueS2oPointsError"] =
    ResolversParentTypes["InternalIssueS2oPointsError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalIssueS2oPointsErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalIssueS2oPointsErrorCaseResolvers = EnumResolverSignature<
  {
    InsufficientBalance?: any;
    InvalidAmount?: any;
    InvalidDate?: any;
    InvalidTransactionType?: any;
    TrialContractNotFound?: any;
    UserNotFound?: any;
  },
  ResolversTypes["InternalIssueS2oPointsErrorCase"]
>;

export type InternalIssueS2oPointsPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalIssueS2oPointsPayload"] =
    ResolversParentTypes["InternalIssueS2oPointsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalIssueS2oPointsError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalJtasCreateOrUpdateInspectionStatusesErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalJtasCreateOrUpdateInspectionStatusesError"] =
    ResolversParentTypes["InternalJtasCreateOrUpdateInspectionStatusesError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalJtasCreateOrUpdateInspectionStatusesErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalJtasCreateOrUpdateInspectionStatusesErrorCaseResolvers =
  EnumResolverSignature<
    { ReservationNotFound?: any },
    ResolversTypes["InternalJtasCreateOrUpdateInspectionStatusesErrorCase"]
  >;

export type InternalJtasCreateOrUpdateInspectionStatusesPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalJtasCreateOrUpdateInspectionStatusesPayload"] =
    ResolversParentTypes["InternalJtasCreateOrUpdateInspectionStatusesPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalJtasCreateOrUpdateInspectionStatusesError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalJtasCreateOrUpdateSupplyReportErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalJtasCreateOrUpdateSupplyReportError"] =
    ResolversParentTypes["InternalJtasCreateOrUpdateSupplyReportError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalJtasCreateOrUpdateSupplyReportErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalJtasCreateOrUpdateSupplyReportErrorCaseResolvers =
  EnumResolverSignature<
    {
      MediaFetchFailed?: any;
      ReservationCanceled?: any;
      ReservationNotFound?: any;
      SupplyItemMasterNotFound?: any;
      SupplyReportClosed?: any;
    },
    ResolversTypes["InternalJtasCreateOrUpdateSupplyReportErrorCase"]
  >;

export type InternalJtasCreateOrUpdateSupplyReportPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalJtasCreateOrUpdateSupplyReportPayload"] =
    ResolversParentTypes["InternalJtasCreateOrUpdateSupplyReportPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalJtasCreateOrUpdateSupplyReportError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalJtasCreateOrUpdateViolationReportErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalJtasCreateOrUpdateViolationReportError"] =
    ResolversParentTypes["InternalJtasCreateOrUpdateViolationReportError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalJtasCreateOrUpdateViolationReportErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalJtasCreateOrUpdateViolationReportErrorCaseResolvers =
  EnumResolverSignature<
    {
      MediaFetchFailed?: any;
      ReservationNotFound?: any;
      ViolationReportClosed?: any;
    },
    ResolversTypes["InternalJtasCreateOrUpdateViolationReportErrorCase"]
  >;

export type InternalJtasCreateOrUpdateViolationReportPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalJtasCreateOrUpdateViolationReportPayload"] =
    ResolversParentTypes["InternalJtasCreateOrUpdateViolationReportPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalJtasCreateOrUpdateViolationReportError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalJtasDeleteViolationReportErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalJtasDeleteViolationReportError"] =
    ResolversParentTypes["InternalJtasDeleteViolationReportError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalJtasDeleteViolationReportErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalJtasDeleteViolationReportErrorCaseResolvers =
  EnumResolverSignature<
    { ViolationReportClosed?: any; ViolationReportNotFound?: any },
    ResolversTypes["InternalJtasDeleteViolationReportErrorCase"]
  >;

export type InternalJtasDeleteViolationReportPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalJtasDeleteViolationReportPayload"] =
    ResolversParentTypes["InternalJtasDeleteViolationReportPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalJtasDeleteViolationReportError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalLeaveOrganizationErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalLeaveOrganizationError"] =
    ResolversParentTypes["InternalLeaveOrganizationError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalLeaveOrganizationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalLeaveOrganizationErrorCaseResolvers = EnumResolverSignature<
  { HasActiveReservation?: any },
  ResolversTypes["InternalLeaveOrganizationErrorCase"]
>;

export type InternalLeaveOrganizationPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalLeaveOrganizationPayload"] =
    ResolversParentTypes["InternalLeaveOrganizationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalLeaveOrganizationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalLocalizedStringResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalLocalizedString"] =
    ResolversParentTypes["InternalLocalizedString"],
> = {
  en?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  ja?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  zhCn?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  zhTw?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
};

export type InternalMarkCoOwnersApplicationPlannedForSaleErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalMarkCoOwnersApplicationPlannedForSaleError"] =
    ResolversParentTypes["InternalMarkCoOwnersApplicationPlannedForSaleError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalMarkCoOwnersApplicationPlannedForSaleErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalMarkCoOwnersApplicationPlannedForSaleErrorCaseResolvers =
  EnumResolverSignature<
    {
      InvalidSaleUnits?: any;
      InvalidStatusTransition?: any;
      NextYearStayCreditsInUse?: any;
      NotFound?: any;
      OwnershipNotFound?: any;
      PermissionDenied?: any;
      SaleMonthBeforeHandover?: any;
      SaleMonthBeforePreviousSale?: any;
      SaleMonthRequiresCreditRestore?: any;
      TemporarilyUnavailable?: any;
    },
    ResolversTypes["InternalMarkCoOwnersApplicationPlannedForSaleErrorCase"]
  >;

export type InternalMarkCoOwnersApplicationPlannedForSalePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalMarkCoOwnersApplicationPlannedForSalePayload"] =
    ResolversParentTypes["InternalMarkCoOwnersApplicationPlannedForSalePayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "CoOwnersApplication"
    | "InternalMarkCoOwnersApplicationPlannedForSaleError",
    ParentType,
    ContextType
  >;
};

export type InternalMarkCoOwnersApplicationSoldErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalMarkCoOwnersApplicationSoldError"] =
    ResolversParentTypes["InternalMarkCoOwnersApplicationSoldError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalMarkCoOwnersApplicationSoldErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalMarkCoOwnersApplicationSoldErrorCaseResolvers =
  EnumResolverSignature<
    {
      HasActiveReservations?: any;
      HasActiveStayGifts?: any;
      InvalidStatusTransition?: any;
      NotFound?: any;
      OwnershipNotFound?: any;
      PermissionDenied?: any;
    },
    ResolversTypes["InternalMarkCoOwnersApplicationSoldErrorCase"]
  >;

export type InternalMarkCoOwnersApplicationSoldPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalMarkCoOwnersApplicationSoldPayload"] =
    ResolversParentTypes["InternalMarkCoOwnersApplicationSoldPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CoOwnersApplication" | "InternalMarkCoOwnersApplicationSoldError",
    ParentType,
    ContextType
  >;
};

export type InternalNativeAppHomeContentResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalNativeAppHomeContent"] =
    ResolversParentTypes["InternalNativeAppHomeContent"],
> = {
  createdAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes["InternalLocalizedString"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes["UploadedFile"], ParentType, ContextType>;
  label?: Resolver<
    Maybe<ResolversTypes["InternalLocalizedString"]>,
    ParentType,
    ContextType
  >;
  labelType?: Resolver<
    ResolversTypes["NativeAppHomeContentLabelType"],
    ParentType,
    ContextType
  >;
  link?: Resolver<
    ResolversTypes["InternalLocalizedString"],
    ParentType,
    ContextType
  >;
  linkAction?: Resolver<
    ResolversTypes["NativeAppHomeContentLinkAction"],
    ParentType,
    ContextType
  >;
  linkLabel?: Resolver<
    Maybe<ResolversTypes["InternalLocalizedString"]>,
    ParentType,
    ContextType
  >;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes["NativeAppHomeContentStatus"],
    ParentType,
    ContextType
  >;
  title?: Resolver<
    Maybe<ResolversTypes["InternalLocalizedString"]>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  updatedUser?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalOneShotScriptResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalOneShotScript"] =
    ResolversParentTypes["InternalOneShotScript"],
> = {
  description?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  lastExecutedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  requiredPermission?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  source?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sourceHtml?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  supportsDryRun?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type InternalOtaRoomUnitResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalOtaRoomUnit"] =
    ResolversParentTypes["InternalOtaRoomUnit"],
> = {
  accommodation?: Resolver<
    ResolversTypes["Accommodation"],
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  unit?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
};

export type InternalPartialUpdateOrganizationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalPartialUpdateOrganizationError"] =
    ResolversParentTypes["InternalPartialUpdateOrganizationError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalPartialUpdateOrganizationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalPartialUpdateOrganizationPayload"] =
    ResolversParentTypes["InternalPartialUpdateOrganizationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalPartialUpdateOrganizationError" | "Organization",
    ParentType,
    ContextType
  >;
};

export type InternalReleaseAccessKeyErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalReleaseAccessKeyError"] =
    ResolversParentTypes["InternalReleaseAccessKeyError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalReleaseAccessKeyPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalReleaseAccessKeyPayload"] =
    ResolversParentTypes["InternalReleaseAccessKeyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalReleaseAccessKeyError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalRemoveLocalTaxPolicyErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalRemoveLocalTaxPolicyError"] =
    ResolversParentTypes["InternalRemoveLocalTaxPolicyError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalRemoveLocalTaxPolicyErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalRemoveLocalTaxPolicyErrorCaseResolvers =
  EnumResolverSignature<
    { UsedForTaxCalculation?: any },
    ResolversTypes["InternalRemoveLocalTaxPolicyErrorCase"]
  >;

export type InternalRemoveLocalTaxPolicyPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalRemoveLocalTaxPolicyPayload"] =
    ResolversParentTypes["InternalRemoveLocalTaxPolicyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalRemoveLocalTaxPolicyError" | "LocalTaxPolicy",
    ParentType,
    ContextType
  >;
};

export type InternalRevokeAdminRoleErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalRevokeAdminRoleError"] =
    ResolversParentTypes["InternalRevokeAdminRoleError"],
> = {
  code?: Resolver<
    ResolversTypes["InternalRevokeAdminRoleErrorCode"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalRevokeAdminRoleErrorCodeResolvers = EnumResolverSignature<
  {
    AlreadyRevoked?: any;
    NotFound?: any;
    RoleNotRevocable?: any;
    SelfRevocation?: any;
  },
  ResolversTypes["InternalRevokeAdminRoleErrorCode"]
>;

export type InternalRevokeAdminRolePayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalRevokeAdminRolePayload"] =
    ResolversParentTypes["InternalRevokeAdminRolePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AdminRoleAssignment" | "InternalRevokeAdminRoleError",
    ParentType,
    ContextType
  >;
};

export type InternalRoomTypeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalRoomType"] =
    ResolversParentTypes["InternalRoomType"],
> = {
  architectureType?: Resolver<
    Maybe<ResolversTypes["ArchitectureType"]>,
    ParentType,
    ContextType
  >;
  beds24RoomId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  content?: Resolver<
    Maybe<ResolversTypes["InternalContentRoomType"]>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  displayNames?: Resolver<
    Maybe<ResolversTypes["InternalLocalizedString"]>,
    ParentType,
    ContextType
  >;
  features?: Resolver<
    Array<ResolversTypes["InternalRoomTypeFeature"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  notes?: Resolver<
    Maybe<ResolversTypes["InternalLocalizedString"]>,
    ParentType,
    ContextType
  >;
  otaRoomUnits?: Resolver<
    Array<ResolversTypes["InternalOtaRoomUnit"]>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
};

export type InternalRoomTypeFeatureResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalRoomTypeFeature"] =
    ResolversParentTypes["InternalRoomTypeFeature"],
> = {
  accommodationFacilityType?: Resolver<
    Maybe<ResolversTypes["AccommodationFacilityType"]>,
    ParentType,
    ContextType
  >;
  category?: Resolver<
    ResolversTypes["RoomTypeFeatureCategory"],
    ParentType,
    ContextType
  >;
  iconSlug?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  name?: Resolver<
    ResolversTypes["InternalLocalizedString"],
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type InternalRunOneShotScriptErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalRunOneShotScriptError"] =
    ResolversParentTypes["InternalRunOneShotScriptError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalRunOneShotScriptErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalRunOneShotScriptErrorCaseResolvers = EnumResolverSignature<
  {
    AlreadyRunning?: any;
    ConfirmationMismatch?: any;
    ConfirmationRequired?: any;
    DryRunNotSupported?: any;
    ScriptNotFound?: any;
  },
  ResolversTypes["InternalRunOneShotScriptErrorCase"]
>;

export type InternalRunOneShotScriptResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalRunOneShotScriptResult"] =
    ResolversParentTypes["InternalRunOneShotScriptResult"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalRunOneShotScriptError" | "InternalScriptExecution",
    ParentType,
    ContextType
  >;
};

export type InternalScriptAffectedCountResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalScriptAffectedCount"] =
    ResolversParentTypes["InternalScriptAffectedCount"],
> = {
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  value?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type InternalScriptExecutionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalScriptExecution"] =
    ResolversParentTypes["InternalScriptExecution"],
> = {
  affected?: Resolver<
    Array<ResolversTypes["InternalScriptAffectedCount"]>,
    ParentType,
    ContextType
  >;
  dryRun?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  finishedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  interrupted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  logs?: Resolver<
    Array<ResolversTypes["InternalScriptExecutionLogLine"]>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  startedAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes["ScriptExecutionStatus"],
    ParentType,
    ContextType
  >;
  summary?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  triggeredBy?: Resolver<
    ResolversTypes["InternalScriptExecutionActor"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalScriptExecutionActorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalScriptExecutionActor"] =
    ResolversParentTypes["InternalScriptExecutionActor"],
> = {
  email?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
};

export type InternalScriptExecutionLogLineResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalScriptExecutionLogLine"] =
    ResolversParentTypes["InternalScriptExecutionLogLine"],
> = {
  level?: Resolver<ResolversTypes["ScriptLogLevel"], ParentType, ContextType>;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  ts?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
};

export type InternalSendPushNotificationsErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalSendPushNotificationsError"] =
    ResolversParentTypes["InternalSendPushNotificationsError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalSendPushNotificationsErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalSendPushNotificationsErrorCaseResolvers =
  EnumResolverSignature<
    { InvalidInput?: any; NoAppInstallations?: any },
    ResolversTypes["InternalSendPushNotificationsErrorCase"]
  >;

export type InternalSendPushNotificationsPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalSendPushNotificationsPayload"] =
    ResolversParentTypes["InternalSendPushNotificationsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "InternalSendPushNotificationsError"
    | "InternalSendPushNotificationsResult",
    ParentType,
    ContextType
  >;
};

export type InternalSendPushNotificationsResultResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalSendPushNotificationsResult"] =
    ResolversParentTypes["InternalSendPushNotificationsResult"],
> = {
  deliveredEmails?: Resolver<
    Array<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  failedEmails?: Resolver<
    Array<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  noDeviceEmails?: Resolver<
    Array<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  notFoundEmails?: Resolver<
    Array<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalSiteResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalSite"] =
    ResolversParentTypes["InternalSite"],
> = {
  accommodations?: Resolver<
    Array<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType
  >;
  area?: Resolver<ResolversTypes["InternalArea"], ParentType, ContextType>;
  beds24PropertyId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  checkInAuthenticationType?: Resolver<
    ResolversTypes["CheckInAuthenticationType"],
    ParentType,
    ContextType
  >;
  content?: Resolver<ResolversTypes["SiteContent"], ParentType, ContextType>;
  customReservationLeadMonths?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  earlyCheckInEnabled?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  localizedName?: Resolver<
    ResolversTypes["InternalLocalizedString"],
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  openingDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  ordinalName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  publicOpeningDate?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  published?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  remoteLockLocationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  reservable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  reservableForOwnerEarlyAccess?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  roomTypeFeatures?: Resolver<
    Array<ResolversTypes["InternalRoomTypeFeature"]>,
    ParentType,
    ContextType
  >;
  roomTypes?: Resolver<
    Array<ResolversTypes["InternalRoomType"]>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  supplyItemInstallations?: Resolver<
    Array<ResolversTypes["SupplyItemInstallation"]>,
    ParentType,
    ContextType,
    RequireFields<InternalSitesupplyItemInstallationsArgs, "masterId">
  >;
  switchbotLocationApiKey?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalSiteAddressResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalSiteAddress"] =
    ResolversParentTypes["InternalSiteAddress"],
> = {
  addressLine?: Resolver<
    Maybe<ResolversTypes["InternalLocalizedString"]>,
    ParentType,
    ContextType
  >;
  city?: Resolver<
    Maybe<ResolversTypes["InternalLocalizedString"]>,
    ParentType,
    ContextType
  >;
  prefecture?: Resolver<
    Maybe<ResolversTypes["InternalLocalizedString"]>,
    ParentType,
    ContextType
  >;
};

export type InternalStaffContractResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalStaffContract"] =
    ResolversParentTypes["InternalStaffContract"],
> = {
  createdUser?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  currentSemesterGrantedStayCredits?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  currentSemesterStayCredits?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  enrolledAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  isReservable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  remainingPeakDays?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  semesterCredits?: Resolver<
    Array<ResolversTypes["StaffSemesterCredit"]>,
    ParentType,
    ContextType
  >;
  staffType?: Resolver<ResolversTypes["StaffType"], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes["StaffContractStatus"],
    ParentType,
    ContextType
  >;
  statusDetail?: Resolver<
    ResolversTypes["StaffContractStatusDetail"],
    ParentType,
    ContextType
  >;
  terminatedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  updatedUser?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  user?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
};

export type InternalStaffCreditTransactionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalStaffCreditTransaction"] =
    ResolversParentTypes["InternalStaffCreditTransaction"],
> = {
  accommodationReservation?: Resolver<
    Maybe<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType
  >;
  amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  createdByUser?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  peakDaysAmount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  semester?: Resolver<ResolversTypes["StaffSemester"], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes["StaffStayCreditTransactionStatus"],
    ParentType,
    ContextType
  >;
  type?: Resolver<
    ResolversTypes["StaffStayCreditTransactionType"],
    ParentType,
    ContextType
  >;
  year?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type InternalStartStaffPlanErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalStartStaffPlanError"] =
    ResolversParentTypes["InternalStartStaffPlanError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalStartStaffPlanErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalStartStaffPlanErrorCaseResolvers = EnumResolverSignature<
  {
    AlreadyActive?: any;
    InvalidNights?: any;
    InvalidSemester?: any;
    NotAuthorized?: any;
  },
  ResolversTypes["InternalStartStaffPlanErrorCase"]
>;

export type InternalStartStaffPlanResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalStartStaffPlanResult"] =
    ResolversParentTypes["InternalStartStaffPlanResult"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalStartStaffPlanError" | "InternalStartStaffPlanSuccess",
    ParentType,
    ContextType
  >;
};

export type InternalStartStaffPlanSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalStartStaffPlanSuccess"] =
    ResolversParentTypes["InternalStartStaffPlanSuccess"],
> = {
  contract?: Resolver<ResolversTypes["StaffContract"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalStayTicketsOrderByResolvers = EnumResolverSignature<
  {
    Code?: any;
    CreatedAt?: any;
    ExpiresAt?: any;
    StayEndNight?: any;
    StayStartNight?: any;
  },
  ResolversTypes["InternalStayTicketsOrderBy"]
>;

export type InternalStayTicketsResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalStayTicketsResult"] =
    ResolversParentTypes["InternalStayTicketsResult"],
> = {
  items?: Resolver<
    Array<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType
  >;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type InternalStopStaffPlanErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalStopStaffPlanError"] =
    ResolversParentTypes["InternalStopStaffPlanError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalStopStaffPlanErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalStopStaffPlanErrorCaseResolvers = EnumResolverSignature<
  { FutureReservationsExist?: any; NotActive?: any; NotAuthorized?: any },
  ResolversTypes["InternalStopStaffPlanErrorCase"]
>;

export type InternalStopStaffPlanResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalStopStaffPlanResult"] =
    ResolversParentTypes["InternalStopStaffPlanResult"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalStopStaffPlanError" | "InternalStopStaffPlanSuccess",
    ParentType,
    ContextType
  >;
};

export type InternalStopStaffPlanSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalStopStaffPlanSuccess"] =
    ResolversParentTypes["InternalStopStaffPlanSuccess"],
> = {
  contract?: Resolver<ResolversTypes["StaffContract"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUnlinkIdentityPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalUnlinkIdentityPayload"] =
    ResolversParentTypes["InternalUnlinkIdentityPayload"],
> = {
  success?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
};

export type InternalUpdateAccommodationEquipmentPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateAccommodationEquipmentPayload"] =
    ResolversParentTypes["InternalUpdateAccommodationEquipmentPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AccommodationEquipment" | "InternalAccommodationEquipmentError",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateAccommodationOperationGroupSettingErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateAccommodationOperationGroupSettingError"] =
    ResolversParentTypes["InternalUpdateAccommodationOperationGroupSettingError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateAccommodationOperationGroupSettingErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateAccommodationOperationGroupSettingErrorCaseResolvers =
  EnumResolverSignature<
    {
      InvalidAdditionalFee?: any;
      NotFound?: any;
      SiteReservable?: any;
      UserOwnershipExists?: any;
    },
    ResolversTypes["InternalUpdateAccommodationOperationGroupSettingErrorCase"]
  >;

export type InternalUpdateAccommodationOperationGroupSettingPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateAccommodationOperationGroupSettingPayload"] =
    ResolversParentTypes["InternalUpdateAccommodationOperationGroupSettingPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "AccommodationOperationGroupSetting"
    | "InternalUpdateAccommodationOperationGroupSettingError",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateAreaErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalUpdateAreaError"] =
    ResolversParentTypes["InternalUpdateAreaError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateAreaErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateAreaErrorCaseResolvers = EnumResolverSignature<
  { OptimisticLockConflict?: any },
  ResolversTypes["InternalUpdateAreaErrorCase"]
>;

export type InternalUpdateAreaPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalUpdateAreaPayload"] =
    ResolversParentTypes["InternalUpdateAreaPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalArea" | "InternalUpdateAreaError",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateCoOwnersApplicationDetailErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateCoOwnersApplicationDetailError"] =
    ResolversParentTypes["InternalUpdateCoOwnersApplicationDetailError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateCoOwnersApplicationDetailErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateCoOwnersApplicationDetailErrorCaseResolvers =
  EnumResolverSignature<
    { DetailTypeMismatch?: any; NotFound?: any },
    ResolversTypes["InternalUpdateCoOwnersApplicationDetailErrorCase"]
  >;

export type InternalUpdateCoOwnersApplicationDetailPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateCoOwnersApplicationDetailPayload"] =
    ResolversParentTypes["InternalUpdateCoOwnersApplicationDetailPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CoOwnersApplication" | "InternalUpdateCoOwnersApplicationDetailError",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateCoOwnersApplicationFileErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateCoOwnersApplicationFileError"] =
    ResolversParentTypes["InternalUpdateCoOwnersApplicationFileError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateCoOwnersApplicationFileErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateCoOwnersApplicationFileErrorCaseResolvers =
  EnumResolverSignature<
    { NotFound?: any },
    ResolversTypes["InternalUpdateCoOwnersApplicationFileErrorCase"]
  >;

export type InternalUpdateCoOwnersApplicationFilePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateCoOwnersApplicationFilePayload"] =
    ResolversParentTypes["InternalUpdateCoOwnersApplicationFilePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CoOwnersApplicationFile" | "InternalUpdateCoOwnersApplicationFileError",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateCoOwnersApplicationInfoErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateCoOwnersApplicationInfoError"] =
    ResolversParentTypes["InternalUpdateCoOwnersApplicationInfoError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateCoOwnersApplicationInfoErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateCoOwnersApplicationInfoErrorCaseResolvers =
  EnumResolverSignature<
    {
      IdDocument1Invalid?: any;
      IdDocument2Invalid?: any;
      InvalidInput?: any;
      NotFound?: any;
    },
    ResolversTypes["InternalUpdateCoOwnersApplicationInfoErrorCase"]
  >;

export type InternalUpdateCoOwnersApplicationInfoPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateCoOwnersApplicationInfoPayload"] =
    ResolversParentTypes["InternalUpdateCoOwnersApplicationInfoPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CoOwnersApplication" | "InternalUpdateCoOwnersApplicationInfoError",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateCoOwnersApplicationStatusErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateCoOwnersApplicationStatusError"] =
    ResolversParentTypes["InternalUpdateCoOwnersApplicationStatusError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateCoOwnersApplicationStatusErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateCoOwnersApplicationStatusErrorCaseResolvers =
  EnumResolverSignature<
    {
      IdentityVerificationNotApproved?: any;
      InvalidStatusTransition?: any;
      MissingDesiredHandoverDate?: any;
      NotFound?: any;
    },
    ResolversTypes["InternalUpdateCoOwnersApplicationStatusErrorCase"]
  >;

export type InternalUpdateCoOwnersApplicationStatusPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateCoOwnersApplicationStatusPayload"] =
    ResolversParentTypes["InternalUpdateCoOwnersApplicationStatusPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CoOwnersApplication" | "InternalUpdateCoOwnersApplicationStatusError",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateFacilityContentImagesPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateFacilityContentImagesPayload"] =
    ResolversParentTypes["InternalUpdateFacilityContentImagesPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCommonError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateFacilityReservationCleaningErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateFacilityReservationCleaningError"] =
    ResolversParentTypes["InternalUpdateFacilityReservationCleaningError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateFacilityReservationCleaningErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateFacilityReservationCleaningErrorCaseResolvers =
  EnumResolverSignature<
    { ReservationNotFound?: any },
    ResolversTypes["InternalUpdateFacilityReservationCleaningErrorCase"]
  >;

export type InternalUpdateFacilityReservationCleaningPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateFacilityReservationCleaningPayload"] =
    ResolversParentTypes["InternalUpdateFacilityReservationCleaningPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalUpdateFacilityReservationCleaningError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateFacilityReservationDataSyncErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateFacilityReservationDataSyncError"] =
    ResolversParentTypes["InternalUpdateFacilityReservationDataSyncError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateFacilityReservationDataSyncErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateFacilityReservationDataSyncErrorCaseResolvers =
  EnumResolverSignature<
    { ReservationNotFound?: any },
    ResolversTypes["InternalUpdateFacilityReservationDataSyncErrorCase"]
  >;

export type InternalUpdateFacilityReservationDataSyncPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateFacilityReservationDataSyncPayload"] =
    ResolversParentTypes["InternalUpdateFacilityReservationDataSyncPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalUpdateFacilityReservationDataSyncError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateIdentityVerificationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateIdentityVerificationError"] =
    ResolversParentTypes["InternalUpdateIdentityVerificationError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateIdentityVerificationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateIdentityVerificationErrorCaseResolvers =
  EnumResolverSignature<
    {
      InvalidStatusTransition?: any;
      NotFound?: any;
      ResultRequiredWhenVerified?: any;
    },
    ResolversTypes["InternalUpdateIdentityVerificationErrorCase"]
  >;

export type InternalUpdateIdentityVerificationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateIdentityVerificationPayload"] =
    ResolversParentTypes["InternalUpdateIdentityVerificationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalUpdateIdentityVerificationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateIndividualTermsDocumentErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateIndividualTermsDocumentError"] =
    ResolversParentTypes["InternalUpdateIndividualTermsDocumentError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateIndividualTermsDocumentErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateIndividualTermsDocumentErrorCaseResolvers =
  EnumResolverSignature<
    { InvalidInput?: any; ResourceNotFound?: any },
    ResolversTypes["InternalUpdateIndividualTermsDocumentErrorCase"]
  >;

export type InternalUpdateIndividualTermsDocumentPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateIndividualTermsDocumentPayload"] =
    ResolversParentTypes["InternalUpdateIndividualTermsDocumentPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalUpdateIndividualTermsDocumentError" | "Terms",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateInspectionViolationHandlingErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateInspectionViolationHandlingError"] =
    ResolversParentTypes["InternalUpdateInspectionViolationHandlingError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateInspectionViolationHandlingErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateInspectionViolationHandlingErrorCaseResolvers =
  EnumResolverSignature<
    {
      InspectionReportNotFound?: any;
      NothingToUpdate?: any;
      SeverityNotAssessed?: any;
      ViolationNotReported?: any;
    },
    ResolversTypes["InternalUpdateInspectionViolationHandlingErrorCase"]
  >;

export type InternalUpdateInspectionViolationHandlingPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateInspectionViolationHandlingPayload"] =
    ResolversParentTypes["InternalUpdateInspectionViolationHandlingPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalUpdateInspectionViolationHandlingError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateLocalTaxPolicyErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalUpdateLocalTaxPolicyError"] =
    ResolversParentTypes["InternalUpdateLocalTaxPolicyError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateLocalTaxPolicyErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateLocalTaxPolicyErrorCaseResolvers =
  EnumResolverSignature<
    {
      EffectiveToBeforeEffectiveFrom?: any;
      OverlappingEffectivePeriod?: any;
      UsedAfterEffectiveTo?: any;
    },
    ResolversTypes["InternalUpdateLocalTaxPolicyErrorCase"]
  >;

export type InternalUpdateLocalTaxPolicyPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateLocalTaxPolicyPayload"] =
    ResolversParentTypes["InternalUpdateLocalTaxPolicyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalUpdateLocalTaxPolicyError" | "LocalTaxPolicy",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateSiteErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalUpdateSiteError"] =
    ResolversParentTypes["InternalUpdateSiteError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalUpdateSiteErrorCase"],
    ParentType,
    ContextType
  >;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateSiteErrorCaseResolvers = EnumResolverSignature<
  {
    OperationGroupSettingMissing?: any;
    OptimisticLockConflict?: any;
    RemoteLockLocationNotFound?: any;
    SiteNotPublished?: any;
  },
  ResolversTypes["InternalUpdateSiteErrorCase"]
>;

export type InternalUpdateSiteImagesPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalUpdateSiteImagesPayload"] =
    ResolversParentTypes["InternalUpdateSiteImagesPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalCommonError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateSiteParametersErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalUpdateSiteParametersError"] =
    ResolversParentTypes["InternalUpdateSiteParametersError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateSiteParametersPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateSiteParametersPayload"] =
    ResolversParentTypes["InternalUpdateSiteParametersPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalSite" | "InternalUpdateSiteParametersError",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateSitePayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalUpdateSitePayload"] =
    ResolversParentTypes["InternalUpdateSitePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalSite" | "InternalUpdateSiteError",
    ParentType,
    ContextType
  >;
};

export type InternalUpdateStayTicketInvalidStatusErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateStayTicketInvalidStatusError"] =
    ResolversParentTypes["InternalUpdateStayTicketInvalidStatusError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateStayTicketNotFoundErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpdateStayTicketNotFoundError"] =
    ResolversParentTypes["InternalUpdateStayTicketNotFoundError"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpdateStayTicketPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalUpdateStayTicketPayload"] =
    ResolversParentTypes["InternalUpdateStayTicketPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "InternalUpdateStayTicketInvalidStatusError"
    | "InternalUpdateStayTicketNotFoundError"
    | "StayTicket",
    ParentType,
    ContextType
  >;
};

export type InternalUpsertBaseAccommodationFeeDailyRateErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpsertBaseAccommodationFeeDailyRateError"] =
    ResolversParentTypes["InternalUpsertBaseAccommodationFeeDailyRateError"],
> = {
  beds24RoomId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  date?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  index?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type InternalUpsertBaseAccommodationFeeDailyRatesPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpsertBaseAccommodationFeeDailyRatesPayload"] =
    ResolversParentTypes["InternalUpsertBaseAccommodationFeeDailyRatesPayload"],
> = {
  created?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  errors?: Resolver<
    Array<ResolversTypes["InternalUpsertBaseAccommodationFeeDailyRateError"]>,
    ParentType,
    ContextType
  >;
  skipped?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type InternalUpsertConsumedSupplyFeeItemWaiversErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpsertConsumedSupplyFeeItemWaiversError"] =
    ResolversParentTypes["InternalUpsertConsumedSupplyFeeItemWaiversError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalUpsertConsumedSupplyFeeItemWaiversPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalUpsertConsumedSupplyFeeItemWaiversPayload"] =
    ResolversParentTypes["InternalUpsertConsumedSupplyFeeItemWaiversPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InternalUpsertConsumedSupplyFeeItemWaiversError" | "Success",
    ParentType,
    ContextType
  >;
};

export type InternalUserSearchResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalUserSearchResult"] =
    ResolversParentTypes["InternalUserSearchResult"],
> = {
  hasNextPage?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes["User"]>, ParentType, ContextType>;
};

export type InternalUserStatsResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InternalUserStats"] =
    ResolversParentTypes["InternalUserStats"],
> = {
  activeMembers?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  guests?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  monthlyChurnRate?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  newSignupsThisMonth?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  totalUsers?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  usersWithUpcomingReservations?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
};

export type InternalVoidCoOwnersApplicationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalVoidCoOwnersApplicationError"] =
    ResolversParentTypes["InternalVoidCoOwnersApplicationError"],
> = {
  case?: Resolver<
    ResolversTypes["InternalVoidCoOwnersApplicationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalVoidCoOwnersApplicationErrorCaseResolvers =
  EnumResolverSignature<
    {
      HasActiveReservations?: any;
      HasActiveStayGifts?: any;
      InvalidStatusTransition?: any;
      NotFound?: any;
      OwnershipNotFound?: any;
      PermissionDenied?: any;
    },
    ResolversTypes["InternalVoidCoOwnersApplicationErrorCase"]
  >;

export type InternalVoidCoOwnersApplicationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["InternalVoidCoOwnersApplicationPayload"] =
    ResolversParentTypes["InternalVoidCoOwnersApplicationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CoOwnersApplication" | "InternalVoidCoOwnersApplicationError",
    ParentType,
    ContextType
  >;
};

export type InviteBusinessMembersErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InviteBusinessMembersError"] =
    ResolversParentTypes["InviteBusinessMembersError"],
> = {
  case?: Resolver<
    ResolversTypes["InviteBusinessMembersErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteBusinessMembersErrorCaseResolvers = EnumResolverSignature<
  {
    EmptyEmails?: any;
    ExceedsMaxRecipients?: any;
    InvalidEmailFormat?: any;
    NotOrganizationAdmin?: any;
  },
  ResolversTypes["InviteBusinessMembersErrorCase"]
>;

export type InviteBusinessMembersPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InviteBusinessMembersPayload"] =
    ResolversParentTypes["InviteBusinessMembersPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "InviteBusinessMembersError" | "InviteBusinessMembersSuccess",
    ParentType,
    ContextType
  >;
};

export type InviteBusinessMembersSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["InviteBusinessMembersSuccess"] =
    ResolversParentTypes["InviteBusinessMembersSuccess"],
> = {
  sentCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IssueSanuEdgeDeviceAccessTokenErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["IssueSanuEdgeDeviceAccessTokenError"] =
    ResolversParentTypes["IssueSanuEdgeDeviceAccessTokenError"],
> = {
  case?: Resolver<
    ResolversTypes["IssueSanuEdgeDeviceAccessTokenErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IssueSanuEdgeDeviceAccessTokenErrorCaseResolvers =
  EnumResolverSignature<
    {
      DeviceNotAccessible?: any;
      NoDevice?: any;
      ReservationNotFound?: any;
      Unauthorized?: any;
    },
    ResolversTypes["IssueSanuEdgeDeviceAccessTokenErrorCase"]
  >;

export type IssueSanuEdgeDeviceAccessTokenPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["IssueSanuEdgeDeviceAccessTokenPayload"] =
    ResolversParentTypes["IssueSanuEdgeDeviceAccessTokenPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "IssueSanuEdgeDeviceAccessTokenError"
    | "IssueSanuEdgeDeviceAccessTokenSuccess",
    ParentType,
    ContextType
  >;
};

export type IssueSanuEdgeDeviceAccessTokenSuccessResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["IssueSanuEdgeDeviceAccessTokenSuccess"] =
    ResolversParentTypes["IssueSanuEdgeDeviceAccessTokenSuccess"],
> = {
  device?: Resolver<ResolversTypes["SanuEdgeDevice"], ParentType, ContextType>;
  token?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IssueStayTicketsErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["IssueStayTicketsError"] =
    ResolversParentTypes["IssueStayTicketsError"],
> = {
  case?: Resolver<
    ResolversTypes["IssueStayTicketsErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IssueStayTicketsErrorCaseResolvers = EnumResolverSignature<
  { InvalidRequest?: any },
  ResolversTypes["IssueStayTicketsErrorCase"]
>;

export type IssueStayTicketsPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["IssueStayTicketsPayload"] =
    ResolversParentTypes["IssueStayTicketsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "IssueStayTicketsError" | "IssueStayTicketsResult",
    ParentType,
    ContextType
  >;
};

export type IssueStayTicketsResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["IssueStayTicketsResult"] =
    ResolversParentTypes["IssueStayTicketsResult"],
> = {
  tickets?: Resolver<
    Array<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JoinOrganizationErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["JoinOrganizationError"] =
    ResolversParentTypes["JoinOrganizationError"],
> = {
  case?: Resolver<
    ResolversTypes["JoinOrganizationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JoinOrganizationErrorCaseResolvers = EnumResolverSignature<
  { AlreadyBelongsToOrganization?: any },
  ResolversTypes["JoinOrganizationErrorCase"]
>;

export type JoinOrganizationPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["JoinOrganizationPayload"] =
    ResolversParentTypes["JoinOrganizationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "JoinOrganizationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type LeaveOrganizationByViewerErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["LeaveOrganizationByViewerError"] =
    ResolversParentTypes["LeaveOrganizationByViewerError"],
> = {
  case?: Resolver<
    ResolversTypes["LeaveOrganizationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaveOrganizationByViewerPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["LeaveOrganizationByViewerPayload"] =
    ResolversParentTypes["LeaveOrganizationByViewerPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "LeaveOrganizationByViewerError" | "Success",
    ParentType,
    ContextType
  >;
};

export type LeaveOrganizationErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["LeaveOrganizationError"] =
    ResolversParentTypes["LeaveOrganizationError"],
> = {
  case?: Resolver<
    ResolversTypes["LeaveOrganizationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaveOrganizationErrorCaseResolvers = EnumResolverSignature<
  { HasActiveReservation?: any; NotBelongsToOrganization?: any },
  ResolversTypes["LeaveOrganizationErrorCase"]
>;

export type LoadDataOutputResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["LoadDataOutput"] =
    ResolversParentTypes["LoadDataOutput"],
> = {
  results?: Resolver<
    Array<ResolversTypes["LoadDataOutputResult"]>,
    ParentType,
    ContextType
  >;
};

export type LoadDataOutputResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["LoadDataOutputResult"] =
    ResolversParentTypes["LoadDataOutputResult"],
> = {
  destinationTable?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  errorRecords?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  errors?: Resolver<
    Array<ResolversTypes["LoadDataOutputResultError"]>,
    ParentType,
    ContextType
  >;
  ignoredRecords?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  insertedRecords?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  sourceRecords?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  sourceTable?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type LoadDataOutputResultErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["LoadDataOutputResultError"] =
    ResolversParentTypes["LoadDataOutputResultError"],
> = {
  data?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  position?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type LoadDataTargetResolvers = EnumResolverSignature<
  {
    all?: any;
    announcement?: any;
    asset?: any;
    business?: any;
    owner?: any;
    reservation?: any;
    ticket?: any;
    user?: any;
  },
  ResolversTypes["LoadDataTarget"]
>;

export type LocalTaxBracketResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["LocalTaxBracket"] =
    ResolversParentTypes["LocalTaxBracket"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  maxAmount?: Resolver<
    Maybe<ResolversTypes["Decimal"]>,
    ParentType,
    ContextType
  >;
  maxTaxAmount?: Resolver<
    Maybe<ResolversTypes["Decimal"]>,
    ParentType,
    ContextType
  >;
  minAmount?: Resolver<ResolversTypes["Decimal"], ParentType, ContextType>;
  taxAmount?: Resolver<
    Maybe<ResolversTypes["Decimal"]>,
    ParentType,
    ContextType
  >;
  taxRate?: Resolver<Maybe<ResolversTypes["Decimal"]>, ParentType, ContextType>;
};

export type LocalTaxPolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["LocalTaxPolicy"] =
    ResolversParentTypes["LocalTaxPolicy"],
> = {
  accommodations?: Resolver<
    Array<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType
  >;
  brackets?: Resolver<
    Array<ResolversTypes["LocalTaxBracket"]>,
    ParentType,
    ContextType
  >;
  effectiveFrom?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
  effectiveTo?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  localGovernmentName?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  sites?: Resolver<
    Array<ResolversTypes["InternalSite"]>,
    ParentType,
    ContextType
  >;
  taxType?: Resolver<ResolversTypes["LocalTaxType"], ParentType, ContextType>;
  type?: Resolver<
    ResolversTypes["LocalTaxPolicyType"],
    ParentType,
    ContextType
  >;
  waiveKids?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocalTaxPolicyTypeResolvers = EnumResolverSignature<
  { FixedAmount?: any; FixedRate?: any; SteppedAmount?: any },
  ResolversTypes["LocalTaxPolicyType"]
>;

export type LocalTaxTypeResolvers = EnumResolverSignature<
  { AccommodationTax?: any; BathingTax?: any },
  ResolversTypes["LocalTaxType"]
>;

export type MemberPerksNowhereDrinkTicketResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["MemberPerksNowhereDrinkTicket"] =
    ResolversParentTypes["MemberPerksNowhereDrinkTicket"],
> = {
  used?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  usedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  user?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
};

export type MusicConnectEquipmentAttributeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["MusicConnectEquipmentAttribute"] =
    ResolversParentTypes["MusicConnectEquipmentAttribute"],
> = {
  instruction?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Mutation"] =
    ResolversParentTypes["Mutation"],
> = {
  acceptAccommodationReservation?: Resolver<
    ResolversTypes["AcceptAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationacceptAccommodationReservationArgs, "userAcceptCode">
  >;
  acquireStayTickets?: Resolver<
    ResolversTypes["AcquireStayTicketsPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationacquireStayTicketsArgs, "input">
  >;
  activateMemberPerksDrinkTicket?: Resolver<
    ResolversTypes["ActivateMemberPerksDrinkTicketPayload"],
    ParentType,
    ContextType
  >;
  agreeToTerms?: Resolver<
    ResolversTypes["AgreeToTermsPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationagreeToTermsArgs, "termsRevisionId">
  >;
  agreeToWeekdayTerms?: Resolver<
    ResolversTypes["AgreeToWeekdayTermsPayload"],
    ParentType,
    ContextType
  >;
  applyToTrialSubscription?: Resolver<
    ResolversTypes["ApplyToTrialSubscriptionPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationapplyToTrialSubscriptionArgs, "enrollmentMonth">
  >;
  applyToWeekdaySubscription?: Resolver<
    ResolversTypes["ApplyToWeekdaySubscriptionPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationapplyToWeekdaySubscriptionArgs, "startFrom">
  >;
  assignUserCompanions?: Resolver<
    Array<ResolversTypes["UserCompanion"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationassignUserCompanionsArgs,
      "accommodationReservationId" | "userCompanionIds"
    >
  >;
  bundleStayTickets?: Resolver<
    ResolversTypes["BundleStayTicketsPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationbundleStayTicketsArgs, "codes">
  >;
  cancelAccommodationReservation?: Resolver<
    ResolversTypes["CancelAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcancelAccommodationReservationArgs, "id">
  >;
  cancelCoOwnersApplication?: Resolver<
    ResolversTypes["CancelCoOwnersApplicationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationcancelCoOwnersApplicationArgs,
      "coOwnersApplicationId"
    >
  >;
  cancelFacilityReservation?: Resolver<
    ResolversTypes["CancelFacilityReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcancelFacilityReservationArgs, "id">
  >;
  cancelStandardSubscriptionApplication?: Resolver<
    ResolversTypes["CancelStandardSubscriptionApplicationPayload"],
    ParentType,
    ContextType
  >;
  cancelStandardSubscriptionPause?: Resolver<
    ResolversTypes["CancelStandardSubscriptionPausePayload"],
    ParentType,
    ContextType
  >;
  cancelStandardSubscriptionResume?: Resolver<
    ResolversTypes["CancelStandardSubscriptionResumePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcancelStandardSubscriptionResumeArgs, "questionnaire">
  >;
  cancelStandardSubscriptionTermination?: Resolver<
    ResolversTypes["CancelStandardSubscriptionTerminationPayload"],
    ParentType,
    ContextType
  >;
  cancelStayGifts?: Resolver<
    ResolversTypes["CancelStayGiftsPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcancelStayGiftsArgs, "ticketIds">
  >;
  cancelTrialSubscription?: Resolver<
    ResolversTypes["CancelTrialSubscriptionPayload"],
    ParentType,
    ContextType
  >;
  changeAccommodationAvailabilityBlock?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      MutationchangeAccommodationAvailabilityBlockArgs,
      "id" | "input"
    >
  >;
  changeAccommodationReservation?: Resolver<
    ResolversTypes["ChangeAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationchangeAccommodationReservationArgs, "id" | "input">
  >;
  checkInAccommodationReservation?: Resolver<
    ResolversTypes["CheckInAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcheckInAccommodationReservationArgs, "id" | "input">
  >;
  checkOutAccommodationReservation?: Resolver<
    ResolversTypes["CheckOutAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcheckOutAccommodationReservationArgs, "id">
  >;
  checkOutAccommodationReservationWithStayReviewResponse?: Resolver<
    ResolversTypes["CheckOutAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationcheckOutAccommodationReservationWithStayReviewResponseArgs,
      "id" | "input"
    >
  >;
  completeAddIdentity?: Resolver<
    ResolversTypes["CompleteAddIdentityPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcompleteAddIdentityArgs, "input">
  >;
  confirmTentativeAccommodationReservation?: Resolver<
    ResolversTypes["ConfirmTentativeAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationconfirmTentativeAccommodationReservationArgs,
      "detailInput" | "id"
    >
  >;
  copyFilesToS3?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationcopyFilesToS3Args, "target">
  >;
  createAccommodationAvailabilityBlock?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationcreateAccommodationAvailabilityBlockArgs, "input">
  >;
  createAccommodationReservation?: Resolver<
    ResolversTypes["CreateAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcreateAccommodationReservationArgs, "input">
  >;
  createCoOwnersApplicationFileDownloadUrl?: Resolver<
    ResolversTypes["CreateCoOwnersApplicationFileDownloadUrlPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationcreateCoOwnersApplicationFileDownloadUrlArgs,
      "coOwnersApplicationFileId"
    >
  >;
  createCoOwnersApplicationFileUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationcreateCoOwnersApplicationFileUploadPolicyArgs,
      "input"
    >
  >;
  createFacilityReservation?: Resolver<
    ResolversTypes["CreateFacilityReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcreateFacilityReservationArgs, "input">
  >;
  createFullOwnerContractUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcreateFullOwnerContractUploadPolicyArgs, "input">
  >;
  createOrUpdateUserAppInstallation?: Resolver<
    ResolversTypes["CreateOrUpdateUserAppInstallationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcreateOrUpdateUserAppInstallationArgs, "input">
  >;
  createSanuOwnerPlanFileUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcreateSanuOwnerPlanFileUploadPolicyArgs, "input">
  >;
  createSanuOwnerPlanUserFileUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcreateSanuOwnerPlanUserFileUploadPolicyArgs, "input">
  >;
  createStripeCardSetupIntentOfOrganization?: Resolver<
    ResolversTypes["CreateStripeCardSetupIntentOfOrganizationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationcreateStripeCardSetupIntentOfOrganizationArgs,
      "organizationId"
    >
  >;
  createStripeCardSetupIntentOfViewer?: Resolver<
    ResolversTypes["CreateStripeCardSetupIntentOfViewerPayload"],
    ParentType,
    ContextType
  >;
  createUserCompanion?: Resolver<
    ResolversTypes["UserCompanion"],
    ParentType,
    ContextType,
    RequireFields<MutationcreateUserCompanionArgs, "input">
  >;
  createUserFileUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcreateUserFileUploadPolicyArgs, "input">
  >;
  createWebviewSession?: Resolver<
    ResolversTypes["CreateWebviewSessionPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationcreateWebviewSessionArgs, "input">
  >;
  deleteAccommodationAvailabilityBlock?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType,
    RequireFields<MutationdeleteAccommodationAvailabilityBlockArgs, "id">
  >;
  deleteUserAppInstallation?: Resolver<
    ResolversTypes["DeleteUserAppInstallationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationdeleteUserAppInstallationArgs, "installationId">
  >;
  deleteUserCompanion?: Resolver<
    ResolversTypes["Success"],
    ParentType,
    ContextType,
    RequireFields<MutationdeleteUserCompanionArgs, "id">
  >;
  deleteViewer?: Resolver<
    ResolversTypes["DeleteViewerPayload"],
    ParentType,
    ContextType
  >;
  finalizeAccountLink?: Resolver<
    ResolversTypes["FinalizeAccountLinkPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationfinalizeAccountLinkArgs, "input">
  >;
  generateCheckInQrCode?: Resolver<
    ResolversTypes["GenerateCheckInQrCodePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationgenerateCheckInQrCodeArgs, "input">
  >;
  immediatelyApplyToStandardSubscriptionForDevelop?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  immediatelyCancelStandardSubscriptionForDevelop?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  initiateAccountLink?: Resolver<
    ResolversTypes["InitiateAccountLinkPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinitiateAccountLinkArgs, "input">
  >;
  initiateAddIdentity?: Resolver<
    ResolversTypes["InitiateAddIdentityPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinitiateAddIdentityArgs, "input">
  >;
  internalAddLocalTaxPolicy?: Resolver<
    ResolversTypes["InternalAddLocalTaxPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalAddLocalTaxPolicyArgs, "policyId" | "target">
  >;
  internalAdjustOwnerStayCredit?: Resolver<
    ResolversTypes["InternalAdjustOwnerStayCreditPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalAdjustOwnerStayCreditArgs,
      "amount" | "ownershipId" | "year"
    >
  >;
  internalAdjustStaffCredits?: Resolver<
    ResolversTypes["InternalAdjustStaffCreditsResult"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalAdjustStaffCreditsArgs,
      "contractId" | "nights" | "peakDays" | "semester" | "year"
    >
  >;
  internalAppendS2oPointsToCoOwnersApplication?: Resolver<
    ResolversTypes["InternalAppendS2oPointsToCoOwnersApplicationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalAppendS2oPointsToCoOwnersApplicationArgs,
      "amount" | "coOwnersApplicationId"
    >
  >;
  internalApplyGuestAccessKey?: Resolver<
    ResolversTypes["InternalApplyGuestAccessKeyPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalApplyGuestAccessKeyArgs,
      "reservationId" | "triggerType"
    >
  >;
  internalApplyStaffAccessKey?: Resolver<
    ResolversTypes["InternalApplyStaffAccessKeyPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalApplyStaffAccessKeyArgs,
      "keyType" | "triggerType"
    >
  >;
  internalAssignAccessCodeToAccommodationReservation?: Resolver<
    ResolversTypes["InternalAssignAccessCodeToAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalAssignAccessCodeToAccommodationReservationArgs,
      "checkStatus" | "reservationId"
    >
  >;
  internalAssignAdminRole?: Resolver<
    ResolversTypes["InternalAssignAdminRolePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalAssignAdminRoleArgs, "input">
  >;
  internalBeds24CreateOrUpdateBlackBooking?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalBeds24CreateOrUpdateBlackBookingArgs,
      "blockId"
    >
  >;
  internalBeds24CreateOrUpdateBlackBookings?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalBeds24CreateOrUpdateBlackBookingsArgs,
      "blockIds"
    >
  >;
  internalBeds24CreateOrUpdateBooking?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalBeds24CreateOrUpdateBookingArgs,
      "reservationId"
    >
  >;
  internalBeds24DeleteBlackBookings?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  internalBeds24ExchangeInviteCode?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalBeds24ExchangeInviteCodeArgs, "inviteCode">
  >;
  internalBeds24ProcessWebhookEvent?: Resolver<
    ResolversTypes["Beds24WebhookResultPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalBeds24ProcessWebhookEventArgs, "event">
  >;
  internalBeds24SendBookingMessage?: Resolver<
    ResolversTypes["Beds24BookingMessageResultPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalBeds24SendBookingMessageArgs,
      "kind" | "reservationId"
    >
  >;
  internalBeds24SendGuestMessageAutoReply?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalBeds24SendGuestMessageAutoReplyArgs,
      "bookingId"
    >
  >;
  internalBeds24SyncFollowingReservations?: Resolver<
    Array<ResolversTypes["Beds24SyncFollowingReservationsResultPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalBeds24SyncFollowingReservationsArgs,
      "leadingReservationId"
    >
  >;
  internalBeds24SyncFuturePrices?: Resolver<
    ResolversTypes["InternalBeds24SyncFuturePricesResult"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalBeds24SyncFuturePricesArgs, "dryRun">
  >;
  internalBulkCreateAccommodationAvailabilityBlocks?: Resolver<
    ResolversTypes["InternalBulkCreateAccommodationAvailabilityBlocksPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalBulkCreateAccommodationAvailabilityBlocksArgs,
      "input" | "skipBeds24CreditCheck"
    >
  >;
  internalBulkCreateOrganizationYearlyContractInvoices?: Resolver<
    ResolversTypes["InternalBulkCreateOrganizationYearlyContractInvoicesPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalBulkCreateOrganizationYearlyContractInvoicesArgs,
      "contractId" | "input"
    >
  >;
  internalBulkDeleteAccommodationAvailabilityBlocks?: Resolver<
    ResolversTypes["InternalBulkDeleteAccommodationAvailabilityBlocksPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalBulkDeleteAccommodationAvailabilityBlocksArgs,
      "ids" | "skipBeds24CreditCheck"
    >
  >;
  internalBulkUpdateSeasonalFeeSettings?: Resolver<
    ResolversTypes["InternalBulkUpdateSeasonalFeeSettingsPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalBulkUpdateSeasonalFeeSettingsArgs, "input">
  >;
  internalBulkUpdateStayTicketMasters?: Resolver<
    ResolversTypes["InternalBulkUpdateStayTicketMastersPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalBulkUpdateStayTicketMastersArgs,
      "dryRun" | "input"
    >
  >;
  internalCancelAccommodationReservation?: Resolver<
    ResolversTypes["CancelAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCancelAccommodationReservationArgs, "id">
  >;
  internalCancelCoOwnersApplication?: Resolver<
    ResolversTypes["InternalCancelCoOwnersApplicationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCancelCoOwnersApplicationArgs, "id">
  >;
  internalCancelFacilityReservation?: Resolver<
    ResolversTypes["CancelFacilityReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCancelFacilityReservationArgs, "id">
  >;
  internalCancelIpBeds24Setup?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  internalChangeAccommodationReservation?: Resolver<
    ResolversTypes["ChangeAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalChangeAccommodationReservationArgs,
      "id" | "input"
    >
  >;
  internalCheckInAccommodationReservation?: Resolver<
    ResolversTypes["CheckInAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCheckInAccommodationReservationArgs,
      "id" | "input"
    >
  >;
  internalConnectBeds24Property?: Resolver<
    ResolversTypes["InternalSite"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalConnectBeds24PropertyArgs,
      "propertyId" | "siteId"
    >
  >;
  internalCreateAccommodationAvailabilityBlockReleaseSchedule?: Resolver<
    ResolversTypes["AccommodationAvailabilityBlockReleaseSchedule"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateAccommodationAvailabilityBlockReleaseScheduleArgs,
      "input"
    >
  >;
  internalCreateAccommodationEquipment?: Resolver<
    ResolversTypes["InternalCreateAccommodationEquipmentPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateAccommodationEquipmentArgs, "input">
  >;
  internalCreateAccommodationOperationGroup?: Resolver<
    ResolversTypes["InternalCreateAccommodationOperationGroupPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateAccommodationOperationGroupArgs,
      "input"
    >
  >;
  internalCreateAccommodationReservation?: Resolver<
    ResolversTypes["CreateAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateAccommodationReservationArgs, "input">
  >;
  internalCreateArchitectureContentImageUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateArchitectureContentImageUploadPolicyArgs,
      "input"
    >
  >;
  internalCreateArea?: Resolver<
    ResolversTypes["InternalArea"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateAreaArgs, "input">
  >;
  internalCreateAreaGuideArticleImageUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType
  >;
  internalCreateAreaImageUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateAreaImageUploadPolicyArgs, "input">
  >;
  internalCreateCoOwnersApplicationFileDownloadUrl?: Resolver<
    ResolversTypes["CreateCoOwnersApplicationFileDownloadUrlPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateCoOwnersApplicationFileDownloadUrlArgs,
      "coOwnersApplicationFileId"
    >
  >;
  internalCreateCoOwnersApplicationFileUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateCoOwnersApplicationFileUploadPolicyArgs,
      "input"
    >
  >;
  internalCreateCoOwnersIdentityVerification?: Resolver<
    ResolversTypes["InternalCreateCoOwnersIdentityVerificationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateCoOwnersIdentityVerificationArgs,
      "coOwnersApplicationId" | "input"
    >
  >;
  internalCreateConsumedSuppliesFeeItems?: Resolver<
    ResolversTypes["InternalCreateConsumedSuppliesFeeItemsPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateConsumedSuppliesFeeItemsArgs, "input">
  >;
  internalCreateFacility?: Resolver<
    ResolversTypes["InternalCreateOrUpdateFacilityPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateFacilityArgs, "input">
  >;
  internalCreateFacilityImageUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateFacilityImageUploadPolicyArgs, "input">
  >;
  internalCreateFacilityReservation?: Resolver<
    ResolversTypes["InternalCreateFacilityReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateFacilityReservationArgs, "input">
  >;
  internalCreateFullOwnerIdentityVerification?: Resolver<
    ResolversTypes["InternalCreateFullOwnerIdentityVerificationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateFullOwnerIdentityVerificationArgs,
      "input" | "ownerPlanId" | "userId"
    >
  >;
  internalCreateLocalTaxPolicy?: Resolver<
    ResolversTypes["InternalCreateLocalTaxPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateLocalTaxPolicyArgs, "input">
  >;
  internalCreateNativeAppHomeContentImageUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType
  >;
  internalCreateOrUpdateAccommodation?: Resolver<
    ResolversTypes["InternalCreateOrUpdateAccommodationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateAccommodationArgs, "input">
  >;
  internalCreateOrUpdateAccommodationContent?: Resolver<
    ResolversTypes["Accommodation"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateAccommodationContentArgs,
      "accommodationId" | "input"
    >
  >;
  internalCreateOrUpdateAccommodationNotice?: Resolver<
    ResolversTypes["InternalCreateOrUpdateAccommodationNoticePayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateAccommodationNoticeArgs,
      "input"
    >
  >;
  internalCreateOrUpdateAdditionalGuestFeePolicy?: Resolver<
    ResolversTypes["InternalCreateOrUpdateAdditionalGuestFeePolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateAdditionalGuestFeePolicyArgs,
      "input"
    >
  >;
  internalCreateOrUpdateArchitectureType?: Resolver<
    ResolversTypes["ArchitectureType"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateArchitectureTypeArgs, "input">
  >;
  internalCreateOrUpdateAreaGuideArticle?: Resolver<
    ResolversTypes["AreaGuideArticle"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateAreaGuideArticleArgs, "input">
  >;
  internalCreateOrUpdateAreaGuideSpot?: Resolver<
    ResolversTypes["AreaGuideSpot"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateAreaGuideSpotArgs, "input">
  >;
  internalCreateOrUpdateBaseAccommodationFeePolicy?: Resolver<
    ResolversTypes["InternalCreateOrUpdateBaseAccommodationFeePolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateBaseAccommodationFeePolicyArgs,
      "input"
    >
  >;
  internalCreateOrUpdateBeds24Property?: Resolver<
    ResolversTypes["InternalSite"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateBeds24PropertyArgs, "siteId">
  >;
  internalCreateOrUpdateBusinessPlan?: Resolver<
    ResolversTypes["InternalCreateOrUpdateBusinessPlanPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateBusinessPlanArgs, "input">
  >;
  internalCreateOrUpdateCancelFeePolicy?: Resolver<
    ResolversTypes["InternalCreateOrUpdateCancelFeePolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateCancelFeePolicyArgs, "input">
  >;
  internalCreateOrUpdateCoOwnersPlanOffering?: Resolver<
    ResolversTypes["InternalCreateOrUpdateCoOwnersPlanOfferingPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateCoOwnersPlanOfferingArgs,
      "input"
    >
  >;
  internalCreateOrUpdateCoOwnersWebinarSchedule?: Resolver<
    ResolversTypes["InternalCreateOrUpdateCoOwnersWebinarSchedulePayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateCoOwnersWebinarScheduleArgs,
      "input"
    >
  >;
  internalCreateOrUpdateContentArchitect?: Resolver<
    ResolversTypes["InternalCreateOrUpdateContentArchitectPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateContentArchitectArgs, "input">
  >;
  internalCreateOrUpdateContentArchitecturalFeature?: Resolver<
    ResolversTypes["InternalCreateOrUpdateContentArchitecturalFeaturePayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateContentArchitecturalFeatureArgs,
      "accommodationFacilityId" | "input"
    >
  >;
  internalCreateOrUpdateContentArchitecturalFeatureUsageRule?: Resolver<
    ResolversTypes["InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateContentArchitecturalFeatureUsageRuleArgs,
      "featureId" | "input"
    >
  >;
  internalCreateOrUpdateContentArchitectureType?: Resolver<
    ResolversTypes["InternalCreateOrUpdateContentArchitectureTypePayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateContentArchitectureTypeArgs,
      "architectureTypeId" | "input"
    >
  >;
  internalCreateOrUpdateContentArchitectureTypeBasicAmenity?: Resolver<
    ResolversTypes["InternalCreateOrUpdateContentBasicAmenityPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateContentArchitectureTypeBasicAmenityArgs,
      "input"
    >
  >;
  internalCreateOrUpdateContentArchitectureTypeVariant?: Resolver<
    ResolversTypes["InternalCreateOrUpdateContentArchitectureTypeVariantPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateContentArchitectureTypeVariantArgs,
      "architectureTypeId" | "input" | "kind"
    >
  >;
  internalCreateOrUpdateContentFacilityAmenity?: Resolver<
    ResolversTypes["InternalCreateOrUpdateContentFacilityAmenityPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateContentFacilityAmenityArgs,
      "input"
    >
  >;
  internalCreateOrUpdateFacilityResourceBlock?: Resolver<
    ResolversTypes["InternalCreateOrUpdateFacilityResourceBlockPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateFacilityResourceBlockArgs,
      "input"
    >
  >;
  internalCreateOrUpdateNativeAppHomeContent?: Resolver<
    ResolversTypes["InternalCreateOrUpdateNativeAppHomeContentPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateNativeAppHomeContentArgs,
      "input"
    >
  >;
  internalCreateOrUpdateNews?: Resolver<
    ResolversTypes["InternalCreateOrUpdateNewsPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateNewsArgs, "input">
  >;
  internalCreateOrUpdateOrganization?: Resolver<
    ResolversTypes["InternalCreateOrUpdateOrganizationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateOrganizationArgs, "input">
  >;
  internalCreateOrUpdateOrganizationYearlyContract?: Resolver<
    ResolversTypes["InternalCreateOrUpdateOrganizationYearlyContractPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateOrganizationYearlyContractArgs,
      "input" | "organizationId"
    >
  >;
  internalCreateOrUpdateOrganizationYearlyContractInvoice?: Resolver<
    ResolversTypes["InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateOrganizationYearlyContractInvoiceArgs,
      "input"
    >
  >;
  internalCreateOrUpdateOwnerPlan?: Resolver<
    ResolversTypes["InternalCreateOrUpdateOwnerPlanPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateOwnerPlanArgs, "input">
  >;
  internalCreateOrUpdateSiteAccessRouteGroup?: Resolver<
    ResolversTypes["SiteAccessRouteGroup"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateSiteAccessRouteGroupArgs,
      "input"
    >
  >;
  internalCreateOrUpdateSiteFaq?: Resolver<
    ResolversTypes["InternalCreateOrUpdateSiteFaqPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateSiteFaqArgs, "input">
  >;
  internalCreateOrUpdateStaffGroup?: Resolver<
    ResolversTypes["InternalCreateOrUpdateStaffGroupPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateStaffGroupArgs, "input">
  >;
  internalCreateOrUpdateStayTicketMaster?: Resolver<
    ResolversTypes["InternalCreateOrUpdateStayTicketMasterPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateStayTicketMasterArgs, "input">
  >;
  internalCreateOrUpdateStayTicketMasterTemplate?: Resolver<
    ResolversTypes["InternalCreateOrUpdateStayTicketMasterTemplatePayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateStayTicketMasterTemplateArgs,
      "input"
    >
  >;
  internalCreateOrUpdateStayTicketTemplate?: Resolver<
    ResolversTypes["InternalCreateStayTicketTemplatePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateStayTicketTemplateArgs, "input">
  >;
  internalCreateOrUpdateSupplyItemInstallations?: Resolver<
    ResolversTypes["InternalCreateOrUpdateSupplyItemInstallationsPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateOrUpdateSupplyItemInstallationsArgs,
      "installations" | "masterId"
    >
  >;
  internalCreateOrUpdateSupplyItemMaster?: Resolver<
    ResolversTypes["InternalCreateOrUpdateSupplyItemMasterPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOrUpdateSupplyItemMasterArgs, "input">
  >;
  internalCreateOtaRoomUnit?: Resolver<
    ResolversTypes["InternalOtaRoomUnit"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateOtaRoomUnitArgs, "input" | "roomTypeId">
  >;
  internalCreateRoomType?: Resolver<
    ResolversTypes["InternalRoomType"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateRoomTypeArgs, "input" | "siteId">
  >;
  internalCreateRoomTypeImageUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateRoomTypeImageUploadPolicyArgs, "input">
  >;
  internalCreateSite?: Resolver<
    ResolversTypes["InternalCreateSitePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateSiteArgs, "areaId" | "input">
  >;
  internalCreateSiteActivityProgram?: Resolver<
    ResolversTypes["InternalCreateOrUpdateSiteActivityProgramPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateSiteActivityProgramArgs, "input">
  >;
  internalCreateSiteActivityProgramImageUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType
  >;
  internalCreateSiteFaqImageUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateSiteFaqImageUploadPolicyArgs, "input">
  >;
  internalCreateSiteHighSeasonPeriod?: Resolver<
    ResolversTypes["SiteHighSeasonPeriod"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateSiteHighSeasonPeriodArgs, "input">
  >;
  internalCreateSiteImageUploadPolicy?: Resolver<
    ResolversTypes["FileUploadPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateSiteImageUploadPolicyArgs, "input">
  >;
  internalCreateTermsRevision?: Resolver<
    ResolversTypes["InternalCreateTermsRevisionPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalCreateTermsRevisionArgs, "input">
  >;
  internalCreateTicketsFromMaster?: Resolver<
    Array<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateTicketsFromMasterArgs,
      "count" | "expiresAt"
    >
  >;
  internalCreateUserOwnership?: Resolver<
    ResolversTypes["UserOwnership"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalCreateUserOwnershipArgs,
      "ownerPlanId" | "startDate" | "units" | "userId"
    >
  >;
  internalDeleteAccommodation?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteAccommodationArgs, "id">
  >;
  internalDeleteAccommodationAvailabilityBlockReleaseSchedule?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalDeleteAccommodationAvailabilityBlockReleaseScheduleArgs,
      "id"
    >
  >;
  internalDeleteAccommodationEquipment?: Resolver<
    ResolversTypes["InternalDeleteAccommodationEquipmentPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteAccommodationEquipmentArgs, "id">
  >;
  internalDeleteAreaGuideArticle?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteAreaGuideArticleArgs, "id">
  >;
  internalDeleteAreaGuideSpot?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteAreaGuideSpotArgs, "id">
  >;
  internalDeleteAuth0User?: Resolver<
    ResolversTypes["InternalUnlinkIdentityPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteAuth0UserArgs, "auth0UserId">
  >;
  internalDeleteCoOwnersApplicationFile?: Resolver<
    ResolversTypes["InternalUpdateCoOwnersApplicationFilePayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalDeleteCoOwnersApplicationFileArgs,
      "coOwnersApplicationFileId"
    >
  >;
  internalDeleteContentArchitect?: Resolver<
    ResolversTypes["InternalDeleteArchitectureContentPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteContentArchitectArgs, "id">
  >;
  internalDeleteContentArchitecturalFeature?: Resolver<
    ResolversTypes["InternalDeleteArchitectureContentPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteContentArchitecturalFeatureArgs, "id">
  >;
  internalDeleteContentArchitecturalFeatureUsageRule?: Resolver<
    ResolversTypes["InternalDeleteArchitectureContentPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalDeleteContentArchitecturalFeatureUsageRuleArgs,
      "id"
    >
  >;
  internalDeleteContentArchitectureTypeBasicAmenity?: Resolver<
    ResolversTypes["InternalDeleteArchitectureContentPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalDeleteContentArchitectureTypeBasicAmenityArgs,
      "id"
    >
  >;
  internalDeleteContentArchitectureTypeVariant?: Resolver<
    ResolversTypes["InternalDeleteArchitectureContentPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalDeleteContentArchitectureTypeVariantArgs,
      "id" | "kind"
    >
  >;
  internalDeleteContentFacilityAmenity?: Resolver<
    ResolversTypes["InternalDeleteArchitectureContentPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteContentFacilityAmenityArgs, "id">
  >;
  internalDeleteFacilityResourceBlock?: Resolver<
    ResolversTypes["InternalDeleteFacilityResourceBlockPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteFacilityResourceBlockArgs, "id">
  >;
  internalDeleteLocalTaxPolicy?: Resolver<
    ResolversTypes["InternalDeleteLocalTaxPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteLocalTaxPolicyArgs, "id">
  >;
  internalDeleteOtaRoomUnit?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteOtaRoomUnitArgs, "id">
  >;
  internalDeleteRoomType?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteRoomTypeArgs, "id">
  >;
  internalDeleteSiteAccessRouteGroup?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteSiteAccessRouteGroupArgs, "id">
  >;
  internalDeleteSiteActivityProgram?: Resolver<
    ResolversTypes["Success"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteSiteActivityProgramArgs, "id">
  >;
  internalDeleteSiteFaq?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteSiteFaqArgs, "id">
  >;
  internalDeleteSiteHighSeasonPeriod?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteSiteHighSeasonPeriodArgs, "id">
  >;
  internalDeleteSupplyItemInstallation?: Resolver<
    ResolversTypes["InternalDeleteSupplyItemInstallationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteSupplyItemInstallationArgs, "id">
  >;
  internalDeleteSupplyItemMaster?: Resolver<
    ResolversTypes["InternalDeleteSupplyItemMasterPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalDeleteSupplyItemMasterArgs, "id">
  >;
  internalEnqueueBeds24DeleteBlackBookings?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  internalExecuteRetoolWorkflow?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalExecuteRetoolWorkflowArgs,
      "event" | "payload"
    >
  >;
  internalFinalizeOrganizationYearlyContractInvoice?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalFinalizeOrganizationYearlyContractInvoiceArgs,
      "invoiceId"
    >
  >;
  internalGrantNightsToOwnerFirstYear?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalGrantNightsToOwnerFirstYearArgs,
      "ownershipId" | "year"
    >
  >;
  internalGrantTestS2oPoints?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalGrantTestS2oPointsArgs,
      "amount" | "months" | "userId"
    >
  >;
  internalHubSpotSyncContact?: Resolver<
    ResolversTypes["HubSpotSyncContactResult"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalHubSpotSyncContactArgs, "userId">
  >;
  internalHubSpotSyncDeal?: Resolver<
    ResolversTypes["HubSpotSyncDealResult"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalHubSpotSyncDealArgs, "coOwnersApplicationId">
  >;
  internalInvalidateOrganizationYearlyContract?: Resolver<
    ResolversTypes["InternalInvalidateOrganizationYearlyContractPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalInvalidateOrganizationYearlyContractArgs,
      "contractId"
    >
  >;
  internalInvalidateOrganizationYearlyContractInvoice?: Resolver<
    ResolversTypes["InternalInvalidateOrganizationYearlyContractInvoicePayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalInvalidateOrganizationYearlyContractInvoiceArgs,
      "invoiceId"
    >
  >;
  internalInvalidateS2oPoints?: Resolver<
    ResolversTypes["InternalInvalidateS2oPointsPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalInvalidateS2oPointsArgs, "input">
  >;
  internalInvalidateStayTicketsByCode?: Resolver<
    ResolversTypes["InternalInvalidateStayTicketsByCodeResult"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalInvalidateStayTicketsByCodeArgs, "codes">
  >;
  internalIpBeds24SetupStep?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalIpBeds24SetupStepArgs, "state">
  >;
  internalIssueS2oPoints?: Resolver<
    ResolversTypes["InternalIssueS2oPointsPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalIssueS2oPointsArgs, "input">
  >;
  internalJoinOrganization?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalJoinOrganizationArgs,
      "organizationId" | "role" | "userEmail"
    >
  >;
  internalJtasCreateOrUpdateInspectionStatuses?: Resolver<
    ResolversTypes["InternalJtasCreateOrUpdateInspectionStatusesPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalJtasCreateOrUpdateInspectionStatusesArgs,
      "input"
    >
  >;
  internalJtasCreateOrUpdateSupplyReport?: Resolver<
    ResolversTypes["InternalJtasCreateOrUpdateSupplyReportPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalJtasCreateOrUpdateSupplyReportArgs, "input">
  >;
  internalJtasCreateOrUpdateViolationReport?: Resolver<
    ResolversTypes["InternalJtasCreateOrUpdateViolationReportPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalJtasCreateOrUpdateViolationReportArgs,
      "input"
    >
  >;
  internalJtasDeleteViolationReport?: Resolver<
    ResolversTypes["InternalJtasDeleteViolationReportPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalJtasDeleteViolationReportArgs, "input">
  >;
  internalLeaveOrganization?: Resolver<
    ResolversTypes["InternalLeaveOrganizationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalLeaveOrganizationArgs,
      "organizationId" | "userEmail"
    >
  >;
  internalMarkCoOwnersApplicationPlannedForSale?: Resolver<
    ResolversTypes["InternalMarkCoOwnersApplicationPlannedForSalePayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalMarkCoOwnersApplicationPlannedForSaleArgs,
      "id" | "saleYearMonth" | "units"
    >
  >;
  internalMarkCoOwnersApplicationSold?: Resolver<
    ResolversTypes["InternalMarkCoOwnersApplicationSoldPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalMarkCoOwnersApplicationSoldArgs, "id">
  >;
  internalPartialUpdateOrganization?: Resolver<
    ResolversTypes["InternalPartialUpdateOrganizationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalPartialUpdateOrganizationArgs,
      "input" | "organizationId"
    >
  >;
  internalPartialUpdateUserSystemSettings?: Resolver<
    ResolversTypes["User"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalPartialUpdateUserSystemSettingsArgs,
      "input" | "userId"
    >
  >;
  internalRegisterCoOwnersApplicationFile?: Resolver<
    ResolversTypes["RegisterCoOwnersApplicationFilePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalRegisterCoOwnersApplicationFileArgs, "input">
  >;
  internalReleaseAccessKey?: Resolver<
    ResolversTypes["InternalReleaseAccessKeyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalReleaseAccessKeyArgs, "accessPersonId">
  >;
  internalReleaseAvailabilitesFromCanceledReservations?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  internalReleaseStayTicketsFromTentativeReservation?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalReleaseStayTicketsFromTentativeReservationArgs,
      "unitId"
    >
  >;
  internalRemoveLocalTaxPolicy?: Resolver<
    ResolversTypes["InternalRemoveLocalTaxPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalRemoveLocalTaxPolicyArgs,
      "policyId" | "target"
    >
  >;
  internalRemoveStripeSubscriptionPaymentMethod?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalRemoveStripeSubscriptionPaymentMethodArgs,
      "subscriptionId"
    >
  >;
  internalReorderAccommodations?: Resolver<
    Array<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType,
    RequireFields<MutationinternalReorderAccommodationsArgs, "input">
  >;
  internalReorderAreaGuideArticles?: Resolver<
    Array<ResolversTypes["AreaGuideArticle"]>,
    ParentType,
    ContextType,
    RequireFields<MutationinternalReorderAreaGuideArticlesArgs, "input">
  >;
  internalReorderAreaGuideSpots?: Resolver<
    Array<ResolversTypes["AreaGuideSpot"]>,
    ParentType,
    ContextType,
    RequireFields<MutationinternalReorderAreaGuideSpotsArgs, "input">
  >;
  internalReorderAreas?: Resolver<
    Array<ResolversTypes["Area"]>,
    ParentType,
    ContextType,
    RequireFields<MutationinternalReorderAreasArgs, "input">
  >;
  internalReorderContentArchitecturalFeatureUsageRules?: Resolver<
    Array<ResolversTypes["ContentArchitecturalFeatureUsageRule"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalReorderContentArchitecturalFeatureUsageRulesArgs,
      "input"
    >
  >;
  internalReorderContentArchitectureTypeBasicAmenities?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeBasicAmenity"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalReorderContentArchitectureTypeBasicAmenitiesArgs,
      "input"
    >
  >;
  internalReorderContentArchitectureTypes?: Resolver<
    Array<ResolversTypes["ContentArchitectureType"]>,
    ParentType,
    ContextType,
    RequireFields<MutationinternalReorderContentArchitectureTypesArgs, "input">
  >;
  internalReorderSiteAccessRouteGroups?: Resolver<
    Array<ResolversTypes["SiteAccessRouteGroup"]>,
    ParentType,
    ContextType,
    RequireFields<MutationinternalReorderSiteAccessRouteGroupsArgs, "input">
  >;
  internalReorderSiteFaqs?: Resolver<
    Array<ResolversTypes["RawSiteFaq"]>,
    ParentType,
    ContextType,
    RequireFields<MutationinternalReorderSiteFaqsArgs, "input">
  >;
  internalReorderSites?: Resolver<
    Array<ResolversTypes["Site"]>,
    ParentType,
    ContextType,
    RequireFields<MutationinternalReorderSitesArgs, "input">
  >;
  internalResetTentativeReservationUser?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalResetTentativeReservationUserArgs,
      "reservationId"
    >
  >;
  internalRevokeAdminRole?: Resolver<
    ResolversTypes["InternalRevokeAdminRolePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalRevokeAdminRoleArgs, "id">
  >;
  internalRunOneShotScript?: Resolver<
    ResolversTypes["InternalRunOneShotScriptResult"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalRunOneShotScriptArgs, "input">
  >;
  internalScheduleStandardSubscriptionTermination?: Resolver<
    ResolversTypes["ScheduleStandardSubscriptionTerminationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalScheduleStandardSubscriptionTerminationArgs,
      "afterIterations" | "targetUserId"
    >
  >;
  internalScheduledReleaseReservationBlocks?: Resolver<
    Array<ResolversTypes["String"]>,
    ParentType,
    ContextType,
    Partial<MutationinternalScheduledReleaseReservationBlocksArgs>
  >;
  internalSendCoOwnersIdentityVerificationRequest?: Resolver<
    ResolversTypes["Success"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalSendCoOwnersIdentityVerificationRequestArgs,
      "coOwnersApplicationId"
    >
  >;
  internalSendPushNotifications?: Resolver<
    ResolversTypes["InternalSendPushNotificationsPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalSendPushNotificationsArgs, "input">
  >;
  internalSendTestSms?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType,
    RequireFields<MutationinternalSendTestSmsArgs, "phoneNumber">
  >;
  internalStartIpBeds24Setup?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    Partial<MutationinternalStartIpBeds24SetupArgs>
  >;
  internalStartStaffPlan?: Resolver<
    ResolversTypes["InternalStartStaffPlanResult"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalStartStaffPlanArgs,
      "initialNights" | "staffType" | "startSemester" | "startYear" | "userId"
    >
  >;
  internalStopStaffPlan?: Resolver<
    ResolversTypes["InternalStopStaffPlanResult"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalStopStaffPlanArgs, "userId">
  >;
  internalSyncAllBeds24Rooms?: Resolver<
    ResolversTypes["InternalSite"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalSyncAllBeds24RoomsArgs, "siteId">
  >;
  internalSyncBeds24RoomQty?: Resolver<
    ResolversTypes["InternalRoomType"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalSyncBeds24RoomQtyArgs, "roomTypeId">
  >;
  internalUnlinkAuth0Identity?: Resolver<
    ResolversTypes["InternalUnlinkIdentityPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUnlinkAuth0IdentityArgs,
      "primaryAuth0UserId" | "provider" | "providerUserId"
    >
  >;
  internalUnlinkIdentity?: Resolver<
    ResolversTypes["InternalUnlinkIdentityPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUnlinkIdentityArgs, "provider" | "userId">
  >;
  internalUpdateAccommodationAvailabilityBlockReleaseSchedule?: Resolver<
    ResolversTypes["AccommodationAvailabilityBlockReleaseSchedule"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateAccommodationAvailabilityBlockReleaseScheduleArgs,
      "id" | "input"
    >
  >;
  internalUpdateAccommodationEquipment?: Resolver<
    ResolversTypes["InternalUpdateAccommodationEquipmentPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateAccommodationEquipmentArgs,
      "id" | "input"
    >
  >;
  internalUpdateAccommodationOperationGroupSetting?: Resolver<
    ResolversTypes["InternalUpdateAccommodationOperationGroupSettingPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateAccommodationOperationGroupSettingArgs,
      "id" | "input"
    >
  >;
  internalUpdateArea?: Resolver<
    ResolversTypes["InternalUpdateAreaPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateAreaArgs, "id" | "input">
  >;
  internalUpdateAreaContent?: Resolver<
    ResolversTypes["InternalArea"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateAreaContentArgs, "areaId" | "input">
  >;
  internalUpdateCoOwnersApplicationDetail?: Resolver<
    ResolversTypes["InternalUpdateCoOwnersApplicationDetailPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateCoOwnersApplicationDetailArgs,
      "id" | "input"
    >
  >;
  internalUpdateCoOwnersApplicationFileVisibility?: Resolver<
    ResolversTypes["InternalUpdateCoOwnersApplicationFilePayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateCoOwnersApplicationFileVisibilityArgs,
      "coOwnersApplicationFileId" | "visibleToApplicant"
    >
  >;
  internalUpdateCoOwnersApplicationInfo?: Resolver<
    ResolversTypes["InternalUpdateCoOwnersApplicationInfoPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateCoOwnersApplicationInfoArgs,
      "id" | "input"
    >
  >;
  internalUpdateCoOwnersApplicationStatus?: Resolver<
    ResolversTypes["InternalUpdateCoOwnersApplicationStatusPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateCoOwnersApplicationStatusArgs,
      "id" | "input"
    >
  >;
  internalUpdateFacility?: Resolver<
    ResolversTypes["InternalCreateOrUpdateFacilityPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateFacilityArgs, "input">
  >;
  internalUpdateFacilityContentImages?: Resolver<
    ResolversTypes["InternalUpdateFacilityContentImagesPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateFacilityContentImagesArgs,
      "facilityId" | "input"
    >
  >;
  internalUpdateFacilityReservation?: Resolver<
    ResolversTypes["UpdateFacilityReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateFacilityReservationArgs, "input">
  >;
  internalUpdateFacilityReservationCleaning?: Resolver<
    ResolversTypes["InternalUpdateFacilityReservationCleaningPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateFacilityReservationCleaningArgs,
      "reservationId" | "status"
    >
  >;
  internalUpdateFacilityReservationDataSync?: Resolver<
    ResolversTypes["InternalUpdateFacilityReservationDataSyncPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateFacilityReservationDataSyncArgs,
      "reservationId" | "status"
    >
  >;
  internalUpdateIdentityVerification?: Resolver<
    ResolversTypes["InternalUpdateIdentityVerificationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateIdentityVerificationArgs,
      "id" | "input"
    >
  >;
  internalUpdateIndividualTermsDocument?: Resolver<
    ResolversTypes["InternalUpdateIndividualTermsDocumentPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateIndividualTermsDocumentArgs,
      "id" | "input"
    >
  >;
  internalUpdateInspectionViolationHandling?: Resolver<
    ResolversTypes["InternalUpdateInspectionViolationHandlingPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateInspectionViolationHandlingArgs,
      "input"
    >
  >;
  internalUpdateLocalTaxPolicy?: Resolver<
    ResolversTypes["InternalUpdateLocalTaxPolicyPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateLocalTaxPolicyArgs, "id" | "input">
  >;
  internalUpdateRoomType?: Resolver<
    ResolversTypes["InternalRoomType"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateRoomTypeArgs, "id" | "input">
  >;
  internalUpdateRoomTypeContent?: Resolver<
    ResolversTypes["InternalContentRoomType"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateRoomTypeContentArgs,
      "input" | "roomTypeId"
    >
  >;
  internalUpdateSite?: Resolver<
    ResolversTypes["InternalUpdateSitePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateSiteArgs, "id" | "input">
  >;
  internalUpdateSiteActivityProgram?: Resolver<
    ResolversTypes["InternalCreateOrUpdateSiteActivityProgramPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateSiteActivityProgramArgs, "id" | "input">
  >;
  internalUpdateSiteContent?: Resolver<
    ResolversTypes["InternalSite"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateSiteContentArgs, "input" | "siteId">
  >;
  internalUpdateSiteHighSeasonPeriod?: Resolver<
    ResolversTypes["SiteHighSeasonPeriod"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpdateSiteHighSeasonPeriodArgs,
      "id" | "input"
    >
  >;
  internalUpdateSiteImages?: Resolver<
    ResolversTypes["InternalUpdateSiteImagesPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateSiteImagesArgs, "input" | "siteId">
  >;
  internalUpdateSiteParameters?: Resolver<
    ResolversTypes["InternalUpdateSiteParametersPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateSiteParametersArgs, "input" | "siteId">
  >;
  internalUpdateStayTicket?: Resolver<
    ResolversTypes["InternalUpdateStayTicketPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateStayTicketArgs, "id" | "input">
  >;
  internalUpdateUser?: Resolver<
    ResolversTypes["User"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalUpdateUserArgs, "id" | "input">
  >;
  internalUpsertBaseAccommodationFeeDailyRates?: Resolver<
    ResolversTypes["InternalUpsertBaseAccommodationFeeDailyRatesPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpsertBaseAccommodationFeeDailyRatesArgs,
      "input" | "target"
    >
  >;
  internalUpsertConsumedSupplyFeeItemWaivers?: Resolver<
    ResolversTypes["InternalUpsertConsumedSupplyFeeItemWaiversPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationinternalUpsertConsumedSupplyFeeItemWaiversArgs,
      "input"
    >
  >;
  internalVoidCoOwnersApplication?: Resolver<
    ResolversTypes["InternalVoidCoOwnersApplicationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalVoidCoOwnersApplicationArgs, "id">
  >;
  internalZendeskSyncUser?: Resolver<
    ResolversTypes["ZendeskSyncUserResult"],
    ParentType,
    ContextType,
    RequireFields<MutationinternalZendeskSyncUserArgs, "userId">
  >;
  inviteBusinessMembers?: Resolver<
    ResolversTypes["InviteBusinessMembersPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationinviteBusinessMembersArgs, "input">
  >;
  issueSanuEdgeDeviceAccessToken?: Resolver<
    ResolversTypes["IssueSanuEdgeDeviceAccessTokenPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationissueSanuEdgeDeviceAccessTokenArgs, "input">
  >;
  issueStayTickets?: Resolver<
    ResolversTypes["IssueStayTicketsPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationissueStayTicketsArgs, "input">
  >;
  joinOrganization?: Resolver<
    ResolversTypes["JoinOrganizationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationjoinOrganizationArgs, "organizationId" | "role">
  >;
  leaveOrganization?: Resolver<
    ResolversTypes["leaveOrganizationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationleaveOrganizationArgs, "organizationId" | "userId">
  >;
  leaveOrganizationByViewer?: Resolver<
    ResolversTypes["LeaveOrganizationByViewerPayload"],
    ParentType,
    ContextType
  >;
  loadData?: Resolver<
    ResolversTypes["LoadDataOutput"],
    ParentType,
    ContextType,
    RequireFields<MutationloadDataArgs, "target">
  >;
  partialUpdateOrganization?: Resolver<
    ResolversTypes["PartialUpdateOrganizationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationpartialUpdateOrganizationArgs, "id" | "input">
  >;
  partialUpdateOrganizationMembership?: Resolver<
    ResolversTypes["PartialUpdateOrganizationMembershipPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationpartialUpdateOrganizationMembershipArgs,
      "input" | "organizationId" | "userId"
    >
  >;
  partialUpdateViewerSystemSettings?: Resolver<
    ResolversTypes["User"],
    ParentType,
    ContextType,
    RequireFields<MutationpartialUpdateViewerSystemSettingsArgs, "input">
  >;
  postStayReviewResponse?: Resolver<
    ResolversTypes["PostStayReviewResponsePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationpostStayReviewResponseArgs, "id" | "input">
  >;
  processCronJob?: Resolver<
    ResolversTypes["ProcessCronJobResponse"],
    ParentType,
    ContextType,
    RequireFields<MutationprocessCronJobArgs, "authHeader" | "job">
  >;
  processStripeEvent?: Resolver<
    ResolversTypes["ProcessStripeEventResponse"],
    ParentType,
    ContextType,
    RequireFields<MutationprocessStripeEventArgs, "payload" | "signature">
  >;
  processTrustdockEvent?: Resolver<
    ResolversTypes["ProcessTrustdockEventResponse"],
    ParentType,
    ContextType,
    RequireFields<MutationprocessTrustdockEventArgs, "payload" | "signature">
  >;
  registerCoOwnersApplicationFile?: Resolver<
    ResolversTypes["RegisterCoOwnersApplicationFilePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationregisterCoOwnersApplicationFileArgs, "input">
  >;
  removeIdentity?: Resolver<
    ResolversTypes["RemoveIdentityPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationremoveIdentityArgs, "input">
  >;
  resumeStandardSubscriptionImmediately?: Resolver<
    ResolversTypes["ResumeStandardSubscriptionImmediatelyPayload"],
    ParentType,
    ContextType
  >;
  saveStayReviewV2Draft?: Resolver<
    ResolversTypes["SaveStayReviewV2DraftPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationsaveStayReviewV2DraftArgs,
      "accommodationReservationId" | "input"
    >
  >;
  scheduleStandardSubscriptionPause?: Resolver<
    ResolversTypes["ScheduleStandardSubscriptionPausePayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationscheduleStandardSubscriptionPauseArgs,
      "other" | "pauseDate" | "reason" | "resumeDate"
    >
  >;
  scheduleStandardSubscriptionTermination?: Resolver<
    ResolversTypes["ScheduleStandardSubscriptionTerminationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationscheduleStandardSubscriptionTerminationArgs,
      "questionnaire"
    >
  >;
  selectWebinarSchedule?: Resolver<
    ResolversTypes["SelectWebinarSchedulePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationselectWebinarScheduleArgs, "coOwnersApplicationId">
  >;
  sendEmailToVerifyEmail?: Resolver<
    ResolversTypes["SendEmailToVerifyNewEmailPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationsendEmailToVerifyEmailArgs, "input">
  >;
  sendEmailToVerifyNewEmail?: Resolver<
    ResolversTypes["SendEmailToVerifyNewEmailPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationsendEmailToVerifyNewEmailArgs, "input">
  >;
  sendPasswordResetEmail?: Resolver<
    ResolversTypes["SendPasswordResetEmailPayload"],
    ParentType,
    ContextType
  >;
  submitAdHocQuestionnaireResponse?: Resolver<
    ResolversTypes["SubmitAdHocQuestionnaireResponsePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationsubmitAdHocQuestionnaireResponseArgs, "input">
  >;
  submitCoOwnersApplication?: Resolver<
    ResolversTypes["SubmitCoOwnersApplicationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationsubmitCoOwnersApplicationArgs, "input">
  >;
  submitStayReviewV2?: Resolver<
    ResolversTypes["SubmitStayReviewV2Payload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationsubmitStayReviewV2Args,
      "accommodationReservationId" | "input"
    >
  >;
  updateAccommodationReservationOptions?: Resolver<
    ResolversTypes["UpdateAccommodationReservationOptionsPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationupdateAccommodationReservationOptionsArgs,
      "id" | "input"
    >
  >;
  updateCoOwnersApplicationOwnerInfo?: Resolver<
    ResolversTypes["UpdateCoOwnersApplicationOwnerInfoPayload"],
    ParentType,
    ContextType,
    RequireFields<
      MutationupdateCoOwnersApplicationOwnerInfoArgs,
      "id" | "input"
    >
  >;
  updateFacilityReservation?: Resolver<
    ResolversTypes["UpdateFacilityReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationupdateFacilityReservationArgs, "input">
  >;
  updateUserCompanion?: Resolver<
    ResolversTypes["UserCompanion"],
    ParentType,
    ContextType,
    RequireFields<MutationupdateUserCompanionArgs, "id" | "input">
  >;
  updateViewer?: Resolver<
    ResolversTypes["User"],
    ParentType,
    ContextType,
    RequireFields<MutationupdateViewerArgs, "input">
  >;
  updateViewerMarketingEmailConsent?: Resolver<
    ResolversTypes["User"],
    ParentType,
    ContextType,
    RequireFields<MutationupdateViewerMarketingEmailConsentArgs, "accept">
  >;
  updateViewerName?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType,
    RequireFields<MutationupdateViewerNameArgs, "name">
  >;
  verifyAddIdentityReauth?: Resolver<
    ResolversTypes["VerifyAddIdentityReauthPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationverifyAddIdentityReauthArgs, "input">
  >;
  verifyCheckInQrCode?: Resolver<
    ResolversTypes["VerifyCheckInQrCodePayload"],
    ParentType,
    ContextType,
    RequireFields<MutationverifyCheckInQrCodeArgs, "input">
  >;
  verifyNewEmail?: Resolver<
    ResolversTypes["VerifyNewEmailPayload"],
    ParentType,
    ContextType,
    RequireFields<MutationverifyNewEmailArgs, "input">
  >;
  writeBack?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type NativeAppHomeContentResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["NativeAppHomeContent"] =
    ResolversParentTypes["NativeAppHomeContent"],
> = {
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  imageUrl?: Resolver<ResolversTypes["UploadedFile"], ParentType, ContextType>;
  label?: Resolver<
    Maybe<ResolversTypes["NativeAppHomeContentLabel"]>,
    ParentType,
    ContextType
  >;
  link?: Resolver<
    ResolversTypes["NativeAppHomeContentLink"],
    ParentType,
    ContextType
  >;
  title?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
};

export type NativeAppHomeContentLabelResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["NativeAppHomeContentLabel"] =
    ResolversParentTypes["NativeAppHomeContentLabel"],
> = {
  text?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<
    ResolversTypes["NativeAppHomeContentLabelType"],
    ParentType,
    ContextType
  >;
};

export type NativeAppHomeContentLabelTypeResolvers = EnumResolverSignature<
  { Accent?: any; Default?: any },
  ResolversTypes["NativeAppHomeContentLabelType"]
>;

export type NativeAppHomeContentLinkResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["NativeAppHomeContentLink"] =
    ResolversParentTypes["NativeAppHomeContentLink"],
> = {
  action?: Resolver<
    ResolversTypes["NativeAppHomeContentLinkAction"],
    ParentType,
    ContextType
  >;
  label?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  path?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type NativeAppHomeContentLinkActionResolvers = EnumResolverSignature<
  { DrillDown?: any; ExternalBrowser?: any; FullSheet?: any; Sheet?: any },
  ResolversTypes["NativeAppHomeContentLinkAction"]
>;

export type NativeAppHomeContentStatusResolvers = EnumResolverSignature<
  { Active?: any; Draft?: any; Unpublished?: any },
  ResolversTypes["NativeAppHomeContentStatus"]
>;

export type NewsResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["News"] =
    ResolversParentTypes["News"],
> = {
  content?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  contentType?: Resolver<
    ResolversTypes["NewsContentType"],
    ParentType,
    ContextType
  >;
  displayCategory?: Resolver<
    ResolversTypes["NewsDisplayCategory"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  publishedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewsContentTypeResolvers = EnumResolverSignature<
  { ExternalLink?: any; HTML?: any; InternalPage?: any },
  ResolversTypes["NewsContentType"]
>;

export type NewsDisplayCategoryResolvers = EnumResolverSignature<
  { NewsLetterArticle?: any; Notice?: any; ServiceUpdate?: any },
  ResolversTypes["NewsDisplayCategory"]
>;

export type NewsStatusResolvers = EnumResolverSignature<
  { Active?: any; Draft?: any; Unpublished?: any },
  ResolversTypes["NewsStatus"]
>;

export type OccupancyLimitTargetResolvers = EnumResolverSignature<
  { Guest?: any; Unrestricted?: any },
  ResolversTypes["OccupancyLimitTarget"]
>;

export type OccupancyLimitTargetTypeResolvers = EnumResolverSignature<
  {
    Guest?: any;
    OrganizationMember?: any;
    StandardSubscriber?: any;
    Unrestricted?: any;
  },
  ResolversTypes["OccupancyLimitTargetType"]
>;

export type OneMoreCabinAccommodationReservationProviderResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["OneMoreCabinAccommodationReservationProvider"] =
    ResolversParentTypes["OneMoreCabinAccommodationReservationProvider"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  parentAccommodationReservationId?: Resolver<
    ResolversTypes["ID"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnlineTravelAgentAccommodationReservationProviderResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["OnlineTravelAgentAccommodationReservationProvider"] =
    ResolversParentTypes["OnlineTravelAgentAccommodationReservationProvider"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  isIkyuDiamondMember?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  leadAccommodationReservationId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnsenAccommodationFacilityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OnsenAccommodationFacility"] =
    ResolversParentTypes["OnsenAccommodationFacility"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
};

export type OnsenAndSaunaDoorLockResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OnsenAndSaunaDoorLock"] =
    ResolversParentTypes["OnsenAndSaunaDoorLock"],
> = {
  pinCode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Organization"] =
    ResolversParentTypes["Organization"],
> = {
  announcementContent?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  assignedUser?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType
  >;
  billingEmail?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  bubbleId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  contract?: Resolver<
    ResolversTypes["OrganizationYearlyContract"],
    ParentType,
    ContextType,
    RequireFields<OrganizationcontractArgs, "id">
  >;
  contracts?: Resolver<
    Array<ResolversTypes["OrganizationYearlyContract"]>,
    ParentType,
    ContextType
  >;
  control?: Resolver<
    ResolversTypes["OrganizationControl"],
    ParentType,
    ContextType
  >;
  currentContract?: Resolver<
    Maybe<ResolversTypes["OrganizationYearlyContract"]>,
    ParentType,
    ContextType
  >;
  currentOrUpcomingContract?: Resolver<
    Maybe<ResolversTypes["OrganizationYearlyContract"]>,
    ParentType,
    ContextType
  >;
  defaultFrequency?: Resolver<
    Maybe<ResolversTypes["OrganizationYearlyContractInvoiceFrequency"]>,
    ParentType,
    ContextType
  >;
  defaultPaymentMethod?: Resolver<
    Maybe<ResolversTypes["OrganizationYearlyContractInvoicePaymentMethodType"]>,
    ParentType,
    ContextType
  >;
  displayName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  emailDomainsForMember?: Resolver<
    Maybe<Array<ResolversTypes["String"]>>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  invitationCode?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  memberCustomField?: Resolver<
    ResolversTypes["OrganizationMemberCustomField"],
    ParentType,
    ContextType
  >;
  members?: Resolver<
    Array<ResolversTypes["User"]>,
    ParentType,
    ContextType,
    Partial<OrganizationmembersArgs>
  >;
  membersStay?: Resolver<
    ResolversTypes["OrganizationMembersStay"],
    ParentType,
    ContextType
  >;
  memberships?: Resolver<
    Array<ResolversTypes["OrganizationMembership"]>,
    ParentType,
    ContextType,
    Partial<OrganizationmembershipsArgs>
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  onboardingInfo?: Resolver<
    Maybe<ResolversTypes["OrganizationOnboardingInfo"]>,
    ParentType,
    ContextType
  >;
  paymentMethodCardEnabled?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  stripe?: Resolver<ResolversTypes["StripeCustomer"], ParentType, ContextType>;
  suspended?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationControlResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OrganizationControl"] =
    ResolversParentTypes["OrganizationControl"],
> = {
  maxNightsPerMember?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  maxNightsPerMonth?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  maxNightsPerStay?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
};

export type OrganizationMemberCustomFieldResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OrganizationMemberCustomField"] =
    ResolversParentTypes["OrganizationMemberCustomField"],
> = {
  enabled?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  placeholder?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  required?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
};

export type OrganizationMemberNewReservationStatusResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["OrganizationMemberNewReservationStatus"] =
    ResolversParentTypes["OrganizationMemberNewReservationStatus"],
> = {
  holdMaxInTotal?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  latestMonthlyReservationStatuses?: Resolver<
    Array<ResolversTypes["OrganizationMonthlyReservationStatus"]>,
    ParentType,
    ContextType
  >;
  latestYearlyReservationStatuses?: Resolver<
    Array<ResolversTypes["OrganizationYearlyReservationStatus"]>,
    ParentType,
    ContextType
  >;
  maxNightsPerStay?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  suspended?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
};

export type OrganizationMemberPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OrganizationMemberPayload"] =
    ResolversParentTypes["OrganizationMemberPayload"],
> = {
  myself?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  user?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
};

export type OrganizationMemberReservationStatusResolvers =
  EnumResolverSignature<
    { NotUsable?: any; Usable?: any },
    ResolversTypes["OrganizationMemberReservationStatus"]
  >;

export type OrganizationMembersStayResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OrganizationMembersStay"] =
    ResolversParentTypes["OrganizationMembersStay"],
> = {
  monthlyConsumedNights?: Resolver<
    Array<ResolversTypes["OrganizationPlanMonthlyConsumedNights"]>,
    ParentType,
    ContextType
  >;
  reservations?: Resolver<
    Array<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType,
    RequireFields<
      OrganizationMembersStayreservationsArgs,
      "excludeCancel" | "month"
    >
  >;
  reservationsForExport?: Resolver<
    Array<ResolversTypes["ReservationExportItem"]>,
    ParentType,
    ContextType
  >;
  usedNightsInCurrentContract?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
};

export type OrganizationMembershipResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OrganizationMembership"] =
    ResolversParentTypes["OrganizationMembership"],
> = {
  customFieldValue?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  organization?: Resolver<
    ResolversTypes["Organization"],
    ParentType,
    ContextType
  >;
  reservationNewStatus?: Resolver<
    ResolversTypes["OrganizationMemberNewReservationStatus"],
    ParentType,
    ContextType
  >;
  reservationStatus?: Resolver<
    ResolversTypes["OrganizationMemberReservationStatus"],
    ParentType,
    ContextType
  >;
  role?: Resolver<ResolversTypes["OrganizationRole"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationMonthlyReservationStatusResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["OrganizationMonthlyReservationStatus"] =
    ResolversParentTypes["OrganizationMonthlyReservationStatus"],
> = {
  alreadyHold?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isContracted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  remainingNights?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  yearMonth?: Resolver<
    ResolversTypes["PlainYearMonth"],
    ParentType,
    ContextType
  >;
  yearlyReservationStatus?: Resolver<
    Maybe<ResolversTypes["OrganizationYearlyReservationStatus"]>,
    ParentType,
    ContextType
  >;
};

export type OrganizationOnboardingInfoResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OrganizationOnboardingInfo"] =
    ResolversParentTypes["OrganizationOnboardingInfo"],
> = {
  feePerNights?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  isPeakDayFeeFree?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  maxNightsPerStay?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  nightsPerYear?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type OrganizationPlanMonthlyConsumedNightsResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["OrganizationPlanMonthlyConsumedNights"] =
    ResolversParentTypes["OrganizationPlanMonthlyConsumedNights"],
> = {
  nights?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  yearMonth?: Resolver<
    ResolversTypes["PlainYearMonth"],
    ParentType,
    ContextType
  >;
};

export type OrganizationRoleResolvers = EnumResolverSignature<
  { Admin?: any; Member?: any },
  ResolversTypes["OrganizationRole"]
>;

export type OrganizationYearlyContractResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OrganizationYearlyContract"] =
    ResolversParentTypes["OrganizationYearlyContract"],
> = {
  accommodationReservations?: Resolver<
    Array<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType
  >;
  amountRecord?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  businessPlan?: Resolver<
    ResolversTypes["BusinessPlan"],
    ParentType,
    ContextType
  >;
  continuationType?: Resolver<
    ResolversTypes["ContractContinuationType"],
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  createdInvoiceCount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  endMonth?: Resolver<
    ResolversTypes["PlainYearMonth"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  invalidatedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  isCurrent?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isInvalidated?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  nextEndMonth?: Resolver<
    Maybe<ResolversTypes["PlainYearMonth"]>,
    ParentType,
    ContextType
  >;
  nextStartMonth?: Resolver<
    Maybe<ResolversTypes["PlainYearMonth"]>,
    ParentType,
    ContextType
  >;
  nightsPerMonth?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  nightsPerYear?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  organization?: Resolver<
    ResolversTypes["Organization"],
    ParentType,
    ContextType
  >;
  remainingNightsPerYear?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  scheduledNightsPerYear?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  startMonth?: Resolver<
    ResolversTypes["PlainYearMonth"],
    ParentType,
    ContextType
  >;
  status?: Resolver<ResolversTypes["ContractStatus"], ParentType, ContextType>;
  totalFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  usedNightsPerYear?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationYearlyContractInvoiceFrequencyResolvers =
  EnumResolverSignature<
    { Monthly?: any; Yearly?: any },
    ResolversTypes["OrganizationYearlyContractInvoiceFrequency"]
  >;

export type OrganizationYearlyContractInvoicePaymentMethodTypeResolvers =
  EnumResolverSignature<
    { BankTransfer?: any; CreditCard?: any },
    ResolversTypes["OrganizationYearlyContractInvoicePaymentMethodType"]
  >;

export type OrganizationYearlyContractInvoicesResultResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["OrganizationYearlyContractInvoicesResult"] =
    ResolversParentTypes["OrganizationYearlyContractInvoicesResult"],
> = {
  count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  data?: Resolver<
    Array<ResolversTypes["StripeInvoice"]>,
    ParentType,
    ContextType
  >;
  hasMore?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  nextCursor?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
};

export type OrganizationYearlyContractSortFieldResolvers =
  EnumResolverSignature<
    {
      ContinuationType?: any;
      CreatedAt?: any;
      EndMonth?: any;
      OrganizationName?: any;
      StartMonth?: any;
      Status?: any;
    },
    ResolversTypes["OrganizationYearlyContractSortField"]
  >;

export type OrganizationYearlyContractsResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OrganizationYearlyContractsResult"] =
    ResolversParentTypes["OrganizationYearlyContractsResult"],
> = {
  count?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  data?: Resolver<
    Array<ResolversTypes["OrganizationYearlyContract"]>,
    ParentType,
    ContextType
  >;
  hasMore?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  nextCursor?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
};

export type OrganizationYearlyReservationStatusResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["OrganizationYearlyReservationStatus"] =
    ResolversParentTypes["OrganizationYearlyReservationStatus"],
> = {
  endYearMonth?: Resolver<
    ResolversTypes["PlainYearMonth"],
    ParentType,
    ContextType
  >;
  maxNights?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  remainingNights?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  startYearMonth?: Resolver<
    ResolversTypes["PlainYearMonth"],
    ParentType,
    ContextType
  >;
};

export type OtaReservationLookupErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OtaReservationLookupError"] =
    ResolversParentTypes["OtaReservationLookupError"],
> = {
  case?: Resolver<
    ResolversTypes["OtaReservationLookupErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OtaReservationLookupErrorCaseResolvers = EnumResolverSignature<
  { AlreadyRegistered?: any },
  ResolversTypes["OtaReservationLookupErrorCase"]
>;

export type OtaReservationLookupResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OtaReservationLookupResult"] =
    ResolversParentTypes["OtaReservationLookupResult"],
> = {
  __resolveType?: TypeResolveFn<
    "OtaReservationLookupError" | "OtaReservationLookupSuccess",
    ParentType,
    ContextType
  >;
};

export type OtaReservationLookupSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OtaReservationLookupSuccess"] =
    ResolversParentTypes["OtaReservationLookupSuccess"],
> = {
  architectureTypeName?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  facilityTypes?: Resolver<
    Array<ResolversTypes["AccommodationFacilityType"]>,
    ParentType,
    ContextType
  >;
  firstDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  lastDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  preRegistrationUrl?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  siteName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OwnerIntendedUsageTypeResolvers = EnumResolverSignature<
  {
    LongVacation?: any;
    MainlyWeekdays?: any;
    MainlyWeekends?: any;
    WeekdaysOnly?: any;
    WeekendsOnly?: any;
  },
  ResolversTypes["OwnerIntendedUsageType"]
>;

export type OwnerOrganizationBeneficialOwnerRelationshipTypeResolvers =
  EnumResolverSignature<
    { Creditor?: any; Other?: any; Representative?: any; Shareholder?: any },
    ResolversTypes["OwnerOrganizationBeneficialOwnerRelationshipType"]
  >;

export type OwnerOrganizationBusinessActivityTypeResolvers =
  EnumResolverSignature<
    {
      Construction?: any;
      FinanceInsurance?: any;
      Manufacturing?: any;
      Other?: any;
      RealEstate?: any;
      Service?: any;
      Transportation?: any;
      WholesaleRetail?: any;
    },
    ResolversTypes["OwnerOrganizationBusinessActivityType"]
  >;

export type OwnerOrganizationRelationshipTypeResolvers = EnumResolverSignature<
  { Representative?: any; TransactionManager?: any },
  ResolversTypes["OwnerOrganizationRelationshipType"]
>;

export type OwnerPlanResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["OwnerPlan"] =
    ResolversParentTypes["OwnerPlan"],
> = {
  accommodation?: Resolver<
    Maybe<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType
  >;
  accommodationFacilities?: Resolver<
    Array<ResolversTypes["AccommodationFacility"]>,
    ParentType,
    ContextType
  >;
  advancePaymentRequired?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  architectureType?: Resolver<
    Maybe<ResolversTypes["ArchitectureType"]>,
    ParentType,
    ContextType
  >;
  balconySizeSqm?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  baseAccommodationFeePerNight?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  coOwnersMaxConcurrentReservationsPerUnit?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  coOwnersMaxPeakDaysPerUnit?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  coOwnersPlanOfferings?: Resolver<
    Array<ResolversTypes["CoOwnersPlanOffering"]>,
    ParentType,
    ContextType,
    RequireFields<OwnerPlancoOwnersPlanOfferingsArgs, "earlyAccessCode">
  >;
  dogFriendlyFilter?: Resolver<
    Maybe<ResolversTypes["AccommodationFacilityFilterType"]>,
    ParentType,
    ContextType
  >;
  formOfRights?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  fullOwnerContract?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  guestRoomSizeSqm?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  handoverStartDate?: Resolver<
    Maybe<ResolversTypes["PlainYearMonth"]>,
    ParentType,
    ContextType
  >;
  heldAccommodationClass?: Resolver<
    Maybe<ResolversTypes["AccommodationClass"]>,
    ParentType,
    ContextType,
    Partial<OwnerPlanheldAccommodationClassArgs>
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  internalCoOwnersPlanOfferings?: Resolver<
    Array<ResolversTypes["CoOwnersPlanOffering"]>,
    ParentType,
    ContextType
  >;
  leasedLandSizeSqm?: Resolver<
    ResolversTypes["Float"],
    ParentType,
    ContextType
  >;
  limitPeakDays?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  managedName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  nonOwnedBaseAccommodationFeePerNight?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  registrationFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  site?: Resolver<ResolversTypes["Site"], ParentType, ContextType>;
  siteSizeSqm?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  totalUnits?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["OwnerPlanType"], ParentType, ContextType>;
  unitAnnualFireInsuranceFee?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  unitAnnualLandRentFee?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  unitAnnualMaintenanceFee?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  unitAnnualOnsenFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  unitAnnualPropertyTax?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  unitAnnualRepairReserve?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  unitApplicationFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  unitBuildingFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  unitNightsPerYear?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  unitPurchaseAmount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OwnerPlanTypeResolvers = EnumResolverSignature<
  { CoOwners?: any; FullOwner?: any },
  ResolversTypes["OwnerPlanType"]
>;

export type OwnerPurchasePurposeTypeResolvers = EnumResolverSignature<
  { Other?: any; SelfUse?: any },
  ResolversTypes["OwnerPurchasePurposeType"]
>;

export type PartialUpdateOrganizationErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["PartialUpdateOrganizationError"] =
    ResolversParentTypes["PartialUpdateOrganizationError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartialUpdateOrganizationMembershipErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["PartialUpdateOrganizationMembershipError"] =
    ResolversParentTypes["PartialUpdateOrganizationMembershipError"],
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PartialUpdateOrganizationMembershipPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["PartialUpdateOrganizationMembershipPayload"] =
    ResolversParentTypes["PartialUpdateOrganizationMembershipPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "OrganizationMembership" | "PartialUpdateOrganizationMembershipError",
    ParentType,
    ContextType
  >;
};

export type PartialUpdateOrganizationPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["PartialUpdateOrganizationPayload"] =
    ResolversParentTypes["PartialUpdateOrganizationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "Organization" | "PartialUpdateOrganizationError",
    ParentType,
    ContextType
  >;
};

export type PaymentMethodTypeResolvers = EnumResolverSignature<
  { BankTransfer?: any; Card?: any },
  ResolversTypes["PaymentMethodType"]
>;

export interface PlainDateScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes["PlainDate"],
  any
> {
  name: "PlainDate";
}

export interface PlainDateTimeScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes["PlainDateTime"],
  any
> {
  name: "PlainDateTime";
}

export interface PlainYearMonthScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes["PlainYearMonth"],
  any
> {
  name: "PlainYearMonth";
}

export type PlugDeviceResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["PlugDevice"] =
    ResolversParentTypes["PlugDevice"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  lastChangedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes["PlugDeviceStatus"],
    ParentType,
    ContextType
  >;
};

export type PlugDeviceStatusResolvers = EnumResolverSignature<
  { Available?: any; InUse?: any; Unknown?: any },
  ResolversTypes["PlugDeviceStatus"]
>;

export type PostStayReviewResponseErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["PostStayReviewResponseError"] =
    ResolversParentTypes["PostStayReviewResponseError"],
> = {
  case?: Resolver<
    ResolversTypes["PostStayReviewResponseErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostStayReviewResponseErrorCaseResolvers = EnumResolverSignature<
  { NotAuthorized?: any; QuestionnaireNotFound?: any; ValidationError?: any },
  ResolversTypes["PostStayReviewResponseErrorCase"]
>;

export type PostStayReviewResponsePayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["PostStayReviewResponsePayload"] =
    ResolversParentTypes["PostStayReviewResponsePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "PostStayReviewResponseError" | "StayReviewResponse",
    ParentType,
    ContextType
  >;
};

export type PriceWithTaxRateResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["PriceWithTaxRate"] =
    ResolversParentTypes["PriceWithTaxRate"],
> = {
  price?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  taxRate?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
};

export type ProcessCronJobResponseResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ProcessCronJobResponse"] =
    ResolversParentTypes["ProcessCronJobResponse"],
> = {
  body?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type ProcessStripeEventResponseResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ProcessStripeEventResponse"] =
    ResolversParentTypes["ProcessStripeEventResponse"],
> = {
  body?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type ProcessTrustdockEventResponseResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ProcessTrustdockEventResponse"] =
    ResolversParentTypes["ProcessTrustdockEventResponse"],
> = {
  body?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type PushNotificationPlatformResolvers = EnumResolverSignature<
  { Android?: any; Apple?: any },
  ResolversTypes["PushNotificationPlatform"]
>;

export type QueryResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Query"] =
    ResolversParentTypes["Query"],
> = {
  accommodation?: Resolver<
    Maybe<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType,
    RequireFields<QueryaccommodationArgs, "id">
  >;
  accommodationAvailabilityBlock?: Resolver<
    ResolversTypes["AccommodationAvailabilityBlock"],
    ParentType,
    ContextType,
    RequireFields<QueryaccommodationAvailabilityBlockArgs, "id">
  >;
  accommodationAvailabilityBlockCategoryInfos?: Resolver<
    Array<ResolversTypes["AccommodationAvailabilityBlockCategoryInfo"]>,
    ParentType,
    ContextType
  >;
  accommodationAvailabilityBlocks?: Resolver<
    Array<ResolversTypes["AccommodationAvailabilityBlock"]>,
    ParentType,
    ContextType,
    Partial<QueryaccommodationAvailabilityBlocksArgs>
  >;
  accommodationReservation?: Resolver<
    ResolversTypes["AccommodationReservation"],
    ParentType,
    ContextType,
    RequireFields<QueryaccommodationReservationArgs, "id">
  >;
  accommodationReservationCheckOutAvailabilities?: Resolver<
    ResolversTypes["AccommodationReservationCheckOutAvailabilitiesPayload"],
    ParentType,
    ContextType,
    RequireFields<
      QueryaccommodationReservationCheckOutAvailabilitiesArgs,
      "input" | "internal"
    >
  >;
  architectureTopPage?: Resolver<
    ResolversTypes["ContentArchitecturePageNavigation"],
    ParentType,
    ContextType
  >;
  architectureTypePage?: Resolver<
    ResolversTypes["ContentArchitectureType"],
    ParentType,
    ContextType,
    RequireFields<QueryarchitectureTypePageArgs, "slug">
  >;
  architectureTypes?: Resolver<
    Array<ResolversTypes["ArchitectureType"]>,
    ParentType,
    ContextType,
    Partial<QueryarchitectureTypesArgs>
  >;
  areaBySlug?: Resolver<
    Maybe<ResolversTypes["Area"]>,
    ParentType,
    ContextType,
    RequireFields<QueryareaBySlugArgs, "slug">
  >;
  areas?: Resolver<Array<ResolversTypes["Area"]>, ParentType, ContextType>;
  areasForReservation?: Resolver<
    Array<ResolversTypes["Area"]>,
    ParentType,
    ContextType,
    Partial<QueryareasForReservationArgs>
  >;
  cancellableStayGiftsForOwner?: Resolver<
    Array<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType
  >;
  coOwnersApplication?: Resolver<
    ResolversTypes["CoOwnersApplication"],
    ParentType,
    ContextType,
    RequireFields<QuerycoOwnersApplicationArgs, "id">
  >;
  coOwnersWebinarSchedule?: Resolver<
    ResolversTypes["CoOwnersWebinarSchedule"],
    ParentType,
    ContextType,
    RequireFields<QuerycoOwnersWebinarScheduleArgs, "id">
  >;
  draftAccommodationReservation?: Resolver<
    ResolversTypes["DraftAccommodationReservation"],
    ParentType,
    ContextType,
    RequireFields<QuerydraftAccommodationReservationArgs, "input">
  >;
  draftAccommodationReservationByStayTicketMaster?: Resolver<
    ResolversTypes["DraftAccommodationReservationByStayTicketMasterResult"],
    ParentType,
    ContextType,
    RequireFields<
      QuerydraftAccommodationReservationByStayTicketMasterArgs,
      "input"
    >
  >;
  estimateStandardSubscriptionApplicationFee?: Resolver<
    ResolversTypes["EstimateStandardSubscriptionApplicationFeePayload"],
    ParentType,
    ContextType,
    Partial<QueryestimateStandardSubscriptionApplicationFeeArgs>
  >;
  estimatedCancelFeeOfAccommodationReservation?: Resolver<
    ResolversTypes["EstimatedCancelFeeOfAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      QueryestimatedCancelFeeOfAccommodationReservationArgs,
      "id" | "internal"
    >
  >;
  estimatedChangeFeeOfAccommodationReservation?: Resolver<
    ResolversTypes["EstimatedChangeFeeOfAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<
      QueryestimatedChangeFeeOfAccommodationReservationArgs,
      "fromAccommodationReservationId" | "internal" | "to"
    >
  >;
  exportStayGiftsForOwner?: Resolver<
    ResolversTypes["ExportStayGiftsPayload"],
    ParentType,
    ContextType,
    Partial<QueryexportStayGiftsForOwnerArgs>
  >;
  facility?: Resolver<
    Maybe<ResolversTypes["Facility"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryfacilityArgs,
      "accommodationReservationId" | "facilityType"
    >
  >;
  facilityReservation?: Resolver<
    Maybe<ResolversTypes["FacilityReservation"]>,
    ParentType,
    ContextType,
    RequireFields<QueryfacilityReservationArgs, "id">
  >;
  featurePage?: Resolver<
    ResolversTypes["ContentArchitectureTypeFeature"],
    ParentType,
    ContextType,
    RequireFields<QueryfeaturePageArgs, "slug">
  >;
  hook?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType,
    Partial<QueryhookArgs>
  >;
  internalAccommodation?: Resolver<
    Maybe<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalAccommodationArgs, "id">
  >;
  internalAccommodationAvailabilityBlockReleaseSchedules?: Resolver<
    Array<ResolversTypes["AccommodationAvailabilityBlockReleaseSchedule"]>,
    ParentType,
    ContextType
  >;
  internalAccommodationEquipments?: Resolver<
    Array<ResolversTypes["AccommodationEquipment"]>,
    ParentType,
    ContextType
  >;
  internalAccommodationFacilities?: Resolver<
    Array<ResolversTypes["AccommodationFacility"]>,
    ParentType,
    ContextType
  >;
  internalAccommodationFacility?: Resolver<
    ResolversTypes["AccommodationFacility"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalAccommodationFacilityArgs, "id">
  >;
  internalAccommodationNotices?: Resolver<
    Array<ResolversTypes["AccommodationNotice"]>,
    ParentType,
    ContextType
  >;
  internalAccommodationOperationGroups?: Resolver<
    Array<ResolversTypes["AccommodationOperationGroup"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalAccommodationOperationGroupsArgs, "siteId">
  >;
  internalAccommodationReservationsBySearch?: Resolver<
    Array<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalAccommodationReservationsBySearchArgs>
  >;
  internalAccommodationReservationsForExport?: Resolver<
    Array<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalAccommodationReservationsForExportArgs>
  >;
  internalAccommodations?: Resolver<
    Array<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalAccommodationsArgs>
  >;
  internalAdditionalGuestFeePolicies?: Resolver<
    Array<ResolversTypes["AdditionalGuestFeePolicy"]>,
    ParentType,
    ContextType
  >;
  internalAdditionalGuestFeePolicyById?: Resolver<
    Maybe<ResolversTypes["AdditionalGuestFeePolicy"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalAdditionalGuestFeePolicyByIdArgs, "id">
  >;
  internalAdminRoleAssignments?: Resolver<
    Array<ResolversTypes["AdminRoleAssignment"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalAdminRoleAssignmentsArgs, "includeInactive">
  >;
  internalArchitectureType?: Resolver<
    ResolversTypes["ArchitectureType"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalArchitectureTypeArgs, "id">
  >;
  internalArchitectureTypes?: Resolver<
    Array<ResolversTypes["ArchitectureType"]>,
    ParentType,
    ContextType
  >;
  internalArea?: Resolver<
    ResolversTypes["InternalArea"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalAreaArgs, "id">
  >;
  internalAreaGuideArticles?: Resolver<
    Array<ResolversTypes["AreaGuideArticle"]>,
    ParentType,
    ContextType
  >;
  internalAreas?: Resolver<
    Array<ResolversTypes["InternalArea"]>,
    ParentType,
    ContextType
  >;
  internalAuth0DashboardBaseUrl?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  internalAuth0UsersByEmail?: Resolver<
    Array<ResolversTypes["InternalAuth0User"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalAuth0UsersByEmailArgs, "email">
  >;
  internalAvailableStaffSemesters?: Resolver<
    Array<ResolversTypes["InternalAvailableStaffSemester"]>,
    ParentType,
    ContextType
  >;
  internalBaseAccommodationFeePolicies?: Resolver<
    Array<ResolversTypes["RawBaseAccommodationFeePolicy"]>,
    ParentType,
    ContextType
  >;
  internalBeds24DeleteBlackBookingsTargetCount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  internalBeds24Property?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalBeds24PropertyArgs, "propertyId">
  >;
  internalBeds24TokenStatus?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  internalBusinessPlans?: Resolver<
    Array<ResolversTypes["BusinessPlan"]>,
    ParentType,
    ContextType
  >;
  internalCancelFeePolicies?: Resolver<
    Array<ResolversTypes["RawCancelFeePolicy"]>,
    ParentType,
    ContextType
  >;
  internalCoOwnersApplication?: Resolver<
    Maybe<ResolversTypes["CoOwnersApplication"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalCoOwnersApplicationArgs, "id">
  >;
  internalCoOwnersApplications?: Resolver<
    Array<ResolversTypes["CoOwnersApplication"]>,
    ParentType,
    ContextType
  >;
  internalCoOwnersBakurakuInvoiceAnnualPaymentItems?: Resolver<
    Array<ResolversTypes["CoOwnersBakurakuInvoiceAnnualPaymentItem"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryinternalCoOwnersBakurakuInvoiceAnnualPaymentItemsArgs,
      "programYear"
    >
  >;
  internalCoOwnersBakurakuInvoiceRecipients?: Resolver<
    Array<ResolversTypes["CoOwnersBakurakuInvoiceRecipient"]>,
    ParentType,
    ContextType
  >;
  internalCoOwnersBakurakuInvoiceRegistrationFeeItems?: Resolver<
    Array<ResolversTypes["CoOwnersBakurakuInvoiceRegistrationFeeItem"]>,
    ParentType,
    ContextType
  >;
  internalCoOwnersBakurakuInvoiceRemainingPaymentItems?: Resolver<
    Array<ResolversTypes["CoOwnersBakurakuInvoiceRemainingPaymentItem"]>,
    ParentType,
    ContextType
  >;
  internalCoOwnersWebinarSchedules?: Resolver<
    Array<ResolversTypes["CoOwnersWebinarSchedule"]>,
    ParentType,
    ContextType
  >;
  internalContentArchitects?: Resolver<
    Array<ResolversTypes["ContentArchitect"]>,
    ParentType,
    ContextType
  >;
  internalContentArchitecturalFeature?: Resolver<
    Maybe<ResolversTypes["ContentArchitecturalFeature"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryinternalContentArchitecturalFeatureArgs,
      "accommodationFacilityId"
    >
  >;
  internalContentArchitectureTypeBasicAmenities?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeBasicAmenity"]>,
    ParentType,
    ContextType
  >;
  internalContentFacilityAmenities?: Resolver<
    Array<ResolversTypes["ContentArchitectureTypeVariantFacilityAmenity"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalContentFacilityAmenitiesArgs>
  >;
  internalDraftAccommodationReservation?: Resolver<
    ResolversTypes["DraftAccommodationReservation"],
    ParentType,
    ContextType,
    RequireFields<
      QueryinternalDraftAccommodationReservationArgs,
      "input" | "waiveCleaningFee"
    >
  >;
  internalFacilities?: Resolver<
    Array<ResolversTypes["Facility"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalFacilitiesArgs>
  >;
  internalFacility?: Resolver<
    Maybe<ResolversTypes["Facility"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalFacilityArgs, "id">
  >;
  internalFacilityReservations?: Resolver<
    Array<ResolversTypes["FacilityReservation"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalFacilityReservationsArgs>
  >;
  internalFacilityResourceBlocks?: Resolver<
    Array<ResolversTypes["FacilityResourceBlock"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalFacilityResourceBlocksArgs>
  >;
  internalFutureCleaningAmounts?: Resolver<
    ResolversTypes["InternalFutureCleaningAmountsPayload"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalFutureCleaningAmountsArgs, "siteId">
  >;
  internalGeneratePinCodeForLockDevice?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  internalGenerateUserMonthlyStatement?: Resolver<
    ResolversTypes["InternalGenerateUserMonthlyStatementPayload"],
    ParentType,
    ContextType,
    RequireFields<
      QueryinternalGenerateUserMonthlyStatementArgs,
      "userId" | "yearMonth"
    >
  >;
  internalGrantableAdminRoles?: Resolver<
    Array<ResolversTypes["InternalGrantableAdminRole"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalGrantableAdminRolesArgs>
  >;
  internalHighSeasonPeriods?: Resolver<
    Array<ResolversTypes["HighSeasonPeriod"]>,
    ParentType,
    ContextType
  >;
  internalInspectionReports?: Resolver<
    Array<ResolversTypes["InspectionReport"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalInspectionReportsArgs>
  >;
  internalIpBeds24SetupEstimate?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType,
    Partial<QueryinternalIpBeds24SetupEstimateArgs>
  >;
  internalIpBeds24SetupStatus?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  internalJtasInspections?: Resolver<
    Array<ResolversTypes["Inspection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalJtasInspectionsArgs, "inspectionDate">
  >;
  internalLocalTaxPolicies?: Resolver<
    Array<ResolversTypes["LocalTaxPolicy"]>,
    ParentType,
    ContextType
  >;
  internalLocalTaxPolicy?: Resolver<
    ResolversTypes["LocalTaxPolicy"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalLocalTaxPolicyArgs, "id">
  >;
  internalNativeAppHomeContent?: Resolver<
    Maybe<ResolversTypes["InternalNativeAppHomeContent"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalNativeAppHomeContentArgs, "id">
  >;
  internalNativeAppHomeContents?: Resolver<
    Array<ResolversTypes["InternalNativeAppHomeContent"]>,
    ParentType,
    ContextType
  >;
  internalNews?: Resolver<
    Array<ResolversTypes["RawNews"]>,
    ParentType,
    ContextType
  >;
  internalOneShotScript?: Resolver<
    Maybe<ResolversTypes["InternalOneShotScript"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalOneShotScriptArgs, "slug">
  >;
  internalOneShotScripts?: Resolver<
    Array<ResolversTypes["InternalOneShotScript"]>,
    ParentType,
    ContextType
  >;
  internalOrganization?: Resolver<
    ResolversTypes["Organization"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalOrganizationArgs, "id">
  >;
  internalOrganizationYearlyContractInvoices?: Resolver<
    ResolversTypes["OrganizationYearlyContractInvoicesResult"],
    ParentType,
    ContextType,
    Partial<QueryinternalOrganizationYearlyContractInvoicesArgs>
  >;
  internalOrganizationYearlyContracts?: Resolver<
    ResolversTypes["OrganizationYearlyContractsResult"],
    ParentType,
    ContextType,
    Partial<QueryinternalOrganizationYearlyContractsArgs>
  >;
  internalOrganizations?: Resolver<
    Array<ResolversTypes["Organization"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalOrganizationsArgs>
  >;
  internalOwnerPlans?: Resolver<
    Array<ResolversTypes["OwnerPlan"]>,
    ParentType,
    ContextType
  >;
  internalScriptExecutions?: Resolver<
    Array<ResolversTypes["InternalScriptExecution"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalScriptExecutionsArgs>
  >;
  internalSeasonalFeeSettings?: Resolver<
    Array<ResolversTypes["SeasonalFeeSetting"]>,
    ParentType,
    ContextType
  >;
  internalSite?: Resolver<
    ResolversTypes["InternalSite"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalSiteArgs, "id">
  >;
  internalSiteActivityProgram?: Resolver<
    Maybe<ResolversTypes["SiteActivityProgram"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalSiteActivityProgramArgs, "id">
  >;
  internalSiteActivityPrograms?: Resolver<
    Array<ResolversTypes["SiteActivityProgram"]>,
    ParentType,
    ContextType
  >;
  internalSiteFaqs?: Resolver<
    Array<ResolversTypes["RawSiteFaq"]>,
    ParentType,
    ContextType
  >;
  internalSiteHighSeasonPeriods?: Resolver<
    Array<ResolversTypes["SiteHighSeasonPeriod"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalSiteHighSeasonPeriodsArgs, "siteId">
  >;
  internalSites?: Resolver<
    Array<ResolversTypes["Site"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalSitesArgs>
  >;
  internalStaffContract?: Resolver<
    ResolversTypes["InternalStaffContract"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalStaffContractArgs, "id">
  >;
  internalStaffContracts?: Resolver<
    Array<ResolversTypes["InternalStaffContract"]>,
    ParentType,
    ContextType
  >;
  internalStaffCreditTransactions?: Resolver<
    Array<ResolversTypes["InternalStaffCreditTransaction"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalStaffCreditTransactionsArgs, "contractId">
  >;
  internalStaffGroup?: Resolver<
    ResolversTypes["StaffGroup"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalStaffGroupArgs, "id">
  >;
  internalStayReviewResponse?: Resolver<
    ResolversTypes["StayReviewResponseWithReservation"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalStayReviewResponseArgs, "id">
  >;
  internalStayReviewResponses?: Resolver<
    Array<ResolversTypes["StayReviewResponseWithReservation"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalStayReviewResponsesArgs>
  >;
  internalStayReviewedAccommodationReservations?: Resolver<
    Array<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryinternalStayReviewedAccommodationReservationsArgs,
      "endCheckOutDate" | "startCheckOutDate"
    >
  >;
  internalStayTicketByCode?: Resolver<
    Maybe<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalStayTicketByCodeArgs, "code">
  >;
  internalStayTicketMasterById?: Resolver<
    Maybe<ResolversTypes["StayTicketMaster"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalStayTicketMasterByIdArgs, "id">
  >;
  internalStayTicketMasterTemplates?: Resolver<
    Array<ResolversTypes["StayTicketMasterTemplate"]>,
    ParentType,
    ContextType
  >;
  internalStayTicketMasters?: Resolver<
    Array<ResolversTypes["StayTicketMaster"]>,
    ParentType,
    ContextType
  >;
  internalStayTicketTemplates?: Resolver<
    Array<ResolversTypes["StayTicketTemplate"]>,
    ParentType,
    ContextType
  >;
  internalStayTickets?: Resolver<
    ResolversTypes["InternalStayTicketsResult"],
    ParentType,
    ContextType,
    RequireFields<
      QueryinternalStayTicketsArgs,
      "limit" | "offset" | "orderBy" | "orderDir" | "stayTicketMasterId"
    >
  >;
  internalStripeDashboardBaseUrl?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  internalSupplyItemMaster?: Resolver<
    Maybe<ResolversTypes["SupplyItemMaster"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalSupplyItemMasterArgs, "id">
  >;
  internalSupplyItemMasters?: Resolver<
    Array<ResolversTypes["SupplyItemMaster"]>,
    ParentType,
    ContextType
  >;
  internalSupplyItems?: Resolver<
    Array<ResolversTypes["SupplyItem"]>,
    ParentType,
    ContextType,
    RequireFields<QueryinternalSupplyItemsArgs, "accommodationId">
  >;
  internalTerms?: Resolver<
    Array<ResolversTypes["Terms"]>,
    ParentType,
    ContextType
  >;
  internalUser?: Resolver<
    ResolversTypes["User"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalUserArgs, "id">
  >;
  internalUserOwnership?: Resolver<
    ResolversTypes["UserOwnership"],
    ParentType,
    ContextType,
    RequireFields<QueryinternalUserOwnershipArgs, "id">
  >;
  internalUserOwnerships?: Resolver<
    Array<ResolversTypes["UserOwnership"]>,
    ParentType,
    ContextType
  >;
  internalUserStats?: Resolver<
    ResolversTypes["InternalUserStats"],
    ParentType,
    ContextType
  >;
  internalUsers?: Resolver<
    Array<ResolversTypes["User"]>,
    ParentType,
    ContextType
  >;
  internalUsersBySearch?: Resolver<
    Array<ResolversTypes["User"]>,
    ParentType,
    ContextType,
    Partial<QueryinternalUsersBySearchArgs>
  >;
  internalUsersSearch?: Resolver<
    ResolversTypes["InternalUserSearchResult"],
    ParentType,
    ContextType,
    Partial<QueryinternalUsersSearchArgs>
  >;
  lookupOtaReservationByReference?: Resolver<
    Array<ResolversTypes["OtaReservationLookupResult"]>,
    ParentType,
    ContextType,
    RequireFields<QuerylookupOtaReservationByReferenceArgs, "reference">
  >;
  maybeViewer?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType
  >;
  nativeAppHomeContents?: Resolver<
    Array<ResolversTypes["NativeAppHomeContent"]>,
    ParentType,
    ContextType
  >;
  news?: Resolver<Array<ResolversTypes["News"]>, ParentType, ContextType>;
  newsDetail?: Resolver<
    ResolversTypes["News"],
    ParentType,
    ContextType,
    RequireFields<QuerynewsDetailArgs, "id">
  >;
  offeredCoOwnersPlans?: Resolver<
    Array<ResolversTypes["OwnerPlan"]>,
    ParentType,
    ContextType,
    RequireFields<QueryofferedCoOwnersPlansArgs, "earlyAccessCode">
  >;
  organization?: Resolver<
    ResolversTypes["Organization"],
    ParentType,
    ContextType,
    RequireFields<QueryorganizationArgs, "id">
  >;
  organizationIdByInvitationCode?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType,
    RequireFields<QueryorganizationIdByInvitationCodeArgs, "invitationCode">
  >;
  organizationMember?: Resolver<
    ResolversTypes["OrganizationMemberPayload"],
    ParentType,
    ContextType,
    RequireFields<QueryorganizationMemberArgs, "userId">
  >;
  ownerPlan?: Resolver<
    ResolversTypes["OwnerPlan"],
    ParentType,
    ContextType,
    RequireFields<QueryownerPlanArgs, "id">
  >;
  peakDays?: Resolver<
    Array<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType,
    RequireFields<QuerypeakDaysArgs, "firstNight" | "lastNight">
  >;
  plugDevice?: Resolver<
    Maybe<ResolversTypes["PlugDevice"]>,
    ParentType,
    ContextType,
    RequireFields<QueryplugDeviceArgs, "id">
  >;
  reservationRuleRevision2027Policy?: Resolver<
    ResolversTypes["ReservationRuleRevision2027Policy"],
    ParentType,
    ContextType,
    RequireFields<QueryreservationRuleRevision2027PolicyArgs, "provider">
  >;
  roomType?: Resolver<
    Maybe<ResolversTypes["RoomType"]>,
    ParentType,
    ContextType,
    RequireFields<QueryroomTypeArgs, "id">
  >;
  roomTypeBySlug?: Resolver<
    Maybe<ResolversTypes["RoomType"]>,
    ParentType,
    ContextType,
    RequireFields<QueryroomTypeBySlugArgs, "roomTypeSlug" | "siteSlug">
  >;
  siteBySlug?: Resolver<
    Maybe<ResolversTypes["Site"]>,
    ParentType,
    ContextType,
    RequireFields<QuerysiteBySlugArgs, "slug">
  >;
  staffGroups?: Resolver<
    Array<ResolversTypes["StaffGroup"]>,
    ParentType,
    ContextType,
    RequireFields<QuerystaffGroupsArgs, "includeInvalidated">
  >;
  stayReviewQuestionnaire?: Resolver<
    ResolversTypes["StayReviewQuestionnaire"],
    ParentType,
    ContextType
  >;
  stayReviewV2Form?: Resolver<
    ResolversTypes["StayReviewV2Form"],
    ParentType,
    ContextType
  >;
  stayTicketReservationInfo?: Resolver<
    Maybe<ResolversTypes["StayTicketReservationInfo"]>,
    ParentType,
    ContextType,
    RequireFields<QuerystayTicketReservationInfoArgs, "stayTicketUnitId">
  >;
  tentativeAccommodationReservation?: Resolver<
    ResolversTypes["TentativeAccommodationReservationPayload"],
    ParentType,
    ContextType,
    RequireFields<QuerytentativeAccommodationReservationArgs, "code">
  >;
  topPage?: Resolver<ResolversTypes["TopPage"], ParentType, ContextType>;
  urlFromCode?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType,
    RequireFields<QueryurlFromCodeArgs, "code">
  >;
  userCompanion?: Resolver<
    ResolversTypes["UserCompanion"],
    ParentType,
    ContextType,
    RequireFields<QueryuserCompanionArgs, "id">
  >;
  userOwnership?: Resolver<
    ResolversTypes["UserOwnership"],
    ParentType,
    ContextType,
    RequireFields<QueryuserOwnershipArgs, "id">
  >;
  verifyAccountLinkSession?: Resolver<
    ResolversTypes["VerifyAccountLinkSessionPayload"],
    ParentType,
    ContextType,
    RequireFields<QueryverifyAccountLinkSessionArgs, "input">
  >;
  viewer?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
};

export type RawBaseAccommodationFeePolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RawBaseAccommodationFeePolicy"] =
    ResolversParentTypes["RawBaseAccommodationFeePolicy"],
> = {
  dailyFeePolicy?: Resolver<
    Array<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  feeModifier?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  feeModifierType?: Resolver<
    Maybe<ResolversTypes["FeeModifierType"]>,
    ParentType,
    ContextType
  >;
  feeRules?: Resolver<
    Array<ResolversTypes["AccommodationFeeRule"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  internalName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  isThirdPartyCovered?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  thirdPartyCoveredDailyFeePolicy?: Resolver<
    Array<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RawCancelFeePolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RawCancelFeePolicy"] =
    ResolversParentTypes["RawCancelFeePolicy"],
> = {
  cancelFeePolicy?: Resolver<
    ResolversTypes["CancelFeePolicy"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  internalDescription?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  internalName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RawNewsResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RawNews"] =
    ResolversParentTypes["RawNews"],
> = {
  content?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  contentType?: Resolver<
    ResolversTypes["NewsContentType"],
    ParentType,
    ContextType
  >;
  createdUser?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  displayCategory?: Resolver<
    ResolversTypes["NewsDisplayCategory"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  publishedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  status?: Resolver<ResolversTypes["NewsStatus"], ParentType, ContextType>;
  targetPlans?: Resolver<
    Array<ResolversTypes["TargetPlanType"]>,
    ParentType,
    ContextType
  >;
  title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type RawSiteFaqResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RawSiteFaq"] =
    ResolversParentTypes["RawSiteFaq"],
> = {
  answer?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  guidanceImageUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  question?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  site?: Resolver<ResolversTypes["Site"], ParentType, ContextType>;
  sort?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RedirectLocationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RedirectLocation"] =
    ResolversParentTypes["RedirectLocation"],
> = {
  path?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegisterCoOwnersApplicationFileErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["RegisterCoOwnersApplicationFileError"] =
    ResolversParentTypes["RegisterCoOwnersApplicationFileError"],
> = {
  case?: Resolver<
    ResolversTypes["RegisterCoOwnersApplicationFileErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegisterCoOwnersApplicationFileErrorCaseResolvers =
  EnumResolverSignature<
    {
      AlreadyRegistered?: any;
      FileNotUploaded?: any;
      InvalidFile?: any;
      NotFound?: any;
    },
    ResolversTypes["RegisterCoOwnersApplicationFileErrorCase"]
  >;

export type RegisterCoOwnersApplicationFilePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["RegisterCoOwnersApplicationFilePayload"] =
    ResolversParentTypes["RegisterCoOwnersApplicationFilePayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "RegisterCoOwnersApplicationFileError"
    | "RegisterCoOwnersApplicationFileSuccess",
    ParentType,
    ContextType
  >;
};

export type RegisterCoOwnersApplicationFileSuccessResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["RegisterCoOwnersApplicationFileSuccess"] =
    ResolversParentTypes["RegisterCoOwnersApplicationFileSuccess"],
> = {
  file?: Resolver<
    ResolversTypes["CoOwnersApplicationFile"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveIdentityErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RemoveIdentityError"] =
    ResolversParentTypes["RemoveIdentityError"],
> = {
  case?: Resolver<
    ResolversTypes["RemoveIdentityErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveIdentityErrorCaseResolvers = EnumResolverSignature<
  {
    AppleTokenRevocationFailed?: any;
    IdentityNotFound?: any;
    LastIdentity?: any;
    NoVerifiedRemaining?: any;
    PasswordNotSet?: any;
    Unauthorized?: any;
  },
  ResolversTypes["RemoveIdentityErrorCase"]
>;

export type RemoveIdentityPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RemoveIdentityPayload"] =
    ResolversParentTypes["RemoveIdentityPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "RemoveIdentityError" | "RemoveIdentitySuccess",
    ParentType,
    ContextType
  >;
};

export type RemoveIdentitySuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RemoveIdentitySuccess"] =
    ResolversParentTypes["RemoveIdentitySuccess"],
> = {
  removedProvider?: Resolver<
    ResolversTypes["IdentityProvider"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentalCycleKeyBoxResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RentalCycleKeyBox"] =
    ResolversParentTypes["RentalCycleKeyBox"],
> = {
  comment?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  inUseAt?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  pinCode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  reservationId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  returnedAt?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  usableFrom?: Resolver<
    ResolversTypes["PlainDateTime"],
    ParentType,
    ContextType
  >;
  usableTo?: Resolver<ResolversTypes["PlainDateTime"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReservationExportItemResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ReservationExportItem"] =
    ResolversParentTypes["ReservationExportItem"],
> = {
  accommodationCode?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  checkInDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  checkOutDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  contractStartDate?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  nights?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  numberOfAdults?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  numberOfDogs?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  numberOfInfants?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  numberOfKids?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  organizationName?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  siteName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  stayComment?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  stayRating?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  stayStatus?: Resolver<
    ResolversTypes["AccommodationReservationStayStatus"],
    ParentType,
    ContextType
  >;
  totalAmount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  userEmail?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  userName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type ReservationPriceStatementResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ReservationPriceStatement"] =
    ResolversParentTypes["ReservationPriceStatement"],
> = {
  accommodationTax?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  additionalFacilityFee?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  additionalFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  baseFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  bathingTax?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  cancelFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  cleaningFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  consumedSuppliesFee?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  consumedSuppliesFeeByTaxRate?: Resolver<
    Array<ResolversTypes["PriceWithTaxRate"]>,
    ParentType,
    ContextType
  >;
  dogFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  evFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  facilityReservationFee?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
};

export type ReservationRuleRevision2027PolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ReservationRuleRevision2027Policy"] =
    ResolversParentTypes["ReservationRuleRevision2027Policy"],
> = {
  announcementStartDate?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
  firstApplicableNight?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
};

export type ReservationStatementItemResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ReservationStatementItem"] =
    ResolversParentTypes["ReservationStatementItem"],
> = {
  accommodationName?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  canceledAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  date?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  fee?: Resolver<ResolversTypes["AccommodationFee"], ParentType, ContextType>;
  price?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  priceStatement?: Resolver<
    ResolversTypes["ReservationPriceStatement"],
    ParentType,
    ContextType
  >;
  reservationId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  status?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type ResourcePermissionResolvers = EnumResolverSignature<
  {
    AccommodationsRead?: any;
    AdminRolesWrite?: any;
    AvailabilityBlocksRead?: any;
    CoOwnersRead?: any;
    DevToolsUse?: any;
    FacilitiesRead?: any;
    FacilityCleaningWrite?: any;
    FullOwnersRead?: any;
    FullOwnersWrite?: any;
    InspectionsRead?: any;
    JtasSyncWrite?: any;
    OrganizationsRead?: any;
    ReservationsRead?: any;
    ReservationsUse?: any;
    ReservationsWrite?: any;
    ScriptsUse?: any;
    SitesRead?: any;
    StayTicketsRead?: any;
    UserCompanionsRead?: any;
    UsersIdentityRead?: any;
    UsersRead?: any;
    UsersWrite?: any;
  },
  ResolversTypes["ResourcePermission"]
>;

export type ResumeStandardSubscriptionImmediatelyErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ResumeStandardSubscriptionImmediatelyError"] =
    ResolversParentTypes["ResumeStandardSubscriptionImmediatelyError"],
> = {
  case?: Resolver<
    ResolversTypes["ResumeStandardSubscriptionImmediatelyErrorCase"],
    ParentType,
    ContextType
  >;
  info?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResumeStandardSubscriptionImmediatelyErrorCaseResolvers =
  EnumResolverSignature<
    {
      AlreadySubscribedError?: any;
      InvalidOperation?: any;
      NoSubscriptionScheduleError?: any;
      StripeError?: any;
      UnexpectedSubscriptionScheduleStatus?: any;
    },
    ResolversTypes["ResumeStandardSubscriptionImmediatelyErrorCase"]
  >;

export type ResumeStandardSubscriptionImmediatelyPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ResumeStandardSubscriptionImmediatelyPayload"] =
    ResolversParentTypes["ResumeStandardSubscriptionImmediatelyPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "ResumeStandardSubscriptionImmediatelyError" | "Success",
    ParentType,
    ContextType
  >;
};

export type RoomTypeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RoomType"] =
    ResolversParentTypes["RoomType"],
> = {
  architectureType?: Resolver<
    Maybe<ResolversTypes["ArchitectureType"]>,
    ParentType,
    ContextType
  >;
  availabilities?: Resolver<
    ResolversTypes["RoomTypeAvailabilities"],
    ParentType,
    ContextType,
    RequireFields<RoomTypeavailabilitiesArgs, "provider">
  >;
  availabilitiesByStayTicketMaster?: Resolver<
    ResolversTypes["RoomTypeAvailabilities"],
    ParentType,
    ContextType,
    RequireFields<
      RoomTypeavailabilitiesByStayTicketMasterArgs,
      "firstNight" | "lastNight" | "stayTicketMasterReference"
    >
  >;
  content?: Resolver<
    Maybe<ResolversTypes["ContentRoomType"]>,
    ParentType,
    ContextType
  >;
  displayName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  features?: Resolver<
    Array<ResolversTypes["RoomTypeFeature"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  site?: Resolver<ResolversTypes["Site"], ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
};

export type RoomTypeAvailabilitiesResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RoomTypeAvailabilities"] =
    ResolversParentTypes["RoomTypeAvailabilities"],
> = {
  fromPrice?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  nights?: Resolver<
    Array<ResolversTypes["RoomTypeAvailability"]>,
    ParentType,
    ContextType
  >;
  stayTicketMasterId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
};

export type RoomTypeAvailabilityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RoomTypeAvailability"] =
    ResolversParentTypes["RoomTypeAvailability"],
> = {
  availableAccommodations?: Resolver<
    Array<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType
  >;
  availableCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  isAvailable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  maxConsecutiveNights?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  night?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  price?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type RoomTypeFeatureResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["RoomTypeFeature"] =
    ResolversParentTypes["RoomTypeFeature"],
> = {
  category?: Resolver<
    ResolversTypes["RoomTypeFeatureCategory"],
    ParentType,
    ContextType
  >;
  displayName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  iconSlug?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type RoomTypeFeatureCategoryResolvers = EnumResolverSignature<
  { Amenity?: any; Floor?: any; Other?: any; View?: any },
  ResolversTypes["RoomTypeFeatureCategory"]
>;

export type S2oResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["S2o"] = ResolversParentTypes["S2o"],
> = {
  balance?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  points?: Resolver<Array<ResolversTypes["S2oPoint"]>, ParentType, ContextType>;
  stayCreditBalance?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  usedAmount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType,
    RequireFields<
      S2ousedAmountArgs,
      "ownerPlanId" | "units" | "useStayCredit" | "useWeekdayTrial"
    >
  >;
  userId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  weekdayTrialBalance?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
};

export type S2oPointResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["S2oPoint"] =
    ResolversParentTypes["S2oPoint"],
> = {
  amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  date?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  note?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  status?: Resolver<ResolversTypes["S2oPointStatus"], ParentType, ContextType>;
  transactionType?: Resolver<
    ResolversTypes["S2oPointTransactionType"],
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
};

export type S2oPointAdminTransactionTypeResolvers = EnumResolverSignature<
  {
    MonthlySubscriptionPayment?: any;
    StayGuestPayment?: any;
    TrialMonthlySubscriptionPayment?: any;
  },
  ResolversTypes["S2oPointAdminTransactionType"]
>;

export type S2oPointStatusResolvers = EnumResolverSignature<
  { Active?: any; Expired?: any; Unavailable?: any },
  ResolversTypes["S2oPointStatus"]
>;

export type S2oPointTransactionTypeResolvers = EnumResolverSignature<
  {
    CancellationInvalidation?: any;
    CoOwnerApplicationRefund?: any;
    CoOwnerApplicationUsage?: any;
    EnrollmentPayment?: any;
    InvalidatedByAdmin?: any;
    ManualAdjustment?: any;
    MonthlySubscriptionPayment?: any;
    StayGuestPayment?: any;
    TrialCancellationInvalidation?: any;
    TrialMonthlySubscriptionPayment?: any;
  },
  ResolversTypes["S2oPointTransactionType"]
>;

export type S3UploadPolicyResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["S3UploadPolicy"] =
    ResolversParentTypes["S3UploadPolicy"],
> = {
  fields?: Resolver<
    Array<ResolversTypes["S3UploadPolicyField"]>,
    ParentType,
    ContextType
  >;
  rawUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type S3UploadPolicyFieldResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["S3UploadPolicyField"] =
    ResolversParentTypes["S3UploadPolicyField"],
> = {
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  value?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type SanuEdgeDeviceResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SanuEdgeDevice"] =
    ResolversParentTypes["SanuEdgeDevice"],
> = {
  accommodation?: Resolver<
    ResolversTypes["Accommodation"],
    ParentType,
    ContextType
  >;
  deviceId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  deviceType?: Resolver<
    ResolversTypes["SanuEdgeDeviceType"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
};

export type SanuEdgeDeviceTypeResolvers = EnumResolverSignature<
  { SaunaControlUnit?: any },
  ResolversTypes["SanuEdgeDeviceType"]
>;

export type SanuFileTypeResolvers = EnumResolverSignature<
  {
    CoOwnersBuildingLeaseAgreement?: any;
    CoOwnersEstimate?: any;
    CoOwnersHandoverDocument?: any;
    CoOwnersImportantMattersDocument?: any;
    CoOwnersOtherFiles?: any;
    CoOwnersSalesContract?: any;
    CoOwnershipAgreement?: any;
    FullOwnerContract?: any;
  },
  ResolversTypes["SanuFileType"]
>;

export type SanuIncAccommodationReservationProviderResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["SanuIncAccommodationReservationProvider"] =
    ResolversParentTypes["SanuIncAccommodationReservationProvider"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  staffGroup?: Resolver<
    Maybe<ResolversTypes["StaffGroup"]>,
    ParentType,
    ContextType
  >;
  usage?: Resolver<
    ResolversTypes["AccommodationReservationProviderSanuIncUsage"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SanuOwnerPlanUserFileTypeResolvers = EnumResolverSignature<
  {
    CoOwnersBuildingLeaseAgreement?: any;
    CoOwnersHandoverDocuments?: any;
    CoOwnersImportantMatters?: any;
    CoOwnersSaleContract?: any;
    CoOwnershipAgreement?: any;
  },
  ResolversTypes["SanuOwnerPlanUserFileType"]
>;

export type SaunaAccommodationFacilityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SaunaAccommodationFacility"] =
    ResolversParentTypes["SaunaAccommodationFacility"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
};

export type SaunaEquipmentAttributeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SaunaEquipmentAttribute"] =
    ResolversParentTypes["SaunaEquipmentAttribute"],
> = {
  deviceId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SaveStayReviewV2DraftPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SaveStayReviewV2DraftPayload"] =
    ResolversParentTypes["SaveStayReviewV2DraftPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "StayReviewV2" | "StayReviewV2Error",
    ParentType,
    ContextType
  >;
};

export type ScheduleStandardSubscriptionPauseErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ScheduleStandardSubscriptionPauseError"] =
    ResolversParentTypes["ScheduleStandardSubscriptionPauseError"],
> = {
  case?: Resolver<
    ResolversTypes["ScheduleStandardSubscriptionPauseErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduleStandardSubscriptionPauseErrorCaseResolvers =
  EnumResolverSignature<
    {
      InvalidOperation?: any;
      InvalidPauseDate?: any;
      InvalidResumeDate?: any;
      NoSubscriptionError?: any;
      NotPausableDateYet?: any;
      ReservationExists?: any;
      StripeError?: any;
    },
    ResolversTypes["ScheduleStandardSubscriptionPauseErrorCase"]
  >;

export type ScheduleStandardSubscriptionPausePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ScheduleStandardSubscriptionPausePayload"] =
    ResolversParentTypes["ScheduleStandardSubscriptionPausePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "ScheduleStandardSubscriptionPauseError" | "Success",
    ParentType,
    ContextType
  >;
};

export type ScheduleStandardSubscriptionTerminationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ScheduleStandardSubscriptionTerminationError"] =
    ResolversParentTypes["ScheduleStandardSubscriptionTerminationError"],
> = {
  case?: Resolver<
    ResolversTypes["ScheduleStandardSubscriptionTerminationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduleStandardSubscriptionTerminationErrorCaseResolvers =
  EnumResolverSignature<
    {
      InvalidOperation?: any;
      NoSubscriptionError?: any;
      NotPausableDateYet?: any;
      ReservationExists?: any;
      StripeError?: any;
    },
    ResolversTypes["ScheduleStandardSubscriptionTerminationErrorCase"]
  >;

export type ScheduleStandardSubscriptionTerminationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["ScheduleStandardSubscriptionTerminationPayload"] =
    ResolversParentTypes["ScheduleStandardSubscriptionTerminationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "ScheduleStandardSubscriptionTerminationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type ScopeDimensionResolvers = EnumResolverSignature<
  { Site?: any },
  ResolversTypes["ScopeDimension"]
>;

export type ScriptExecutionStatusResolvers = EnumResolverSignature<
  { Failed?: any; Running?: any; Success?: any },
  ResolversTypes["ScriptExecutionStatus"]
>;

export type ScriptLogLevelResolvers = EnumResolverSignature<
  { Error?: any; Info?: any; Warn?: any },
  ResolversTypes["ScriptLogLevel"]
>;

export type SeasonalFeeSettingResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SeasonalFeeSetting"] =
    ResolversParentTypes["SeasonalFeeSetting"],
> = {
  additionalFee?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  night?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
};

export type SelectWebinarScheduleErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SelectWebinarScheduleError"] =
    ResolversParentTypes["SelectWebinarScheduleError"],
> = {
  case?: Resolver<
    ResolversTypes["SelectWebinarScheduleErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectWebinarScheduleErrorCaseResolvers = EnumResolverSignature<
  {
    AlreadyCompleted?: any;
    AlreadySelected?: any;
    ApplicationNotFound?: any;
    InvalidWebinarSchedule?: any;
    PermissionDenied?: any;
  },
  ResolversTypes["SelectWebinarScheduleErrorCase"]
>;

export type SelectWebinarSchedulePayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SelectWebinarSchedulePayload"] =
    ResolversParentTypes["SelectWebinarSchedulePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CoOwnersApplication" | "SelectWebinarScheduleError",
    ParentType,
    ContextType
  >;
};

export type SendEmailToVerifyNewEmailErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SendEmailToVerifyNewEmailError"] =
    ResolversParentTypes["SendEmailToVerifyNewEmailError"],
> = {
  case?: Resolver<
    ResolversTypes["SendEmailToVerifyNewEmailErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendEmailToVerifyNewEmailErrorCaseResolvers = EnumResolverSignature<
  {
    EmailAlreadyUsed?: any;
    GeneralError?: any;
    InvalidEmailFormat?: any;
    NoEmailPasswordIdentity?: any;
    SameEmail?: any;
  },
  ResolversTypes["SendEmailToVerifyNewEmailErrorCase"]
>;

export type SendEmailToVerifyNewEmailPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SendEmailToVerifyNewEmailPayload"] =
    ResolversParentTypes["SendEmailToVerifyNewEmailPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "SendEmailToVerifyNewEmailError" | "SendEmailToVerifyNewEmailSuccess",
    ParentType,
    ContextType
  >;
};

export type SendEmailToVerifyNewEmailSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SendEmailToVerifyNewEmailSuccess"] =
    ResolversParentTypes["SendEmailToVerifyNewEmailSuccess"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendPasswordResetEmailErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SendPasswordResetEmailError"] =
    ResolversParentTypes["SendPasswordResetEmailError"],
> = {
  case?: Resolver<
    Maybe<ResolversTypes["SendPasswordResetEmailErrorCase"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendPasswordResetEmailErrorCaseResolvers = EnumResolverSignature<
  { GeneralError?: any },
  ResolversTypes["SendPasswordResetEmailErrorCase"]
>;

export type SendPasswordResetEmailPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SendPasswordResetEmailPayload"] =
    ResolversParentTypes["SendPasswordResetEmailPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "SendPasswordResetEmailError" | "SendPasswordResetEmailSuccess",
    ParentType,
    ContextType
  >;
};

export type SendPasswordResetEmailSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SendPasswordResetEmailSuccess"] =
    ResolversParentTypes["SendPasswordResetEmailSuccess"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ServiceUpdateResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ServiceUpdate"] =
    ResolversParentTypes["ServiceUpdate"],
> = {
  isNew?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  publishedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  url?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type SiteResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Site"] =
    ResolversParentTypes["Site"],
> = {
  accommodations?: Resolver<
    Array<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType
  >;
  accommodationsForReservation?: Resolver<
    Array<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType,
    Partial<SiteaccommodationsForReservationArgs>
  >;
  area?: Resolver<ResolversTypes["Area"], ParentType, ContextType>;
  availability?: Resolver<
    Array<ResolversTypes["SiteAvailabilityNight"]>,
    ParentType,
    ContextType,
    RequireFields<
      SiteavailabilityArgs,
      | "architectureTypes"
      | "facilitySlugs"
      | "firstNight"
      | "lastNight"
      | "provider"
    >
  >;
  beds24PropertyId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  checkInAuthenticationType?: Resolver<
    ResolversTypes["CheckInAuthenticationType"],
    ParentType,
    ContextType
  >;
  coOwnersWebinarSchedules?: Resolver<
    Array<ResolversTypes["CoOwnersWebinarSchedule"]>,
    ParentType,
    ContextType
  >;
  content?: Resolver<ResolversTypes["SiteContent"], ParentType, ContextType>;
  customReservationLeadMonths?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  earlyCheckInEnabled?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  facilities?: Resolver<
    Array<ResolversTypes["Facility"]>,
    ParentType,
    ContextType,
    Partial<SitefacilitiesArgs>
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  isRemote?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  openingDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  ordinalName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  reservable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  reservableForOwnerEarlyAccess?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  roomTypeFeatures?: Resolver<
    Array<ResolversTypes["InternalRoomTypeFeature"]>,
    ParentType,
    ContextType
  >;
  roomTypes?: Resolver<
    Array<ResolversTypes["InternalRoomType"]>,
    ParentType,
    ContextType
  >;
  roomTypesForReservation?: Resolver<
    Array<ResolversTypes["RoomType"]>,
    ParentType,
    ContextType,
    Partial<SiteroomTypesForReservationArgs>
  >;
  shortAddress?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type SiteAccessRouteGroupResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SiteAccessRouteGroup"] =
    ResolversParentTypes["SiteAccessRouteGroup"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  points?: Resolver<
    Array<ResolversTypes["SiteAccessRoutePoint"]>,
    ParentType,
    ContextType
  >;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  transportIcon?: Resolver<
    ResolversTypes["AccessRouteTransportIcon"],
    ParentType,
    ContextType
  >;
};

export type SiteAccessRoutePointResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SiteAccessRoutePoint"] =
    ResolversParentTypes["SiteAccessRoutePoint"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  legToNextDescription?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type SiteActivityProgramResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SiteActivityProgram"] =
    ResolversParentTypes["SiteActivityProgram"],
> = {
  createdAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  externalUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  image?: Resolver<ResolversTypes["UploadedFile"], ParentType, ContextType>;
  localizedDescription?: Resolver<
    ResolversTypes["InternalLocalizedString"],
    ParentType,
    ContextType
  >;
  localizedTitle?: Resolver<
    ResolversTypes["InternalLocalizedString"],
    ParentType,
    ContextType
  >;
  publishEndAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  publishStartAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  sites?: Resolver<
    Array<ResolversTypes["InternalSite"]>,
    ParentType,
    ContextType
  >;
  title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SiteAvailabilityNightResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SiteAvailabilityNight"] =
    ResolversParentTypes["SiteAvailabilityNight"],
> = {
  fromPrice?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  isAvailable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  night?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
};

export type SiteContentResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SiteContent"] =
    ResolversParentTypes["SiteContent"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  accessRouteGroups?: Resolver<
    Array<ResolversTypes["SiteAccessRouteGroup"]>,
    ParentType,
    ContextType
  >;
  activityPrograms?: Resolver<
    Array<ResolversTypes["SiteActivityProgram"]>,
    ParentType,
    ContextType
  >;
  addressForEdit?: Resolver<
    Maybe<ResolversTypes["InternalSiteAddress"]>,
    ParentType,
    ContextType
  >;
  addressLine?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  city?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  faqs?: Resolver<Array<ResolversTypes["SiteFaq"]>, ParentType, ContextType>;
  googleMapsReviewUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  googleMapsUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  heroImages?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  iceRoadInfoUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  images?: Resolver<
    Array<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  latitude?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  mapImageUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  parkingCapacity?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  parkingInfo?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  postalCode?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  prefecture?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
};

export type SiteFaqResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SiteFaq"] =
    ResolversParentTypes["SiteFaq"],
> = {
  answer?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  guidanceImageUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  question?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type SiteHighSeasonPeriodResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SiteHighSeasonPeriod"] =
    ResolversParentTypes["SiteHighSeasonPeriod"],
> = {
  additionalFeeAmount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  endDay?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  endMonth?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  siteId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  startDay?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  startMonth?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type SortDirectionResolvers = EnumResolverSignature<
  { Asc?: any; Desc?: any },
  ResolversTypes["SortDirection"]
>;

export type StaffAccessKeyTriggerResolvers = EnumResolverSignature<
  {
    CancelReserve?: any;
    ChangeReserve?: any;
    CheckOutReserve?: any;
    CreateReserve?: any;
    CronJob?: any;
  },
  ResolversTypes["StaffAccessKeyTrigger"]
>;

export type StaffContractResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StaffContract"] =
    ResolversParentTypes["StaffContract"],
> = {
  currentSemesterGrantedStayCredits?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  currentSemesterStayCredits?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  enrolledAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  enrolledDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  isReservable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  remainingPeakDays?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  semesterCredits?: Resolver<
    Array<ResolversTypes["StaffSemesterCredit"]>,
    ParentType,
    ContextType
  >;
  staffType?: Resolver<ResolversTypes["StaffType"], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes["StaffContractStatus"],
    ParentType,
    ContextType
  >;
  statusDetail?: Resolver<
    ResolversTypes["StaffContractStatusDetail"],
    ParentType,
    ContextType
  >;
  terminatedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  terminatedDate?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
};

export type StaffContractStatusResolvers = EnumResolverSignature<
  { Neutral?: any; Usable?: any },
  ResolversTypes["StaffContractStatus"]
>;

export type StaffContractStatusDetailResolvers = EnumResolverSignature<
  { NeutralDefault?: any; NeutralTerminated?: any; UsableDefault?: any },
  ResolversTypes["StaffContractStatusDetail"]
>;

export type StaffGroupResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StaffGroup"] =
    ResolversParentTypes["StaffGroup"],
> = {
  archivedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  fullName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  smarthrId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes["StaffGroupStatus"],
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffGroupStatusResolvers = EnumResolverSignature<
  { Active?: any; Inactive?: any },
  ResolversTypes["StaffGroupStatus"]
>;

export type StaffPlanAccommodationReservationProviderResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["StaffPlanAccommodationReservationProvider"] =
    ResolversParentTypes["StaffPlanAccommodationReservationProvider"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  staffContractId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffSemesterResolvers = EnumResolverSignature<
  { First?: any; Second?: any },
  ResolversTypes["StaffSemester"]
>;

export type StaffSemesterCreditResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StaffSemesterCredit"] =
    ResolversParentTypes["StaffSemesterCredit"],
> = {
  grantedStayCredits?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  remainingPeakDays?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  remainingStayCredits?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  semester?: Resolver<ResolversTypes["StaffSemester"], ParentType, ContextType>;
  year?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type StaffStayCreditTransactionStatusResolvers = EnumResolverSignature<
  { Finalized?: any; Open?: any; Void?: any },
  ResolversTypes["StaffStayCreditTransactionStatus"]
>;

export type StaffStayCreditTransactionTypeResolvers = EnumResolverSignature<
  {
    GrantByBatch?: any;
    GrantByManual?: any;
    RedeemByCancel?: any;
    RedeemByNoShow?: any;
    RedeemByReserve?: any;
  },
  ResolversTypes["StaffStayCreditTransactionType"]
>;

export type StaffTypeResolvers = EnumResolverSignature<
  { Contractor?: any; Permanent?: any },
  ResolversTypes["StaffType"]
>;

export type StandardPlanAccommodationReservationProviderResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["StandardPlanAccommodationReservationProvider"] =
    ResolversParentTypes["StandardPlanAccommodationReservationProvider"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  userSubscriptionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StayCreditBreakdownItemResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayCreditBreakdownItem"] =
    ResolversParentTypes["StayCreditBreakdownItem"],
> = {
  amount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  reservationId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
};

export type StayCreditEstimateResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayCreditEstimate"] =
    ResolversParentTypes["StayCreditEstimate"],
> = {
  activatable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  breakdown?: Resolver<
    Array<ResolversTypes["StayCreditBreakdownItem"]>,
    ParentType,
    ContextType
  >;
  qualifyingStayCount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  remainingStayCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  total?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type StayDirectAccommodationReservationProviderResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["StayDirectAccommodationReservationProvider"] =
    ResolversParentTypes["StayDirectAccommodationReservationProvider"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StayGiftExportItemResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayGiftExportItem"] =
    ResolversParentTypes["StayGiftExportItem"],
> = {
  code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  invitationUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  issuedAt?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes["StayTicketStatusType"],
    ParentType,
    ContextType
  >;
  validFrom?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  validTo?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
};

export type StayReviewResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReview"] =
    ResolversParentTypes["StayReview"],
> = {
  comment?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  commentForSigns?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  desiredFoodExperiences?: Resolver<
    Maybe<Array<ResolversTypes["StayReviewFoodExperienceType"]>>,
    ParentType,
    ContextType
  >;
  experiencesDuringStay?: Resolver<
    Maybe<Array<ResolversTypes["StayReviewExperienceType"]>>,
    ParentType,
    ContextType
  >;
  foodExperienceImpression?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  improvementPointFree?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  improvementPoints?: Resolver<
    Maybe<Array<ResolversTypes["String"]>>,
    ParentType,
    ContextType
  >;
  overallImpressionForExperience?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  rating?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  sawPoster?: Resolver<
    Maybe<Array<ResolversTypes["StayReviewPosterViewType"]>>,
    ParentType,
    ContextType
  >;
  signAndBrightnessInSite?: Resolver<
    Maybe<ResolversTypes["StayReviewSignResponseType"]>,
    ParentType,
    ContextType
  >;
  signForApproach?: Resolver<
    Maybe<ResolversTypes["StayReviewSignResponseType"]>,
    ParentType,
    ContextType
  >;
  signForParking?: Resolver<
    Maybe<ResolversTypes["StayReviewSignResponseType"]>,
    ParentType,
    ContextType
  >;
  signForWayToSite?: Resolver<
    Maybe<ResolversTypes["StayReviewSignResponseType"]>,
    ParentType,
    ContextType
  >;
  usedFoodExperiences?: Resolver<
    Maybe<Array<ResolversTypes["StayReviewFoodExperienceType"]>>,
    ParentType,
    ContextType
  >;
};

export type StayReviewAxisResolvers = EnumResolverSignature<
  {
    ArchitectureAndNature?: any;
    Cleaning?: any;
    Equipment?: any;
    GuidanceAndSupport?: any;
  },
  ResolversTypes["StayReviewAxis"]
>;

export type StayReviewAxisDefinitionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewAxisDefinition"] =
    ResolversParentTypes["StayReviewAxisDefinition"],
> = {
  axis?: Resolver<ResolversTypes["StayReviewAxis"], ParentType, ContextType>;
  concernKinds?: Resolver<
    Array<ResolversTypes["StayReviewConcernKindDefinition"]>,
    ParentType,
    ContextType
  >;
  description?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type StayReviewConcernDetailResolvers = EnumResolverSignature<
  {
    CheckInProcedureUnclear?: any;
    CheckOutGuideNotFound?: any;
    CheckOutTooManyTasks?: any;
    DarkAtNight?: any;
    FarFromShops?: any;
    FarFromStationOrAirport?: any;
    FewRestaurants?: any;
    KeyDidNotOpen?: any;
    NarrowRoad?: any;
    NoiseFromEquipment?: any;
    NoiseFromNeighborRoom?: any;
    NoiseFromOutside?: any;
    ParkingFarOrRoughRoad?: any;
    ParkingLocationUnclear?: any;
    PoorSignalForKey?: any;
    RouteOrNavigationFailed?: any;
    SignageOrEntranceUnclear?: any;
    SupportOperatorQuality?: any;
    SupportSlowResponse?: any;
    SupportUnreachable?: any;
  },
  ResolversTypes["StayReviewConcernDetail"]
>;

export type StayReviewConcernDetailOptionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewConcernDetailOption"] =
    ResolversParentTypes["StayReviewConcernDetailOption"],
> = {
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  value?: Resolver<
    ResolversTypes["StayReviewConcernDetail"],
    ParentType,
    ContextType
  >;
};

export type StayReviewConcernKindResolvers = EnumResolverSignature<
  {
    ArchitectureAndNatureOther?: any;
    ArrivalGuidanceOrParking?: any;
    Breakage?: any;
    BuildingDefect?: any;
    CheckOut?: any;
    CleaningOther?: any;
    Dirt?: any;
    EquipmentOther?: any;
    GuidanceAndSupportOther?: any;
    Insects?: any;
    KeyOrCheckIn?: any;
    LocationAccess?: any;
    Noise?: any;
    Odor?: any;
    Shortage?: any;
    Support?: any;
    TrashOrHair?: any;
    UsageUnclear?: any;
  },
  ResolversTypes["StayReviewConcernKind"]
>;

export type StayReviewConcernKindDefinitionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewConcernKindDefinition"] =
    ResolversParentTypes["StayReviewConcernKindDefinition"],
> = {
  commentPlaceholder?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  details?: Resolver<
    Array<ResolversTypes["StayReviewConcernDetailOption"]>,
    ParentType,
    ContextType
  >;
  kind?: Resolver<
    ResolversTypes["StayReviewConcernKind"],
    ParentType,
    ContextType
  >;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type StayReviewExperienceTypeResolvers = EnumResolverSignature<
  {
    DrinkingCoffee?: any;
    MakingDinner?: any;
    NotApplicable?: any;
    PickingFlowers?: any;
  },
  ResolversTypes["StayReviewExperienceType"]
>;

export type StayReviewFoodExperienceTypeResolvers = EnumResolverSignature<
  {
    FrozenBread?: any;
    FrozenPizza?: any;
    HerbGarden?: any;
    NotUsedOrNotApplicable?: any;
    Soup?: any;
    Wine?: any;
  },
  ResolversTypes["StayReviewFoodExperienceType"]
>;

export type StayReviewFreeTextQuestionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewFreeTextQuestion"] =
    ResolversParentTypes["StayReviewFreeTextQuestion"],
> = {
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type StayReviewMemorableExperienceResolvers = EnumResolverSignature<
  {
    ComfortableSpace?: any;
    FocusedOnOwnTime?: any;
    NatureSoundsAndScenery?: any;
    OutdoorActivities?: any;
    SeasonsAndCreatures?: any;
    TimeWithFamilyAndFriends?: any;
  },
  ResolversTypes["StayReviewMemorableExperience"]
>;

export type StayReviewMemorableExperienceOptionResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["StayReviewMemorableExperienceOption"] =
    ResolversParentTypes["StayReviewMemorableExperienceOption"],
> = {
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  value?: Resolver<
    ResolversTypes["StayReviewMemorableExperience"],
    ParentType,
    ContextType
  >;
};

export type StayReviewPosterViewTypeResolvers = EnumResolverSignature<
  {
    NotSeenOrNoticed?: any;
    SeenAndLiked?: any;
    SeenAndWantToTry?: any;
    SeenButNoImpression?: any;
    TookPosterHome?: any;
    TriedExperience?: any;
  },
  ResolversTypes["StayReviewPosterViewType"]
>;

export type StayReviewQuestionnaireResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewQuestionnaire"] =
    ResolversParentTypes["StayReviewQuestionnaire"],
> = {
  freeTextAfterCheckOut?: Resolver<
    ResolversTypes["StayReviewFreeTextQuestion"],
    ParentType,
    ContextType
  >;
  freeTextAtCheckOut?: Resolver<
    ResolversTypes["StayReviewFreeTextQuestion"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  selectionAfterCheckOut?: Resolver<
    ResolversTypes["StayReviewSelectionQuestion"],
    ParentType,
    ContextType
  >;
  selectionAtCheckOut?: Resolver<
    ResolversTypes["StayReviewSelectionQuestion"],
    ParentType,
    ContextType
  >;
};

export type StayReviewResponseResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewResponse"] =
    ResolversParentTypes["StayReviewResponse"],
> = {
  createdAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  freeTextAfterCheckOutAnswer?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  freeTextAtCheckOutAnswer?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  questionnaire?: Resolver<
    ResolversTypes["StayReviewQuestionnaire"],
    ParentType,
    ContextType
  >;
  rating?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  selectionAfterCheckOutAnswer?: Resolver<
    Array<ResolversTypes["StayReviewSelectionOption"]>,
    ParentType,
    ContextType
  >;
  selectionAtCheckOutAnswer?: Resolver<
    Array<ResolversTypes["StayReviewSelectionOption"]>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StayReviewResponseWithReservationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewResponseWithReservation"] =
    ResolversParentTypes["StayReviewResponseWithReservation"],
> = {
  accommodationReservation?: Resolver<
    ResolversTypes["AccommodationReservation"],
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  freeTextAfterCheckOutAnswer?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  freeTextAtCheckOutAnswer?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  questionnaire?: Resolver<
    ResolversTypes["StayReviewQuestionnaire"],
    ParentType,
    ContextType
  >;
  rating?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  selectionAfterCheckOutAnswer?: Resolver<
    Array<ResolversTypes["StayReviewSelectionOption"]>,
    ParentType,
    ContextType
  >;
  selectionAtCheckOutAnswer?: Resolver<
    Array<ResolversTypes["StayReviewSelectionOption"]>,
    ParentType,
    ContextType
  >;
};

export type StayReviewSelectionOptionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewSelectionOption"] =
    ResolversParentTypes["StayReviewSelectionOption"],
> = {
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type StayReviewSelectionQuestionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewSelectionQuestion"] =
    ResolversParentTypes["StayReviewSelectionQuestion"],
> = {
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  options?: Resolver<
    Array<ResolversTypes["StayReviewSelectionOption"]>,
    ParentType,
    ContextType
  >;
  title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type StayReviewSignResponseTypeResolvers = EnumResolverSignature<
  { Difficult?: any; NoProblem?: any; NotUseOrRemember?: any },
  ResolversTypes["StayReviewSignResponseType"]
>;

export type StayReviewV2Resolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewV2"] =
    ResolversParentTypes["StayReviewV2"],
> = {
  architectureAndNatureRating?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  cleaningRating?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  comment?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  concerns?: Resolver<
    Array<ResolversTypes["StayReviewV2Concern"]>,
    ParentType,
    ContextType
  >;
  equipmentRating?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  guidanceAndSupportRating?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  memorableExperiences?: Resolver<
    Array<ResolversTypes["StayReviewMemorableExperience"]>,
    ParentType,
    ContextType
  >;
  submittedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StayReviewV2ConcernResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewV2Concern"] =
    ResolversParentTypes["StayReviewV2Concern"],
> = {
  comment?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  details?: Resolver<
    Array<ResolversTypes["StayReviewConcernDetail"]>,
    ParentType,
    ContextType
  >;
  kind?: Resolver<
    ResolversTypes["StayReviewConcernKind"],
    ParentType,
    ContextType
  >;
};

export type StayReviewV2ErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewV2Error"] =
    ResolversParentTypes["StayReviewV2Error"],
> = {
  case?: Resolver<
    ResolversTypes["StayReviewV2ErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StayReviewV2ErrorCaseResolvers = EnumResolverSignature<
  {
    AlreadySubmitted?: any;
    NotAuthorized?: any;
    OutOfPeriod?: any;
    ValidationError?: any;
  },
  ResolversTypes["StayReviewV2ErrorCase"]
>;

export type StayReviewV2FormResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayReviewV2Form"] =
    ResolversParentTypes["StayReviewV2Form"],
> = {
  axes?: Resolver<
    Array<ResolversTypes["StayReviewAxisDefinition"]>,
    ParentType,
    ContextType
  >;
  memorableExperiences?: Resolver<
    Array<ResolversTypes["StayReviewMemorableExperienceOption"]>,
    ParentType,
    ContextType
  >;
};

export type StayTicketResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayTicket"] =
    ResolversParentTypes["StayTicket"],
> = {
  accommodationReservations?: Resolver<
    Array<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType
  >;
  code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  createdByUser?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType
  >;
  destinationEmail?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  expiresAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  master?: Resolver<
    Maybe<ResolversTypes["StayTicketMaster"]>,
    ParentType,
    ContextType
  >;
  reservationInfo?: Resolver<
    ResolversTypes["StayTicketReservationInfo"],
    ParentType,
    ContextType
  >;
  reservedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes["StayTicketStatusType"],
    ParentType,
    ContextType
  >;
  stayEndNight?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  stayStartNight?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
  userOwnership?: Resolver<
    Maybe<ResolversTypes["UserOwnership"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StayTicketAccommodationReservationProviderResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["StayTicketAccommodationReservationProvider"] =
    ResolversParentTypes["StayTicketAccommodationReservationProvider"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  stayTicketUnitId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StayTicketAcquisitionModeResolvers = EnumResolverSignature<
  { OwnerNightExchange?: any; Purchase?: any },
  ResolversTypes["StayTicketAcquisitionMode"]
>;

export type StayTicketMasterResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayTicketMaster"] =
    ResolversParentTypes["StayTicketMaster"],
> = {
  additionalGuestFeePolicy?: Resolver<
    Maybe<ResolversTypes["AdditionalGuestFeePolicy"]>,
    ParentType,
    ContextType
  >;
  additionalNoticeTypes?: Resolver<
    Array<ResolversTypes["AdditionalNoticeType"]>,
    ParentType,
    ContextType
  >;
  availableAccommodationFacilities?: Resolver<
    Array<ResolversTypes["AccommodationFacility"]>,
    ParentType,
    ContextType
  >;
  availableArchitectureTypes?: Resolver<
    Array<ResolversTypes["ArchitectureType"]>,
    ParentType,
    ContextType
  >;
  availableSites?: Resolver<
    Array<ResolversTypes["Site"]>,
    ParentType,
    ContextType
  >;
  baseAccommodationFeeMode?: Resolver<
    ResolversTypes["BaseAccommodationFeeMode"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  includeSeasonalFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  internalDescription?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  isArchived?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isBulkUsage?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  lookupKey?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  notice?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  occupancyLimitTarget?: Resolver<
    ResolversTypes["OccupancyLimitTarget"],
    ParentType,
    ContextType
  >;
  rawBaseAccommodationFeePolicy?: Resolver<
    ResolversTypes["RawBaseAccommodationFeePolicy"],
    ParentType,
    ContextType
  >;
  rawCancelFeePolicy?: Resolver<
    ResolversTypes["RawCancelFeePolicy"],
    ParentType,
    ContextType
  >;
  staffGroup?: Resolver<
    Maybe<ResolversTypes["StaffGroup"]>,
    ParentType,
    ContextType
  >;
  stayTickets?: Resolver<
    Array<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType,
    RequireFields<StayTicketMasterstayTicketsArgs, "includeExpiredTicket">
  >;
  template?: Resolver<
    Maybe<ResolversTypes["StayTicketMasterTemplate"]>,
    ParentType,
    ContextType
  >;
  templates?: Resolver<
    Array<ResolversTypes["StayTicketTemplate"]>,
    ParentType,
    ContextType
  >;
  ticketCategory?: Resolver<
    Maybe<ResolversTypes["TicketCategory"]>,
    ParentType,
    ContextType
  >;
  waiveArchitectureTypeAdditionalFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveCleaningFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveConsumedSuppliesFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveDogFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waiveDogRunFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waiveEvChargerFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveOnsenFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waivePeakDayFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveSaunaFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waiveSiteAdditionalFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StayTicketMasterTemplateResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayTicketMasterTemplate"] =
    ResolversParentTypes["StayTicketMasterTemplate"],
> = {
  additionalGuestFeePolicy?: Resolver<
    Maybe<ResolversTypes["AdditionalGuestFeePolicy"]>,
    ParentType,
    ContextType
  >;
  availableAccommodationFacilities?: Resolver<
    Array<ResolversTypes["AccommodationFacility"]>,
    ParentType,
    ContextType
  >;
  availableArchitectureTypes?: Resolver<
    Array<ResolversTypes["ArchitectureType"]>,
    ParentType,
    ContextType
  >;
  availableSites?: Resolver<
    Array<ResolversTypes["Site"]>,
    ParentType,
    ContextType
  >;
  baseAccommodationFeeMode?: Resolver<
    ResolversTypes["BaseAccommodationFeeMode"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  includeSeasonalFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  internalDescription?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  isBulkUsage?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  occupancyLimitTarget?: Resolver<
    ResolversTypes["OccupancyLimitTarget"],
    ParentType,
    ContextType
  >;
  rawBaseAccommodationFeePolicy?: Resolver<
    Maybe<ResolversTypes["RawBaseAccommodationFeePolicy"]>,
    ParentType,
    ContextType
  >;
  rawCancelFeePolicy?: Resolver<
    Maybe<ResolversTypes["RawCancelFeePolicy"]>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  waiveArchitectureTypeAdditionalFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveCleaningFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveConsumedSuppliesFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveDogFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waiveDogRunFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waiveEvChargerFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveOnsenFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waivePeakDayFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveSaunaFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waiveSiteAdditionalFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StayTicketReservationInfoResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayTicketReservationInfo"] =
    ResolversParentTypes["StayTicketReservationInfo"],
> = {
  additionalGuestFeeAdultPricePerNight?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  additionalGuestFeeKidsPricePerNight?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  additionalGuestFeeStartsAt?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  additionalNoticeTypes?: Resolver<
    Array<ResolversTypes["AdditionalNoticeType"]>,
    ParentType,
    ContextType
  >;
  availableAccommodationFacilityTypes?: Resolver<
    Array<ResolversTypes["AccommodationFacilityType"]>,
    ParentType,
    ContextType
  >;
  availableArchitectureTypes?: Resolver<
    Array<ResolversTypes["ArchitectureType"]>,
    ParentType,
    ContextType
  >;
  availableSites?: Resolver<
    Array<ResolversTypes["Site"]>,
    ParentType,
    ContextType
  >;
  cancelFeePolicy?: Resolver<
    ResolversTypes["CancelFeePolicy"],
    ParentType,
    ContextType
  >;
  discounts?: Resolver<
    Array<ResolversTypes["AccommodationFeeDiscount"]>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  notice?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  ownerPlanType?: Resolver<
    Maybe<ResolversTypes["OwnerPlanType"]>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes["StayTicketType"], ParentType, ContextType>;
  waiveCleaningFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveConsumedSuppliesFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveDogFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waiveEvChargerFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  waiveOnsenFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  waiveSaunaFee?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
};

export type StayTicketStatusTypeResolvers = EnumResolverSignature<
  { Expired?: any; Open?: any; Reserved?: any; Stayed?: any; Void?: any },
  ResolversTypes["StayTicketStatusType"]
>;

export type StayTicketTemplateResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayTicketTemplate"] =
    ResolversParentTypes["StayTicketTemplate"],
> = {
  createdAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  daysUntilExpiration?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  daysUntilLastStay?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  expiresAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  lookupKey?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  master?: Resolver<
    ResolversTypes["StayTicketMaster"],
    ParentType,
    ContextType
  >;
  rawExpiresAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  rawStayEndNight?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  rawStayStartNight?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  stayEndNight?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  stayStartNight?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StayTicketTypeResolvers = EnumResolverSignature<
  { Regular?: any; StayGiftFromOwners?: any },
  ResolversTypes["StayTicketType"]
>;

export type StayTicketUnitResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayTicketUnit"] =
    ResolversParentTypes["StayTicketUnit"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  reservationInfo?: Resolver<
    ResolversTypes["StayTicketReservationInfo"],
    ParentType,
    ContextType
  >;
  stayEndNight?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  stayStartNight?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
  stayTicketMasterId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  stayTickets?: Resolver<
    Array<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType
  >;
};

export type StayTicketValidationErrorResolvers = EnumResolverSignature<
  {
    Duplicate?: any;
    Expired?: any;
    MasterMismatch?: any;
    NotFound?: any;
    UnitFull?: any;
    Unusable?: any;
  },
  ResolversTypes["StayTicketValidationError"]
>;

export type StayTicketValidationResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StayTicketValidationResult"] =
    ResolversParentTypes["StayTicketValidationResult"],
> = {
  stayTicketCode?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  validationError?: Resolver<
    Maybe<ResolversTypes["StayTicketValidationError"]>,
    ParentType,
    ContextType
  >;
};

export type StripeCardResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StripeCard"] =
    ResolversParentTypes["StripeCard"],
> = {
  brand?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  exp_month?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  exp_year?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  last4?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type StripeCollectionMethodResolvers = EnumResolverSignature<
  { charge_automatically?: any; send_invoice?: any },
  ResolversTypes["StripeCollectionMethod"]
>;

export type StripeCustomerResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StripeCustomer"] =
    ResolversParentTypes["StripeCustomer"],
> = {
  customerId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  defaultCard?: Resolver<
    Maybe<ResolversTypes["StripeCard"]>,
    ParentType,
    ContextType
  >;
  invoices?: Resolver<
    Array<ResolversTypes["StripeInvoice"]>,
    ParentType,
    ContextType,
    Partial<StripeCustomerinvoicesArgs>
  >;
};

export type StripeInvoiceResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StripeInvoice"] =
    ResolversParentTypes["StripeInvoice"],
> = {
  collection_method?: Resolver<
    Maybe<ResolversTypes["StripeCollectionMethod"]>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  hosted_invoice_url?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  metadata_list?: Resolver<
    Array<ResolversTypes["StripeMetadataItem"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes["StripeInvoiceStatus"],
    ParentType,
    ContextType
  >;
  status_transitions?: Resolver<
    Maybe<ResolversTypes["StripeInvoiceStatusTransitions"]>,
    ParentType,
    ContextType
  >;
  subscription?: Resolver<
    Maybe<ResolversTypes["StripeInvoiceSubscription"]>,
    ParentType,
    ContextType
  >;
  total?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type StripeInvoiceStatusResolvers = EnumResolverSignature<
  { draft?: any; open?: any; paid?: any; uncollectible?: any; void?: any },
  ResolversTypes["StripeInvoiceStatus"]
>;

export type StripeInvoiceStatusTransitionsResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StripeInvoiceStatusTransitions"] =
    ResolversParentTypes["StripeInvoiceStatusTransitions"],
> = {
  paid_at?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
};

export type StripeInvoiceSubscriptionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StripeInvoiceSubscription"] =
    ResolversParentTypes["StripeInvoiceSubscription"],
> = {
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
};

export type StripeMetadataItemResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StripeMetadataItem"] =
    ResolversParentTypes["StripeMetadataItem"],
> = {
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  value?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type StripeRequireNextActionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["StripeRequireNextAction"] =
    ResolversParentTypes["StripeRequireNextAction"],
> = {
  clientSecret?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  coOwnersApplicationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubmitAdHocQuestionnaireResponseErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["SubmitAdHocQuestionnaireResponseError"] =
    ResolversParentTypes["SubmitAdHocQuestionnaireResponseError"],
> = {
  case?: Resolver<
    ResolversTypes["SubmitAdHocQuestionnaireResponseErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubmitAdHocQuestionnaireResponseErrorCaseResolvers =
  EnumResolverSignature<
    { GeneralError?: any; TemplateNotFound?: any },
    ResolversTypes["SubmitAdHocQuestionnaireResponseErrorCase"]
  >;

export type SubmitAdHocQuestionnaireResponsePayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["SubmitAdHocQuestionnaireResponsePayload"] =
    ResolversParentTypes["SubmitAdHocQuestionnaireResponsePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "SubmitAdHocQuestionnaireResponseError" | "Success",
    ParentType,
    ContextType
  >;
};

export type SubmitCoOwnersApplicationErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SubmitCoOwnersApplicationError"] =
    ResolversParentTypes["SubmitCoOwnersApplicationError"],
> = {
  case?: Resolver<
    ResolversTypes["SubmitCoOwnersApplicationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubmitCoOwnersApplicationErrorCaseResolvers = EnumResolverSignature<
  {
    IdDocument1Invalid?: any;
    IdDocument2Invalid?: any;
    InvalidRequest?: any;
    NoBeneficialOwnerRelationshipFree?: any;
    NoBusinessActivityFree?: any;
    NoIndividualEmployerName?: any;
    NoPurchasePurposeFree?: any;
    NoSomeOfOrganizationName?: any;
    PaymentFailed?: any;
    PaymentRequiresAction?: any;
    RegistryCertificateInvalid?: any;
    UnitsOutOfRange?: any;
  },
  ResolversTypes["SubmitCoOwnersApplicationErrorCase"]
>;

export type SubmitCoOwnersApplicationPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SubmitCoOwnersApplicationPayload"] =
    ResolversParentTypes["SubmitCoOwnersApplicationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "CoOwnersApplication"
    | "StripeRequireNextAction"
    | "SubmitCoOwnersApplicationError",
    ParentType,
    ContextType
  >;
};

export type SubmitStayReviewV2PayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SubmitStayReviewV2Payload"] =
    ResolversParentTypes["SubmitStayReviewV2Payload"],
> = {
  __resolveType?: TypeResolveFn<
    "StayReviewV2" | "StayReviewV2Error",
    ParentType,
    ContextType
  >;
};

export type SuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Success"] =
    ResolversParentTypes["Success"],
> = {
  _?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplyItemResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SupplyItem"] =
    ResolversParentTypes["SupplyItem"],
> = {
  defaultQuantity?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  master?: Resolver<
    ResolversTypes["SupplyItemMaster"],
    ParentType,
    ContextType
  >;
};

export type SupplyItemInstallationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SupplyItemInstallation"] =
    ResolversParentTypes["SupplyItemInstallation"],
> = {
  accommodation?: Resolver<
    Maybe<ResolversTypes["Accommodation"]>,
    ParentType,
    ContextType
  >;
  architectureType?: Resolver<
    Maybe<ResolversTypes["ArchitectureType"]>,
    ParentType,
    ContextType
  >;
  defaultQuantity?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
};

export type SupplyItemMasterResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["SupplyItemMaster"] =
    ResolversParentTypes["SupplyItemMaster"],
> = {
  category?: Resolver<
    ResolversTypes["SupplyItemMasterCategory"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  namePrivate?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  namePublic?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  price?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  sort?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  taxRateType?: Resolver<
    ResolversTypes["ConsumptionTaxRateType"],
    ParentType,
    ContextType
  >;
  unit?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplyItemMasterCategoryResolvers = EnumResolverSignature<
  {
    Bread?: any;
    CoffeeBean?: any;
    Curry?: any;
    Firewood?: any;
    FrozenDessert?: any;
    Other?: any;
    Pizza?: any;
    Rice?: any;
    Soup?: any;
    Toothbrush?: any;
    Wine?: any;
  },
  ResolversTypes["SupplyItemMasterCategory"]
>;

export type TargetPlanTypeResolvers = EnumResolverSignature<
  {
    BusinessSubscription?: any;
    CoOwners?: any;
    FullOwner?: any;
    IndividualSubscription?: any;
    NoPlan?: any;
  },
  ResolversTypes["TargetPlanType"]
>;

export type TentativeAccommodationReservationErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["TentativeAccommodationReservationError"] =
    ResolversParentTypes["TentativeAccommodationReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["TentativeAccommodationReservationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TentativeAccommodationReservationErrorCaseResolvers =
  EnumResolverSignature<
    {
      Expired?: any;
      NotAuthorized?: any;
      NotFound?: any;
      OneMoreCabinParentReservationUser?: any;
    },
    ResolversTypes["TentativeAccommodationReservationErrorCase"]
  >;

export type TentativeAccommodationReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["TentativeAccommodationReservationPayload"] =
    ResolversParentTypes["TentativeAccommodationReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    | "AccommodationReservation"
    | "RedirectLocation"
    | "TentativeAccommodationReservationError",
    ParentType,
    ContextType
  >;
};

export type TermsResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["Terms"] =
    ResolversParentTypes["Terms"],
> = {
  documentUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  ownerPlan?: Resolver<
    Maybe<ResolversTypes["OwnerPlan"]>,
    ParentType,
    ContextType
  >;
  plan?: Resolver<ResolversTypes["TermsPlanType"], ParentType, ContextType>;
  revisions?: Resolver<
    Array<ResolversTypes["TermsRevision"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TermsPlanTypeResolvers = EnumResolverSignature<
  {
    BusinessPlan?: any;
    CoOwnersPlan?: any;
    FullOwnerPlan?: any;
    StandardPlan?: any;
  },
  ResolversTypes["TermsPlanType"]
>;

export type TermsRevisionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["TermsRevision"] =
    ResolversParentTypes["TermsRevision"],
> = {
  description?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  internalSummary?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  news?: Resolver<Maybe<ResolversTypes["News"]>, ParentType, ContextType>;
  revisedDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  targetOwnerPlan?: Resolver<
    Maybe<ResolversTypes["OwnerPlan"]>,
    ParentType,
    ContextType
  >;
  terms?: Resolver<ResolversTypes["Terms"], ParentType, ContextType>;
};

export type TicketCategoryResolvers = EnumResolverSignature<
  {
    StayGift?: any;
    StaySelfBooking?: any;
    Tieup?: any;
    TieupSeparateBilling?: any;
    TrialFree?: any;
    TrialPaid?: any;
  },
  ResolversTypes["TicketCategory"]
>;

export type TopPageResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["TopPage"] =
    ResolversParentTypes["TopPage"],
> = {
  archiveArticle?: Resolver<
    Maybe<ResolversTypes["ArchiveArticle"]>,
    ParentType,
    ContextType
  >;
  bannerContents?: Resolver<
    Array<ResolversTypes["TopPageBannerContent"]>,
    ParentType,
    ContextType
  >;
  news?: Resolver<Maybe<ResolversTypes["News"]>, ParentType, ContextType>;
  serviceUpdate?: Resolver<
    Maybe<ResolversTypes["ServiceUpdate"]>,
    ParentType,
    ContextType
  >;
};

export type TopPageBannerContentResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["TopPageBannerContent"] =
    ResolversParentTypes["TopPageBannerContent"],
> = {
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  url?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type TrialContractResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["TrialContract"] =
    ResolversParentTypes["TrialContract"],
> = {
  accumulatedS2oAmount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  appliedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  cancelledAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  currentPeriodGrantedStayCredits?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  currentPeriodStayCredits?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  endDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  enrolledAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  enrolledDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  firstSemesterEndDate?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
  firstSemesterGrantedStayCredits?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  firstSemesterRemainingPeakDays?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  firstSemesterStayCredits?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  remainingPeakDays?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  remainingStayCredits?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  secondSemesterGrantedStayCredits?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  secondSemesterRemainingPeakDays?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  secondSemesterStartDate?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
  secondSemesterStayCredits?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes["TrialContractStatus"],
    ParentType,
    ContextType
  >;
  statusDetail?: Resolver<
    ResolversTypes["TrialContractStatusDetail"],
    ParentType,
    ContextType
  >;
  stripeSubscriptionId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  stripeSubscriptionScheduleId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  suspended?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  suspendedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  terminatedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  totalStayCredits?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type TrialContractStatusResolvers = EnumResolverSignature<
  { Neutral?: any; Planned?: any; Usable?: any },
  ResolversTypes["TrialContractStatus"]
>;

export type TrialContractStatusDetailResolvers = EnumResolverSignature<
  {
    NeutralDefault?: any;
    NeutralTerminated?: any;
    PlannedDefault?: any;
    UsableDefault?: any;
  },
  ResolversTypes["TrialContractStatusDetail"]
>;

export type TrialPlanAccommodationReservationProviderResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["TrialPlanAccommodationReservationProvider"] =
    ResolversParentTypes["TrialPlanAccommodationReservationProvider"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  trialContractId?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAccommodationReservationOptionsErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["UpdateAccommodationReservationOptionsError"] =
    ResolversParentTypes["UpdateAccommodationReservationOptionsError"],
> = {
  case?: Resolver<
    ResolversTypes["UpdateAccommodationReservationOptionsErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAccommodationReservationOptionsErrorCaseResolvers =
  EnumResolverSignature<
    { DeniedByStatus?: any; UnknownError?: any },
    ResolversTypes["UpdateAccommodationReservationOptionsErrorCase"]
  >;

export type UpdateAccommodationReservationOptionsPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["UpdateAccommodationReservationOptionsPayload"] =
    ResolversParentTypes["UpdateAccommodationReservationOptionsPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "AccommodationReservation" | "UpdateAccommodationReservationOptionsError",
    ParentType,
    ContextType
  >;
};

export type UpdateCoOwnersApplicationOwnerInfoErrorResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["UpdateCoOwnersApplicationOwnerInfoError"] =
    ResolversParentTypes["UpdateCoOwnersApplicationOwnerInfoError"],
> = {
  case?: Resolver<
    ResolversTypes["UpdateCoOwnersApplicationOwnerInfoErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCoOwnersApplicationOwnerInfoErrorCaseResolvers =
  EnumResolverSignature<
    { DetailTypeMismatch?: any; NotFound?: any; Unauthorized?: any },
    ResolversTypes["UpdateCoOwnersApplicationOwnerInfoErrorCase"]
  >;

export type UpdateCoOwnersApplicationOwnerInfoPayloadResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["UpdateCoOwnersApplicationOwnerInfoPayload"] =
    ResolversParentTypes["UpdateCoOwnersApplicationOwnerInfoPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "CoOwnersApplication" | "UpdateCoOwnersApplicationOwnerInfoError",
    ParentType,
    ContextType
  >;
};

export type UpdateFacilityReservationErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UpdateFacilityReservationError"] =
    ResolversParentTypes["UpdateFacilityReservationError"],
> = {
  case?: Resolver<
    ResolversTypes["UpdateFacilityReservationErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateFacilityReservationErrorCaseResolvers = EnumResolverSignature<
  {
    CommentPeriodExpired?: any;
    InvalidAttribute?: any;
    InvalidTransition?: any;
    NotAuthorized?: any;
    OutsideUsablePeriod?: any;
    ReservationNotFound?: any;
    UsageFlowNotSupported?: any;
  },
  ResolversTypes["UpdateFacilityReservationErrorCase"]
>;

export type UpdateFacilityReservationPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UpdateFacilityReservationPayload"] =
    ResolversParentTypes["UpdateFacilityReservationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "UpdateFacilityReservationError" | "UpdateFacilityReservationSuccess",
    ParentType,
    ContextType
  >;
};

export type UpdateFacilityReservationSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UpdateFacilityReservationSuccess"] =
    ResolversParentTypes["UpdateFacilityReservationSuccess"],
> = {
  reservation?: Resolver<
    ResolversTypes["FacilityReservation"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadedFileResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UploadedFile"] =
    ResolversParentTypes["UploadedFile"],
> = {
  caption?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  rawUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  url?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type UserResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["User"] =
    ResolversParentTypes["User"],
> = {
  acceptMarketingEmail?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  accessibleReservationCalendars?: Resolver<
    Array<ResolversTypes["AccessibleReservationCalendarType"]>,
    ParentType,
    ContextType
  >;
  accommodationReservations?: Resolver<
    Array<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType
  >;
  adHocQuestionnaireResponses?: Resolver<
    Array<ResolversTypes["AdHocQuestionnaireResponse"]>,
    ParentType,
    ContextType
  >;
  adminRoleAssignments?: Resolver<
    Array<ResolversTypes["AdminRoleAssignment"]>,
    ParentType,
    ContextType,
    RequireFields<UseradminRoleAssignmentsArgs, "includeInactive">
  >;
  allAccommodationReservations?: Resolver<
    Array<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType
  >;
  appInstallations?: Resolver<
    Array<ResolversTypes["UserAppInstallation"]>,
    ParentType,
    ContextType
  >;
  auth0Users?: Resolver<
    Array<ResolversTypes["Auth0User"]>,
    ParentType,
    ContextType
  >;
  bubbleId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  coOwnersApplications?: Resolver<
    Array<ResolversTypes["CoOwnersApplication"]>,
    ParentType,
    ContextType
  >;
  coOwnerships?: Resolver<
    Array<ResolversTypes["UserOwnership"]>,
    ParentType,
    ContextType
  >;
  companions?: Resolver<
    Maybe<Array<ResolversTypes["UserCompanion"]>>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  currentMonthUsedDrinkTicket?: Resolver<
    Maybe<ResolversTypes["MemberPerksNowhereDrinkTicket"]>,
    ParentType,
    ContextType
  >;
  deletedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  email?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  emailVerified?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  fullOwnerIdentityVerifications?: Resolver<
    Array<ResolversTypes["IdentityVerification"]>,
    ParentType,
    ContextType
  >;
  fullOwnerships?: Resolver<
    Array<ResolversTypes["UserOwnership"]>,
    ParentType,
    ContextType
  >;
  hasReservablePlan?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  hasUnpaidAccommodationFee?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  identities?: Resolver<
    Array<ResolversTypes["UserIdentity"]>,
    ParentType,
    ContextType
  >;
  intercomJwt?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  isAdmin?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isEligibleMemberForDrinkTicketPerks?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  isEligibleToPurchaseStayGift?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  isFilledRequiredProfile?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  isGuest?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isMember?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  maybeProfile?: Resolver<
    Maybe<ResolversTypes["UserProfile"]>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  nameKana?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  organization?: Resolver<
    Maybe<ResolversTypes["Organization"]>,
    ParentType,
    ContextType
  >;
  organizationMembership?: Resolver<
    Maybe<ResolversTypes["OrganizationMembership"]>,
    ParentType,
    ContextType
  >;
  personaMetrics?: Resolver<
    ResolversTypes["UserPersonaMetrics"],
    ParentType,
    ContextType
  >;
  phoneNumber?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  profile?: Resolver<ResolversTypes["UserProfile"], ParentType, ContextType>;
  requiredTermsAgreements?: Resolver<
    Array<ResolversTypes["TermsRevision"]>,
    ParentType,
    ContextType,
    Partial<UserrequiredTermsAgreementsArgs>
  >;
  s2o?: Resolver<ResolversTypes["S2o"], ParentType, ContextType>;
  staffContract?: Resolver<
    Maybe<ResolversTypes["StaffContract"]>,
    ParentType,
    ContextType
  >;
  stayCreditEstimate?: Resolver<
    ResolversTypes["StayCreditEstimate"],
    ParentType,
    ContextType
  >;
  stayTickets?: Resolver<
    Array<ResolversTypes["StayTicket"]>,
    ParentType,
    ContextType
  >;
  stayedReservationCount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  stripe?: Resolver<ResolversTypes["StripeCustomer"], ParentType, ContextType>;
  subscription?: Resolver<
    ResolversTypes["UserSubscription"],
    ParentType,
    ContextType
  >;
  systemSettings?: Resolver<
    ResolversTypes["UserSystemSettings"],
    ParentType,
    ContextType
  >;
  trialContract?: Resolver<
    Maybe<ResolversTypes["TrialContract"]>,
    ParentType,
    ContextType
  >;
  unconfirmedAccommodationReservations?: Resolver<
    Array<ResolversTypes["AccommodationReservation"]>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<ResolversTypes["DateTime"], ParentType, ContextType>;
  zendeskId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
};

export type UserAppInstallationResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UserAppInstallation"] =
    ResolversParentTypes["UserAppInstallation"],
> = {
  createdAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  fcmToken?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  installationId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  platform?: Resolver<
    ResolversTypes["PushNotificationPlatform"],
    ParentType,
    ContextType
  >;
  registeredAppVersion?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  registeredDeviceModel?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  registeredOsVersion?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    ResolversTypes["ZonedDateTime"],
    ParentType,
    ContextType
  >;
  user?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
};

export type UserCompanionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UserCompanion"] =
    ResolversParentTypes["UserCompanion"],
> = {
  address?: Resolver<ResolversTypes["Address"], ParentType, ContextType>;
  birthDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  gender?: Resolver<ResolversTypes["GenderType"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  nationality?: Resolver<
    Maybe<ResolversTypes["CountryEnum"]>,
    ParentType,
    ContextType
  >;
  passportNumber?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  passportPhoto?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  phoneNumber?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  professionType?: Resolver<
    Maybe<ResolversTypes["UserProfileProfessionType"]>,
    ParentType,
    ContextType
  >;
};

export type UserFileTypeResolvers = EnumResolverSignature<
  {
    RegistryCertificate?: any;
    UserFacePhoto?: any;
    UserIdentityDocument1?: any;
    UserIdentityDocument2?: any;
    UserPassportPhoto?: any;
  },
  ResolversTypes["UserFileType"]
>;

export type UserIdentityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UserIdentity"] =
    ResolversParentTypes["UserIdentity"],
> = {
  autoGeneratedPassword?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  connection?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  emailVerified?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isAppleRelay?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isSocial?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isSyncedLocally?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  provider?: Resolver<
    ResolversTypes["IdentityProvider"],
    ParentType,
    ContextType
  >;
  userId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type UserMonthlyStatementResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UserMonthlyStatement"] =
    ResolversParentTypes["UserMonthlyStatement"],
> = {
  reservationStatements?: Resolver<
    Array<ResolversTypes["ReservationStatementItem"]>,
    ParentType,
    ContextType
  >;
  totalPrice?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  user?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
  yearMonth?: Resolver<
    ResolversTypes["PlainYearMonth"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOwnershipResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UserOwnership"] =
    ResolversParentTypes["UserOwnership"],
> = {
  coOwnersApplication?: Resolver<
    Maybe<ResolversTypes["CoOwnersApplication"]>,
    ParentType,
    ContextType
  >;
  currentYearStatus?: Resolver<
    ResolversTypes["UserOwnershipProgramYearStatus"],
    ParentType,
    ContextType
  >;
  holderName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  maxPeakDaysPerYear?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  maxSiteHighSeasonDaysPerYear?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  nextPaymentDate?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
  nextYearStatus?: Resolver<
    Maybe<ResolversTypes["UserOwnershipProgramYearStatus"]>,
    ParentType,
    ContextType
  >;
  nightsPerYear?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  plan?: Resolver<ResolversTypes["OwnerPlan"], ParentType, ContextType>;
  units?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  usageEndDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  usageStartDate?: Resolver<
    ResolversTypes["PlainDate"],
    ParentType,
    ContextType
  >;
  user?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
};

export type UserOwnershipProgramYearStatusResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UserOwnershipProgramYearStatus"] =
    ResolversParentTypes["UserOwnershipProgramYearStatus"],
> = {
  endDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  remainingNights?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  remainingPeakDays?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  remainingSiteHighSeasonDays?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  startDate?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  year?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type UserPersonaMetricsResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UserPersonaMetrics"] =
    ResolversParentTypes["UserPersonaMetrics"],
> = {
  exploration?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  investment?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  loyalty?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  seasonality?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type UserProfileResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UserProfile"] =
    ResolversParentTypes["UserProfile"],
> = {
  address?: Resolver<Maybe<ResolversTypes["Address"]>, ParentType, ContextType>;
  birthDate?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  carOwnershipStatus?: Resolver<
    Maybe<ResolversTypes["UserProfileCarOwnershipStatus"]>,
    ParentType,
    ContextType
  >;
  facePhoto?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  gender?: Resolver<
    Maybe<ResolversTypes["GenderType"]>,
    ParentType,
    ContextType
  >;
  householdComposition?: Resolver<
    Maybe<ResolversTypes["UserProfileHouseholdComposition"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  nationality?: Resolver<
    Maybe<ResolversTypes["CountryEnum"]>,
    ParentType,
    ContextType
  >;
  numberOfDogs?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  passportNumber?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  passportPhoto?: Resolver<
    Maybe<ResolversTypes["UploadedFile"]>,
    ParentType,
    ContextType
  >;
  professionFree?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  professionType?: Resolver<
    Maybe<ResolversTypes["UserProfileProfessionType"]>,
    ParentType,
    ContextType
  >;
  user?: Resolver<ResolversTypes["User"], ParentType, ContextType>;
};

export type UserProfileCarOwnershipStatusResolvers = EnumResolverSignature<
  { WithCarShare?: any; WithOwnCar?: any; WithoutAny?: any },
  ResolversTypes["UserProfileCarOwnershipStatus"]
>;

export type UserProfileHouseholdCompositionResolvers = EnumResolverSignature<
  { FamilyWithKids?: any; FamilyWithoutKids?: any; Other?: any; Single?: any },
  ResolversTypes["UserProfileHouseholdComposition"]
>;

export type UserProfileProfessionTypeResolvers = EnumResolverSignature<
  {
    CivilServant?: any;
    CivilServantOrOrganizationEmployee?: any;
    CompanyEmployee?: any;
    CompanyEmployeeOffice?: any;
    CompanyEmployeeRemote?: any;
    ExecutiveOrDirector?: any;
    ExecutiveOrProfessional?: any;
    FullTimeHomemaker?: any;
    OrganizationEmployee?: any;
    Other?: any;
    ProfessorOrTeacher?: any;
    SelfEmployedOrFreelancer?: any;
    Student?: any;
    UnemployedOrMinor?: any;
  },
  ResolversTypes["UserProfileProfessionType"]
>;

export type UserSubscriptionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UserSubscription"] =
    ResolversParentTypes["UserSubscription"],
> = {
  accumulatedS2oAmount?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  appliedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  billingCycleDay?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  enrolledAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  enrollmentScheduledAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  next7DaysReservationPeriod?: Resolver<
    Maybe<ResolversTypes["UserSubscriptionNext7DaysReservationPeriod"]>,
    ParentType,
    ContextType
  >;
  pausableDates?: Resolver<
    Array<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  pausableFrom?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  pauseScheduledAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  pausedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  requiresWeekdayTermsAgreement?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  reservationCycle?: Resolver<
    Maybe<ResolversTypes["UserSubscriptionReservationCycle"]>,
    ParentType,
    ContextType
  >;
  reservationCyclePeriods?: Resolver<
    Array<ResolversTypes["UserSubscriptionReservationCyclePeriod"]>,
    ParentType,
    ContextType,
    RequireFields<UserSubscriptionreservationCyclePeriodsArgs, "limit">
  >;
  resumeScheduledAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  resumedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes["UserSubscriptionStatus"],
    ParentType,
    ContextType
  >;
  statusDetail?: Resolver<
    ResolversTypes["UserSubscriptionStatusDetail"],
    ParentType,
    ContextType
  >;
  stripeCurrentSubscriptionId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  stripeCurrentSubscriptionScheduleId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  stripeUpcomingSubscriptionScheduleId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  suspended?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  suspendedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  terminatableDate?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  terminatableFrom?: Resolver<
    Maybe<ResolversTypes["PlainDate"]>,
    ParentType,
    ContextType
  >;
  terminatedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  terminationProhibitReason?: Resolver<
    ResolversTypes["UserSubscriptionTerminationProhibitReason"],
    ParentType,
    ContextType
  >;
  terminationScheduledAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
  weekdayTermsAgreedAt?: Resolver<
    Maybe<ResolversTypes["ZonedDateTime"]>,
    ParentType,
    ContextType
  >;
};

export type UserSubscriptionNext7DaysReservationPeriodResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["UserSubscriptionNext7DaysReservationPeriod"] =
    ResolversParentTypes["UserSubscriptionNext7DaysReservationPeriod"],
> = {
  end?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  start?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
};

export type UserSubscriptionReservationCycleResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UserSubscriptionReservationCycle"] =
    ResolversParentTypes["UserSubscriptionReservationCycle"],
> = {
  endDay?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  startDay?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
};

export type UserSubscriptionReservationCyclePeriodResolvers<
  ContextType = Context,
  ParentType extends
    ResolversParentTypes["UserSubscriptionReservationCyclePeriod"] =
    ResolversParentTypes["UserSubscriptionReservationCyclePeriod"],
> = {
  additionalNights?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  end?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  hasActiveReservation?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  remainingBaseNights?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  start?: Resolver<ResolversTypes["PlainDate"], ParentType, ContextType>;
  stayedAndReservedNights?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
};

export type UserSubscriptionStatusResolvers = EnumResolverSignature<
  { Neutral?: any; Planed?: any; Usable?: any },
  ResolversTypes["UserSubscriptionStatus"]
>;

export type UserSubscriptionStatusDetailResolvers = EnumResolverSignature<
  {
    NeutralDefault?: any;
    NeutralTerminated?: any;
    PlanedDefault?: any;
    PlanedToResume?: any;
    UsableDefault?: any;
    UsableToPause?: any;
    UsableToTerminate?: any;
  },
  ResolversTypes["UserSubscriptionStatusDetail"]
>;

export type UserSubscriptionTerminationProhibitReasonResolvers =
  EnumResolverSignature<
    {
      InvalidOperation?: any;
      InvalidStatusTransition?: any;
      NoReason?: any;
      NoSubscription?: any;
      NotPausableDateYet?: any;
      ReservationExists?: any;
      UnknownError?: any;
    },
    ResolversTypes["UserSubscriptionTerminationProhibitReason"]
  >;

export type UserSystemSettingsResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["UserSystemSettings"] =
    ResolversParentTypes["UserSystemSettings"],
> = {
  hasSeenHouseRules?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
};

export type VerifyAccountLinkSessionErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["VerifyAccountLinkSessionError"] =
    ResolversParentTypes["VerifyAccountLinkSessionError"],
> = {
  case?: Resolver<
    ResolversTypes["VerifyAccountLinkSessionErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyAccountLinkSessionErrorCaseResolvers = EnumResolverSignature<
  { InvalidSessionToken?: any },
  ResolversTypes["VerifyAccountLinkSessionErrorCase"]
>;

export type VerifyAccountLinkSessionPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["VerifyAccountLinkSessionPayload"] =
    ResolversParentTypes["VerifyAccountLinkSessionPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "VerifyAccountLinkSessionError" | "VerifyAccountLinkSessionSuccess",
    ParentType,
    ContextType
  >;
};

export type VerifyAccountLinkSessionSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["VerifyAccountLinkSessionSuccess"] =
    ResolversParentTypes["VerifyAccountLinkSessionSuccess"],
> = {
  candidateIdentity?: Resolver<
    ResolversTypes["AccountLinkIdentity"],
    ParentType,
    ContextType
  >;
  currentIdentity?: Resolver<
    ResolversTypes["AccountLinkIdentity"],
    ParentType,
    ContextType
  >;
  email?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyAddIdentityReauthErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["VerifyAddIdentityReauthError"] =
    ResolversParentTypes["VerifyAddIdentityReauthError"],
> = {
  case?: Resolver<
    ResolversTypes["VerifyAddIdentityReauthErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyAddIdentityReauthErrorCaseResolvers = EnumResolverSignature<
  {
    IdentityMismatch?: any;
    InvalidIntentToken?: any;
    TokenExchangeFailed?: any;
  },
  ResolversTypes["VerifyAddIdentityReauthErrorCase"]
>;

export type VerifyAddIdentityReauthPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["VerifyAddIdentityReauthPayload"] =
    ResolversParentTypes["VerifyAddIdentityReauthPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "VerifyAddIdentityReauthError" | "VerifyAddIdentityReauthRedirect",
    ParentType,
    ContextType
  >;
};

export type VerifyAddIdentityReauthRedirectResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["VerifyAddIdentityReauthRedirect"] =
    ResolversParentTypes["VerifyAddIdentityReauthRedirect"],
> = {
  redirectUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyCheckInQrCodeErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["VerifyCheckInQrCodeError"] =
    ResolversParentTypes["VerifyCheckInQrCodeError"],
> = {
  case?: Resolver<
    ResolversTypes["VerifyCheckInQrCodeErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyCheckInQrCodeErrorCaseResolvers = EnumResolverSignature<
  { AlreadyUsed?: any; Expired?: any; InvalidCode?: any; SiteMismatch?: any },
  ResolversTypes["VerifyCheckInQrCodeErrorCase"]
>;

export type VerifyCheckInQrCodePayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["VerifyCheckInQrCodePayload"] =
    ResolversParentTypes["VerifyCheckInQrCodePayload"],
> = {
  __resolveType?: TypeResolveFn<
    "VerifyCheckInQrCodeError" | "VerifyCheckInQrCodeSuccess",
    ParentType,
    ContextType
  >;
};

export type VerifyCheckInQrCodeSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["VerifyCheckInQrCodeSuccess"] =
    ResolversParentTypes["VerifyCheckInQrCodeSuccess"],
> = {
  accommodationReservationId?: Resolver<
    ResolversTypes["ID"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyNewEmailErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["VerifyNewEmailError"] =
    ResolversParentTypes["VerifyNewEmailError"],
> = {
  case?: Resolver<
    ResolversTypes["VerifyNewEmailErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyNewEmailErrorCaseResolvers = EnumResolverSignature<
  { DifferentEmail?: any; GeneralError?: any; InvalidEmailOrCode?: any },
  ResolversTypes["VerifyNewEmailErrorCase"]
>;

export type VerifyNewEmailPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["VerifyNewEmailPayload"] =
    ResolversParentTypes["VerifyNewEmailPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "VerifyNewEmailError" | "VerifyNewEmailSuccess",
    ParentType,
    ContextType
  >;
};

export type VerifyNewEmailSuccessResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["VerifyNewEmailSuccess"] =
    ResolversParentTypes["VerifyNewEmailSuccess"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WashingMachineTrackerResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["WashingMachineTracker"] =
    ResolversParentTypes["WashingMachineTracker"],
> = {
  controllerId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WifiConnectionResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["WifiConnection"] =
    ResolversParentTypes["WifiConnection"],
> = {
  password?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  ssid?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
};

export type WifiEquipmentAttributeResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["WifiEquipmentAttribute"] =
    ResolversParentTypes["WifiEquipmentAttribute"],
> = {
  primary?: Resolver<ResolversTypes["WifiConnection"], ParentType, ContextType>;
  secondary?: Resolver<
    Maybe<ResolversTypes["WifiConnection"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkationAccommodationFacilityResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["WorkationAccommodationFacility"] =
    ResolversParentTypes["WorkationAccommodationFacility"],
> = {
  _?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
};

export type ZendeskSyncUserErrorResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ZendeskSyncUserError"] =
    ResolversParentTypes["ZendeskSyncUserError"],
> = {
  case?: Resolver<
    ResolversTypes["ZendeskSyncUserErrorCase"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ZendeskSyncUserErrorCaseResolvers = EnumResolverSignature<
  {
    UserEmailNotVerified?: any;
    UserNotFound?: any;
    ZendeskApiPermanentError?: any;
    ZendeskApiTransientError?: any;
    ZendeskIdNotFound?: any;
    ZendeskIdUpdateError?: any;
  },
  ResolversTypes["ZendeskSyncUserErrorCase"]
>;

export type ZendeskSyncUserResultResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["ZendeskSyncUserResult"] =
    ResolversParentTypes["ZendeskSyncUserResult"],
> = {
  __resolveType?: TypeResolveFn<
    "Success" | "ZendeskSyncUserError",
    ParentType,
    ContextType
  >;
};

export interface ZonedDateTimeScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes["ZonedDateTime"],
  any
> {
  name: "ZonedDateTime";
}

export type leaveOrganizationPayloadResolvers<
  ContextType = Context,
  ParentType extends ResolversParentTypes["leaveOrganizationPayload"] =
    ResolversParentTypes["leaveOrganizationPayload"],
> = {
  __resolveType?: TypeResolveFn<
    "LeaveOrganizationError" | "Success",
    ParentType,
    ContextType
  >;
};

export type Resolvers<ContextType = Context> = {
  AcceptAccommodationReservationError?: AcceptAccommodationReservationErrorResolvers<ContextType>;
  AcceptAccommodationReservationErrorCase?: AcceptAccommodationReservationErrorCaseResolvers;
  AcceptAccommodationReservationPayload?: AcceptAccommodationReservationPayloadResolvers<ContextType>;
  AccessKeyType?: AccessKeyTypeResolvers;
  AccessRouteTransportIcon?: AccessRouteTransportIconResolvers;
  AccessibleReservationCalendarType?: AccessibleReservationCalendarTypeResolvers;
  Accommodation?: AccommodationResolvers<ContextType>;
  AccommodationAccessKey?: AccommodationAccessKeyResolvers<ContextType>;
  AccommodationAvailability?: AccommodationAvailabilityResolvers<ContextType>;
  AccommodationAvailabilityBlock?: AccommodationAvailabilityBlockResolvers<ContextType>;
  AccommodationAvailabilityBlockCategory?: AccommodationAvailabilityBlockCategoryResolvers;
  AccommodationAvailabilityBlockCategoryInfo?: AccommodationAvailabilityBlockCategoryInfoResolvers<ContextType>;
  AccommodationAvailabilityBlockReleaseSchedule?: AccommodationAvailabilityBlockReleaseScheduleResolvers<ContextType>;
  AccommodationClass?: AccommodationClassResolvers;
  AccommodationClassRelation?: AccommodationClassRelationResolvers;
  AccommodationContent?: AccommodationContentResolvers<ContextType>;
  AccommodationEquipment?: AccommodationEquipmentResolvers<ContextType>;
  AccommodationEquipmentAttribute?: AccommodationEquipmentAttributeResolvers<ContextType>;
  AccommodationEquipmentStatusType?: AccommodationEquipmentStatusTypeResolvers;
  AccommodationEquipmentType?: AccommodationEquipmentTypeResolvers;
  AccommodationFacility?: AccommodationFacilityResolvers<ContextType>;
  AccommodationFacilityFilterType?: AccommodationFacilityFilterTypeResolvers;
  AccommodationFacilityType?: AccommodationFacilityTypeResolvers;
  AccommodationFee?: AccommodationFeeResolvers<ContextType>;
  AccommodationFeeApplicability?: AccommodationFeeApplicabilityResolvers<ContextType>;
  AccommodationFeeDiscount?: AccommodationFeeDiscountResolvers<ContextType>;
  AccommodationFeeItem?: AccommodationFeeItemResolvers<ContextType>;
  AccommodationFeeItemPerType?: AccommodationFeeItemPerTypeResolvers;
  AccommodationFeeRule?: AccommodationFeeRuleResolvers<ContextType>;
  AccommodationFeeRuleType?: AccommodationFeeRuleTypeResolvers;
  AccommodationFeeStatus?: AccommodationFeeStatusResolvers;
  AccommodationNotice?: AccommodationNoticeResolvers<ContextType>;
  AccommodationNoticeStatus?: AccommodationNoticeStatusResolvers;
  AccommodationOperationGroup?: AccommodationOperationGroupResolvers<ContextType>;
  AccommodationOperationGroupSetting?: AccommodationOperationGroupSettingResolvers<ContextType>;
  AccommodationOperationType?: AccommodationOperationTypeResolvers;
  AccommodationReservation?: AccommodationReservationResolvers<ContextType>;
  AccommodationReservationAdditionalKeySet?: AccommodationReservationAdditionalKeySetResolvers<ContextType>;
  AccommodationReservationChange?: AccommodationReservationChangeResolvers<ContextType>;
  AccommodationReservationCheckOutAvailabilitiesPayload?: AccommodationReservationCheckOutAvailabilitiesPayloadResolvers<ContextType>;
  AccommodationReservationCheckOutItem?: AccommodationReservationCheckOutItemResolvers<ContextType>;
  AccommodationReservationDetail?: AccommodationReservationDetailResolvers<ContextType>;
  AccommodationReservationMutationScope?: AccommodationReservationMutationScopeResolvers;
  AccommodationReservationOptions?: AccommodationReservationOptionsResolvers<ContextType>;
  AccommodationReservationOtaDetail?: AccommodationReservationOtaDetailResolvers<ContextType>;
  AccommodationReservationProvider?: AccommodationReservationProviderResolvers<ContextType>;
  AccommodationReservationProviderSanuIncUsage?: AccommodationReservationProviderSanuIncUsageResolvers;
  AccommodationReservationProviderType?: AccommodationReservationProviderTypeResolvers;
  AccommodationReservationStayStatus?: AccommodationReservationStayStatusResolvers;
  AccountLinkIdentity?: AccountLinkIdentityResolvers<ContextType>;
  AccountLinkPlatform?: AccountLinkPlatformResolvers;
  AcquireStayTicketsError?: AcquireStayTicketsErrorResolvers<ContextType>;
  AcquireStayTicketsErrorCase?: AcquireStayTicketsErrorCaseResolvers;
  AcquireStayTicketsPayload?: AcquireStayTicketsPayloadResolvers<ContextType>;
  AcquireStayTicketsResult?: AcquireStayTicketsResultResolvers<ContextType>;
  ActivateMemberPerksDrinkTicketError?: ActivateMemberPerksDrinkTicketErrorResolvers<ContextType>;
  ActivateMemberPerksDrinkTicketErrorCase?: ActivateMemberPerksDrinkTicketErrorCaseResolvers;
  ActivateMemberPerksDrinkTicketPayload?: ActivateMemberPerksDrinkTicketPayloadResolvers<ContextType>;
  AdHocQuestionnaireResponse?: AdHocQuestionnaireResponseResolvers<ContextType>;
  AdditionalGuestFeePolicy?: AdditionalGuestFeePolicyResolvers<ContextType>;
  AdditionalNoticeType?: AdditionalNoticeTypeResolvers;
  Address?: AddressResolvers<ContextType>;
  AddressInJapan?: AddressInJapanResolvers<ContextType>;
  AddressInternational?: AddressInternationalResolvers<ContextType>;
  AdminRole?: AdminRoleResolvers;
  AdminRoleAssignment?: AdminRoleAssignmentResolvers<ContextType>;
  AgreeToTermsError?: AgreeToTermsErrorResolvers<ContextType>;
  AgreeToTermsErrorCase?: AgreeToTermsErrorCaseResolvers;
  AgreeToTermsPayload?: AgreeToTermsPayloadResolvers<ContextType>;
  AgreeToWeekdayTermsError?: AgreeToWeekdayTermsErrorResolvers<ContextType>;
  AgreeToWeekdayTermsErrorCase?: AgreeToWeekdayTermsErrorCaseResolvers;
  AgreeToWeekdayTermsPayload?: AgreeToWeekdayTermsPayloadResolvers<ContextType>;
  ApplyToTrialSubscriptionError?: ApplyToTrialSubscriptionErrorResolvers<ContextType>;
  ApplyToTrialSubscriptionErrorCase?: ApplyToTrialSubscriptionErrorCaseResolvers;
  ApplyToTrialSubscriptionPayload?: ApplyToTrialSubscriptionPayloadResolvers<ContextType>;
  ApplyToWeekdaySubscriptionError?: ApplyToWeekdaySubscriptionErrorResolvers<ContextType>;
  ApplyToWeekdaySubscriptionErrorCase?: ApplyToWeekdaySubscriptionErrorCaseResolvers;
  ApplyToWeekdaySubscriptionPayload?: ApplyToWeekdaySubscriptionPayloadResolvers<ContextType>;
  ArchitectureType?: ArchitectureTypeResolvers<ContextType>;
  ArchitectureTypeSeries?: ArchitectureTypeSeriesResolvers;
  ArchitectureTypeSize?: ArchitectureTypeSizeResolvers;
  ArchiveArticle?: ArchiveArticleResolvers<ContextType>;
  Area?: AreaResolvers<ContextType>;
  AreaContent?: AreaContentResolvers<ContextType>;
  AreaGuideArticle?: AreaGuideArticleResolvers<ContextType>;
  AreaGuideSpot?: AreaGuideSpotResolvers<ContextType>;
  AreaGuideSpotCategory?: AreaGuideSpotCategoryResolvers;
  Auth0User?: Auth0UserResolvers<ContextType>;
  BaseAccommodationFeeMode?: BaseAccommodationFeeModeResolvers;
  BaseAccommodationFeePolicy?: BaseAccommodationFeePolicyResolvers<ContextType>;
  Beds24BookingDetail?: Beds24BookingDetailResolvers<ContextType>;
  Beds24BookingFee?: Beds24BookingFeeResolvers<ContextType>;
  Beds24BookingMessageError?: Beds24BookingMessageErrorResolvers<ContextType>;
  Beds24BookingMessageErrorCase?: Beds24BookingMessageErrorCaseResolvers;
  Beds24BookingMessageKind?: Beds24BookingMessageKindResolvers;
  Beds24BookingMessageResult?: Beds24BookingMessageResultResolvers<ContextType>;
  Beds24BookingMessageResultPayload?: Beds24BookingMessageResultPayloadResolvers<ContextType>;
  Beds24SyncFollowingReservationsResultPayload?: Beds24SyncFollowingReservationsResultPayloadResolvers<ContextType>;
  Beds24WebhookError?: Beds24WebhookErrorResolvers<ContextType>;
  Beds24WebhookErrorCase?: Beds24WebhookErrorCaseResolvers;
  Beds24WebhookResult?: Beds24WebhookResultResolvers<ContextType>;
  Beds24WebhookResultPayload?: Beds24WebhookResultPayloadResolvers<ContextType>;
  Beds24WebhookSuccess?: Beds24WebhookSuccessResolvers<ContextType>;
  Beds24WebhookSuccessCase?: Beds24WebhookSuccessCaseResolvers;
  BillingMethod?: BillingMethodResolvers;
  BundleStayTicketsPayload?: BundleStayTicketsPayloadResolvers<ContextType>;
  BusinessPlan?: BusinessPlanResolvers<ContextType>;
  BusinessPlanAccommodationReservationProvider?: BusinessPlanAccommodationReservationProviderResolvers<ContextType>;
  CancelAccommodationReservationError?: CancelAccommodationReservationErrorResolvers<ContextType>;
  CancelAccommodationReservationErrorCase?: CancelAccommodationReservationErrorCaseResolvers;
  CancelAccommodationReservationPayload?: CancelAccommodationReservationPayloadResolvers<ContextType>;
  CancelCoOwnersApplicationError?: CancelCoOwnersApplicationErrorResolvers<ContextType>;
  CancelCoOwnersApplicationErrorCase?: CancelCoOwnersApplicationErrorCaseResolvers;
  CancelCoOwnersApplicationPayload?: CancelCoOwnersApplicationPayloadResolvers<ContextType>;
  CancelFacilityReservationError?: CancelFacilityReservationErrorResolvers<ContextType>;
  CancelFacilityReservationErrorCase?: CancelFacilityReservationErrorCaseResolvers;
  CancelFacilityReservationPayload?: CancelFacilityReservationPayloadResolvers<ContextType>;
  CancelFeeFixedPolicy?: CancelFeeFixedPolicyResolvers<ContextType>;
  CancelFeePolicy?: CancelFeePolicyResolvers<ContextType>;
  CancelFeeRatePolicy?: CancelFeeRatePolicyResolvers<ContextType>;
  CancelStandardSubscriptionApplicationError?: CancelStandardSubscriptionApplicationErrorResolvers<ContextType>;
  CancelStandardSubscriptionApplicationErrorCase?: CancelStandardSubscriptionApplicationErrorCaseResolvers;
  CancelStandardSubscriptionApplicationPayload?: CancelStandardSubscriptionApplicationPayloadResolvers<ContextType>;
  CancelStandardSubscriptionPauseError?: CancelStandardSubscriptionPauseErrorResolvers<ContextType>;
  CancelStandardSubscriptionPauseErrorCase?: CancelStandardSubscriptionPauseErrorCaseResolvers;
  CancelStandardSubscriptionPausePayload?: CancelStandardSubscriptionPausePayloadResolvers<ContextType>;
  CancelStandardSubscriptionResumeError?: CancelStandardSubscriptionResumeErrorResolvers<ContextType>;
  CancelStandardSubscriptionResumeErrorCase?: CancelStandardSubscriptionResumeErrorCaseResolvers;
  CancelStandardSubscriptionResumePayload?: CancelStandardSubscriptionResumePayloadResolvers<ContextType>;
  CancelStandardSubscriptionTerminationError?: CancelStandardSubscriptionTerminationErrorResolvers<ContextType>;
  CancelStandardSubscriptionTerminationErrorCase?: CancelStandardSubscriptionTerminationErrorCaseResolvers;
  CancelStandardSubscriptionTerminationPayload?: CancelStandardSubscriptionTerminationPayloadResolvers<ContextType>;
  CancelStayGiftsError?: CancelStayGiftsErrorResolvers<ContextType>;
  CancelStayGiftsErrorCase?: CancelStayGiftsErrorCaseResolvers;
  CancelStayGiftsPayload?: CancelStayGiftsPayloadResolvers<ContextType>;
  CancelStayGiftsResult?: CancelStayGiftsResultResolvers<ContextType>;
  CancelTrialSubscriptionError?: CancelTrialSubscriptionErrorResolvers<ContextType>;
  CancelTrialSubscriptionErrorCase?: CancelTrialSubscriptionErrorCaseResolvers;
  CancelTrialSubscriptionPayload?: CancelTrialSubscriptionPayloadResolvers<ContextType>;
  CancellationFeeTier?: CancellationFeeTierResolvers<ContextType>;
  CancellationPolicyContent?: CancellationPolicyContentResolvers<ContextType>;
  CancellationPolicySection?: CancellationPolicySectionResolvers<ContextType>;
  ChangeAccommodationReservationError?: ChangeAccommodationReservationErrorResolvers<ContextType>;
  ChangeAccommodationReservationErrorCase?: ChangeAccommodationReservationErrorCaseResolvers;
  ChangeAccommodationReservationPayload?: ChangeAccommodationReservationPayloadResolvers<ContextType>;
  CheckInAccommodationReservationError?: CheckInAccommodationReservationErrorResolvers<ContextType>;
  CheckInAccommodationReservationErrorCase?: CheckInAccommodationReservationErrorCaseResolvers;
  CheckInAccommodationReservationPayload?: CheckInAccommodationReservationPayloadResolvers<ContextType>;
  CheckInAuthenticationType?: CheckInAuthenticationTypeResolvers;
  CheckInQrCode?: CheckInQrCodeResolvers<ContextType>;
  CheckInQrCodeStatus?: CheckInQrCodeStatusResolvers;
  CheckOutAccommodationReservationError?: CheckOutAccommodationReservationErrorResolvers<ContextType>;
  CheckOutAccommodationReservationErrorCase?: CheckOutAccommodationReservationErrorCaseResolvers;
  CheckOutAccommodationReservationPayload?: CheckOutAccommodationReservationPayloadResolvers<ContextType>;
  CoOwnerPeakDaysRatio?: CoOwnerPeakDaysRatioResolvers;
  CoOwnersApplicantInfo?: CoOwnersApplicantInfoResolvers<ContextType>;
  CoOwnersApplicantInfoDetail?: CoOwnersApplicantInfoDetailResolvers<ContextType>;
  CoOwnersApplicantInfoDetailIndividual?: CoOwnersApplicantInfoDetailIndividualResolvers<ContextType>;
  CoOwnersApplicantInfoDetailOrganization?: CoOwnersApplicantInfoDetailOrganizationResolvers<ContextType>;
  CoOwnersApplication?: CoOwnersApplicationResolvers<ContextType>;
  CoOwnersApplicationEvents?: CoOwnersApplicationEventsResolvers<ContextType>;
  CoOwnersApplicationFile?: CoOwnersApplicationFileResolvers<ContextType>;
  CoOwnersApplicationStatus?: CoOwnersApplicationStatusResolvers;
  CoOwnersBakurakuInvoiceAnnualPaymentItem?: CoOwnersBakurakuInvoiceAnnualPaymentItemResolvers<ContextType>;
  CoOwnersBakurakuInvoiceRecipient?: CoOwnersBakurakuInvoiceRecipientResolvers<ContextType>;
  CoOwnersBakurakuInvoiceRegistrationFeeItem?: CoOwnersBakurakuInvoiceRegistrationFeeItemResolvers<ContextType>;
  CoOwnersBakurakuInvoiceRemainingPaymentItem?: CoOwnersBakurakuInvoiceRemainingPaymentItemResolvers<ContextType>;
  CoOwnersPlanAccommodationReservationProvider?: CoOwnersPlanAccommodationReservationProviderResolvers<ContextType>;
  CoOwnersPlanOffering?: CoOwnersPlanOfferingResolvers<ContextType>;
  CoOwnersUnitSale?: CoOwnersUnitSaleResolvers<ContextType>;
  CoOwnersWebinarSchedule?: CoOwnersWebinarScheduleResolvers<ContextType>;
  CoWorkingSpaceDoorLock?: CoWorkingSpaceDoorLockResolvers<ContextType>;
  CoWorkingSpaceKey?: CoWorkingSpaceKeyResolvers<ContextType>;
  CompleteAddIdentityError?: CompleteAddIdentityErrorResolvers<ContextType>;
  CompleteAddIdentityErrorCase?: CompleteAddIdentityErrorCaseResolvers;
  CompleteAddIdentityPayload?: CompleteAddIdentityPayloadResolvers<ContextType>;
  CompleteAddIdentitySuccess?: CompleteAddIdentitySuccessResolvers<ContextType>;
  ConfirmTentativeAccommodationReservationError?: ConfirmTentativeAccommodationReservationErrorResolvers<ContextType>;
  ConfirmTentativeAccommodationReservationErrorCase?: ConfirmTentativeAccommodationReservationErrorCaseResolvers;
  ConfirmTentativeAccommodationReservationPayload?: ConfirmTentativeAccommodationReservationPayloadResolvers<ContextType>;
  ConsumedSuppliesFee?: ConsumedSuppliesFeeResolvers<ContextType>;
  ConsumedSuppliesFeeItem?: ConsumedSuppliesFeeItemResolvers<ContextType>;
  ConsumedSupplyFeeItemWaiver?: ConsumedSupplyFeeItemWaiverResolvers<ContextType>;
  ConsumedSupplyFeeItemWaiverType?: ConsumedSupplyFeeItemWaiverTypeResolvers;
  ConsumptionTaxRateType?: ConsumptionTaxRateTypeResolvers;
  ContentArchitect?: ContentArchitectResolvers<ContextType>;
  ContentArchitecturalFeature?: ContentArchitecturalFeatureResolvers<ContextType>;
  ContentArchitecturalFeatureUsageRule?: ContentArchitecturalFeatureUsageRuleResolvers<ContextType>;
  ContentArchitecturePageNavigation?: ContentArchitecturePageNavigationResolvers<ContextType>;
  ContentArchitecturePageNavigationItem?: ContentArchitecturePageNavigationItemResolvers<ContextType>;
  ContentArchitecturePageNavigationSubItem?: ContentArchitecturePageNavigationSubItemResolvers<ContextType>;
  ContentArchitectureType?: ContentArchitectureTypeResolvers<ContextType>;
  ContentArchitectureTypeBasicAmenity?: ContentArchitectureTypeBasicAmenityResolvers<ContextType>;
  ContentArchitectureTypeExperience?: ContentArchitectureTypeExperienceResolvers<ContextType>;
  ContentArchitectureTypeFeature?: ContentArchitectureTypeFeatureResolvers<ContextType>;
  ContentArchitectureTypeFeatureSite?: ContentArchitectureTypeFeatureSiteResolvers<ContextType>;
  ContentArchitectureTypeFeatureUsageRule?: ContentArchitectureTypeFeatureUsageRuleResolvers<ContextType>;
  ContentArchitectureTypeFeatureUsageRuleItem?: ContentArchitectureTypeFeatureUsageRuleItemResolvers<ContextType>;
  ContentArchitectureTypeSite?: ContentArchitectureTypeSiteResolvers<ContextType>;
  ContentArchitectureTypeVariant?: ContentArchitectureTypeVariantResolvers<ContextType>;
  ContentArchitectureTypeVariantFacilityAmenity?: ContentArchitectureTypeVariantFacilityAmenityResolvers<ContextType>;
  ContentArchitectureTypeVariantKind?: ContentArchitectureTypeVariantKindResolvers;
  ContentArchitectureTypeVariantSite?: ContentArchitectureTypeVariantSiteResolvers<ContextType>;
  ContentFacilityAmenityReferenceCounts?: ContentFacilityAmenityReferenceCountsResolvers<ContextType>;
  ContentFacilityDetails?: ContentFacilityDetailsResolvers<ContextType>;
  ContentRoomType?: ContentRoomTypeResolvers<ContextType>;
  ContractContinuationType?: ContractContinuationTypeResolvers;
  ContractStatus?: ContractStatusResolvers;
  CountryEnum?: CountryEnumResolvers;
  CreateAccommodationReservationError?: CreateAccommodationReservationErrorResolvers<ContextType>;
  CreateAccommodationReservationErrorCase?: CreateAccommodationReservationErrorCaseResolvers;
  CreateAccommodationReservationPayload?: CreateAccommodationReservationPayloadResolvers<ContextType>;
  CreateCoOwnersApplicationFileDownloadUrlError?: CreateCoOwnersApplicationFileDownloadUrlErrorResolvers<ContextType>;
  CreateCoOwnersApplicationFileDownloadUrlErrorCase?: CreateCoOwnersApplicationFileDownloadUrlErrorCaseResolvers;
  CreateCoOwnersApplicationFileDownloadUrlPayload?: CreateCoOwnersApplicationFileDownloadUrlPayloadResolvers<ContextType>;
  CreateCoOwnersApplicationFileDownloadUrlSuccess?: CreateCoOwnersApplicationFileDownloadUrlSuccessResolvers<ContextType>;
  CreateFacilityReservationError?: CreateFacilityReservationErrorResolvers<ContextType>;
  CreateFacilityReservationErrorCase?: CreateFacilityReservationErrorCaseResolvers;
  CreateFacilityReservationPayload?: CreateFacilityReservationPayloadResolvers<ContextType>;
  CreateFacilityReservationSuccess?: CreateFacilityReservationSuccessResolvers<ContextType>;
  CreateFileUploadPolicyError?: CreateFileUploadPolicyErrorResolvers<ContextType>;
  CreateFileUploadPolicyErrorCase?: CreateFileUploadPolicyErrorCaseResolvers;
  CreateFileUploadPolicySuccess?: CreateFileUploadPolicySuccessResolvers<ContextType>;
  CreateOrUpdateUserAppInstallationError?: CreateOrUpdateUserAppInstallationErrorResolvers<ContextType>;
  CreateOrUpdateUserAppInstallationErrorCase?: CreateOrUpdateUserAppInstallationErrorCaseResolvers;
  CreateOrUpdateUserAppInstallationPayload?: CreateOrUpdateUserAppInstallationPayloadResolvers<ContextType>;
  CreateStripeCardSetupIntentOfOrganizationPayload?: CreateStripeCardSetupIntentOfOrganizationPayloadResolvers<ContextType>;
  CreateStripeCardSetupIntentOfViewerPayload?: CreateStripeCardSetupIntentOfViewerPayloadResolvers<ContextType>;
  CreateWebviewSessionError?: CreateWebviewSessionErrorResolvers<ContextType>;
  CreateWebviewSessionErrorCase?: CreateWebviewSessionErrorCaseResolvers;
  CreateWebviewSessionPayload?: CreateWebviewSessionPayloadResolvers<ContextType>;
  CreateWebviewSessionSuccess?: CreateWebviewSessionSuccessResolvers<ContextType>;
  CronJobName?: CronJobNameResolvers;
  DailyRateTarget?: DailyRateTargetResolvers;
  DateTime?: GraphQLScalarType;
  Decimal?: GraphQLScalarType;
  DeleteUserAppInstallationError?: DeleteUserAppInstallationErrorResolvers<ContextType>;
  DeleteUserAppInstallationErrorCase?: DeleteUserAppInstallationErrorCaseResolvers;
  DeleteUserAppInstallationPayload?: DeleteUserAppInstallationPayloadResolvers<ContextType>;
  DeleteViewerError?: DeleteViewerErrorResolvers<ContextType>;
  DeleteViewerErrorCase?: DeleteViewerErrorCaseResolvers;
  DeleteViewerPayload?: DeleteViewerPayloadResolvers<ContextType>;
  DisclosureAssistantType?: DisclosureAssistantTypeResolvers;
  DogfriendlyAccommodationFacility?: DogfriendlyAccommodationFacilityResolvers<ContextType>;
  DraftAccommodationReservation?: DraftAccommodationReservationResolvers<ContextType>;
  DraftAccommodationReservationByStayTicketMasterResult?: DraftAccommodationReservationByStayTicketMasterResultResolvers<ContextType>;
  EVChargerAccommodationFacility?: EVChargerAccommodationFacilityResolvers<ContextType>;
  EarlyCheckInPriceSlot?: EarlyCheckInPriceSlotResolvers<ContextType>;
  EarlyCheckInStatus?: EarlyCheckInStatusResolvers;
  EstimateStandardSubscriptionApplicationError?: EstimateStandardSubscriptionApplicationErrorResolvers<ContextType>;
  EstimateStandardSubscriptionApplicationErrorCase?: EstimateStandardSubscriptionApplicationErrorCaseResolvers;
  EstimateStandardSubscriptionApplicationFeePayload?: EstimateStandardSubscriptionApplicationFeePayloadResolvers<ContextType>;
  EstimateStandardSubscriptionApplicationSuccess?: EstimateStandardSubscriptionApplicationSuccessResolvers<ContextType>;
  EstimatedCancelFeeOfAccommodationReservationError?: EstimatedCancelFeeOfAccommodationReservationErrorResolvers<ContextType>;
  EstimatedCancelFeeOfAccommodationReservationErrorCase?: EstimatedCancelFeeOfAccommodationReservationErrorCaseResolvers;
  EstimatedCancelFeeOfAccommodationReservationPayload?: EstimatedCancelFeeOfAccommodationReservationPayloadResolvers<ContextType>;
  EstimatedChangeFeeOfAccommodationReservationError?: EstimatedChangeFeeOfAccommodationReservationErrorResolvers<ContextType>;
  EstimatedChangeFeeOfAccommodationReservationErrorCase?: EstimatedChangeFeeOfAccommodationReservationErrorCaseResolvers;
  EstimatedChangeFeeOfAccommodationReservationPayload?: EstimatedChangeFeeOfAccommodationReservationPayloadResolvers<ContextType>;
  EstimatedChargeOfAccommodationReservation?: EstimatedChargeOfAccommodationReservationResolvers<ContextType>;
  EstimatedChargeOfAccommodationReservationItem?: EstimatedChargeOfAccommodationReservationItemResolvers<ContextType>;
  EstimatedChargeOfAccommodationReservationItemType?: EstimatedChargeOfAccommodationReservationItemTypeResolvers;
  EvChargerLock?: EvChargerLockResolvers<ContextType>;
  ExportStayGiftsPayload?: ExportStayGiftsPayloadResolvers<ContextType>;
  Facility?: FacilityResolvers<ContextType>;
  FacilityBaseFeePolicy?: FacilityBaseFeePolicyResolvers<ContextType>;
  FacilityCancelFeePolicy?: FacilityCancelFeePolicyResolvers<ContextType>;
  FacilityController?: FacilityControllerResolvers<ContextType>;
  FacilityControllerAttribute?: FacilityControllerAttributeResolvers<ContextType>;
  FacilityCustomFieldItem?: FacilityCustomFieldItemResolvers<ContextType>;
  FacilityCustomFieldValue?: FacilityCustomFieldValueResolvers<ContextType>;
  FacilityDiscountFeePolicy?: FacilityDiscountFeePolicyResolvers<ContextType>;
  FacilityFee?: FacilityFeeResolvers<ContextType>;
  FacilityFeeItem?: FacilityFeeItemResolvers<ContextType>;
  FacilityFieldType?: FacilityFieldTypeResolvers;
  FacilityInvoiceLabelPart?: FacilityInvoiceLabelPartResolvers<ContextType>;
  FacilityInvoiceLabelPartType?: FacilityInvoiceLabelPartTypeResolvers;
  FacilityInvoiceLabelPeriodFormat?: FacilityInvoiceLabelPeriodFormatResolvers;
  FacilityReservation?: FacilityReservationResolvers<ContextType>;
  FacilityReservationCleaningReport?: FacilityReservationCleaningReportResolvers<ContextType>;
  FacilityReservationCleaningStatus?: FacilityReservationCleaningStatusResolvers;
  FacilityReservationDataSync?: FacilityReservationDataSyncResolvers<ContextType>;
  FacilityReservationDataSyncStatus?: FacilityReservationDataSyncStatusResolvers;
  FacilityReservationStatusType?: FacilityReservationStatusTypeResolvers;
  FacilityResource?: FacilityResourceResolvers<ContextType>;
  FacilityResourceBlock?: FacilityResourceBlockResolvers<ContextType>;
  FacilityResourceBlockType?: FacilityResourceBlockTypeResolvers;
  FacilityResourceControllerType?: FacilityResourceControllerTypeResolvers;
  FacilitySlot?: FacilitySlotResolvers<ContextType>;
  FacilitySlotAvailability?: FacilitySlotAvailabilityResolvers<ContextType>;
  FacilitySlotUnavailableReason?: FacilitySlotUnavailableReasonResolvers;
  FacilityStatusType?: FacilityStatusTypeResolvers;
  FacilityType?: FacilityTypeResolvers;
  FacilityUnitType?: FacilityUnitTypeResolvers;
  FeeModifierType?: FeeModifierTypeResolvers;
  FieldTierPermission?: FieldTierPermissionResolvers;
  FileCopyTarget?: FileCopyTargetResolvers;
  FileUploadPolicyPayload?: FileUploadPolicyPayloadResolvers<ContextType>;
  FinalizeAccountLinkError?: FinalizeAccountLinkErrorResolvers<ContextType>;
  FinalizeAccountLinkErrorCase?: FinalizeAccountLinkErrorCaseResolvers;
  FinalizeAccountLinkPayload?: FinalizeAccountLinkPayloadResolvers<ContextType>;
  FinalizeAccountLinkSuccess?: FinalizeAccountLinkSuccessResolvers<ContextType>;
  FinancialAssetsBracketType?: FinancialAssetsBracketTypeResolvers;
  FullOwnerPlanAccommodationReservationProvider?: FullOwnerPlanAccommodationReservationProviderResolvers<ContextType>;
  GenderType?: GenderTypeResolvers;
  GenerateCheckInQrCodeError?: GenerateCheckInQrCodeErrorResolvers<ContextType>;
  GenerateCheckInQrCodeErrorCase?: GenerateCheckInQrCodeErrorCaseResolvers;
  GenerateCheckInQrCodePayload?: GenerateCheckInQrCodePayloadResolvers<ContextType>;
  GenerateCheckInQrCodeSuccess?: GenerateCheckInQrCodeSuccessResolvers<ContextType>;
  GeoLocation?: GeoLocationResolvers<ContextType>;
  GuestAccessKeyTrigger?: GuestAccessKeyTriggerResolvers;
  HighSeasonPeriod?: HighSeasonPeriodResolvers<ContextType>;
  HighSeasonType?: HighSeasonTypeResolvers;
  HubSpotSyncContactError?: HubSpotSyncContactErrorResolvers<ContextType>;
  HubSpotSyncContactErrorCase?: HubSpotSyncContactErrorCaseResolvers;
  HubSpotSyncContactResult?: HubSpotSyncContactResultResolvers<ContextType>;
  HubSpotSyncDealError?: HubSpotSyncDealErrorResolvers<ContextType>;
  HubSpotSyncDealErrorCase?: HubSpotSyncDealErrorCaseResolvers;
  HubSpotSyncDealResult?: HubSpotSyncDealResultResolvers<ContextType>;
  IdentificationDocumentType?: IdentificationDocumentTypeResolvers;
  IdentityProvider?: IdentityProviderResolvers;
  IdentityVerification?: IdentityVerificationResolvers<ContextType>;
  IdentityVerificationMethod?: IdentityVerificationMethodResolvers;
  IdentityVerificationResult?: IdentityVerificationResultResolvers;
  IdentityVerificationStatus?: IdentityVerificationStatusResolvers;
  IncomeBracketType?: IncomeBracketTypeResolvers;
  InitiateAccountLinkError?: InitiateAccountLinkErrorResolvers<ContextType>;
  InitiateAccountLinkErrorCase?: InitiateAccountLinkErrorCaseResolvers;
  InitiateAccountLinkPayload?: InitiateAccountLinkPayloadResolvers<ContextType>;
  InitiateAccountLinkSuccess?: InitiateAccountLinkSuccessResolvers<ContextType>;
  InitiateAddIdentityError?: InitiateAddIdentityErrorResolvers<ContextType>;
  InitiateAddIdentityErrorCase?: InitiateAddIdentityErrorCaseResolvers;
  InitiateAddIdentityPayload?: InitiateAddIdentityPayloadResolvers<ContextType>;
  InitiateAddIdentitySuccess?: InitiateAddIdentitySuccessResolvers<ContextType>;
  Inspection?: InspectionResolvers<ContextType>;
  InspectionReport?: InspectionReportResolvers<ContextType>;
  InspectionReportType?: InspectionReportTypeResolvers;
  InspectionStatusType?: InspectionStatusTypeResolvers;
  InspectionSupplyItem?: InspectionSupplyItemResolvers<ContextType>;
  InspectionViolationHandling?: InspectionViolationHandlingResolvers<ContextType>;
  InspectionViolationHandlingStatus?: InspectionViolationHandlingStatusResolvers;
  InspectionViolationItem?: InspectionViolationItemResolvers<ContextType>;
  InspectionViolationSeverity?: InspectionViolationSeverityResolvers;
  InternalAccommodationEquipmentError?: InternalAccommodationEquipmentErrorResolvers<ContextType>;
  InternalAccommodationEquipmentErrorCase?: InternalAccommodationEquipmentErrorCaseResolvers;
  InternalAddLocalTaxPolicyError?: InternalAddLocalTaxPolicyErrorResolvers<ContextType>;
  InternalAddLocalTaxPolicyErrorCase?: InternalAddLocalTaxPolicyErrorCaseResolvers;
  InternalAddLocalTaxPolicyPayload?: InternalAddLocalTaxPolicyPayloadResolvers<ContextType>;
  InternalAdjustOwnerStayCreditError?: InternalAdjustOwnerStayCreditErrorResolvers<ContextType>;
  InternalAdjustOwnerStayCreditErrorCase?: InternalAdjustOwnerStayCreditErrorCaseResolvers;
  InternalAdjustOwnerStayCreditPayload?: InternalAdjustOwnerStayCreditPayloadResolvers<ContextType>;
  InternalAdjustStaffCreditsError?: InternalAdjustStaffCreditsErrorResolvers<ContextType>;
  InternalAdjustStaffCreditsErrorCase?: InternalAdjustStaffCreditsErrorCaseResolvers;
  InternalAdjustStaffCreditsResult?: InternalAdjustStaffCreditsResultResolvers<ContextType>;
  InternalAdjustStaffCreditsSuccess?: InternalAdjustStaffCreditsSuccessResolvers<ContextType>;
  InternalAdminRoleAssignee?: InternalAdminRoleAssigneeResolvers<ContextType>;
  InternalAppendS2oPointsToCoOwnersApplicationError?: InternalAppendS2oPointsToCoOwnersApplicationErrorResolvers<ContextType>;
  InternalAppendS2oPointsToCoOwnersApplicationErrorCase?: InternalAppendS2oPointsToCoOwnersApplicationErrorCaseResolvers;
  InternalAppendS2oPointsToCoOwnersApplicationPayload?: InternalAppendS2oPointsToCoOwnersApplicationPayloadResolvers<ContextType>;
  InternalApplyGuestAccessKeyError?: InternalApplyGuestAccessKeyErrorResolvers<ContextType>;
  InternalApplyGuestAccessKeyPayload?: InternalApplyGuestAccessKeyPayloadResolvers<ContextType>;
  InternalApplyStaffAccessKeyError?: InternalApplyStaffAccessKeyErrorResolvers<ContextType>;
  InternalApplyStaffAccessKeyPayload?: InternalApplyStaffAccessKeyPayloadResolvers<ContextType>;
  InternalArchitectureContentError?: InternalArchitectureContentErrorResolvers<ContextType>;
  InternalArchitectureContentErrorCase?: InternalArchitectureContentErrorCaseResolvers;
  InternalArchitectureContentImageKind?: InternalArchitectureContentImageKindResolvers;
  InternalArea?: InternalAreaResolvers<ContextType>;
  InternalAssignAccessCodeToAccommodationReservationError?: InternalAssignAccessCodeToAccommodationReservationErrorResolvers<ContextType>;
  InternalAssignAccessCodeToAccommodationReservationPayload?: InternalAssignAccessCodeToAccommodationReservationPayloadResolvers<ContextType>;
  InternalAssignAdminRoleError?: InternalAssignAdminRoleErrorResolvers<ContextType>;
  InternalAssignAdminRoleErrorCode?: InternalAssignAdminRoleErrorCodeResolvers;
  InternalAssignAdminRolePayload?: InternalAssignAdminRolePayloadResolvers<ContextType>;
  InternalAuth0Identity?: InternalAuth0IdentityResolvers<ContextType>;
  InternalAuth0User?: InternalAuth0UserResolvers<ContextType>;
  InternalAvailableStaffSemester?: InternalAvailableStaffSemesterResolvers<ContextType>;
  InternalBeds24SyncFuturePricesResult?: InternalBeds24SyncFuturePricesResultResolvers<ContextType>;
  InternalBeds24SyncFuturePricesSkip?: InternalBeds24SyncFuturePricesSkipResolvers<ContextType>;
  InternalBeds24SyncFuturePricesTarget?: InternalBeds24SyncFuturePricesTargetResolvers<ContextType>;
  InternalBulkCreateAccommodationAvailabilityBlockFailure?: InternalBulkCreateAccommodationAvailabilityBlockFailureResolvers<ContextType>;
  InternalBulkCreateAccommodationAvailabilityBlockFailureInput?: InternalBulkCreateAccommodationAvailabilityBlockFailureInputResolvers<ContextType>;
  InternalBulkCreateAccommodationAvailabilityBlocksPayload?: InternalBulkCreateAccommodationAvailabilityBlocksPayloadResolvers<ContextType>;
  InternalBulkCreateOrganizationYearlyContractInvoicesError?: InternalBulkCreateOrganizationYearlyContractInvoicesErrorResolvers<ContextType>;
  InternalBulkCreateOrganizationYearlyContractInvoicesErrorCase?: InternalBulkCreateOrganizationYearlyContractInvoicesErrorCaseResolvers;
  InternalBulkCreateOrganizationYearlyContractInvoicesPayload?: InternalBulkCreateOrganizationYearlyContractInvoicesPayloadResolvers<ContextType>;
  InternalBulkCreateOrganizationYearlyContractInvoicesSuccess?: InternalBulkCreateOrganizationYearlyContractInvoicesSuccessResolvers<ContextType>;
  InternalBulkDeleteAccommodationAvailabilityBlockFailure?: InternalBulkDeleteAccommodationAvailabilityBlockFailureResolvers<ContextType>;
  InternalBulkDeleteAccommodationAvailabilityBlocksPayload?: InternalBulkDeleteAccommodationAvailabilityBlocksPayloadResolvers<ContextType>;
  InternalBulkUpdateSeasonalFeeSettingsError?: InternalBulkUpdateSeasonalFeeSettingsErrorResolvers<ContextType>;
  InternalBulkUpdateSeasonalFeeSettingsPayload?: InternalBulkUpdateSeasonalFeeSettingsPayloadResolvers<ContextType>;
  InternalBulkUpdateStayTicketMastersError?: InternalBulkUpdateStayTicketMastersErrorResolvers<ContextType>;
  InternalBulkUpdateStayTicketMastersPayload?: InternalBulkUpdateStayTicketMastersPayloadResolvers<ContextType>;
  InternalCancelCoOwnersApplicationError?: InternalCancelCoOwnersApplicationErrorResolvers<ContextType>;
  InternalCancelCoOwnersApplicationErrorCase?: InternalCancelCoOwnersApplicationErrorCaseResolvers;
  InternalCancelCoOwnersApplicationPayload?: InternalCancelCoOwnersApplicationPayloadResolvers<ContextType>;
  InternalCommonError?: InternalCommonErrorResolvers<ContextType>;
  InternalContentRoomType?: InternalContentRoomTypeResolvers<ContextType>;
  InternalCreateAccommodationEquipmentPayload?: InternalCreateAccommodationEquipmentPayloadResolvers<ContextType>;
  InternalCreateAccommodationOperationGroupError?: InternalCreateAccommodationOperationGroupErrorResolvers<ContextType>;
  InternalCreateAccommodationOperationGroupErrorCase?: InternalCreateAccommodationOperationGroupErrorCaseResolvers;
  InternalCreateAccommodationOperationGroupPayload?: InternalCreateAccommodationOperationGroupPayloadResolvers<ContextType>;
  InternalCreateCoOwnersIdentityVerificationError?: InternalCreateCoOwnersIdentityVerificationErrorResolvers<ContextType>;
  InternalCreateCoOwnersIdentityVerificationErrorCase?: InternalCreateCoOwnersIdentityVerificationErrorCaseResolvers;
  InternalCreateCoOwnersIdentityVerificationPayload?: InternalCreateCoOwnersIdentityVerificationPayloadResolvers<ContextType>;
  InternalCreateConsumedSuppliesFeeItemsError?: InternalCreateConsumedSuppliesFeeItemsErrorResolvers<ContextType>;
  InternalCreateConsumedSuppliesFeeItemsErrorCase?: InternalCreateConsumedSuppliesFeeItemsErrorCaseResolvers;
  InternalCreateConsumedSuppliesFeeItemsPayload?: InternalCreateConsumedSuppliesFeeItemsPayloadResolvers<ContextType>;
  InternalCreateFacilityReservationError?: InternalCreateFacilityReservationErrorResolvers<ContextType>;
  InternalCreateFacilityReservationErrorCase?: InternalCreateFacilityReservationErrorCaseResolvers;
  InternalCreateFacilityReservationPayload?: InternalCreateFacilityReservationPayloadResolvers<ContextType>;
  InternalCreateFullOwnerIdentityVerificationError?: InternalCreateFullOwnerIdentityVerificationErrorResolvers<ContextType>;
  InternalCreateFullOwnerIdentityVerificationErrorCase?: InternalCreateFullOwnerIdentityVerificationErrorCaseResolvers;
  InternalCreateFullOwnerIdentityVerificationPayload?: InternalCreateFullOwnerIdentityVerificationPayloadResolvers<ContextType>;
  InternalCreateLocalTaxPolicyError?: InternalCreateLocalTaxPolicyErrorResolvers<ContextType>;
  InternalCreateLocalTaxPolicyErrorCase?: InternalCreateLocalTaxPolicyErrorCaseResolvers;
  InternalCreateLocalTaxPolicyPayload?: InternalCreateLocalTaxPolicyPayloadResolvers<ContextType>;
  InternalCreateOrUpdateAccommodationError?: InternalCreateOrUpdateAccommodationErrorResolvers<ContextType>;
  InternalCreateOrUpdateAccommodationNoticeError?: InternalCreateOrUpdateAccommodationNoticeErrorResolvers<ContextType>;
  InternalCreateOrUpdateAccommodationNoticeErrorCase?: InternalCreateOrUpdateAccommodationNoticeErrorCaseResolvers;
  InternalCreateOrUpdateAccommodationNoticePayload?: InternalCreateOrUpdateAccommodationNoticePayloadResolvers<ContextType>;
  InternalCreateOrUpdateAccommodationPayload?: InternalCreateOrUpdateAccommodationPayloadResolvers<ContextType>;
  InternalCreateOrUpdateAdditionalGuestFeePolicyError?: InternalCreateOrUpdateAdditionalGuestFeePolicyErrorResolvers<ContextType>;
  InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCase?: InternalCreateOrUpdateAdditionalGuestFeePolicyErrorCaseResolvers;
  InternalCreateOrUpdateAdditionalGuestFeePolicyPayload?: InternalCreateOrUpdateAdditionalGuestFeePolicyPayloadResolvers<ContextType>;
  InternalCreateOrUpdateBaseAccommodationFeePolicyError?: InternalCreateOrUpdateBaseAccommodationFeePolicyErrorResolvers<ContextType>;
  InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCase?: InternalCreateOrUpdateBaseAccommodationFeePolicyErrorCaseResolvers;
  InternalCreateOrUpdateBaseAccommodationFeePolicyPayload?: InternalCreateOrUpdateBaseAccommodationFeePolicyPayloadResolvers<ContextType>;
  InternalCreateOrUpdateBusinessPlanError?: InternalCreateOrUpdateBusinessPlanErrorResolvers<ContextType>;
  InternalCreateOrUpdateBusinessPlanErrorCase?: InternalCreateOrUpdateBusinessPlanErrorCaseResolvers;
  InternalCreateOrUpdateBusinessPlanPayload?: InternalCreateOrUpdateBusinessPlanPayloadResolvers<ContextType>;
  InternalCreateOrUpdateCancelFeePolicyError?: InternalCreateOrUpdateCancelFeePolicyErrorResolvers<ContextType>;
  InternalCreateOrUpdateCancelFeePolicyErrorCase?: InternalCreateOrUpdateCancelFeePolicyErrorCaseResolvers;
  InternalCreateOrUpdateCancelFeePolicyPayload?: InternalCreateOrUpdateCancelFeePolicyPayloadResolvers<ContextType>;
  InternalCreateOrUpdateCoOwnersPlanOfferingError?: InternalCreateOrUpdateCoOwnersPlanOfferingErrorResolvers<ContextType>;
  InternalCreateOrUpdateCoOwnersPlanOfferingErrorCase?: InternalCreateOrUpdateCoOwnersPlanOfferingErrorCaseResolvers;
  InternalCreateOrUpdateCoOwnersPlanOfferingPayload?: InternalCreateOrUpdateCoOwnersPlanOfferingPayloadResolvers<ContextType>;
  InternalCreateOrUpdateCoOwnersWebinarScheduleError?: InternalCreateOrUpdateCoOwnersWebinarScheduleErrorResolvers<ContextType>;
  InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCase?: InternalCreateOrUpdateCoOwnersWebinarScheduleErrorCaseResolvers;
  InternalCreateOrUpdateCoOwnersWebinarSchedulePayload?: InternalCreateOrUpdateCoOwnersWebinarSchedulePayloadResolvers<ContextType>;
  InternalCreateOrUpdateContentArchitectPayload?: InternalCreateOrUpdateContentArchitectPayloadResolvers<ContextType>;
  InternalCreateOrUpdateContentArchitecturalFeaturePayload?: InternalCreateOrUpdateContentArchitecturalFeaturePayloadResolvers<ContextType>;
  InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayload?: InternalCreateOrUpdateContentArchitecturalFeatureUsageRulePayloadResolvers<ContextType>;
  InternalCreateOrUpdateContentArchitectureTypePayload?: InternalCreateOrUpdateContentArchitectureTypePayloadResolvers<ContextType>;
  InternalCreateOrUpdateContentArchitectureTypeVariantPayload?: InternalCreateOrUpdateContentArchitectureTypeVariantPayloadResolvers<ContextType>;
  InternalCreateOrUpdateContentBasicAmenityPayload?: InternalCreateOrUpdateContentBasicAmenityPayloadResolvers<ContextType>;
  InternalCreateOrUpdateContentFacilityAmenityPayload?: InternalCreateOrUpdateContentFacilityAmenityPayloadResolvers<ContextType>;
  InternalCreateOrUpdateFacilityError?: InternalCreateOrUpdateFacilityErrorResolvers<ContextType>;
  InternalCreateOrUpdateFacilityErrorCase?: InternalCreateOrUpdateFacilityErrorCaseResolvers;
  InternalCreateOrUpdateFacilityPayload?: InternalCreateOrUpdateFacilityPayloadResolvers<ContextType>;
  InternalCreateOrUpdateFacilityResourceBlockError?: InternalCreateOrUpdateFacilityResourceBlockErrorResolvers<ContextType>;
  InternalCreateOrUpdateFacilityResourceBlockErrorCase?: InternalCreateOrUpdateFacilityResourceBlockErrorCaseResolvers;
  InternalCreateOrUpdateFacilityResourceBlockPayload?: InternalCreateOrUpdateFacilityResourceBlockPayloadResolvers<ContextType>;
  InternalCreateOrUpdateNativeAppHomeContentError?: InternalCreateOrUpdateNativeAppHomeContentErrorResolvers<ContextType>;
  InternalCreateOrUpdateNativeAppHomeContentErrorCase?: InternalCreateOrUpdateNativeAppHomeContentErrorCaseResolvers;
  InternalCreateOrUpdateNativeAppHomeContentPayload?: InternalCreateOrUpdateNativeAppHomeContentPayloadResolvers<ContextType>;
  InternalCreateOrUpdateNewsError?: InternalCreateOrUpdateNewsErrorResolvers<ContextType>;
  InternalCreateOrUpdateNewsErrorCase?: InternalCreateOrUpdateNewsErrorCaseResolvers;
  InternalCreateOrUpdateNewsPayload?: InternalCreateOrUpdateNewsPayloadResolvers<ContextType>;
  InternalCreateOrUpdateOrganizationError?: InternalCreateOrUpdateOrganizationErrorResolvers<ContextType>;
  InternalCreateOrUpdateOrganizationErrorCase?: InternalCreateOrUpdateOrganizationErrorCaseResolvers;
  InternalCreateOrUpdateOrganizationPayload?: InternalCreateOrUpdateOrganizationPayloadResolvers<ContextType>;
  InternalCreateOrUpdateOrganizationYearlyContractError?: InternalCreateOrUpdateOrganizationYearlyContractErrorResolvers<ContextType>;
  InternalCreateOrUpdateOrganizationYearlyContractInvoiceError?: InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorResolvers<ContextType>;
  InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCase?: InternalCreateOrUpdateOrganizationYearlyContractInvoiceErrorCaseResolvers;
  InternalCreateOrUpdateOrganizationYearlyContractInvoicePayload?: InternalCreateOrUpdateOrganizationYearlyContractInvoicePayloadResolvers<ContextType>;
  InternalCreateOrUpdateOrganizationYearlyContractPayload?: InternalCreateOrUpdateOrganizationYearlyContractPayloadResolvers<ContextType>;
  InternalCreateOrUpdateOwnerPlanError?: InternalCreateOrUpdateOwnerPlanErrorResolvers<ContextType>;
  InternalCreateOrUpdateOwnerPlanErrorCase?: InternalCreateOrUpdateOwnerPlanErrorCaseResolvers;
  InternalCreateOrUpdateOwnerPlanPayload?: InternalCreateOrUpdateOwnerPlanPayloadResolvers<ContextType>;
  InternalCreateOrUpdateSiteActivityProgramError?: InternalCreateOrUpdateSiteActivityProgramErrorResolvers<ContextType>;
  InternalCreateOrUpdateSiteActivityProgramErrorCase?: InternalCreateOrUpdateSiteActivityProgramErrorCaseResolvers;
  InternalCreateOrUpdateSiteActivityProgramPayload?: InternalCreateOrUpdateSiteActivityProgramPayloadResolvers<ContextType>;
  InternalCreateOrUpdateSiteFaqError?: InternalCreateOrUpdateSiteFaqErrorResolvers<ContextType>;
  InternalCreateOrUpdateSiteFaqErrorCase?: InternalCreateOrUpdateSiteFaqErrorCaseResolvers;
  InternalCreateOrUpdateSiteFaqPayload?: InternalCreateOrUpdateSiteFaqPayloadResolvers<ContextType>;
  InternalCreateOrUpdateStaffGroupError?: InternalCreateOrUpdateStaffGroupErrorResolvers<ContextType>;
  InternalCreateOrUpdateStaffGroupErrorCase?: InternalCreateOrUpdateStaffGroupErrorCaseResolvers;
  InternalCreateOrUpdateStaffGroupPayload?: InternalCreateOrUpdateStaffGroupPayloadResolvers<ContextType>;
  InternalCreateOrUpdateStayTicketMasterError?: InternalCreateOrUpdateStayTicketMasterErrorResolvers<ContextType>;
  InternalCreateOrUpdateStayTicketMasterErrorCase?: InternalCreateOrUpdateStayTicketMasterErrorCaseResolvers;
  InternalCreateOrUpdateStayTicketMasterPayload?: InternalCreateOrUpdateStayTicketMasterPayloadResolvers<ContextType>;
  InternalCreateOrUpdateStayTicketMasterTemplateError?: InternalCreateOrUpdateStayTicketMasterTemplateErrorResolvers<ContextType>;
  InternalCreateOrUpdateStayTicketMasterTemplateErrorCase?: InternalCreateOrUpdateStayTicketMasterTemplateErrorCaseResolvers;
  InternalCreateOrUpdateStayTicketMasterTemplatePayload?: InternalCreateOrUpdateStayTicketMasterTemplatePayloadResolvers<ContextType>;
  InternalCreateOrUpdateStayTicketTemplateError?: InternalCreateOrUpdateStayTicketTemplateErrorResolvers<ContextType>;
  InternalCreateOrUpdateSupplyItemInstallationsError?: InternalCreateOrUpdateSupplyItemInstallationsErrorResolvers<ContextType>;
  InternalCreateOrUpdateSupplyItemInstallationsErrorCase?: InternalCreateOrUpdateSupplyItemInstallationsErrorCaseResolvers;
  InternalCreateOrUpdateSupplyItemInstallationsPayload?: InternalCreateOrUpdateSupplyItemInstallationsPayloadResolvers<ContextType>;
  InternalCreateOrUpdateSupplyItemMasterError?: InternalCreateOrUpdateSupplyItemMasterErrorResolvers<ContextType>;
  InternalCreateOrUpdateSupplyItemMasterErrorCase?: InternalCreateOrUpdateSupplyItemMasterErrorCaseResolvers;
  InternalCreateOrUpdateSupplyItemMasterPayload?: InternalCreateOrUpdateSupplyItemMasterPayloadResolvers<ContextType>;
  InternalCreateSiteError?: InternalCreateSiteErrorResolvers<ContextType>;
  InternalCreateSiteErrorCase?: InternalCreateSiteErrorCaseResolvers;
  InternalCreateSitePayload?: InternalCreateSitePayloadResolvers<ContextType>;
  InternalCreateStayTicketTemplatePayload?: InternalCreateStayTicketTemplatePayloadResolvers<ContextType>;
  InternalCreateTermsRevisionError?: InternalCreateTermsRevisionErrorResolvers<ContextType>;
  InternalCreateTermsRevisionErrorCase?: InternalCreateTermsRevisionErrorCaseResolvers;
  InternalCreateTermsRevisionPayload?: InternalCreateTermsRevisionPayloadResolvers<ContextType>;
  InternalDeleteAccommodationEquipmentPayload?: InternalDeleteAccommodationEquipmentPayloadResolvers<ContextType>;
  InternalDeleteAccommodationEquipmentSuccess?: InternalDeleteAccommodationEquipmentSuccessResolvers<ContextType>;
  InternalDeleteArchitectureContentPayload?: InternalDeleteArchitectureContentPayloadResolvers<ContextType>;
  InternalDeleteFacilityResourceBlockError?: InternalDeleteFacilityResourceBlockErrorResolvers<ContextType>;
  InternalDeleteFacilityResourceBlockErrorCase?: InternalDeleteFacilityResourceBlockErrorCaseResolvers;
  InternalDeleteFacilityResourceBlockPayload?: InternalDeleteFacilityResourceBlockPayloadResolvers<ContextType>;
  InternalDeleteLocalTaxPolicyError?: InternalDeleteLocalTaxPolicyErrorResolvers<ContextType>;
  InternalDeleteLocalTaxPolicyErrorCase?: InternalDeleteLocalTaxPolicyErrorCaseResolvers;
  InternalDeleteLocalTaxPolicyPayload?: InternalDeleteLocalTaxPolicyPayloadResolvers<ContextType>;
  InternalDeleteSupplyItemInstallationError?: InternalDeleteSupplyItemInstallationErrorResolvers<ContextType>;
  InternalDeleteSupplyItemInstallationErrorCase?: InternalDeleteSupplyItemInstallationErrorCaseResolvers;
  InternalDeleteSupplyItemInstallationPayload?: InternalDeleteSupplyItemInstallationPayloadResolvers<ContextType>;
  InternalDeleteSupplyItemMasterError?: InternalDeleteSupplyItemMasterErrorResolvers<ContextType>;
  InternalDeleteSupplyItemMasterErrorCase?: InternalDeleteSupplyItemMasterErrorCaseResolvers;
  InternalDeleteSupplyItemMasterPayload?: InternalDeleteSupplyItemMasterPayloadResolvers<ContextType>;
  InternalFacilityController?: InternalFacilityControllerResolvers<ContextType>;
  InternalFutureCleaningAmount?: InternalFutureCleaningAmountResolvers<ContextType>;
  InternalFutureCleaningAmountByFacility?: InternalFutureCleaningAmountByFacilityResolvers<ContextType>;
  InternalFutureCleaningAmounts?: InternalFutureCleaningAmountsResolvers<ContextType>;
  InternalFutureCleaningAmountsError?: InternalFutureCleaningAmountsErrorResolvers<ContextType>;
  InternalFutureCleaningAmountsPayload?: InternalFutureCleaningAmountsPayloadResolvers<ContextType>;
  InternalGenerateUserMonthlyStatementError?: InternalGenerateUserMonthlyStatementErrorResolvers<ContextType>;
  InternalGenerateUserMonthlyStatementErrorCase?: InternalGenerateUserMonthlyStatementErrorCaseResolvers;
  InternalGenerateUserMonthlyStatementPayload?: InternalGenerateUserMonthlyStatementPayloadResolvers<ContextType>;
  InternalGrantableAdminRole?: InternalGrantableAdminRoleResolvers<ContextType>;
  InternalInvalidateOrganizationYearlyContractError?: InternalInvalidateOrganizationYearlyContractErrorResolvers<ContextType>;
  InternalInvalidateOrganizationYearlyContractErrorCase?: InternalInvalidateOrganizationYearlyContractErrorCaseResolvers;
  InternalInvalidateOrganizationYearlyContractInvoiceError?: InternalInvalidateOrganizationYearlyContractInvoiceErrorResolvers<ContextType>;
  InternalInvalidateOrganizationYearlyContractInvoiceErrorCase?: InternalInvalidateOrganizationYearlyContractInvoiceErrorCaseResolvers;
  InternalInvalidateOrganizationYearlyContractInvoicePayload?: InternalInvalidateOrganizationYearlyContractInvoicePayloadResolvers<ContextType>;
  InternalInvalidateOrganizationYearlyContractPayload?: InternalInvalidateOrganizationYearlyContractPayloadResolvers<ContextType>;
  InternalInvalidateS2oPointsError?: InternalInvalidateS2oPointsErrorResolvers<ContextType>;
  InternalInvalidateS2oPointsErrorCase?: InternalInvalidateS2oPointsErrorCaseResolvers;
  InternalInvalidateS2oPointsPayload?: InternalInvalidateS2oPointsPayloadResolvers<ContextType>;
  InternalInvalidateStayTicketsByCodeResult?: InternalInvalidateStayTicketsByCodeResultResolvers<ContextType>;
  InternalIssueS2oPointsError?: InternalIssueS2oPointsErrorResolvers<ContextType>;
  InternalIssueS2oPointsErrorCase?: InternalIssueS2oPointsErrorCaseResolvers;
  InternalIssueS2oPointsPayload?: InternalIssueS2oPointsPayloadResolvers<ContextType>;
  InternalJtasCreateOrUpdateInspectionStatusesError?: InternalJtasCreateOrUpdateInspectionStatusesErrorResolvers<ContextType>;
  InternalJtasCreateOrUpdateInspectionStatusesErrorCase?: InternalJtasCreateOrUpdateInspectionStatusesErrorCaseResolvers;
  InternalJtasCreateOrUpdateInspectionStatusesPayload?: InternalJtasCreateOrUpdateInspectionStatusesPayloadResolvers<ContextType>;
  InternalJtasCreateOrUpdateSupplyReportError?: InternalJtasCreateOrUpdateSupplyReportErrorResolvers<ContextType>;
  InternalJtasCreateOrUpdateSupplyReportErrorCase?: InternalJtasCreateOrUpdateSupplyReportErrorCaseResolvers;
  InternalJtasCreateOrUpdateSupplyReportPayload?: InternalJtasCreateOrUpdateSupplyReportPayloadResolvers<ContextType>;
  InternalJtasCreateOrUpdateViolationReportError?: InternalJtasCreateOrUpdateViolationReportErrorResolvers<ContextType>;
  InternalJtasCreateOrUpdateViolationReportErrorCase?: InternalJtasCreateOrUpdateViolationReportErrorCaseResolvers;
  InternalJtasCreateOrUpdateViolationReportPayload?: InternalJtasCreateOrUpdateViolationReportPayloadResolvers<ContextType>;
  InternalJtasDeleteViolationReportError?: InternalJtasDeleteViolationReportErrorResolvers<ContextType>;
  InternalJtasDeleteViolationReportErrorCase?: InternalJtasDeleteViolationReportErrorCaseResolvers;
  InternalJtasDeleteViolationReportPayload?: InternalJtasDeleteViolationReportPayloadResolvers<ContextType>;
  InternalLeaveOrganizationError?: InternalLeaveOrganizationErrorResolvers<ContextType>;
  InternalLeaveOrganizationErrorCase?: InternalLeaveOrganizationErrorCaseResolvers;
  InternalLeaveOrganizationPayload?: InternalLeaveOrganizationPayloadResolvers<ContextType>;
  InternalLocalizedString?: InternalLocalizedStringResolvers<ContextType>;
  InternalMarkCoOwnersApplicationPlannedForSaleError?: InternalMarkCoOwnersApplicationPlannedForSaleErrorResolvers<ContextType>;
  InternalMarkCoOwnersApplicationPlannedForSaleErrorCase?: InternalMarkCoOwnersApplicationPlannedForSaleErrorCaseResolvers;
  InternalMarkCoOwnersApplicationPlannedForSalePayload?: InternalMarkCoOwnersApplicationPlannedForSalePayloadResolvers<ContextType>;
  InternalMarkCoOwnersApplicationSoldError?: InternalMarkCoOwnersApplicationSoldErrorResolvers<ContextType>;
  InternalMarkCoOwnersApplicationSoldErrorCase?: InternalMarkCoOwnersApplicationSoldErrorCaseResolvers;
  InternalMarkCoOwnersApplicationSoldPayload?: InternalMarkCoOwnersApplicationSoldPayloadResolvers<ContextType>;
  InternalNativeAppHomeContent?: InternalNativeAppHomeContentResolvers<ContextType>;
  InternalOneShotScript?: InternalOneShotScriptResolvers<ContextType>;
  InternalOtaRoomUnit?: InternalOtaRoomUnitResolvers<ContextType>;
  InternalPartialUpdateOrganizationError?: InternalPartialUpdateOrganizationErrorResolvers<ContextType>;
  InternalPartialUpdateOrganizationPayload?: InternalPartialUpdateOrganizationPayloadResolvers<ContextType>;
  InternalReleaseAccessKeyError?: InternalReleaseAccessKeyErrorResolvers<ContextType>;
  InternalReleaseAccessKeyPayload?: InternalReleaseAccessKeyPayloadResolvers<ContextType>;
  InternalRemoveLocalTaxPolicyError?: InternalRemoveLocalTaxPolicyErrorResolvers<ContextType>;
  InternalRemoveLocalTaxPolicyErrorCase?: InternalRemoveLocalTaxPolicyErrorCaseResolvers;
  InternalRemoveLocalTaxPolicyPayload?: InternalRemoveLocalTaxPolicyPayloadResolvers<ContextType>;
  InternalRevokeAdminRoleError?: InternalRevokeAdminRoleErrorResolvers<ContextType>;
  InternalRevokeAdminRoleErrorCode?: InternalRevokeAdminRoleErrorCodeResolvers;
  InternalRevokeAdminRolePayload?: InternalRevokeAdminRolePayloadResolvers<ContextType>;
  InternalRoomType?: InternalRoomTypeResolvers<ContextType>;
  InternalRoomTypeFeature?: InternalRoomTypeFeatureResolvers<ContextType>;
  InternalRunOneShotScriptError?: InternalRunOneShotScriptErrorResolvers<ContextType>;
  InternalRunOneShotScriptErrorCase?: InternalRunOneShotScriptErrorCaseResolvers;
  InternalRunOneShotScriptResult?: InternalRunOneShotScriptResultResolvers<ContextType>;
  InternalScriptAffectedCount?: InternalScriptAffectedCountResolvers<ContextType>;
  InternalScriptExecution?: InternalScriptExecutionResolvers<ContextType>;
  InternalScriptExecutionActor?: InternalScriptExecutionActorResolvers<ContextType>;
  InternalScriptExecutionLogLine?: InternalScriptExecutionLogLineResolvers<ContextType>;
  InternalSendPushNotificationsError?: InternalSendPushNotificationsErrorResolvers<ContextType>;
  InternalSendPushNotificationsErrorCase?: InternalSendPushNotificationsErrorCaseResolvers;
  InternalSendPushNotificationsPayload?: InternalSendPushNotificationsPayloadResolvers<ContextType>;
  InternalSendPushNotificationsResult?: InternalSendPushNotificationsResultResolvers<ContextType>;
  InternalSite?: InternalSiteResolvers<ContextType>;
  InternalSiteAddress?: InternalSiteAddressResolvers<ContextType>;
  InternalStaffContract?: InternalStaffContractResolvers<ContextType>;
  InternalStaffCreditTransaction?: InternalStaffCreditTransactionResolvers<ContextType>;
  InternalStartStaffPlanError?: InternalStartStaffPlanErrorResolvers<ContextType>;
  InternalStartStaffPlanErrorCase?: InternalStartStaffPlanErrorCaseResolvers;
  InternalStartStaffPlanResult?: InternalStartStaffPlanResultResolvers<ContextType>;
  InternalStartStaffPlanSuccess?: InternalStartStaffPlanSuccessResolvers<ContextType>;
  InternalStayTicketsOrderBy?: InternalStayTicketsOrderByResolvers;
  InternalStayTicketsResult?: InternalStayTicketsResultResolvers<ContextType>;
  InternalStopStaffPlanError?: InternalStopStaffPlanErrorResolvers<ContextType>;
  InternalStopStaffPlanErrorCase?: InternalStopStaffPlanErrorCaseResolvers;
  InternalStopStaffPlanResult?: InternalStopStaffPlanResultResolvers<ContextType>;
  InternalStopStaffPlanSuccess?: InternalStopStaffPlanSuccessResolvers<ContextType>;
  InternalUnlinkIdentityPayload?: InternalUnlinkIdentityPayloadResolvers<ContextType>;
  InternalUpdateAccommodationEquipmentPayload?: InternalUpdateAccommodationEquipmentPayloadResolvers<ContextType>;
  InternalUpdateAccommodationOperationGroupSettingError?: InternalUpdateAccommodationOperationGroupSettingErrorResolvers<ContextType>;
  InternalUpdateAccommodationOperationGroupSettingErrorCase?: InternalUpdateAccommodationOperationGroupSettingErrorCaseResolvers;
  InternalUpdateAccommodationOperationGroupSettingPayload?: InternalUpdateAccommodationOperationGroupSettingPayloadResolvers<ContextType>;
  InternalUpdateAreaError?: InternalUpdateAreaErrorResolvers<ContextType>;
  InternalUpdateAreaErrorCase?: InternalUpdateAreaErrorCaseResolvers;
  InternalUpdateAreaPayload?: InternalUpdateAreaPayloadResolvers<ContextType>;
  InternalUpdateCoOwnersApplicationDetailError?: InternalUpdateCoOwnersApplicationDetailErrorResolvers<ContextType>;
  InternalUpdateCoOwnersApplicationDetailErrorCase?: InternalUpdateCoOwnersApplicationDetailErrorCaseResolvers;
  InternalUpdateCoOwnersApplicationDetailPayload?: InternalUpdateCoOwnersApplicationDetailPayloadResolvers<ContextType>;
  InternalUpdateCoOwnersApplicationFileError?: InternalUpdateCoOwnersApplicationFileErrorResolvers<ContextType>;
  InternalUpdateCoOwnersApplicationFileErrorCase?: InternalUpdateCoOwnersApplicationFileErrorCaseResolvers;
  InternalUpdateCoOwnersApplicationFilePayload?: InternalUpdateCoOwnersApplicationFilePayloadResolvers<ContextType>;
  InternalUpdateCoOwnersApplicationInfoError?: InternalUpdateCoOwnersApplicationInfoErrorResolvers<ContextType>;
  InternalUpdateCoOwnersApplicationInfoErrorCase?: InternalUpdateCoOwnersApplicationInfoErrorCaseResolvers;
  InternalUpdateCoOwnersApplicationInfoPayload?: InternalUpdateCoOwnersApplicationInfoPayloadResolvers<ContextType>;
  InternalUpdateCoOwnersApplicationStatusError?: InternalUpdateCoOwnersApplicationStatusErrorResolvers<ContextType>;
  InternalUpdateCoOwnersApplicationStatusErrorCase?: InternalUpdateCoOwnersApplicationStatusErrorCaseResolvers;
  InternalUpdateCoOwnersApplicationStatusPayload?: InternalUpdateCoOwnersApplicationStatusPayloadResolvers<ContextType>;
  InternalUpdateFacilityContentImagesPayload?: InternalUpdateFacilityContentImagesPayloadResolvers<ContextType>;
  InternalUpdateFacilityReservationCleaningError?: InternalUpdateFacilityReservationCleaningErrorResolvers<ContextType>;
  InternalUpdateFacilityReservationCleaningErrorCase?: InternalUpdateFacilityReservationCleaningErrorCaseResolvers;
  InternalUpdateFacilityReservationCleaningPayload?: InternalUpdateFacilityReservationCleaningPayloadResolvers<ContextType>;
  InternalUpdateFacilityReservationDataSyncError?: InternalUpdateFacilityReservationDataSyncErrorResolvers<ContextType>;
  InternalUpdateFacilityReservationDataSyncErrorCase?: InternalUpdateFacilityReservationDataSyncErrorCaseResolvers;
  InternalUpdateFacilityReservationDataSyncPayload?: InternalUpdateFacilityReservationDataSyncPayloadResolvers<ContextType>;
  InternalUpdateIdentityVerificationError?: InternalUpdateIdentityVerificationErrorResolvers<ContextType>;
  InternalUpdateIdentityVerificationErrorCase?: InternalUpdateIdentityVerificationErrorCaseResolvers;
  InternalUpdateIdentityVerificationPayload?: InternalUpdateIdentityVerificationPayloadResolvers<ContextType>;
  InternalUpdateIndividualTermsDocumentError?: InternalUpdateIndividualTermsDocumentErrorResolvers<ContextType>;
  InternalUpdateIndividualTermsDocumentErrorCase?: InternalUpdateIndividualTermsDocumentErrorCaseResolvers;
  InternalUpdateIndividualTermsDocumentPayload?: InternalUpdateIndividualTermsDocumentPayloadResolvers<ContextType>;
  InternalUpdateInspectionViolationHandlingError?: InternalUpdateInspectionViolationHandlingErrorResolvers<ContextType>;
  InternalUpdateInspectionViolationHandlingErrorCase?: InternalUpdateInspectionViolationHandlingErrorCaseResolvers;
  InternalUpdateInspectionViolationHandlingPayload?: InternalUpdateInspectionViolationHandlingPayloadResolvers<ContextType>;
  InternalUpdateLocalTaxPolicyError?: InternalUpdateLocalTaxPolicyErrorResolvers<ContextType>;
  InternalUpdateLocalTaxPolicyErrorCase?: InternalUpdateLocalTaxPolicyErrorCaseResolvers;
  InternalUpdateLocalTaxPolicyPayload?: InternalUpdateLocalTaxPolicyPayloadResolvers<ContextType>;
  InternalUpdateSiteError?: InternalUpdateSiteErrorResolvers<ContextType>;
  InternalUpdateSiteErrorCase?: InternalUpdateSiteErrorCaseResolvers;
  InternalUpdateSiteImagesPayload?: InternalUpdateSiteImagesPayloadResolvers<ContextType>;
  InternalUpdateSiteParametersError?: InternalUpdateSiteParametersErrorResolvers<ContextType>;
  InternalUpdateSiteParametersPayload?: InternalUpdateSiteParametersPayloadResolvers<ContextType>;
  InternalUpdateSitePayload?: InternalUpdateSitePayloadResolvers<ContextType>;
  InternalUpdateStayTicketInvalidStatusError?: InternalUpdateStayTicketInvalidStatusErrorResolvers<ContextType>;
  InternalUpdateStayTicketNotFoundError?: InternalUpdateStayTicketNotFoundErrorResolvers<ContextType>;
  InternalUpdateStayTicketPayload?: InternalUpdateStayTicketPayloadResolvers<ContextType>;
  InternalUpsertBaseAccommodationFeeDailyRateError?: InternalUpsertBaseAccommodationFeeDailyRateErrorResolvers<ContextType>;
  InternalUpsertBaseAccommodationFeeDailyRatesPayload?: InternalUpsertBaseAccommodationFeeDailyRatesPayloadResolvers<ContextType>;
  InternalUpsertConsumedSupplyFeeItemWaiversError?: InternalUpsertConsumedSupplyFeeItemWaiversErrorResolvers<ContextType>;
  InternalUpsertConsumedSupplyFeeItemWaiversPayload?: InternalUpsertConsumedSupplyFeeItemWaiversPayloadResolvers<ContextType>;
  InternalUserSearchResult?: InternalUserSearchResultResolvers<ContextType>;
  InternalUserStats?: InternalUserStatsResolvers<ContextType>;
  InternalVoidCoOwnersApplicationError?: InternalVoidCoOwnersApplicationErrorResolvers<ContextType>;
  InternalVoidCoOwnersApplicationErrorCase?: InternalVoidCoOwnersApplicationErrorCaseResolvers;
  InternalVoidCoOwnersApplicationPayload?: InternalVoidCoOwnersApplicationPayloadResolvers<ContextType>;
  InviteBusinessMembersError?: InviteBusinessMembersErrorResolvers<ContextType>;
  InviteBusinessMembersErrorCase?: InviteBusinessMembersErrorCaseResolvers;
  InviteBusinessMembersPayload?: InviteBusinessMembersPayloadResolvers<ContextType>;
  InviteBusinessMembersSuccess?: InviteBusinessMembersSuccessResolvers<ContextType>;
  IssueSanuEdgeDeviceAccessTokenError?: IssueSanuEdgeDeviceAccessTokenErrorResolvers<ContextType>;
  IssueSanuEdgeDeviceAccessTokenErrorCase?: IssueSanuEdgeDeviceAccessTokenErrorCaseResolvers;
  IssueSanuEdgeDeviceAccessTokenPayload?: IssueSanuEdgeDeviceAccessTokenPayloadResolvers<ContextType>;
  IssueSanuEdgeDeviceAccessTokenSuccess?: IssueSanuEdgeDeviceAccessTokenSuccessResolvers<ContextType>;
  IssueStayTicketsError?: IssueStayTicketsErrorResolvers<ContextType>;
  IssueStayTicketsErrorCase?: IssueStayTicketsErrorCaseResolvers;
  IssueStayTicketsPayload?: IssueStayTicketsPayloadResolvers<ContextType>;
  IssueStayTicketsResult?: IssueStayTicketsResultResolvers<ContextType>;
  JoinOrganizationError?: JoinOrganizationErrorResolvers<ContextType>;
  JoinOrganizationErrorCase?: JoinOrganizationErrorCaseResolvers;
  JoinOrganizationPayload?: JoinOrganizationPayloadResolvers<ContextType>;
  LeaveOrganizationByViewerError?: LeaveOrganizationByViewerErrorResolvers<ContextType>;
  LeaveOrganizationByViewerPayload?: LeaveOrganizationByViewerPayloadResolvers<ContextType>;
  LeaveOrganizationError?: LeaveOrganizationErrorResolvers<ContextType>;
  LeaveOrganizationErrorCase?: LeaveOrganizationErrorCaseResolvers;
  LoadDataOutput?: LoadDataOutputResolvers<ContextType>;
  LoadDataOutputResult?: LoadDataOutputResultResolvers<ContextType>;
  LoadDataOutputResultError?: LoadDataOutputResultErrorResolvers<ContextType>;
  LoadDataTarget?: LoadDataTargetResolvers;
  LocalTaxBracket?: LocalTaxBracketResolvers<ContextType>;
  LocalTaxPolicy?: LocalTaxPolicyResolvers<ContextType>;
  LocalTaxPolicyType?: LocalTaxPolicyTypeResolvers;
  LocalTaxType?: LocalTaxTypeResolvers;
  MemberPerksNowhereDrinkTicket?: MemberPerksNowhereDrinkTicketResolvers<ContextType>;
  MusicConnectEquipmentAttribute?: MusicConnectEquipmentAttributeResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NativeAppHomeContent?: NativeAppHomeContentResolvers<ContextType>;
  NativeAppHomeContentLabel?: NativeAppHomeContentLabelResolvers<ContextType>;
  NativeAppHomeContentLabelType?: NativeAppHomeContentLabelTypeResolvers;
  NativeAppHomeContentLink?: NativeAppHomeContentLinkResolvers<ContextType>;
  NativeAppHomeContentLinkAction?: NativeAppHomeContentLinkActionResolvers;
  NativeAppHomeContentStatus?: NativeAppHomeContentStatusResolvers;
  News?: NewsResolvers<ContextType>;
  NewsContentType?: NewsContentTypeResolvers;
  NewsDisplayCategory?: NewsDisplayCategoryResolvers;
  NewsStatus?: NewsStatusResolvers;
  OccupancyLimitTarget?: OccupancyLimitTargetResolvers;
  OccupancyLimitTargetType?: OccupancyLimitTargetTypeResolvers;
  OneMoreCabinAccommodationReservationProvider?: OneMoreCabinAccommodationReservationProviderResolvers<ContextType>;
  OnlineTravelAgentAccommodationReservationProvider?: OnlineTravelAgentAccommodationReservationProviderResolvers<ContextType>;
  OnsenAccommodationFacility?: OnsenAccommodationFacilityResolvers<ContextType>;
  OnsenAndSaunaDoorLock?: OnsenAndSaunaDoorLockResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  OrganizationControl?: OrganizationControlResolvers<ContextType>;
  OrganizationMemberCustomField?: OrganizationMemberCustomFieldResolvers<ContextType>;
  OrganizationMemberNewReservationStatus?: OrganizationMemberNewReservationStatusResolvers<ContextType>;
  OrganizationMemberPayload?: OrganizationMemberPayloadResolvers<ContextType>;
  OrganizationMemberReservationStatus?: OrganizationMemberReservationStatusResolvers;
  OrganizationMembersStay?: OrganizationMembersStayResolvers<ContextType>;
  OrganizationMembership?: OrganizationMembershipResolvers<ContextType>;
  OrganizationMonthlyReservationStatus?: OrganizationMonthlyReservationStatusResolvers<ContextType>;
  OrganizationOnboardingInfo?: OrganizationOnboardingInfoResolvers<ContextType>;
  OrganizationPlanMonthlyConsumedNights?: OrganizationPlanMonthlyConsumedNightsResolvers<ContextType>;
  OrganizationRole?: OrganizationRoleResolvers;
  OrganizationYearlyContract?: OrganizationYearlyContractResolvers<ContextType>;
  OrganizationYearlyContractInvoiceFrequency?: OrganizationYearlyContractInvoiceFrequencyResolvers;
  OrganizationYearlyContractInvoicePaymentMethodType?: OrganizationYearlyContractInvoicePaymentMethodTypeResolvers;
  OrganizationYearlyContractInvoicesResult?: OrganizationYearlyContractInvoicesResultResolvers<ContextType>;
  OrganizationYearlyContractSortField?: OrganizationYearlyContractSortFieldResolvers;
  OrganizationYearlyContractsResult?: OrganizationYearlyContractsResultResolvers<ContextType>;
  OrganizationYearlyReservationStatus?: OrganizationYearlyReservationStatusResolvers<ContextType>;
  OtaReservationLookupError?: OtaReservationLookupErrorResolvers<ContextType>;
  OtaReservationLookupErrorCase?: OtaReservationLookupErrorCaseResolvers;
  OtaReservationLookupResult?: OtaReservationLookupResultResolvers<ContextType>;
  OtaReservationLookupSuccess?: OtaReservationLookupSuccessResolvers<ContextType>;
  OwnerIntendedUsageType?: OwnerIntendedUsageTypeResolvers;
  OwnerOrganizationBeneficialOwnerRelationshipType?: OwnerOrganizationBeneficialOwnerRelationshipTypeResolvers;
  OwnerOrganizationBusinessActivityType?: OwnerOrganizationBusinessActivityTypeResolvers;
  OwnerOrganizationRelationshipType?: OwnerOrganizationRelationshipTypeResolvers;
  OwnerPlan?: OwnerPlanResolvers<ContextType>;
  OwnerPlanType?: OwnerPlanTypeResolvers;
  OwnerPurchasePurposeType?: OwnerPurchasePurposeTypeResolvers;
  PartialUpdateOrganizationError?: PartialUpdateOrganizationErrorResolvers<ContextType>;
  PartialUpdateOrganizationMembershipError?: PartialUpdateOrganizationMembershipErrorResolvers<ContextType>;
  PartialUpdateOrganizationMembershipPayload?: PartialUpdateOrganizationMembershipPayloadResolvers<ContextType>;
  PartialUpdateOrganizationPayload?: PartialUpdateOrganizationPayloadResolvers<ContextType>;
  PaymentMethodType?: PaymentMethodTypeResolvers;
  PlainDate?: GraphQLScalarType;
  PlainDateTime?: GraphQLScalarType;
  PlainYearMonth?: GraphQLScalarType;
  PlugDevice?: PlugDeviceResolvers<ContextType>;
  PlugDeviceStatus?: PlugDeviceStatusResolvers;
  PostStayReviewResponseError?: PostStayReviewResponseErrorResolvers<ContextType>;
  PostStayReviewResponseErrorCase?: PostStayReviewResponseErrorCaseResolvers;
  PostStayReviewResponsePayload?: PostStayReviewResponsePayloadResolvers<ContextType>;
  PriceWithTaxRate?: PriceWithTaxRateResolvers<ContextType>;
  ProcessCronJobResponse?: ProcessCronJobResponseResolvers<ContextType>;
  ProcessStripeEventResponse?: ProcessStripeEventResponseResolvers<ContextType>;
  ProcessTrustdockEventResponse?: ProcessTrustdockEventResponseResolvers<ContextType>;
  PushNotificationPlatform?: PushNotificationPlatformResolvers;
  Query?: QueryResolvers<ContextType>;
  RawBaseAccommodationFeePolicy?: RawBaseAccommodationFeePolicyResolvers<ContextType>;
  RawCancelFeePolicy?: RawCancelFeePolicyResolvers<ContextType>;
  RawNews?: RawNewsResolvers<ContextType>;
  RawSiteFaq?: RawSiteFaqResolvers<ContextType>;
  RedirectLocation?: RedirectLocationResolvers<ContextType>;
  RegisterCoOwnersApplicationFileError?: RegisterCoOwnersApplicationFileErrorResolvers<ContextType>;
  RegisterCoOwnersApplicationFileErrorCase?: RegisterCoOwnersApplicationFileErrorCaseResolvers;
  RegisterCoOwnersApplicationFilePayload?: RegisterCoOwnersApplicationFilePayloadResolvers<ContextType>;
  RegisterCoOwnersApplicationFileSuccess?: RegisterCoOwnersApplicationFileSuccessResolvers<ContextType>;
  RemoveIdentityError?: RemoveIdentityErrorResolvers<ContextType>;
  RemoveIdentityErrorCase?: RemoveIdentityErrorCaseResolvers;
  RemoveIdentityPayload?: RemoveIdentityPayloadResolvers<ContextType>;
  RemoveIdentitySuccess?: RemoveIdentitySuccessResolvers<ContextType>;
  RentalCycleKeyBox?: RentalCycleKeyBoxResolvers<ContextType>;
  ReservationExportItem?: ReservationExportItemResolvers<ContextType>;
  ReservationPriceStatement?: ReservationPriceStatementResolvers<ContextType>;
  ReservationRuleRevision2027Policy?: ReservationRuleRevision2027PolicyResolvers<ContextType>;
  ReservationStatementItem?: ReservationStatementItemResolvers<ContextType>;
  ResourcePermission?: ResourcePermissionResolvers;
  ResumeStandardSubscriptionImmediatelyError?: ResumeStandardSubscriptionImmediatelyErrorResolvers<ContextType>;
  ResumeStandardSubscriptionImmediatelyErrorCase?: ResumeStandardSubscriptionImmediatelyErrorCaseResolvers;
  ResumeStandardSubscriptionImmediatelyPayload?: ResumeStandardSubscriptionImmediatelyPayloadResolvers<ContextType>;
  RoomType?: RoomTypeResolvers<ContextType>;
  RoomTypeAvailabilities?: RoomTypeAvailabilitiesResolvers<ContextType>;
  RoomTypeAvailability?: RoomTypeAvailabilityResolvers<ContextType>;
  RoomTypeFeature?: RoomTypeFeatureResolvers<ContextType>;
  RoomTypeFeatureCategory?: RoomTypeFeatureCategoryResolvers;
  S2o?: S2oResolvers<ContextType>;
  S2oPoint?: S2oPointResolvers<ContextType>;
  S2oPointAdminTransactionType?: S2oPointAdminTransactionTypeResolvers;
  S2oPointStatus?: S2oPointStatusResolvers;
  S2oPointTransactionType?: S2oPointTransactionTypeResolvers;
  S3UploadPolicy?: S3UploadPolicyResolvers<ContextType>;
  S3UploadPolicyField?: S3UploadPolicyFieldResolvers<ContextType>;
  SanuEdgeDevice?: SanuEdgeDeviceResolvers<ContextType>;
  SanuEdgeDeviceType?: SanuEdgeDeviceTypeResolvers;
  SanuFileType?: SanuFileTypeResolvers;
  SanuIncAccommodationReservationProvider?: SanuIncAccommodationReservationProviderResolvers<ContextType>;
  SanuOwnerPlanUserFileType?: SanuOwnerPlanUserFileTypeResolvers;
  SaunaAccommodationFacility?: SaunaAccommodationFacilityResolvers<ContextType>;
  SaunaEquipmentAttribute?: SaunaEquipmentAttributeResolvers<ContextType>;
  SaveStayReviewV2DraftPayload?: SaveStayReviewV2DraftPayloadResolvers<ContextType>;
  ScheduleStandardSubscriptionPauseError?: ScheduleStandardSubscriptionPauseErrorResolvers<ContextType>;
  ScheduleStandardSubscriptionPauseErrorCase?: ScheduleStandardSubscriptionPauseErrorCaseResolvers;
  ScheduleStandardSubscriptionPausePayload?: ScheduleStandardSubscriptionPausePayloadResolvers<ContextType>;
  ScheduleStandardSubscriptionTerminationError?: ScheduleStandardSubscriptionTerminationErrorResolvers<ContextType>;
  ScheduleStandardSubscriptionTerminationErrorCase?: ScheduleStandardSubscriptionTerminationErrorCaseResolvers;
  ScheduleStandardSubscriptionTerminationPayload?: ScheduleStandardSubscriptionTerminationPayloadResolvers<ContextType>;
  ScopeDimension?: ScopeDimensionResolvers;
  ScriptExecutionStatus?: ScriptExecutionStatusResolvers;
  ScriptLogLevel?: ScriptLogLevelResolvers;
  SeasonalFeeSetting?: SeasonalFeeSettingResolvers<ContextType>;
  SelectWebinarScheduleError?: SelectWebinarScheduleErrorResolvers<ContextType>;
  SelectWebinarScheduleErrorCase?: SelectWebinarScheduleErrorCaseResolvers;
  SelectWebinarSchedulePayload?: SelectWebinarSchedulePayloadResolvers<ContextType>;
  SendEmailToVerifyNewEmailError?: SendEmailToVerifyNewEmailErrorResolvers<ContextType>;
  SendEmailToVerifyNewEmailErrorCase?: SendEmailToVerifyNewEmailErrorCaseResolvers;
  SendEmailToVerifyNewEmailPayload?: SendEmailToVerifyNewEmailPayloadResolvers<ContextType>;
  SendEmailToVerifyNewEmailSuccess?: SendEmailToVerifyNewEmailSuccessResolvers<ContextType>;
  SendPasswordResetEmailError?: SendPasswordResetEmailErrorResolvers<ContextType>;
  SendPasswordResetEmailErrorCase?: SendPasswordResetEmailErrorCaseResolvers;
  SendPasswordResetEmailPayload?: SendPasswordResetEmailPayloadResolvers<ContextType>;
  SendPasswordResetEmailSuccess?: SendPasswordResetEmailSuccessResolvers<ContextType>;
  ServiceUpdate?: ServiceUpdateResolvers<ContextType>;
  Site?: SiteResolvers<ContextType>;
  SiteAccessRouteGroup?: SiteAccessRouteGroupResolvers<ContextType>;
  SiteAccessRoutePoint?: SiteAccessRoutePointResolvers<ContextType>;
  SiteActivityProgram?: SiteActivityProgramResolvers<ContextType>;
  SiteAvailabilityNight?: SiteAvailabilityNightResolvers<ContextType>;
  SiteContent?: SiteContentResolvers<ContextType>;
  SiteFaq?: SiteFaqResolvers<ContextType>;
  SiteHighSeasonPeriod?: SiteHighSeasonPeriodResolvers<ContextType>;
  SortDirection?: SortDirectionResolvers;
  StaffAccessKeyTrigger?: StaffAccessKeyTriggerResolvers;
  StaffContract?: StaffContractResolvers<ContextType>;
  StaffContractStatus?: StaffContractStatusResolvers;
  StaffContractStatusDetail?: StaffContractStatusDetailResolvers;
  StaffGroup?: StaffGroupResolvers<ContextType>;
  StaffGroupStatus?: StaffGroupStatusResolvers;
  StaffPlanAccommodationReservationProvider?: StaffPlanAccommodationReservationProviderResolvers<ContextType>;
  StaffSemester?: StaffSemesterResolvers;
  StaffSemesterCredit?: StaffSemesterCreditResolvers<ContextType>;
  StaffStayCreditTransactionStatus?: StaffStayCreditTransactionStatusResolvers;
  StaffStayCreditTransactionType?: StaffStayCreditTransactionTypeResolvers;
  StaffType?: StaffTypeResolvers;
  StandardPlanAccommodationReservationProvider?: StandardPlanAccommodationReservationProviderResolvers<ContextType>;
  StayCreditBreakdownItem?: StayCreditBreakdownItemResolvers<ContextType>;
  StayCreditEstimate?: StayCreditEstimateResolvers<ContextType>;
  StayDirectAccommodationReservationProvider?: StayDirectAccommodationReservationProviderResolvers<ContextType>;
  StayGiftExportItem?: StayGiftExportItemResolvers<ContextType>;
  StayReview?: StayReviewResolvers<ContextType>;
  StayReviewAxis?: StayReviewAxisResolvers;
  StayReviewAxisDefinition?: StayReviewAxisDefinitionResolvers<ContextType>;
  StayReviewConcernDetail?: StayReviewConcernDetailResolvers;
  StayReviewConcernDetailOption?: StayReviewConcernDetailOptionResolvers<ContextType>;
  StayReviewConcernKind?: StayReviewConcernKindResolvers;
  StayReviewConcernKindDefinition?: StayReviewConcernKindDefinitionResolvers<ContextType>;
  StayReviewExperienceType?: StayReviewExperienceTypeResolvers;
  StayReviewFoodExperienceType?: StayReviewFoodExperienceTypeResolvers;
  StayReviewFreeTextQuestion?: StayReviewFreeTextQuestionResolvers<ContextType>;
  StayReviewMemorableExperience?: StayReviewMemorableExperienceResolvers;
  StayReviewMemorableExperienceOption?: StayReviewMemorableExperienceOptionResolvers<ContextType>;
  StayReviewPosterViewType?: StayReviewPosterViewTypeResolvers;
  StayReviewQuestionnaire?: StayReviewQuestionnaireResolvers<ContextType>;
  StayReviewResponse?: StayReviewResponseResolvers<ContextType>;
  StayReviewResponseWithReservation?: StayReviewResponseWithReservationResolvers<ContextType>;
  StayReviewSelectionOption?: StayReviewSelectionOptionResolvers<ContextType>;
  StayReviewSelectionQuestion?: StayReviewSelectionQuestionResolvers<ContextType>;
  StayReviewSignResponseType?: StayReviewSignResponseTypeResolvers;
  StayReviewV2?: StayReviewV2Resolvers<ContextType>;
  StayReviewV2Concern?: StayReviewV2ConcernResolvers<ContextType>;
  StayReviewV2Error?: StayReviewV2ErrorResolvers<ContextType>;
  StayReviewV2ErrorCase?: StayReviewV2ErrorCaseResolvers;
  StayReviewV2Form?: StayReviewV2FormResolvers<ContextType>;
  StayTicket?: StayTicketResolvers<ContextType>;
  StayTicketAccommodationReservationProvider?: StayTicketAccommodationReservationProviderResolvers<ContextType>;
  StayTicketAcquisitionMode?: StayTicketAcquisitionModeResolvers;
  StayTicketMaster?: StayTicketMasterResolvers<ContextType>;
  StayTicketMasterTemplate?: StayTicketMasterTemplateResolvers<ContextType>;
  StayTicketReservationInfo?: StayTicketReservationInfoResolvers<ContextType>;
  StayTicketStatusType?: StayTicketStatusTypeResolvers;
  StayTicketTemplate?: StayTicketTemplateResolvers<ContextType>;
  StayTicketType?: StayTicketTypeResolvers;
  StayTicketUnit?: StayTicketUnitResolvers<ContextType>;
  StayTicketValidationError?: StayTicketValidationErrorResolvers;
  StayTicketValidationResult?: StayTicketValidationResultResolvers<ContextType>;
  StripeCard?: StripeCardResolvers<ContextType>;
  StripeCollectionMethod?: StripeCollectionMethodResolvers;
  StripeCustomer?: StripeCustomerResolvers<ContextType>;
  StripeInvoice?: StripeInvoiceResolvers<ContextType>;
  StripeInvoiceStatus?: StripeInvoiceStatusResolvers;
  StripeInvoiceStatusTransitions?: StripeInvoiceStatusTransitionsResolvers<ContextType>;
  StripeInvoiceSubscription?: StripeInvoiceSubscriptionResolvers<ContextType>;
  StripeMetadataItem?: StripeMetadataItemResolvers<ContextType>;
  StripeRequireNextAction?: StripeRequireNextActionResolvers<ContextType>;
  SubmitAdHocQuestionnaireResponseError?: SubmitAdHocQuestionnaireResponseErrorResolvers<ContextType>;
  SubmitAdHocQuestionnaireResponseErrorCase?: SubmitAdHocQuestionnaireResponseErrorCaseResolvers;
  SubmitAdHocQuestionnaireResponsePayload?: SubmitAdHocQuestionnaireResponsePayloadResolvers<ContextType>;
  SubmitCoOwnersApplicationError?: SubmitCoOwnersApplicationErrorResolvers<ContextType>;
  SubmitCoOwnersApplicationErrorCase?: SubmitCoOwnersApplicationErrorCaseResolvers;
  SubmitCoOwnersApplicationPayload?: SubmitCoOwnersApplicationPayloadResolvers<ContextType>;
  SubmitStayReviewV2Payload?: SubmitStayReviewV2PayloadResolvers<ContextType>;
  Success?: SuccessResolvers<ContextType>;
  SupplyItem?: SupplyItemResolvers<ContextType>;
  SupplyItemInstallation?: SupplyItemInstallationResolvers<ContextType>;
  SupplyItemMaster?: SupplyItemMasterResolvers<ContextType>;
  SupplyItemMasterCategory?: SupplyItemMasterCategoryResolvers;
  TargetPlanType?: TargetPlanTypeResolvers;
  TentativeAccommodationReservationError?: TentativeAccommodationReservationErrorResolvers<ContextType>;
  TentativeAccommodationReservationErrorCase?: TentativeAccommodationReservationErrorCaseResolvers;
  TentativeAccommodationReservationPayload?: TentativeAccommodationReservationPayloadResolvers<ContextType>;
  Terms?: TermsResolvers<ContextType>;
  TermsPlanType?: TermsPlanTypeResolvers;
  TermsRevision?: TermsRevisionResolvers<ContextType>;
  TicketCategory?: TicketCategoryResolvers;
  TopPage?: TopPageResolvers<ContextType>;
  TopPageBannerContent?: TopPageBannerContentResolvers<ContextType>;
  TrialContract?: TrialContractResolvers<ContextType>;
  TrialContractStatus?: TrialContractStatusResolvers;
  TrialContractStatusDetail?: TrialContractStatusDetailResolvers;
  TrialPlanAccommodationReservationProvider?: TrialPlanAccommodationReservationProviderResolvers<ContextType>;
  UpdateAccommodationReservationOptionsError?: UpdateAccommodationReservationOptionsErrorResolvers<ContextType>;
  UpdateAccommodationReservationOptionsErrorCase?: UpdateAccommodationReservationOptionsErrorCaseResolvers;
  UpdateAccommodationReservationOptionsPayload?: UpdateAccommodationReservationOptionsPayloadResolvers<ContextType>;
  UpdateCoOwnersApplicationOwnerInfoError?: UpdateCoOwnersApplicationOwnerInfoErrorResolvers<ContextType>;
  UpdateCoOwnersApplicationOwnerInfoErrorCase?: UpdateCoOwnersApplicationOwnerInfoErrorCaseResolvers;
  UpdateCoOwnersApplicationOwnerInfoPayload?: UpdateCoOwnersApplicationOwnerInfoPayloadResolvers<ContextType>;
  UpdateFacilityReservationError?: UpdateFacilityReservationErrorResolvers<ContextType>;
  UpdateFacilityReservationErrorCase?: UpdateFacilityReservationErrorCaseResolvers;
  UpdateFacilityReservationPayload?: UpdateFacilityReservationPayloadResolvers<ContextType>;
  UpdateFacilityReservationSuccess?: UpdateFacilityReservationSuccessResolvers<ContextType>;
  UploadedFile?: UploadedFileResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserAppInstallation?: UserAppInstallationResolvers<ContextType>;
  UserCompanion?: UserCompanionResolvers<ContextType>;
  UserFileType?: UserFileTypeResolvers;
  UserIdentity?: UserIdentityResolvers<ContextType>;
  UserMonthlyStatement?: UserMonthlyStatementResolvers<ContextType>;
  UserOwnership?: UserOwnershipResolvers<ContextType>;
  UserOwnershipProgramYearStatus?: UserOwnershipProgramYearStatusResolvers<ContextType>;
  UserPersonaMetrics?: UserPersonaMetricsResolvers<ContextType>;
  UserProfile?: UserProfileResolvers<ContextType>;
  UserProfileCarOwnershipStatus?: UserProfileCarOwnershipStatusResolvers;
  UserProfileHouseholdComposition?: UserProfileHouseholdCompositionResolvers;
  UserProfileProfessionType?: UserProfileProfessionTypeResolvers;
  UserSubscription?: UserSubscriptionResolvers<ContextType>;
  UserSubscriptionNext7DaysReservationPeriod?: UserSubscriptionNext7DaysReservationPeriodResolvers<ContextType>;
  UserSubscriptionReservationCycle?: UserSubscriptionReservationCycleResolvers<ContextType>;
  UserSubscriptionReservationCyclePeriod?: UserSubscriptionReservationCyclePeriodResolvers<ContextType>;
  UserSubscriptionStatus?: UserSubscriptionStatusResolvers;
  UserSubscriptionStatusDetail?: UserSubscriptionStatusDetailResolvers;
  UserSubscriptionTerminationProhibitReason?: UserSubscriptionTerminationProhibitReasonResolvers;
  UserSystemSettings?: UserSystemSettingsResolvers<ContextType>;
  VerifyAccountLinkSessionError?: VerifyAccountLinkSessionErrorResolvers<ContextType>;
  VerifyAccountLinkSessionErrorCase?: VerifyAccountLinkSessionErrorCaseResolvers;
  VerifyAccountLinkSessionPayload?: VerifyAccountLinkSessionPayloadResolvers<ContextType>;
  VerifyAccountLinkSessionSuccess?: VerifyAccountLinkSessionSuccessResolvers<ContextType>;
  VerifyAddIdentityReauthError?: VerifyAddIdentityReauthErrorResolvers<ContextType>;
  VerifyAddIdentityReauthErrorCase?: VerifyAddIdentityReauthErrorCaseResolvers;
  VerifyAddIdentityReauthPayload?: VerifyAddIdentityReauthPayloadResolvers<ContextType>;
  VerifyAddIdentityReauthRedirect?: VerifyAddIdentityReauthRedirectResolvers<ContextType>;
  VerifyCheckInQrCodeError?: VerifyCheckInQrCodeErrorResolvers<ContextType>;
  VerifyCheckInQrCodeErrorCase?: VerifyCheckInQrCodeErrorCaseResolvers;
  VerifyCheckInQrCodePayload?: VerifyCheckInQrCodePayloadResolvers<ContextType>;
  VerifyCheckInQrCodeSuccess?: VerifyCheckInQrCodeSuccessResolvers<ContextType>;
  VerifyNewEmailError?: VerifyNewEmailErrorResolvers<ContextType>;
  VerifyNewEmailErrorCase?: VerifyNewEmailErrorCaseResolvers;
  VerifyNewEmailPayload?: VerifyNewEmailPayloadResolvers<ContextType>;
  VerifyNewEmailSuccess?: VerifyNewEmailSuccessResolvers<ContextType>;
  WashingMachineTracker?: WashingMachineTrackerResolvers<ContextType>;
  WifiConnection?: WifiConnectionResolvers<ContextType>;
  WifiEquipmentAttribute?: WifiEquipmentAttributeResolvers<ContextType>;
  WorkationAccommodationFacility?: WorkationAccommodationFacilityResolvers<ContextType>;
  ZendeskSyncUserError?: ZendeskSyncUserErrorResolvers<ContextType>;
  ZendeskSyncUserErrorCase?: ZendeskSyncUserErrorCaseResolvers;
  ZendeskSyncUserResult?: ZendeskSyncUserResultResolvers<ContextType>;
  ZonedDateTime?: GraphQLScalarType;
  leaveOrganizationPayload?: leaveOrganizationPayloadResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = Context> = {
  access?: accessDirectiveResolver<any, any, ContextType>;
  fieldMeta?: fieldMetaDirectiveResolver<any, any, ContextType>;
  isContent?: isContentDirectiveResolver<any, any, ContextType>;
  masked?: maskedDirectiveResolver<any, any, ContextType>;
  resourceMeta?: resourceMetaDirectiveResolver<any, any, ContextType>;
  role?: roleDirectiveResolver<any, any, ContextType>;
  scoped?: scopedDirectiveResolver<any, any, ContextType>;
};
